import { jsx as x, jsxs as te, Fragment as Ue } from "react/jsx-runtime";
import { createContext as Wt, useContext as st, useMemo as Le, Fragment as il, forwardRef as ol, createElement as yu, useState as Ae, useCallback as Ye, useRef as Ce, memo as gt, useLayoutEffect as D0, useEffect as Ze, useId as Ho, isValidElement as yz, cloneElement as vz, useInsertionEffect as A0, Component as bz, lazy as _z, Suspense as wz } from "react";
import { createPortal as kz } from "react-dom";
import { Field as j0, FieldLabel as M0, FieldTitle as Sz, FieldDescription as Xu, FieldContent as xz, Switch as $0, ToggleGroup as Iz, ToggleGroupItem as Pz, Slider as Oz, Button as Tt, Textarea as mo, TooltipProvider as Yu, Tooltip as Qu, TooltipTrigger as ec, TooltipContent as tc, Input as Qt, Popover as R0, PopoverTrigger as Z0, PopoverContent as L0, Label as zz, Badge as _r, AlertDialog as Ez, AlertDialogContent as Tz, AlertDialogHeader as Nz, AlertDialogTitle as Cz, AlertDialogDescription as Dz, AlertDialogFooter as Az, AlertDialogCancel as jz, AlertDialogAction as Mz, Checkbox as F0, Alert as $z, AlertTitle as Rz, AlertDescription as Zz, Kbd as Gm } from "@monksflow/monks-ui";
import { create as zr } from "zustand";
import { persist as Lz } from "zustand/middleware";
import { useRelayChat as Fz, compactionDataSchema as Uz, exclusiveUsageByNode as U0, selectRunSummary as Bz, nodeCostUsd as Vz, useRunStore as gi, formatCostUsd as lp } from "@inference.engine/agentic-react";
import { useQuery as Cn, useQueries as qz } from "@tanstack/react-query";
import "ai";
import { createWithEqualityFn as Hz, useStoreWithEqualityFn as Wz } from "zustand/traditional";
import { shallow as ct } from "zustand/shallow";
import { useShallow as Gz } from "zustand/react/shallow";
import { HostRequestError as Kz } from "./host-errors.js";
const B0 = (e, t, n) => n ? t.replace(
  /\{\{\s*(\w+)\s*\}\}/g,
  (r, i) => i in n ? String(n[i]) : r
) : t, V0 = [
  "agent",
  "tool",
  "web-search",
  "mcp-connection",
  "guardrail",
  "scorer"
], nc = Wt(null), Km = /* @__PURE__ */ new WeakMap();
let Jz = 0;
function Xz(e) {
  let t = Km.get(e);
  return t === void 0 && (t = ++Jz, Km.set(e, t)), t;
}
function BK({
  host: e,
  children: t
}) {
  const n = Le(
    () => ({
      data: e.data,
      ...e.copilot ? { copilot: e.copilot } : {},
      inspector: e.inspector ?? {},
      dataKey: Xz(e.data),
      branding: e.branding ?? {},
      capabilities: {
        nodeKinds: e.capabilities?.nodeKinds ?? V0,
        ...e.capabilities?.manageConnections ? { manageConnections: e.capabilities.manageConnections } : {},
        ...e.capabilities?.connectConnection ? { connectConnection: e.capabilities.connectConnection } : {},
        ...e.capabilities?.newWidget ? { newWidget: e.capabilities.newWidget } : {},
        ...e.capabilities?.deleteWidget ? { deleteWidget: e.capabilities.deleteWidget } : {},
        copilot: !!e.copilot || (e.capabilities?.copilot ?? !1)
      },
      text: e.text ?? B0
    }),
    [e]
  );
  return /* @__PURE__ */ x(nc.Provider, { value: n, children: t });
}
function dt() {
  const e = st(nc);
  if (!e) throw new Error("agentic-ui components must be rendered inside AgenticUiHostProvider");
  return e;
}
const Yz = { nodeKinds: V0, copilot: !1 };
function Qz() {
  return st(nc)?.capabilities ?? Yz;
}
const q0 = Wt(null);
function VK({ text: e, children: t }) {
  return /* @__PURE__ */ x(q0.Provider, { value: e, children: t });
}
function Re() {
  const e = st(q0), t = st(nc);
  return e ?? t?.text ?? B0;
}
const qK = {
  "builder.palette": "Palette",
  "builder.sidePanel": "Run details",
  "canvas.agentFiles": "This agent's files",
  "canvas.allTools": "Every tool it offers",
  "canvas.alwaysAllowedCount": "{{count}} always allowed",
  "canvas.approvalCount": "{{count}} need approval",
  "canvas.emptyHint": "Drag one in from the palette.",
  "canvas.emptyHintCopilot": "Drag one in from the palette, or ask Flow.Assist to draw the whole flow for you.",
  "canvas.emptyTitle": "Start with an agent",
  "canvas.loopRefused": "Not connected: this would let an agent invoke itself ({{loop}}).",
  "canvas.noCriterion": "No criterion yet",
  "canvas.noScorer": "No scorer picked",
  "canvas.noToolsEnabled": "No tools enabled",
  "canvas.nothingToShow": "Nothing to show",
  "canvas.resizeHeight": "Resize panel height",
  "canvas.resizeSplit": "Resize between the inspector and Flow.Assist",
  "canvas.resizeWidth": "Resize panel width",
  "canvas.toolCount": "{{count}} tools",
  "canvas.toolCountOne": "{{count}} tool",
  "canvas.webSearchProvider": "the model's provider",
  "chat.answeredQuestions": "You answered",
  "chat.askingAnnouncement": "The agent is asking you something. Answer above the message box.",
  "chat.compactionDetail": "Turns 1 to {{turns}} summarized: read {{input}} tokens, {{cached}} from cache, wrote {{output}}.",
  "chat.compactionMarker": "Earlier messages summarized",
  "chat.minimizeQuestions": "Minimize questions",
  "chat.nextQuestion": "Next",
  "chat.otherAnswer": "Other",
  "chat.otherAnswerHint": "Type your own answer",
  "chat.previousQuestion": "Back",
  "chat.questionProgress": "{{current}}/{{total}}",
  "chat.questions": "Questions from the agent",
  "chat.sendAnswers": "Send answers",
  "chat.showQuestions": "Show questions",
  "chat.skipQuestions": "Skip",
  "chat.unansweredQuestions": "Not answered",
  "chat.yourAnswer": "Your answer",
  "completeness.addCriterion": "Add a criterion",
  "completeness.addInstructions": "Add instructions",
  "completeness.addName": "Add a name",
  "completeness.entryNotAgent": "The entry node must be an agent",
  "completeness.loop": "Agents invoke each other in a loop: {{loop}}",
  "completeness.missingAgent": "Missing agent reference",
  "completeness.missingConnection": "Missing connection",
  "completeness.missingTool": "Missing tool reference",
  "completeness.nameFlow": "Name the flow",
  "completeness.noToolsSelected": "No tools selected",
  "completeness.nodeNeedsAttention": "{{count}} node needs attention",
  "completeness.nodesNeedAttention": "{{count}} nodes need attention",
  "completeness.pickGuidelinesFolder": "Choose a guidelines folder",
  "completeness.pickKnowledgeBase": "Choose a knowledge base",
  "completeness.pickScorer": "Pick a scorer",
  "completeness.refToolSteps": "A referenced agent runs the tool-step budget it was registered with",
  "completeness.setEntry": "Set an entry agent",
  "completeness.toolStepsRange": "Tool steps must be a whole number from 1 to {{max}}",
  "completeness.unknownTool": "Unknown tool",
  "completeness.unreachable": "Never runs: nothing from the entry agent reaches it",
  "composer.attach": "Attach file",
  "composer.attachDisabled": "Attachments are not allowed",
  "composer.placeholder": "Message the agent…",
  "composer.removeFile": "Remove {{name}}",
  "composer.send": "Send",
  "composer.stop": "Stop",
  "composer.tooLarge": "Too large to send: {{files}}",
  "composer.tooMany": "At most {{count}} files can be sent at once: {{files}}",
  "composer.unsupportedType": "This type of file cannot be sent: {{files}}",
  "connector.allTools": "Every tool",
  "connector.allToolsHint": "Offer whatever the server has when the agent runs. Tools it doesn't mark read-only ask before running.",
  "connector.alwaysAllow": "Always allow",
  "connector.alwaysAllowAllTitle": "Allow every tool?",
  "connector.alwaysAllowAllWarning": "{{count}} of these tools may change things outside the agent. They will run without asking anyone who uses this agent.",
  "connector.alwaysAllowAllWarningOne": "{{count}} of these tools may change things outside the agent. It will run without asking anyone who uses this agent.",
  "connector.alwaysAllowCancel": "Cancel",
  "connector.alwaysAllowConfirm": "Always allow",
  "connector.alwaysAllowTitle": "Always allow {{tool}}?",
  "connector.alwaysAllowWarning": "This tool may change things outside the agent. It will run without asking anyone who uses this agent.",
  "connector.alwaysAllowed": "Always allowed",
  "connector.alwaysAllowedTool": "The server doesn't mark this tool read-only, but it runs without asking",
  "connector.connect": "Connect",
  "connector.discovering": "Discovering tools…",
  "connector.noTools": "This connection exposes no tools.",
  "connector.notConnected": "Connect this server with your own account to choose its tools.",
  "connector.retry": "Retry",
  "connector.setAll": "Set all tools",
  "connector.tools": "Tools",
  "connector.unreachable": "Couldn't reach the MCP server.",
  "connector.writeTool": "The server doesn't mark this tool read-only, so it asks before running",
  "copilot.defaultModel": "Default model",
  "copilot.empty": "Describe what you want to build and I'll draw it on the canvas: agents, connections, tools and prompts.",
  "copilot.minimize": "Minimize Flow.Assist",
  "copilot.model": "Flow.Assist model",
  "copilot.newConversation": "New conversation",
  "copilot.open": "Ask Flow.Assist to build or change this agent",
  "copilot.placeholder": "Describe what to build…",
  "copilot.step.addAgent": "Added agent {{name}}",
  "copilot.step.addGuardrail": "Added a guardrail",
  "copilot.step.addScorer": "Added a scorer",
  "copilot.step.connect": "Connected two nodes",
  "copilot.step.connection": "Updated connector tools",
  "copilot.step.connector": "Attached connector {{name}}",
  "copilot.step.dataset": "Kept {{key}} as a dataset",
  "copilot.step.datasetRemoved": "Removed the dataset {{key}}",
  "copilot.step.delete": "Deleted a node",
  "copilot.step.disconnect": "Removed a connection",
  "copilot.step.edge": "Updated a connection",
  "copilot.step.entry": "Set the entry agent",
  "copilot.step.guardrail": "Updated a guardrail",
  "copilot.step.metadata": "Updated agent details",
  "copilot.step.model": "Changed the model",
  "copilot.step.newFlow": "Started a new flow",
  "copilot.step.policy": "Changed a tool policy",
  "copilot.step.prompt": "Wrote the system prompt",
  "copilot.step.redo": "Redid a change",
  "copilot.step.rename": "Renamed to {{name}}",
  "copilot.step.save": "Saved the flow",
  "copilot.step.scorer": "Updated a scorer",
  "copilot.step.settings": "Changed agent settings",
  "copilot.step.tool": "Attached tool {{name}}",
  "copilot.step.undo": "Undid the last change",
  "copilot.step.webSearch": "Attached web search",
  "copilot.title": "Flow.Assist",
  "debug.agents": "{{count}} agents",
  "debug.compactNow": "Compact now",
  "debug.compacting": "Compacting...",
  "debug.context": "Context {{tokens}}",
  "debug.contextOfWindow": "Context {{tokens}} / {{window}} ({{percent}}%)",
  "debug.contextTitle": "The largest prompt {{agent}} sent its model this turn",
  "debug.detail.cost": "Cost",
  "debug.detail.model": "Model",
  "debug.detail.tokens": "Tokens",
  "debug.empty": "Send a test message to see which part of the agent runs.",
  "debug.guardrail.failed": "Blocked",
  "debug.guardrail.passed": "Passed",
  "debug.handoffs": "{{count}} handoffs",
  "debug.kiloTokens": "{{value}}k",
  "debug.kind.handoff": "handoff",
  "debug.kind.tool": "as tool",
  "debug.megaTokens": "{{value}}M",
  "debug.seconds": "{{value}}s",
  "debug.status.aborted": "Stopped",
  "debug.status.awaiting": "Waiting for you",
  "debug.status.completed": "Completed",
  "debug.status.error": "Failed",
  "debug.status.running": "Running",
  "debug.title": "Run details",
  "debug.tokensCached": "{{cached}} cached",
  "debug.tokensInOut": "{{input}} in · {{output}} out",
  "debug.unnamedTool": "tool",
  "edge.asTool": "as tool",
  "edge.denied": "denied",
  "edge.handoff": "handoff",
  "edge.input": "input",
  "edge.output": "output",
  "edge.remove": "Remove link",
  "edge.scores": "scores",
  "edge.tool": "tool",
  "entity.agent": "Agent",
  "entity.brandGuidelines": "Brand guidelines",
  "entity.connector": "Connector",
  "entity.generativeWidget": "Generative widgets",
  "entity.guardrail": "Guardrail",
  "entity.knowledgeBase": "Knowledge base",
  "entity.refAgent": "Existing agent",
  "entity.scorer": "Scorer",
  "entity.tool": "Tool",
  "entity.webSearch": "Web Search",
  "entity.widget": "Widget",
  "entity.widgetInline": "Inline widget",
  "entity.widgetPanel": "Side panel widget",
  "entity.workflow": "Workflow",
  "graph.handoffFrom": "Handoff from {{name}}",
  "graph.requiresApproval": "requires approval",
  "graph.requiresApprovalConditional": "requires approval (conditional)",
  "guidelineCategory.brandAssets": "Brand assets",
  "guidelineCategory.contentStyle": "Content style",
  "guidelineCategory.technicalRequirements": "Technical requirements",
  "guidelineCategory.textCorrectness": "Text correctness",
  "guidelineCategory.textFormatting": "Text formatting",
  "inspector.agent.advanced": "Advanced",
  "inspector.agent.defaultModel": "Default model",
  "inspector.agent.instructions": "Instructions",
  "inspector.agent.isEntry": "This agent is the flow entry point.",
  "inspector.agent.llmFacing": "LLM-facing",
  "inspector.agent.maxOutputTokens": "Max output tokens",
  "inspector.agent.maxToolSteps": "Max tool steps",
  "inspector.agent.maxToolStepsDefault": "{{steps}} (default)",
  "inspector.agent.maxToolStepsHint": "Rounds of tool calls before the agent has to answer.",
  "inspector.agent.maxTurns": "Max turns",
  "inspector.agent.memory": "Memory",
  "inspector.agent.metadata": "Metadata",
  "inspector.agent.model": "Model",
  "inspector.agent.modelSection": "Model & sampling",
  "inspector.agent.refReadOnly": "Referenced agents are read-only; edit them where they are defined.",
  "inspector.agent.samplingOneOf": "This model takes one of temperature and top P, so setting one clears the other.",
  "inspector.agent.setEntry": "Set as entry",
  "inspector.agent.temperature": "Temperature",
  "inspector.agent.topP": "Top P",
  "inspector.agent.useMemory": "Use memory",
  "inspector.agent.useMemoryHint": "Keeps the latest turns of the conversation in front of the agent.",
  "inspector.agent.userFacing": "User-facing",
  "inspector.agentTool.title": "Agent as tool",
  "inspector.agentTool.toolName": "Tool name",
  "inspector.close": "Close inspector",
  "inspector.criterion": "Criterion",
  "inspector.description": "Description",
  "inspector.edge.route": "{{source}} → {{target}}",
  "inspector.empty": "Create or open a flow to begin",
  "inspector.guardrail.criterionRequired": "A criterion is required to run.",
  "inspector.guardrail.flowDefault": "Flow default",
  "inspector.guards.input": "Input",
  "inspector.guards.output": "Output",
  "inspector.guards.placement": "Placement",
  "inspector.guards.placementHint": "Input evaluates the incoming message before the agent runs; output evaluates the agent's response.",
  "inspector.guards.title": "Guardrail link",
  "inspector.handoff.placeholder": "Hand off to {{name}}",
  "inspector.handoff.title": "Handoff",
  "inspector.judgeModel": "Judge model",
  "inspector.minimize": "Minimize inspector",
  "inspector.name": "Name",
  "inspector.policy.allow": "Allow",
  "inspector.policy.deny": "Deny",
  "inspector.policy.needsApproval": "Needs approval",
  "inspector.problems.title": "Needs attention",
  "inspector.reasoning.high": "High",
  "inspector.reasoning.label": "Reasoning",
  "inspector.reasoning.low": "Low",
  "inspector.reasoning.max": "Max",
  "inspector.reasoning.medium": "Medium",
  "inspector.reasoning.minimal": "Minimal",
  "inspector.reasoning.xhigh": "Extra high",
  "inspector.restore": "Show the inspector",
  "inspector.sampling.auto": "Auto",
  "inspector.sampling.reset": "Reset",
  "inspector.scorer.default": "Scorer default",
  "inspector.scorer.expectedTools": "Expected tools",
  "inspector.scorer.expectedToolsHint": "Comma-separated. Scores the fraction of these the agent actually called.",
  "inspector.scorer.expectedToolsPlaceholder": "web_search, calculate",
  "inspector.scorer.judgeModelHint": "Scorer models resolve through the scoring library's own client, not the engine model catalog, so eval spend does not appear in the cost panel.",
  "inspector.scorer.needsCriterion": "{{scorer}} needs a criterion; without one it has nothing to grade the output against.",
  "inspector.scorer.needsTools": "{{scorer}} needs at least one expected tool; with nothing to look for it cannot measure anything, and reports no score at all.",
  "inspector.scorer.pick": "Pick a scorer…",
  "inspector.scorer.referenceBased": "Reference-based: needs an {{field}} value in the dataset, so it only runs in offline evaluation.",
  "inspector.scorer.required": "A scorer is required to run.",
  "inspector.scorer.resultsKey": "Results are reported under the name above, or under the scorer id if you leave it blank.",
  "inspector.scorer.scorer": "Scorer",
  "inspector.scorerPlaceholder": "scorer",
  "inspector.scores.body": "Results are reported under {{key}}. Scoring is post-hoc: unlike a guardrail, it never blocks the run. Configure the scorer on its own node.",
  "inspector.scores.title": "Scorer link",
  "inspector.title": "Inspector",
  "inspector.tool.policy": "Policy",
  "inspector.tool.policyHint": "Deny keeps the connection but removes the tool from the agent (shown as a severed edge).",
  "inspector.toolConfig.agentFiles": "This agent's files",
  "inspector.toolConfig.agentFilesHint": "Only this agent searches them. They apply to every version straight away.",
  "inspector.toolConfig.categories": "Categories",
  "inspector.toolConfig.categoriesHint": "Leave all unticked to read every category.",
  "inspector.toolConfig.change": "Change",
  "inspector.toolConfig.createInKnowledgeHub": "Create one in the Knowledge Hub",
  "inspector.toolConfig.gone": "No longer available. Pick another.",
  "inspector.toolConfig.guidelinesFolder": "Guidelines folder",
  "inspector.toolConfig.guidelinesHint": "Read with the access of whoever uses the agent. A folder belongs to one workspace.",
  "inspector.toolConfig.knowledgeBase": "Knowledge base",
  "inspector.toolConfig.knowledgeBaseHint": "Anyone who uses this agent can search it.",
  "inspector.toolConfig.noFolders": "No guidelines folders in this workspace yet.",
  "inspector.toolConfig.noKnowledgeBases": "No knowledge bases yet.",
  "inspector.toolConfig.noMatch": "Nothing matches.",
  "inspector.toolConfig.open": "Open",
  "inspector.toolConfig.pickKnowledgeBase": "Knowledge base",
  "inspector.toolConfig.placementInline": "Inline, in the reply",
  "inspector.toolConfig.placementPanel": "Side panel",
  "inspector.toolConfig.placements": "Where widgets show",
  "inspector.toolConfig.placementsHint": "Inline for short summaries, the side panel for dashboards.",
  "inspector.toolConfig.search": "Search",
  "inspector.toolConfig.uploadFiles": "Upload files",
  "inspector.toolLink.body": "Tool identity and policy are configured on the tool node.",
  "inspector.toolLink.title": "Tool link",
  "inspector.webSearch.allowedDomains": "Only search these sites",
  "inspector.webSearch.appliesTo": "Applies on {{providers}}",
  "inspector.webSearch.blockedDomains": "Never search these sites",
  "inspector.webSearch.blockedPlaceholder": "reddit.com",
  "inspector.webSearch.blockedWithAllowed": "Anthropic takes one list only, so it uses the sites to search.",
  "inspector.webSearch.city": "City",
  "inspector.webSearch.connected": "The connected agents run on {{providers}}.",
  "inspector.webSearch.contextHigh": "High",
  "inspector.webSearch.contextLow": "Low",
  "inspector.webSearch.contextMedium": "Medium",
  "inspector.webSearch.contextSize": "How much of each page to read",
  "inspector.webSearch.contextSizeHint": "More context answers better, and costs more and takes longer.",
  "inspector.webSearch.country": "Country",
  "inspector.webSearch.countryInvalid": "Use a two-letter country code, such as GB.",
  "inspector.webSearch.countryPlaceholder": "Country (GB)",
  "inspector.webSearch.default": "Default",
  "inspector.webSearch.disclaimer": "The search is run by the provider of the connected agent's model, so each setting applies only on the providers it names, and the others ignore it.",
  "inspector.webSearch.domainsHint": "Separate sites with commas. Subdomains are included.",
  "inspector.webSearch.domainsPlaceholder": "apple.com, reuters.com",
  "inspector.webSearch.ignored": "Ignored while the connected agents run on {{providers}}.",
  "inspector.webSearch.liveResults": "Fetch live pages",
  "inspector.webSearch.liveResultsHint": "Off uses cached results, which is faster but can be out of date.",
  "inspector.webSearch.location": "Search from a location",
  "inspector.webSearch.locationHint": "Ranks results for that place. All fields are optional.",
  "inspector.webSearch.maxUses": "Most searches per answer",
  "inspector.webSearch.maxUsesHint": "Leave empty for no limit.",
  "inspector.webSearch.notConnected": "Connect it to an agent to see which provider runs it.",
  "inspector.webSearch.provider.anthropic": "Anthropic",
  "inspector.webSearch.provider.google": "Gemini",
  "inspector.webSearch.provider.openai": "OpenAI",
  "inspector.webSearch.region": "Region",
  "inspector.webSearch.timeRange": "Only results published between",
  "inspector.webSearch.timeRangeEnd": "To",
  "inspector.webSearch.timeRangeHint": "Set both dates, or neither.",
  "inspector.webSearch.timeRangeStart": "From",
  "inspector.webSearch.timezone": "Time zone",
  "inspector.webSearch.timezonePlaceholder": "Europe/London",
  "maximize.maximizeLabel": "Maximize {{label}}",
  "maximize.maximizeTitle": "Maximize",
  "maximize.restoreLabel": "Restore {{label}}",
  "maximize.restoreTitle": "Restore (Esc)",
  "messages.file": "file",
  "model.configuration": "Configuration",
  "model.maxTokens": "max tokens",
  "model.price": "{{input}} / {{output}} per 1M",
  "model.providerLogo": "{{provider}} logo",
  "model.temperature": "temp",
  "model.topP": "top-p",
  "node.entry": "entry",
  "node.entryPoint": "Entry point",
  "node.handle.handoffs": "Handoffs",
  "node.handle.input": "Input",
  "node.handle.inputGuardrails": "Input guardrails",
  "node.handle.outputGuardrails": "Output guardrails",
  "node.handle.scorers": "Scorers",
  "node.handle.tools": "Tools",
  "node.policy.approval": "approval",
  "node.policy.denied": "denied",
  "node.rename": "Double-click to rename",
  "node.run.kiloTokens": "{{value}}k tok",
  "node.run.seconds": "{{value}}s",
  "node.run.tokens": "{{value}} tok",
  "palette.agent": "Agent",
  "palette.brand": "Brand",
  "palette.category.agents": "Agents",
  "palette.category.connectors": "Connectors",
  "palette.category.guardrails": "Guardrails",
  "palette.category.scorers": "Scorers",
  "palette.category.tools": "Tools",
  "palette.category.widgets": "Widgets",
  "palette.connectors": "Connectors",
  "palette.deleteWidget": "Delete {{name}}",
  "palette.existingAgents": "Existing agents",
  "palette.generativeWidgets": "Designed by the agent, answer by answer",
  "palette.guardrail": "Guardrail",
  "palette.knowledge": "Knowledge",
  "palette.manageConnections": "Manage connections",
  "palette.minimize": "Minimize palette",
  "palette.newWidget": "New widget",
  "palette.noMatches": "No matches.",
  "palette.restore": "Show the palette",
  "palette.scorer": "Scorer",
  "palette.searchLabel": "Search palette",
  "palette.searchPlaceholder": "Search tools, agents, connectors",
  "palette.title": "Palette",
  "palette.tools": "Tools",
  "palette.webSearch": "Web Search",
  "palette.webSearchDescription": "Searches the web for current information, through the agent's model provider.",
  "palette.widgetInfo": "About {{name}}",
  "palette.widgets": "Widgets",
  "trace.artifactKind": "Shown as",
  "trace.conditionalApproval": "conditional approval",
  "trace.cost": "Cost",
  "trace.duration": "Duration",
  "trace.error": "error",
  "trace.guardrailType": "Type",
  "trace.input": "Input",
  "trace.kept": "kept as {{handle}}",
  "trace.kind.agent": "agent",
  "trace.kind.artifact": "widget",
  "trace.kind.guardrail": "guardrail",
  "trace.kind.handoff": "handoff",
  "trace.kind.step": "step",
  "trace.kind.tool": "tool",
  "trace.messages": "Messages",
  "trace.no": "No",
  "trace.opaque": "A system agent: only that it ran is shown. Its tools, steps and prompts stay private, and what it put on screen appears as its own step.",
  "trace.output": "Output",
  "trace.phase.design": "writing",
  "trace.phase.fix": "fixing",
  "trace.phase.render": "render check",
  "trace.phaseTime": "{{phase}} {{seconds}}s",
  "trace.reason": "Reason",
  "trace.requiresApproval": "requires approval",
  "trace.response": "Response",
  "trace.running": "running…",
  "trace.systemPrompt": "System prompt",
  "trace.timeSpent": "Time spent",
  "trace.tokens": "Tokens",
  "trace.tokensCached": "{{input}} in / {{output}} out · {{cached}} cached",
  "trace.tokensValue": "{{input}} in / {{output}} out",
  "trace.tools": "Tools",
  "trace.triggered": "Triggered",
  "trace.tripped": "tripped",
  "trace.waiting": "waiting",
  "trace.yes": "Yes",
  "widget.draft": "Draft",
  "widget.placement.inline": "Inline",
  "widget.placement.panel": "Panel",
  "widget.version": "v{{version}}",
  "widget.versionChanged": "v{{version}}, changed"
}, Gc = "\0";
function Jm(e, t) {
  const n = Object.fromEntries(Object.keys(t).map((r) => [r, Gc + r + Gc]));
  return e(n).split(Gc).map(
    (r, i) => i % 2 === 1 && r in t ? /* @__PURE__ */ x(il, { children: t[r] }, i) : r
  );
}
function up(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $r = {}, Ol = {}, zl = {}, Xm;
function H0() {
  if (Xm) return zl;
  Xm = 1, Object.defineProperty(zl, "__esModule", { value: !0 }), zl.pruneEmpty = e;
  function e(t) {
    const n = {};
    for (const [r, i] of Object.entries(t))
      if (i !== void 0)
        if (typeof i == "object" && i !== null && !Array.isArray(i)) {
          const a = e(i);
          a !== void 0 && (n[r] = a);
        } else
          n[r] = i;
    return Object.keys(n).length > 0 ? n : void 0;
  }
  return zl;
}
var Ym;
function W0() {
  if (Ym) return Ol;
  Ym = 1, Object.defineProperty(Ol, "__esModule", { value: !0 }), Ol.applyAgentPatch = t;
  const e = H0();
  function t(n, r) {
    const i = (o) => Object.prototype.hasOwnProperty.call(r, o), a = { ...n.llm };
    if (i("model") && (a.model = r.model), i("maxOutputTokens") && (a.maxOutputTokens = r.maxOutputTokens), i("temperature") || i("topP")) {
      const o = { ...n.llm?.sampling ?? {} };
      i("temperature") && (o.temperature = r.temperature), i("topP") && (o.topP = r.topP), a.sampling = (0, e.pruneEmpty)(o);
    }
    return i("providerOptions") && (a.providerOptions = r.providerOptions ? (0, e.pruneEmpty)(r.providerOptions) : void 0), i("reasoningEffort") && (a.reasoningEffort = r.reasoningEffort), {
      ...n,
      name: i("name") ? r.name : n.name,
      instructions: i("instructions") ? r.instructions : n.instructions,
      description: i("description") ? r.description : n.description,
      memoryConfig: i("memoryConfig") ? r.memoryConfig : n.memoryConfig,
      maxToolSteps: i("maxToolSteps") ? r.maxToolSteps : n.maxToolSteps,
      metadata: i("metadata") ? r.metadata : n.metadata,
      llm: (0, e.pruneEmpty)(a)
    };
  }
  return Ol;
}
var El = {}, yn = {}, Kc = {}, ya = {}, Qm;
function eE() {
  if (Qm) return ya;
  Qm = 1, Object.defineProperty(ya, "__esModule", { value: !0 }), ya.findCycle = e, ya.findPath = t;
  function e(n, r, i = (a) => a) {
    const a = /* @__PURE__ */ new Set(), o = [], d = /* @__PURE__ */ new Map(), u = (l) => {
      const c = i(l), f = d.get(c);
      if (f !== void 0)
        return [...o.slice(f), l];
      if (!a.has(c)) {
        d.set(c, o.length), o.push(l);
        for (const s of r(l)) {
          const h = u(s);
          if (h)
            return h;
        }
        o.pop(), d.delete(c), a.add(c);
      }
    };
    for (const l of n) {
      const c = u(l);
      if (c)
        return c;
    }
  }
  function t(n, r, i) {
    const a = /* @__PURE__ */ new Map(), o = [n], d = /* @__PURE__ */ new Set([n]);
    for (let u = 0; u < o.length; u++) {
      const l = o[u];
      if (l === void 0)
        break;
      if (l === r) {
        const c = [l];
        for (let f = a.get(l); f !== void 0; f = a.get(f))
          c.unshift(f);
        return c;
      }
      for (const c of i(l))
        d.has(c) || (d.add(c), a.set(c, l), o.push(c));
    }
  }
  return ya;
}
var Jc = {}, eg;
function tE() {
  return eg || (eg = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.FLOW_MAX_TOOL_STEPS = e.DEFAULT_MAX_TOOL_STEPS = void 0, e.isFlowToolStepBudget = t, e.DEFAULT_MAX_TOOL_STEPS = 8, e.FLOW_MAX_TOOL_STEPS = 50;
    function t(n) {
      return Number.isInteger(n) && n >= 1 && n <= e.FLOW_MAX_TOOL_STEPS;
    }
  })(Jc)), Jc;
}
var tg;
function cp() {
  return tg || (tg = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.INVOCATION_EDGE_TYPES = e.TARGET_KINDS = e.isFlowToolStepBudget = e.FLOW_MAX_TOOL_STEPS = e.DEFAULT_MAX_TOOL_STEPS = void 0, e.isValidEdgeTarget = r, e.findInvocationCycle = a, e.invocationCycleClosedBy = o;
    const t = eE();
    var n = tE();
    Object.defineProperty(e, "DEFAULT_MAX_TOOL_STEPS", { enumerable: !0, get: function() {
      return n.DEFAULT_MAX_TOOL_STEPS;
    } }), Object.defineProperty(e, "FLOW_MAX_TOOL_STEPS", { enumerable: !0, get: function() {
      return n.FLOW_MAX_TOOL_STEPS;
    } }), Object.defineProperty(e, "isFlowToolStepBudget", { enumerable: !0, get: function() {
      return n.isFlowToolStepBudget;
    } }), e.TARGET_KINDS = {
      handoff: ["agent"],
      "uses-tool": ["tool", "mcp-connection", "web-search"],
      "uses-agent-as-tool": ["agent"],
      guards: ["guardrail"],
      scores: ["scorer"]
    };
    function r(d, u) {
      return e.TARGET_KINDS[d].includes(u);
    }
    e.INVOCATION_EDGE_TYPES = ["uses-agent-as-tool", "handoff"];
    function i(d) {
      const u = /* @__PURE__ */ new Map();
      for (const l of d)
        e.INVOCATION_EDGE_TYPES.includes(l.type) && u.set(l.source, [...u.get(l.source) ?? [], l.target]);
      return (l) => u.get(l) ?? [];
    }
    function a(d) {
      return (0, t.findCycle)(d.map((u) => u.source), i(d));
    }
    function o(d, u) {
      if (!e.INVOCATION_EDGE_TYPES.includes(u.type))
        return;
      if (u.source === u.target)
        return [u.source, u.source];
      const l = (0, t.findPath)(u.target, u.source, i(d));
      return l ? [u.source, ...l] : void 0;
    }
  })(Kc)), Kc;
}
var ng;
function G0() {
  if (ng) return yn;
  ng = 1, Object.defineProperty(yn, "__esModule", { value: !0 }), yn.isBuilderSourceHandle = n, yn.resolveEdgeType = r, yn.guardsPlacement = i, yn.guardsHandle = a, yn.edgeExists = o, yn.loopClosedBy = d, yn.describeLoop = u, yn.buildFlowEdge = l;
  const e = cp(), t = [
    "handoff",
    "uses",
    "guards-input",
    "guards-output",
    "scores"
  ];
  function n(c) {
    return c != null && t.includes(c);
  }
  function r(c, f) {
    const s = c === "handoff" ? "handoff" : c === "guards-input" || c === "guards-output" ? "guards" : c === "scores" ? "scores" : f === "agent" ? "uses-agent-as-tool" : "uses-tool";
    return (0, e.isValidEdgeTarget)(s, f) ? s : null;
  }
  function i(c) {
    return c === "guards-output" ? "output" : "input";
  }
  function a(c) {
    return c === "output" ? "guards-output" : "guards-input";
  }
  function o(c, f, s, h, p) {
    return c.some((m) => m.type === f && m.source === s && m.target === h && (m.type !== "guards" || m.placement === p));
  }
  function d(c, f, s, h) {
    return (0, e.invocationCycleClosedBy)(c, { type: f, source: s, target: h });
  }
  function u(c, f) {
    return c.map(f).join(" → ");
  }
  function l(c, f, s, h, p) {
    switch (c) {
      case "handoff":
        return { type: c, id: f, source: s, target: h };
      case "uses-agent-as-tool":
        return { type: c, id: f, source: s, target: h };
      case "uses-tool":
        return { type: c, id: f, source: s, target: h };
      case "guards":
        return { type: c, id: f, source: s, target: h, placement: p };
      case "scores":
        return { type: c, id: f, source: s, target: h };
    }
  }
  return yn;
}
var Tl = {}, rg;
function K0() {
  if (rg) return Tl;
  rg = 1, Object.defineProperty(Tl, "__esModule", { value: !0 }), Tl.applyScorerPatch = e;
  function e(t, n) {
    const r = (i) => Object.prototype.hasOwnProperty.call(n, i);
    return {
      ...t,
      // Not clearable: the strict flow schema requires a non-empty scorerId to build.
      scorerId: n.scorerId ?? t.scorerId,
      name: r("name") ? n.name : t.name,
      model: r("model") ? n.model : t.model,
      criterion: r("criterion") ? n.criterion : t.criterion,
      options: r("options") ? n.options : t.options
    };
  }
  return Tl;
}
var ig;
function nE() {
  if (ig) return El;
  ig = 1, Object.defineProperty(El, "__esModule", { value: !0 }), El.applyCanvasOp = a;
  const e = G0(), t = W0(), n = K0(), r = { x: 0, y: 0 };
  function i(o, d, u) {
    const l = o.nodes.map((c) => c.id === d && c.kind === "agent" ? (0, t.applyAgentPatch)(c, u) : c);
    return { ...o, nodes: l };
  }
  function a(o, d) {
    switch (d.op) {
      case "add_agent": {
        const u = {
          kind: "agent",
          id: d.id,
          source: "inline",
          name: d.name,
          instructions: d.instructions,
          llm: { model: d.model },
          ui: r
        }, l = o.entryNodeId === "" ? d.id : o.entryNodeId;
        return { ...o, nodes: [...o.nodes, u], entryNodeId: l };
      }
      case "add_ref_agent": {
        const u = {
          kind: "agent",
          id: d.id,
          source: "ref",
          agentId: d.agentId,
          name: d.name,
          ui: r
        }, l = o.entryNodeId === "" ? d.id : o.entryNodeId;
        return { ...o, nodes: [...o.nodes, u], entryNodeId: l };
      }
      case "set_ref_agent_input": {
        const u = Object.keys(d.input).length === 0, l = o.nodes.map((c) => {
          if (c.id !== d.id || c.kind !== "agent" || c.source !== "ref")
            return c;
          const { input: f, ...s } = c;
          return u ? s : { ...s, input: d.input };
        });
        return { ...o, nodes: l };
      }
      case "write_prompt":
        return i(o, d.id, { instructions: d.instructions });
      case "set_model": {
        const u = {};
        d.model !== void 0 && (u.model = d.model), d.temperature !== void 0 && (u.temperature = d.temperature), d.topP !== void 0 && (u.topP = d.topP), d.maxOutputTokens !== void 0 && (u.maxOutputTokens = d.maxOutputTokens), d.maxToolSteps !== void 0 && (u.maxToolSteps = d.maxToolSteps);
        const l = new Set(d.ids), c = o.nodes.map((f) => l.has(f.id) && f.kind === "agent" ? (0, t.applyAgentPatch)(f, u) : f);
        return { ...o, nodes: c };
      }
      case "set_metadata": {
        const u = {};
        return d.name !== void 0 && (u.name = d.name), d.description !== void 0 && (u.description = d.description), d.memoryConfig !== void 0 && (u.memoryConfig = d.memoryConfig), d.metadata !== void 0 && (u.metadata = d.metadata), i(o, d.id, u);
      }
      case "set_tool_policy": {
        const u = o.nodes.map((l) => l.id === d.id && l.kind === "tool" ? { ...l, policy: d.policy } : l);
        return { ...o, nodes: u };
      }
      case "update_connection": {
        const u = o.nodes.map((l) => l.id === d.id && l.kind === "mcp-connection" ? { ...l, tools: d.tools } : l);
        return { ...o, nodes: u };
      }
      case "update_guardrail": {
        const u = o.nodes.map((l) => l.id === d.id && l.kind === "guardrail" ? {
          ...l,
          name: d.name !== void 0 ? d.name : l.name,
          criterion: d.criterion ?? l.criterion,
          model: d.model !== void 0 ? d.model : l.model
        } : l);
        return { ...o, nodes: u };
      }
      case "connect": {
        const u = o.nodes.find((c) => c.id === d.source);
        if (u?.kind !== "agent" || u.source !== "inline")
          return o;
        const l = (0, e.buildFlowEdge)(d.edgeType, d.edgeId, d.source, d.target, d.placement ?? "input");
        return { ...o, edges: [...o.edges, l] };
      }
      case "attach_tool": {
        const u = {
          kind: "tool",
          id: d.toolNodeId,
          toolId: d.toolId,
          policy: "allow",
          ...d.config ? { config: d.config } : {},
          ui: r
        }, l = (0, e.buildFlowEdge)("uses-tool", d.edgeId, d.agentId, d.toolNodeId, "input");
        return { ...o, nodes: [...o.nodes, u], edges: [...o.edges, l] };
      }
      case "attach_web_search": {
        const u = { kind: "web-search", id: d.webSearchNodeId, ui: r }, l = (0, e.buildFlowEdge)("uses-tool", d.edgeId, d.agentId, d.webSearchNodeId, "input");
        return { ...o, nodes: [...o.nodes, u], edges: [...o.edges, l] };
      }
      case "attach_connector": {
        const u = {
          kind: "mcp-connection",
          id: d.mcpNodeId,
          connectionId: d.connectionId,
          tools: d.tools,
          ui: r
        }, l = (0, e.buildFlowEdge)("uses-tool", d.edgeId, d.agentId, d.mcpNodeId, "input");
        return { ...o, nodes: [...o.nodes, u], edges: [...o.edges, l] };
      }
      case "add_guardrail": {
        const u = {
          kind: "guardrail",
          id: d.guardrailNodeId,
          criterion: d.criterion,
          model: d.model,
          ui: r
        }, l = (0, e.buildFlowEdge)("guards", d.edgeId, d.agentId, d.guardrailNodeId, d.placement);
        return { ...o, nodes: [...o.nodes, u], edges: [...o.edges, l] };
      }
      case "add_scorer": {
        const u = {
          kind: "scorer",
          id: d.scorerNodeId,
          scorerId: d.scorerId,
          ...d.name === void 0 ? {} : { name: d.name },
          ...d.model === void 0 ? {} : { model: d.model },
          ...d.criterion === void 0 ? {} : { criterion: d.criterion },
          ...d.options === void 0 ? {} : { options: d.options },
          ui: r
        }, l = (0, e.buildFlowEdge)("scores", d.edgeId, d.agentId, d.scorerNodeId, "input");
        return { ...o, nodes: [...o.nodes, u], edges: [...o.edges, l] };
      }
      case "update_scorer": {
        const { op: u, id: l, ...c } = d, f = o.nodes.map((s) => s.id === d.id && s.kind === "scorer" ? (0, n.applyScorerPatch)(s, c) : s);
        return { ...o, nodes: f };
      }
      case "disconnect":
        return { ...o, edges: o.edges.filter((u) => u.id !== d.edgeId) };
      case "update_edge": {
        const u = o.edges.map((l) => l.id !== d.edgeId ? l : l.type === "handoff" ? {
          ...l,
          description: d.description !== void 0 ? d.description : l.description
        } : l.type === "uses-agent-as-tool" ? {
          ...l,
          toolName: d.toolName !== void 0 ? d.toolName : l.toolName,
          description: d.description !== void 0 ? d.description : l.description
        } : l.type === "guards" ? { ...l, placement: d.placement ?? l.placement } : l);
        return { ...o, edges: u };
      }
      case "set_entry":
        return { ...o, entryNodeId: d.id };
      case "delete_node": {
        const u = o.nodes.filter((f) => f.id !== d.id), l = o.edges.filter((f) => f.source !== d.id && f.target !== d.id);
        let c = o.entryNodeId;
        if (c === d.id) {
          const f = u.find((s) => s.kind === "agent");
          c = f ? f.id : "";
        }
        return { ...o, nodes: u, edges: l, entryNodeId: c };
      }
      case "set_flow_name":
        return { ...o, name: d.name };
      case "set_dataset":
        return {
          ...o,
          datasets: [
            ...(o.datasets ?? []).filter((u) => u.key !== d.dataset.key),
            d.dataset
          ]
        };
      case "remove_dataset":
        return { ...o, datasets: (o.datasets ?? []).filter((u) => u.key !== d.key) };
      // Meta ops change history/persistence, not the doc directly — the caller
      // (store + mirror) handles them. Return the doc unchanged.
      case "undo":
      case "redo":
      case "save":
      case "new_flow":
        return o;
    }
  }
  return El;
}
var va = {}, og;
function rE() {
  return og || (og = 1, Object.defineProperty(va, "__esModule", { value: !0 }), va.GUIDELINE_CATEGORIES = void 0, va.GUIDELINE_CATEGORIES = [
    "TextCorrectness",
    "TextFormatting",
    "ContentStyle",
    "BrandAssets",
    "TechnicalRequirements"
  ]), va;
}
var Xc = {}, Yc = {}, ba = {}, ag;
function iE() {
  return ag || (ag = 1, Object.defineProperty(ba, "__esModule", { value: !0 }), ba.DATA_MEDIA_TYPES = void 0, ba.DATA_MEDIA_TYPES = [
    "application/json",
    "text/csv",
    "text/tab-separated-values",
    "text/markdown",
    "text/plain"
  ]), ba;
}
var sg;
function oE() {
  return sg || (sg = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DATA_MEDIA_TYPES = void 0, e.structuredView = a, e.describeShape = o, e.asRawText = d, e.datasetView = l;
    var t = iE();
    Object.defineProperty(e, "DATA_MEDIA_TYPES", { enumerable: !0, get: function() {
      return t.DATA_MEDIA_TYPES;
    } });
    const n = {
      "text/csv": ",",
      "text/tab-separated-values": "	"
    };
    function r(c, f) {
      if (c.includes('"'))
        return;
      const [s, ...h] = c.replace(/^\uFEFF/, "").trim().split(/\r?\n/);
      if (!s || h.length === 0)
        return;
      const p = s.split(f).map((y) => y.trim());
      if (p.some((y) => y === "") || new Set(p).size !== p.length)
        return;
      const m = [];
      for (const y of h) {
        const w = y.split(f).map((b) => b.trim());
        if (w.length !== p.length)
          return;
        m.push(Object.fromEntries(p.map((b, _) => [b, w[_] ?? ""])));
      }
      return m;
    }
    function i(c) {
      const [f, s, ...h] = c.trim().split(/\r?\n/);
      if (f === void 0 || s === void 0 || h.length === 0 || ![f, ...h].every((y) => y.trim().startsWith("|")) || !/^\|?\s*:?-{3,}/.test(s.trim()))
        return;
      const p = (y) => y.trim().replace(/^\||\|$/g, "").split("|").map((w) => w.trim()), m = [f, ...h].map((y) => p(y).join("	")).join(`
`);
      return r(m, "	");
    }
    function a(c, f) {
      if (f === "application/json")
        try {
          return JSON.parse(c);
        } catch {
          return { text: c };
        }
      const s = n[f];
      return (s ? r(c, s) : f === "text/markdown" ? i(c) : void 0) ?? { text: c };
    }
    function o(c) {
      if (typeof c == "string")
        return `text, ${String(c.length)} chars`;
      if (Array.isArray(c))
        return `[${String(c.length)}]`;
      if (c === null || typeof c != "object")
        return typeof c;
      const f = Object.entries(c), [s] = f;
      return f.length === 1 && s?.[0] === "text" && typeof s[1] == "string" ? o(s[1]) : f.map(([h, p]) => Array.isArray(p) ? `${h}[${String(p.length)}]` : h).join(", ");
    }
    function d(c) {
      if (typeof c == "string")
        return { raw: c, mediaType: "text/plain" };
      if (!(c instanceof Uint8Array || c instanceof ArrayBuffer))
        try {
          const f = JSON.stringify(c);
          return f === void 0 ? void 0 : { raw: f, mediaType: "application/json" };
        } catch {
          return;
        }
    }
    const u = /* @__PURE__ */ new WeakMap();
    function l(c) {
      return u.has(c) || u.set(c, a(c.content, c.mediaType)), u.get(c);
    }
  })(Yc)), Yc;
}
var vn = {}, Jt = {}, bn = {}, Qc = {}, lg;
function al() {
  return lg || (lg = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.globalConfig = e.$ZodEncodeError = e.$ZodAsyncError = e.$brand = e.NEVER = void 0, e.$constructor = t, e.config = i, e.NEVER = Object.freeze({
      status: "aborted"
    });
    function t(a, o, d) {
      function u(s, h) {
        if (s._zod || Object.defineProperty(s, "_zod", {
          value: {
            def: h,
            constr: f,
            traits: /* @__PURE__ */ new Set()
          },
          enumerable: !1
        }), s._zod.traits.has(a))
          return;
        s._zod.traits.add(a), o(s, h);
        const p = f.prototype, m = Object.keys(p);
        for (let y = 0; y < m.length; y++) {
          const w = m[y];
          w in s || (s[w] = p[w].bind(s));
        }
      }
      const l = d?.Parent ?? Object;
      class c extends l {
      }
      Object.defineProperty(c, "name", { value: a });
      function f(s) {
        var h;
        const p = d?.Parent ? new c() : this;
        u(p, s), (h = p._zod).deferred ?? (h.deferred = []);
        for (const m of p._zod.deferred)
          m();
        return p;
      }
      return Object.defineProperty(f, "init", { value: u }), Object.defineProperty(f, Symbol.hasInstance, {
        value: (s) => d?.Parent && s instanceof d.Parent ? !0 : s?._zod?.traits?.has(a)
      }), Object.defineProperty(f, "name", { value: a }), f;
    }
    e.$brand = /* @__PURE__ */ Symbol("zod_brand");
    class n extends Error {
      constructor() {
        super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
      }
    }
    e.$ZodAsyncError = n;
    class r extends Error {
      constructor(o) {
        super(`Encountered unidirectional transform during encode: ${o}`), this.name = "ZodEncodeError";
      }
    }
    e.$ZodEncodeError = r, e.globalConfig = {};
    function i(a) {
      return a && Object.assign(e.globalConfig, a), e.globalConfig;
    }
  })(Qc)), Qc;
}
var Kn = {}, Pt = {}, _e = {}, ug;
function Pe() {
  if (ug) return _e;
  ug = 1, Object.defineProperty(_e, "__esModule", { value: !0 }), _e.Class = _e.BIGINT_FORMAT_RANGES = _e.NUMBER_FORMAT_RANGES = _e.primitiveTypes = _e.propertyKeyTypes = _e.getParsedType = _e.allowsEval = _e.captureStackTrace = void 0, _e.assertEqual = e, _e.assertNotEqual = t, _e.assertIs = n, _e.assertNever = r, _e.assert = i, _e.getEnumValues = a, _e.joinValues = o, _e.jsonStringifyReplacer = d, _e.cached = u, _e.nullish = l, _e.cleanRegex = c, _e.floatSafeRemainder = f, _e.defineLazy = h, _e.objectClone = p, _e.assignProp = m, _e.mergeDefs = y, _e.cloneDef = w, _e.getElementAtPath = b, _e.promiseAllObject = _, _e.randomString = g, _e.esc = O, _e.slugify = P, _e.isObject = E, _e.isPlainObject = T, _e.shallowClone = D, _e.numKeys = N, _e.escapeRegex = R, _e.clone = V, _e.normalizeParams = C, _e.createTransparentProxy = B, _e.stringifyPrimitive = G, _e.optionalKeys = Q, _e.pick = k, _e.omit = I, _e.extend = S, _e.safeExtend = A, _e.merge = j, _e.partial = z, _e.required = L, _e.aborted = F, _e.prefixIssues = K, _e.unwrapMessage = ee, _e.finalizeIssue = U, _e.getSizableOrigin = q, _e.getLengthableOrigin = ne, _e.parsedType = oe, _e.issue = Y, _e.cleanEnum = re, _e.base64ToUint8Array = de, _e.uint8ArrayToBase64 = ve, _e.base64urlToUint8Array = se, _e.uint8ArrayToBase64url = pe, _e.hexToUint8Array = ke, _e.uint8ArrayToHex = Ne;
  function e(X) {
    return X;
  }
  function t(X) {
    return X;
  }
  function n(X) {
  }
  function r(X) {
    throw new Error("Unexpected value in exhaustive check");
  }
  function i(X) {
  }
  function a(X) {
    const ae = Object.values(X).filter((me) => typeof me == "number");
    return Object.entries(X).filter(([me, Ee]) => ae.indexOf(+me) === -1).map(([me, Ee]) => Ee);
  }
  function o(X, ae = "|") {
    return X.map((he) => G(he)).join(ae);
  }
  function d(X, ae) {
    return typeof ae == "bigint" ? ae.toString() : ae;
  }
  function u(X) {
    return {
      get value() {
        {
          const ae = X();
          return Object.defineProperty(this, "value", { value: ae }), ae;
        }
      }
    };
  }
  function l(X) {
    return X == null;
  }
  function c(X) {
    const ae = X.startsWith("^") ? 1 : 0, he = X.endsWith("$") ? X.length - 1 : X.length;
    return X.slice(ae, he);
  }
  function f(X, ae) {
    const he = (X.toString().split(".")[1] || "").length, me = ae.toString();
    let Ee = (me.split(".")[1] || "").length;
    if (Ee === 0 && /\d?e-\d?/.test(me)) {
      const Te = me.match(/\d?e-(\d?)/);
      Te?.[1] && (Ee = Number.parseInt(Te[1]));
    }
    const ie = he > Ee ? he : Ee, fe = Number.parseInt(X.toFixed(ie).replace(".", "")), be = Number.parseInt(ae.toFixed(ie).replace(".", ""));
    return fe % be / 10 ** ie;
  }
  const s = /* @__PURE__ */ Symbol("evaluating");
  function h(X, ae, he) {
    let me;
    Object.defineProperty(X, ae, {
      get() {
        if (me !== s)
          return me === void 0 && (me = s, me = he()), me;
      },
      set(Ee) {
        Object.defineProperty(X, ae, {
          value: Ee
          // configurable: true,
        });
      },
      configurable: !0
    });
  }
  function p(X) {
    return Object.create(Object.getPrototypeOf(X), Object.getOwnPropertyDescriptors(X));
  }
  function m(X, ae, he) {
    Object.defineProperty(X, ae, {
      value: he,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  }
  function y(...X) {
    const ae = {};
    for (const he of X) {
      const me = Object.getOwnPropertyDescriptors(he);
      Object.assign(ae, me);
    }
    return Object.defineProperties({}, ae);
  }
  function w(X) {
    return y(X._zod.def);
  }
  function b(X, ae) {
    return ae ? ae.reduce((he, me) => he?.[me], X) : X;
  }
  function _(X) {
    const ae = Object.keys(X), he = ae.map((me) => X[me]);
    return Promise.all(he).then((me) => {
      const Ee = {};
      for (let ie = 0; ie < ae.length; ie++)
        Ee[ae[ie]] = me[ie];
      return Ee;
    });
  }
  function g(X = 10) {
    const ae = "abcdefghijklmnopqrstuvwxyz";
    let he = "";
    for (let me = 0; me < X; me++)
      he += ae[Math.floor(Math.random() * ae.length)];
    return he;
  }
  function O(X) {
    return JSON.stringify(X);
  }
  function P(X) {
    return X.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
  }
  _e.captureStackTrace = "captureStackTrace" in Error ? Error.captureStackTrace : (...X) => {
  };
  function E(X) {
    return typeof X == "object" && X !== null && !Array.isArray(X);
  }
  _e.allowsEval = u(() => {
    if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
      return !1;
    try {
      const X = Function;
      return new X(""), !0;
    } catch {
      return !1;
    }
  });
  function T(X) {
    if (E(X) === !1)
      return !1;
    const ae = X.constructor;
    if (ae === void 0 || typeof ae != "function")
      return !0;
    const he = ae.prototype;
    return !(E(he) === !1 || Object.prototype.hasOwnProperty.call(he, "isPrototypeOf") === !1);
  }
  function D(X) {
    return T(X) ? { ...X } : Array.isArray(X) ? [...X] : X;
  }
  function N(X) {
    let ae = 0;
    for (const he in X)
      Object.prototype.hasOwnProperty.call(X, he) && ae++;
    return ae;
  }
  const M = (X) => {
    const ae = typeof X;
    switch (ae) {
      case "undefined":
        return "undefined";
      case "string":
        return "string";
      case "number":
        return Number.isNaN(X) ? "nan" : "number";
      case "boolean":
        return "boolean";
      case "function":
        return "function";
      case "bigint":
        return "bigint";
      case "symbol":
        return "symbol";
      case "object":
        return Array.isArray(X) ? "array" : X === null ? "null" : X.then && typeof X.then == "function" && X.catch && typeof X.catch == "function" ? "promise" : typeof Map < "u" && X instanceof Map ? "map" : typeof Set < "u" && X instanceof Set ? "set" : typeof Date < "u" && X instanceof Date ? "date" : typeof File < "u" && X instanceof File ? "file" : "object";
      default:
        throw new Error(`Unknown data type: ${ae}`);
    }
  };
  _e.getParsedType = M, _e.propertyKeyTypes = /* @__PURE__ */ new Set(["string", "number", "symbol"]), _e.primitiveTypes = /* @__PURE__ */ new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
  function R(X) {
    return X.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function V(X, ae, he) {
    const me = new X._zod.constr(ae ?? X._zod.def);
    return (!ae || he?.parent) && (me._zod.parent = X), me;
  }
  function C(X) {
    const ae = X;
    if (!ae)
      return {};
    if (typeof ae == "string")
      return { error: () => ae };
    if (ae?.message !== void 0) {
      if (ae?.error !== void 0)
        throw new Error("Cannot specify both `message` and `error` params");
      ae.error = ae.message;
    }
    return delete ae.message, typeof ae.error == "string" ? { ...ae, error: () => ae.error } : ae;
  }
  function B(X) {
    let ae;
    return new Proxy({}, {
      get(he, me, Ee) {
        return ae ?? (ae = X()), Reflect.get(ae, me, Ee);
      },
      set(he, me, Ee, ie) {
        return ae ?? (ae = X()), Reflect.set(ae, me, Ee, ie);
      },
      has(he, me) {
        return ae ?? (ae = X()), Reflect.has(ae, me);
      },
      deleteProperty(he, me) {
        return ae ?? (ae = X()), Reflect.deleteProperty(ae, me);
      },
      ownKeys(he) {
        return ae ?? (ae = X()), Reflect.ownKeys(ae);
      },
      getOwnPropertyDescriptor(he, me) {
        return ae ?? (ae = X()), Reflect.getOwnPropertyDescriptor(ae, me);
      },
      defineProperty(he, me, Ee) {
        return ae ?? (ae = X()), Reflect.defineProperty(ae, me, Ee);
      }
    });
  }
  function G(X) {
    return typeof X == "bigint" ? X.toString() + "n" : typeof X == "string" ? `"${X}"` : `${X}`;
  }
  function Q(X) {
    return Object.keys(X).filter((ae) => X[ae]._zod.optin === "optional" && X[ae]._zod.optout === "optional");
  }
  _e.NUMBER_FORMAT_RANGES = {
    safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
    int32: [-2147483648, 2147483647],
    uint32: [0, 4294967295],
    float32: [-34028234663852886e22, 34028234663852886e22],
    float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
  }, _e.BIGINT_FORMAT_RANGES = {
    int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
    uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
  };
  function k(X, ae) {
    const he = X._zod.def, me = he.checks;
    if (me && me.length > 0)
      throw new Error(".pick() cannot be used on object schemas containing refinements");
    const ie = y(X._zod.def, {
      get shape() {
        const fe = {};
        for (const be in ae) {
          if (!(be in he.shape))
            throw new Error(`Unrecognized key: "${be}"`);
          ae[be] && (fe[be] = he.shape[be]);
        }
        return m(this, "shape", fe), fe;
      },
      checks: []
    });
    return V(X, ie);
  }
  function I(X, ae) {
    const he = X._zod.def, me = he.checks;
    if (me && me.length > 0)
      throw new Error(".omit() cannot be used on object schemas containing refinements");
    const ie = y(X._zod.def, {
      get shape() {
        const fe = { ...X._zod.def.shape };
        for (const be in ae) {
          if (!(be in he.shape))
            throw new Error(`Unrecognized key: "${be}"`);
          ae[be] && delete fe[be];
        }
        return m(this, "shape", fe), fe;
      },
      checks: []
    });
    return V(X, ie);
  }
  function S(X, ae) {
    if (!T(ae))
      throw new Error("Invalid input to extend: expected a plain object");
    const he = X._zod.def.checks;
    if (he && he.length > 0) {
      const ie = X._zod.def.shape;
      for (const fe in ae)
        if (Object.getOwnPropertyDescriptor(ie, fe) !== void 0)
          throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
    }
    const Ee = y(X._zod.def, {
      get shape() {
        const ie = { ...X._zod.def.shape, ...ae };
        return m(this, "shape", ie), ie;
      }
    });
    return V(X, Ee);
  }
  function A(X, ae) {
    if (!T(ae))
      throw new Error("Invalid input to safeExtend: expected a plain object");
    const he = y(X._zod.def, {
      get shape() {
        const me = { ...X._zod.def.shape, ...ae };
        return m(this, "shape", me), me;
      }
    });
    return V(X, he);
  }
  function j(X, ae) {
    const he = y(X._zod.def, {
      get shape() {
        const me = { ...X._zod.def.shape, ...ae._zod.def.shape };
        return m(this, "shape", me), me;
      },
      get catchall() {
        return ae._zod.def.catchall;
      },
      checks: []
      // delete existing checks
    });
    return V(X, he);
  }
  function z(X, ae, he) {
    const Ee = ae._zod.def.checks;
    if (Ee && Ee.length > 0)
      throw new Error(".partial() cannot be used on object schemas containing refinements");
    const fe = y(ae._zod.def, {
      get shape() {
        const be = ae._zod.def.shape, Te = { ...be };
        if (he)
          for (const De in he) {
            if (!(De in be))
              throw new Error(`Unrecognized key: "${De}"`);
            he[De] && (Te[De] = X ? new X({
              type: "optional",
              innerType: be[De]
            }) : be[De]);
          }
        else
          for (const De in be)
            Te[De] = X ? new X({
              type: "optional",
              innerType: be[De]
            }) : be[De];
        return m(this, "shape", Te), Te;
      },
      checks: []
    });
    return V(ae, fe);
  }
  function L(X, ae, he) {
    const me = y(ae._zod.def, {
      get shape() {
        const Ee = ae._zod.def.shape, ie = { ...Ee };
        if (he)
          for (const fe in he) {
            if (!(fe in ie))
              throw new Error(`Unrecognized key: "${fe}"`);
            he[fe] && (ie[fe] = new X({
              type: "nonoptional",
              innerType: Ee[fe]
            }));
          }
        else
          for (const fe in Ee)
            ie[fe] = new X({
              type: "nonoptional",
              innerType: Ee[fe]
            });
        return m(this, "shape", ie), ie;
      }
    });
    return V(ae, me);
  }
  function F(X, ae = 0) {
    if (X.aborted === !0)
      return !0;
    for (let he = ae; he < X.issues.length; he++)
      if (X.issues[he]?.continue !== !0)
        return !0;
    return !1;
  }
  function K(X, ae) {
    return ae.map((he) => {
      var me;
      return (me = he).path ?? (me.path = []), he.path.unshift(X), he;
    });
  }
  function ee(X) {
    return typeof X == "string" ? X : X?.message;
  }
  function U(X, ae, he) {
    const me = { ...X, path: X.path ?? [] };
    if (!X.message) {
      const Ee = ee(X.inst?._zod.def?.error?.(X)) ?? ee(ae?.error?.(X)) ?? ee(he.customError?.(X)) ?? ee(he.localeError?.(X)) ?? "Invalid input";
      me.message = Ee;
    }
    return delete me.inst, delete me.continue, ae?.reportInput || delete me.input, me;
  }
  function q(X) {
    return X instanceof Set ? "set" : X instanceof Map ? "map" : X instanceof File ? "file" : "unknown";
  }
  function ne(X) {
    return Array.isArray(X) ? "array" : typeof X == "string" ? "string" : "unknown";
  }
  function oe(X) {
    const ae = typeof X;
    switch (ae) {
      case "number":
        return Number.isNaN(X) ? "nan" : "number";
      case "object": {
        if (X === null)
          return "null";
        if (Array.isArray(X))
          return "array";
        const he = X;
        if (he && Object.getPrototypeOf(he) !== Object.prototype && "constructor" in he && he.constructor)
          return he.constructor.name;
      }
    }
    return ae;
  }
  function Y(...X) {
    const [ae, he, me] = X;
    return typeof ae == "string" ? {
      message: ae,
      code: "custom",
      input: he,
      inst: me
    } : { ...ae };
  }
  function re(X) {
    return Object.entries(X).filter(([ae, he]) => Number.isNaN(Number.parseInt(ae, 10))).map((ae) => ae[1]);
  }
  function de(X) {
    const ae = atob(X), he = new Uint8Array(ae.length);
    for (let me = 0; me < ae.length; me++)
      he[me] = ae.charCodeAt(me);
    return he;
  }
  function ve(X) {
    let ae = "";
    for (let he = 0; he < X.length; he++)
      ae += String.fromCharCode(X[he]);
    return btoa(ae);
  }
  function se(X) {
    const ae = X.replace(/-/g, "+").replace(/_/g, "/"), he = "=".repeat((4 - ae.length % 4) % 4);
    return de(ae + he);
  }
  function pe(X) {
    return ve(X).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  }
  function ke(X) {
    const ae = X.replace(/^0x/, "");
    if (ae.length % 2 !== 0)
      throw new Error("Invalid hex string length");
    const he = new Uint8Array(ae.length / 2);
    for (let me = 0; me < ae.length; me += 2)
      he[me / 2] = Number.parseInt(ae.slice(me, me + 2), 16);
    return he;
  }
  function Ne(X) {
    return Array.from(X).map((ae) => ae.toString(16).padStart(2, "0")).join("");
  }
  class Ke {
    constructor(...ae) {
    }
  }
  return _e.Class = Ke, _e;
}
var cg;
function J0() {
  if (cg) return Pt;
  cg = 1;
  var e = Pt && Pt.__createBinding || (Object.create ? (function(f, s, h, p) {
    p === void 0 && (p = h);
    var m = Object.getOwnPropertyDescriptor(s, h);
    (!m || ("get" in m ? !s.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return s[h];
    } }), Object.defineProperty(f, p, m);
  }) : (function(f, s, h, p) {
    p === void 0 && (p = h), f[p] = s[h];
  })), t = Pt && Pt.__setModuleDefault || (Object.create ? (function(f, s) {
    Object.defineProperty(f, "default", { enumerable: !0, value: s });
  }) : function(f, s) {
    f.default = s;
  }), n = Pt && Pt.__importStar || function(f) {
    if (f && f.__esModule) return f;
    var s = {};
    if (f != null) for (var h in f) h !== "default" && Object.prototype.hasOwnProperty.call(f, h) && e(s, f, h);
    return t(s, f), s;
  };
  Object.defineProperty(Pt, "__esModule", { value: !0 }), Pt.$ZodRealError = Pt.$ZodError = void 0, Pt.flattenError = o, Pt.formatError = d, Pt.treeifyError = u, Pt.toDotPath = l, Pt.prettifyError = c;
  const r = al(), i = n(Pe()), a = (f, s) => {
    f.name = "$ZodError", Object.defineProperty(f, "_zod", {
      value: f._zod,
      enumerable: !1
    }), Object.defineProperty(f, "issues", {
      value: s,
      enumerable: !1
    }), f.message = JSON.stringify(s, i.jsonStringifyReplacer, 2), Object.defineProperty(f, "toString", {
      value: () => f.message,
      enumerable: !1
    });
  };
  Pt.$ZodError = (0, r.$constructor)("$ZodError", a), Pt.$ZodRealError = (0, r.$constructor)("$ZodError", a, { Parent: Error });
  function o(f, s = (h) => h.message) {
    const h = {}, p = [];
    for (const m of f.issues)
      m.path.length > 0 ? (h[m.path[0]] = h[m.path[0]] || [], h[m.path[0]].push(s(m))) : p.push(s(m));
    return { formErrors: p, fieldErrors: h };
  }
  function d(f, s = (h) => h.message) {
    const h = { _errors: [] }, p = (m) => {
      for (const y of m.issues)
        if (y.code === "invalid_union" && y.errors.length)
          y.errors.map((w) => p({ issues: w }));
        else if (y.code === "invalid_key")
          p({ issues: y.issues });
        else if (y.code === "invalid_element")
          p({ issues: y.issues });
        else if (y.path.length === 0)
          h._errors.push(s(y));
        else {
          let w = h, b = 0;
          for (; b < y.path.length; ) {
            const _ = y.path[b];
            b === y.path.length - 1 ? (w[_] = w[_] || { _errors: [] }, w[_]._errors.push(s(y))) : w[_] = w[_] || { _errors: [] }, w = w[_], b++;
          }
        }
    };
    return p(f), h;
  }
  function u(f, s = (h) => h.message) {
    const h = { errors: [] }, p = (m, y = []) => {
      var w, b;
      for (const _ of m.issues)
        if (_.code === "invalid_union" && _.errors.length)
          _.errors.map((g) => p({ issues: g }, _.path));
        else if (_.code === "invalid_key")
          p({ issues: _.issues }, _.path);
        else if (_.code === "invalid_element")
          p({ issues: _.issues }, _.path);
        else {
          const g = [...y, ..._.path];
          if (g.length === 0) {
            h.errors.push(s(_));
            continue;
          }
          let O = h, P = 0;
          for (; P < g.length; ) {
            const E = g[P], T = P === g.length - 1;
            typeof E == "string" ? (O.properties ?? (O.properties = {}), (w = O.properties)[E] ?? (w[E] = { errors: [] }), O = O.properties[E]) : (O.items ?? (O.items = []), (b = O.items)[E] ?? (b[E] = { errors: [] }), O = O.items[E]), T && O.errors.push(s(_)), P++;
          }
        }
    };
    return p(f), h;
  }
  function l(f) {
    const s = [], h = f.map((p) => typeof p == "object" ? p.key : p);
    for (const p of h)
      typeof p == "number" ? s.push(`[${p}]`) : typeof p == "symbol" ? s.push(`[${JSON.stringify(String(p))}]`) : /[^\w$]/.test(p) ? s.push(`[${JSON.stringify(p)}]`) : (s.length && s.push("."), s.push(p));
    return s.join("");
  }
  function c(f) {
    const s = [], h = [...f.issues].sort((p, m) => (p.path ?? []).length - (m.path ?? []).length);
    for (const p of h)
      s.push(`✖ ${p.message}`), p.path?.length && s.push(`  → at ${l(p.path)}`);
    return s.join(`
`);
  }
  return Pt;
}
var dg;
function X0() {
  return dg || (dg = 1, (function(e) {
    var t = Kn && Kn.__createBinding || (Object.create ? (function(_, g, O, P) {
      P === void 0 && (P = O);
      var E = Object.getOwnPropertyDescriptor(g, O);
      (!E || ("get" in E ? !g.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
        return g[O];
      } }), Object.defineProperty(_, P, E);
    }) : (function(_, g, O, P) {
      P === void 0 && (P = O), _[P] = g[O];
    })), n = Kn && Kn.__setModuleDefault || (Object.create ? (function(_, g) {
      Object.defineProperty(_, "default", { enumerable: !0, value: g });
    }) : function(_, g) {
      _.default = g;
    }), r = Kn && Kn.__importStar || function(_) {
      if (_ && _.__esModule) return _;
      var g = {};
      if (_ != null) for (var O in _) O !== "default" && Object.prototype.hasOwnProperty.call(_, O) && t(g, _, O);
      return n(g, _), g;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.safeDecodeAsync = e._safeDecodeAsync = e.safeEncodeAsync = e._safeEncodeAsync = e.safeDecode = e._safeDecode = e.safeEncode = e._safeEncode = e.decodeAsync = e._decodeAsync = e.encodeAsync = e._encodeAsync = e.decode = e._decode = e.encode = e._encode = e.safeParseAsync = e._safeParseAsync = e.safeParse = e._safeParse = e.parseAsync = e._parseAsync = e.parse = e._parse = void 0;
    const i = r(al()), a = r(J0()), o = r(Pe()), d = (_) => (g, O, P, E) => {
      const T = P ? Object.assign(P, { async: !1 }) : { async: !1 }, D = g._zod.run({ value: O, issues: [] }, T);
      if (D instanceof Promise)
        throw new i.$ZodAsyncError();
      if (D.issues.length) {
        const N = new (E?.Err ?? _)(D.issues.map((M) => o.finalizeIssue(M, T, i.config())));
        throw o.captureStackTrace(N, E?.callee), N;
      }
      return D.value;
    };
    e._parse = d, e.parse = (0, e._parse)(a.$ZodRealError);
    const u = (_) => async (g, O, P, E) => {
      const T = P ? Object.assign(P, { async: !0 }) : { async: !0 };
      let D = g._zod.run({ value: O, issues: [] }, T);
      if (D instanceof Promise && (D = await D), D.issues.length) {
        const N = new (E?.Err ?? _)(D.issues.map((M) => o.finalizeIssue(M, T, i.config())));
        throw o.captureStackTrace(N, E?.callee), N;
      }
      return D.value;
    };
    e._parseAsync = u, e.parseAsync = (0, e._parseAsync)(a.$ZodRealError);
    const l = (_) => (g, O, P) => {
      const E = P ? { ...P, async: !1 } : { async: !1 }, T = g._zod.run({ value: O, issues: [] }, E);
      if (T instanceof Promise)
        throw new i.$ZodAsyncError();
      return T.issues.length ? {
        success: !1,
        error: new (_ ?? a.$ZodError)(T.issues.map((D) => o.finalizeIssue(D, E, i.config())))
      } : { success: !0, data: T.value };
    };
    e._safeParse = l, e.safeParse = (0, e._safeParse)(a.$ZodRealError);
    const c = (_) => async (g, O, P) => {
      const E = P ? Object.assign(P, { async: !0 }) : { async: !0 };
      let T = g._zod.run({ value: O, issues: [] }, E);
      return T instanceof Promise && (T = await T), T.issues.length ? {
        success: !1,
        error: new _(T.issues.map((D) => o.finalizeIssue(D, E, i.config())))
      } : { success: !0, data: T.value };
    };
    e._safeParseAsync = c, e.safeParseAsync = (0, e._safeParseAsync)(a.$ZodRealError);
    const f = (_) => (g, O, P) => {
      const E = P ? Object.assign(P, { direction: "backward" }) : { direction: "backward" };
      return (0, e._parse)(_)(g, O, E);
    };
    e._encode = f, e.encode = (0, e._encode)(a.$ZodRealError);
    const s = (_) => (g, O, P) => (0, e._parse)(_)(g, O, P);
    e._decode = s, e.decode = (0, e._decode)(a.$ZodRealError);
    const h = (_) => async (g, O, P) => {
      const E = P ? Object.assign(P, { direction: "backward" }) : { direction: "backward" };
      return (0, e._parseAsync)(_)(g, O, E);
    };
    e._encodeAsync = h, e.encodeAsync = (0, e._encodeAsync)(a.$ZodRealError);
    const p = (_) => async (g, O, P) => (0, e._parseAsync)(_)(g, O, P);
    e._decodeAsync = p, e.decodeAsync = (0, e._decodeAsync)(a.$ZodRealError);
    const m = (_) => (g, O, P) => {
      const E = P ? Object.assign(P, { direction: "backward" }) : { direction: "backward" };
      return (0, e._safeParse)(_)(g, O, E);
    };
    e._safeEncode = m, e.safeEncode = (0, e._safeEncode)(a.$ZodRealError);
    const y = (_) => (g, O, P) => (0, e._safeParse)(_)(g, O, P);
    e._safeDecode = y, e.safeDecode = (0, e._safeDecode)(a.$ZodRealError);
    const w = (_) => async (g, O, P) => {
      const E = P ? Object.assign(P, { direction: "backward" }) : { direction: "backward" };
      return (0, e._safeParseAsync)(_)(g, O, E);
    };
    e._safeEncodeAsync = w, e.safeEncodeAsync = (0, e._safeEncodeAsync)(a.$ZodRealError);
    const b = (_) => async (g, O, P) => (0, e._safeParseAsync)(_)(g, O, P);
    e._safeDecodeAsync = b, e.safeDecodeAsync = (0, e._safeDecodeAsync)(a.$ZodRealError);
  })(Kn)), Kn;
}
var Jn = {}, Xn = {}, Yn = {}, fg;
function dp() {
  return fg || (fg = 1, (function(e) {
    var t = Yn && Yn.__createBinding || (Object.create ? (function(b, _, g, O) {
      O === void 0 && (O = g);
      var P = Object.getOwnPropertyDescriptor(_, g);
      (!P || ("get" in P ? !_.__esModule : P.writable || P.configurable)) && (P = { enumerable: !0, get: function() {
        return _[g];
      } }), Object.defineProperty(b, O, P);
    }) : (function(b, _, g, O) {
      O === void 0 && (O = g), b[O] = _[g];
    })), n = Yn && Yn.__setModuleDefault || (Object.create ? (function(b, _) {
      Object.defineProperty(b, "default", { enumerable: !0, value: _ });
    }) : function(b, _) {
      b.default = _;
    }), r = Yn && Yn.__importStar || function(b) {
      if (b && b.__esModule) return b;
      var _ = {};
      if (b != null) for (var g in b) g !== "default" && Object.prototype.hasOwnProperty.call(b, g) && t(_, b, g);
      return n(_, b), _;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.sha384_hex = e.sha256_base64url = e.sha256_base64 = e.sha256_hex = e.sha1_base64url = e.sha1_base64 = e.sha1_hex = e.md5_base64url = e.md5_base64 = e.md5_hex = e.hex = e.uppercase = e.lowercase = e.undefined = e.null = e.boolean = e.number = e.integer = e.bigint = e.string = e.date = e.e164 = e.domain = e.hostname = e.base64url = e.base64 = e.cidrv6 = e.cidrv4 = e.mac = e.ipv6 = e.ipv4 = e.browserEmail = e.idnEmail = e.unicodeEmail = e.rfc5322Email = e.html5Email = e.email = e.uuid7 = e.uuid6 = e.uuid4 = e.uuid = e.guid = e.extendedDuration = e.duration = e.nanoid = e.ksuid = e.xid = e.ulid = e.cuid2 = e.cuid = void 0, e.sha512_base64url = e.sha512_base64 = e.sha512_hex = e.sha384_base64url = e.sha384_base64 = void 0, e.emoji = d, e.time = f, e.datetime = s;
    const i = r(Pe());
    e.cuid = /^[cC][^\s-]{8,}$/, e.cuid2 = /^[0-9a-z]+$/, e.ulid = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, e.xid = /^[0-9a-vA-V]{20}$/, e.ksuid = /^[A-Za-z0-9]{27}$/, e.nanoid = /^[a-zA-Z0-9_-]{21}$/, e.duration = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, e.extendedDuration = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, e.guid = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
    const a = (b) => b ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${b}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    e.uuid = a, e.uuid4 = (0, e.uuid)(4), e.uuid6 = (0, e.uuid)(6), e.uuid7 = (0, e.uuid)(7), e.email = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, e.html5Email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, e.rfc5322Email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, e.unicodeEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u, e.idnEmail = e.unicodeEmail, e.browserEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const o = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
    function d() {
      return new RegExp(o, "u");
    }
    e.ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, e.ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
    const u = (b) => {
      const _ = i.escapeRegex(b ?? ":");
      return new RegExp(`^(?:[0-9A-F]{2}${_}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${_}){5}[0-9a-f]{2}$`);
    };
    e.mac = u, e.cidrv4 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, e.cidrv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, e.base64 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, e.base64url = /^[A-Za-z0-9_-]*$/, e.hostname = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, e.domain = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, e.e164 = /^\+[1-9]\d{6,14}$/;
    const l = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
    e.date = new RegExp(`^${l}$`);
    function c(b) {
      const _ = "(?:[01]\\d|2[0-3]):[0-5]\\d";
      return typeof b.precision == "number" ? b.precision === -1 ? `${_}` : b.precision === 0 ? `${_}:[0-5]\\d` : `${_}:[0-5]\\d\\.\\d{${b.precision}}` : `${_}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    }
    function f(b) {
      return new RegExp(`^${c(b)}$`);
    }
    function s(b) {
      const _ = c({ precision: b.precision }), g = ["Z"];
      b.local && g.push(""), b.offset && g.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
      const O = `${_}(?:${g.join("|")})`;
      return new RegExp(`^${l}T(?:${O})$`);
    }
    const h = (b) => {
      const _ = b ? `[\\s\\S]{${b?.minimum ?? 0},${b?.maximum ?? ""}}` : "[\\s\\S]*";
      return new RegExp(`^${_}$`);
    };
    e.string = h, e.bigint = /^-?\d+n?$/, e.integer = /^-?\d+$/, e.number = /^-?\d+(?:\.\d+)?$/, e.boolean = /^(?:true|false)$/i;
    const p = /^null$/i;
    e.null = p;
    const m = /^undefined$/i;
    e.undefined = m, e.lowercase = /^[^A-Z]*$/, e.uppercase = /^[^a-z]*$/, e.hex = /^[0-9a-fA-F]*$/;
    function y(b, _) {
      return new RegExp(`^[A-Za-z0-9+/]{${b}}${_}$`);
    }
    function w(b) {
      return new RegExp(`^[A-Za-z0-9_-]{${b}}$`);
    }
    e.md5_hex = /^[0-9a-fA-F]{32}$/, e.md5_base64 = y(22, "=="), e.md5_base64url = w(22), e.sha1_hex = /^[0-9a-fA-F]{40}$/, e.sha1_base64 = y(27, "="), e.sha1_base64url = w(27), e.sha256_hex = /^[0-9a-fA-F]{64}$/, e.sha256_base64 = y(43, "="), e.sha256_base64url = w(43), e.sha384_hex = /^[0-9a-fA-F]{96}$/, e.sha384_base64 = y(64, ""), e.sha384_base64url = w(64), e.sha512_hex = /^[0-9a-fA-F]{128}$/, e.sha512_base64 = y(86, "=="), e.sha512_base64url = w(86);
  })(Yn)), Yn;
}
var hg;
function fp() {
  return hg || (hg = 1, (function(e) {
    var t = Xn && Xn.__createBinding || (Object.create ? (function(l, c, f, s) {
      s === void 0 && (s = f);
      var h = Object.getOwnPropertyDescriptor(c, f);
      (!h || ("get" in h ? !c.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return c[f];
      } }), Object.defineProperty(l, s, h);
    }) : (function(l, c, f, s) {
      s === void 0 && (s = f), l[s] = c[f];
    })), n = Xn && Xn.__setModuleDefault || (Object.create ? (function(l, c) {
      Object.defineProperty(l, "default", { enumerable: !0, value: c });
    }) : function(l, c) {
      l.default = c;
    }), r = Xn && Xn.__importStar || function(l) {
      if (l && l.__esModule) return l;
      var c = {};
      if (l != null) for (var f in l) f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(c, l, f);
      return n(c, l), c;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.$ZodCheckOverwrite = e.$ZodCheckMimeType = e.$ZodCheckProperty = e.$ZodCheckEndsWith = e.$ZodCheckStartsWith = e.$ZodCheckIncludes = e.$ZodCheckUpperCase = e.$ZodCheckLowerCase = e.$ZodCheckRegex = e.$ZodCheckStringFormat = e.$ZodCheckLengthEquals = e.$ZodCheckMinLength = e.$ZodCheckMaxLength = e.$ZodCheckSizeEquals = e.$ZodCheckMinSize = e.$ZodCheckMaxSize = e.$ZodCheckBigIntFormat = e.$ZodCheckNumberFormat = e.$ZodCheckMultipleOf = e.$ZodCheckGreaterThan = e.$ZodCheckLessThan = e.$ZodCheck = void 0;
    const i = r(al()), a = r(dp()), o = r(Pe());
    e.$ZodCheck = i.$constructor("$ZodCheck", (l, c) => {
      var f;
      l._zod ?? (l._zod = {}), l._zod.def = c, (f = l._zod).onattach ?? (f.onattach = []);
    });
    const d = {
      number: "number",
      bigint: "bigint",
      object: "date"
    };
    e.$ZodCheckLessThan = i.$constructor("$ZodCheckLessThan", (l, c) => {
      e.$ZodCheck.init(l, c);
      const f = d[typeof c.value];
      l._zod.onattach.push((s) => {
        const h = s._zod.bag, p = (c.inclusive ? h.maximum : h.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        c.value < p && (c.inclusive ? h.maximum = c.value : h.exclusiveMaximum = c.value);
      }), l._zod.check = (s) => {
        (c.inclusive ? s.value <= c.value : s.value < c.value) || s.issues.push({
          origin: f,
          code: "too_big",
          maximum: typeof c.value == "object" ? c.value.getTime() : c.value,
          input: s.value,
          inclusive: c.inclusive,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckGreaterThan = i.$constructor("$ZodCheckGreaterThan", (l, c) => {
      e.$ZodCheck.init(l, c);
      const f = d[typeof c.value];
      l._zod.onattach.push((s) => {
        const h = s._zod.bag, p = (c.inclusive ? h.minimum : h.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        c.value > p && (c.inclusive ? h.minimum = c.value : h.exclusiveMinimum = c.value);
      }), l._zod.check = (s) => {
        (c.inclusive ? s.value >= c.value : s.value > c.value) || s.issues.push({
          origin: f,
          code: "too_small",
          minimum: typeof c.value == "object" ? c.value.getTime() : c.value,
          input: s.value,
          inclusive: c.inclusive,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckMultipleOf = /* @__PURE__ */ i.$constructor("$ZodCheckMultipleOf", (l, c) => {
      e.$ZodCheck.init(l, c), l._zod.onattach.push((f) => {
        var s;
        (s = f._zod.bag).multipleOf ?? (s.multipleOf = c.value);
      }), l._zod.check = (f) => {
        if (typeof f.value != typeof c.value)
          throw new Error("Cannot mix number and bigint in multiple_of check.");
        (typeof f.value == "bigint" ? f.value % c.value === BigInt(0) : o.floatSafeRemainder(f.value, c.value) === 0) || f.issues.push({
          origin: typeof f.value,
          code: "not_multiple_of",
          divisor: c.value,
          input: f.value,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckNumberFormat = i.$constructor("$ZodCheckNumberFormat", (l, c) => {
      e.$ZodCheck.init(l, c), c.format = c.format || "float64";
      const f = c.format?.includes("int"), s = f ? "int" : "number", [h, p] = o.NUMBER_FORMAT_RANGES[c.format];
      l._zod.onattach.push((m) => {
        const y = m._zod.bag;
        y.format = c.format, y.minimum = h, y.maximum = p, f && (y.pattern = a.integer);
      }), l._zod.check = (m) => {
        const y = m.value;
        if (f) {
          if (!Number.isInteger(y)) {
            m.issues.push({
              expected: s,
              format: c.format,
              code: "invalid_type",
              continue: !1,
              input: y,
              inst: l
            });
            return;
          }
          if (!Number.isSafeInteger(y)) {
            y > 0 ? m.issues.push({
              input: y,
              code: "too_big",
              maximum: Number.MAX_SAFE_INTEGER,
              note: "Integers must be within the safe integer range.",
              inst: l,
              origin: s,
              inclusive: !0,
              continue: !c.abort
            }) : m.issues.push({
              input: y,
              code: "too_small",
              minimum: Number.MIN_SAFE_INTEGER,
              note: "Integers must be within the safe integer range.",
              inst: l,
              origin: s,
              inclusive: !0,
              continue: !c.abort
            });
            return;
          }
        }
        y < h && m.issues.push({
          origin: "number",
          input: y,
          code: "too_small",
          minimum: h,
          inclusive: !0,
          inst: l,
          continue: !c.abort
        }), y > p && m.issues.push({
          origin: "number",
          input: y,
          code: "too_big",
          maximum: p,
          inclusive: !0,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckBigIntFormat = i.$constructor("$ZodCheckBigIntFormat", (l, c) => {
      e.$ZodCheck.init(l, c);
      const [f, s] = o.BIGINT_FORMAT_RANGES[c.format];
      l._zod.onattach.push((h) => {
        const p = h._zod.bag;
        p.format = c.format, p.minimum = f, p.maximum = s;
      }), l._zod.check = (h) => {
        const p = h.value;
        p < f && h.issues.push({
          origin: "bigint",
          input: p,
          code: "too_small",
          minimum: f,
          inclusive: !0,
          inst: l,
          continue: !c.abort
        }), p > s && h.issues.push({
          origin: "bigint",
          input: p,
          code: "too_big",
          maximum: s,
          inclusive: !0,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckMaxSize = i.$constructor("$ZodCheckMaxSize", (l, c) => {
      var f;
      e.$ZodCheck.init(l, c), (f = l._zod.def).when ?? (f.when = (s) => {
        const h = s.value;
        return !o.nullish(h) && h.size !== void 0;
      }), l._zod.onattach.push((s) => {
        const h = s._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        c.maximum < h && (s._zod.bag.maximum = c.maximum);
      }), l._zod.check = (s) => {
        const h = s.value;
        h.size <= c.maximum || s.issues.push({
          origin: o.getSizableOrigin(h),
          code: "too_big",
          maximum: c.maximum,
          inclusive: !0,
          input: h,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckMinSize = i.$constructor("$ZodCheckMinSize", (l, c) => {
      var f;
      e.$ZodCheck.init(l, c), (f = l._zod.def).when ?? (f.when = (s) => {
        const h = s.value;
        return !o.nullish(h) && h.size !== void 0;
      }), l._zod.onattach.push((s) => {
        const h = s._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        c.minimum > h && (s._zod.bag.minimum = c.minimum);
      }), l._zod.check = (s) => {
        const h = s.value;
        h.size >= c.minimum || s.issues.push({
          origin: o.getSizableOrigin(h),
          code: "too_small",
          minimum: c.minimum,
          inclusive: !0,
          input: h,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckSizeEquals = i.$constructor("$ZodCheckSizeEquals", (l, c) => {
      var f;
      e.$ZodCheck.init(l, c), (f = l._zod.def).when ?? (f.when = (s) => {
        const h = s.value;
        return !o.nullish(h) && h.size !== void 0;
      }), l._zod.onattach.push((s) => {
        const h = s._zod.bag;
        h.minimum = c.size, h.maximum = c.size, h.size = c.size;
      }), l._zod.check = (s) => {
        const h = s.value, p = h.size;
        if (p === c.size)
          return;
        const m = p > c.size;
        s.issues.push({
          origin: o.getSizableOrigin(h),
          ...m ? { code: "too_big", maximum: c.size } : { code: "too_small", minimum: c.size },
          inclusive: !0,
          exact: !0,
          input: s.value,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckMaxLength = i.$constructor("$ZodCheckMaxLength", (l, c) => {
      var f;
      e.$ZodCheck.init(l, c), (f = l._zod.def).when ?? (f.when = (s) => {
        const h = s.value;
        return !o.nullish(h) && h.length !== void 0;
      }), l._zod.onattach.push((s) => {
        const h = s._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        c.maximum < h && (s._zod.bag.maximum = c.maximum);
      }), l._zod.check = (s) => {
        const h = s.value;
        if (h.length <= c.maximum)
          return;
        const m = o.getLengthableOrigin(h);
        s.issues.push({
          origin: m,
          code: "too_big",
          maximum: c.maximum,
          inclusive: !0,
          input: h,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckMinLength = i.$constructor("$ZodCheckMinLength", (l, c) => {
      var f;
      e.$ZodCheck.init(l, c), (f = l._zod.def).when ?? (f.when = (s) => {
        const h = s.value;
        return !o.nullish(h) && h.length !== void 0;
      }), l._zod.onattach.push((s) => {
        const h = s._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        c.minimum > h && (s._zod.bag.minimum = c.minimum);
      }), l._zod.check = (s) => {
        const h = s.value;
        if (h.length >= c.minimum)
          return;
        const m = o.getLengthableOrigin(h);
        s.issues.push({
          origin: m,
          code: "too_small",
          minimum: c.minimum,
          inclusive: !0,
          input: h,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckLengthEquals = i.$constructor("$ZodCheckLengthEquals", (l, c) => {
      var f;
      e.$ZodCheck.init(l, c), (f = l._zod.def).when ?? (f.when = (s) => {
        const h = s.value;
        return !o.nullish(h) && h.length !== void 0;
      }), l._zod.onattach.push((s) => {
        const h = s._zod.bag;
        h.minimum = c.length, h.maximum = c.length, h.length = c.length;
      }), l._zod.check = (s) => {
        const h = s.value, p = h.length;
        if (p === c.length)
          return;
        const m = o.getLengthableOrigin(h), y = p > c.length;
        s.issues.push({
          origin: m,
          ...y ? { code: "too_big", maximum: c.length } : { code: "too_small", minimum: c.length },
          inclusive: !0,
          exact: !0,
          input: s.value,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckStringFormat = i.$constructor("$ZodCheckStringFormat", (l, c) => {
      var f, s;
      e.$ZodCheck.init(l, c), l._zod.onattach.push((h) => {
        const p = h._zod.bag;
        p.format = c.format, c.pattern && (p.patterns ?? (p.patterns = /* @__PURE__ */ new Set()), p.patterns.add(c.pattern));
      }), c.pattern ? (f = l._zod).check ?? (f.check = (h) => {
        c.pattern.lastIndex = 0, !c.pattern.test(h.value) && h.issues.push({
          origin: "string",
          code: "invalid_format",
          format: c.format,
          input: h.value,
          ...c.pattern ? { pattern: c.pattern.toString() } : {},
          inst: l,
          continue: !c.abort
        });
      }) : (s = l._zod).check ?? (s.check = () => {
      });
    }), e.$ZodCheckRegex = i.$constructor("$ZodCheckRegex", (l, c) => {
      e.$ZodCheckStringFormat.init(l, c), l._zod.check = (f) => {
        c.pattern.lastIndex = 0, !c.pattern.test(f.value) && f.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "regex",
          input: f.value,
          pattern: c.pattern.toString(),
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckLowerCase = i.$constructor("$ZodCheckLowerCase", (l, c) => {
      c.pattern ?? (c.pattern = a.lowercase), e.$ZodCheckStringFormat.init(l, c);
    }), e.$ZodCheckUpperCase = i.$constructor("$ZodCheckUpperCase", (l, c) => {
      c.pattern ?? (c.pattern = a.uppercase), e.$ZodCheckStringFormat.init(l, c);
    }), e.$ZodCheckIncludes = i.$constructor("$ZodCheckIncludes", (l, c) => {
      e.$ZodCheck.init(l, c);
      const f = o.escapeRegex(c.includes), s = new RegExp(typeof c.position == "number" ? `^.{${c.position}}${f}` : f);
      c.pattern = s, l._zod.onattach.push((h) => {
        const p = h._zod.bag;
        p.patterns ?? (p.patterns = /* @__PURE__ */ new Set()), p.patterns.add(s);
      }), l._zod.check = (h) => {
        h.value.includes(c.includes, c.position) || h.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "includes",
          includes: c.includes,
          input: h.value,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckStartsWith = i.$constructor("$ZodCheckStartsWith", (l, c) => {
      e.$ZodCheck.init(l, c);
      const f = new RegExp(`^${o.escapeRegex(c.prefix)}.*`);
      c.pattern ?? (c.pattern = f), l._zod.onattach.push((s) => {
        const h = s._zod.bag;
        h.patterns ?? (h.patterns = /* @__PURE__ */ new Set()), h.patterns.add(f);
      }), l._zod.check = (s) => {
        s.value.startsWith(c.prefix) || s.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "starts_with",
          prefix: c.prefix,
          input: s.value,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckEndsWith = i.$constructor("$ZodCheckEndsWith", (l, c) => {
      e.$ZodCheck.init(l, c);
      const f = new RegExp(`.*${o.escapeRegex(c.suffix)}$`);
      c.pattern ?? (c.pattern = f), l._zod.onattach.push((s) => {
        const h = s._zod.bag;
        h.patterns ?? (h.patterns = /* @__PURE__ */ new Set()), h.patterns.add(f);
      }), l._zod.check = (s) => {
        s.value.endsWith(c.suffix) || s.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "ends_with",
          suffix: c.suffix,
          input: s.value,
          inst: l,
          continue: !c.abort
        });
      };
    });
    function u(l, c, f) {
      l.issues.length && c.issues.push(...o.prefixIssues(f, l.issues));
    }
    e.$ZodCheckProperty = i.$constructor("$ZodCheckProperty", (l, c) => {
      e.$ZodCheck.init(l, c), l._zod.check = (f) => {
        const s = c.schema._zod.run({
          value: f.value[c.property],
          issues: []
        }, {});
        if (s instanceof Promise)
          return s.then((h) => u(h, f, c.property));
        u(s, f, c.property);
      };
    }), e.$ZodCheckMimeType = i.$constructor("$ZodCheckMimeType", (l, c) => {
      e.$ZodCheck.init(l, c);
      const f = new Set(c.mime);
      l._zod.onattach.push((s) => {
        s._zod.bag.mime = c.mime;
      }), l._zod.check = (s) => {
        f.has(s.value.type) || s.issues.push({
          code: "invalid_value",
          values: c.mime,
          input: s.value.type,
          inst: l,
          continue: !c.abort
        });
      };
    }), e.$ZodCheckOverwrite = i.$constructor("$ZodCheckOverwrite", (l, c) => {
      e.$ZodCheck.init(l, c), l._zod.check = (f) => {
        f.value = c.tx(f.value);
      };
    });
  })(Xn)), Xn;
}
var _a = {}, pg;
function Y0() {
  if (pg) return _a;
  pg = 1, Object.defineProperty(_a, "__esModule", { value: !0 }), _a.Doc = void 0;
  class e {
    constructor(n = []) {
      this.content = [], this.indent = 0, this && (this.args = n);
    }
    indented(n) {
      this.indent += 1, n(this), this.indent -= 1;
    }
    write(n) {
      if (typeof n == "function") {
        n(this, { execution: "sync" }), n(this, { execution: "async" });
        return;
      }
      const i = n.split(`
`).filter((d) => d), a = Math.min(...i.map((d) => d.length - d.trimStart().length)), o = i.map((d) => d.slice(a)).map((d) => " ".repeat(this.indent * 2) + d);
      for (const d of o)
        this.content.push(d);
    }
    compile() {
      const n = Function, r = this?.args, a = [...(this?.content ?? [""]).map((o) => `  ${o}`)];
      return new n(...r, a.join(`
`));
    }
  }
  return _a.Doc = e, _a;
}
var wa = {}, mg;
function Q0() {
  return mg || (mg = 1, Object.defineProperty(wa, "__esModule", { value: !0 }), wa.version = void 0, wa.version = {
    major: 4,
    minor: 3,
    patch: 6
  }), wa;
}
var gg;
function ek() {
  return gg || (gg = 1, (function(e) {
    var t = Jn && Jn.__createBinding || (Object.create ? (function(k, I, S, A) {
      A === void 0 && (A = S);
      var j = Object.getOwnPropertyDescriptor(I, S);
      (!j || ("get" in j ? !I.__esModule : j.writable || j.configurable)) && (j = { enumerable: !0, get: function() {
        return I[S];
      } }), Object.defineProperty(k, A, j);
    }) : (function(k, I, S, A) {
      A === void 0 && (A = S), k[A] = I[S];
    })), n = Jn && Jn.__setModuleDefault || (Object.create ? (function(k, I) {
      Object.defineProperty(k, "default", { enumerable: !0, value: I });
    }) : function(k, I) {
      k.default = I;
    }), r = Jn && Jn.__importStar || function(k) {
      if (k && k.__esModule) return k;
      var I = {};
      if (k != null) for (var S in k) S !== "default" && Object.prototype.hasOwnProperty.call(k, S) && t(I, k, S);
      return n(I, k), I;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.$ZodTuple = e.$ZodIntersection = e.$ZodDiscriminatedUnion = e.$ZodXor = e.$ZodUnion = e.$ZodObjectJIT = e.$ZodObject = e.$ZodArray = e.$ZodDate = e.$ZodVoid = e.$ZodNever = e.$ZodUnknown = e.$ZodAny = e.$ZodNull = e.$ZodUndefined = e.$ZodSymbol = e.$ZodBigIntFormat = e.$ZodBigInt = e.$ZodBoolean = e.$ZodNumberFormat = e.$ZodNumber = e.$ZodCustomStringFormat = e.$ZodJWT = e.$ZodE164 = e.$ZodBase64URL = e.$ZodBase64 = e.$ZodCIDRv6 = e.$ZodCIDRv4 = e.$ZodMAC = e.$ZodIPv6 = e.$ZodIPv4 = e.$ZodISODuration = e.$ZodISOTime = e.$ZodISODate = e.$ZodISODateTime = e.$ZodKSUID = e.$ZodXID = e.$ZodULID = e.$ZodCUID2 = e.$ZodCUID = e.$ZodNanoID = e.$ZodEmoji = e.$ZodURL = e.$ZodEmail = e.$ZodUUID = e.$ZodGUID = e.$ZodStringFormat = e.$ZodString = e.clone = e.$ZodType = void 0, e.$ZodCustom = e.$ZodLazy = e.$ZodPromise = e.$ZodFunction = e.$ZodTemplateLiteral = e.$ZodReadonly = e.$ZodCodec = e.$ZodPipe = e.$ZodNaN = e.$ZodCatch = e.$ZodSuccess = e.$ZodNonOptional = e.$ZodPrefault = e.$ZodDefault = e.$ZodNullable = e.$ZodExactOptional = e.$ZodOptional = e.$ZodTransform = e.$ZodFile = e.$ZodLiteral = e.$ZodEnum = e.$ZodSet = e.$ZodMap = e.$ZodRecord = void 0, e.isValidBase64 = s, e.isValidBase64URL = h, e.isValidJWT = p;
    const i = r(fp()), a = r(al()), o = Y0(), d = X0(), u = r(dp()), l = r(Pe()), c = Q0();
    e.$ZodType = a.$constructor("$ZodType", (k, I) => {
      var S;
      k ?? (k = {}), k._zod.def = I, k._zod.bag = k._zod.bag || {}, k._zod.version = c.version;
      const A = [...k._zod.def.checks ?? []];
      k._zod.traits.has("$ZodCheck") && A.unshift(k);
      for (const j of A)
        for (const z of j._zod.onattach)
          z(k);
      if (A.length === 0)
        (S = k._zod).deferred ?? (S.deferred = []), k._zod.deferred?.push(() => {
          k._zod.run = k._zod.parse;
        });
      else {
        const j = (L, F, K) => {
          let ee = l.aborted(L), U;
          for (const q of F) {
            if (q._zod.def.when) {
              if (!q._zod.def.when(L))
                continue;
            } else if (ee)
              continue;
            const ne = L.issues.length, oe = q._zod.check(L);
            if (oe instanceof Promise && K?.async === !1)
              throw new a.$ZodAsyncError();
            if (U || oe instanceof Promise)
              U = (U ?? Promise.resolve()).then(async () => {
                await oe, L.issues.length !== ne && (ee || (ee = l.aborted(L, ne)));
              });
            else {
              if (L.issues.length === ne)
                continue;
              ee || (ee = l.aborted(L, ne));
            }
          }
          return U ? U.then(() => L) : L;
        }, z = (L, F, K) => {
          if (l.aborted(L))
            return L.aborted = !0, L;
          const ee = j(F, A, K);
          if (ee instanceof Promise) {
            if (K.async === !1)
              throw new a.$ZodAsyncError();
            return ee.then((U) => k._zod.parse(U, K));
          }
          return k._zod.parse(ee, K);
        };
        k._zod.run = (L, F) => {
          if (F.skipChecks)
            return k._zod.parse(L, F);
          if (F.direction === "backward") {
            const ee = k._zod.parse({ value: L.value, issues: [] }, { ...F, skipChecks: !0 });
            return ee instanceof Promise ? ee.then((U) => z(U, L, F)) : z(ee, L, F);
          }
          const K = k._zod.parse(L, F);
          if (K instanceof Promise) {
            if (F.async === !1)
              throw new a.$ZodAsyncError();
            return K.then((ee) => j(ee, A, F));
          }
          return j(K, A, F);
        };
      }
      l.defineLazy(k, "~standard", () => ({
        validate: (j) => {
          try {
            const z = (0, d.safeParse)(k, j);
            return z.success ? { value: z.data } : { issues: z.error?.issues };
          } catch {
            return (0, d.safeParseAsync)(k, j).then((L) => L.success ? { value: L.data } : { issues: L.error?.issues });
          }
        },
        vendor: "zod",
        version: 1
      }));
    });
    var f = Pe();
    Object.defineProperty(e, "clone", { enumerable: !0, get: function() {
      return f.clone;
    } }), e.$ZodString = a.$constructor("$ZodString", (k, I) => {
      e.$ZodType.init(k, I), k._zod.pattern = [...k?._zod.bag?.patterns ?? []].pop() ?? u.string(k._zod.bag), k._zod.parse = (S, A) => {
        if (I.coerce)
          try {
            S.value = String(S.value);
          } catch {
          }
        return typeof S.value == "string" || S.issues.push({
          expected: "string",
          code: "invalid_type",
          input: S.value,
          inst: k
        }), S;
      };
    }), e.$ZodStringFormat = a.$constructor("$ZodStringFormat", (k, I) => {
      i.$ZodCheckStringFormat.init(k, I), e.$ZodString.init(k, I);
    }), e.$ZodGUID = a.$constructor("$ZodGUID", (k, I) => {
      I.pattern ?? (I.pattern = u.guid), e.$ZodStringFormat.init(k, I);
    }), e.$ZodUUID = a.$constructor("$ZodUUID", (k, I) => {
      if (I.version) {
        const A = {
          v1: 1,
          v2: 2,
          v3: 3,
          v4: 4,
          v5: 5,
          v6: 6,
          v7: 7,
          v8: 8
        }[I.version];
        if (A === void 0)
          throw new Error(`Invalid UUID version: "${I.version}"`);
        I.pattern ?? (I.pattern = u.uuid(A));
      } else
        I.pattern ?? (I.pattern = u.uuid());
      e.$ZodStringFormat.init(k, I);
    }), e.$ZodEmail = a.$constructor("$ZodEmail", (k, I) => {
      I.pattern ?? (I.pattern = u.email), e.$ZodStringFormat.init(k, I);
    }), e.$ZodURL = a.$constructor("$ZodURL", (k, I) => {
      e.$ZodStringFormat.init(k, I), k._zod.check = (S) => {
        try {
          const A = S.value.trim(), j = new URL(A);
          I.hostname && (I.hostname.lastIndex = 0, I.hostname.test(j.hostname) || S.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid hostname",
            pattern: I.hostname.source,
            input: S.value,
            inst: k,
            continue: !I.abort
          })), I.protocol && (I.protocol.lastIndex = 0, I.protocol.test(j.protocol.endsWith(":") ? j.protocol.slice(0, -1) : j.protocol) || S.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid protocol",
            pattern: I.protocol.source,
            input: S.value,
            inst: k,
            continue: !I.abort
          })), I.normalize ? S.value = j.href : S.value = A;
          return;
        } catch {
          S.issues.push({
            code: "invalid_format",
            format: "url",
            input: S.value,
            inst: k,
            continue: !I.abort
          });
        }
      };
    }), e.$ZodEmoji = a.$constructor("$ZodEmoji", (k, I) => {
      I.pattern ?? (I.pattern = u.emoji()), e.$ZodStringFormat.init(k, I);
    }), e.$ZodNanoID = a.$constructor("$ZodNanoID", (k, I) => {
      I.pattern ?? (I.pattern = u.nanoid), e.$ZodStringFormat.init(k, I);
    }), e.$ZodCUID = a.$constructor("$ZodCUID", (k, I) => {
      I.pattern ?? (I.pattern = u.cuid), e.$ZodStringFormat.init(k, I);
    }), e.$ZodCUID2 = a.$constructor("$ZodCUID2", (k, I) => {
      I.pattern ?? (I.pattern = u.cuid2), e.$ZodStringFormat.init(k, I);
    }), e.$ZodULID = a.$constructor("$ZodULID", (k, I) => {
      I.pattern ?? (I.pattern = u.ulid), e.$ZodStringFormat.init(k, I);
    }), e.$ZodXID = a.$constructor("$ZodXID", (k, I) => {
      I.pattern ?? (I.pattern = u.xid), e.$ZodStringFormat.init(k, I);
    }), e.$ZodKSUID = a.$constructor("$ZodKSUID", (k, I) => {
      I.pattern ?? (I.pattern = u.ksuid), e.$ZodStringFormat.init(k, I);
    }), e.$ZodISODateTime = a.$constructor("$ZodISODateTime", (k, I) => {
      I.pattern ?? (I.pattern = u.datetime(I)), e.$ZodStringFormat.init(k, I);
    }), e.$ZodISODate = a.$constructor("$ZodISODate", (k, I) => {
      I.pattern ?? (I.pattern = u.date), e.$ZodStringFormat.init(k, I);
    }), e.$ZodISOTime = a.$constructor("$ZodISOTime", (k, I) => {
      I.pattern ?? (I.pattern = u.time(I)), e.$ZodStringFormat.init(k, I);
    }), e.$ZodISODuration = a.$constructor("$ZodISODuration", (k, I) => {
      I.pattern ?? (I.pattern = u.duration), e.$ZodStringFormat.init(k, I);
    }), e.$ZodIPv4 = a.$constructor("$ZodIPv4", (k, I) => {
      I.pattern ?? (I.pattern = u.ipv4), e.$ZodStringFormat.init(k, I), k._zod.bag.format = "ipv4";
    }), e.$ZodIPv6 = a.$constructor("$ZodIPv6", (k, I) => {
      I.pattern ?? (I.pattern = u.ipv6), e.$ZodStringFormat.init(k, I), k._zod.bag.format = "ipv6", k._zod.check = (S) => {
        try {
          new URL(`http://[${S.value}]`);
        } catch {
          S.issues.push({
            code: "invalid_format",
            format: "ipv6",
            input: S.value,
            inst: k,
            continue: !I.abort
          });
        }
      };
    }), e.$ZodMAC = a.$constructor("$ZodMAC", (k, I) => {
      I.pattern ?? (I.pattern = u.mac(I.delimiter)), e.$ZodStringFormat.init(k, I), k._zod.bag.format = "mac";
    }), e.$ZodCIDRv4 = a.$constructor("$ZodCIDRv4", (k, I) => {
      I.pattern ?? (I.pattern = u.cidrv4), e.$ZodStringFormat.init(k, I);
    }), e.$ZodCIDRv6 = a.$constructor("$ZodCIDRv6", (k, I) => {
      I.pattern ?? (I.pattern = u.cidrv6), e.$ZodStringFormat.init(k, I), k._zod.check = (S) => {
        const A = S.value.split("/");
        try {
          if (A.length !== 2)
            throw new Error();
          const [j, z] = A;
          if (!z)
            throw new Error();
          const L = Number(z);
          if (`${L}` !== z)
            throw new Error();
          if (L < 0 || L > 128)
            throw new Error();
          new URL(`http://[${j}]`);
        } catch {
          S.issues.push({
            code: "invalid_format",
            format: "cidrv6",
            input: S.value,
            inst: k,
            continue: !I.abort
          });
        }
      };
    });
    function s(k) {
      if (k === "")
        return !0;
      if (k.length % 4 !== 0)
        return !1;
      try {
        return atob(k), !0;
      } catch {
        return !1;
      }
    }
    e.$ZodBase64 = a.$constructor("$ZodBase64", (k, I) => {
      I.pattern ?? (I.pattern = u.base64), e.$ZodStringFormat.init(k, I), k._zod.bag.contentEncoding = "base64", k._zod.check = (S) => {
        s(S.value) || S.issues.push({
          code: "invalid_format",
          format: "base64",
          input: S.value,
          inst: k,
          continue: !I.abort
        });
      };
    });
    function h(k) {
      if (!u.base64url.test(k))
        return !1;
      const I = k.replace(/[-_]/g, (A) => A === "-" ? "+" : "/"), S = I.padEnd(Math.ceil(I.length / 4) * 4, "=");
      return s(S);
    }
    e.$ZodBase64URL = a.$constructor("$ZodBase64URL", (k, I) => {
      I.pattern ?? (I.pattern = u.base64url), e.$ZodStringFormat.init(k, I), k._zod.bag.contentEncoding = "base64url", k._zod.check = (S) => {
        h(S.value) || S.issues.push({
          code: "invalid_format",
          format: "base64url",
          input: S.value,
          inst: k,
          continue: !I.abort
        });
      };
    }), e.$ZodE164 = a.$constructor("$ZodE164", (k, I) => {
      I.pattern ?? (I.pattern = u.e164), e.$ZodStringFormat.init(k, I);
    });
    function p(k, I = null) {
      try {
        const S = k.split(".");
        if (S.length !== 3)
          return !1;
        const [A] = S;
        if (!A)
          return !1;
        const j = JSON.parse(atob(A));
        return !("typ" in j && j?.typ !== "JWT" || !j.alg || I && (!("alg" in j) || j.alg !== I));
      } catch {
        return !1;
      }
    }
    e.$ZodJWT = a.$constructor("$ZodJWT", (k, I) => {
      e.$ZodStringFormat.init(k, I), k._zod.check = (S) => {
        p(S.value, I.alg) || S.issues.push({
          code: "invalid_format",
          format: "jwt",
          input: S.value,
          inst: k,
          continue: !I.abort
        });
      };
    }), e.$ZodCustomStringFormat = a.$constructor("$ZodCustomStringFormat", (k, I) => {
      e.$ZodStringFormat.init(k, I), k._zod.check = (S) => {
        I.fn(S.value) || S.issues.push({
          code: "invalid_format",
          format: I.format,
          input: S.value,
          inst: k,
          continue: !I.abort
        });
      };
    }), e.$ZodNumber = a.$constructor("$ZodNumber", (k, I) => {
      e.$ZodType.init(k, I), k._zod.pattern = k._zod.bag.pattern ?? u.number, k._zod.parse = (S, A) => {
        if (I.coerce)
          try {
            S.value = Number(S.value);
          } catch {
          }
        const j = S.value;
        if (typeof j == "number" && !Number.isNaN(j) && Number.isFinite(j))
          return S;
        const z = typeof j == "number" ? Number.isNaN(j) ? "NaN" : Number.isFinite(j) ? void 0 : "Infinity" : void 0;
        return S.issues.push({
          expected: "number",
          code: "invalid_type",
          input: j,
          inst: k,
          ...z ? { received: z } : {}
        }), S;
      };
    }), e.$ZodNumberFormat = a.$constructor("$ZodNumberFormat", (k, I) => {
      i.$ZodCheckNumberFormat.init(k, I), e.$ZodNumber.init(k, I);
    }), e.$ZodBoolean = a.$constructor("$ZodBoolean", (k, I) => {
      e.$ZodType.init(k, I), k._zod.pattern = u.boolean, k._zod.parse = (S, A) => {
        if (I.coerce)
          try {
            S.value = !!S.value;
          } catch {
          }
        const j = S.value;
        return typeof j == "boolean" || S.issues.push({
          expected: "boolean",
          code: "invalid_type",
          input: j,
          inst: k
        }), S;
      };
    }), e.$ZodBigInt = a.$constructor("$ZodBigInt", (k, I) => {
      e.$ZodType.init(k, I), k._zod.pattern = u.bigint, k._zod.parse = (S, A) => {
        if (I.coerce)
          try {
            S.value = BigInt(S.value);
          } catch {
          }
        return typeof S.value == "bigint" || S.issues.push({
          expected: "bigint",
          code: "invalid_type",
          input: S.value,
          inst: k
        }), S;
      };
    }), e.$ZodBigIntFormat = a.$constructor("$ZodBigIntFormat", (k, I) => {
      i.$ZodCheckBigIntFormat.init(k, I), e.$ZodBigInt.init(k, I);
    }), e.$ZodSymbol = a.$constructor("$ZodSymbol", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value;
        return typeof j == "symbol" || S.issues.push({
          expected: "symbol",
          code: "invalid_type",
          input: j,
          inst: k
        }), S;
      };
    }), e.$ZodUndefined = a.$constructor("$ZodUndefined", (k, I) => {
      e.$ZodType.init(k, I), k._zod.pattern = u.undefined, k._zod.values = /* @__PURE__ */ new Set([void 0]), k._zod.optin = "optional", k._zod.optout = "optional", k._zod.parse = (S, A) => {
        const j = S.value;
        return typeof j > "u" || S.issues.push({
          expected: "undefined",
          code: "invalid_type",
          input: j,
          inst: k
        }), S;
      };
    }), e.$ZodNull = a.$constructor("$ZodNull", (k, I) => {
      e.$ZodType.init(k, I), k._zod.pattern = u.null, k._zod.values = /* @__PURE__ */ new Set([null]), k._zod.parse = (S, A) => {
        const j = S.value;
        return j === null || S.issues.push({
          expected: "null",
          code: "invalid_type",
          input: j,
          inst: k
        }), S;
      };
    }), e.$ZodAny = a.$constructor("$ZodAny", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S) => S;
    }), e.$ZodUnknown = a.$constructor("$ZodUnknown", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S) => S;
    }), e.$ZodNever = a.$constructor("$ZodNever", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => (S.issues.push({
        expected: "never",
        code: "invalid_type",
        input: S.value,
        inst: k
      }), S);
    }), e.$ZodVoid = a.$constructor("$ZodVoid", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value;
        return typeof j > "u" || S.issues.push({
          expected: "void",
          code: "invalid_type",
          input: j,
          inst: k
        }), S;
      };
    }), e.$ZodDate = a.$constructor("$ZodDate", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        if (I.coerce)
          try {
            S.value = new Date(S.value);
          } catch {
          }
        const j = S.value, z = j instanceof Date;
        return z && !Number.isNaN(j.getTime()) || S.issues.push({
          expected: "date",
          code: "invalid_type",
          input: j,
          ...z ? { received: "Invalid Date" } : {},
          inst: k
        }), S;
      };
    });
    function m(k, I, S) {
      k.issues.length && I.issues.push(...l.prefixIssues(S, k.issues)), I.value[S] = k.value;
    }
    e.$ZodArray = a.$constructor("$ZodArray", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value;
        if (!Array.isArray(j))
          return S.issues.push({
            expected: "array",
            code: "invalid_type",
            input: j,
            inst: k
          }), S;
        S.value = Array(j.length);
        const z = [];
        for (let L = 0; L < j.length; L++) {
          const F = j[L], K = I.element._zod.run({
            value: F,
            issues: []
          }, A);
          K instanceof Promise ? z.push(K.then((ee) => m(ee, S, L))) : m(K, S, L);
        }
        return z.length ? Promise.all(z).then(() => S) : S;
      };
    });
    function y(k, I, S, A, j) {
      if (k.issues.length) {
        if (j && !(S in A))
          return;
        I.issues.push(...l.prefixIssues(S, k.issues));
      }
      k.value === void 0 ? S in A && (I.value[S] = void 0) : I.value[S] = k.value;
    }
    function w(k) {
      const I = Object.keys(k.shape);
      for (const A of I)
        if (!k.shape?.[A]?._zod?.traits?.has("$ZodType"))
          throw new Error(`Invalid element at key "${A}": expected a Zod schema`);
      const S = l.optionalKeys(k.shape);
      return {
        ...k,
        keys: I,
        keySet: new Set(I),
        numKeys: I.length,
        optionalKeys: new Set(S)
      };
    }
    function b(k, I, S, A, j, z) {
      const L = [], F = j.keySet, K = j.catchall._zod, ee = K.def.type, U = K.optout === "optional";
      for (const q in I) {
        if (F.has(q))
          continue;
        if (ee === "never") {
          L.push(q);
          continue;
        }
        const ne = K.run({ value: I[q], issues: [] }, A);
        ne instanceof Promise ? k.push(ne.then((oe) => y(oe, S, q, I, U))) : y(ne, S, q, I, U);
      }
      return L.length && S.issues.push({
        code: "unrecognized_keys",
        keys: L,
        input: I,
        inst: z
      }), k.length ? Promise.all(k).then(() => S) : S;
    }
    e.$ZodObject = a.$constructor("$ZodObject", (k, I) => {
      if (e.$ZodType.init(k, I), !Object.getOwnPropertyDescriptor(I, "shape")?.get) {
        const F = I.shape;
        Object.defineProperty(I, "shape", {
          get: () => {
            const K = { ...F };
            return Object.defineProperty(I, "shape", {
              value: K
            }), K;
          }
        });
      }
      const A = l.cached(() => w(I));
      l.defineLazy(k._zod, "propValues", () => {
        const F = I.shape, K = {};
        for (const ee in F) {
          const U = F[ee]._zod;
          if (U.values) {
            K[ee] ?? (K[ee] = /* @__PURE__ */ new Set());
            for (const q of U.values)
              K[ee].add(q);
          }
        }
        return K;
      });
      const j = l.isObject, z = I.catchall;
      let L;
      k._zod.parse = (F, K) => {
        L ?? (L = A.value);
        const ee = F.value;
        if (!j(ee))
          return F.issues.push({
            expected: "object",
            code: "invalid_type",
            input: ee,
            inst: k
          }), F;
        F.value = {};
        const U = [], q = L.shape;
        for (const ne of L.keys) {
          const oe = q[ne], Y = oe._zod.optout === "optional", re = oe._zod.run({ value: ee[ne], issues: [] }, K);
          re instanceof Promise ? U.push(re.then((de) => y(de, F, ne, ee, Y))) : y(re, F, ne, ee, Y);
        }
        return z ? b(U, ee, F, K, A.value, k) : U.length ? Promise.all(U).then(() => F) : F;
      };
    }), e.$ZodObjectJIT = a.$constructor("$ZodObjectJIT", (k, I) => {
      e.$ZodObject.init(k, I);
      const S = k._zod.parse, A = l.cached(() => w(I)), j = (ne) => {
        const oe = new o.Doc(["shape", "payload", "ctx"]), Y = A.value, re = (pe) => {
          const ke = l.esc(pe);
          return `shape[${ke}]._zod.run({ value: input[${ke}], issues: [] }, ctx)`;
        };
        oe.write("const input = payload.value;");
        const de = /* @__PURE__ */ Object.create(null);
        let ve = 0;
        for (const pe of Y.keys)
          de[pe] = `key_${ve++}`;
        oe.write("const newResult = {};");
        for (const pe of Y.keys) {
          const ke = de[pe], Ne = l.esc(pe), X = ne[pe]?._zod?.optout === "optional";
          oe.write(`const ${ke} = ${re(pe)};`), X ? oe.write(`
        if (${ke}.issues.length) {
          if (${Ne} in input) {
            payload.issues = payload.issues.concat(${ke}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${Ne}, ...iss.path] : [${Ne}]
            })));
          }
        }
        
        if (${ke}.value === undefined) {
          if (${Ne} in input) {
            newResult[${Ne}] = undefined;
          }
        } else {
          newResult[${Ne}] = ${ke}.value;
        }
        
      `) : oe.write(`
        if (${ke}.issues.length) {
          payload.issues = payload.issues.concat(${ke}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${Ne}, ...iss.path] : [${Ne}]
          })));
        }
        
        if (${ke}.value === undefined) {
          if (${Ne} in input) {
            newResult[${Ne}] = undefined;
          }
        } else {
          newResult[${Ne}] = ${ke}.value;
        }
        
      `);
        }
        oe.write("payload.value = newResult;"), oe.write("return payload;");
        const se = oe.compile();
        return (pe, ke) => se(ne, pe, ke);
      };
      let z;
      const L = l.isObject, F = !a.globalConfig.jitless, K = l.allowsEval, ee = F && K.value, U = I.catchall;
      let q;
      k._zod.parse = (ne, oe) => {
        q ?? (q = A.value);
        const Y = ne.value;
        return L(Y) ? F && ee && oe?.async === !1 && oe.jitless !== !0 ? (z || (z = j(I.shape)), ne = z(ne, oe), U ? b([], Y, ne, oe, q, k) : ne) : S(ne, oe) : (ne.issues.push({
          expected: "object",
          code: "invalid_type",
          input: Y,
          inst: k
        }), ne);
      };
    });
    function _(k, I, S, A) {
      for (const z of k)
        if (z.issues.length === 0)
          return I.value = z.value, I;
      const j = k.filter((z) => !l.aborted(z));
      return j.length === 1 ? (I.value = j[0].value, j[0]) : (I.issues.push({
        code: "invalid_union",
        input: I.value,
        inst: S,
        errors: k.map((z) => z.issues.map((L) => l.finalizeIssue(L, A, a.config())))
      }), I);
    }
    e.$ZodUnion = a.$constructor("$ZodUnion", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "optin", () => I.options.some((j) => j._zod.optin === "optional") ? "optional" : void 0), l.defineLazy(k._zod, "optout", () => I.options.some((j) => j._zod.optout === "optional") ? "optional" : void 0), l.defineLazy(k._zod, "values", () => {
        if (I.options.every((j) => j._zod.values))
          return new Set(I.options.flatMap((j) => Array.from(j._zod.values)));
      }), l.defineLazy(k._zod, "pattern", () => {
        if (I.options.every((j) => j._zod.pattern)) {
          const j = I.options.map((z) => z._zod.pattern);
          return new RegExp(`^(${j.map((z) => l.cleanRegex(z.source)).join("|")})$`);
        }
      });
      const S = I.options.length === 1, A = I.options[0]._zod.run;
      k._zod.parse = (j, z) => {
        if (S)
          return A(j, z);
        let L = !1;
        const F = [];
        for (const K of I.options) {
          const ee = K._zod.run({
            value: j.value,
            issues: []
          }, z);
          if (ee instanceof Promise)
            F.push(ee), L = !0;
          else {
            if (ee.issues.length === 0)
              return ee;
            F.push(ee);
          }
        }
        return L ? Promise.all(F).then((K) => _(K, j, k, z)) : _(F, j, k, z);
      };
    });
    function g(k, I, S, A) {
      const j = k.filter((z) => z.issues.length === 0);
      return j.length === 1 ? (I.value = j[0].value, I) : (j.length === 0 ? I.issues.push({
        code: "invalid_union",
        input: I.value,
        inst: S,
        errors: k.map((z) => z.issues.map((L) => l.finalizeIssue(L, A, a.config())))
      }) : I.issues.push({
        code: "invalid_union",
        input: I.value,
        inst: S,
        errors: [],
        inclusive: !1
      }), I);
    }
    e.$ZodXor = a.$constructor("$ZodXor", (k, I) => {
      e.$ZodUnion.init(k, I), I.inclusive = !1;
      const S = I.options.length === 1, A = I.options[0]._zod.run;
      k._zod.parse = (j, z) => {
        if (S)
          return A(j, z);
        let L = !1;
        const F = [];
        for (const K of I.options) {
          const ee = K._zod.run({
            value: j.value,
            issues: []
          }, z);
          ee instanceof Promise ? (F.push(ee), L = !0) : F.push(ee);
        }
        return L ? Promise.all(F).then((K) => g(K, j, k, z)) : g(F, j, k, z);
      };
    }), e.$ZodDiscriminatedUnion = /* @__PURE__ */ a.$constructor("$ZodDiscriminatedUnion", (k, I) => {
      I.inclusive = !1, e.$ZodUnion.init(k, I);
      const S = k._zod.parse;
      l.defineLazy(k._zod, "propValues", () => {
        const j = {};
        for (const z of I.options) {
          const L = z._zod.propValues;
          if (!L || Object.keys(L).length === 0)
            throw new Error(`Invalid discriminated union option at index "${I.options.indexOf(z)}"`);
          for (const [F, K] of Object.entries(L)) {
            j[F] || (j[F] = /* @__PURE__ */ new Set());
            for (const ee of K)
              j[F].add(ee);
          }
        }
        return j;
      });
      const A = l.cached(() => {
        const j = I.options, z = /* @__PURE__ */ new Map();
        for (const L of j) {
          const F = L._zod.propValues?.[I.discriminator];
          if (!F || F.size === 0)
            throw new Error(`Invalid discriminated union option at index "${I.options.indexOf(L)}"`);
          for (const K of F) {
            if (z.has(K))
              throw new Error(`Duplicate discriminator value "${String(K)}"`);
            z.set(K, L);
          }
        }
        return z;
      });
      k._zod.parse = (j, z) => {
        const L = j.value;
        if (!l.isObject(L))
          return j.issues.push({
            code: "invalid_type",
            expected: "object",
            input: L,
            inst: k
          }), j;
        const F = A.value.get(L?.[I.discriminator]);
        return F ? F._zod.run(j, z) : I.unionFallback ? S(j, z) : (j.issues.push({
          code: "invalid_union",
          errors: [],
          note: "No matching discriminator",
          discriminator: I.discriminator,
          input: L,
          path: [I.discriminator],
          inst: k
        }), j);
      };
    }), e.$ZodIntersection = a.$constructor("$ZodIntersection", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value, z = I.left._zod.run({ value: j, issues: [] }, A), L = I.right._zod.run({ value: j, issues: [] }, A);
        return z instanceof Promise || L instanceof Promise ? Promise.all([z, L]).then(([K, ee]) => P(S, K, ee)) : P(S, z, L);
      };
    });
    function O(k, I) {
      if (k === I)
        return { valid: !0, data: k };
      if (k instanceof Date && I instanceof Date && +k == +I)
        return { valid: !0, data: k };
      if (l.isPlainObject(k) && l.isPlainObject(I)) {
        const S = Object.keys(I), A = Object.keys(k).filter((z) => S.indexOf(z) !== -1), j = { ...k, ...I };
        for (const z of A) {
          const L = O(k[z], I[z]);
          if (!L.valid)
            return {
              valid: !1,
              mergeErrorPath: [z, ...L.mergeErrorPath]
            };
          j[z] = L.data;
        }
        return { valid: !0, data: j };
      }
      if (Array.isArray(k) && Array.isArray(I)) {
        if (k.length !== I.length)
          return { valid: !1, mergeErrorPath: [] };
        const S = [];
        for (let A = 0; A < k.length; A++) {
          const j = k[A], z = I[A], L = O(j, z);
          if (!L.valid)
            return {
              valid: !1,
              mergeErrorPath: [A, ...L.mergeErrorPath]
            };
          S.push(L.data);
        }
        return { valid: !0, data: S };
      }
      return { valid: !1, mergeErrorPath: [] };
    }
    function P(k, I, S) {
      const A = /* @__PURE__ */ new Map();
      let j;
      for (const F of I.issues)
        if (F.code === "unrecognized_keys") {
          j ?? (j = F);
          for (const K of F.keys)
            A.has(K) || A.set(K, {}), A.get(K).l = !0;
        } else
          k.issues.push(F);
      for (const F of S.issues)
        if (F.code === "unrecognized_keys")
          for (const K of F.keys)
            A.has(K) || A.set(K, {}), A.get(K).r = !0;
        else
          k.issues.push(F);
      const z = [...A].filter(([, F]) => F.l && F.r).map(([F]) => F);
      if (z.length && j && k.issues.push({ ...j, keys: z }), l.aborted(k))
        return k;
      const L = O(I.value, S.value);
      if (!L.valid)
        throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(L.mergeErrorPath)}`);
      return k.value = L.data, k;
    }
    e.$ZodTuple = a.$constructor("$ZodTuple", (k, I) => {
      e.$ZodType.init(k, I);
      const S = I.items;
      k._zod.parse = (A, j) => {
        const z = A.value;
        if (!Array.isArray(z))
          return A.issues.push({
            input: z,
            inst: k,
            expected: "tuple",
            code: "invalid_type"
          }), A;
        A.value = [];
        const L = [], F = [...S].reverse().findIndex((U) => U._zod.optin !== "optional"), K = F === -1 ? 0 : S.length - F;
        if (!I.rest) {
          const U = z.length > S.length, q = z.length < K - 1;
          if (U || q)
            return A.issues.push({
              ...U ? { code: "too_big", maximum: S.length, inclusive: !0 } : { code: "too_small", minimum: S.length },
              input: z,
              inst: k,
              origin: "array"
            }), A;
        }
        let ee = -1;
        for (const U of S) {
          if (ee++, ee >= z.length && ee >= K)
            continue;
          const q = U._zod.run({
            value: z[ee],
            issues: []
          }, j);
          q instanceof Promise ? L.push(q.then((ne) => E(ne, A, ee))) : E(q, A, ee);
        }
        if (I.rest) {
          const U = z.slice(S.length);
          for (const q of U) {
            ee++;
            const ne = I.rest._zod.run({
              value: q,
              issues: []
            }, j);
            ne instanceof Promise ? L.push(ne.then((oe) => E(oe, A, ee))) : E(ne, A, ee);
          }
        }
        return L.length ? Promise.all(L).then(() => A) : A;
      };
    });
    function E(k, I, S) {
      k.issues.length && I.issues.push(...l.prefixIssues(S, k.issues)), I.value[S] = k.value;
    }
    e.$ZodRecord = a.$constructor("$ZodRecord", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value;
        if (!l.isPlainObject(j))
          return S.issues.push({
            expected: "record",
            code: "invalid_type",
            input: j,
            inst: k
          }), S;
        const z = [], L = I.keyType._zod.values;
        if (L) {
          S.value = {};
          const F = /* @__PURE__ */ new Set();
          for (const ee of L)
            if (typeof ee == "string" || typeof ee == "number" || typeof ee == "symbol") {
              F.add(typeof ee == "number" ? ee.toString() : ee);
              const U = I.valueType._zod.run({ value: j[ee], issues: [] }, A);
              U instanceof Promise ? z.push(U.then((q) => {
                q.issues.length && S.issues.push(...l.prefixIssues(ee, q.issues)), S.value[ee] = q.value;
              })) : (U.issues.length && S.issues.push(...l.prefixIssues(ee, U.issues)), S.value[ee] = U.value);
            }
          let K;
          for (const ee in j)
            F.has(ee) || (K = K ?? [], K.push(ee));
          K && K.length > 0 && S.issues.push({
            code: "unrecognized_keys",
            input: j,
            inst: k,
            keys: K
          });
        } else {
          S.value = {};
          for (const F of Reflect.ownKeys(j)) {
            if (F === "__proto__")
              continue;
            let K = I.keyType._zod.run({ value: F, issues: [] }, A);
            if (K instanceof Promise)
              throw new Error("Async schemas not supported in object keys currently");
            if (typeof F == "string" && u.number.test(F) && K.issues.length) {
              const q = I.keyType._zod.run({ value: Number(F), issues: [] }, A);
              if (q instanceof Promise)
                throw new Error("Async schemas not supported in object keys currently");
              q.issues.length === 0 && (K = q);
            }
            if (K.issues.length) {
              I.mode === "loose" ? S.value[F] = j[F] : S.issues.push({
                code: "invalid_key",
                origin: "record",
                issues: K.issues.map((q) => l.finalizeIssue(q, A, a.config())),
                input: F,
                path: [F],
                inst: k
              });
              continue;
            }
            const U = I.valueType._zod.run({ value: j[F], issues: [] }, A);
            U instanceof Promise ? z.push(U.then((q) => {
              q.issues.length && S.issues.push(...l.prefixIssues(F, q.issues)), S.value[K.value] = q.value;
            })) : (U.issues.length && S.issues.push(...l.prefixIssues(F, U.issues)), S.value[K.value] = U.value);
          }
        }
        return z.length ? Promise.all(z).then(() => S) : S;
      };
    }), e.$ZodMap = a.$constructor("$ZodMap", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value;
        if (!(j instanceof Map))
          return S.issues.push({
            expected: "map",
            code: "invalid_type",
            input: j,
            inst: k
          }), S;
        const z = [];
        S.value = /* @__PURE__ */ new Map();
        for (const [L, F] of j) {
          const K = I.keyType._zod.run({ value: L, issues: [] }, A), ee = I.valueType._zod.run({ value: F, issues: [] }, A);
          K instanceof Promise || ee instanceof Promise ? z.push(Promise.all([K, ee]).then(([U, q]) => {
            T(U, q, S, L, j, k, A);
          })) : T(K, ee, S, L, j, k, A);
        }
        return z.length ? Promise.all(z).then(() => S) : S;
      };
    });
    function T(k, I, S, A, j, z, L) {
      k.issues.length && (l.propertyKeyTypes.has(typeof A) ? S.issues.push(...l.prefixIssues(A, k.issues)) : S.issues.push({
        code: "invalid_key",
        origin: "map",
        input: j,
        inst: z,
        issues: k.issues.map((F) => l.finalizeIssue(F, L, a.config()))
      })), I.issues.length && (l.propertyKeyTypes.has(typeof A) ? S.issues.push(...l.prefixIssues(A, I.issues)) : S.issues.push({
        origin: "map",
        code: "invalid_element",
        input: j,
        inst: z,
        key: A,
        issues: I.issues.map((F) => l.finalizeIssue(F, L, a.config()))
      })), S.value.set(k.value, I.value);
    }
    e.$ZodSet = a.$constructor("$ZodSet", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value;
        if (!(j instanceof Set))
          return S.issues.push({
            input: j,
            inst: k,
            expected: "set",
            code: "invalid_type"
          }), S;
        const z = [];
        S.value = /* @__PURE__ */ new Set();
        for (const L of j) {
          const F = I.valueType._zod.run({ value: L, issues: [] }, A);
          F instanceof Promise ? z.push(F.then((K) => D(K, S))) : D(F, S);
        }
        return z.length ? Promise.all(z).then(() => S) : S;
      };
    });
    function D(k, I) {
      k.issues.length && I.issues.push(...k.issues), I.value.add(k.value);
    }
    e.$ZodEnum = a.$constructor("$ZodEnum", (k, I) => {
      e.$ZodType.init(k, I);
      const S = l.getEnumValues(I.entries), A = new Set(S);
      k._zod.values = A, k._zod.pattern = new RegExp(`^(${S.filter((j) => l.propertyKeyTypes.has(typeof j)).map((j) => typeof j == "string" ? l.escapeRegex(j) : j.toString()).join("|")})$`), k._zod.parse = (j, z) => {
        const L = j.value;
        return A.has(L) || j.issues.push({
          code: "invalid_value",
          values: S,
          input: L,
          inst: k
        }), j;
      };
    }), e.$ZodLiteral = a.$constructor("$ZodLiteral", (k, I) => {
      if (e.$ZodType.init(k, I), I.values.length === 0)
        throw new Error("Cannot create literal schema with no valid values");
      const S = new Set(I.values);
      k._zod.values = S, k._zod.pattern = new RegExp(`^(${I.values.map((A) => typeof A == "string" ? l.escapeRegex(A) : A ? l.escapeRegex(A.toString()) : String(A)).join("|")})$`), k._zod.parse = (A, j) => {
        const z = A.value;
        return S.has(z) || A.issues.push({
          code: "invalid_value",
          values: I.values,
          input: z,
          inst: k
        }), A;
      };
    }), e.$ZodFile = a.$constructor("$ZodFile", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        const j = S.value;
        return j instanceof File || S.issues.push({
          expected: "file",
          code: "invalid_type",
          input: j,
          inst: k
        }), S;
      };
    }), e.$ZodTransform = a.$constructor("$ZodTransform", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        if (A.direction === "backward")
          throw new a.$ZodEncodeError(k.constructor.name);
        const j = I.transform(S.value, S);
        if (A.async)
          return (j instanceof Promise ? j : Promise.resolve(j)).then((L) => (S.value = L, S));
        if (j instanceof Promise)
          throw new a.$ZodAsyncError();
        return S.value = j, S;
      };
    });
    function N(k, I) {
      return k.issues.length && I === void 0 ? { issues: [], value: void 0 } : k;
    }
    e.$ZodOptional = a.$constructor("$ZodOptional", (k, I) => {
      e.$ZodType.init(k, I), k._zod.optin = "optional", k._zod.optout = "optional", l.defineLazy(k._zod, "values", () => I.innerType._zod.values ? /* @__PURE__ */ new Set([...I.innerType._zod.values, void 0]) : void 0), l.defineLazy(k._zod, "pattern", () => {
        const S = I.innerType._zod.pattern;
        return S ? new RegExp(`^(${l.cleanRegex(S.source)})?$`) : void 0;
      }), k._zod.parse = (S, A) => {
        if (I.innerType._zod.optin === "optional") {
          const j = I.innerType._zod.run(S, A);
          return j instanceof Promise ? j.then((z) => N(z, S.value)) : N(j, S.value);
        }
        return S.value === void 0 ? S : I.innerType._zod.run(S, A);
      };
    }), e.$ZodExactOptional = a.$constructor("$ZodExactOptional", (k, I) => {
      e.$ZodOptional.init(k, I), l.defineLazy(k._zod, "values", () => I.innerType._zod.values), l.defineLazy(k._zod, "pattern", () => I.innerType._zod.pattern), k._zod.parse = (S, A) => I.innerType._zod.run(S, A);
    }), e.$ZodNullable = a.$constructor("$ZodNullable", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "optin", () => I.innerType._zod.optin), l.defineLazy(k._zod, "optout", () => I.innerType._zod.optout), l.defineLazy(k._zod, "pattern", () => {
        const S = I.innerType._zod.pattern;
        return S ? new RegExp(`^(${l.cleanRegex(S.source)}|null)$`) : void 0;
      }), l.defineLazy(k._zod, "values", () => I.innerType._zod.values ? /* @__PURE__ */ new Set([...I.innerType._zod.values, null]) : void 0), k._zod.parse = (S, A) => S.value === null ? S : I.innerType._zod.run(S, A);
    }), e.$ZodDefault = a.$constructor("$ZodDefault", (k, I) => {
      e.$ZodType.init(k, I), k._zod.optin = "optional", l.defineLazy(k._zod, "values", () => I.innerType._zod.values), k._zod.parse = (S, A) => {
        if (A.direction === "backward")
          return I.innerType._zod.run(S, A);
        if (S.value === void 0)
          return S.value = I.defaultValue, S;
        const j = I.innerType._zod.run(S, A);
        return j instanceof Promise ? j.then((z) => M(z, I)) : M(j, I);
      };
    });
    function M(k, I) {
      return k.value === void 0 && (k.value = I.defaultValue), k;
    }
    e.$ZodPrefault = a.$constructor("$ZodPrefault", (k, I) => {
      e.$ZodType.init(k, I), k._zod.optin = "optional", l.defineLazy(k._zod, "values", () => I.innerType._zod.values), k._zod.parse = (S, A) => (A.direction === "backward" || S.value === void 0 && (S.value = I.defaultValue), I.innerType._zod.run(S, A));
    }), e.$ZodNonOptional = a.$constructor("$ZodNonOptional", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "values", () => {
        const S = I.innerType._zod.values;
        return S ? new Set([...S].filter((A) => A !== void 0)) : void 0;
      }), k._zod.parse = (S, A) => {
        const j = I.innerType._zod.run(S, A);
        return j instanceof Promise ? j.then((z) => R(z, k)) : R(j, k);
      };
    });
    function R(k, I) {
      return !k.issues.length && k.value === void 0 && k.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: k.value,
        inst: I
      }), k;
    }
    e.$ZodSuccess = a.$constructor("$ZodSuccess", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => {
        if (A.direction === "backward")
          throw new a.$ZodEncodeError("ZodSuccess");
        const j = I.innerType._zod.run(S, A);
        return j instanceof Promise ? j.then((z) => (S.value = z.issues.length === 0, S)) : (S.value = j.issues.length === 0, S);
      };
    }), e.$ZodCatch = a.$constructor("$ZodCatch", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "optin", () => I.innerType._zod.optin), l.defineLazy(k._zod, "optout", () => I.innerType._zod.optout), l.defineLazy(k._zod, "values", () => I.innerType._zod.values), k._zod.parse = (S, A) => {
        if (A.direction === "backward")
          return I.innerType._zod.run(S, A);
        const j = I.innerType._zod.run(S, A);
        return j instanceof Promise ? j.then((z) => (S.value = z.value, z.issues.length && (S.value = I.catchValue({
          ...S,
          error: {
            issues: z.issues.map((L) => l.finalizeIssue(L, A, a.config()))
          },
          input: S.value
        }), S.issues = []), S)) : (S.value = j.value, j.issues.length && (S.value = I.catchValue({
          ...S,
          error: {
            issues: j.issues.map((z) => l.finalizeIssue(z, A, a.config()))
          },
          input: S.value
        }), S.issues = []), S);
      };
    }), e.$ZodNaN = a.$constructor("$ZodNaN", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => ((typeof S.value != "number" || !Number.isNaN(S.value)) && S.issues.push({
        input: S.value,
        inst: k,
        expected: "nan",
        code: "invalid_type"
      }), S);
    }), e.$ZodPipe = a.$constructor("$ZodPipe", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "values", () => I.in._zod.values), l.defineLazy(k._zod, "optin", () => I.in._zod.optin), l.defineLazy(k._zod, "optout", () => I.out._zod.optout), l.defineLazy(k._zod, "propValues", () => I.in._zod.propValues), k._zod.parse = (S, A) => {
        if (A.direction === "backward") {
          const z = I.out._zod.run(S, A);
          return z instanceof Promise ? z.then((L) => V(L, I.in, A)) : V(z, I.in, A);
        }
        const j = I.in._zod.run(S, A);
        return j instanceof Promise ? j.then((z) => V(z, I.out, A)) : V(j, I.out, A);
      };
    });
    function V(k, I, S) {
      return k.issues.length ? (k.aborted = !0, k) : I._zod.run({ value: k.value, issues: k.issues }, S);
    }
    e.$ZodCodec = a.$constructor("$ZodCodec", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "values", () => I.in._zod.values), l.defineLazy(k._zod, "optin", () => I.in._zod.optin), l.defineLazy(k._zod, "optout", () => I.out._zod.optout), l.defineLazy(k._zod, "propValues", () => I.in._zod.propValues), k._zod.parse = (S, A) => {
        if ((A.direction || "forward") === "forward") {
          const z = I.in._zod.run(S, A);
          return z instanceof Promise ? z.then((L) => C(L, I, A)) : C(z, I, A);
        } else {
          const z = I.out._zod.run(S, A);
          return z instanceof Promise ? z.then((L) => C(L, I, A)) : C(z, I, A);
        }
      };
    });
    function C(k, I, S) {
      if (k.issues.length)
        return k.aborted = !0, k;
      if ((S.direction || "forward") === "forward") {
        const j = I.transform(k.value, k);
        return j instanceof Promise ? j.then((z) => B(k, z, I.out, S)) : B(k, j, I.out, S);
      } else {
        const j = I.reverseTransform(k.value, k);
        return j instanceof Promise ? j.then((z) => B(k, z, I.in, S)) : B(k, j, I.in, S);
      }
    }
    function B(k, I, S, A) {
      return k.issues.length ? (k.aborted = !0, k) : S._zod.run({ value: I, issues: k.issues }, A);
    }
    e.$ZodReadonly = a.$constructor("$ZodReadonly", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "propValues", () => I.innerType._zod.propValues), l.defineLazy(k._zod, "values", () => I.innerType._zod.values), l.defineLazy(k._zod, "optin", () => I.innerType?._zod?.optin), l.defineLazy(k._zod, "optout", () => I.innerType?._zod?.optout), k._zod.parse = (S, A) => {
        if (A.direction === "backward")
          return I.innerType._zod.run(S, A);
        const j = I.innerType._zod.run(S, A);
        return j instanceof Promise ? j.then(G) : G(j);
      };
    });
    function G(k) {
      return k.value = Object.freeze(k.value), k;
    }
    e.$ZodTemplateLiteral = a.$constructor("$ZodTemplateLiteral", (k, I) => {
      e.$ZodType.init(k, I);
      const S = [];
      for (const A of I.parts)
        if (typeof A == "object" && A !== null) {
          if (!A._zod.pattern)
            throw new Error(`Invalid template literal part, no pattern found: ${[...A._zod.traits].shift()}`);
          const j = A._zod.pattern instanceof RegExp ? A._zod.pattern.source : A._zod.pattern;
          if (!j)
            throw new Error(`Invalid template literal part: ${A._zod.traits}`);
          const z = j.startsWith("^") ? 1 : 0, L = j.endsWith("$") ? j.length - 1 : j.length;
          S.push(j.slice(z, L));
        } else if (A === null || l.primitiveTypes.has(typeof A))
          S.push(l.escapeRegex(`${A}`));
        else
          throw new Error(`Invalid template literal part: ${A}`);
      k._zod.pattern = new RegExp(`^${S.join("")}$`), k._zod.parse = (A, j) => typeof A.value != "string" ? (A.issues.push({
        input: A.value,
        inst: k,
        expected: "string",
        code: "invalid_type"
      }), A) : (k._zod.pattern.lastIndex = 0, k._zod.pattern.test(A.value) || A.issues.push({
        input: A.value,
        inst: k,
        code: "invalid_format",
        format: I.format ?? "template_literal",
        pattern: k._zod.pattern.source
      }), A);
    }), e.$ZodFunction = a.$constructor("$ZodFunction", (k, I) => (e.$ZodType.init(k, I), k._def = I, k._zod.def = I, k.implement = (S) => {
      if (typeof S != "function")
        throw new Error("implement() must be called with a function");
      return function(...A) {
        const j = k._def.input ? (0, d.parse)(k._def.input, A) : A, z = Reflect.apply(S, this, j);
        return k._def.output ? (0, d.parse)(k._def.output, z) : z;
      };
    }, k.implementAsync = (S) => {
      if (typeof S != "function")
        throw new Error("implementAsync() must be called with a function");
      return async function(...A) {
        const j = k._def.input ? await (0, d.parseAsync)(k._def.input, A) : A, z = await Reflect.apply(S, this, j);
        return k._def.output ? await (0, d.parseAsync)(k._def.output, z) : z;
      };
    }, k._zod.parse = (S, A) => typeof S.value != "function" ? (S.issues.push({
      code: "invalid_type",
      expected: "function",
      input: S.value,
      inst: k
    }), S) : (k._def.output && k._def.output._zod.def.type === "promise" ? S.value = k.implementAsync(S.value) : S.value = k.implement(S.value), S), k.input = (...S) => {
      const A = k.constructor;
      return Array.isArray(S[0]) ? new A({
        type: "function",
        input: new e.$ZodTuple({
          type: "tuple",
          items: S[0],
          rest: S[1]
        }),
        output: k._def.output
      }) : new A({
        type: "function",
        input: S[0],
        output: k._def.output
      });
    }, k.output = (S) => {
      const A = k.constructor;
      return new A({
        type: "function",
        input: k._def.input,
        output: S
      });
    }, k)), e.$ZodPromise = a.$constructor("$ZodPromise", (k, I) => {
      e.$ZodType.init(k, I), k._zod.parse = (S, A) => Promise.resolve(S.value).then((j) => I.innerType._zod.run({ value: j, issues: [] }, A));
    }), e.$ZodLazy = a.$constructor("$ZodLazy", (k, I) => {
      e.$ZodType.init(k, I), l.defineLazy(k._zod, "innerType", () => I.getter()), l.defineLazy(k._zod, "pattern", () => k._zod.innerType?._zod?.pattern), l.defineLazy(k._zod, "propValues", () => k._zod.innerType?._zod?.propValues), l.defineLazy(k._zod, "optin", () => k._zod.innerType?._zod?.optin ?? void 0), l.defineLazy(k._zod, "optout", () => k._zod.innerType?._zod?.optout ?? void 0), k._zod.parse = (S, A) => k._zod.innerType._zod.run(S, A);
    }), e.$ZodCustom = a.$constructor("$ZodCustom", (k, I) => {
      i.$ZodCheck.init(k, I), e.$ZodType.init(k, I), k._zod.parse = (S, A) => S, k._zod.check = (S) => {
        const A = S.value, j = I.fn(A);
        if (j instanceof Promise)
          return j.then((z) => Q(z, S, A, k));
        Q(j, S, A, k);
      };
    });
    function Q(k, I, S, A) {
      if (!k) {
        const j = {
          code: "custom",
          input: S,
          inst: A,
          // incorporates params.error into issue reporting
          path: [...A._zod.def.path ?? []],
          // incorporates params.error into issue reporting
          continue: !A._zod.def.abort
          // params: inst._zod.def.params,
        };
        A._zod.def.params && (j.params = A._zod.def.params), I.issues.push(l.issue(j));
      }
    }
  })(Jn)), Jn;
}
var ka = {}, Ca = { exports: {} }, yi = Ca.exports, yg;
function aE() {
  return yg || (yg = 1, (function(e, t) {
    var n = yi && yi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = yi && yi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = yi && yi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "حرف", verb: "أن يحوي" },
        file: { unit: "بايت", verb: "أن يحوي" },
        array: { unit: "عنصر", verb: "أن يحوي" },
        set: { unit: "عنصر", verb: "أن يحوي" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "مدخل",
        email: "بريد إلكتروني",
        url: "رابط",
        emoji: "إيموجي",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "تاريخ ووقت بمعيار ISO",
        date: "تاريخ بمعيار ISO",
        time: "وقت بمعيار ISO",
        duration: "مدة بمعيار ISO",
        ipv4: "عنوان IPv4",
        ipv6: "عنوان IPv6",
        cidrv4: "مدى عناوين بصيغة IPv4",
        cidrv6: "مدى عناوين بصيغة IPv6",
        base64: "نَص بترميز base64-encoded",
        base64url: "نَص بترميز base64url-encoded",
        json_string: "نَص على هيئة JSON",
        e164: "رقم هاتف بمعيار E.164",
        jwt: "JWT",
        template_literal: "مدخل"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `مدخلات غير مقبولة: يفترض إدخال instanceof ${s.expected}، ولكن تم إدخال ${m}` : `مدخلات غير مقبولة: يفترض إدخال ${h}، ولكن تم إدخال ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `مدخلات غير مقبولة: يفترض إدخال ${a.stringifyPrimitive(s.values[0])}` : `اختيار غير مقبول: يتوقع انتقاء أحد هذه الخيارات: ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? ` أكبر من اللازم: يفترض أن تكون ${s.origin ?? "القيمة"} ${h} ${s.maximum.toString()} ${p.unit ?? "عنصر"}` : `أكبر من اللازم: يفترض أن تكون ${s.origin ?? "القيمة"} ${h} ${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `أصغر من اللازم: يفترض لـ ${s.origin} أن يكون ${h} ${s.minimum.toString()} ${p.unit}` : `أصغر من اللازم: يفترض لـ ${s.origin} أن يكون ${h} ${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `نَص غير مقبول: يجب أن يبدأ بـ "${s.prefix}"` : h.format === "ends_with" ? `نَص غير مقبول: يجب أن ينتهي بـ "${h.suffix}"` : h.format === "includes" ? `نَص غير مقبول: يجب أن يتضمَّن "${h.includes}"` : h.format === "regex" ? `نَص غير مقبول: يجب أن يطابق النمط ${h.pattern}` : `${c[h.format] ?? s.format} غير مقبول`;
          }
          case "not_multiple_of":
            return `رقم غير مقبول: يجب أن يكون من مضاعفات ${s.divisor}`;
          case "unrecognized_keys":
            return `معرف${s.keys.length > 1 ? "ات" : ""} غريب${s.keys.length > 1 ? "ة" : ""}: ${a.joinValues(s.keys, "، ")}`;
          case "invalid_key":
            return `معرف غير مقبول في ${s.origin}`;
          case "invalid_union":
            return "مدخل غير مقبول";
          case "invalid_element":
            return `مدخل غير مقبول في ${s.origin}`;
          default:
            return "مدخل غير مقبول";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ca, Ca.exports)), Ca.exports;
}
var Da = { exports: {} }, vi = Da.exports, vg;
function sE() {
  return vg || (vg = 1, (function(e, t) {
    var n = vi && vi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = vi && vi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = vi && vi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "simvol", verb: "olmalıdır" },
        file: { unit: "bayt", verb: "olmalıdır" },
        array: { unit: "element", verb: "olmalıdır" },
        set: { unit: "element", verb: "olmalıdır" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Yanlış dəyər: gözlənilən instanceof ${s.expected}, daxil olan ${m}` : `Yanlış dəyər: gözlənilən ${h}, daxil olan ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Yanlış dəyər: gözlənilən ${a.stringifyPrimitive(s.values[0])}` : `Yanlış seçim: aşağıdakılardan biri olmalıdır: ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Çox böyük: gözlənilən ${s.origin ?? "dəyər"} ${h}${s.maximum.toString()} ${p.unit ?? "element"}` : `Çox böyük: gözlənilən ${s.origin ?? "dəyər"} ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Çox kiçik: gözlənilən ${s.origin} ${h}${s.minimum.toString()} ${p.unit}` : `Çox kiçik: gözlənilən ${s.origin} ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Yanlış mətn: "${h.prefix}" ilə başlamalıdır` : h.format === "ends_with" ? `Yanlış mətn: "${h.suffix}" ilə bitməlidir` : h.format === "includes" ? `Yanlış mətn: "${h.includes}" daxil olmalıdır` : h.format === "regex" ? `Yanlış mətn: ${h.pattern} şablonuna uyğun olmalıdır` : `Yanlış ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Yanlış ədəd: ${s.divisor} ilə bölünə bilən olmalıdır`;
          case "unrecognized_keys":
            return `Tanınmayan açar${s.keys.length > 1 ? "lar" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `${s.origin} daxilində yanlış açar`;
          case "invalid_union":
            return "Yanlış dəyər";
          case "invalid_element":
            return `${s.origin} daxilində yanlış dəyər`;
          default:
            return "Yanlış dəyər";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Da, Da.exports)), Da.exports;
}
var Aa = { exports: {} }, bi = Aa.exports, bg;
function lE() {
  return bg || (bg = 1, (function(e, t) {
    var n = bi && bi.__createBinding || (Object.create ? (function(l, c, f, s) {
      s === void 0 && (s = f);
      var h = Object.getOwnPropertyDescriptor(c, f);
      (!h || ("get" in h ? !c.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return c[f];
      } }), Object.defineProperty(l, s, h);
    }) : (function(l, c, f, s) {
      s === void 0 && (s = f), l[s] = c[f];
    })), r = bi && bi.__setModuleDefault || (Object.create ? (function(l, c) {
      Object.defineProperty(l, "default", { enumerable: !0, value: c });
    }) : function(l, c) {
      l.default = c;
    }), i = bi && bi.__importStar || function(l) {
      if (l && l.__esModule) return l;
      var c = {};
      if (l != null) for (var f in l) f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && n(c, l, f);
      return r(c, l), c;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = u;
    const a = i(Pe());
    function o(l, c, f, s) {
      const h = Math.abs(l), p = h % 10, m = h % 100;
      return m >= 11 && m <= 19 ? s : p === 1 ? c : p >= 2 && p <= 4 ? f : s;
    }
    const d = () => {
      const l = {
        string: {
          unit: {
            one: "сімвал",
            few: "сімвалы",
            many: "сімвалаў"
          },
          verb: "мець"
        },
        array: {
          unit: {
            one: "элемент",
            few: "элементы",
            many: "элементаў"
          },
          verb: "мець"
        },
        set: {
          unit: {
            one: "элемент",
            few: "элементы",
            many: "элементаў"
          },
          verb: "мець"
        },
        file: {
          unit: {
            one: "байт",
            few: "байты",
            many: "байтаў"
          },
          verb: "мець"
        }
      };
      function c(h) {
        return l[h] ?? null;
      }
      const f = {
        regex: "увод",
        email: "email адрас",
        url: "URL",
        emoji: "эмодзі",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO дата і час",
        date: "ISO дата",
        time: "ISO час",
        duration: "ISO працягласць",
        ipv4: "IPv4 адрас",
        ipv6: "IPv6 адрас",
        cidrv4: "IPv4 дыяпазон",
        cidrv6: "IPv6 дыяпазон",
        base64: "радок у фармаце base64",
        base64url: "радок у фармаце base64url",
        json_string: "JSON радок",
        e164: "нумар E.164",
        jwt: "JWT",
        template_literal: "увод"
      }, s = {
        nan: "NaN",
        number: "лік",
        array: "масіў"
      };
      return (h) => {
        switch (h.code) {
          case "invalid_type": {
            const p = s[h.expected] ?? h.expected, m = a.parsedType(h.input), y = s[m] ?? m;
            return /^[A-Z]/.test(h.expected) ? `Няправільны ўвод: чакаўся instanceof ${h.expected}, атрымана ${y}` : `Няправільны ўвод: чакаўся ${p}, атрымана ${y}`;
          }
          case "invalid_value":
            return h.values.length === 1 ? `Няправільны ўвод: чакалася ${a.stringifyPrimitive(h.values[0])}` : `Няправільны варыянт: чакаўся адзін з ${a.joinValues(h.values, "|")}`;
          case "too_big": {
            const p = h.inclusive ? "<=" : "<", m = c(h.origin);
            if (m) {
              const y = Number(h.maximum), w = o(y, m.unit.one, m.unit.few, m.unit.many);
              return `Занадта вялікі: чакалася, што ${h.origin ?? "значэнне"} павінна ${m.verb} ${p}${h.maximum.toString()} ${w}`;
            }
            return `Занадта вялікі: чакалася, што ${h.origin ?? "значэнне"} павінна быць ${p}${h.maximum.toString()}`;
          }
          case "too_small": {
            const p = h.inclusive ? ">=" : ">", m = c(h.origin);
            if (m) {
              const y = Number(h.minimum), w = o(y, m.unit.one, m.unit.few, m.unit.many);
              return `Занадта малы: чакалася, што ${h.origin} павінна ${m.verb} ${p}${h.minimum.toString()} ${w}`;
            }
            return `Занадта малы: чакалася, што ${h.origin} павінна быць ${p}${h.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = h;
            return p.format === "starts_with" ? `Няправільны радок: павінен пачынацца з "${p.prefix}"` : p.format === "ends_with" ? `Няправільны радок: павінен заканчвацца на "${p.suffix}"` : p.format === "includes" ? `Няправільны радок: павінен змяшчаць "${p.includes}"` : p.format === "regex" ? `Няправільны радок: павінен адпавядаць шаблону ${p.pattern}` : `Няправільны ${f[p.format] ?? h.format}`;
          }
          case "not_multiple_of":
            return `Няправільны лік: павінен быць кратным ${h.divisor}`;
          case "unrecognized_keys":
            return `Нераспазнаны ${h.keys.length > 1 ? "ключы" : "ключ"}: ${a.joinValues(h.keys, ", ")}`;
          case "invalid_key":
            return `Няправільны ключ у ${h.origin}`;
          case "invalid_union":
            return "Няправільны ўвод";
          case "invalid_element":
            return `Няправільнае значэнне ў ${h.origin}`;
          default:
            return "Няправільны ўвод";
        }
      };
    };
    function u() {
      return {
        localeError: d()
      };
    }
    e.exports = t.default;
  })(Aa, Aa.exports)), Aa.exports;
}
var ja = { exports: {} }, _i = ja.exports, _g;
function uE() {
  return _g || (_g = 1, (function(e, t) {
    var n = _i && _i.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = _i && _i.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = _i && _i.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "символа", verb: "да съдържа" },
        file: { unit: "байта", verb: "да съдържа" },
        array: { unit: "елемента", verb: "да съдържа" },
        set: { unit: "елемента", verb: "да съдържа" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "вход",
        email: "имейл адрес",
        url: "URL",
        emoji: "емоджи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO време",
        date: "ISO дата",
        time: "ISO време",
        duration: "ISO продължителност",
        ipv4: "IPv4 адрес",
        ipv6: "IPv6 адрес",
        cidrv4: "IPv4 диапазон",
        cidrv6: "IPv6 диапазон",
        base64: "base64-кодиран низ",
        base64url: "base64url-кодиран низ",
        json_string: "JSON низ",
        e164: "E.164 номер",
        jwt: "JWT",
        template_literal: "вход"
      }, f = {
        nan: "NaN",
        number: "число",
        array: "масив"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Невалиден вход: очакван instanceof ${s.expected}, получен ${m}` : `Невалиден вход: очакван ${h}, получен ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Невалиден вход: очакван ${a.stringifyPrimitive(s.values[0])}` : `Невалидна опция: очаквано едно от ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Твърде голямо: очаква се ${s.origin ?? "стойност"} да съдържа ${h}${s.maximum.toString()} ${p.unit ?? "елемента"}` : `Твърде голямо: очаква се ${s.origin ?? "стойност"} да бъде ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Твърде малко: очаква се ${s.origin} да съдържа ${h}${s.minimum.toString()} ${p.unit}` : `Твърде малко: очаква се ${s.origin} да бъде ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            if (h.format === "starts_with")
              return `Невалиден низ: трябва да започва с "${h.prefix}"`;
            if (h.format === "ends_with")
              return `Невалиден низ: трябва да завършва с "${h.suffix}"`;
            if (h.format === "includes")
              return `Невалиден низ: трябва да включва "${h.includes}"`;
            if (h.format === "regex")
              return `Невалиден низ: трябва да съвпада с ${h.pattern}`;
            let p = "Невалиден";
            return h.format === "emoji" && (p = "Невалидно"), h.format === "datetime" && (p = "Невалидно"), h.format === "date" && (p = "Невалидна"), h.format === "time" && (p = "Невалидно"), h.format === "duration" && (p = "Невалидна"), `${p} ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Невалидно число: трябва да бъде кратно на ${s.divisor}`;
          case "unrecognized_keys":
            return `Неразпознат${s.keys.length > 1 ? "и" : ""} ключ${s.keys.length > 1 ? "ове" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Невалиден ключ в ${s.origin}`;
          case "invalid_union":
            return "Невалиден вход";
          case "invalid_element":
            return `Невалидна стойност в ${s.origin}`;
          default:
            return "Невалиден вход";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ja, ja.exports)), ja.exports;
}
var Ma = { exports: {} }, wi = Ma.exports, wg;
function cE() {
  return wg || (wg = 1, (function(e, t) {
    var n = wi && wi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = wi && wi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = wi && wi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "caràcters", verb: "contenir" },
        file: { unit: "bytes", verb: "contenir" },
        array: { unit: "elements", verb: "contenir" },
        set: { unit: "elements", verb: "contenir" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "entrada",
        email: "adreça electrònica",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "durada ISO",
        ipv4: "adreça IPv4",
        ipv6: "adreça IPv6",
        cidrv4: "rang IPv4",
        cidrv6: "rang IPv6",
        base64: "cadena codificada en base64",
        base64url: "cadena codificada en base64url",
        json_string: "cadena JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Tipus invàlid: s'esperava instanceof ${s.expected}, s'ha rebut ${m}` : `Tipus invàlid: s'esperava ${h}, s'ha rebut ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Valor invàlid: s'esperava ${a.stringifyPrimitive(s.values[0])}` : `Opció invàlida: s'esperava una de ${a.joinValues(s.values, " o ")}`;
          case "too_big": {
            const h = s.inclusive ? "com a màxim" : "menys de", p = l(s.origin);
            return p ? `Massa gran: s'esperava que ${s.origin ?? "el valor"} contingués ${h} ${s.maximum.toString()} ${p.unit ?? "elements"}` : `Massa gran: s'esperava que ${s.origin ?? "el valor"} fos ${h} ${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? "com a mínim" : "més de", p = l(s.origin);
            return p ? `Massa petit: s'esperava que ${s.origin} contingués ${h} ${s.minimum.toString()} ${p.unit}` : `Massa petit: s'esperava que ${s.origin} fos ${h} ${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Format invàlid: ha de començar amb "${h.prefix}"` : h.format === "ends_with" ? `Format invàlid: ha d'acabar amb "${h.suffix}"` : h.format === "includes" ? `Format invàlid: ha d'incloure "${h.includes}"` : h.format === "regex" ? `Format invàlid: ha de coincidir amb el patró ${h.pattern}` : `Format invàlid per a ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Número invàlid: ha de ser múltiple de ${s.divisor}`;
          case "unrecognized_keys":
            return `Clau${s.keys.length > 1 ? "s" : ""} no reconeguda${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Clau invàlida a ${s.origin}`;
          case "invalid_union":
            return "Entrada invàlida";
          // Could also be "Tipus d'unió invàlid" but "Entrada invàlida" is more general
          case "invalid_element":
            return `Element invàlid a ${s.origin}`;
          default:
            return "Entrada invàlida";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ma, Ma.exports)), Ma.exports;
}
var $a = { exports: {} }, ki = $a.exports, kg;
function dE() {
  return kg || (kg = 1, (function(e, t) {
    var n = ki && ki.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = ki && ki.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = ki && ki.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "znaků", verb: "mít" },
        file: { unit: "bajtů", verb: "mít" },
        array: { unit: "prvků", verb: "mít" },
        set: { unit: "prvků", verb: "mít" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "regulární výraz",
        email: "e-mailová adresa",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "datum a čas ve formátu ISO",
        date: "datum ve formátu ISO",
        time: "čas ve formátu ISO",
        duration: "doba trvání ISO",
        ipv4: "IPv4 adresa",
        ipv6: "IPv6 adresa",
        cidrv4: "rozsah IPv4",
        cidrv6: "rozsah IPv6",
        base64: "řetězec zakódovaný ve formátu base64",
        base64url: "řetězec zakódovaný ve formátu base64url",
        json_string: "řetězec ve formátu JSON",
        e164: "číslo E.164",
        jwt: "JWT",
        template_literal: "vstup"
      }, f = {
        nan: "NaN",
        number: "číslo",
        string: "řetězec",
        function: "funkce",
        array: "pole"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Neplatný vstup: očekáváno instanceof ${s.expected}, obdrženo ${m}` : `Neplatný vstup: očekáváno ${h}, obdrženo ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Neplatný vstup: očekáváno ${a.stringifyPrimitive(s.values[0])}` : `Neplatná možnost: očekávána jedna z hodnot ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Hodnota je příliš velká: ${s.origin ?? "hodnota"} musí mít ${h}${s.maximum.toString()} ${p.unit ?? "prvků"}` : `Hodnota je příliš velká: ${s.origin ?? "hodnota"} musí být ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Hodnota je příliš malá: ${s.origin ?? "hodnota"} musí mít ${h}${s.minimum.toString()} ${p.unit ?? "prvků"}` : `Hodnota je příliš malá: ${s.origin ?? "hodnota"} musí být ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Neplatný řetězec: musí začínat na "${h.prefix}"` : h.format === "ends_with" ? `Neplatný řetězec: musí končit na "${h.suffix}"` : h.format === "includes" ? `Neplatný řetězec: musí obsahovat "${h.includes}"` : h.format === "regex" ? `Neplatný řetězec: musí odpovídat vzoru ${h.pattern}` : `Neplatný formát ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Neplatné číslo: musí být násobkem ${s.divisor}`;
          case "unrecognized_keys":
            return `Neznámé klíče: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Neplatný klíč v ${s.origin}`;
          case "invalid_union":
            return "Neplatný vstup";
          case "invalid_element":
            return `Neplatná hodnota v ${s.origin}`;
          default:
            return "Neplatný vstup";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })($a, $a.exports)), $a.exports;
}
var Ra = { exports: {} }, Si = Ra.exports, Sg;
function fE() {
  return Sg || (Sg = 1, (function(e, t) {
    var n = Si && Si.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Si && Si.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Si && Si.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "tegn", verb: "havde" },
        file: { unit: "bytes", verb: "havde" },
        array: { unit: "elementer", verb: "indeholdt" },
        set: { unit: "elementer", verb: "indeholdt" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "input",
        email: "e-mailadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslæt",
        date: "ISO-dato",
        time: "ISO-klokkeslæt",
        duration: "ISO-varighed",
        ipv4: "IPv4-område",
        ipv6: "IPv6-område",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodet streng",
        base64url: "base64url-kodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        nan: "NaN",
        string: "streng",
        number: "tal",
        boolean: "boolean",
        array: "liste",
        object: "objekt",
        set: "sæt",
        file: "fil"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Ugyldigt input: forventede instanceof ${s.expected}, fik ${m}` : `Ugyldigt input: forventede ${h}, fik ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Ugyldig værdi: forventede ${a.stringifyPrimitive(s.values[0])}` : `Ugyldigt valg: forventede en af følgende ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin), m = f[s.origin] ?? s.origin;
            return p ? `For stor: forventede ${m ?? "value"} ${p.verb} ${h} ${s.maximum.toString()} ${p.unit ?? "elementer"}` : `For stor: forventede ${m ?? "value"} havde ${h} ${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin), m = f[s.origin] ?? s.origin;
            return p ? `For lille: forventede ${m} ${p.verb} ${h} ${s.minimum.toString()} ${p.unit}` : `For lille: forventede ${m} havde ${h} ${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Ugyldig streng: skal starte med "${h.prefix}"` : h.format === "ends_with" ? `Ugyldig streng: skal ende med "${h.suffix}"` : h.format === "includes" ? `Ugyldig streng: skal indeholde "${h.includes}"` : h.format === "regex" ? `Ugyldig streng: skal matche mønsteret ${h.pattern}` : `Ugyldig ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Ugyldigt tal: skal være deleligt med ${s.divisor}`;
          case "unrecognized_keys":
            return `${s.keys.length > 1 ? "Ukendte nøgler" : "Ukendt nøgle"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Ugyldig nøgle i ${s.origin}`;
          case "invalid_union":
            return "Ugyldigt input: matcher ingen af de tilladte typer";
          case "invalid_element":
            return `Ugyldig værdi i ${s.origin}`;
          default:
            return "Ugyldigt input";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ra, Ra.exports)), Ra.exports;
}
var Za = { exports: {} }, xi = Za.exports, xg;
function hE() {
  return xg || (xg = 1, (function(e, t) {
    var n = xi && xi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = xi && xi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = xi && xi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "Zeichen", verb: "zu haben" },
        file: { unit: "Bytes", verb: "zu haben" },
        array: { unit: "Elemente", verb: "zu haben" },
        set: { unit: "Elemente", verb: "zu haben" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "Eingabe",
        email: "E-Mail-Adresse",
        url: "URL",
        emoji: "Emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-Datum und -Uhrzeit",
        date: "ISO-Datum",
        time: "ISO-Uhrzeit",
        duration: "ISO-Dauer",
        ipv4: "IPv4-Adresse",
        ipv6: "IPv6-Adresse",
        cidrv4: "IPv4-Bereich",
        cidrv6: "IPv6-Bereich",
        base64: "Base64-codierter String",
        base64url: "Base64-URL-codierter String",
        json_string: "JSON-String",
        e164: "E.164-Nummer",
        jwt: "JWT",
        template_literal: "Eingabe"
      }, f = {
        nan: "NaN",
        number: "Zahl",
        array: "Array"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Ungültige Eingabe: erwartet instanceof ${s.expected}, erhalten ${m}` : `Ungültige Eingabe: erwartet ${h}, erhalten ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Ungültige Eingabe: erwartet ${a.stringifyPrimitive(s.values[0])}` : `Ungültige Option: erwartet eine von ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Zu groß: erwartet, dass ${s.origin ?? "Wert"} ${h}${s.maximum.toString()} ${p.unit ?? "Elemente"} hat` : `Zu groß: erwartet, dass ${s.origin ?? "Wert"} ${h}${s.maximum.toString()} ist`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Zu klein: erwartet, dass ${s.origin} ${h}${s.minimum.toString()} ${p.unit} hat` : `Zu klein: erwartet, dass ${s.origin} ${h}${s.minimum.toString()} ist`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Ungültiger String: muss mit "${h.prefix}" beginnen` : h.format === "ends_with" ? `Ungültiger String: muss mit "${h.suffix}" enden` : h.format === "includes" ? `Ungültiger String: muss "${h.includes}" enthalten` : h.format === "regex" ? `Ungültiger String: muss dem Muster ${h.pattern} entsprechen` : `Ungültig: ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Ungültige Zahl: muss ein Vielfaches von ${s.divisor} sein`;
          case "unrecognized_keys":
            return `${s.keys.length > 1 ? "Unbekannte Schlüssel" : "Unbekannter Schlüssel"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Ungültiger Schlüssel in ${s.origin}`;
          case "invalid_union":
            return "Ungültige Eingabe";
          case "invalid_element":
            return `Ungültiger Wert in ${s.origin}`;
          default:
            return "Ungültige Eingabe";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Za, Za.exports)), Za.exports;
}
var La = { exports: {} }, Ii = La.exports, Ig;
function tk() {
  return Ig || (Ig = 1, (function(e, t) {
    var n = Ii && Ii.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ii && Ii.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ii && Ii.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "characters", verb: "to have" },
        file: { unit: "bytes", verb: "to have" },
        array: { unit: "items", verb: "to have" },
        set: { unit: "items", verb: "to have" },
        map: { unit: "entries", verb: "to have" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        // Compatibility: "nan" -> "NaN" for display
        nan: "NaN"
        // All other type names omitted - they fall back to raw values via ?? operator
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return `Invalid input: expected ${h}, received ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Invalid input: expected ${a.stringifyPrimitive(s.values[0])}` : `Invalid option: expected one of ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Too big: expected ${s.origin ?? "value"} to have ${h}${s.maximum.toString()} ${p.unit ?? "elements"}` : `Too big: expected ${s.origin ?? "value"} to be ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Too small: expected ${s.origin} to have ${h}${s.minimum.toString()} ${p.unit}` : `Too small: expected ${s.origin} to be ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Invalid string: must start with "${h.prefix}"` : h.format === "ends_with" ? `Invalid string: must end with "${h.suffix}"` : h.format === "includes" ? `Invalid string: must include "${h.includes}"` : h.format === "regex" ? `Invalid string: must match pattern ${h.pattern}` : `Invalid ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Invalid number: must be a multiple of ${s.divisor}`;
          case "unrecognized_keys":
            return `Unrecognized key${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Invalid key in ${s.origin}`;
          case "invalid_union":
            return "Invalid input";
          case "invalid_element":
            return `Invalid value in ${s.origin}`;
          default:
            return "Invalid input";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(La, La.exports)), La.exports;
}
var Fa = { exports: {} }, Pi = Fa.exports, Pg;
function pE() {
  return Pg || (Pg = 1, (function(e, t) {
    var n = Pi && Pi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Pi && Pi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Pi && Pi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "karaktrojn", verb: "havi" },
        file: { unit: "bajtojn", verb: "havi" },
        array: { unit: "elementojn", verb: "havi" },
        set: { unit: "elementojn", verb: "havi" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "enigo",
        email: "retadreso",
        url: "URL",
        emoji: "emoĝio",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datotempo",
        date: "ISO-dato",
        time: "ISO-tempo",
        duration: "ISO-daŭro",
        ipv4: "IPv4-adreso",
        ipv6: "IPv6-adreso",
        cidrv4: "IPv4-rango",
        cidrv6: "IPv6-rango",
        base64: "64-ume kodita karaktraro",
        base64url: "URL-64-ume kodita karaktraro",
        json_string: "JSON-karaktraro",
        e164: "E.164-nombro",
        jwt: "JWT",
        template_literal: "enigo"
      }, f = {
        nan: "NaN",
        number: "nombro",
        array: "tabelo",
        null: "senvalora"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Nevalida enigo: atendiĝis instanceof ${s.expected}, riceviĝis ${m}` : `Nevalida enigo: atendiĝis ${h}, riceviĝis ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Nevalida enigo: atendiĝis ${a.stringifyPrimitive(s.values[0])}` : `Nevalida opcio: atendiĝis unu el ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Tro granda: atendiĝis ke ${s.origin ?? "valoro"} havu ${h}${s.maximum.toString()} ${p.unit ?? "elementojn"}` : `Tro granda: atendiĝis ke ${s.origin ?? "valoro"} havu ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Tro malgranda: atendiĝis ke ${s.origin} havu ${h}${s.minimum.toString()} ${p.unit}` : `Tro malgranda: atendiĝis ke ${s.origin} estu ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Nevalida karaktraro: devas komenciĝi per "${h.prefix}"` : h.format === "ends_with" ? `Nevalida karaktraro: devas finiĝi per "${h.suffix}"` : h.format === "includes" ? `Nevalida karaktraro: devas inkluzivi "${h.includes}"` : h.format === "regex" ? `Nevalida karaktraro: devas kongrui kun la modelo ${h.pattern}` : `Nevalida ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Nevalida nombro: devas esti oblo de ${s.divisor}`;
          case "unrecognized_keys":
            return `Nekonata${s.keys.length > 1 ? "j" : ""} ŝlosilo${s.keys.length > 1 ? "j" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Nevalida ŝlosilo en ${s.origin}`;
          case "invalid_union":
            return "Nevalida enigo";
          case "invalid_element":
            return `Nevalida valoro en ${s.origin}`;
          default:
            return "Nevalida enigo";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Fa, Fa.exports)), Fa.exports;
}
var Ua = { exports: {} }, Oi = Ua.exports, Og;
function mE() {
  return Og || (Og = 1, (function(e, t) {
    var n = Oi && Oi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Oi && Oi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Oi && Oi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "caracteres", verb: "tener" },
        file: { unit: "bytes", verb: "tener" },
        array: { unit: "elementos", verb: "tener" },
        set: { unit: "elementos", verb: "tener" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "entrada",
        email: "dirección de correo electrónico",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "fecha y hora ISO",
        date: "fecha ISO",
        time: "hora ISO",
        duration: "duración ISO",
        ipv4: "dirección IPv4",
        ipv6: "dirección IPv6",
        cidrv4: "rango IPv4",
        cidrv6: "rango IPv6",
        base64: "cadena codificada en base64",
        base64url: "URL codificada en base64",
        json_string: "cadena JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      }, f = {
        nan: "NaN",
        string: "texto",
        number: "número",
        boolean: "booleano",
        array: "arreglo",
        object: "objeto",
        set: "conjunto",
        file: "archivo",
        date: "fecha",
        bigint: "número grande",
        symbol: "símbolo",
        undefined: "indefinido",
        null: "nulo",
        function: "función",
        map: "mapa",
        record: "registro",
        tuple: "tupla",
        enum: "enumeración",
        union: "unión",
        literal: "literal",
        promise: "promesa",
        void: "vacío",
        never: "nunca",
        unknown: "desconocido",
        any: "cualquiera"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Entrada inválida: se esperaba instanceof ${s.expected}, recibido ${m}` : `Entrada inválida: se esperaba ${h}, recibido ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Entrada inválida: se esperaba ${a.stringifyPrimitive(s.values[0])}` : `Opción inválida: se esperaba una de ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin), m = f[s.origin] ?? s.origin;
            return p ? `Demasiado grande: se esperaba que ${m ?? "valor"} tuviera ${h}${s.maximum.toString()} ${p.unit ?? "elementos"}` : `Demasiado grande: se esperaba que ${m ?? "valor"} fuera ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin), m = f[s.origin] ?? s.origin;
            return p ? `Demasiado pequeño: se esperaba que ${m} tuviera ${h}${s.minimum.toString()} ${p.unit}` : `Demasiado pequeño: se esperaba que ${m} fuera ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Cadena inválida: debe comenzar con "${h.prefix}"` : h.format === "ends_with" ? `Cadena inválida: debe terminar en "${h.suffix}"` : h.format === "includes" ? `Cadena inválida: debe incluir "${h.includes}"` : h.format === "regex" ? `Cadena inválida: debe coincidir con el patrón ${h.pattern}` : `Inválido ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Número inválido: debe ser múltiplo de ${s.divisor}`;
          case "unrecognized_keys":
            return `Llave${s.keys.length > 1 ? "s" : ""} desconocida${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Llave inválida en ${f[s.origin] ?? s.origin}`;
          case "invalid_union":
            return "Entrada inválida";
          case "invalid_element":
            return `Valor inválido en ${f[s.origin] ?? s.origin}`;
          default:
            return "Entrada inválida";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ua, Ua.exports)), Ua.exports;
}
var Ba = { exports: {} }, zi = Ba.exports, zg;
function gE() {
  return zg || (zg = 1, (function(e, t) {
    var n = zi && zi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = zi && zi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = zi && zi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "کاراکتر", verb: "داشته باشد" },
        file: { unit: "بایت", verb: "داشته باشد" },
        array: { unit: "آیتم", verb: "داشته باشد" },
        set: { unit: "آیتم", verb: "داشته باشد" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "ورودی",
        email: "آدرس ایمیل",
        url: "URL",
        emoji: "ایموجی",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "تاریخ و زمان ایزو",
        date: "تاریخ ایزو",
        time: "زمان ایزو",
        duration: "مدت زمان ایزو",
        ipv4: "IPv4 آدرس",
        ipv6: "IPv6 آدرس",
        cidrv4: "IPv4 دامنه",
        cidrv6: "IPv6 دامنه",
        base64: "base64-encoded رشته",
        base64url: "base64url-encoded رشته",
        json_string: "JSON رشته",
        e164: "E.164 عدد",
        jwt: "JWT",
        template_literal: "ورودی"
      }, f = {
        nan: "NaN",
        number: "عدد",
        array: "آرایه"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `ورودی نامعتبر: می‌بایست instanceof ${s.expected} می‌بود، ${m} دریافت شد` : `ورودی نامعتبر: می‌بایست ${h} می‌بود، ${m} دریافت شد`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `ورودی نامعتبر: می‌بایست ${a.stringifyPrimitive(s.values[0])} می‌بود` : `گزینه نامعتبر: می‌بایست یکی از ${a.joinValues(s.values, "|")} می‌بود`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `خیلی بزرگ: ${s.origin ?? "مقدار"} باید ${h}${s.maximum.toString()} ${p.unit ?? "عنصر"} باشد` : `خیلی بزرگ: ${s.origin ?? "مقدار"} باید ${h}${s.maximum.toString()} باشد`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `خیلی کوچک: ${s.origin} باید ${h}${s.minimum.toString()} ${p.unit} باشد` : `خیلی کوچک: ${s.origin} باید ${h}${s.minimum.toString()} باشد`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `رشته نامعتبر: باید با "${h.prefix}" شروع شود` : h.format === "ends_with" ? `رشته نامعتبر: باید با "${h.suffix}" تمام شود` : h.format === "includes" ? `رشته نامعتبر: باید شامل "${h.includes}" باشد` : h.format === "regex" ? `رشته نامعتبر: باید با الگوی ${h.pattern} مطابقت داشته باشد` : `${c[h.format] ?? s.format} نامعتبر`;
          }
          case "not_multiple_of":
            return `عدد نامعتبر: باید مضرب ${s.divisor} باشد`;
          case "unrecognized_keys":
            return `کلید${s.keys.length > 1 ? "های" : ""} ناشناس: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `کلید ناشناس در ${s.origin}`;
          case "invalid_union":
            return "ورودی نامعتبر";
          case "invalid_element":
            return `مقدار نامعتبر در ${s.origin}`;
          default:
            return "ورودی نامعتبر";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ba, Ba.exports)), Ba.exports;
}
var Va = { exports: {} }, Ei = Va.exports, Eg;
function yE() {
  return Eg || (Eg = 1, (function(e, t) {
    var n = Ei && Ei.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ei && Ei.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ei && Ei.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "merkkiä", subject: "merkkijonon" },
        file: { unit: "tavua", subject: "tiedoston" },
        array: { unit: "alkiota", subject: "listan" },
        set: { unit: "alkiota", subject: "joukon" },
        number: { unit: "", subject: "luvun" },
        bigint: { unit: "", subject: "suuren kokonaisluvun" },
        int: { unit: "", subject: "kokonaisluvun" },
        date: { unit: "", subject: "päivämäärän" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "säännöllinen lauseke",
        email: "sähköpostiosoite",
        url: "URL-osoite",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-aikaleima",
        date: "ISO-päivämäärä",
        time: "ISO-aika",
        duration: "ISO-kesto",
        ipv4: "IPv4-osoite",
        ipv6: "IPv6-osoite",
        cidrv4: "IPv4-alue",
        cidrv6: "IPv6-alue",
        base64: "base64-koodattu merkkijono",
        base64url: "base64url-koodattu merkkijono",
        json_string: "JSON-merkkijono",
        e164: "E.164-luku",
        jwt: "JWT",
        template_literal: "templaattimerkkijono"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Virheellinen tyyppi: odotettiin instanceof ${s.expected}, oli ${m}` : `Virheellinen tyyppi: odotettiin ${h}, oli ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Virheellinen syöte: täytyy olla ${a.stringifyPrimitive(s.values[0])}` : `Virheellinen valinta: täytyy olla yksi seuraavista: ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Liian suuri: ${p.subject} täytyy olla ${h}${s.maximum.toString()} ${p.unit}`.trim() : `Liian suuri: arvon täytyy olla ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Liian pieni: ${p.subject} täytyy olla ${h}${s.minimum.toString()} ${p.unit}`.trim() : `Liian pieni: arvon täytyy olla ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Virheellinen syöte: täytyy alkaa "${h.prefix}"` : h.format === "ends_with" ? `Virheellinen syöte: täytyy loppua "${h.suffix}"` : h.format === "includes" ? `Virheellinen syöte: täytyy sisältää "${h.includes}"` : h.format === "regex" ? `Virheellinen syöte: täytyy vastata säännöllistä lauseketta ${h.pattern}` : `Virheellinen ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Virheellinen luku: täytyy olla luvun ${s.divisor} monikerta`;
          case "unrecognized_keys":
            return `${s.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return "Virheellinen avain tietueessa";
          case "invalid_union":
            return "Virheellinen unioni";
          case "invalid_element":
            return "Virheellinen arvo joukossa";
          default:
            return "Virheellinen syöte";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Va, Va.exports)), Va.exports;
}
var qa = { exports: {} }, Ti = qa.exports, Tg;
function vE() {
  return Tg || (Tg = 1, (function(e, t) {
    var n = Ti && Ti.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ti && Ti.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ti && Ti.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "caractères", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "éléments", verb: "avoir" },
        set: { unit: "éléments", verb: "avoir" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "entrée",
        email: "adresse e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date et heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "durée ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "chaîne encodée en base64",
        base64url: "chaîne encodée en base64url",
        json_string: "chaîne JSON",
        e164: "numéro E.164",
        jwt: "JWT",
        template_literal: "entrée"
      }, f = {
        nan: "NaN",
        number: "nombre",
        array: "tableau"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Entrée invalide : instanceof ${s.expected} attendu, ${m} reçu` : `Entrée invalide : ${h} attendu, ${m} reçu`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Entrée invalide : ${a.stringifyPrimitive(s.values[0])} attendu` : `Option invalide : une valeur parmi ${a.joinValues(s.values, "|")} attendue`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Trop grand : ${s.origin ?? "valeur"} doit ${p.verb} ${h}${s.maximum.toString()} ${p.unit ?? "élément(s)"}` : `Trop grand : ${s.origin ?? "valeur"} doit être ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Trop petit : ${s.origin} doit ${p.verb} ${h}${s.minimum.toString()} ${p.unit}` : `Trop petit : ${s.origin} doit être ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Chaîne invalide : doit commencer par "${h.prefix}"` : h.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${h.suffix}"` : h.format === "includes" ? `Chaîne invalide : doit inclure "${h.includes}"` : h.format === "regex" ? `Chaîne invalide : doit correspondre au modèle ${h.pattern}` : `${c[h.format] ?? s.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit être un multiple de ${s.divisor}`;
          case "unrecognized_keys":
            return `Clé${s.keys.length > 1 ? "s" : ""} non reconnue${s.keys.length > 1 ? "s" : ""} : ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Clé invalide dans ${s.origin}`;
          case "invalid_union":
            return "Entrée invalide";
          case "invalid_element":
            return `Valeur invalide dans ${s.origin}`;
          default:
            return "Entrée invalide";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(qa, qa.exports)), qa.exports;
}
var Ha = { exports: {} }, Ni = Ha.exports, Ng;
function bE() {
  return Ng || (Ng = 1, (function(e, t) {
    var n = Ni && Ni.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ni && Ni.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ni && Ni.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "caractères", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "éléments", verb: "avoir" },
        set: { unit: "éléments", verb: "avoir" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "entrée",
        email: "adresse courriel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date-heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "durée ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "chaîne encodée en base64",
        base64url: "chaîne encodée en base64url",
        json_string: "chaîne JSON",
        e164: "numéro E.164",
        jwt: "JWT",
        template_literal: "entrée"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Entrée invalide : attendu instanceof ${s.expected}, reçu ${m}` : `Entrée invalide : attendu ${h}, reçu ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Entrée invalide : attendu ${a.stringifyPrimitive(s.values[0])}` : `Option invalide : attendu l'une des valeurs suivantes ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "≤" : "<", p = l(s.origin);
            return p ? `Trop grand : attendu que ${s.origin ?? "la valeur"} ait ${h}${s.maximum.toString()} ${p.unit}` : `Trop grand : attendu que ${s.origin ?? "la valeur"} soit ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? "≥" : ">", p = l(s.origin);
            return p ? `Trop petit : attendu que ${s.origin} ait ${h}${s.minimum.toString()} ${p.unit}` : `Trop petit : attendu que ${s.origin} soit ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Chaîne invalide : doit commencer par "${h.prefix}"` : h.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${h.suffix}"` : h.format === "includes" ? `Chaîne invalide : doit inclure "${h.includes}"` : h.format === "regex" ? `Chaîne invalide : doit correspondre au motif ${h.pattern}` : `${c[h.format] ?? s.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit être un multiple de ${s.divisor}`;
          case "unrecognized_keys":
            return `Clé${s.keys.length > 1 ? "s" : ""} non reconnue${s.keys.length > 1 ? "s" : ""} : ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Clé invalide dans ${s.origin}`;
          case "invalid_union":
            return "Entrée invalide";
          case "invalid_element":
            return `Valeur invalide dans ${s.origin}`;
          default:
            return "Entrée invalide";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ha, Ha.exports)), Ha.exports;
}
var Wa = { exports: {} }, Ci = Wa.exports, Cg;
function _E() {
  return Cg || (Cg = 1, (function(e, t) {
    var n = Ci && Ci.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ci && Ci.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ci && Ci.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { label: "מחרוזת", gender: "f" },
        number: { label: "מספר", gender: "m" },
        boolean: { label: "ערך בוליאני", gender: "m" },
        bigint: { label: "BigInt", gender: "m" },
        date: { label: "תאריך", gender: "m" },
        array: { label: "מערך", gender: "m" },
        object: { label: "אובייקט", gender: "m" },
        null: { label: "ערך ריק (null)", gender: "m" },
        undefined: { label: "ערך לא מוגדר (undefined)", gender: "m" },
        symbol: { label: "סימבול (Symbol)", gender: "m" },
        function: { label: "פונקציה", gender: "f" },
        map: { label: "מפה (Map)", gender: "f" },
        set: { label: "קבוצה (Set)", gender: "f" },
        file: { label: "קובץ", gender: "m" },
        promise: { label: "Promise", gender: "m" },
        NaN: { label: "NaN", gender: "m" },
        unknown: { label: "ערך לא ידוע", gender: "m" },
        value: { label: "ערך", gender: "m" }
      }, l = {
        string: { unit: "תווים", shortLabel: "קצר", longLabel: "ארוך" },
        file: { unit: "בייטים", shortLabel: "קטן", longLabel: "גדול" },
        array: { unit: "פריטים", shortLabel: "קטן", longLabel: "גדול" },
        set: { unit: "פריטים", shortLabel: "קטן", longLabel: "גדול" },
        number: { unit: "", shortLabel: "קטן", longLabel: "גדול" }
        // no unit
      }, c = (w) => w ? u[w] : void 0, f = (w) => {
        const b = c(w);
        return b ? b.label : w ?? u.unknown.label;
      }, s = (w) => `ה${f(w)}`, h = (w) => (c(w)?.gender ?? "m") === "f" ? "צריכה להיות" : "צריך להיות", p = (w) => w ? l[w] ?? null : null, m = {
        regex: { label: "קלט", gender: "m" },
        email: { label: "כתובת אימייל", gender: "f" },
        url: { label: "כתובת רשת", gender: "f" },
        emoji: { label: "אימוג'י", gender: "m" },
        uuid: { label: "UUID", gender: "m" },
        nanoid: { label: "nanoid", gender: "m" },
        guid: { label: "GUID", gender: "m" },
        cuid: { label: "cuid", gender: "m" },
        cuid2: { label: "cuid2", gender: "m" },
        ulid: { label: "ULID", gender: "m" },
        xid: { label: "XID", gender: "m" },
        ksuid: { label: "KSUID", gender: "m" },
        datetime: { label: "תאריך וזמן ISO", gender: "m" },
        date: { label: "תאריך ISO", gender: "m" },
        time: { label: "זמן ISO", gender: "m" },
        duration: { label: "משך זמן ISO", gender: "m" },
        ipv4: { label: "כתובת IPv4", gender: "f" },
        ipv6: { label: "כתובת IPv6", gender: "f" },
        cidrv4: { label: "טווח IPv4", gender: "m" },
        cidrv6: { label: "טווח IPv6", gender: "m" },
        base64: { label: "מחרוזת בבסיס 64", gender: "f" },
        base64url: { label: "מחרוזת בבסיס 64 לכתובות רשת", gender: "f" },
        json_string: { label: "מחרוזת JSON", gender: "f" },
        e164: { label: "מספר E.164", gender: "m" },
        jwt: { label: "JWT", gender: "m" },
        ends_with: { label: "קלט", gender: "m" },
        includes: { label: "קלט", gender: "m" },
        lowercase: { label: "קלט", gender: "m" },
        starts_with: { label: "קלט", gender: "m" },
        uppercase: { label: "קלט", gender: "m" }
      }, y = {
        nan: "NaN"
      };
      return (w) => {
        switch (w.code) {
          case "invalid_type": {
            const b = w.expected, _ = y[b ?? ""] ?? f(b), g = a.parsedType(w.input), O = y[g] ?? u[g]?.label ?? g;
            return /^[A-Z]/.test(w.expected) ? `קלט לא תקין: צריך להיות instanceof ${w.expected}, התקבל ${O}` : `קלט לא תקין: צריך להיות ${_}, התקבל ${O}`;
          }
          case "invalid_value": {
            if (w.values.length === 1)
              return `ערך לא תקין: הערך חייב להיות ${a.stringifyPrimitive(w.values[0])}`;
            const b = w.values.map((O) => a.stringifyPrimitive(O));
            if (w.values.length === 2)
              return `ערך לא תקין: האפשרויות המתאימות הן ${b[0]} או ${b[1]}`;
            const _ = b[b.length - 1];
            return `ערך לא תקין: האפשרויות המתאימות הן ${b.slice(0, -1).join(", ")} או ${_}`;
          }
          case "too_big": {
            const b = p(w.origin), _ = s(w.origin ?? "value");
            if (w.origin === "string")
              return `${b?.longLabel ?? "ארוך"} מדי: ${_} צריכה להכיל ${w.maximum.toString()} ${b?.unit ?? ""} ${w.inclusive ? "או פחות" : "לכל היותר"}`.trim();
            if (w.origin === "number") {
              const P = w.inclusive ? `קטן או שווה ל-${w.maximum}` : `קטן מ-${w.maximum}`;
              return `גדול מדי: ${_} צריך להיות ${P}`;
            }
            if (w.origin === "array" || w.origin === "set") {
              const P = w.origin === "set" ? "צריכה" : "צריך", E = w.inclusive ? `${w.maximum} ${b?.unit ?? ""} או פחות` : `פחות מ-${w.maximum} ${b?.unit ?? ""}`;
              return `גדול מדי: ${_} ${P} להכיל ${E}`.trim();
            }
            const g = w.inclusive ? "<=" : "<", O = h(w.origin ?? "value");
            return b?.unit ? `${b.longLabel} מדי: ${_} ${O} ${g}${w.maximum.toString()} ${b.unit}` : `${b?.longLabel ?? "גדול"} מדי: ${_} ${O} ${g}${w.maximum.toString()}`;
          }
          case "too_small": {
            const b = p(w.origin), _ = s(w.origin ?? "value");
            if (w.origin === "string")
              return `${b?.shortLabel ?? "קצר"} מדי: ${_} צריכה להכיל ${w.minimum.toString()} ${b?.unit ?? ""} ${w.inclusive ? "או יותר" : "לפחות"}`.trim();
            if (w.origin === "number") {
              const P = w.inclusive ? `גדול או שווה ל-${w.minimum}` : `גדול מ-${w.minimum}`;
              return `קטן מדי: ${_} צריך להיות ${P}`;
            }
            if (w.origin === "array" || w.origin === "set") {
              const P = w.origin === "set" ? "צריכה" : "צריך";
              if (w.minimum === 1 && w.inclusive) {
                const T = (w.origin === "set", "לפחות פריט אחד");
                return `קטן מדי: ${_} ${P} להכיל ${T}`;
              }
              const E = w.inclusive ? `${w.minimum} ${b?.unit ?? ""} או יותר` : `יותר מ-${w.minimum} ${b?.unit ?? ""}`;
              return `קטן מדי: ${_} ${P} להכיל ${E}`.trim();
            }
            const g = w.inclusive ? ">=" : ">", O = h(w.origin ?? "value");
            return b?.unit ? `${b.shortLabel} מדי: ${_} ${O} ${g}${w.minimum.toString()} ${b.unit}` : `${b?.shortLabel ?? "קטן"} מדי: ${_} ${O} ${g}${w.minimum.toString()}`;
          }
          case "invalid_format": {
            const b = w;
            if (b.format === "starts_with")
              return `המחרוזת חייבת להתחיל ב "${b.prefix}"`;
            if (b.format === "ends_with")
              return `המחרוזת חייבת להסתיים ב "${b.suffix}"`;
            if (b.format === "includes")
              return `המחרוזת חייבת לכלול "${b.includes}"`;
            if (b.format === "regex")
              return `המחרוזת חייבת להתאים לתבנית ${b.pattern}`;
            const _ = m[b.format], g = _?.label ?? b.format, P = (_?.gender ?? "m") === "f" ? "תקינה" : "תקין";
            return `${g} לא ${P}`;
          }
          case "not_multiple_of":
            return `מספר לא תקין: חייב להיות מכפלה של ${w.divisor}`;
          case "unrecognized_keys":
            return `מפתח${w.keys.length > 1 ? "ות" : ""} לא מזוה${w.keys.length > 1 ? "ים" : "ה"}: ${a.joinValues(w.keys, ", ")}`;
          case "invalid_key":
            return "שדה לא תקין באובייקט";
          case "invalid_union":
            return "קלט לא תקין";
          case "invalid_element":
            return `ערך לא תקין ב${s(w.origin ?? "array")}`;
          default:
            return "קלט לא תקין";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Wa, Wa.exports)), Wa.exports;
}
var Ga = { exports: {} }, Di = Ga.exports, Dg;
function wE() {
  return Dg || (Dg = 1, (function(e, t) {
    var n = Di && Di.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Di && Di.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Di && Di.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "karakter", verb: "legyen" },
        file: { unit: "byte", verb: "legyen" },
        array: { unit: "elem", verb: "legyen" },
        set: { unit: "elem", verb: "legyen" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "bemenet",
        email: "email cím",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO időbélyeg",
        date: "ISO dátum",
        time: "ISO idő",
        duration: "ISO időintervallum",
        ipv4: "IPv4 cím",
        ipv6: "IPv6 cím",
        cidrv4: "IPv4 tartomány",
        cidrv6: "IPv6 tartomány",
        base64: "base64-kódolt string",
        base64url: "base64url-kódolt string",
        json_string: "JSON string",
        e164: "E.164 szám",
        jwt: "JWT",
        template_literal: "bemenet"
      }, f = {
        nan: "NaN",
        number: "szám",
        array: "tömb"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Érvénytelen bemenet: a várt érték instanceof ${s.expected}, a kapott érték ${m}` : `Érvénytelen bemenet: a várt érték ${h}, a kapott érték ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Érvénytelen bemenet: a várt érték ${a.stringifyPrimitive(s.values[0])}` : `Érvénytelen opció: valamelyik érték várt ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Túl nagy: ${s.origin ?? "érték"} mérete túl nagy ${h}${s.maximum.toString()} ${p.unit ?? "elem"}` : `Túl nagy: a bemeneti érték ${s.origin ?? "érték"} túl nagy: ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Túl kicsi: a bemeneti érték ${s.origin} mérete túl kicsi ${h}${s.minimum.toString()} ${p.unit}` : `Túl kicsi: a bemeneti érték ${s.origin} túl kicsi ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Érvénytelen string: "${h.prefix}" értékkel kell kezdődnie` : h.format === "ends_with" ? `Érvénytelen string: "${h.suffix}" értékkel kell végződnie` : h.format === "includes" ? `Érvénytelen string: "${h.includes}" értéket kell tartalmaznia` : h.format === "regex" ? `Érvénytelen string: ${h.pattern} mintának kell megfelelnie` : `Érvénytelen ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Érvénytelen szám: ${s.divisor} többszörösének kell lennie`;
          case "unrecognized_keys":
            return `Ismeretlen kulcs${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Érvénytelen kulcs ${s.origin}`;
          case "invalid_union":
            return "Érvénytelen bemenet";
          case "invalid_element":
            return `Érvénytelen érték: ${s.origin}`;
          default:
            return "Érvénytelen bemenet";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ga, Ga.exports)), Ga.exports;
}
var Ka = { exports: {} }, Ai = Ka.exports, Ag;
function kE() {
  return Ag || (Ag = 1, (function(e, t) {
    var n = Ai && Ai.__createBinding || (Object.create ? (function(c, f, s, h) {
      h === void 0 && (h = s);
      var p = Object.getOwnPropertyDescriptor(f, s);
      (!p || ("get" in p ? !f.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return f[s];
      } }), Object.defineProperty(c, h, p);
    }) : (function(c, f, s, h) {
      h === void 0 && (h = s), c[h] = f[s];
    })), r = Ai && Ai.__setModuleDefault || (Object.create ? (function(c, f) {
      Object.defineProperty(c, "default", { enumerable: !0, value: f });
    }) : function(c, f) {
      c.default = f;
    }), i = Ai && Ai.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var f = {};
      if (c != null) for (var s in c) s !== "default" && Object.prototype.hasOwnProperty.call(c, s) && n(f, c, s);
      return r(f, c), f;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const a = i(Pe());
    function o(c, f, s) {
      return Math.abs(c) === 1 ? f : s;
    }
    function d(c) {
      if (!c)
        return "";
      const f = ["ա", "ե", "ը", "ի", "ո", "ու", "օ"], s = c[c.length - 1];
      return c + (f.includes(s) ? "ն" : "ը");
    }
    const u = () => {
      const c = {
        string: {
          unit: {
            one: "նշան",
            many: "նշաններ"
          },
          verb: "ունենալ"
        },
        file: {
          unit: {
            one: "բայթ",
            many: "բայթեր"
          },
          verb: "ունենալ"
        },
        array: {
          unit: {
            one: "տարր",
            many: "տարրեր"
          },
          verb: "ունենալ"
        },
        set: {
          unit: {
            one: "տարր",
            many: "տարրեր"
          },
          verb: "ունենալ"
        }
      };
      function f(p) {
        return c[p] ?? null;
      }
      const s = {
        regex: "մուտք",
        email: "էլ. հասցե",
        url: "URL",
        emoji: "էմոջի",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO ամսաթիվ և ժամ",
        date: "ISO ամսաթիվ",
        time: "ISO ժամ",
        duration: "ISO տևողություն",
        ipv4: "IPv4 հասցե",
        ipv6: "IPv6 հասցե",
        cidrv4: "IPv4 միջակայք",
        cidrv6: "IPv6 միջակայք",
        base64: "base64 ձևաչափով տող",
        base64url: "base64url ձևաչափով տող",
        json_string: "JSON տող",
        e164: "E.164 համար",
        jwt: "JWT",
        template_literal: "մուտք"
      }, h = {
        nan: "NaN",
        number: "թիվ",
        array: "զանգված"
      };
      return (p) => {
        switch (p.code) {
          case "invalid_type": {
            const m = h[p.expected] ?? p.expected, y = a.parsedType(p.input), w = h[y] ?? y;
            return /^[A-Z]/.test(p.expected) ? `Սխալ մուտքագրում․ սպասվում էր instanceof ${p.expected}, ստացվել է ${w}` : `Սխալ մուտքագրում․ սպասվում էր ${m}, ստացվել է ${w}`;
          }
          case "invalid_value":
            return p.values.length === 1 ? `Սխալ մուտքագրում․ սպասվում էր ${a.stringifyPrimitive(p.values[1])}` : `Սխալ տարբերակ․ սպասվում էր հետևյալներից մեկը՝ ${a.joinValues(p.values, "|")}`;
          case "too_big": {
            const m = p.inclusive ? "<=" : "<", y = f(p.origin);
            if (y) {
              const w = Number(p.maximum), b = o(w, y.unit.one, y.unit.many);
              return `Չափազանց մեծ արժեք․ սպասվում է, որ ${d(p.origin ?? "արժեք")} կունենա ${m}${p.maximum.toString()} ${b}`;
            }
            return `Չափազանց մեծ արժեք․ սպասվում է, որ ${d(p.origin ?? "արժեք")} լինի ${m}${p.maximum.toString()}`;
          }
          case "too_small": {
            const m = p.inclusive ? ">=" : ">", y = f(p.origin);
            if (y) {
              const w = Number(p.minimum), b = o(w, y.unit.one, y.unit.many);
              return `Չափազանց փոքր արժեք․ սպասվում է, որ ${d(p.origin)} կունենա ${m}${p.minimum.toString()} ${b}`;
            }
            return `Չափազանց փոքր արժեք․ սպասվում է, որ ${d(p.origin)} լինի ${m}${p.minimum.toString()}`;
          }
          case "invalid_format": {
            const m = p;
            return m.format === "starts_with" ? `Սխալ տող․ պետք է սկսվի "${m.prefix}"-ով` : m.format === "ends_with" ? `Սխալ տող․ պետք է ավարտվի "${m.suffix}"-ով` : m.format === "includes" ? `Սխալ տող․ պետք է պարունակի "${m.includes}"` : m.format === "regex" ? `Սխալ տող․ պետք է համապատասխանի ${m.pattern} ձևաչափին` : `Սխալ ${s[m.format] ?? p.format}`;
          }
          case "not_multiple_of":
            return `Սխալ թիվ․ պետք է բազմապատիկ լինի ${p.divisor}-ի`;
          case "unrecognized_keys":
            return `Չճանաչված բանալի${p.keys.length > 1 ? "ներ" : ""}. ${a.joinValues(p.keys, ", ")}`;
          case "invalid_key":
            return `Սխալ բանալի ${d(p.origin)}-ում`;
          case "invalid_union":
            return "Սխալ մուտքագրում";
          case "invalid_element":
            return `Սխալ արժեք ${d(p.origin)}-ում`;
          default:
            return "Սխալ մուտքագրում";
        }
      };
    };
    function l() {
      return {
        localeError: u()
      };
    }
    e.exports = t.default;
  })(Ka, Ka.exports)), Ka.exports;
}
var Ja = { exports: {} }, ji = Ja.exports, jg;
function SE() {
  return jg || (jg = 1, (function(e, t) {
    var n = ji && ji.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = ji && ji.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = ji && ji.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "karakter", verb: "memiliki" },
        file: { unit: "byte", verb: "memiliki" },
        array: { unit: "item", verb: "memiliki" },
        set: { unit: "item", verb: "memiliki" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "input",
        email: "alamat email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tanggal dan waktu format ISO",
        date: "tanggal format ISO",
        time: "jam format ISO",
        duration: "durasi format ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "rentang alamat IPv4",
        cidrv6: "rentang alamat IPv6",
        base64: "string dengan enkode base64",
        base64url: "string dengan enkode base64url",
        json_string: "string JSON",
        e164: "angka E.164",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Input tidak valid: diharapkan instanceof ${s.expected}, diterima ${m}` : `Input tidak valid: diharapkan ${h}, diterima ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Input tidak valid: diharapkan ${a.stringifyPrimitive(s.values[0])}` : `Pilihan tidak valid: diharapkan salah satu dari ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Terlalu besar: diharapkan ${s.origin ?? "value"} memiliki ${h}${s.maximum.toString()} ${p.unit ?? "elemen"}` : `Terlalu besar: diharapkan ${s.origin ?? "value"} menjadi ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Terlalu kecil: diharapkan ${s.origin} memiliki ${h}${s.minimum.toString()} ${p.unit}` : `Terlalu kecil: diharapkan ${s.origin} menjadi ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `String tidak valid: harus dimulai dengan "${h.prefix}"` : h.format === "ends_with" ? `String tidak valid: harus berakhir dengan "${h.suffix}"` : h.format === "includes" ? `String tidak valid: harus menyertakan "${h.includes}"` : h.format === "regex" ? `String tidak valid: harus sesuai pola ${h.pattern}` : `${c[h.format] ?? s.format} tidak valid`;
          }
          case "not_multiple_of":
            return `Angka tidak valid: harus kelipatan dari ${s.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali ${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak valid di ${s.origin}`;
          case "invalid_union":
            return "Input tidak valid";
          case "invalid_element":
            return `Nilai tidak valid di ${s.origin}`;
          default:
            return "Input tidak valid";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ja, Ja.exports)), Ja.exports;
}
var Xa = { exports: {} }, Mi = Xa.exports, Mg;
function xE() {
  return Mg || (Mg = 1, (function(e, t) {
    var n = Mi && Mi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Mi && Mi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Mi && Mi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "stafi", verb: "að hafa" },
        file: { unit: "bæti", verb: "að hafa" },
        array: { unit: "hluti", verb: "að hafa" },
        set: { unit: "hluti", verb: "að hafa" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "gildi",
        email: "netfang",
        url: "vefslóð",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dagsetning og tími",
        date: "ISO dagsetning",
        time: "ISO tími",
        duration: "ISO tímalengd",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded strengur",
        base64url: "base64url-encoded strengur",
        json_string: "JSON strengur",
        e164: "E.164 tölugildi",
        jwt: "JWT",
        template_literal: "gildi"
      }, f = {
        nan: "NaN",
        number: "númer",
        array: "fylki"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Rangt gildi: Þú slóst inn ${m} þar sem á að vera instanceof ${s.expected}` : `Rangt gildi: Þú slóst inn ${m} þar sem á að vera ${h}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Rangt gildi: gert ráð fyrir ${a.stringifyPrimitive(s.values[0])}` : `Ógilt val: má vera eitt af eftirfarandi ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Of stórt: gert er ráð fyrir að ${s.origin ?? "gildi"} hafi ${h}${s.maximum.toString()} ${p.unit ?? "hluti"}` : `Of stórt: gert er ráð fyrir að ${s.origin ?? "gildi"} sé ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Of lítið: gert er ráð fyrir að ${s.origin} hafi ${h}${s.minimum.toString()} ${p.unit}` : `Of lítið: gert er ráð fyrir að ${s.origin} sé ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Ógildur strengur: verður að byrja á "${h.prefix}"` : h.format === "ends_with" ? `Ógildur strengur: verður að enda á "${h.suffix}"` : h.format === "includes" ? `Ógildur strengur: verður að innihalda "${h.includes}"` : h.format === "regex" ? `Ógildur strengur: verður að fylgja mynstri ${h.pattern}` : `Rangt ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Röng tala: verður að vera margfeldi af ${s.divisor}`;
          case "unrecognized_keys":
            return `Óþekkt ${s.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Rangur lykill í ${s.origin}`;
          case "invalid_union":
            return "Rangt gildi";
          case "invalid_element":
            return `Rangt gildi í ${s.origin}`;
          default:
            return "Rangt gildi";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Xa, Xa.exports)), Xa.exports;
}
var Ya = { exports: {} }, $i = Ya.exports, $g;
function IE() {
  return $g || ($g = 1, (function(e, t) {
    var n = $i && $i.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = $i && $i.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = $i && $i.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "caratteri", verb: "avere" },
        file: { unit: "byte", verb: "avere" },
        array: { unit: "elementi", verb: "avere" },
        set: { unit: "elementi", verb: "avere" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "input",
        email: "indirizzo email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e ora ISO",
        date: "data ISO",
        time: "ora ISO",
        duration: "durata ISO",
        ipv4: "indirizzo IPv4",
        ipv6: "indirizzo IPv6",
        cidrv4: "intervallo IPv4",
        cidrv6: "intervallo IPv6",
        base64: "stringa codificata in base64",
        base64url: "URL codificata in base64",
        json_string: "stringa JSON",
        e164: "numero E.164",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        nan: "NaN",
        number: "numero",
        array: "vettore"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Input non valido: atteso instanceof ${s.expected}, ricevuto ${m}` : `Input non valido: atteso ${h}, ricevuto ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Input non valido: atteso ${a.stringifyPrimitive(s.values[0])}` : `Opzione non valida: atteso uno tra ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Troppo grande: ${s.origin ?? "valore"} deve avere ${h}${s.maximum.toString()} ${p.unit ?? "elementi"}` : `Troppo grande: ${s.origin ?? "valore"} deve essere ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Troppo piccolo: ${s.origin} deve avere ${h}${s.minimum.toString()} ${p.unit}` : `Troppo piccolo: ${s.origin} deve essere ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Stringa non valida: deve iniziare con "${h.prefix}"` : h.format === "ends_with" ? `Stringa non valida: deve terminare con "${h.suffix}"` : h.format === "includes" ? `Stringa non valida: deve includere "${h.includes}"` : h.format === "regex" ? `Stringa non valida: deve corrispondere al pattern ${h.pattern}` : `Invalid ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Numero non valido: deve essere un multiplo di ${s.divisor}`;
          case "unrecognized_keys":
            return `Chiav${s.keys.length > 1 ? "i" : "e"} non riconosciut${s.keys.length > 1 ? "e" : "a"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Chiave non valida in ${s.origin}`;
          case "invalid_union":
            return "Input non valido";
          case "invalid_element":
            return `Valore non valido in ${s.origin}`;
          default:
            return "Input non valido";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ya, Ya.exports)), Ya.exports;
}
var Qa = { exports: {} }, Ri = Qa.exports, Rg;
function PE() {
  return Rg || (Rg = 1, (function(e, t) {
    var n = Ri && Ri.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ri && Ri.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ri && Ri.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "文字", verb: "である" },
        file: { unit: "バイト", verb: "である" },
        array: { unit: "要素", verb: "である" },
        set: { unit: "要素", verb: "である" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "入力値",
        email: "メールアドレス",
        url: "URL",
        emoji: "絵文字",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO日時",
        date: "ISO日付",
        time: "ISO時刻",
        duration: "ISO期間",
        ipv4: "IPv4アドレス",
        ipv6: "IPv6アドレス",
        cidrv4: "IPv4範囲",
        cidrv6: "IPv6範囲",
        base64: "base64エンコード文字列",
        base64url: "base64urlエンコード文字列",
        json_string: "JSON文字列",
        e164: "E.164番号",
        jwt: "JWT",
        template_literal: "入力値"
      }, f = {
        nan: "NaN",
        number: "数値",
        array: "配列"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `無効な入力: instanceof ${s.expected}が期待されましたが、${m}が入力されました` : `無効な入力: ${h}が期待されましたが、${m}が入力されました`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `無効な入力: ${a.stringifyPrimitive(s.values[0])}が期待されました` : `無効な選択: ${a.joinValues(s.values, "、")}のいずれかである必要があります`;
          case "too_big": {
            const h = s.inclusive ? "以下である" : "より小さい", p = l(s.origin);
            return p ? `大きすぎる値: ${s.origin ?? "値"}は${s.maximum.toString()}${p.unit ?? "要素"}${h}必要があります` : `大きすぎる値: ${s.origin ?? "値"}は${s.maximum.toString()}${h}必要があります`;
          }
          case "too_small": {
            const h = s.inclusive ? "以上である" : "より大きい", p = l(s.origin);
            return p ? `小さすぎる値: ${s.origin}は${s.minimum.toString()}${p.unit}${h}必要があります` : `小さすぎる値: ${s.origin}は${s.minimum.toString()}${h}必要があります`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `無効な文字列: "${h.prefix}"で始まる必要があります` : h.format === "ends_with" ? `無効な文字列: "${h.suffix}"で終わる必要があります` : h.format === "includes" ? `無効な文字列: "${h.includes}"を含む必要があります` : h.format === "regex" ? `無効な文字列: パターン${h.pattern}に一致する必要があります` : `無効な${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `無効な数値: ${s.divisor}の倍数である必要があります`;
          case "unrecognized_keys":
            return `認識されていないキー${s.keys.length > 1 ? "群" : ""}: ${a.joinValues(s.keys, "、")}`;
          case "invalid_key":
            return `${s.origin}内の無効なキー`;
          case "invalid_union":
            return "無効な入力";
          case "invalid_element":
            return `${s.origin}内の無効な値`;
          default:
            return "無効な入力";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Qa, Qa.exports)), Qa.exports;
}
var es = { exports: {} }, Zi = es.exports, Zg;
function OE() {
  return Zg || (Zg = 1, (function(e, t) {
    var n = Zi && Zi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Zi && Zi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Zi && Zi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "სიმბოლო", verb: "უნდა შეიცავდეს" },
        file: { unit: "ბაიტი", verb: "უნდა შეიცავდეს" },
        array: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" },
        set: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "შეყვანა",
        email: "ელ-ფოსტის მისამართი",
        url: "URL",
        emoji: "ემოჯი",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "თარიღი-დრო",
        date: "თარიღი",
        time: "დრო",
        duration: "ხანგრძლივობა",
        ipv4: "IPv4 მისამართი",
        ipv6: "IPv6 მისამართი",
        cidrv4: "IPv4 დიაპაზონი",
        cidrv6: "IPv6 დიაპაზონი",
        base64: "base64-კოდირებული სტრინგი",
        base64url: "base64url-კოდირებული სტრინგი",
        json_string: "JSON სტრინგი",
        e164: "E.164 ნომერი",
        jwt: "JWT",
        template_literal: "შეყვანა"
      }, f = {
        nan: "NaN",
        number: "რიცხვი",
        string: "სტრინგი",
        boolean: "ბულეანი",
        function: "ფუნქცია",
        array: "მასივი"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `არასწორი შეყვანა: მოსალოდნელი instanceof ${s.expected}, მიღებული ${m}` : `არასწორი შეყვანა: მოსალოდნელი ${h}, მიღებული ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `არასწორი შეყვანა: მოსალოდნელი ${a.stringifyPrimitive(s.values[0])}` : `არასწორი ვარიანტი: მოსალოდნელია ერთ-ერთი ${a.joinValues(s.values, "|")}-დან`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `ზედმეტად დიდი: მოსალოდნელი ${s.origin ?? "მნიშვნელობა"} ${p.verb} ${h}${s.maximum.toString()} ${p.unit}` : `ზედმეტად დიდი: მოსალოდნელი ${s.origin ?? "მნიშვნელობა"} იყოს ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `ზედმეტად პატარა: მოსალოდნელი ${s.origin} ${p.verb} ${h}${s.minimum.toString()} ${p.unit}` : `ზედმეტად პატარა: მოსალოდნელი ${s.origin} იყოს ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `არასწორი სტრინგი: უნდა იწყებოდეს "${h.prefix}"-ით` : h.format === "ends_with" ? `არასწორი სტრინგი: უნდა მთავრდებოდეს "${h.suffix}"-ით` : h.format === "includes" ? `არასწორი სტრინგი: უნდა შეიცავდეს "${h.includes}"-ს` : h.format === "regex" ? `არასწორი სტრინგი: უნდა შეესაბამებოდეს შაბლონს ${h.pattern}` : `არასწორი ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `არასწორი რიცხვი: უნდა იყოს ${s.divisor}-ის ჯერადი`;
          case "unrecognized_keys":
            return `უცნობი გასაღებ${s.keys.length > 1 ? "ები" : "ი"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `არასწორი გასაღები ${s.origin}-ში`;
          case "invalid_union":
            return "არასწორი შეყვანა";
          case "invalid_element":
            return `არასწორი მნიშვნელობა ${s.origin}-ში`;
          default:
            return "არასწორი შეყვანა";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(es, es.exports)), es.exports;
}
var ts = { exports: {} }, ns = { exports: {} }, Li = ns.exports, Lg;
function nk() {
  return Lg || (Lg = 1, (function(e, t) {
    var n = Li && Li.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Li && Li.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Li && Li.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "តួអក្សរ", verb: "គួរមាន" },
        file: { unit: "បៃ", verb: "គួរមាន" },
        array: { unit: "ធាតុ", verb: "គួរមាន" },
        set: { unit: "ធាតុ", verb: "គួរមាន" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "ទិន្នន័យបញ្ចូល",
        email: "អាសយដ្ឋានអ៊ីមែល",
        url: "URL",
        emoji: "សញ្ញាអារម្មណ៍",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "កាលបរិច្ឆេទ និងម៉ោង ISO",
        date: "កាលបរិច្ឆេទ ISO",
        time: "ម៉ោង ISO",
        duration: "រយៈពេល ISO",
        ipv4: "អាសយដ្ឋាន IPv4",
        ipv6: "អាសយដ្ឋាន IPv6",
        cidrv4: "ដែនអាសយដ្ឋាន IPv4",
        cidrv6: "ដែនអាសយដ្ឋាន IPv6",
        base64: "ខ្សែអក្សរអ៊ិកូដ base64",
        base64url: "ខ្សែអក្សរអ៊ិកូដ base64url",
        json_string: "ខ្សែអក្សរ JSON",
        e164: "លេខ E.164",
        jwt: "JWT",
        template_literal: "ទិន្នន័យបញ្ចូល"
      }, f = {
        nan: "NaN",
        number: "លេខ",
        array: "អារេ (Array)",
        null: "គ្មានតម្លៃ (null)"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ instanceof ${s.expected} ប៉ុន្តែទទួលបាន ${m}` : `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${h} ប៉ុន្តែទទួលបាន ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${a.stringifyPrimitive(s.values[0])}` : `ជម្រើសមិនត្រឹមត្រូវ៖ ត្រូវជាមួយក្នុងចំណោម ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `ធំពេក៖ ត្រូវការ ${s.origin ?? "តម្លៃ"} ${h} ${s.maximum.toString()} ${p.unit ?? "ធាតុ"}` : `ធំពេក៖ ត្រូវការ ${s.origin ?? "តម្លៃ"} ${h} ${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `តូចពេក៖ ត្រូវការ ${s.origin} ${h} ${s.minimum.toString()} ${p.unit}` : `តូចពេក៖ ត្រូវការ ${s.origin} ${h} ${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវចាប់ផ្តើមដោយ "${h.prefix}"` : h.format === "ends_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវបញ្ចប់ដោយ "${h.suffix}"` : h.format === "includes" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវមាន "${h.includes}"` : h.format === "regex" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវតែផ្គូផ្គងនឹងទម្រង់ដែលបានកំណត់ ${h.pattern}` : `មិនត្រឹមត្រូវ៖ ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `លេខមិនត្រឹមត្រូវ៖ ត្រូវតែជាពហុគុណនៃ ${s.divisor}`;
          case "unrecognized_keys":
            return `រកឃើញសោមិនស្គាល់៖ ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `សោមិនត្រឹមត្រូវនៅក្នុង ${s.origin}`;
          case "invalid_union":
            return "ទិន្នន័យមិនត្រឹមត្រូវ";
          case "invalid_element":
            return `ទិន្នន័យមិនត្រឹមត្រូវនៅក្នុង ${s.origin}`;
          default:
            return "ទិន្នន័យមិនត្រឹមត្រូវ";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ns, ns.exports)), ns.exports;
}
var Fg = ts.exports, Ug;
function zE() {
  return Ug || (Ug = 1, (function(e, t) {
    var n = Fg && Fg.__importDefault || function(a) {
      return a && a.__esModule ? a : { default: a };
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = i;
    const r = n(nk());
    function i() {
      return (0, r.default)();
    }
    e.exports = t.default;
  })(ts, ts.exports)), ts.exports;
}
var rs = { exports: {} }, Fi = rs.exports, Bg;
function EE() {
  return Bg || (Bg = 1, (function(e, t) {
    var n = Fi && Fi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Fi && Fi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Fi && Fi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "문자", verb: "to have" },
        file: { unit: "바이트", verb: "to have" },
        array: { unit: "개", verb: "to have" },
        set: { unit: "개", verb: "to have" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "입력",
        email: "이메일 주소",
        url: "URL",
        emoji: "이모지",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO 날짜시간",
        date: "ISO 날짜",
        time: "ISO 시간",
        duration: "ISO 기간",
        ipv4: "IPv4 주소",
        ipv6: "IPv6 주소",
        cidrv4: "IPv4 범위",
        cidrv6: "IPv6 범위",
        base64: "base64 인코딩 문자열",
        base64url: "base64url 인코딩 문자열",
        json_string: "JSON 문자열",
        e164: "E.164 번호",
        jwt: "JWT",
        template_literal: "입력"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `잘못된 입력: 예상 타입은 instanceof ${s.expected}, 받은 타입은 ${m}입니다` : `잘못된 입력: 예상 타입은 ${h}, 받은 타입은 ${m}입니다`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `잘못된 입력: 값은 ${a.stringifyPrimitive(s.values[0])} 이어야 합니다` : `잘못된 옵션: ${a.joinValues(s.values, "또는 ")} 중 하나여야 합니다`;
          case "too_big": {
            const h = s.inclusive ? "이하" : "미만", p = h === "미만" ? "이어야 합니다" : "여야 합니다", m = l(s.origin), y = m?.unit ?? "요소";
            return m ? `${s.origin ?? "값"}이 너무 큽니다: ${s.maximum.toString()}${y} ${h}${p}` : `${s.origin ?? "값"}이 너무 큽니다: ${s.maximum.toString()} ${h}${p}`;
          }
          case "too_small": {
            const h = s.inclusive ? "이상" : "초과", p = h === "이상" ? "이어야 합니다" : "여야 합니다", m = l(s.origin), y = m?.unit ?? "요소";
            return m ? `${s.origin ?? "값"}이 너무 작습니다: ${s.minimum.toString()}${y} ${h}${p}` : `${s.origin ?? "값"}이 너무 작습니다: ${s.minimum.toString()} ${h}${p}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `잘못된 문자열: "${h.prefix}"(으)로 시작해야 합니다` : h.format === "ends_with" ? `잘못된 문자열: "${h.suffix}"(으)로 끝나야 합니다` : h.format === "includes" ? `잘못된 문자열: "${h.includes}"을(를) 포함해야 합니다` : h.format === "regex" ? `잘못된 문자열: 정규식 ${h.pattern} 패턴과 일치해야 합니다` : `잘못된 ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `잘못된 숫자: ${s.divisor}의 배수여야 합니다`;
          case "unrecognized_keys":
            return `인식할 수 없는 키: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `잘못된 키: ${s.origin}`;
          case "invalid_union":
            return "잘못된 입력";
          case "invalid_element":
            return `잘못된 값: ${s.origin}`;
          default:
            return "잘못된 입력";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(rs, rs.exports)), rs.exports;
}
var is = { exports: {} }, Ui = is.exports, Vg;
function TE() {
  return Vg || (Vg = 1, (function(e, t) {
    var n = Ui && Ui.__createBinding || (Object.create ? (function(c, f, s, h) {
      h === void 0 && (h = s);
      var p = Object.getOwnPropertyDescriptor(f, s);
      (!p || ("get" in p ? !f.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return f[s];
      } }), Object.defineProperty(c, h, p);
    }) : (function(c, f, s, h) {
      h === void 0 && (h = s), c[h] = f[s];
    })), r = Ui && Ui.__setModuleDefault || (Object.create ? (function(c, f) {
      Object.defineProperty(c, "default", { enumerable: !0, value: f });
    }) : function(c, f) {
      c.default = f;
    }), i = Ui && Ui.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var f = {};
      if (c != null) for (var s in c) s !== "default" && Object.prototype.hasOwnProperty.call(c, s) && n(f, c, s);
      return r(f, c), f;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const a = i(Pe()), o = (c) => c.charAt(0).toUpperCase() + c.slice(1);
    function d(c) {
      const f = Math.abs(c), s = f % 10, h = f % 100;
      return h >= 11 && h <= 19 || s === 0 ? "many" : s === 1 ? "one" : "few";
    }
    const u = () => {
      const c = {
        string: {
          unit: {
            one: "simbolis",
            few: "simboliai",
            many: "simbolių"
          },
          verb: {
            smaller: {
              inclusive: "turi būti ne ilgesnė kaip",
              notInclusive: "turi būti trumpesnė kaip"
            },
            bigger: {
              inclusive: "turi būti ne trumpesnė kaip",
              notInclusive: "turi būti ilgesnė kaip"
            }
          }
        },
        file: {
          unit: {
            one: "baitas",
            few: "baitai",
            many: "baitų"
          },
          verb: {
            smaller: {
              inclusive: "turi būti ne didesnis kaip",
              notInclusive: "turi būti mažesnis kaip"
            },
            bigger: {
              inclusive: "turi būti ne mažesnis kaip",
              notInclusive: "turi būti didesnis kaip"
            }
          }
        },
        array: {
          unit: {
            one: "elementą",
            few: "elementus",
            many: "elementų"
          },
          verb: {
            smaller: {
              inclusive: "turi turėti ne daugiau kaip",
              notInclusive: "turi turėti mažiau kaip"
            },
            bigger: {
              inclusive: "turi turėti ne mažiau kaip",
              notInclusive: "turi turėti daugiau kaip"
            }
          }
        },
        set: {
          unit: {
            one: "elementą",
            few: "elementus",
            many: "elementų"
          },
          verb: {
            smaller: {
              inclusive: "turi turėti ne daugiau kaip",
              notInclusive: "turi turėti mažiau kaip"
            },
            bigger: {
              inclusive: "turi turėti ne mažiau kaip",
              notInclusive: "turi turėti daugiau kaip"
            }
          }
        }
      };
      function f(p, m, y, w) {
        const b = c[p] ?? null;
        return b === null ? b : {
          unit: b.unit[m],
          verb: b.verb[w][y ? "inclusive" : "notInclusive"]
        };
      }
      const s = {
        regex: "įvestis",
        email: "el. pašto adresas",
        url: "URL",
        emoji: "jaustukas",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO data ir laikas",
        date: "ISO data",
        time: "ISO laikas",
        duration: "ISO trukmė",
        ipv4: "IPv4 adresas",
        ipv6: "IPv6 adresas",
        cidrv4: "IPv4 tinklo prefiksas (CIDR)",
        cidrv6: "IPv6 tinklo prefiksas (CIDR)",
        base64: "base64 užkoduota eilutė",
        base64url: "base64url užkoduota eilutė",
        json_string: "JSON eilutė",
        e164: "E.164 numeris",
        jwt: "JWT",
        template_literal: "įvestis"
      }, h = {
        nan: "NaN",
        number: "skaičius",
        bigint: "sveikasis skaičius",
        string: "eilutė",
        boolean: "loginė reikšmė",
        undefined: "neapibrėžta reikšmė",
        function: "funkcija",
        symbol: "simbolis",
        array: "masyvas",
        object: "objektas",
        null: "nulinė reikšmė"
      };
      return (p) => {
        switch (p.code) {
          case "invalid_type": {
            const m = h[p.expected] ?? p.expected, y = a.parsedType(p.input), w = h[y] ?? y;
            return /^[A-Z]/.test(p.expected) ? `Gautas tipas ${w}, o tikėtasi - instanceof ${p.expected}` : `Gautas tipas ${w}, o tikėtasi - ${m}`;
          }
          case "invalid_value":
            return p.values.length === 1 ? `Privalo būti ${a.stringifyPrimitive(p.values[0])}` : `Privalo būti vienas iš ${a.joinValues(p.values, "|")} pasirinkimų`;
          case "too_big": {
            const m = h[p.origin] ?? p.origin, y = f(p.origin, d(Number(p.maximum)), p.inclusive ?? !1, "smaller");
            if (y?.verb)
              return `${o(m ?? p.origin ?? "reikšmė")} ${y.verb} ${p.maximum.toString()} ${y.unit ?? "elementų"}`;
            const w = p.inclusive ? "ne didesnis kaip" : "mažesnis kaip";
            return `${o(m ?? p.origin ?? "reikšmė")} turi būti ${w} ${p.maximum.toString()} ${y?.unit}`;
          }
          case "too_small": {
            const m = h[p.origin] ?? p.origin, y = f(p.origin, d(Number(p.minimum)), p.inclusive ?? !1, "bigger");
            if (y?.verb)
              return `${o(m ?? p.origin ?? "reikšmė")} ${y.verb} ${p.minimum.toString()} ${y.unit ?? "elementų"}`;
            const w = p.inclusive ? "ne mažesnis kaip" : "didesnis kaip";
            return `${o(m ?? p.origin ?? "reikšmė")} turi būti ${w} ${p.minimum.toString()} ${y?.unit}`;
          }
          case "invalid_format": {
            const m = p;
            return m.format === "starts_with" ? `Eilutė privalo prasidėti "${m.prefix}"` : m.format === "ends_with" ? `Eilutė privalo pasibaigti "${m.suffix}"` : m.format === "includes" ? `Eilutė privalo įtraukti "${m.includes}"` : m.format === "regex" ? `Eilutė privalo atitikti ${m.pattern}` : `Neteisingas ${s[m.format] ?? p.format}`;
          }
          case "not_multiple_of":
            return `Skaičius privalo būti ${p.divisor} kartotinis.`;
          case "unrecognized_keys":
            return `Neatpažint${p.keys.length > 1 ? "i" : "as"} rakt${p.keys.length > 1 ? "ai" : "as"}: ${a.joinValues(p.keys, ", ")}`;
          case "invalid_key":
            return "Rastas klaidingas raktas";
          case "invalid_union":
            return "Klaidinga įvestis";
          case "invalid_element": {
            const m = h[p.origin] ?? p.origin;
            return `${o(m ?? p.origin ?? "reikšmė")} turi klaidingą įvestį`;
          }
          default:
            return "Klaidinga įvestis";
        }
      };
    };
    function l() {
      return {
        localeError: u()
      };
    }
    e.exports = t.default;
  })(is, is.exports)), is.exports;
}
var os = { exports: {} }, Bi = os.exports, qg;
function NE() {
  return qg || (qg = 1, (function(e, t) {
    var n = Bi && Bi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Bi && Bi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Bi && Bi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "знаци", verb: "да имаат" },
        file: { unit: "бајти", verb: "да имаат" },
        array: { unit: "ставки", verb: "да имаат" },
        set: { unit: "ставки", verb: "да имаат" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "внес",
        email: "адреса на е-пошта",
        url: "URL",
        emoji: "емоџи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO датум и време",
        date: "ISO датум",
        time: "ISO време",
        duration: "ISO времетраење",
        ipv4: "IPv4 адреса",
        ipv6: "IPv6 адреса",
        cidrv4: "IPv4 опсег",
        cidrv6: "IPv6 опсег",
        base64: "base64-енкодирана низа",
        base64url: "base64url-енкодирана низа",
        json_string: "JSON низа",
        e164: "E.164 број",
        jwt: "JWT",
        template_literal: "внес"
      }, f = {
        nan: "NaN",
        number: "број",
        array: "низа"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Грешен внес: се очекува instanceof ${s.expected}, примено ${m}` : `Грешен внес: се очекува ${h}, примено ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Invalid input: expected ${a.stringifyPrimitive(s.values[0])}` : `Грешана опција: се очекува една ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Премногу голем: се очекува ${s.origin ?? "вредноста"} да има ${h}${s.maximum.toString()} ${p.unit ?? "елементи"}` : `Премногу голем: се очекува ${s.origin ?? "вредноста"} да биде ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Премногу мал: се очекува ${s.origin} да има ${h}${s.minimum.toString()} ${p.unit}` : `Премногу мал: се очекува ${s.origin} да биде ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Неважечка низа: мора да започнува со "${h.prefix}"` : h.format === "ends_with" ? `Неважечка низа: мора да завршува со "${h.suffix}"` : h.format === "includes" ? `Неважечка низа: мора да вклучува "${h.includes}"` : h.format === "regex" ? `Неважечка низа: мора да одгоара на патернот ${h.pattern}` : `Invalid ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Грешен број: мора да биде делив со ${s.divisor}`;
          case "unrecognized_keys":
            return `${s.keys.length > 1 ? "Непрепознаени клучеви" : "Непрепознаен клуч"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Грешен клуч во ${s.origin}`;
          case "invalid_union":
            return "Грешен внес";
          case "invalid_element":
            return `Грешна вредност во ${s.origin}`;
          default:
            return "Грешен внес";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(os, os.exports)), os.exports;
}
var as = { exports: {} }, Vi = as.exports, Hg;
function CE() {
  return Hg || (Hg = 1, (function(e, t) {
    var n = Vi && Vi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Vi && Vi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Vi && Vi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "aksara", verb: "mempunyai" },
        file: { unit: "bait", verb: "mempunyai" },
        array: { unit: "elemen", verb: "mempunyai" },
        set: { unit: "elemen", verb: "mempunyai" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "input",
        email: "alamat e-mel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tarikh masa ISO",
        date: "tarikh ISO",
        time: "masa ISO",
        duration: "tempoh ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "julat IPv4",
        cidrv6: "julat IPv6",
        base64: "string dikodkan base64",
        base64url: "string dikodkan base64url",
        json_string: "string JSON",
        e164: "nombor E.164",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        nan: "NaN",
        number: "nombor"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Input tidak sah: dijangka instanceof ${s.expected}, diterima ${m}` : `Input tidak sah: dijangka ${h}, diterima ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Input tidak sah: dijangka ${a.stringifyPrimitive(s.values[0])}` : `Pilihan tidak sah: dijangka salah satu daripada ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Terlalu besar: dijangka ${s.origin ?? "nilai"} ${p.verb} ${h}${s.maximum.toString()} ${p.unit ?? "elemen"}` : `Terlalu besar: dijangka ${s.origin ?? "nilai"} adalah ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Terlalu kecil: dijangka ${s.origin} ${p.verb} ${h}${s.minimum.toString()} ${p.unit}` : `Terlalu kecil: dijangka ${s.origin} adalah ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `String tidak sah: mesti bermula dengan "${h.prefix}"` : h.format === "ends_with" ? `String tidak sah: mesti berakhir dengan "${h.suffix}"` : h.format === "includes" ? `String tidak sah: mesti mengandungi "${h.includes}"` : h.format === "regex" ? `String tidak sah: mesti sepadan dengan corak ${h.pattern}` : `${c[h.format] ?? s.format} tidak sah`;
          }
          case "not_multiple_of":
            return `Nombor tidak sah: perlu gandaan ${s.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak sah dalam ${s.origin}`;
          case "invalid_union":
            return "Input tidak sah";
          case "invalid_element":
            return `Nilai tidak sah dalam ${s.origin}`;
          default:
            return "Input tidak sah";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(as, as.exports)), as.exports;
}
var ss = { exports: {} }, qi = ss.exports, Wg;
function DE() {
  return Wg || (Wg = 1, (function(e, t) {
    var n = qi && qi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = qi && qi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = qi && qi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "tekens", verb: "heeft" },
        file: { unit: "bytes", verb: "heeft" },
        array: { unit: "elementen", verb: "heeft" },
        set: { unit: "elementen", verb: "heeft" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "invoer",
        email: "emailadres",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum en tijd",
        date: "ISO datum",
        time: "ISO tijd",
        duration: "ISO duur",
        ipv4: "IPv4-adres",
        ipv6: "IPv6-adres",
        cidrv4: "IPv4-bereik",
        cidrv6: "IPv6-bereik",
        base64: "base64-gecodeerde tekst",
        base64url: "base64 URL-gecodeerde tekst",
        json_string: "JSON string",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "invoer"
      }, f = {
        nan: "NaN",
        number: "getal"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Ongeldige invoer: verwacht instanceof ${s.expected}, ontving ${m}` : `Ongeldige invoer: verwacht ${h}, ontving ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Ongeldige invoer: verwacht ${a.stringifyPrimitive(s.values[0])}` : `Ongeldige optie: verwacht één van ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin), m = s.origin === "date" ? "laat" : s.origin === "string" ? "lang" : "groot";
            return p ? `Te ${m}: verwacht dat ${s.origin ?? "waarde"} ${h}${s.maximum.toString()} ${p.unit ?? "elementen"} ${p.verb}` : `Te ${m}: verwacht dat ${s.origin ?? "waarde"} ${h}${s.maximum.toString()} is`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin), m = s.origin === "date" ? "vroeg" : s.origin === "string" ? "kort" : "klein";
            return p ? `Te ${m}: verwacht dat ${s.origin} ${h}${s.minimum.toString()} ${p.unit} ${p.verb}` : `Te ${m}: verwacht dat ${s.origin} ${h}${s.minimum.toString()} is`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Ongeldige tekst: moet met "${h.prefix}" beginnen` : h.format === "ends_with" ? `Ongeldige tekst: moet op "${h.suffix}" eindigen` : h.format === "includes" ? `Ongeldige tekst: moet "${h.includes}" bevatten` : h.format === "regex" ? `Ongeldige tekst: moet overeenkomen met patroon ${h.pattern}` : `Ongeldig: ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Ongeldig getal: moet een veelvoud van ${s.divisor} zijn`;
          case "unrecognized_keys":
            return `Onbekende key${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Ongeldige key in ${s.origin}`;
          case "invalid_union":
            return "Ongeldige invoer";
          case "invalid_element":
            return `Ongeldige waarde in ${s.origin}`;
          default:
            return "Ongeldige invoer";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ss, ss.exports)), ss.exports;
}
var ls = { exports: {} }, Hi = ls.exports, Gg;
function AE() {
  return Gg || (Gg = 1, (function(e, t) {
    var n = Hi && Hi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Hi && Hi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Hi && Hi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "tegn", verb: "å ha" },
        file: { unit: "bytes", verb: "å ha" },
        array: { unit: "elementer", verb: "å inneholde" },
        set: { unit: "elementer", verb: "å inneholde" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "input",
        email: "e-postadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslett",
        date: "ISO-dato",
        time: "ISO-klokkeslett",
        duration: "ISO-varighet",
        ipv4: "IPv4-område",
        ipv6: "IPv6-område",
        cidrv4: "IPv4-spekter",
        cidrv6: "IPv6-spekter",
        base64: "base64-enkodet streng",
        base64url: "base64url-enkodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        nan: "NaN",
        number: "tall",
        array: "liste"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Ugyldig input: forventet instanceof ${s.expected}, fikk ${m}` : `Ugyldig input: forventet ${h}, fikk ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Ugyldig verdi: forventet ${a.stringifyPrimitive(s.values[0])}` : `Ugyldig valg: forventet en av ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `For stor(t): forventet ${s.origin ?? "value"} til å ha ${h}${s.maximum.toString()} ${p.unit ?? "elementer"}` : `For stor(t): forventet ${s.origin ?? "value"} til å ha ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `For lite(n): forventet ${s.origin} til å ha ${h}${s.minimum.toString()} ${p.unit}` : `For lite(n): forventet ${s.origin} til å ha ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Ugyldig streng: må starte med "${h.prefix}"` : h.format === "ends_with" ? `Ugyldig streng: må ende med "${h.suffix}"` : h.format === "includes" ? `Ugyldig streng: må inneholde "${h.includes}"` : h.format === "regex" ? `Ugyldig streng: må matche mønsteret ${h.pattern}` : `Ugyldig ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Ugyldig tall: må være et multiplum av ${s.divisor}`;
          case "unrecognized_keys":
            return `${s.keys.length > 1 ? "Ukjente nøkler" : "Ukjent nøkkel"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Ugyldig nøkkel i ${s.origin}`;
          case "invalid_union":
            return "Ugyldig input";
          case "invalid_element":
            return `Ugyldig verdi i ${s.origin}`;
          default:
            return "Ugyldig input";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ls, ls.exports)), ls.exports;
}
var us = { exports: {} }, Wi = us.exports, Kg;
function jE() {
  return Kg || (Kg = 1, (function(e, t) {
    var n = Wi && Wi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Wi && Wi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Wi && Wi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "harf", verb: "olmalıdır" },
        file: { unit: "bayt", verb: "olmalıdır" },
        array: { unit: "unsur", verb: "olmalıdır" },
        set: { unit: "unsur", verb: "olmalıdır" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "giren",
        email: "epostagâh",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO hengâmı",
        date: "ISO tarihi",
        time: "ISO zamanı",
        duration: "ISO müddeti",
        ipv4: "IPv4 nişânı",
        ipv6: "IPv6 nişânı",
        cidrv4: "IPv4 menzili",
        cidrv6: "IPv6 menzili",
        base64: "base64-şifreli metin",
        base64url: "base64url-şifreli metin",
        json_string: "JSON metin",
        e164: "E.164 sayısı",
        jwt: "JWT",
        template_literal: "giren"
      }, f = {
        nan: "NaN",
        number: "numara",
        array: "saf",
        null: "gayb"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Fâsit giren: umulan instanceof ${s.expected}, alınan ${m}` : `Fâsit giren: umulan ${h}, alınan ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Fâsit giren: umulan ${a.stringifyPrimitive(s.values[0])}` : `Fâsit tercih: mûteberler ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Fazla büyük: ${s.origin ?? "value"}, ${h}${s.maximum.toString()} ${p.unit ?? "elements"} sahip olmalıydı.` : `Fazla büyük: ${s.origin ?? "value"}, ${h}${s.maximum.toString()} olmalıydı.`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Fazla küçük: ${s.origin}, ${h}${s.minimum.toString()} ${p.unit} sahip olmalıydı.` : `Fazla küçük: ${s.origin}, ${h}${s.minimum.toString()} olmalıydı.`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Fâsit metin: "${h.prefix}" ile başlamalı.` : h.format === "ends_with" ? `Fâsit metin: "${h.suffix}" ile bitmeli.` : h.format === "includes" ? `Fâsit metin: "${h.includes}" ihtivâ etmeli.` : h.format === "regex" ? `Fâsit metin: ${h.pattern} nakşına uymalı.` : `Fâsit ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Fâsit sayı: ${s.divisor} katı olmalıydı.`;
          case "unrecognized_keys":
            return `Tanınmayan anahtar ${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `${s.origin} için tanınmayan anahtar var.`;
          case "invalid_union":
            return "Giren tanınamadı.";
          case "invalid_element":
            return `${s.origin} için tanınmayan kıymet var.`;
          default:
            return "Kıymet tanınamadı.";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(us, us.exports)), us.exports;
}
var cs = { exports: {} }, Gi = cs.exports, Jg;
function ME() {
  return Jg || (Jg = 1, (function(e, t) {
    var n = Gi && Gi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Gi && Gi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Gi && Gi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "توکي", verb: "ولري" },
        file: { unit: "بایټس", verb: "ولري" },
        array: { unit: "توکي", verb: "ولري" },
        set: { unit: "توکي", verb: "ولري" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "ورودي",
        email: "بریښنالیک",
        url: "یو آر ال",
        emoji: "ایموجي",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "نیټه او وخت",
        date: "نېټه",
        time: "وخت",
        duration: "موده",
        ipv4: "د IPv4 پته",
        ipv6: "د IPv6 پته",
        cidrv4: "د IPv4 ساحه",
        cidrv6: "د IPv6 ساحه",
        base64: "base64-encoded متن",
        base64url: "base64url-encoded متن",
        json_string: "JSON متن",
        e164: "د E.164 شمېره",
        jwt: "JWT",
        template_literal: "ورودي"
      }, f = {
        nan: "NaN",
        number: "عدد",
        array: "ارې"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `ناسم ورودي: باید instanceof ${s.expected} وای, مګر ${m} ترلاسه شو` : `ناسم ورودي: باید ${h} وای, مګر ${m} ترلاسه شو`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `ناسم ورودي: باید ${a.stringifyPrimitive(s.values[0])} وای` : `ناسم انتخاب: باید یو له ${a.joinValues(s.values, "|")} څخه وای`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `ډیر لوی: ${s.origin ?? "ارزښت"} باید ${h}${s.maximum.toString()} ${p.unit ?? "عنصرونه"} ولري` : `ډیر لوی: ${s.origin ?? "ارزښت"} باید ${h}${s.maximum.toString()} وي`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `ډیر کوچنی: ${s.origin} باید ${h}${s.minimum.toString()} ${p.unit} ولري` : `ډیر کوچنی: ${s.origin} باید ${h}${s.minimum.toString()} وي`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `ناسم متن: باید د "${h.prefix}" سره پیل شي` : h.format === "ends_with" ? `ناسم متن: باید د "${h.suffix}" سره پای ته ورسيږي` : h.format === "includes" ? `ناسم متن: باید "${h.includes}" ولري` : h.format === "regex" ? `ناسم متن: باید د ${h.pattern} سره مطابقت ولري` : `${c[h.format] ?? s.format} ناسم دی`;
          }
          case "not_multiple_of":
            return `ناسم عدد: باید د ${s.divisor} مضرب وي`;
          case "unrecognized_keys":
            return `ناسم ${s.keys.length > 1 ? "کلیډونه" : "کلیډ"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `ناسم کلیډ په ${s.origin} کې`;
          case "invalid_union":
            return "ناسمه ورودي";
          case "invalid_element":
            return `ناسم عنصر په ${s.origin} کې`;
          default:
            return "ناسمه ورودي";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(cs, cs.exports)), cs.exports;
}
var ds = { exports: {} }, Ki = ds.exports, Xg;
function $E() {
  return Xg || (Xg = 1, (function(e, t) {
    var n = Ki && Ki.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ki && Ki.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ki && Ki.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "znaków", verb: "mieć" },
        file: { unit: "bajtów", verb: "mieć" },
        array: { unit: "elementów", verb: "mieć" },
        set: { unit: "elementów", verb: "mieć" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "wyrażenie",
        email: "adres email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i godzina w formacie ISO",
        date: "data w formacie ISO",
        time: "godzina w formacie ISO",
        duration: "czas trwania ISO",
        ipv4: "adres IPv4",
        ipv6: "adres IPv6",
        cidrv4: "zakres IPv4",
        cidrv6: "zakres IPv6",
        base64: "ciąg znaków zakodowany w formacie base64",
        base64url: "ciąg znaków zakodowany w formacie base64url",
        json_string: "ciąg znaków w formacie JSON",
        e164: "liczba E.164",
        jwt: "JWT",
        template_literal: "wejście"
      }, f = {
        nan: "NaN",
        number: "liczba",
        array: "tablica"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Nieprawidłowe dane wejściowe: oczekiwano instanceof ${s.expected}, otrzymano ${m}` : `Nieprawidłowe dane wejściowe: oczekiwano ${h}, otrzymano ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Nieprawidłowe dane wejściowe: oczekiwano ${a.stringifyPrimitive(s.values[0])}` : `Nieprawidłowa opcja: oczekiwano jednej z wartości ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Za duża wartość: oczekiwano, że ${s.origin ?? "wartość"} będzie mieć ${h}${s.maximum.toString()} ${p.unit ?? "elementów"}` : `Zbyt duż(y/a/e): oczekiwano, że ${s.origin ?? "wartość"} będzie wynosić ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Za mała wartość: oczekiwano, że ${s.origin ?? "wartość"} będzie mieć ${h}${s.minimum.toString()} ${p.unit ?? "elementów"}` : `Zbyt mał(y/a/e): oczekiwano, że ${s.origin ?? "wartość"} będzie wynosić ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Nieprawidłowy ciąg znaków: musi zaczynać się od "${h.prefix}"` : h.format === "ends_with" ? `Nieprawidłowy ciąg znaków: musi kończyć się na "${h.suffix}"` : h.format === "includes" ? `Nieprawidłowy ciąg znaków: musi zawierać "${h.includes}"` : h.format === "regex" ? `Nieprawidłowy ciąg znaków: musi odpowiadać wzorcowi ${h.pattern}` : `Nieprawidłow(y/a/e) ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Nieprawidłowa liczba: musi być wielokrotnością ${s.divisor}`;
          case "unrecognized_keys":
            return `Nierozpoznane klucze${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Nieprawidłowy klucz w ${s.origin}`;
          case "invalid_union":
            return "Nieprawidłowe dane wejściowe";
          case "invalid_element":
            return `Nieprawidłowa wartość w ${s.origin}`;
          default:
            return "Nieprawidłowe dane wejściowe";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ds, ds.exports)), ds.exports;
}
var fs = { exports: {} }, Ji = fs.exports, Yg;
function RE() {
  return Yg || (Yg = 1, (function(e, t) {
    var n = Ji && Ji.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Ji && Ji.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Ji && Ji.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "caracteres", verb: "ter" },
        file: { unit: "bytes", verb: "ter" },
        array: { unit: "itens", verb: "ter" },
        set: { unit: "itens", verb: "ter" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "padrão",
        email: "endereço de e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "duração ISO",
        ipv4: "endereço IPv4",
        ipv6: "endereço IPv6",
        cidrv4: "faixa de IPv4",
        cidrv6: "faixa de IPv6",
        base64: "texto codificado em base64",
        base64url: "URL codificada em base64",
        json_string: "texto JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      }, f = {
        nan: "NaN",
        number: "número",
        null: "nulo"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Tipo inválido: esperado instanceof ${s.expected}, recebido ${m}` : `Tipo inválido: esperado ${h}, recebido ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Entrada inválida: esperado ${a.stringifyPrimitive(s.values[0])}` : `Opção inválida: esperada uma das ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Muito grande: esperado que ${s.origin ?? "valor"} tivesse ${h}${s.maximum.toString()} ${p.unit ?? "elementos"}` : `Muito grande: esperado que ${s.origin ?? "valor"} fosse ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Muito pequeno: esperado que ${s.origin} tivesse ${h}${s.minimum.toString()} ${p.unit}` : `Muito pequeno: esperado que ${s.origin} fosse ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Texto inválido: deve começar com "${h.prefix}"` : h.format === "ends_with" ? `Texto inválido: deve terminar com "${h.suffix}"` : h.format === "includes" ? `Texto inválido: deve incluir "${h.includes}"` : h.format === "regex" ? `Texto inválido: deve corresponder ao padrão ${h.pattern}` : `${c[h.format] ?? s.format} inválido`;
          }
          case "not_multiple_of":
            return `Número inválido: deve ser múltiplo de ${s.divisor}`;
          case "unrecognized_keys":
            return `Chave${s.keys.length > 1 ? "s" : ""} desconhecida${s.keys.length > 1 ? "s" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Chave inválida em ${s.origin}`;
          case "invalid_union":
            return "Entrada inválida";
          case "invalid_element":
            return `Valor inválido em ${s.origin}`;
          default:
            return "Campo inválido";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(fs, fs.exports)), fs.exports;
}
var hs = { exports: {} }, Xi = hs.exports, Qg;
function ZE() {
  return Qg || (Qg = 1, (function(e, t) {
    var n = Xi && Xi.__createBinding || (Object.create ? (function(l, c, f, s) {
      s === void 0 && (s = f);
      var h = Object.getOwnPropertyDescriptor(c, f);
      (!h || ("get" in h ? !c.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return c[f];
      } }), Object.defineProperty(l, s, h);
    }) : (function(l, c, f, s) {
      s === void 0 && (s = f), l[s] = c[f];
    })), r = Xi && Xi.__setModuleDefault || (Object.create ? (function(l, c) {
      Object.defineProperty(l, "default", { enumerable: !0, value: c });
    }) : function(l, c) {
      l.default = c;
    }), i = Xi && Xi.__importStar || function(l) {
      if (l && l.__esModule) return l;
      var c = {};
      if (l != null) for (var f in l) f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && n(c, l, f);
      return r(c, l), c;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = u;
    const a = i(Pe());
    function o(l, c, f, s) {
      const h = Math.abs(l), p = h % 10, m = h % 100;
      return m >= 11 && m <= 19 ? s : p === 1 ? c : p >= 2 && p <= 4 ? f : s;
    }
    const d = () => {
      const l = {
        string: {
          unit: {
            one: "символ",
            few: "символа",
            many: "символов"
          },
          verb: "иметь"
        },
        file: {
          unit: {
            one: "байт",
            few: "байта",
            many: "байт"
          },
          verb: "иметь"
        },
        array: {
          unit: {
            one: "элемент",
            few: "элемента",
            many: "элементов"
          },
          verb: "иметь"
        },
        set: {
          unit: {
            one: "элемент",
            few: "элемента",
            many: "элементов"
          },
          verb: "иметь"
        }
      };
      function c(h) {
        return l[h] ?? null;
      }
      const f = {
        regex: "ввод",
        email: "email адрес",
        url: "URL",
        emoji: "эмодзи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO дата и время",
        date: "ISO дата",
        time: "ISO время",
        duration: "ISO длительность",
        ipv4: "IPv4 адрес",
        ipv6: "IPv6 адрес",
        cidrv4: "IPv4 диапазон",
        cidrv6: "IPv6 диапазон",
        base64: "строка в формате base64",
        base64url: "строка в формате base64url",
        json_string: "JSON строка",
        e164: "номер E.164",
        jwt: "JWT",
        template_literal: "ввод"
      }, s = {
        nan: "NaN",
        number: "число",
        array: "массив"
      };
      return (h) => {
        switch (h.code) {
          case "invalid_type": {
            const p = s[h.expected] ?? h.expected, m = a.parsedType(h.input), y = s[m] ?? m;
            return /^[A-Z]/.test(h.expected) ? `Неверный ввод: ожидалось instanceof ${h.expected}, получено ${y}` : `Неверный ввод: ожидалось ${p}, получено ${y}`;
          }
          case "invalid_value":
            return h.values.length === 1 ? `Неверный ввод: ожидалось ${a.stringifyPrimitive(h.values[0])}` : `Неверный вариант: ожидалось одно из ${a.joinValues(h.values, "|")}`;
          case "too_big": {
            const p = h.inclusive ? "<=" : "<", m = c(h.origin);
            if (m) {
              const y = Number(h.maximum), w = o(y, m.unit.one, m.unit.few, m.unit.many);
              return `Слишком большое значение: ожидалось, что ${h.origin ?? "значение"} будет иметь ${p}${h.maximum.toString()} ${w}`;
            }
            return `Слишком большое значение: ожидалось, что ${h.origin ?? "значение"} будет ${p}${h.maximum.toString()}`;
          }
          case "too_small": {
            const p = h.inclusive ? ">=" : ">", m = c(h.origin);
            if (m) {
              const y = Number(h.minimum), w = o(y, m.unit.one, m.unit.few, m.unit.many);
              return `Слишком маленькое значение: ожидалось, что ${h.origin} будет иметь ${p}${h.minimum.toString()} ${w}`;
            }
            return `Слишком маленькое значение: ожидалось, что ${h.origin} будет ${p}${h.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = h;
            return p.format === "starts_with" ? `Неверная строка: должна начинаться с "${p.prefix}"` : p.format === "ends_with" ? `Неверная строка: должна заканчиваться на "${p.suffix}"` : p.format === "includes" ? `Неверная строка: должна содержать "${p.includes}"` : p.format === "regex" ? `Неверная строка: должна соответствовать шаблону ${p.pattern}` : `Неверный ${f[p.format] ?? h.format}`;
          }
          case "not_multiple_of":
            return `Неверное число: должно быть кратным ${h.divisor}`;
          case "unrecognized_keys":
            return `Нераспознанн${h.keys.length > 1 ? "ые" : "ый"} ключ${h.keys.length > 1 ? "и" : ""}: ${a.joinValues(h.keys, ", ")}`;
          case "invalid_key":
            return `Неверный ключ в ${h.origin}`;
          case "invalid_union":
            return "Неверные входные данные";
          case "invalid_element":
            return `Неверное значение в ${h.origin}`;
          default:
            return "Неверные входные данные";
        }
      };
    };
    function u() {
      return {
        localeError: d()
      };
    }
    e.exports = t.default;
  })(hs, hs.exports)), hs.exports;
}
var ps = { exports: {} }, Yi = ps.exports, ey;
function LE() {
  return ey || (ey = 1, (function(e, t) {
    var n = Yi && Yi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Yi && Yi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Yi && Yi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "znakov", verb: "imeti" },
        file: { unit: "bajtov", verb: "imeti" },
        array: { unit: "elementov", verb: "imeti" },
        set: { unit: "elementov", verb: "imeti" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "vnos",
        email: "e-poštni naslov",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum in čas",
        date: "ISO datum",
        time: "ISO čas",
        duration: "ISO trajanje",
        ipv4: "IPv4 naslov",
        ipv6: "IPv6 naslov",
        cidrv4: "obseg IPv4",
        cidrv6: "obseg IPv6",
        base64: "base64 kodiran niz",
        base64url: "base64url kodiran niz",
        json_string: "JSON niz",
        e164: "E.164 številka",
        jwt: "JWT",
        template_literal: "vnos"
      }, f = {
        nan: "NaN",
        number: "število",
        array: "tabela"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Neveljaven vnos: pričakovano instanceof ${s.expected}, prejeto ${m}` : `Neveljaven vnos: pričakovano ${h}, prejeto ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Neveljaven vnos: pričakovano ${a.stringifyPrimitive(s.values[0])}` : `Neveljavna možnost: pričakovano eno izmed ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Preveliko: pričakovano, da bo ${s.origin ?? "vrednost"} imelo ${h}${s.maximum.toString()} ${p.unit ?? "elementov"}` : `Preveliko: pričakovano, da bo ${s.origin ?? "vrednost"} ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Premajhno: pričakovano, da bo ${s.origin} imelo ${h}${s.minimum.toString()} ${p.unit}` : `Premajhno: pričakovano, da bo ${s.origin} ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Neveljaven niz: mora se začeti z "${h.prefix}"` : h.format === "ends_with" ? `Neveljaven niz: mora se končati z "${h.suffix}"` : h.format === "includes" ? `Neveljaven niz: mora vsebovati "${h.includes}"` : h.format === "regex" ? `Neveljaven niz: mora ustrezati vzorcu ${h.pattern}` : `Neveljaven ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Neveljavno število: mora biti večkratnik ${s.divisor}`;
          case "unrecognized_keys":
            return `Neprepoznan${s.keys.length > 1 ? "i ključi" : " ključ"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Neveljaven ključ v ${s.origin}`;
          case "invalid_union":
            return "Neveljaven vnos";
          case "invalid_element":
            return `Neveljavna vrednost v ${s.origin}`;
          default:
            return "Neveljaven vnos";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ps, ps.exports)), ps.exports;
}
var ms = { exports: {} }, Qi = ms.exports, ty;
function FE() {
  return ty || (ty = 1, (function(e, t) {
    var n = Qi && Qi.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = Qi && Qi.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = Qi && Qi.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "tecken", verb: "att ha" },
        file: { unit: "bytes", verb: "att ha" },
        array: { unit: "objekt", verb: "att innehålla" },
        set: { unit: "objekt", verb: "att innehålla" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "reguljärt uttryck",
        email: "e-postadress",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datum och tid",
        date: "ISO-datum",
        time: "ISO-tid",
        duration: "ISO-varaktighet",
        ipv4: "IPv4-intervall",
        ipv6: "IPv6-intervall",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodad sträng",
        base64url: "base64url-kodad sträng",
        json_string: "JSON-sträng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "mall-literal"
      }, f = {
        nan: "NaN",
        number: "antal",
        array: "lista"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Ogiltig inmatning: förväntat instanceof ${s.expected}, fick ${m}` : `Ogiltig inmatning: förväntat ${h}, fick ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Ogiltig inmatning: förväntat ${a.stringifyPrimitive(s.values[0])}` : `Ogiltigt val: förväntade en av ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `För stor(t): förväntade ${s.origin ?? "värdet"} att ha ${h}${s.maximum.toString()} ${p.unit ?? "element"}` : `För stor(t): förväntat ${s.origin ?? "värdet"} att ha ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `För lite(t): förväntade ${s.origin ?? "värdet"} att ha ${h}${s.minimum.toString()} ${p.unit}` : `För lite(t): förväntade ${s.origin ?? "värdet"} att ha ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Ogiltig sträng: måste börja med "${h.prefix}"` : h.format === "ends_with" ? `Ogiltig sträng: måste sluta med "${h.suffix}"` : h.format === "includes" ? `Ogiltig sträng: måste innehålla "${h.includes}"` : h.format === "regex" ? `Ogiltig sträng: måste matcha mönstret "${h.pattern}"` : `Ogiltig(t) ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Ogiltigt tal: måste vara en multipel av ${s.divisor}`;
          case "unrecognized_keys":
            return `${s.keys.length > 1 ? "Okända nycklar" : "Okänd nyckel"}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Ogiltig nyckel i ${s.origin ?? "värdet"}`;
          case "invalid_union":
            return "Ogiltig input";
          case "invalid_element":
            return `Ogiltigt värde i ${s.origin ?? "värdet"}`;
          default:
            return "Ogiltig input";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ms, ms.exports)), ms.exports;
}
var gs = { exports: {} }, eo = gs.exports, ny;
function UE() {
  return ny || (ny = 1, (function(e, t) {
    var n = eo && eo.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = eo && eo.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = eo && eo.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "எழுத்துக்கள்", verb: "கொண்டிருக்க வேண்டும்" },
        file: { unit: "பைட்டுகள்", verb: "கொண்டிருக்க வேண்டும்" },
        array: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" },
        set: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "உள்ளீடு",
        email: "மின்னஞ்சல் முகவரி",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO தேதி நேரம்",
        date: "ISO தேதி",
        time: "ISO நேரம்",
        duration: "ISO கால அளவு",
        ipv4: "IPv4 முகவரி",
        ipv6: "IPv6 முகவரி",
        cidrv4: "IPv4 வரம்பு",
        cidrv6: "IPv6 வரம்பு",
        base64: "base64-encoded சரம்",
        base64url: "base64url-encoded சரம்",
        json_string: "JSON சரம்",
        e164: "E.164 எண்",
        jwt: "JWT",
        template_literal: "input"
      }, f = {
        nan: "NaN",
        number: "எண்",
        array: "அணி",
        null: "வெறுமை"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது instanceof ${s.expected}, பெறப்பட்டது ${m}` : `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${h}, பெறப்பட்டது ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${a.stringifyPrimitive(s.values[0])}` : `தவறான விருப்பம்: எதிர்பார்க்கப்பட்டது ${a.joinValues(s.values, "|")} இல் ஒன்று`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${s.origin ?? "மதிப்பு"} ${h}${s.maximum.toString()} ${p.unit ?? "உறுப்புகள்"} ஆக இருக்க வேண்டும்` : `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${s.origin ?? "மதிப்பு"} ${h}${s.maximum.toString()} ஆக இருக்க வேண்டும்`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${s.origin} ${h}${s.minimum.toString()} ${p.unit} ஆக இருக்க வேண்டும்` : `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${s.origin} ${h}${s.minimum.toString()} ஆக இருக்க வேண்டும்`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `தவறான சரம்: "${h.prefix}" இல் தொடங்க வேண்டும்` : h.format === "ends_with" ? `தவறான சரம்: "${h.suffix}" இல் முடிவடைய வேண்டும்` : h.format === "includes" ? `தவறான சரம்: "${h.includes}" ஐ உள்ளடக்க வேண்டும்` : h.format === "regex" ? `தவறான சரம்: ${h.pattern} முறைபாட்டுடன் பொருந்த வேண்டும்` : `தவறான ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `தவறான எண்: ${s.divisor} இன் பலமாக இருக்க வேண்டும்`;
          case "unrecognized_keys":
            return `அடையாளம் தெரியாத விசை${s.keys.length > 1 ? "கள்" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `${s.origin} இல் தவறான விசை`;
          case "invalid_union":
            return "தவறான உள்ளீடு";
          case "invalid_element":
            return `${s.origin} இல் தவறான மதிப்பு`;
          default:
            return "தவறான உள்ளீடு";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(gs, gs.exports)), gs.exports;
}
var ys = { exports: {} }, to = ys.exports, ry;
function BE() {
  return ry || (ry = 1, (function(e, t) {
    var n = to && to.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = to && to.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = to && to.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "ตัวอักษร", verb: "ควรมี" },
        file: { unit: "ไบต์", verb: "ควรมี" },
        array: { unit: "รายการ", verb: "ควรมี" },
        set: { unit: "รายการ", verb: "ควรมี" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "ข้อมูลที่ป้อน",
        email: "ที่อยู่อีเมล",
        url: "URL",
        emoji: "อิโมจิ",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "วันที่เวลาแบบ ISO",
        date: "วันที่แบบ ISO",
        time: "เวลาแบบ ISO",
        duration: "ช่วงเวลาแบบ ISO",
        ipv4: "ที่อยู่ IPv4",
        ipv6: "ที่อยู่ IPv6",
        cidrv4: "ช่วง IP แบบ IPv4",
        cidrv6: "ช่วง IP แบบ IPv6",
        base64: "ข้อความแบบ Base64",
        base64url: "ข้อความแบบ Base64 สำหรับ URL",
        json_string: "ข้อความแบบ JSON",
        e164: "เบอร์โทรศัพท์ระหว่างประเทศ (E.164)",
        jwt: "โทเคน JWT",
        template_literal: "ข้อมูลที่ป้อน"
      }, f = {
        nan: "NaN",
        number: "ตัวเลข",
        array: "อาร์เรย์ (Array)",
        null: "ไม่มีค่า (null)"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น instanceof ${s.expected} แต่ได้รับ ${m}` : `ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น ${h} แต่ได้รับ ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `ค่าไม่ถูกต้อง: ควรเป็น ${a.stringifyPrimitive(s.values[0])}` : `ตัวเลือกไม่ถูกต้อง: ควรเป็นหนึ่งใน ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "ไม่เกิน" : "น้อยกว่า", p = l(s.origin);
            return p ? `เกินกำหนด: ${s.origin ?? "ค่า"} ควรมี${h} ${s.maximum.toString()} ${p.unit ?? "รายการ"}` : `เกินกำหนด: ${s.origin ?? "ค่า"} ควรมี${h} ${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? "อย่างน้อย" : "มากกว่า", p = l(s.origin);
            return p ? `น้อยกว่ากำหนด: ${s.origin} ควรมี${h} ${s.minimum.toString()} ${p.unit}` : `น้อยกว่ากำหนด: ${s.origin} ควรมี${h} ${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องขึ้นต้นด้วย "${h.prefix}"` : h.format === "ends_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องลงท้ายด้วย "${h.suffix}"` : h.format === "includes" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องมี "${h.includes}" อยู่ในข้อความ` : h.format === "regex" ? `รูปแบบไม่ถูกต้อง: ต้องตรงกับรูปแบบที่กำหนด ${h.pattern}` : `รูปแบบไม่ถูกต้อง: ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `ตัวเลขไม่ถูกต้อง: ต้องเป็นจำนวนที่หารด้วย ${s.divisor} ได้ลงตัว`;
          case "unrecognized_keys":
            return `พบคีย์ที่ไม่รู้จัก: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `คีย์ไม่ถูกต้องใน ${s.origin}`;
          case "invalid_union":
            return "ข้อมูลไม่ถูกต้อง: ไม่ตรงกับรูปแบบยูเนียนที่กำหนดไว้";
          case "invalid_element":
            return `ข้อมูลไม่ถูกต้องใน ${s.origin}`;
          default:
            return "ข้อมูลไม่ถูกต้อง";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ys, ys.exports)), ys.exports;
}
var vs = { exports: {} }, no = vs.exports, iy;
function VE() {
  return iy || (iy = 1, (function(e, t) {
    var n = no && no.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = no && no.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = no && no.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "karakter", verb: "olmalı" },
        file: { unit: "bayt", verb: "olmalı" },
        array: { unit: "öğe", verb: "olmalı" },
        set: { unit: "öğe", verb: "olmalı" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "girdi",
        email: "e-posta adresi",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO tarih ve saat",
        date: "ISO tarih",
        time: "ISO saat",
        duration: "ISO süre",
        ipv4: "IPv4 adresi",
        ipv6: "IPv6 adresi",
        cidrv4: "IPv4 aralığı",
        cidrv6: "IPv6 aralığı",
        base64: "base64 ile şifrelenmiş metin",
        base64url: "base64url ile şifrelenmiş metin",
        json_string: "JSON dizesi",
        e164: "E.164 sayısı",
        jwt: "JWT",
        template_literal: "Şablon dizesi"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Geçersiz değer: beklenen instanceof ${s.expected}, alınan ${m}` : `Geçersiz değer: beklenen ${h}, alınan ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Geçersiz değer: beklenen ${a.stringifyPrimitive(s.values[0])}` : `Geçersiz seçenek: aşağıdakilerden biri olmalı: ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Çok büyük: beklenen ${s.origin ?? "değer"} ${h}${s.maximum.toString()} ${p.unit ?? "öğe"}` : `Çok büyük: beklenen ${s.origin ?? "değer"} ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Çok küçük: beklenen ${s.origin} ${h}${s.minimum.toString()} ${p.unit}` : `Çok küçük: beklenen ${s.origin} ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Geçersiz metin: "${h.prefix}" ile başlamalı` : h.format === "ends_with" ? `Geçersiz metin: "${h.suffix}" ile bitmeli` : h.format === "includes" ? `Geçersiz metin: "${h.includes}" içermeli` : h.format === "regex" ? `Geçersiz metin: ${h.pattern} desenine uymalı` : `Geçersiz ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Geçersiz sayı: ${s.divisor} ile tam bölünebilmeli`;
          case "unrecognized_keys":
            return `Tanınmayan anahtar${s.keys.length > 1 ? "lar" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `${s.origin} içinde geçersiz anahtar`;
          case "invalid_union":
            return "Geçersiz değer";
          case "invalid_element":
            return `${s.origin} içinde geçersiz değer`;
          default:
            return "Geçersiz değer";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(vs, vs.exports)), vs.exports;
}
var bs = { exports: {} }, _s = { exports: {} }, ro = _s.exports, oy;
function rk() {
  return oy || (oy = 1, (function(e, t) {
    var n = ro && ro.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = ro && ro.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = ro && ro.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "символів", verb: "матиме" },
        file: { unit: "байтів", verb: "матиме" },
        array: { unit: "елементів", verb: "матиме" },
        set: { unit: "елементів", verb: "матиме" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "вхідні дані",
        email: "адреса електронної пошти",
        url: "URL",
        emoji: "емодзі",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "дата та час ISO",
        date: "дата ISO",
        time: "час ISO",
        duration: "тривалість ISO",
        ipv4: "адреса IPv4",
        ipv6: "адреса IPv6",
        cidrv4: "діапазон IPv4",
        cidrv6: "діапазон IPv6",
        base64: "рядок у кодуванні base64",
        base64url: "рядок у кодуванні base64url",
        json_string: "рядок JSON",
        e164: "номер E.164",
        jwt: "JWT",
        template_literal: "вхідні дані"
      }, f = {
        nan: "NaN",
        number: "число",
        array: "масив"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Неправильні вхідні дані: очікується instanceof ${s.expected}, отримано ${m}` : `Неправильні вхідні дані: очікується ${h}, отримано ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Неправильні вхідні дані: очікується ${a.stringifyPrimitive(s.values[0])}` : `Неправильна опція: очікується одне з ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Занадто велике: очікується, що ${s.origin ?? "значення"} ${p.verb} ${h}${s.maximum.toString()} ${p.unit ?? "елементів"}` : `Занадто велике: очікується, що ${s.origin ?? "значення"} буде ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Занадто мале: очікується, що ${s.origin} ${p.verb} ${h}${s.minimum.toString()} ${p.unit}` : `Занадто мале: очікується, що ${s.origin} буде ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Неправильний рядок: повинен починатися з "${h.prefix}"` : h.format === "ends_with" ? `Неправильний рядок: повинен закінчуватися на "${h.suffix}"` : h.format === "includes" ? `Неправильний рядок: повинен містити "${h.includes}"` : h.format === "regex" ? `Неправильний рядок: повинен відповідати шаблону ${h.pattern}` : `Неправильний ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Неправильне число: повинно бути кратним ${s.divisor}`;
          case "unrecognized_keys":
            return `Нерозпізнаний ключ${s.keys.length > 1 ? "і" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Неправильний ключ у ${s.origin}`;
          case "invalid_union":
            return "Неправильні вхідні дані";
          case "invalid_element":
            return `Неправильне значення у ${s.origin}`;
          default:
            return "Неправильні вхідні дані";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(_s, _s.exports)), _s.exports;
}
var ay = bs.exports, sy;
function qE() {
  return sy || (sy = 1, (function(e, t) {
    var n = ay && ay.__importDefault || function(a) {
      return a && a.__esModule ? a : { default: a };
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = i;
    const r = n(rk());
    function i() {
      return (0, r.default)();
    }
    e.exports = t.default;
  })(bs, bs.exports)), bs.exports;
}
var ws = { exports: {} }, io = ws.exports, ly;
function HE() {
  return ly || (ly = 1, (function(e, t) {
    var n = io && io.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = io && io.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = io && io.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "حروف", verb: "ہونا" },
        file: { unit: "بائٹس", verb: "ہونا" },
        array: { unit: "آئٹمز", verb: "ہونا" },
        set: { unit: "آئٹمز", verb: "ہونا" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "ان پٹ",
        email: "ای میل ایڈریس",
        url: "یو آر ایل",
        emoji: "ایموجی",
        uuid: "یو یو آئی ڈی",
        uuidv4: "یو یو آئی ڈی وی 4",
        uuidv6: "یو یو آئی ڈی وی 6",
        nanoid: "نینو آئی ڈی",
        guid: "جی یو آئی ڈی",
        cuid: "سی یو آئی ڈی",
        cuid2: "سی یو آئی ڈی 2",
        ulid: "یو ایل آئی ڈی",
        xid: "ایکس آئی ڈی",
        ksuid: "کے ایس یو آئی ڈی",
        datetime: "آئی ایس او ڈیٹ ٹائم",
        date: "آئی ایس او تاریخ",
        time: "آئی ایس او وقت",
        duration: "آئی ایس او مدت",
        ipv4: "آئی پی وی 4 ایڈریس",
        ipv6: "آئی پی وی 6 ایڈریس",
        cidrv4: "آئی پی وی 4 رینج",
        cidrv6: "آئی پی وی 6 رینج",
        base64: "بیس 64 ان کوڈڈ سٹرنگ",
        base64url: "بیس 64 یو آر ایل ان کوڈڈ سٹرنگ",
        json_string: "جے ایس او این سٹرنگ",
        e164: "ای 164 نمبر",
        jwt: "جے ڈبلیو ٹی",
        template_literal: "ان پٹ"
      }, f = {
        nan: "NaN",
        number: "نمبر",
        array: "آرے",
        null: "نل"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `غلط ان پٹ: instanceof ${s.expected} متوقع تھا، ${m} موصول ہوا` : `غلط ان پٹ: ${h} متوقع تھا، ${m} موصول ہوا`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `غلط ان پٹ: ${a.stringifyPrimitive(s.values[0])} متوقع تھا` : `غلط آپشن: ${a.joinValues(s.values, "|")} میں سے ایک متوقع تھا`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `بہت بڑا: ${s.origin ?? "ویلیو"} کے ${h}${s.maximum.toString()} ${p.unit ?? "عناصر"} ہونے متوقع تھے` : `بہت بڑا: ${s.origin ?? "ویلیو"} کا ${h}${s.maximum.toString()} ہونا متوقع تھا`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `بہت چھوٹا: ${s.origin} کے ${h}${s.minimum.toString()} ${p.unit} ہونے متوقع تھے` : `بہت چھوٹا: ${s.origin} کا ${h}${s.minimum.toString()} ہونا متوقع تھا`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `غلط سٹرنگ: "${h.prefix}" سے شروع ہونا چاہیے` : h.format === "ends_with" ? `غلط سٹرنگ: "${h.suffix}" پر ختم ہونا چاہیے` : h.format === "includes" ? `غلط سٹرنگ: "${h.includes}" شامل ہونا چاہیے` : h.format === "regex" ? `غلط سٹرنگ: پیٹرن ${h.pattern} سے میچ ہونا چاہیے` : `غلط ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `غلط نمبر: ${s.divisor} کا مضاعف ہونا چاہیے`;
          case "unrecognized_keys":
            return `غیر تسلیم شدہ کی${s.keys.length > 1 ? "ز" : ""}: ${a.joinValues(s.keys, "، ")}`;
          case "invalid_key":
            return `${s.origin} میں غلط کی`;
          case "invalid_union":
            return "غلط ان پٹ";
          case "invalid_element":
            return `${s.origin} میں غلط ویلیو`;
          default:
            return "غلط ان پٹ";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ws, ws.exports)), ws.exports;
}
var ks = { exports: {} }, oo = ks.exports, uy;
function WE() {
  return uy || (uy = 1, (function(e, t) {
    var n = oo && oo.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = oo && oo.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = oo && oo.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "belgi", verb: "bo‘lishi kerak" },
        file: { unit: "bayt", verb: "bo‘lishi kerak" },
        array: { unit: "element", verb: "bo‘lishi kerak" },
        set: { unit: "element", verb: "bo‘lishi kerak" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "kirish",
        email: "elektron pochta manzili",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO sana va vaqti",
        date: "ISO sana",
        time: "ISO vaqt",
        duration: "ISO davomiylik",
        ipv4: "IPv4 manzil",
        ipv6: "IPv6 manzil",
        mac: "MAC manzil",
        cidrv4: "IPv4 diapazon",
        cidrv6: "IPv6 diapazon",
        base64: "base64 kodlangan satr",
        base64url: "base64url kodlangan satr",
        json_string: "JSON satr",
        e164: "E.164 raqam",
        jwt: "JWT",
        template_literal: "kirish"
      }, f = {
        nan: "NaN",
        number: "raqam",
        array: "massiv"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Noto‘g‘ri kirish: kutilgan instanceof ${s.expected}, qabul qilingan ${m}` : `Noto‘g‘ri kirish: kutilgan ${h}, qabul qilingan ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Noto‘g‘ri kirish: kutilgan ${a.stringifyPrimitive(s.values[0])}` : `Noto‘g‘ri variant: quyidagilardan biri kutilgan ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Juda katta: kutilgan ${s.origin ?? "qiymat"} ${h}${s.maximum.toString()} ${p.unit} ${p.verb}` : `Juda katta: kutilgan ${s.origin ?? "qiymat"} ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Juda kichik: kutilgan ${s.origin} ${h}${s.minimum.toString()} ${p.unit} ${p.verb}` : `Juda kichik: kutilgan ${s.origin} ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Noto‘g‘ri satr: "${h.prefix}" bilan boshlanishi kerak` : h.format === "ends_with" ? `Noto‘g‘ri satr: "${h.suffix}" bilan tugashi kerak` : h.format === "includes" ? `Noto‘g‘ri satr: "${h.includes}" ni o‘z ichiga olishi kerak` : h.format === "regex" ? `Noto‘g‘ri satr: ${h.pattern} shabloniga mos kelishi kerak` : `Noto‘g‘ri ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Noto‘g‘ri raqam: ${s.divisor} ning karralisi bo‘lishi kerak`;
          case "unrecognized_keys":
            return `Noma’lum kalit${s.keys.length > 1 ? "lar" : ""}: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `${s.origin} dagi kalit noto‘g‘ri`;
          case "invalid_union":
            return "Noto‘g‘ri kirish";
          case "invalid_element":
            return `${s.origin} da noto‘g‘ri qiymat`;
          default:
            return "Noto‘g‘ri kirish";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(ks, ks.exports)), ks.exports;
}
var Ss = { exports: {} }, ao = Ss.exports, cy;
function GE() {
  return cy || (cy = 1, (function(e, t) {
    var n = ao && ao.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = ao && ao.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = ao && ao.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "ký tự", verb: "có" },
        file: { unit: "byte", verb: "có" },
        array: { unit: "phần tử", verb: "có" },
        set: { unit: "phần tử", verb: "có" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "đầu vào",
        email: "địa chỉ email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ngày giờ ISO",
        date: "ngày ISO",
        time: "giờ ISO",
        duration: "khoảng thời gian ISO",
        ipv4: "địa chỉ IPv4",
        ipv6: "địa chỉ IPv6",
        cidrv4: "dải IPv4",
        cidrv6: "dải IPv6",
        base64: "chuỗi mã hóa base64",
        base64url: "chuỗi mã hóa base64url",
        json_string: "chuỗi JSON",
        e164: "số E.164",
        jwt: "JWT",
        template_literal: "đầu vào"
      }, f = {
        nan: "NaN",
        number: "số",
        array: "mảng"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Đầu vào không hợp lệ: mong đợi instanceof ${s.expected}, nhận được ${m}` : `Đầu vào không hợp lệ: mong đợi ${h}, nhận được ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Đầu vào không hợp lệ: mong đợi ${a.stringifyPrimitive(s.values[0])}` : `Tùy chọn không hợp lệ: mong đợi một trong các giá trị ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Quá lớn: mong đợi ${s.origin ?? "giá trị"} ${p.verb} ${h}${s.maximum.toString()} ${p.unit ?? "phần tử"}` : `Quá lớn: mong đợi ${s.origin ?? "giá trị"} ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Quá nhỏ: mong đợi ${s.origin} ${p.verb} ${h}${s.minimum.toString()} ${p.unit}` : `Quá nhỏ: mong đợi ${s.origin} ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Chuỗi không hợp lệ: phải bắt đầu bằng "${h.prefix}"` : h.format === "ends_with" ? `Chuỗi không hợp lệ: phải kết thúc bằng "${h.suffix}"` : h.format === "includes" ? `Chuỗi không hợp lệ: phải bao gồm "${h.includes}"` : h.format === "regex" ? `Chuỗi không hợp lệ: phải khớp với mẫu ${h.pattern}` : `${c[h.format] ?? s.format} không hợp lệ`;
          }
          case "not_multiple_of":
            return `Số không hợp lệ: phải là bội số của ${s.divisor}`;
          case "unrecognized_keys":
            return `Khóa không được nhận dạng: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Khóa không hợp lệ trong ${s.origin}`;
          case "invalid_union":
            return "Đầu vào không hợp lệ";
          case "invalid_element":
            return `Giá trị không hợp lệ trong ${s.origin}`;
          default:
            return "Đầu vào không hợp lệ";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ss, Ss.exports)), Ss.exports;
}
var xs = { exports: {} }, so = xs.exports, dy;
function KE() {
  return dy || (dy = 1, (function(e, t) {
    var n = so && so.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = so && so.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = so && so.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "字符", verb: "包含" },
        file: { unit: "字节", verb: "包含" },
        array: { unit: "项", verb: "包含" },
        set: { unit: "项", verb: "包含" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "输入",
        email: "电子邮件",
        url: "URL",
        emoji: "表情符号",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO日期时间",
        date: "ISO日期",
        time: "ISO时间",
        duration: "ISO时长",
        ipv4: "IPv4地址",
        ipv6: "IPv6地址",
        cidrv4: "IPv4网段",
        cidrv6: "IPv6网段",
        base64: "base64编码字符串",
        base64url: "base64url编码字符串",
        json_string: "JSON字符串",
        e164: "E.164号码",
        jwt: "JWT",
        template_literal: "输入"
      }, f = {
        nan: "NaN",
        number: "数字",
        array: "数组",
        null: "空值(null)"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `无效输入：期望 instanceof ${s.expected}，实际接收 ${m}` : `无效输入：期望 ${h}，实际接收 ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `无效输入：期望 ${a.stringifyPrimitive(s.values[0])}` : `无效选项：期望以下之一 ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `数值过大：期望 ${s.origin ?? "值"} ${h}${s.maximum.toString()} ${p.unit ?? "个元素"}` : `数值过大：期望 ${s.origin ?? "值"} ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `数值过小：期望 ${s.origin} ${h}${s.minimum.toString()} ${p.unit}` : `数值过小：期望 ${s.origin} ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `无效字符串：必须以 "${h.prefix}" 开头` : h.format === "ends_with" ? `无效字符串：必须以 "${h.suffix}" 结尾` : h.format === "includes" ? `无效字符串：必须包含 "${h.includes}"` : h.format === "regex" ? `无效字符串：必须满足正则表达式 ${h.pattern}` : `无效${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `无效数字：必须是 ${s.divisor} 的倍数`;
          case "unrecognized_keys":
            return `出现未知的键(key): ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `${s.origin} 中的键(key)无效`;
          case "invalid_union":
            return "无效输入";
          case "invalid_element":
            return `${s.origin} 中包含无效值(value)`;
          default:
            return "无效输入";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(xs, xs.exports)), xs.exports;
}
var Is = { exports: {} }, lo = Is.exports, fy;
function JE() {
  return fy || (fy = 1, (function(e, t) {
    var n = lo && lo.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = lo && lo.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = lo && lo.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "字元", verb: "擁有" },
        file: { unit: "位元組", verb: "擁有" },
        array: { unit: "項目", verb: "擁有" },
        set: { unit: "項目", verb: "擁有" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "輸入",
        email: "郵件地址",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO 日期時間",
        date: "ISO 日期",
        time: "ISO 時間",
        duration: "ISO 期間",
        ipv4: "IPv4 位址",
        ipv6: "IPv6 位址",
        cidrv4: "IPv4 範圍",
        cidrv6: "IPv6 範圍",
        base64: "base64 編碼字串",
        base64url: "base64url 編碼字串",
        json_string: "JSON 字串",
        e164: "E.164 數值",
        jwt: "JWT",
        template_literal: "輸入"
      }, f = {
        nan: "NaN"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `無效的輸入值：預期為 instanceof ${s.expected}，但收到 ${m}` : `無效的輸入值：預期為 ${h}，但收到 ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `無效的輸入值：預期為 ${a.stringifyPrimitive(s.values[0])}` : `無效的選項：預期為以下其中之一 ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `數值過大：預期 ${s.origin ?? "值"} 應為 ${h}${s.maximum.toString()} ${p.unit ?? "個元素"}` : `數值過大：預期 ${s.origin ?? "值"} 應為 ${h}${s.maximum.toString()}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `數值過小：預期 ${s.origin} 應為 ${h}${s.minimum.toString()} ${p.unit}` : `數值過小：預期 ${s.origin} 應為 ${h}${s.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `無效的字串：必須以 "${h.prefix}" 開頭` : h.format === "ends_with" ? `無效的字串：必須以 "${h.suffix}" 結尾` : h.format === "includes" ? `無效的字串：必須包含 "${h.includes}"` : h.format === "regex" ? `無效的字串：必須符合格式 ${h.pattern}` : `無效的 ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `無效的數字：必須為 ${s.divisor} 的倍數`;
          case "unrecognized_keys":
            return `無法識別的鍵值${s.keys.length > 1 ? "們" : ""}：${a.joinValues(s.keys, "、")}`;
          case "invalid_key":
            return `${s.origin} 中有無效的鍵值`;
          case "invalid_union":
            return "無效的輸入值";
          case "invalid_element":
            return `${s.origin} 中有無效的值`;
          default:
            return "無效的輸入值";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Is, Is.exports)), Is.exports;
}
var Ps = { exports: {} }, uo = Ps.exports, hy;
function XE() {
  return hy || (hy = 1, (function(e, t) {
    var n = uo && uo.__createBinding || (Object.create ? (function(u, l, c, f) {
      f === void 0 && (f = c);
      var s = Object.getOwnPropertyDescriptor(l, c);
      (!s || ("get" in s ? !l.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(u, f, s);
    }) : (function(u, l, c, f) {
      f === void 0 && (f = c), u[f] = l[c];
    })), r = uo && uo.__setModuleDefault || (Object.create ? (function(u, l) {
      Object.defineProperty(u, "default", { enumerable: !0, value: l });
    }) : function(u, l) {
      u.default = l;
    }), i = uo && uo.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var l = {};
      if (u != null) for (var c in u) c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && n(l, u, c);
      return r(l, u), l;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
    const a = i(Pe()), o = () => {
      const u = {
        string: { unit: "àmi", verb: "ní" },
        file: { unit: "bytes", verb: "ní" },
        array: { unit: "nkan", verb: "ní" },
        set: { unit: "nkan", verb: "ní" }
      };
      function l(s) {
        return u[s] ?? null;
      }
      const c = {
        regex: "ẹ̀rọ ìbáwọlé",
        email: "àdírẹ́sì ìmẹ́lì",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "àkókò ISO",
        date: "ọjọ́ ISO",
        time: "àkókò ISO",
        duration: "àkókò tó pé ISO",
        ipv4: "àdírẹ́sì IPv4",
        ipv6: "àdírẹ́sì IPv6",
        cidrv4: "àgbègbè IPv4",
        cidrv6: "àgbègbè IPv6",
        base64: "ọ̀rọ̀ tí a kọ́ ní base64",
        base64url: "ọ̀rọ̀ base64url",
        json_string: "ọ̀rọ̀ JSON",
        e164: "nọ́mbà E.164",
        jwt: "JWT",
        template_literal: "ẹ̀rọ ìbáwọlé"
      }, f = {
        nan: "NaN",
        number: "nọ́mbà",
        array: "akopọ"
      };
      return (s) => {
        switch (s.code) {
          case "invalid_type": {
            const h = f[s.expected] ?? s.expected, p = a.parsedType(s.input), m = f[p] ?? p;
            return /^[A-Z]/.test(s.expected) ? `Ìbáwọlé aṣìṣe: a ní láti fi instanceof ${s.expected}, àmọ̀ a rí ${m}` : `Ìbáwọlé aṣìṣe: a ní láti fi ${h}, àmọ̀ a rí ${m}`;
          }
          case "invalid_value":
            return s.values.length === 1 ? `Ìbáwọlé aṣìṣe: a ní láti fi ${a.stringifyPrimitive(s.values[0])}` : `Àṣàyàn aṣìṣe: yan ọ̀kan lára ${a.joinValues(s.values, "|")}`;
          case "too_big": {
            const h = s.inclusive ? "<=" : "<", p = l(s.origin);
            return p ? `Tó pọ̀ jù: a ní láti jẹ́ pé ${s.origin ?? "iye"} ${p.verb} ${h}${s.maximum} ${p.unit}` : `Tó pọ̀ jù: a ní láti jẹ́ ${h}${s.maximum}`;
          }
          case "too_small": {
            const h = s.inclusive ? ">=" : ">", p = l(s.origin);
            return p ? `Kéré ju: a ní láti jẹ́ pé ${s.origin} ${p.verb} ${h}${s.minimum} ${p.unit}` : `Kéré ju: a ní láti jẹ́ ${h}${s.minimum}`;
          }
          case "invalid_format": {
            const h = s;
            return h.format === "starts_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bẹ̀rẹ̀ pẹ̀lú "${h.prefix}"` : h.format === "ends_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ parí pẹ̀lú "${h.suffix}"` : h.format === "includes" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ ní "${h.includes}"` : h.format === "regex" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bá àpẹẹrẹ mu ${h.pattern}` : `Aṣìṣe: ${c[h.format] ?? s.format}`;
          }
          case "not_multiple_of":
            return `Nọ́mbà aṣìṣe: gbọ́dọ̀ jẹ́ èyà pípín ti ${s.divisor}`;
          case "unrecognized_keys":
            return `Bọtìnì àìmọ̀: ${a.joinValues(s.keys, ", ")}`;
          case "invalid_key":
            return `Bọtìnì aṣìṣe nínú ${s.origin}`;
          case "invalid_union":
            return "Ìbáwọlé aṣìṣe";
          case "invalid_element":
            return `Iye aṣìṣe nínú ${s.origin}`;
          default:
            return "Ìbáwọlé aṣìṣe";
        }
      };
    };
    function d() {
      return {
        localeError: o()
      };
    }
    e.exports = t.default;
  })(Ps, Ps.exports)), Ps.exports;
}
var py;
function ik() {
  return py || (py = 1, (function(e) {
    var t = ka && ka.__importDefault || function(ve) {
      return ve && ve.__esModule ? ve : { default: ve };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.yo = e.zhTW = e.zhCN = e.vi = e.uz = e.ur = e.uk = e.ua = e.tr = e.th = e.ta = e.sv = e.sl = e.ru = e.pt = e.pl = e.ps = e.ota = e.no = e.nl = e.ms = e.mk = e.lt = e.ko = e.km = e.kh = e.ka = e.ja = e.it = e.is = e.id = e.hy = e.hu = e.he = e.frCA = e.fr = e.fi = e.fa = e.es = e.eo = e.en = e.de = e.da = e.cs = e.ca = e.bg = e.be = e.az = e.ar = void 0;
    var n = aE();
    Object.defineProperty(e, "ar", { enumerable: !0, get: function() {
      return t(n).default;
    } });
    var r = sE();
    Object.defineProperty(e, "az", { enumerable: !0, get: function() {
      return t(r).default;
    } });
    var i = lE();
    Object.defineProperty(e, "be", { enumerable: !0, get: function() {
      return t(i).default;
    } });
    var a = uE();
    Object.defineProperty(e, "bg", { enumerable: !0, get: function() {
      return t(a).default;
    } });
    var o = cE();
    Object.defineProperty(e, "ca", { enumerable: !0, get: function() {
      return t(o).default;
    } });
    var d = dE();
    Object.defineProperty(e, "cs", { enumerable: !0, get: function() {
      return t(d).default;
    } });
    var u = fE();
    Object.defineProperty(e, "da", { enumerable: !0, get: function() {
      return t(u).default;
    } });
    var l = hE();
    Object.defineProperty(e, "de", { enumerable: !0, get: function() {
      return t(l).default;
    } });
    var c = tk();
    Object.defineProperty(e, "en", { enumerable: !0, get: function() {
      return t(c).default;
    } });
    var f = pE();
    Object.defineProperty(e, "eo", { enumerable: !0, get: function() {
      return t(f).default;
    } });
    var s = mE();
    Object.defineProperty(e, "es", { enumerable: !0, get: function() {
      return t(s).default;
    } });
    var h = gE();
    Object.defineProperty(e, "fa", { enumerable: !0, get: function() {
      return t(h).default;
    } });
    var p = yE();
    Object.defineProperty(e, "fi", { enumerable: !0, get: function() {
      return t(p).default;
    } });
    var m = vE();
    Object.defineProperty(e, "fr", { enumerable: !0, get: function() {
      return t(m).default;
    } });
    var y = bE();
    Object.defineProperty(e, "frCA", { enumerable: !0, get: function() {
      return t(y).default;
    } });
    var w = _E();
    Object.defineProperty(e, "he", { enumerable: !0, get: function() {
      return t(w).default;
    } });
    var b = wE();
    Object.defineProperty(e, "hu", { enumerable: !0, get: function() {
      return t(b).default;
    } });
    var _ = kE();
    Object.defineProperty(e, "hy", { enumerable: !0, get: function() {
      return t(_).default;
    } });
    var g = SE();
    Object.defineProperty(e, "id", { enumerable: !0, get: function() {
      return t(g).default;
    } });
    var O = xE();
    Object.defineProperty(e, "is", { enumerable: !0, get: function() {
      return t(O).default;
    } });
    var P = IE();
    Object.defineProperty(e, "it", { enumerable: !0, get: function() {
      return t(P).default;
    } });
    var E = PE();
    Object.defineProperty(e, "ja", { enumerable: !0, get: function() {
      return t(E).default;
    } });
    var T = OE();
    Object.defineProperty(e, "ka", { enumerable: !0, get: function() {
      return t(T).default;
    } });
    var D = zE();
    Object.defineProperty(e, "kh", { enumerable: !0, get: function() {
      return t(D).default;
    } });
    var N = nk();
    Object.defineProperty(e, "km", { enumerable: !0, get: function() {
      return t(N).default;
    } });
    var M = EE();
    Object.defineProperty(e, "ko", { enumerable: !0, get: function() {
      return t(M).default;
    } });
    var R = TE();
    Object.defineProperty(e, "lt", { enumerable: !0, get: function() {
      return t(R).default;
    } });
    var V = NE();
    Object.defineProperty(e, "mk", { enumerable: !0, get: function() {
      return t(V).default;
    } });
    var C = CE();
    Object.defineProperty(e, "ms", { enumerable: !0, get: function() {
      return t(C).default;
    } });
    var B = DE();
    Object.defineProperty(e, "nl", { enumerable: !0, get: function() {
      return t(B).default;
    } });
    var G = AE();
    Object.defineProperty(e, "no", { enumerable: !0, get: function() {
      return t(G).default;
    } });
    var Q = jE();
    Object.defineProperty(e, "ota", { enumerable: !0, get: function() {
      return t(Q).default;
    } });
    var k = ME();
    Object.defineProperty(e, "ps", { enumerable: !0, get: function() {
      return t(k).default;
    } });
    var I = $E();
    Object.defineProperty(e, "pl", { enumerable: !0, get: function() {
      return t(I).default;
    } });
    var S = RE();
    Object.defineProperty(e, "pt", { enumerable: !0, get: function() {
      return t(S).default;
    } });
    var A = ZE();
    Object.defineProperty(e, "ru", { enumerable: !0, get: function() {
      return t(A).default;
    } });
    var j = LE();
    Object.defineProperty(e, "sl", { enumerable: !0, get: function() {
      return t(j).default;
    } });
    var z = FE();
    Object.defineProperty(e, "sv", { enumerable: !0, get: function() {
      return t(z).default;
    } });
    var L = UE();
    Object.defineProperty(e, "ta", { enumerable: !0, get: function() {
      return t(L).default;
    } });
    var F = BE();
    Object.defineProperty(e, "th", { enumerable: !0, get: function() {
      return t(F).default;
    } });
    var K = VE();
    Object.defineProperty(e, "tr", { enumerable: !0, get: function() {
      return t(K).default;
    } });
    var ee = qE();
    Object.defineProperty(e, "ua", { enumerable: !0, get: function() {
      return t(ee).default;
    } });
    var U = rk();
    Object.defineProperty(e, "uk", { enumerable: !0, get: function() {
      return t(U).default;
    } });
    var q = HE();
    Object.defineProperty(e, "ur", { enumerable: !0, get: function() {
      return t(q).default;
    } });
    var ne = WE();
    Object.defineProperty(e, "uz", { enumerable: !0, get: function() {
      return t(ne).default;
    } });
    var oe = GE();
    Object.defineProperty(e, "vi", { enumerable: !0, get: function() {
      return t(oe).default;
    } });
    var Y = KE();
    Object.defineProperty(e, "zhCN", { enumerable: !0, get: function() {
      return t(Y).default;
    } });
    var re = JE();
    Object.defineProperty(e, "zhTW", { enumerable: !0, get: function() {
      return t(re).default;
    } });
    var de = XE();
    Object.defineProperty(e, "yo", { enumerable: !0, get: function() {
      return t(de).default;
    } });
  })(ka)), ka;
}
var sn = {}, my;
function rc() {
  if (my) return sn;
  my = 1;
  var e;
  Object.defineProperty(sn, "__esModule", { value: !0 }), sn.globalRegistry = sn.$ZodRegistry = sn.$input = sn.$output = void 0, sn.registry = n, sn.$output = /* @__PURE__ */ Symbol("ZodOutput"), sn.$input = /* @__PURE__ */ Symbol("ZodInput");
  class t {
    constructor() {
      this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
    }
    add(i, ...a) {
      const o = a[0];
      return this._map.set(i, o), o && typeof o == "object" && "id" in o && this._idmap.set(o.id, i), this;
    }
    clear() {
      return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
    }
    remove(i) {
      const a = this._map.get(i);
      return a && typeof a == "object" && "id" in a && this._idmap.delete(a.id), this._map.delete(i), this;
    }
    get(i) {
      const a = i._zod.parent;
      if (a) {
        const o = { ...this.get(a) ?? {} };
        delete o.id;
        const d = { ...o, ...this._map.get(i) };
        return Object.keys(d).length ? d : void 0;
      }
      return this._map.get(i);
    }
    has(i) {
      return this._map.has(i);
    }
  }
  sn.$ZodRegistry = t;
  function n() {
    return new t();
  }
  return (e = globalThis).__zod_globalRegistry ?? (e.__zod_globalRegistry = n()), sn.globalRegistry = globalThis.__zod_globalRegistry, sn;
}
var ue = {}, gy;
function YE() {
  if (gy) return ue;
  gy = 1;
  var e = ue && ue.__createBinding || (Object.create ? (function(W, J, ye, $e) {
    $e === void 0 && ($e = ye);
    var qe = Object.getOwnPropertyDescriptor(J, ye);
    (!qe || ("get" in qe ? !J.__esModule : qe.writable || qe.configurable)) && (qe = { enumerable: !0, get: function() {
      return J[ye];
    } }), Object.defineProperty(W, $e, qe);
  }) : (function(W, J, ye, $e) {
    $e === void 0 && ($e = ye), W[$e] = J[ye];
  })), t = ue && ue.__setModuleDefault || (Object.create ? (function(W, J) {
    Object.defineProperty(W, "default", { enumerable: !0, value: J });
  }) : function(W, J) {
    W.default = J;
  }), n = ue && ue.__importStar || function(W) {
    if (W && W.__esModule) return W;
    var J = {};
    if (W != null) for (var ye in W) ye !== "default" && Object.prototype.hasOwnProperty.call(W, ye) && e(J, W, ye);
    return t(J, W), J;
  };
  Object.defineProperty(ue, "__esModule", { value: !0 }), ue.TimePrecision = void 0, ue._string = d, ue._coercedString = u, ue._email = l, ue._guid = c, ue._uuid = f, ue._uuidv4 = s, ue._uuidv6 = h, ue._uuidv7 = p, ue._url = m, ue._emoji = y, ue._nanoid = w, ue._cuid = b, ue._cuid2 = _, ue._ulid = g, ue._xid = O, ue._ksuid = P, ue._ipv4 = E, ue._ipv6 = T, ue._mac = D, ue._cidrv4 = N, ue._cidrv6 = M, ue._base64 = R, ue._base64url = V, ue._e164 = C, ue._jwt = B, ue._isoDateTime = G, ue._isoDate = Q, ue._isoTime = k, ue._isoDuration = I, ue._number = S, ue._coercedNumber = A, ue._int = j, ue._float32 = z, ue._float64 = L, ue._int32 = F, ue._uint32 = K, ue._boolean = ee, ue._coercedBoolean = U, ue._bigint = q, ue._coercedBigint = ne, ue._int64 = oe, ue._uint64 = Y, ue._symbol = re, ue._undefined = de, ue._null = ve, ue._any = se, ue._unknown = pe, ue._never = ke, ue._void = Ne, ue._date = Ke, ue._coercedDate = X, ue._nan = ae, ue._lt = he, ue._lte = me, ue._max = me, ue._lte = me, ue._max = me, ue._gt = Ee, ue._gte = ie, ue._min = ie, ue._gte = ie, ue._min = ie, ue._positive = fe, ue._negative = be, ue._nonpositive = Te, ue._nonnegative = De, ue._multipleOf = It, ue._maxSize = Ft, ue._minSize = At, ue._size = hn, ue._maxLength = pn, ue._minLength = St, ue._length = Ut, ue._regex = jt, ue._lowercase = na, ue._uppercase = ra, ue._includes = Dr, ue._startsWith = fr, ue._endsWith = ui, ue._property = hr, ue._mime = ia, ue._overwrite = mn, ue._normalize = ci, ue._trim = di, ue._toLowerCase = oa, ue._toUpperCase = fi, ue._slugify = aa, ue._array = pr, ue._union = sa, ue._xor = hi, ue._discriminatedUnion = la, ue._intersection = pi, ue._tuple = ua, ue._record = mr, ue._map = ca, ue._set = da, ue._enum = Ar, ue._nativeEnum = jr, ue._literal = mi, ue._file = fa, ue._transform = ha, ue._optional = pa, ue._nullable = v, ue._default = $, ue._nonoptional = Z, ue._success = H, ue._catch = le, ue._pipe = Qe, ue._readonly = mt, ue._templateLiteral = Mc, ue._lazy = $c, ue._promise = Rc, ue._custom = Zc, ue._refine = Lc, ue._superRefine = Sl, ue._check = xl, ue.describe = Fc, ue.meta = Uc, ue._stringbool = Bc, ue._stringFormat = Vc;
  const r = n(fp()), i = n(rc()), a = n(ek()), o = n(Pe());
  // @__NO_SIDE_EFFECTS__
  function d(W, J) {
    return new W({
      type: "string",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function u(W, J) {
    return new W({
      type: "string",
      coerce: !0,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function l(W, J) {
    return new W({
      type: "string",
      format: "email",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function c(W, J) {
    return new W({
      type: "string",
      format: "guid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function f(W, J) {
    return new W({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function s(W, J) {
    return new W({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v4",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function h(W, J) {
    return new W({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v6",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function p(W, J) {
    return new W({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v7",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function m(W, J) {
    return new W({
      type: "string",
      format: "url",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function y(W, J) {
    return new W({
      type: "string",
      format: "emoji",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function w(W, J) {
    return new W({
      type: "string",
      format: "nanoid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function b(W, J) {
    return new W({
      type: "string",
      format: "cuid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function _(W, J) {
    return new W({
      type: "string",
      format: "cuid2",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function g(W, J) {
    return new W({
      type: "string",
      format: "ulid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function O(W, J) {
    return new W({
      type: "string",
      format: "xid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function P(W, J) {
    return new W({
      type: "string",
      format: "ksuid",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function E(W, J) {
    return new W({
      type: "string",
      format: "ipv4",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function T(W, J) {
    return new W({
      type: "string",
      format: "ipv6",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function D(W, J) {
    return new W({
      type: "string",
      format: "mac",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function N(W, J) {
    return new W({
      type: "string",
      format: "cidrv4",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function M(W, J) {
    return new W({
      type: "string",
      format: "cidrv6",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function R(W, J) {
    return new W({
      type: "string",
      format: "base64",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function V(W, J) {
    return new W({
      type: "string",
      format: "base64url",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function C(W, J) {
    return new W({
      type: "string",
      format: "e164",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function B(W, J) {
    return new W({
      type: "string",
      format: "jwt",
      check: "string_format",
      abort: !1,
      ...o.normalizeParams(J)
    });
  }
  ue.TimePrecision = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
  };
  // @__NO_SIDE_EFFECTS__
  function G(W, J) {
    return new W({
      type: "string",
      format: "datetime",
      check: "string_format",
      offset: !1,
      local: !1,
      precision: null,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Q(W, J) {
    return new W({
      type: "string",
      format: "date",
      check: "string_format",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function k(W, J) {
    return new W({
      type: "string",
      format: "time",
      check: "string_format",
      precision: null,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function I(W, J) {
    return new W({
      type: "string",
      format: "duration",
      check: "string_format",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function S(W, J) {
    return new W({
      type: "number",
      checks: [],
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function A(W, J) {
    return new W({
      type: "number",
      coerce: !0,
      checks: [],
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function j(W, J) {
    return new W({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "safeint",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function z(W, J) {
    return new W({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "float32",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function L(W, J) {
    return new W({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "float64",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function F(W, J) {
    return new W({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "int32",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function K(W, J) {
    return new W({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "uint32",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ee(W, J) {
    return new W({
      type: "boolean",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function U(W, J) {
    return new W({
      type: "boolean",
      coerce: !0,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function q(W, J) {
    return new W({
      type: "bigint",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ne(W, J) {
    return new W({
      type: "bigint",
      coerce: !0,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function oe(W, J) {
    return new W({
      type: "bigint",
      check: "bigint_format",
      abort: !1,
      format: "int64",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Y(W, J) {
    return new W({
      type: "bigint",
      check: "bigint_format",
      abort: !1,
      format: "uint64",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function re(W, J) {
    return new W({
      type: "symbol",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function de(W, J) {
    return new W({
      type: "undefined",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ve(W, J) {
    return new W({
      type: "null",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function se(W) {
    return new W({
      type: "any"
    });
  }
  // @__NO_SIDE_EFFECTS__
  function pe(W) {
    return new W({
      type: "unknown"
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ke(W, J) {
    return new W({
      type: "never",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Ne(W, J) {
    return new W({
      type: "void",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Ke(W, J) {
    return new W({
      type: "date",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function X(W, J) {
    return new W({
      type: "date",
      coerce: !0,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ae(W, J) {
    return new W({
      type: "nan",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function he(W, J) {
    return new r.$ZodCheckLessThan({
      check: "less_than",
      ...o.normalizeParams(J),
      value: W,
      inclusive: !1
    });
  }
  // @__NO_SIDE_EFFECTS__
  function me(W, J) {
    return new r.$ZodCheckLessThan({
      check: "less_than",
      ...o.normalizeParams(J),
      value: W,
      inclusive: !0
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Ee(W, J) {
    return new r.$ZodCheckGreaterThan({
      check: "greater_than",
      ...o.normalizeParams(J),
      value: W,
      inclusive: !1
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ie(W, J) {
    return new r.$ZodCheckGreaterThan({
      check: "greater_than",
      ...o.normalizeParams(J),
      value: W,
      inclusive: !0
    });
  }
  // @__NO_SIDE_EFFECTS__
  function fe(W) {
    return /* @__PURE__ */ Ee(0, W);
  }
  // @__NO_SIDE_EFFECTS__
  function be(W) {
    return /* @__PURE__ */ he(0, W);
  }
  // @__NO_SIDE_EFFECTS__
  function Te(W) {
    return /* @__PURE__ */ me(0, W);
  }
  // @__NO_SIDE_EFFECTS__
  function De(W) {
    return /* @__PURE__ */ ie(0, W);
  }
  // @__NO_SIDE_EFFECTS__
  function It(W, J) {
    return new r.$ZodCheckMultipleOf({
      check: "multiple_of",
      ...o.normalizeParams(J),
      value: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Ft(W, J) {
    return new r.$ZodCheckMaxSize({
      check: "max_size",
      ...o.normalizeParams(J),
      maximum: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function At(W, J) {
    return new r.$ZodCheckMinSize({
      check: "min_size",
      ...o.normalizeParams(J),
      minimum: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function hn(W, J) {
    return new r.$ZodCheckSizeEquals({
      check: "size_equals",
      ...o.normalizeParams(J),
      size: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function pn(W, J) {
    return new r.$ZodCheckMaxLength({
      check: "max_length",
      ...o.normalizeParams(J),
      maximum: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function St(W, J) {
    return new r.$ZodCheckMinLength({
      check: "min_length",
      ...o.normalizeParams(J),
      minimum: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Ut(W, J) {
    return new r.$ZodCheckLengthEquals({
      check: "length_equals",
      ...o.normalizeParams(J),
      length: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function jt(W, J) {
    return new r.$ZodCheckRegex({
      check: "string_format",
      format: "regex",
      ...o.normalizeParams(J),
      pattern: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function na(W) {
    return new r.$ZodCheckLowerCase({
      check: "string_format",
      format: "lowercase",
      ...o.normalizeParams(W)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ra(W) {
    return new r.$ZodCheckUpperCase({
      check: "string_format",
      format: "uppercase",
      ...o.normalizeParams(W)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Dr(W, J) {
    return new r.$ZodCheckIncludes({
      check: "string_format",
      format: "includes",
      ...o.normalizeParams(J),
      includes: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function fr(W, J) {
    return new r.$ZodCheckStartsWith({
      check: "string_format",
      format: "starts_with",
      ...o.normalizeParams(J),
      prefix: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ui(W, J) {
    return new r.$ZodCheckEndsWith({
      check: "string_format",
      format: "ends_with",
      ...o.normalizeParams(J),
      suffix: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function hr(W, J, ye) {
    return new r.$ZodCheckProperty({
      check: "property",
      property: W,
      schema: J,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ia(W, J) {
    return new r.$ZodCheckMimeType({
      check: "mime_type",
      mime: W,
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function mn(W) {
    return new r.$ZodCheckOverwrite({
      check: "overwrite",
      tx: W
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ci(W) {
    return /* @__PURE__ */ mn((J) => J.normalize(W));
  }
  // @__NO_SIDE_EFFECTS__
  function di() {
    return /* @__PURE__ */ mn((W) => W.trim());
  }
  // @__NO_SIDE_EFFECTS__
  function oa() {
    return /* @__PURE__ */ mn((W) => W.toLowerCase());
  }
  // @__NO_SIDE_EFFECTS__
  function fi() {
    return /* @__PURE__ */ mn((W) => W.toUpperCase());
  }
  // @__NO_SIDE_EFFECTS__
  function aa() {
    return /* @__PURE__ */ mn((W) => o.slugify(W));
  }
  // @__NO_SIDE_EFFECTS__
  function pr(W, J, ye) {
    return new W({
      type: "array",
      element: J,
      // get element() {
      //   return element;
      // },
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function sa(W, J, ye) {
    return new W({
      type: "union",
      options: J,
      ...o.normalizeParams(ye)
    });
  }
  function hi(W, J, ye) {
    return new W({
      type: "union",
      options: J,
      inclusive: !1,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function la(W, J, ye, $e) {
    return new W({
      type: "union",
      options: ye,
      discriminator: J,
      ...o.normalizeParams($e)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function pi(W, J, ye) {
    return new W({
      type: "intersection",
      left: J,
      right: ye
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ua(W, J, ye, $e) {
    const qe = ye instanceof a.$ZodType, jn = qe ? $e : ye, Mr = qe ? ye : null;
    return new W({
      type: "tuple",
      items: J,
      rest: Mr,
      ...o.normalizeParams(jn)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function mr(W, J, ye, $e) {
    return new W({
      type: "record",
      keyType: J,
      valueType: ye,
      ...o.normalizeParams($e)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ca(W, J, ye, $e) {
    return new W({
      type: "map",
      keyType: J,
      valueType: ye,
      ...o.normalizeParams($e)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function da(W, J, ye) {
    return new W({
      type: "set",
      valueType: J,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Ar(W, J, ye) {
    const $e = Array.isArray(J) ? Object.fromEntries(J.map((qe) => [qe, qe])) : J;
    return new W({
      type: "enum",
      entries: $e,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function jr(W, J, ye) {
    return new W({
      type: "enum",
      entries: J,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function mi(W, J, ye) {
    return new W({
      type: "literal",
      values: Array.isArray(J) ? J : [J],
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function fa(W, J) {
    return new W({
      type: "file",
      ...o.normalizeParams(J)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function ha(W, J) {
    return new W({
      type: "transform",
      transform: J
    });
  }
  // @__NO_SIDE_EFFECTS__
  function pa(W, J) {
    return new W({
      type: "optional",
      innerType: J
    });
  }
  // @__NO_SIDE_EFFECTS__
  function v(W, J) {
    return new W({
      type: "nullable",
      innerType: J
    });
  }
  // @__NO_SIDE_EFFECTS__
  function $(W, J, ye) {
    return new W({
      type: "default",
      innerType: J,
      get defaultValue() {
        return typeof ye == "function" ? ye() : o.shallowClone(ye);
      }
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Z(W, J, ye) {
    return new W({
      type: "nonoptional",
      innerType: J,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function H(W, J) {
    return new W({
      type: "success",
      innerType: J
    });
  }
  // @__NO_SIDE_EFFECTS__
  function le(W, J, ye) {
    return new W({
      type: "catch",
      innerType: J,
      catchValue: typeof ye == "function" ? ye : () => ye
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Qe(W, J, ye) {
    return new W({
      type: "pipe",
      in: J,
      out: ye
    });
  }
  // @__NO_SIDE_EFFECTS__
  function mt(W, J) {
    return new W({
      type: "readonly",
      innerType: J
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Mc(W, J, ye) {
    return new W({
      type: "template_literal",
      parts: J,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function $c(W, J) {
    return new W({
      type: "lazy",
      getter: J
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Rc(W, J) {
    return new W({
      type: "promise",
      innerType: J
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Zc(W, J, ye) {
    const $e = o.normalizeParams(ye);
    return $e.abort ?? ($e.abort = !0), new W({
      type: "custom",
      check: "custom",
      fn: J,
      ...$e
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Lc(W, J, ye) {
    return new W({
      type: "custom",
      check: "custom",
      fn: J,
      ...o.normalizeParams(ye)
    });
  }
  // @__NO_SIDE_EFFECTS__
  function Sl(W) {
    const J = /* @__PURE__ */ xl((ye) => (ye.addIssue = ($e) => {
      if (typeof $e == "string")
        ye.issues.push(o.issue($e, ye.value, J._zod.def));
      else {
        const qe = $e;
        qe.fatal && (qe.continue = !1), qe.code ?? (qe.code = "custom"), qe.input ?? (qe.input = ye.value), qe.inst ?? (qe.inst = J), qe.continue ?? (qe.continue = !J._zod.def.abort), ye.issues.push(o.issue(qe));
      }
    }, W(ye.value, ye)));
    return J;
  }
  // @__NO_SIDE_EFFECTS__
  function xl(W, J) {
    const ye = new r.$ZodCheck({
      check: "custom",
      ...o.normalizeParams(J)
    });
    return ye._zod.check = W, ye;
  }
  // @__NO_SIDE_EFFECTS__
  function Fc(W) {
    const J = new r.$ZodCheck({ check: "describe" });
    return J._zod.onattach = [
      (ye) => {
        const $e = i.globalRegistry.get(ye) ?? {};
        i.globalRegistry.add(ye, { ...$e, description: W });
      }
    ], J._zod.check = () => {
    }, J;
  }
  // @__NO_SIDE_EFFECTS__
  function Uc(W) {
    const J = new r.$ZodCheck({ check: "meta" });
    return J._zod.onattach = [
      (ye) => {
        const $e = i.globalRegistry.get(ye) ?? {};
        i.globalRegistry.add(ye, { ...$e, ...W });
      }
    ], J._zod.check = () => {
    }, J;
  }
  // @__NO_SIDE_EFFECTS__
  function Bc(W, J) {
    const ye = o.normalizeParams(J);
    let $e = ye.truthy ?? ["true", "1", "yes", "on", "y", "enabled"], qe = ye.falsy ?? ["false", "0", "no", "off", "n", "disabled"];
    ye.case !== "sensitive" && ($e = $e.map((gn) => typeof gn == "string" ? gn.toLowerCase() : gn), qe = qe.map((gn) => typeof gn == "string" ? gn.toLowerCase() : gn));
    const jn = new Set($e), Mr = new Set(qe), ma = W.Codec ?? a.$ZodCodec, ga = W.Boolean ?? a.$ZodBoolean, qc = W.String ?? a.$ZodString, Hc = new qc({ type: "string", error: ye.error }), Il = new ga({ type: "boolean", error: ye.error }), Wm = new ma({
      type: "pipe",
      in: Hc,
      out: Il,
      transform: ((gn, Wc) => {
        let Pl = gn;
        return ye.case !== "sensitive" && (Pl = Pl.toLowerCase()), jn.has(Pl) ? !0 : Mr.has(Pl) ? !1 : (Wc.issues.push({
          code: "invalid_value",
          expected: "stringbool",
          values: [...jn, ...Mr],
          input: Wc.value,
          inst: Wm,
          continue: !1
        }), {});
      }),
      reverseTransform: ((gn, Wc) => gn === !0 ? $e[0] || "true" : qe[0] || "false"),
      error: ye.error
    });
    return Wm;
  }
  // @__NO_SIDE_EFFECTS__
  function Vc(W, J, ye, $e = {}) {
    const qe = o.normalizeParams($e), jn = {
      ...o.normalizeParams($e),
      check: "string_format",
      type: "string",
      format: J,
      fn: typeof ye == "function" ? ye : (ma) => ye.test(ma),
      ...qe
    };
    return ye instanceof RegExp && (jn.pattern = ye), new W(jn);
  }
  return ue;
}
var ed = {}, yy;
function ic() {
  return yy || (yy = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.createStandardJSONSchemaMethod = e.createToJSONSchemaMethod = void 0, e.initializeContext = n, e.process = r, e.extractDefs = i, e.finalize = a;
    const t = rc();
    function n(l) {
      let c = l?.target ?? "draft-2020-12";
      return c === "draft-4" && (c = "draft-04"), c === "draft-7" && (c = "draft-07"), {
        processors: l.processors ?? {},
        metadataRegistry: l?.metadata ?? t.globalRegistry,
        target: c,
        unrepresentable: l?.unrepresentable ?? "throw",
        override: l?.override ?? (() => {
        }),
        io: l?.io ?? "output",
        counter: 0,
        seen: /* @__PURE__ */ new Map(),
        cycles: l?.cycles ?? "ref",
        reused: l?.reused ?? "inline",
        external: l?.external ?? void 0
      };
    }
    function r(l, c, f = { path: [], schemaPath: [] }) {
      var s;
      const h = l._zod.def, p = c.seen.get(l);
      if (p)
        return p.count++, f.schemaPath.includes(l) && (p.cycle = f.path), p.schema;
      const m = { schema: {}, count: 1, cycle: void 0, path: f.path };
      c.seen.set(l, m);
      const y = l._zod.toJSONSchema?.();
      if (y)
        m.schema = y;
      else {
        const _ = {
          ...f,
          schemaPath: [...f.schemaPath, l],
          path: f.path
        };
        if (l._zod.processJSONSchema)
          l._zod.processJSONSchema(c, m.schema, _);
        else {
          const O = m.schema, P = c.processors[h.type];
          if (!P)
            throw new Error(`[toJSONSchema]: Non-representable type encountered: ${h.type}`);
          P(l, c, O, _);
        }
        const g = l._zod.parent;
        g && (m.ref || (m.ref = g), r(g, c, _), c.seen.get(g).isParent = !0);
      }
      const w = c.metadataRegistry.get(l);
      return w && Object.assign(m.schema, w), c.io === "input" && o(l) && (delete m.schema.examples, delete m.schema.default), c.io === "input" && m.schema._prefault && ((s = m.schema).default ?? (s.default = m.schema._prefault)), delete m.schema._prefault, c.seen.get(l).schema;
    }
    function i(l, c) {
      const f = l.seen.get(c);
      if (!f)
        throw new Error("Unprocessed schema. This is a bug in Zod.");
      const s = /* @__PURE__ */ new Map();
      for (const m of l.seen.entries()) {
        const y = l.metadataRegistry.get(m[0])?.id;
        if (y) {
          const w = s.get(y);
          if (w && w !== m[0])
            throw new Error(`Duplicate schema id "${y}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
          s.set(y, m[0]);
        }
      }
      const h = (m) => {
        const y = l.target === "draft-2020-12" ? "$defs" : "definitions";
        if (l.external) {
          const g = l.external.registry.get(m[0])?.id, O = l.external.uri ?? ((E) => E);
          if (g)
            return { ref: O(g) };
          const P = m[1].defId ?? m[1].schema.id ?? `schema${l.counter++}`;
          return m[1].defId = P, { defId: P, ref: `${O("__shared")}#/${y}/${P}` };
        }
        if (m[1] === f)
          return { ref: "#" };
        const b = `#/${y}/`, _ = m[1].schema.id ?? `__schema${l.counter++}`;
        return { defId: _, ref: b + _ };
      }, p = (m) => {
        if (m[1].schema.$ref)
          return;
        const y = m[1], { ref: w, defId: b } = h(m);
        y.def = { ...y.schema }, b && (y.defId = b);
        const _ = y.schema;
        for (const g in _)
          delete _[g];
        _.$ref = w;
      };
      if (l.cycles === "throw")
        for (const m of l.seen.entries()) {
          const y = m[1];
          if (y.cycle)
            throw new Error(`Cycle detected: #/${y.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
        }
      for (const m of l.seen.entries()) {
        const y = m[1];
        if (c === m[0]) {
          p(m);
          continue;
        }
        if (l.external) {
          const b = l.external.registry.get(m[0])?.id;
          if (c !== m[0] && b) {
            p(m);
            continue;
          }
        }
        if (l.metadataRegistry.get(m[0])?.id) {
          p(m);
          continue;
        }
        if (y.cycle) {
          p(m);
          continue;
        }
        if (y.count > 1 && l.reused === "ref") {
          p(m);
          continue;
        }
      }
    }
    function a(l, c) {
      const f = l.seen.get(c);
      if (!f)
        throw new Error("Unprocessed schema. This is a bug in Zod.");
      const s = (m) => {
        const y = l.seen.get(m);
        if (y.ref === null)
          return;
        const w = y.def ?? y.schema, b = { ...w }, _ = y.ref;
        if (y.ref = null, _) {
          s(_);
          const O = l.seen.get(_), P = O.schema;
          if (P.$ref && (l.target === "draft-07" || l.target === "draft-04" || l.target === "openapi-3.0") ? (w.allOf = w.allOf ?? [], w.allOf.push(P)) : Object.assign(w, P), Object.assign(w, b), m._zod.parent === _)
            for (const T in w)
              T === "$ref" || T === "allOf" || T in b || delete w[T];
          if (P.$ref && O.def)
            for (const T in w)
              T === "$ref" || T === "allOf" || T in O.def && JSON.stringify(w[T]) === JSON.stringify(O.def[T]) && delete w[T];
        }
        const g = m._zod.parent;
        if (g && g !== _) {
          s(g);
          const O = l.seen.get(g);
          if (O?.schema.$ref && (w.$ref = O.schema.$ref, O.def))
            for (const P in w)
              P === "$ref" || P === "allOf" || P in O.def && JSON.stringify(w[P]) === JSON.stringify(O.def[P]) && delete w[P];
        }
        l.override({
          zodSchema: m,
          jsonSchema: w,
          path: y.path ?? []
        });
      };
      for (const m of [...l.seen.entries()].reverse())
        s(m[0]);
      const h = {};
      if (l.target === "draft-2020-12" ? h.$schema = "https://json-schema.org/draft/2020-12/schema" : l.target === "draft-07" ? h.$schema = "http://json-schema.org/draft-07/schema#" : l.target === "draft-04" ? h.$schema = "http://json-schema.org/draft-04/schema#" : l.target, l.external?.uri) {
        const m = l.external.registry.get(c)?.id;
        if (!m)
          throw new Error("Schema is missing an `id` property");
        h.$id = l.external.uri(m);
      }
      Object.assign(h, f.def ?? f.schema);
      const p = l.external?.defs ?? {};
      for (const m of l.seen.entries()) {
        const y = m[1];
        y.def && y.defId && (p[y.defId] = y.def);
      }
      l.external || Object.keys(p).length > 0 && (l.target === "draft-2020-12" ? h.$defs = p : h.definitions = p);
      try {
        const m = JSON.parse(JSON.stringify(h));
        return Object.defineProperty(m, "~standard", {
          value: {
            ...c["~standard"],
            jsonSchema: {
              input: (0, e.createStandardJSONSchemaMethod)(c, "input", l.processors),
              output: (0, e.createStandardJSONSchemaMethod)(c, "output", l.processors)
            }
          },
          enumerable: !1,
          writable: !1
        }), m;
      } catch {
        throw new Error("Error converting schema to JSON.");
      }
    }
    function o(l, c) {
      const f = c ?? { seen: /* @__PURE__ */ new Set() };
      if (f.seen.has(l))
        return !1;
      f.seen.add(l);
      const s = l._zod.def;
      if (s.type === "transform")
        return !0;
      if (s.type === "array")
        return o(s.element, f);
      if (s.type === "set")
        return o(s.valueType, f);
      if (s.type === "lazy")
        return o(s.getter(), f);
      if (s.type === "promise" || s.type === "optional" || s.type === "nonoptional" || s.type === "nullable" || s.type === "readonly" || s.type === "default" || s.type === "prefault")
        return o(s.innerType, f);
      if (s.type === "intersection")
        return o(s.left, f) || o(s.right, f);
      if (s.type === "record" || s.type === "map")
        return o(s.keyType, f) || o(s.valueType, f);
      if (s.type === "pipe")
        return o(s.in, f) || o(s.out, f);
      if (s.type === "object") {
        for (const h in s.shape)
          if (o(s.shape[h], f))
            return !0;
        return !1;
      }
      if (s.type === "union") {
        for (const h of s.options)
          if (o(h, f))
            return !0;
        return !1;
      }
      if (s.type === "tuple") {
        for (const h of s.items)
          if (o(h, f))
            return !0;
        return !!(s.rest && o(s.rest, f));
      }
      return !1;
    }
    const d = (l, c = {}) => (f) => {
      const s = n({ ...f, processors: c });
      return r(l, s), i(s, l), a(s, l);
    };
    e.createToJSONSchemaMethod = d;
    const u = (l, c, f = {}) => (s) => {
      const { libraryOptions: h, target: p } = s ?? {}, m = n({ ...h ?? {}, target: p, io: c, processors: f });
      return r(l, m), i(m, l), a(m, l);
    };
    e.createStandardJSONSchemaMethod = u;
  })(ed)), ed;
}
var td = {}, vy;
function oc() {
  return vy || (vy = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.allProcessors = e.lazyProcessor = e.optionalProcessor = e.promiseProcessor = e.readonlyProcessor = e.pipeProcessor = e.catchProcessor = e.prefaultProcessor = e.defaultProcessor = e.nonoptionalProcessor = e.nullableProcessor = e.recordProcessor = e.tupleProcessor = e.intersectionProcessor = e.unionProcessor = e.objectProcessor = e.arrayProcessor = e.setProcessor = e.mapProcessor = e.transformProcessor = e.functionProcessor = e.customProcessor = e.successProcessor = e.fileProcessor = e.templateLiteralProcessor = e.nanProcessor = e.literalProcessor = e.enumProcessor = e.dateProcessor = e.unknownProcessor = e.anyProcessor = e.neverProcessor = e.voidProcessor = e.undefinedProcessor = e.nullProcessor = e.symbolProcessor = e.bigintProcessor = e.booleanProcessor = e.numberProcessor = e.stringProcessor = void 0, e.toJSONSchema = ee;
    const t = ic(), n = Pe(), r = {
      guid: "uuid",
      url: "uri",
      datetime: "date-time",
      json_string: "json-string",
      regex: ""
      // do not set
    }, i = (U, q, ne, oe) => {
      const Y = ne;
      Y.type = "string";
      const { minimum: re, maximum: de, format: ve, patterns: se, contentEncoding: pe } = U._zod.bag;
      if (typeof re == "number" && (Y.minLength = re), typeof de == "number" && (Y.maxLength = de), ve && (Y.format = r[ve] ?? ve, Y.format === "" && delete Y.format, ve === "time" && delete Y.format), pe && (Y.contentEncoding = pe), se && se.size > 0) {
        const ke = [...se];
        ke.length === 1 ? Y.pattern = ke[0].source : ke.length > 1 && (Y.allOf = [
          ...ke.map((Ne) => ({
            ...q.target === "draft-07" || q.target === "draft-04" || q.target === "openapi-3.0" ? { type: "string" } : {},
            pattern: Ne.source
          }))
        ]);
      }
    };
    e.stringProcessor = i;
    const a = (U, q, ne, oe) => {
      const Y = ne, { minimum: re, maximum: de, format: ve, multipleOf: se, exclusiveMaximum: pe, exclusiveMinimum: ke } = U._zod.bag;
      typeof ve == "string" && ve.includes("int") ? Y.type = "integer" : Y.type = "number", typeof ke == "number" && (q.target === "draft-04" || q.target === "openapi-3.0" ? (Y.minimum = ke, Y.exclusiveMinimum = !0) : Y.exclusiveMinimum = ke), typeof re == "number" && (Y.minimum = re, typeof ke == "number" && q.target !== "draft-04" && (ke >= re ? delete Y.minimum : delete Y.exclusiveMinimum)), typeof pe == "number" && (q.target === "draft-04" || q.target === "openapi-3.0" ? (Y.maximum = pe, Y.exclusiveMaximum = !0) : Y.exclusiveMaximum = pe), typeof de == "number" && (Y.maximum = de, typeof pe == "number" && q.target !== "draft-04" && (pe <= de ? delete Y.maximum : delete Y.exclusiveMaximum)), typeof se == "number" && (Y.multipleOf = se);
    };
    e.numberProcessor = a;
    const o = (U, q, ne, oe) => {
      ne.type = "boolean";
    };
    e.booleanProcessor = o;
    const d = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("BigInt cannot be represented in JSON Schema");
    };
    e.bigintProcessor = d;
    const u = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Symbols cannot be represented in JSON Schema");
    };
    e.symbolProcessor = u;
    const l = (U, q, ne, oe) => {
      q.target === "openapi-3.0" ? (ne.type = "string", ne.nullable = !0, ne.enum = [null]) : ne.type = "null";
    };
    e.nullProcessor = l;
    const c = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Undefined cannot be represented in JSON Schema");
    };
    e.undefinedProcessor = c;
    const f = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Void cannot be represented in JSON Schema");
    };
    e.voidProcessor = f;
    const s = (U, q, ne, oe) => {
      ne.not = {};
    };
    e.neverProcessor = s;
    const h = (U, q, ne, oe) => {
    };
    e.anyProcessor = h;
    const p = (U, q, ne, oe) => {
    };
    e.unknownProcessor = p;
    const m = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Date cannot be represented in JSON Schema");
    };
    e.dateProcessor = m;
    const y = (U, q, ne, oe) => {
      const Y = U._zod.def, re = (0, n.getEnumValues)(Y.entries);
      re.every((de) => typeof de == "number") && (ne.type = "number"), re.every((de) => typeof de == "string") && (ne.type = "string"), ne.enum = re;
    };
    e.enumProcessor = y;
    const w = (U, q, ne, oe) => {
      const Y = U._zod.def, re = [];
      for (const de of Y.values)
        if (de === void 0) {
          if (q.unrepresentable === "throw")
            throw new Error("Literal `undefined` cannot be represented in JSON Schema");
        } else if (typeof de == "bigint") {
          if (q.unrepresentable === "throw")
            throw new Error("BigInt literals cannot be represented in JSON Schema");
          re.push(Number(de));
        } else
          re.push(de);
      if (re.length !== 0) if (re.length === 1) {
        const de = re[0];
        ne.type = de === null ? "null" : typeof de, q.target === "draft-04" || q.target === "openapi-3.0" ? ne.enum = [de] : ne.const = de;
      } else
        re.every((de) => typeof de == "number") && (ne.type = "number"), re.every((de) => typeof de == "string") && (ne.type = "string"), re.every((de) => typeof de == "boolean") && (ne.type = "boolean"), re.every((de) => de === null) && (ne.type = "null"), ne.enum = re;
    };
    e.literalProcessor = w;
    const b = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("NaN cannot be represented in JSON Schema");
    };
    e.nanProcessor = b;
    const _ = (U, q, ne, oe) => {
      const Y = ne, re = U._zod.pattern;
      if (!re)
        throw new Error("Pattern not found in template literal");
      Y.type = "string", Y.pattern = re.source;
    };
    e.templateLiteralProcessor = _;
    const g = (U, q, ne, oe) => {
      const Y = ne, re = {
        type: "string",
        format: "binary",
        contentEncoding: "binary"
      }, { minimum: de, maximum: ve, mime: se } = U._zod.bag;
      de !== void 0 && (re.minLength = de), ve !== void 0 && (re.maxLength = ve), se ? se.length === 1 ? (re.contentMediaType = se[0], Object.assign(Y, re)) : (Object.assign(Y, re), Y.anyOf = se.map((pe) => ({ contentMediaType: pe }))) : Object.assign(Y, re);
    };
    e.fileProcessor = g;
    const O = (U, q, ne, oe) => {
      ne.type = "boolean";
    };
    e.successProcessor = O;
    const P = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Custom types cannot be represented in JSON Schema");
    };
    e.customProcessor = P;
    const E = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Function types cannot be represented in JSON Schema");
    };
    e.functionProcessor = E;
    const T = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Transforms cannot be represented in JSON Schema");
    };
    e.transformProcessor = T;
    const D = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Map cannot be represented in JSON Schema");
    };
    e.mapProcessor = D;
    const N = (U, q, ne, oe) => {
      if (q.unrepresentable === "throw")
        throw new Error("Set cannot be represented in JSON Schema");
    };
    e.setProcessor = N;
    const M = (U, q, ne, oe) => {
      const Y = ne, re = U._zod.def, { minimum: de, maximum: ve } = U._zod.bag;
      typeof de == "number" && (Y.minItems = de), typeof ve == "number" && (Y.maxItems = ve), Y.type = "array", Y.items = (0, t.process)(re.element, q, { ...oe, path: [...oe.path, "items"] });
    };
    e.arrayProcessor = M;
    const R = (U, q, ne, oe) => {
      const Y = ne, re = U._zod.def;
      Y.type = "object", Y.properties = {};
      const de = re.shape;
      for (const pe in de)
        Y.properties[pe] = (0, t.process)(de[pe], q, {
          ...oe,
          path: [...oe.path, "properties", pe]
        });
      const ve = new Set(Object.keys(de)), se = new Set([...ve].filter((pe) => {
        const ke = re.shape[pe]._zod;
        return q.io === "input" ? ke.optin === void 0 : ke.optout === void 0;
      }));
      se.size > 0 && (Y.required = Array.from(se)), re.catchall?._zod.def.type === "never" ? Y.additionalProperties = !1 : re.catchall ? re.catchall && (Y.additionalProperties = (0, t.process)(re.catchall, q, {
        ...oe,
        path: [...oe.path, "additionalProperties"]
      })) : q.io === "output" && (Y.additionalProperties = !1);
    };
    e.objectProcessor = R;
    const V = (U, q, ne, oe) => {
      const Y = U._zod.def, re = Y.inclusive === !1, de = Y.options.map((ve, se) => (0, t.process)(ve, q, {
        ...oe,
        path: [...oe.path, re ? "oneOf" : "anyOf", se]
      }));
      re ? ne.oneOf = de : ne.anyOf = de;
    };
    e.unionProcessor = V;
    const C = (U, q, ne, oe) => {
      const Y = U._zod.def, re = (0, t.process)(Y.left, q, {
        ...oe,
        path: [...oe.path, "allOf", 0]
      }), de = (0, t.process)(Y.right, q, {
        ...oe,
        path: [...oe.path, "allOf", 1]
      }), ve = (pe) => "allOf" in pe && Object.keys(pe).length === 1, se = [
        ...ve(re) ? re.allOf : [re],
        ...ve(de) ? de.allOf : [de]
      ];
      ne.allOf = se;
    };
    e.intersectionProcessor = C;
    const B = (U, q, ne, oe) => {
      const Y = ne, re = U._zod.def;
      Y.type = "array";
      const de = q.target === "draft-2020-12" ? "prefixItems" : "items", ve = q.target === "draft-2020-12" || q.target === "openapi-3.0" ? "items" : "additionalItems", se = re.items.map((Ke, X) => (0, t.process)(Ke, q, {
        ...oe,
        path: [...oe.path, de, X]
      })), pe = re.rest ? (0, t.process)(re.rest, q, {
        ...oe,
        path: [...oe.path, ve, ...q.target === "openapi-3.0" ? [re.items.length] : []]
      }) : null;
      q.target === "draft-2020-12" ? (Y.prefixItems = se, pe && (Y.items = pe)) : q.target === "openapi-3.0" ? (Y.items = {
        anyOf: se
      }, pe && Y.items.anyOf.push(pe), Y.minItems = se.length, pe || (Y.maxItems = se.length)) : (Y.items = se, pe && (Y.additionalItems = pe));
      const { minimum: ke, maximum: Ne } = U._zod.bag;
      typeof ke == "number" && (Y.minItems = ke), typeof Ne == "number" && (Y.maxItems = Ne);
    };
    e.tupleProcessor = B;
    const G = (U, q, ne, oe) => {
      const Y = ne, re = U._zod.def;
      Y.type = "object";
      const de = re.keyType, se = de._zod.bag?.patterns;
      if (re.mode === "loose" && se && se.size > 0) {
        const ke = (0, t.process)(re.valueType, q, {
          ...oe,
          path: [...oe.path, "patternProperties", "*"]
        });
        Y.patternProperties = {};
        for (const Ne of se)
          Y.patternProperties[Ne.source] = ke;
      } else
        (q.target === "draft-07" || q.target === "draft-2020-12") && (Y.propertyNames = (0, t.process)(re.keyType, q, {
          ...oe,
          path: [...oe.path, "propertyNames"]
        })), Y.additionalProperties = (0, t.process)(re.valueType, q, {
          ...oe,
          path: [...oe.path, "additionalProperties"]
        });
      const pe = de._zod.values;
      if (pe) {
        const ke = [...pe].filter((Ne) => typeof Ne == "string" || typeof Ne == "number");
        ke.length > 0 && (Y.required = ke);
      }
    };
    e.recordProcessor = G;
    const Q = (U, q, ne, oe) => {
      const Y = U._zod.def, re = (0, t.process)(Y.innerType, q, oe), de = q.seen.get(U);
      q.target === "openapi-3.0" ? (de.ref = Y.innerType, ne.nullable = !0) : ne.anyOf = [re, { type: "null" }];
    };
    e.nullableProcessor = Q;
    const k = (U, q, ne, oe) => {
      const Y = U._zod.def;
      (0, t.process)(Y.innerType, q, oe);
      const re = q.seen.get(U);
      re.ref = Y.innerType;
    };
    e.nonoptionalProcessor = k;
    const I = (U, q, ne, oe) => {
      const Y = U._zod.def;
      (0, t.process)(Y.innerType, q, oe);
      const re = q.seen.get(U);
      re.ref = Y.innerType, ne.default = JSON.parse(JSON.stringify(Y.defaultValue));
    };
    e.defaultProcessor = I;
    const S = (U, q, ne, oe) => {
      const Y = U._zod.def;
      (0, t.process)(Y.innerType, q, oe);
      const re = q.seen.get(U);
      re.ref = Y.innerType, q.io === "input" && (ne._prefault = JSON.parse(JSON.stringify(Y.defaultValue)));
    };
    e.prefaultProcessor = S;
    const A = (U, q, ne, oe) => {
      const Y = U._zod.def;
      (0, t.process)(Y.innerType, q, oe);
      const re = q.seen.get(U);
      re.ref = Y.innerType;
      let de;
      try {
        de = Y.catchValue(void 0);
      } catch {
        throw new Error("Dynamic catch values are not supported in JSON Schema");
      }
      ne.default = de;
    };
    e.catchProcessor = A;
    const j = (U, q, ne, oe) => {
      const Y = U._zod.def, re = q.io === "input" ? Y.in._zod.def.type === "transform" ? Y.out : Y.in : Y.out;
      (0, t.process)(re, q, oe);
      const de = q.seen.get(U);
      de.ref = re;
    };
    e.pipeProcessor = j;
    const z = (U, q, ne, oe) => {
      const Y = U._zod.def;
      (0, t.process)(Y.innerType, q, oe);
      const re = q.seen.get(U);
      re.ref = Y.innerType, ne.readOnly = !0;
    };
    e.readonlyProcessor = z;
    const L = (U, q, ne, oe) => {
      const Y = U._zod.def;
      (0, t.process)(Y.innerType, q, oe);
      const re = q.seen.get(U);
      re.ref = Y.innerType;
    };
    e.promiseProcessor = L;
    const F = (U, q, ne, oe) => {
      const Y = U._zod.def;
      (0, t.process)(Y.innerType, q, oe);
      const re = q.seen.get(U);
      re.ref = Y.innerType;
    };
    e.optionalProcessor = F;
    const K = (U, q, ne, oe) => {
      const Y = U._zod.innerType;
      (0, t.process)(Y, q, oe);
      const re = q.seen.get(U);
      re.ref = Y;
    };
    e.lazyProcessor = K, e.allProcessors = {
      string: e.stringProcessor,
      number: e.numberProcessor,
      boolean: e.booleanProcessor,
      bigint: e.bigintProcessor,
      symbol: e.symbolProcessor,
      null: e.nullProcessor,
      undefined: e.undefinedProcessor,
      void: e.voidProcessor,
      never: e.neverProcessor,
      any: e.anyProcessor,
      unknown: e.unknownProcessor,
      date: e.dateProcessor,
      enum: e.enumProcessor,
      literal: e.literalProcessor,
      nan: e.nanProcessor,
      template_literal: e.templateLiteralProcessor,
      file: e.fileProcessor,
      success: e.successProcessor,
      custom: e.customProcessor,
      function: e.functionProcessor,
      transform: e.transformProcessor,
      map: e.mapProcessor,
      set: e.setProcessor,
      array: e.arrayProcessor,
      object: e.objectProcessor,
      union: e.unionProcessor,
      intersection: e.intersectionProcessor,
      tuple: e.tupleProcessor,
      record: e.recordProcessor,
      nullable: e.nullableProcessor,
      nonoptional: e.nonoptionalProcessor,
      default: e.defaultProcessor,
      prefault: e.prefaultProcessor,
      catch: e.catchProcessor,
      pipe: e.pipeProcessor,
      readonly: e.readonlyProcessor,
      promise: e.promiseProcessor,
      optional: e.optionalProcessor,
      lazy: e.lazyProcessor
    };
    function ee(U, q) {
      if ("_idmap" in U) {
        const oe = U, Y = (0, t.initializeContext)({ ...q, processors: e.allProcessors }), re = {};
        for (const se of oe._idmap.entries()) {
          const [pe, ke] = se;
          (0, t.process)(ke, Y);
        }
        const de = {}, ve = {
          registry: oe,
          uri: q?.uri,
          defs: re
        };
        Y.external = ve;
        for (const se of oe._idmap.entries()) {
          const [pe, ke] = se;
          (0, t.extractDefs)(Y, ke), de[pe] = (0, t.finalize)(Y, ke);
        }
        if (Object.keys(re).length > 0) {
          const se = Y.target === "draft-2020-12" ? "$defs" : "definitions";
          de.__shared = {
            [se]: re
          };
        }
        return { schemas: de };
      }
      const ne = (0, t.initializeContext)({ ...q, processors: e.allProcessors });
      return (0, t.process)(U, ne), (0, t.extractDefs)(ne, U), (0, t.finalize)(ne, U);
    }
  })(td)), td;
}
var Sa = {}, by;
function QE() {
  if (by) return Sa;
  by = 1, Object.defineProperty(Sa, "__esModule", { value: !0 }), Sa.JSONSchemaGenerator = void 0;
  const e = oc(), t = ic();
  class n {
    /** @deprecated Access via ctx instead */
    get metadataRegistry() {
      return this.ctx.metadataRegistry;
    }
    /** @deprecated Access via ctx instead */
    get target() {
      return this.ctx.target;
    }
    /** @deprecated Access via ctx instead */
    get unrepresentable() {
      return this.ctx.unrepresentable;
    }
    /** @deprecated Access via ctx instead */
    get override() {
      return this.ctx.override;
    }
    /** @deprecated Access via ctx instead */
    get io() {
      return this.ctx.io;
    }
    /** @deprecated Access via ctx instead */
    get counter() {
      return this.ctx.counter;
    }
    set counter(i) {
      this.ctx.counter = i;
    }
    /** @deprecated Access via ctx instead */
    get seen() {
      return this.ctx.seen;
    }
    constructor(i) {
      let a = i?.target ?? "draft-2020-12";
      a === "draft-4" && (a = "draft-04"), a === "draft-7" && (a = "draft-07"), this.ctx = (0, t.initializeContext)({
        processors: e.allProcessors,
        target: a,
        ...i?.metadata && { metadata: i.metadata },
        ...i?.unrepresentable && { unrepresentable: i.unrepresentable },
        ...i?.override && { override: i.override },
        ...i?.io && { io: i.io }
      });
    }
    /**
     * Process a schema to prepare it for JSON Schema generation.
     * This must be called before emit().
     */
    process(i, a = { path: [], schemaPath: [] }) {
      return (0, t.process)(i, this.ctx, a);
    }
    /**
     * Emit the final JSON Schema after processing.
     * Must call process() first.
     */
    emit(i, a) {
      a && (a.cycles && (this.ctx.cycles = a.cycles), a.reused && (this.ctx.reused = a.reused), a.external && (this.ctx.external = a.external)), (0, t.extractDefs)(this.ctx, i);
      const o = (0, t.finalize)(this.ctx, i), { "~standard": d, ...u } = o;
      return u;
    }
  }
  return Sa.JSONSchemaGenerator = n, Sa;
}
var nd = {}, _y;
function eT() {
  return _y || (_y = 1, Object.defineProperty(nd, "__esModule", { value: !0 })), nd;
}
var wy;
function nn() {
  return wy || (wy = 1, (function(e) {
    var t = bn && bn.__createBinding || (Object.create ? (function(d, u, l, c) {
      c === void 0 && (c = l);
      var f = Object.getOwnPropertyDescriptor(u, l);
      (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
        return u[l];
      } }), Object.defineProperty(d, c, f);
    }) : (function(d, u, l, c) {
      c === void 0 && (c = l), d[c] = u[l];
    })), n = bn && bn.__setModuleDefault || (Object.create ? (function(d, u) {
      Object.defineProperty(d, "default", { enumerable: !0, value: u });
    }) : function(d, u) {
      d.default = u;
    }), r = bn && bn.__exportStar || function(d, u) {
      for (var l in d) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && t(u, d, l);
    }, i = bn && bn.__importStar || function(d) {
      if (d && d.__esModule) return d;
      var u = {};
      if (d != null) for (var l in d) l !== "default" && Object.prototype.hasOwnProperty.call(d, l) && t(u, d, l);
      return n(u, d), u;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.JSONSchema = e.JSONSchemaGenerator = e.toJSONSchema = e.locales = e.regexes = e.util = void 0, r(al(), e), r(X0(), e), r(J0(), e), r(ek(), e), r(fp(), e), r(Q0(), e), e.util = i(Pe()), e.regexes = i(dp()), e.locales = i(ik()), r(rc(), e), r(Y0(), e), r(YE(), e), r(ic(), e);
    var a = oc();
    Object.defineProperty(e, "toJSONSchema", { enumerable: !0, get: function() {
      return a.toJSONSchema;
    } });
    var o = QE();
    Object.defineProperty(e, "JSONSchemaGenerator", { enumerable: !0, get: function() {
      return o.JSONSchemaGenerator;
    } }), e.JSONSchema = i(eT());
  })(bn)), bn;
}
var Qn = {}, rd = {}, ky;
function hp() {
  return ky || (ky = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.slugify = e.toUpperCase = e.toLowerCase = e.trim = e.normalize = e.overwrite = e.mime = e.property = e.endsWith = e.startsWith = e.includes = e.uppercase = e.lowercase = e.regex = e.length = e.minLength = e.maxLength = e.size = e.minSize = e.maxSize = e.multipleOf = e.nonnegative = e.nonpositive = e.negative = e.positive = e.gte = e.gt = e.lte = e.lt = void 0;
    var t = nn();
    Object.defineProperty(e, "lt", { enumerable: !0, get: function() {
      return t._lt;
    } }), Object.defineProperty(e, "lte", { enumerable: !0, get: function() {
      return t._lte;
    } }), Object.defineProperty(e, "gt", { enumerable: !0, get: function() {
      return t._gt;
    } }), Object.defineProperty(e, "gte", { enumerable: !0, get: function() {
      return t._gte;
    } }), Object.defineProperty(e, "positive", { enumerable: !0, get: function() {
      return t._positive;
    } }), Object.defineProperty(e, "negative", { enumerable: !0, get: function() {
      return t._negative;
    } }), Object.defineProperty(e, "nonpositive", { enumerable: !0, get: function() {
      return t._nonpositive;
    } }), Object.defineProperty(e, "nonnegative", { enumerable: !0, get: function() {
      return t._nonnegative;
    } }), Object.defineProperty(e, "multipleOf", { enumerable: !0, get: function() {
      return t._multipleOf;
    } }), Object.defineProperty(e, "maxSize", { enumerable: !0, get: function() {
      return t._maxSize;
    } }), Object.defineProperty(e, "minSize", { enumerable: !0, get: function() {
      return t._minSize;
    } }), Object.defineProperty(e, "size", { enumerable: !0, get: function() {
      return t._size;
    } }), Object.defineProperty(e, "maxLength", { enumerable: !0, get: function() {
      return t._maxLength;
    } }), Object.defineProperty(e, "minLength", { enumerable: !0, get: function() {
      return t._minLength;
    } }), Object.defineProperty(e, "length", { enumerable: !0, get: function() {
      return t._length;
    } }), Object.defineProperty(e, "regex", { enumerable: !0, get: function() {
      return t._regex;
    } }), Object.defineProperty(e, "lowercase", { enumerable: !0, get: function() {
      return t._lowercase;
    } }), Object.defineProperty(e, "uppercase", { enumerable: !0, get: function() {
      return t._uppercase;
    } }), Object.defineProperty(e, "includes", { enumerable: !0, get: function() {
      return t._includes;
    } }), Object.defineProperty(e, "startsWith", { enumerable: !0, get: function() {
      return t._startsWith;
    } }), Object.defineProperty(e, "endsWith", { enumerable: !0, get: function() {
      return t._endsWith;
    } }), Object.defineProperty(e, "property", { enumerable: !0, get: function() {
      return t._property;
    } }), Object.defineProperty(e, "mime", { enumerable: !0, get: function() {
      return t._mime;
    } }), Object.defineProperty(e, "overwrite", { enumerable: !0, get: function() {
      return t._overwrite;
    } }), Object.defineProperty(e, "normalize", { enumerable: !0, get: function() {
      return t._normalize;
    } }), Object.defineProperty(e, "trim", { enumerable: !0, get: function() {
      return t._trim;
    } }), Object.defineProperty(e, "toLowerCase", { enumerable: !0, get: function() {
      return t._toLowerCase;
    } }), Object.defineProperty(e, "toUpperCase", { enumerable: !0, get: function() {
      return t._toUpperCase;
    } }), Object.defineProperty(e, "slugify", { enumerable: !0, get: function() {
      return t._slugify;
    } });
  })(rd)), rd;
}
var er = {}, Sy;
function vu() {
  return Sy || (Sy = 1, (function(e) {
    var t = er && er.__createBinding || (Object.create ? (function(c, f, s, h) {
      h === void 0 && (h = s);
      var p = Object.getOwnPropertyDescriptor(f, s);
      (!p || ("get" in p ? !f.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return f[s];
      } }), Object.defineProperty(c, h, p);
    }) : (function(c, f, s, h) {
      h === void 0 && (h = s), c[h] = f[s];
    })), n = er && er.__setModuleDefault || (Object.create ? (function(c, f) {
      Object.defineProperty(c, "default", { enumerable: !0, value: f });
    }) : function(c, f) {
      c.default = f;
    }), r = er && er.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var f = {};
      if (c != null) for (var s in c) s !== "default" && Object.prototype.hasOwnProperty.call(c, s) && t(f, c, s);
      return n(f, c), f;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodISODuration = e.ZodISOTime = e.ZodISODate = e.ZodISODateTime = void 0, e.datetime = o, e.date = d, e.time = u, e.duration = l;
    const i = r(nn()), a = r(ac());
    e.ZodISODateTime = i.$constructor("ZodISODateTime", (c, f) => {
      i.$ZodISODateTime.init(c, f), a.ZodStringFormat.init(c, f);
    });
    function o(c) {
      return i._isoDateTime(e.ZodISODateTime, c);
    }
    e.ZodISODate = i.$constructor("ZodISODate", (c, f) => {
      i.$ZodISODate.init(c, f), a.ZodStringFormat.init(c, f);
    });
    function d(c) {
      return i._isoDate(e.ZodISODate, c);
    }
    e.ZodISOTime = i.$constructor("ZodISOTime", (c, f) => {
      i.$ZodISOTime.init(c, f), a.ZodStringFormat.init(c, f);
    });
    function u(c) {
      return i._isoTime(e.ZodISOTime, c);
    }
    e.ZodISODuration = i.$constructor("ZodISODuration", (c, f) => {
      i.$ZodISODuration.init(c, f), a.ZodStringFormat.init(c, f);
    });
    function l(c) {
      return i._isoDuration(e.ZodISODuration, c);
    }
  })(er)), er;
}
var We = {}, Xt = {}, xy;
function ok() {
  if (xy) return Xt;
  xy = 1;
  var e = Xt && Xt.__createBinding || (Object.create ? (function(d, u, l, c) {
    c === void 0 && (c = l);
    var f = Object.getOwnPropertyDescriptor(u, l);
    (!f || ("get" in f ? !u.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return u[l];
    } }), Object.defineProperty(d, c, f);
  }) : (function(d, u, l, c) {
    c === void 0 && (c = l), d[c] = u[l];
  })), t = Xt && Xt.__setModuleDefault || (Object.create ? (function(d, u) {
    Object.defineProperty(d, "default", { enumerable: !0, value: u });
  }) : function(d, u) {
    d.default = u;
  }), n = Xt && Xt.__importStar || function(d) {
    if (d && d.__esModule) return d;
    var u = {};
    if (d != null) for (var l in d) l !== "default" && Object.prototype.hasOwnProperty.call(d, l) && e(u, d, l);
    return t(u, d), u;
  };
  Object.defineProperty(Xt, "__esModule", { value: !0 }), Xt.ZodRealError = Xt.ZodError = void 0;
  const r = n(nn()), i = nn(), a = n(Pe()), o = (d, u) => {
    i.$ZodError.init(d, u), d.name = "ZodError", Object.defineProperties(d, {
      format: {
        value: (l) => r.formatError(d, l)
        // enumerable: false,
      },
      flatten: {
        value: (l) => r.flattenError(d, l)
        // enumerable: false,
      },
      addIssue: {
        value: (l) => {
          d.issues.push(l), d.message = JSON.stringify(d.issues, a.jsonStringifyReplacer, 2);
        }
        // enumerable: false,
      },
      addIssues: {
        value: (l) => {
          d.issues.push(...l), d.message = JSON.stringify(d.issues, a.jsonStringifyReplacer, 2);
        }
        // enumerable: false,
      },
      isEmpty: {
        get() {
          return d.issues.length === 0;
        }
        // enumerable: false,
      }
    });
  };
  return Xt.ZodError = r.$constructor("ZodError", o), Xt.ZodRealError = r.$constructor("ZodError", o, {
    Parent: Error
  }), Xt;
}
var Iy;
function ak() {
  if (Iy) return We;
  Iy = 1;
  var e = We && We.__createBinding || (Object.create ? (function(a, o, d, u) {
    u === void 0 && (u = d);
    var l = Object.getOwnPropertyDescriptor(o, d);
    (!l || ("get" in l ? !o.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
      return o[d];
    } }), Object.defineProperty(a, u, l);
  }) : (function(a, o, d, u) {
    u === void 0 && (u = d), a[u] = o[d];
  })), t = We && We.__setModuleDefault || (Object.create ? (function(a, o) {
    Object.defineProperty(a, "default", { enumerable: !0, value: o });
  }) : function(a, o) {
    a.default = o;
  }), n = We && We.__importStar || function(a) {
    if (a && a.__esModule) return a;
    var o = {};
    if (a != null) for (var d in a) d !== "default" && Object.prototype.hasOwnProperty.call(a, d) && e(o, a, d);
    return t(o, a), o;
  };
  Object.defineProperty(We, "__esModule", { value: !0 }), We.safeDecodeAsync = We.safeEncodeAsync = We.safeDecode = We.safeEncode = We.decodeAsync = We.encodeAsync = We.decode = We.encode = We.safeParseAsync = We.safeParse = We.parseAsync = We.parse = void 0;
  const r = n(nn()), i = ok();
  return We.parse = r._parse(i.ZodRealError), We.parseAsync = r._parseAsync(i.ZodRealError), We.safeParse = r._safeParse(i.ZodRealError), We.safeParseAsync = r._safeParseAsync(i.ZodRealError), We.encode = r._encode(i.ZodRealError), We.decode = r._decode(i.ZodRealError), We.encodeAsync = r._encodeAsync(i.ZodRealError), We.decodeAsync = r._decodeAsync(i.ZodRealError), We.safeEncode = r._safeEncode(i.ZodRealError), We.safeDecode = r._safeDecode(i.ZodRealError), We.safeEncodeAsync = r._safeEncodeAsync(i.ZodRealError), We.safeDecodeAsync = r._safeDecodeAsync(i.ZodRealError), We;
}
var Py;
function ac() {
  return Py || (Py = 1, (function(e) {
    var t = Qn && Qn.__createBinding || (Object.create ? (function(v, $, Z, H) {
      H === void 0 && (H = Z);
      var le = Object.getOwnPropertyDescriptor($, Z);
      (!le || ("get" in le ? !$.__esModule : le.writable || le.configurable)) && (le = { enumerable: !0, get: function() {
        return $[Z];
      } }), Object.defineProperty(v, H, le);
    }) : (function(v, $, Z, H) {
      H === void 0 && (H = Z), v[H] = $[Z];
    })), n = Qn && Qn.__setModuleDefault || (Object.create ? (function(v, $) {
      Object.defineProperty(v, "default", { enumerable: !0, value: $ });
    }) : function(v, $) {
      v.default = $;
    }), r = Qn && Qn.__importStar || function(v) {
      if (v && v.__esModule) return v;
      var $ = {};
      if (v != null) for (var Z in v) Z !== "default" && Object.prototype.hasOwnProperty.call(v, Z) && t($, v, Z);
      return n($, v), $;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodLiteral = e.ZodEnum = e.ZodSet = e.ZodMap = e.ZodRecord = e.ZodTuple = e.ZodIntersection = e.ZodDiscriminatedUnion = e.ZodXor = e.ZodUnion = e.ZodObject = e.ZodArray = e.ZodDate = e.ZodVoid = e.ZodNever = e.ZodUnknown = e.ZodAny = e.ZodNull = e.ZodUndefined = e.ZodSymbol = e.ZodBigIntFormat = e.ZodBigInt = e.ZodBoolean = e.ZodNumberFormat = e.ZodNumber = e.ZodCustomStringFormat = e.ZodJWT = e.ZodE164 = e.ZodBase64URL = e.ZodBase64 = e.ZodCIDRv6 = e.ZodCIDRv4 = e.ZodIPv6 = e.ZodMAC = e.ZodIPv4 = e.ZodKSUID = e.ZodXID = e.ZodULID = e.ZodCUID2 = e.ZodCUID = e.ZodNanoID = e.ZodEmoji = e.ZodURL = e.ZodUUID = e.ZodGUID = e.ZodEmail = e.ZodStringFormat = e.ZodString = e._ZodString = e.ZodType = void 0, e.stringbool = e.meta = e.describe = e.ZodCustom = e.ZodFunction = e.ZodPromise = e.ZodLazy = e.ZodTemplateLiteral = e.ZodReadonly = e.ZodCodec = e.ZodPipe = e.ZodNaN = e.ZodCatch = e.ZodSuccess = e.ZodNonOptional = e.ZodPrefault = e.ZodDefault = e.ZodNullable = e.ZodExactOptional = e.ZodOptional = e.ZodTransform = e.ZodFile = void 0, e.string = f, e.email = s, e.guid = h, e.uuid = p, e.uuidv4 = m, e.uuidv6 = y, e.uuidv7 = w, e.url = b, e.httpUrl = _, e.emoji = g, e.nanoid = O, e.cuid = P, e.cuid2 = E, e.ulid = T, e.xid = D, e.ksuid = N, e.ipv4 = M, e.mac = R, e.ipv6 = V, e.cidrv4 = C, e.cidrv6 = B, e.base64 = G, e.base64url = Q, e.e164 = k, e.jwt = I, e.stringFormat = S, e.hostname = A, e.hex = j, e.hash = z, e.number = L, e.int = F, e.float32 = K, e.float64 = ee, e.int32 = U, e.uint32 = q, e.boolean = ne, e.bigint = oe, e.int64 = Y, e.uint64 = re, e.symbol = de, e.undefined = ve, e.null = se, e.any = pe, e.unknown = ke, e.never = Ne, e.void = Ke, e.date = X, e.array = ae, e.keyof = he, e.object = me, e.strictObject = Ee, e.looseObject = ie, e.union = fe, e.xor = be, e.discriminatedUnion = Te, e.intersection = De, e.tuple = It, e.record = Ft, e.partialRecord = At, e.looseRecord = hn, e.map = pn, e.set = St, e.enum = Ut, e.nativeEnum = jt, e.literal = na, e.file = ra, e.transform = Dr, e.optional = fr, e.exactOptional = ui, e.nullable = hr, e.nullish = ia, e._default = mn, e.prefault = ci, e.nonoptional = di, e.success = oa, e.catch = fi, e.nan = aa, e.pipe = pr, e.codec = sa, e.readonly = hi, e.templateLiteral = la, e.lazy = pi, e.promise = ua, e._function = mr, e.function = mr, e._function = mr, e.function = mr, e.check = ca, e.custom = da, e.refine = Ar, e.superRefine = jr, e.instanceof = mi, e.json = ha, e.preprocess = pa;
    const i = r(nn()), a = nn(), o = r(oc()), d = ic(), u = r(hp()), l = r(vu()), c = r(ak());
    e.ZodType = i.$constructor("ZodType", (v, $) => (i.$ZodType.init(v, $), Object.assign(v["~standard"], {
      jsonSchema: {
        input: (0, d.createStandardJSONSchemaMethod)(v, "input"),
        output: (0, d.createStandardJSONSchemaMethod)(v, "output")
      }
    }), v.toJSONSchema = (0, d.createToJSONSchemaMethod)(v, {}), v.def = $, v.type = $.type, Object.defineProperty(v, "_def", { value: $ }), v.check = (...Z) => v.clone(a.util.mergeDefs($, {
      checks: [
        ...$.checks ?? [],
        ...Z.map((H) => typeof H == "function" ? { _zod: { check: H, def: { check: "custom" }, onattach: [] } } : H)
      ]
    }), {
      parent: !0
    }), v.with = v.check, v.clone = (Z, H) => i.clone(v, Z, H), v.brand = () => v, v.register = ((Z, H) => (Z.add(v, H), v)), v.parse = (Z, H) => c.parse(v, Z, H, { callee: v.parse }), v.safeParse = (Z, H) => c.safeParse(v, Z, H), v.parseAsync = async (Z, H) => c.parseAsync(v, Z, H, { callee: v.parseAsync }), v.safeParseAsync = async (Z, H) => c.safeParseAsync(v, Z, H), v.spa = v.safeParseAsync, v.encode = (Z, H) => c.encode(v, Z, H), v.decode = (Z, H) => c.decode(v, Z, H), v.encodeAsync = async (Z, H) => c.encodeAsync(v, Z, H), v.decodeAsync = async (Z, H) => c.decodeAsync(v, Z, H), v.safeEncode = (Z, H) => c.safeEncode(v, Z, H), v.safeDecode = (Z, H) => c.safeDecode(v, Z, H), v.safeEncodeAsync = async (Z, H) => c.safeEncodeAsync(v, Z, H), v.safeDecodeAsync = async (Z, H) => c.safeDecodeAsync(v, Z, H), v.refine = (Z, H) => v.check(Ar(Z, H)), v.superRefine = (Z) => v.check(jr(Z)), v.overwrite = (Z) => v.check(u.overwrite(Z)), v.optional = () => fr(v), v.exactOptional = () => ui(v), v.nullable = () => hr(v), v.nullish = () => fr(hr(v)), v.nonoptional = (Z) => di(v, Z), v.array = () => ae(v), v.or = (Z) => fe([v, Z]), v.and = (Z) => De(v, Z), v.transform = (Z) => pr(v, Dr(Z)), v.default = (Z) => mn(v, Z), v.prefault = (Z) => ci(v, Z), v.catch = (Z) => fi(v, Z), v.pipe = (Z) => pr(v, Z), v.readonly = () => hi(v), v.describe = (Z) => {
      const H = v.clone();
      return i.globalRegistry.add(H, { description: Z }), H;
    }, Object.defineProperty(v, "description", {
      get() {
        return i.globalRegistry.get(v)?.description;
      },
      configurable: !0
    }), v.meta = (...Z) => {
      if (Z.length === 0)
        return i.globalRegistry.get(v);
      const H = v.clone();
      return i.globalRegistry.add(H, Z[0]), H;
    }, v.isOptional = () => v.safeParse(void 0).success, v.isNullable = () => v.safeParse(null).success, v.apply = (Z) => Z(v), v)), e._ZodString = i.$constructor("_ZodString", (v, $) => {
      i.$ZodString.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (H, le, Qe) => o.stringProcessor(v, H, le, Qe);
      const Z = v._zod.bag;
      v.format = Z.format ?? null, v.minLength = Z.minimum ?? null, v.maxLength = Z.maximum ?? null, v.regex = (...H) => v.check(u.regex(...H)), v.includes = (...H) => v.check(u.includes(...H)), v.startsWith = (...H) => v.check(u.startsWith(...H)), v.endsWith = (...H) => v.check(u.endsWith(...H)), v.min = (...H) => v.check(u.minLength(...H)), v.max = (...H) => v.check(u.maxLength(...H)), v.length = (...H) => v.check(u.length(...H)), v.nonempty = (...H) => v.check(u.minLength(1, ...H)), v.lowercase = (H) => v.check(u.lowercase(H)), v.uppercase = (H) => v.check(u.uppercase(H)), v.trim = () => v.check(u.trim()), v.normalize = (...H) => v.check(u.normalize(...H)), v.toLowerCase = () => v.check(u.toLowerCase()), v.toUpperCase = () => v.check(u.toUpperCase()), v.slugify = () => v.check(u.slugify());
    }), e.ZodString = i.$constructor("ZodString", (v, $) => {
      i.$ZodString.init(v, $), e._ZodString.init(v, $), v.email = (Z) => v.check(i._email(e.ZodEmail, Z)), v.url = (Z) => v.check(i._url(e.ZodURL, Z)), v.jwt = (Z) => v.check(i._jwt(e.ZodJWT, Z)), v.emoji = (Z) => v.check(i._emoji(e.ZodEmoji, Z)), v.guid = (Z) => v.check(i._guid(e.ZodGUID, Z)), v.uuid = (Z) => v.check(i._uuid(e.ZodUUID, Z)), v.uuidv4 = (Z) => v.check(i._uuidv4(e.ZodUUID, Z)), v.uuidv6 = (Z) => v.check(i._uuidv6(e.ZodUUID, Z)), v.uuidv7 = (Z) => v.check(i._uuidv7(e.ZodUUID, Z)), v.nanoid = (Z) => v.check(i._nanoid(e.ZodNanoID, Z)), v.guid = (Z) => v.check(i._guid(e.ZodGUID, Z)), v.cuid = (Z) => v.check(i._cuid(e.ZodCUID, Z)), v.cuid2 = (Z) => v.check(i._cuid2(e.ZodCUID2, Z)), v.ulid = (Z) => v.check(i._ulid(e.ZodULID, Z)), v.base64 = (Z) => v.check(i._base64(e.ZodBase64, Z)), v.base64url = (Z) => v.check(i._base64url(e.ZodBase64URL, Z)), v.xid = (Z) => v.check(i._xid(e.ZodXID, Z)), v.ksuid = (Z) => v.check(i._ksuid(e.ZodKSUID, Z)), v.ipv4 = (Z) => v.check(i._ipv4(e.ZodIPv4, Z)), v.ipv6 = (Z) => v.check(i._ipv6(e.ZodIPv6, Z)), v.cidrv4 = (Z) => v.check(i._cidrv4(e.ZodCIDRv4, Z)), v.cidrv6 = (Z) => v.check(i._cidrv6(e.ZodCIDRv6, Z)), v.e164 = (Z) => v.check(i._e164(e.ZodE164, Z)), v.datetime = (Z) => v.check(l.datetime(Z)), v.date = (Z) => v.check(l.date(Z)), v.time = (Z) => v.check(l.time(Z)), v.duration = (Z) => v.check(l.duration(Z));
    });
    function f(v) {
      return i._string(e.ZodString, v);
    }
    e.ZodStringFormat = i.$constructor("ZodStringFormat", (v, $) => {
      i.$ZodStringFormat.init(v, $), e._ZodString.init(v, $);
    }), e.ZodEmail = i.$constructor("ZodEmail", (v, $) => {
      i.$ZodEmail.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function s(v) {
      return i._email(e.ZodEmail, v);
    }
    e.ZodGUID = i.$constructor("ZodGUID", (v, $) => {
      i.$ZodGUID.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function h(v) {
      return i._guid(e.ZodGUID, v);
    }
    e.ZodUUID = i.$constructor("ZodUUID", (v, $) => {
      i.$ZodUUID.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function p(v) {
      return i._uuid(e.ZodUUID, v);
    }
    function m(v) {
      return i._uuidv4(e.ZodUUID, v);
    }
    function y(v) {
      return i._uuidv6(e.ZodUUID, v);
    }
    function w(v) {
      return i._uuidv7(e.ZodUUID, v);
    }
    e.ZodURL = i.$constructor("ZodURL", (v, $) => {
      i.$ZodURL.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function b(v) {
      return i._url(e.ZodURL, v);
    }
    function _(v) {
      return i._url(e.ZodURL, {
        protocol: /^https?$/,
        hostname: i.regexes.domain,
        ...a.util.normalizeParams(v)
      });
    }
    e.ZodEmoji = i.$constructor("ZodEmoji", (v, $) => {
      i.$ZodEmoji.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function g(v) {
      return i._emoji(e.ZodEmoji, v);
    }
    e.ZodNanoID = i.$constructor("ZodNanoID", (v, $) => {
      i.$ZodNanoID.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function O(v) {
      return i._nanoid(e.ZodNanoID, v);
    }
    e.ZodCUID = i.$constructor("ZodCUID", (v, $) => {
      i.$ZodCUID.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function P(v) {
      return i._cuid(e.ZodCUID, v);
    }
    e.ZodCUID2 = i.$constructor("ZodCUID2", (v, $) => {
      i.$ZodCUID2.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function E(v) {
      return i._cuid2(e.ZodCUID2, v);
    }
    e.ZodULID = i.$constructor("ZodULID", (v, $) => {
      i.$ZodULID.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function T(v) {
      return i._ulid(e.ZodULID, v);
    }
    e.ZodXID = i.$constructor("ZodXID", (v, $) => {
      i.$ZodXID.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function D(v) {
      return i._xid(e.ZodXID, v);
    }
    e.ZodKSUID = i.$constructor("ZodKSUID", (v, $) => {
      i.$ZodKSUID.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function N(v) {
      return i._ksuid(e.ZodKSUID, v);
    }
    e.ZodIPv4 = i.$constructor("ZodIPv4", (v, $) => {
      i.$ZodIPv4.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function M(v) {
      return i._ipv4(e.ZodIPv4, v);
    }
    e.ZodMAC = i.$constructor("ZodMAC", (v, $) => {
      i.$ZodMAC.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function R(v) {
      return i._mac(e.ZodMAC, v);
    }
    e.ZodIPv6 = i.$constructor("ZodIPv6", (v, $) => {
      i.$ZodIPv6.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function V(v) {
      return i._ipv6(e.ZodIPv6, v);
    }
    e.ZodCIDRv4 = i.$constructor("ZodCIDRv4", (v, $) => {
      i.$ZodCIDRv4.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function C(v) {
      return i._cidrv4(e.ZodCIDRv4, v);
    }
    e.ZodCIDRv6 = i.$constructor("ZodCIDRv6", (v, $) => {
      i.$ZodCIDRv6.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function B(v) {
      return i._cidrv6(e.ZodCIDRv6, v);
    }
    e.ZodBase64 = i.$constructor("ZodBase64", (v, $) => {
      i.$ZodBase64.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function G(v) {
      return i._base64(e.ZodBase64, v);
    }
    e.ZodBase64URL = i.$constructor("ZodBase64URL", (v, $) => {
      i.$ZodBase64URL.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function Q(v) {
      return i._base64url(e.ZodBase64URL, v);
    }
    e.ZodE164 = i.$constructor("ZodE164", (v, $) => {
      i.$ZodE164.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function k(v) {
      return i._e164(e.ZodE164, v);
    }
    e.ZodJWT = i.$constructor("ZodJWT", (v, $) => {
      i.$ZodJWT.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function I(v) {
      return i._jwt(e.ZodJWT, v);
    }
    e.ZodCustomStringFormat = i.$constructor("ZodCustomStringFormat", (v, $) => {
      i.$ZodCustomStringFormat.init(v, $), e.ZodStringFormat.init(v, $);
    });
    function S(v, $, Z = {}) {
      return i._stringFormat(e.ZodCustomStringFormat, v, $, Z);
    }
    function A(v) {
      return i._stringFormat(e.ZodCustomStringFormat, "hostname", i.regexes.hostname, v);
    }
    function j(v) {
      return i._stringFormat(e.ZodCustomStringFormat, "hex", i.regexes.hex, v);
    }
    function z(v, $) {
      const Z = $?.enc ?? "hex", H = `${v}_${Z}`, le = i.regexes[H];
      if (!le)
        throw new Error(`Unrecognized hash format: ${H}`);
      return i._stringFormat(e.ZodCustomStringFormat, H, le, $);
    }
    e.ZodNumber = i.$constructor("ZodNumber", (v, $) => {
      i.$ZodNumber.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (H, le, Qe) => o.numberProcessor(v, H, le, Qe), v.gt = (H, le) => v.check(u.gt(H, le)), v.gte = (H, le) => v.check(u.gte(H, le)), v.min = (H, le) => v.check(u.gte(H, le)), v.lt = (H, le) => v.check(u.lt(H, le)), v.lte = (H, le) => v.check(u.lte(H, le)), v.max = (H, le) => v.check(u.lte(H, le)), v.int = (H) => v.check(F(H)), v.safe = (H) => v.check(F(H)), v.positive = (H) => v.check(u.gt(0, H)), v.nonnegative = (H) => v.check(u.gte(0, H)), v.negative = (H) => v.check(u.lt(0, H)), v.nonpositive = (H) => v.check(u.lte(0, H)), v.multipleOf = (H, le) => v.check(u.multipleOf(H, le)), v.step = (H, le) => v.check(u.multipleOf(H, le)), v.finite = () => v;
      const Z = v._zod.bag;
      v.minValue = Math.max(Z.minimum ?? Number.NEGATIVE_INFINITY, Z.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, v.maxValue = Math.min(Z.maximum ?? Number.POSITIVE_INFINITY, Z.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, v.isInt = (Z.format ?? "").includes("int") || Number.isSafeInteger(Z.multipleOf ?? 0.5), v.isFinite = !0, v.format = Z.format ?? null;
    });
    function L(v) {
      return i._number(e.ZodNumber, v);
    }
    e.ZodNumberFormat = i.$constructor("ZodNumberFormat", (v, $) => {
      i.$ZodNumberFormat.init(v, $), e.ZodNumber.init(v, $);
    });
    function F(v) {
      return i._int(e.ZodNumberFormat, v);
    }
    function K(v) {
      return i._float32(e.ZodNumberFormat, v);
    }
    function ee(v) {
      return i._float64(e.ZodNumberFormat, v);
    }
    function U(v) {
      return i._int32(e.ZodNumberFormat, v);
    }
    function q(v) {
      return i._uint32(e.ZodNumberFormat, v);
    }
    e.ZodBoolean = i.$constructor("ZodBoolean", (v, $) => {
      i.$ZodBoolean.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.booleanProcessor(v, Z, H, le);
    });
    function ne(v) {
      return i._boolean(e.ZodBoolean, v);
    }
    e.ZodBigInt = i.$constructor("ZodBigInt", (v, $) => {
      i.$ZodBigInt.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (H, le, Qe) => o.bigintProcessor(v, H, le, Qe), v.gte = (H, le) => v.check(u.gte(H, le)), v.min = (H, le) => v.check(u.gte(H, le)), v.gt = (H, le) => v.check(u.gt(H, le)), v.gte = (H, le) => v.check(u.gte(H, le)), v.min = (H, le) => v.check(u.gte(H, le)), v.lt = (H, le) => v.check(u.lt(H, le)), v.lte = (H, le) => v.check(u.lte(H, le)), v.max = (H, le) => v.check(u.lte(H, le)), v.positive = (H) => v.check(u.gt(BigInt(0), H)), v.negative = (H) => v.check(u.lt(BigInt(0), H)), v.nonpositive = (H) => v.check(u.lte(BigInt(0), H)), v.nonnegative = (H) => v.check(u.gte(BigInt(0), H)), v.multipleOf = (H, le) => v.check(u.multipleOf(H, le));
      const Z = v._zod.bag;
      v.minValue = Z.minimum ?? null, v.maxValue = Z.maximum ?? null, v.format = Z.format ?? null;
    });
    function oe(v) {
      return i._bigint(e.ZodBigInt, v);
    }
    e.ZodBigIntFormat = i.$constructor("ZodBigIntFormat", (v, $) => {
      i.$ZodBigIntFormat.init(v, $), e.ZodBigInt.init(v, $);
    });
    function Y(v) {
      return i._int64(e.ZodBigIntFormat, v);
    }
    function re(v) {
      return i._uint64(e.ZodBigIntFormat, v);
    }
    e.ZodSymbol = i.$constructor("ZodSymbol", (v, $) => {
      i.$ZodSymbol.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.symbolProcessor(v, Z, H, le);
    });
    function de(v) {
      return i._symbol(e.ZodSymbol, v);
    }
    e.ZodUndefined = i.$constructor("ZodUndefined", (v, $) => {
      i.$ZodUndefined.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.undefinedProcessor(v, Z, H, le);
    });
    function ve(v) {
      return i._undefined(e.ZodUndefined, v);
    }
    e.ZodNull = i.$constructor("ZodNull", (v, $) => {
      i.$ZodNull.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.nullProcessor(v, Z, H, le);
    });
    function se(v) {
      return i._null(e.ZodNull, v);
    }
    e.ZodAny = i.$constructor("ZodAny", (v, $) => {
      i.$ZodAny.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.anyProcessor(v, Z, H, le);
    });
    function pe() {
      return i._any(e.ZodAny);
    }
    e.ZodUnknown = i.$constructor("ZodUnknown", (v, $) => {
      i.$ZodUnknown.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.unknownProcessor(v, Z, H, le);
    });
    function ke() {
      return i._unknown(e.ZodUnknown);
    }
    e.ZodNever = i.$constructor("ZodNever", (v, $) => {
      i.$ZodNever.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.neverProcessor(v, Z, H, le);
    });
    function Ne(v) {
      return i._never(e.ZodNever, v);
    }
    e.ZodVoid = i.$constructor("ZodVoid", (v, $) => {
      i.$ZodVoid.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.voidProcessor(v, Z, H, le);
    });
    function Ke(v) {
      return i._void(e.ZodVoid, v);
    }
    e.ZodDate = i.$constructor("ZodDate", (v, $) => {
      i.$ZodDate.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (H, le, Qe) => o.dateProcessor(v, H, le, Qe), v.min = (H, le) => v.check(u.gte(H, le)), v.max = (H, le) => v.check(u.lte(H, le));
      const Z = v._zod.bag;
      v.minDate = Z.minimum ? new Date(Z.minimum) : null, v.maxDate = Z.maximum ? new Date(Z.maximum) : null;
    });
    function X(v) {
      return i._date(e.ZodDate, v);
    }
    e.ZodArray = i.$constructor("ZodArray", (v, $) => {
      i.$ZodArray.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.arrayProcessor(v, Z, H, le), v.element = $.element, v.min = (Z, H) => v.check(u.minLength(Z, H)), v.nonempty = (Z) => v.check(u.minLength(1, Z)), v.max = (Z, H) => v.check(u.maxLength(Z, H)), v.length = (Z, H) => v.check(u.length(Z, H)), v.unwrap = () => v.element;
    });
    function ae(v, $) {
      return i._array(e.ZodArray, v, $);
    }
    function he(v) {
      const $ = v._zod.def.shape;
      return Ut(Object.keys($));
    }
    e.ZodObject = i.$constructor("ZodObject", (v, $) => {
      i.$ZodObjectJIT.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.objectProcessor(v, Z, H, le), a.util.defineLazy(v, "shape", () => $.shape), v.keyof = () => Ut(Object.keys(v._zod.def.shape)), v.catchall = (Z) => v.clone({ ...v._zod.def, catchall: Z }), v.passthrough = () => v.clone({ ...v._zod.def, catchall: ke() }), v.loose = () => v.clone({ ...v._zod.def, catchall: ke() }), v.strict = () => v.clone({ ...v._zod.def, catchall: Ne() }), v.strip = () => v.clone({ ...v._zod.def, catchall: void 0 }), v.extend = (Z) => a.util.extend(v, Z), v.safeExtend = (Z) => a.util.safeExtend(v, Z), v.merge = (Z) => a.util.merge(v, Z), v.pick = (Z) => a.util.pick(v, Z), v.omit = (Z) => a.util.omit(v, Z), v.partial = (...Z) => a.util.partial(e.ZodOptional, v, Z[0]), v.required = (...Z) => a.util.required(e.ZodNonOptional, v, Z[0]);
    });
    function me(v, $) {
      const Z = {
        type: "object",
        shape: v ?? {},
        ...a.util.normalizeParams($)
      };
      return new e.ZodObject(Z);
    }
    function Ee(v, $) {
      return new e.ZodObject({
        type: "object",
        shape: v,
        catchall: Ne(),
        ...a.util.normalizeParams($)
      });
    }
    function ie(v, $) {
      return new e.ZodObject({
        type: "object",
        shape: v,
        catchall: ke(),
        ...a.util.normalizeParams($)
      });
    }
    e.ZodUnion = i.$constructor("ZodUnion", (v, $) => {
      i.$ZodUnion.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.unionProcessor(v, Z, H, le), v.options = $.options;
    });
    function fe(v, $) {
      return new e.ZodUnion({
        type: "union",
        options: v,
        ...a.util.normalizeParams($)
      });
    }
    e.ZodXor = i.$constructor("ZodXor", (v, $) => {
      e.ZodUnion.init(v, $), i.$ZodXor.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.unionProcessor(v, Z, H, le), v.options = $.options;
    });
    function be(v, $) {
      return new e.ZodXor({
        type: "union",
        options: v,
        inclusive: !1,
        ...a.util.normalizeParams($)
      });
    }
    e.ZodDiscriminatedUnion = i.$constructor("ZodDiscriminatedUnion", (v, $) => {
      e.ZodUnion.init(v, $), i.$ZodDiscriminatedUnion.init(v, $);
    });
    function Te(v, $, Z) {
      return new e.ZodDiscriminatedUnion({
        type: "union",
        options: $,
        discriminator: v,
        ...a.util.normalizeParams(Z)
      });
    }
    e.ZodIntersection = i.$constructor("ZodIntersection", (v, $) => {
      i.$ZodIntersection.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.intersectionProcessor(v, Z, H, le);
    });
    function De(v, $) {
      return new e.ZodIntersection({
        type: "intersection",
        left: v,
        right: $
      });
    }
    e.ZodTuple = i.$constructor("ZodTuple", (v, $) => {
      i.$ZodTuple.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.tupleProcessor(v, Z, H, le), v.rest = (Z) => v.clone({
        ...v._zod.def,
        rest: Z
      });
    });
    function It(v, $, Z) {
      const H = $ instanceof i.$ZodType, le = H ? Z : $, Qe = H ? $ : null;
      return new e.ZodTuple({
        type: "tuple",
        items: v,
        rest: Qe,
        ...a.util.normalizeParams(le)
      });
    }
    e.ZodRecord = i.$constructor("ZodRecord", (v, $) => {
      i.$ZodRecord.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.recordProcessor(v, Z, H, le), v.keyType = $.keyType, v.valueType = $.valueType;
    });
    function Ft(v, $, Z) {
      return new e.ZodRecord({
        type: "record",
        keyType: v,
        valueType: $,
        ...a.util.normalizeParams(Z)
      });
    }
    function At(v, $, Z) {
      const H = i.clone(v);
      return H._zod.values = void 0, new e.ZodRecord({
        type: "record",
        keyType: H,
        valueType: $,
        ...a.util.normalizeParams(Z)
      });
    }
    function hn(v, $, Z) {
      return new e.ZodRecord({
        type: "record",
        keyType: v,
        valueType: $,
        mode: "loose",
        ...a.util.normalizeParams(Z)
      });
    }
    e.ZodMap = i.$constructor("ZodMap", (v, $) => {
      i.$ZodMap.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.mapProcessor(v, Z, H, le), v.keyType = $.keyType, v.valueType = $.valueType, v.min = (...Z) => v.check(i._minSize(...Z)), v.nonempty = (Z) => v.check(i._minSize(1, Z)), v.max = (...Z) => v.check(i._maxSize(...Z)), v.size = (...Z) => v.check(i._size(...Z));
    });
    function pn(v, $, Z) {
      return new e.ZodMap({
        type: "map",
        keyType: v,
        valueType: $,
        ...a.util.normalizeParams(Z)
      });
    }
    e.ZodSet = i.$constructor("ZodSet", (v, $) => {
      i.$ZodSet.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.setProcessor(v, Z, H, le), v.min = (...Z) => v.check(i._minSize(...Z)), v.nonempty = (Z) => v.check(i._minSize(1, Z)), v.max = (...Z) => v.check(i._maxSize(...Z)), v.size = (...Z) => v.check(i._size(...Z));
    });
    function St(v, $) {
      return new e.ZodSet({
        type: "set",
        valueType: v,
        ...a.util.normalizeParams($)
      });
    }
    e.ZodEnum = i.$constructor("ZodEnum", (v, $) => {
      i.$ZodEnum.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (H, le, Qe) => o.enumProcessor(v, H, le, Qe), v.enum = $.entries, v.options = Object.values($.entries);
      const Z = new Set(Object.keys($.entries));
      v.extract = (H, le) => {
        const Qe = {};
        for (const mt of H)
          if (Z.has(mt))
            Qe[mt] = $.entries[mt];
          else
            throw new Error(`Key ${mt} not found in enum`);
        return new e.ZodEnum({
          ...$,
          checks: [],
          ...a.util.normalizeParams(le),
          entries: Qe
        });
      }, v.exclude = (H, le) => {
        const Qe = { ...$.entries };
        for (const mt of H)
          if (Z.has(mt))
            delete Qe[mt];
          else
            throw new Error(`Key ${mt} not found in enum`);
        return new e.ZodEnum({
          ...$,
          checks: [],
          ...a.util.normalizeParams(le),
          entries: Qe
        });
      };
    });
    function Ut(v, $) {
      const Z = Array.isArray(v) ? Object.fromEntries(v.map((H) => [H, H])) : v;
      return new e.ZodEnum({
        type: "enum",
        entries: Z,
        ...a.util.normalizeParams($)
      });
    }
    function jt(v, $) {
      return new e.ZodEnum({
        type: "enum",
        entries: v,
        ...a.util.normalizeParams($)
      });
    }
    e.ZodLiteral = i.$constructor("ZodLiteral", (v, $) => {
      i.$ZodLiteral.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.literalProcessor(v, Z, H, le), v.values = new Set($.values), Object.defineProperty(v, "value", {
        get() {
          if ($.values.length > 1)
            throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
          return $.values[0];
        }
      });
    });
    function na(v, $) {
      return new e.ZodLiteral({
        type: "literal",
        values: Array.isArray(v) ? v : [v],
        ...a.util.normalizeParams($)
      });
    }
    e.ZodFile = i.$constructor("ZodFile", (v, $) => {
      i.$ZodFile.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.fileProcessor(v, Z, H, le), v.min = (Z, H) => v.check(i._minSize(Z, H)), v.max = (Z, H) => v.check(i._maxSize(Z, H)), v.mime = (Z, H) => v.check(i._mime(Array.isArray(Z) ? Z : [Z], H));
    });
    function ra(v) {
      return i._file(e.ZodFile, v);
    }
    e.ZodTransform = i.$constructor("ZodTransform", (v, $) => {
      i.$ZodTransform.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.transformProcessor(v, Z, H, le), v._zod.parse = (Z, H) => {
        if (H.direction === "backward")
          throw new i.$ZodEncodeError(v.constructor.name);
        Z.addIssue = (Qe) => {
          if (typeof Qe == "string")
            Z.issues.push(a.util.issue(Qe, Z.value, $));
          else {
            const mt = Qe;
            mt.fatal && (mt.continue = !1), mt.code ?? (mt.code = "custom"), mt.input ?? (mt.input = Z.value), mt.inst ?? (mt.inst = v), Z.issues.push(a.util.issue(mt));
          }
        };
        const le = $.transform(Z.value, Z);
        return le instanceof Promise ? le.then((Qe) => (Z.value = Qe, Z)) : (Z.value = le, Z);
      };
    });
    function Dr(v) {
      return new e.ZodTransform({
        type: "transform",
        transform: v
      });
    }
    e.ZodOptional = i.$constructor("ZodOptional", (v, $) => {
      i.$ZodOptional.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.optionalProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function fr(v) {
      return new e.ZodOptional({
        type: "optional",
        innerType: v
      });
    }
    e.ZodExactOptional = i.$constructor("ZodExactOptional", (v, $) => {
      i.$ZodExactOptional.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.optionalProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function ui(v) {
      return new e.ZodExactOptional({
        type: "optional",
        innerType: v
      });
    }
    e.ZodNullable = i.$constructor("ZodNullable", (v, $) => {
      i.$ZodNullable.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.nullableProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function hr(v) {
      return new e.ZodNullable({
        type: "nullable",
        innerType: v
      });
    }
    function ia(v) {
      return fr(hr(v));
    }
    e.ZodDefault = i.$constructor("ZodDefault", (v, $) => {
      i.$ZodDefault.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.defaultProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType, v.removeDefault = v.unwrap;
    });
    function mn(v, $) {
      return new e.ZodDefault({
        type: "default",
        innerType: v,
        get defaultValue() {
          return typeof $ == "function" ? $() : a.util.shallowClone($);
        }
      });
    }
    e.ZodPrefault = i.$constructor("ZodPrefault", (v, $) => {
      i.$ZodPrefault.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.prefaultProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function ci(v, $) {
      return new e.ZodPrefault({
        type: "prefault",
        innerType: v,
        get defaultValue() {
          return typeof $ == "function" ? $() : a.util.shallowClone($);
        }
      });
    }
    e.ZodNonOptional = i.$constructor("ZodNonOptional", (v, $) => {
      i.$ZodNonOptional.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.nonoptionalProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function di(v, $) {
      return new e.ZodNonOptional({
        type: "nonoptional",
        innerType: v,
        ...a.util.normalizeParams($)
      });
    }
    e.ZodSuccess = i.$constructor("ZodSuccess", (v, $) => {
      i.$ZodSuccess.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.successProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function oa(v) {
      return new e.ZodSuccess({
        type: "success",
        innerType: v
      });
    }
    e.ZodCatch = i.$constructor("ZodCatch", (v, $) => {
      i.$ZodCatch.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.catchProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType, v.removeCatch = v.unwrap;
    });
    function fi(v, $) {
      return new e.ZodCatch({
        type: "catch",
        innerType: v,
        catchValue: typeof $ == "function" ? $ : () => $
      });
    }
    e.ZodNaN = i.$constructor("ZodNaN", (v, $) => {
      i.$ZodNaN.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.nanProcessor(v, Z, H, le);
    });
    function aa(v) {
      return i._nan(e.ZodNaN, v);
    }
    e.ZodPipe = i.$constructor("ZodPipe", (v, $) => {
      i.$ZodPipe.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.pipeProcessor(v, Z, H, le), v.in = $.in, v.out = $.out;
    });
    function pr(v, $) {
      return new e.ZodPipe({
        type: "pipe",
        in: v,
        out: $
        // ...util.normalizeParams(params),
      });
    }
    e.ZodCodec = i.$constructor("ZodCodec", (v, $) => {
      e.ZodPipe.init(v, $), i.$ZodCodec.init(v, $);
    });
    function sa(v, $, Z) {
      return new e.ZodCodec({
        type: "pipe",
        in: v,
        out: $,
        transform: Z.decode,
        reverseTransform: Z.encode
      });
    }
    e.ZodReadonly = i.$constructor("ZodReadonly", (v, $) => {
      i.$ZodReadonly.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.readonlyProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function hi(v) {
      return new e.ZodReadonly({
        type: "readonly",
        innerType: v
      });
    }
    e.ZodTemplateLiteral = i.$constructor("ZodTemplateLiteral", (v, $) => {
      i.$ZodTemplateLiteral.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.templateLiteralProcessor(v, Z, H, le);
    });
    function la(v, $) {
      return new e.ZodTemplateLiteral({
        type: "template_literal",
        parts: v,
        ...a.util.normalizeParams($)
      });
    }
    e.ZodLazy = i.$constructor("ZodLazy", (v, $) => {
      i.$ZodLazy.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.lazyProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.getter();
    });
    function pi(v) {
      return new e.ZodLazy({
        type: "lazy",
        getter: v
      });
    }
    e.ZodPromise = i.$constructor("ZodPromise", (v, $) => {
      i.$ZodPromise.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.promiseProcessor(v, Z, H, le), v.unwrap = () => v._zod.def.innerType;
    });
    function ua(v) {
      return new e.ZodPromise({
        type: "promise",
        innerType: v
      });
    }
    e.ZodFunction = i.$constructor("ZodFunction", (v, $) => {
      i.$ZodFunction.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.functionProcessor(v, Z, H, le);
    });
    function mr(v) {
      return new e.ZodFunction({
        type: "function",
        input: Array.isArray(v?.input) ? It(v?.input) : v?.input ?? ae(ke()),
        output: v?.output ?? ke()
      });
    }
    e.ZodCustom = i.$constructor("ZodCustom", (v, $) => {
      i.$ZodCustom.init(v, $), e.ZodType.init(v, $), v._zod.processJSONSchema = (Z, H, le) => o.customProcessor(v, Z, H, le);
    });
    function ca(v) {
      const $ = new i.$ZodCheck({
        check: "custom"
        // ...util.normalizeParams(params),
      });
      return $._zod.check = v, $;
    }
    function da(v, $) {
      return i._custom(e.ZodCustom, v ?? (() => !0), $);
    }
    function Ar(v, $ = {}) {
      return i._refine(e.ZodCustom, v, $);
    }
    function jr(v) {
      return i._superRefine(v);
    }
    e.describe = i.describe, e.meta = i.meta;
    function mi(v, $ = {}) {
      const Z = new e.ZodCustom({
        type: "custom",
        check: "custom",
        fn: (H) => H instanceof v,
        abort: !0,
        ...a.util.normalizeParams($)
      });
      return Z._zod.bag.Class = v, Z._zod.check = (H) => {
        H.value instanceof v || H.issues.push({
          code: "invalid_type",
          expected: v.name,
          input: H.value,
          inst: Z,
          path: [...Z._zod.def.path ?? []]
        });
      }, Z;
    }
    const fa = (...v) => i._stringbool({
      Codec: e.ZodCodec,
      Boolean: e.ZodBoolean,
      String: e.ZodString
    }, ...v);
    e.stringbool = fa;
    function ha(v) {
      const $ = pi(() => fe([f(v), L(), ne(), se(), ae($), Ft(f(), $)]));
      return $;
    }
    function pa(v, $) {
      return pr(Dr(v), $);
    }
  })(Qn)), Qn;
}
var tr = {}, Oy;
function tT() {
  return Oy || (Oy = 1, (function(e) {
    var t = tr && tr.__createBinding || (Object.create ? (function(l, c, f, s) {
      s === void 0 && (s = f);
      var h = Object.getOwnPropertyDescriptor(c, f);
      (!h || ("get" in h ? !c.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return c[f];
      } }), Object.defineProperty(l, s, h);
    }) : (function(l, c, f, s) {
      s === void 0 && (s = f), l[s] = c[f];
    })), n = tr && tr.__setModuleDefault || (Object.create ? (function(l, c) {
      Object.defineProperty(l, "default", { enumerable: !0, value: c });
    }) : function(l, c) {
      l.default = c;
    }), r = tr && tr.__importStar || function(l) {
      if (l && l.__esModule) return l;
      var c = {};
      if (l != null) for (var f in l) f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(c, l, f);
      return n(c, l), c;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodFirstPartyTypeKind = e.config = e.$brand = e.ZodIssueCode = void 0, e.setErrorMap = o, e.getErrorMap = d;
    const i = r(nn());
    e.ZodIssueCode = {
      invalid_type: "invalid_type",
      too_big: "too_big",
      too_small: "too_small",
      invalid_format: "invalid_format",
      not_multiple_of: "not_multiple_of",
      unrecognized_keys: "unrecognized_keys",
      invalid_union: "invalid_union",
      invalid_key: "invalid_key",
      invalid_element: "invalid_element",
      invalid_value: "invalid_value",
      custom: "custom"
    };
    var a = nn();
    Object.defineProperty(e, "$brand", { enumerable: !0, get: function() {
      return a.$brand;
    } }), Object.defineProperty(e, "config", { enumerable: !0, get: function() {
      return a.config;
    } });
    function o(l) {
      i.config({
        customError: l
      });
    }
    function d() {
      return i.config().customError;
    }
    var u;
    u || (e.ZodFirstPartyTypeKind = u = {});
  })(tr)), tr;
}
var Mn = {}, zy;
function nT() {
  if (zy) return Mn;
  zy = 1;
  var e = Mn && Mn.__createBinding || (Object.create ? (function(p, m, y, w) {
    w === void 0 && (w = y);
    var b = Object.getOwnPropertyDescriptor(m, y);
    (!b || ("get" in b ? !m.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
      return m[y];
    } }), Object.defineProperty(p, w, b);
  }) : (function(p, m, y, w) {
    w === void 0 && (w = y), p[w] = m[y];
  })), t = Mn && Mn.__setModuleDefault || (Object.create ? (function(p, m) {
    Object.defineProperty(p, "default", { enumerable: !0, value: m });
  }) : function(p, m) {
    p.default = m;
  }), n = Mn && Mn.__importStar || function(p) {
    if (p && p.__esModule) return p;
    var m = {};
    if (p != null) for (var y in p) y !== "default" && Object.prototype.hasOwnProperty.call(p, y) && e(m, p, y);
    return t(m, p), m;
  };
  Object.defineProperty(Mn, "__esModule", { value: !0 }), Mn.fromJSONSchema = h;
  const r = rc(), i = n(hp()), a = n(vu()), d = {
    ...n(ac()),
    ...i,
    iso: a
  }, u = /* @__PURE__ */ new Set([
    // Schema identification
    "$schema",
    "$ref",
    "$defs",
    "definitions",
    // Core schema keywords
    "$id",
    "id",
    "$comment",
    "$anchor",
    "$vocabulary",
    "$dynamicRef",
    "$dynamicAnchor",
    // Type
    "type",
    "enum",
    "const",
    // Composition
    "anyOf",
    "oneOf",
    "allOf",
    "not",
    // Object
    "properties",
    "required",
    "additionalProperties",
    "patternProperties",
    "propertyNames",
    "minProperties",
    "maxProperties",
    // Array
    "items",
    "prefixItems",
    "additionalItems",
    "minItems",
    "maxItems",
    "uniqueItems",
    "contains",
    "minContains",
    "maxContains",
    // String
    "minLength",
    "maxLength",
    "pattern",
    "format",
    // Number
    "minimum",
    "maximum",
    "exclusiveMinimum",
    "exclusiveMaximum",
    "multipleOf",
    // Already handled metadata
    "description",
    "default",
    // Content
    "contentEncoding",
    "contentMediaType",
    "contentSchema",
    // Unsupported (error-throwing)
    "unevaluatedItems",
    "unevaluatedProperties",
    "if",
    "then",
    "else",
    "dependentSchemas",
    "dependentRequired",
    // OpenAPI
    "nullable",
    "readOnly"
  ]);
  function l(p, m) {
    const y = p.$schema;
    return y === "https://json-schema.org/draft/2020-12/schema" ? "draft-2020-12" : y === "http://json-schema.org/draft-07/schema#" ? "draft-7" : y === "http://json-schema.org/draft-04/schema#" ? "draft-4" : m ?? "draft-2020-12";
  }
  function c(p, m) {
    if (!p.startsWith("#"))
      throw new Error("External $ref is not supported, only local refs (#/...) are allowed");
    const y = p.slice(1).split("/").filter(Boolean);
    if (y.length === 0)
      return m.rootSchema;
    const w = m.version === "draft-2020-12" ? "$defs" : "definitions";
    if (y[0] === w) {
      const b = y[1];
      if (!b || !m.defs[b])
        throw new Error(`Reference not found: ${p}`);
      return m.defs[b];
    }
    throw new Error(`Reference not found: ${p}`);
  }
  function f(p, m) {
    if (p.not !== void 0) {
      if (typeof p.not == "object" && Object.keys(p.not).length === 0)
        return d.never();
      throw new Error("not is not supported in Zod (except { not: {} } for never)");
    }
    if (p.unevaluatedItems !== void 0)
      throw new Error("unevaluatedItems is not supported");
    if (p.unevaluatedProperties !== void 0)
      throw new Error("unevaluatedProperties is not supported");
    if (p.if !== void 0 || p.then !== void 0 || p.else !== void 0)
      throw new Error("Conditional schemas (if/then/else) are not supported");
    if (p.dependentSchemas !== void 0 || p.dependentRequired !== void 0)
      throw new Error("dependentSchemas and dependentRequired are not supported");
    if (p.$ref) {
      const b = p.$ref;
      if (m.refs.has(b))
        return m.refs.get(b);
      if (m.processing.has(b))
        return d.lazy(() => {
          if (!m.refs.has(b))
            throw new Error(`Circular reference not resolved: ${b}`);
          return m.refs.get(b);
        });
      m.processing.add(b);
      const _ = c(b, m), g = s(_, m);
      return m.refs.set(b, g), m.processing.delete(b), g;
    }
    if (p.enum !== void 0) {
      const b = p.enum;
      if (m.version === "openapi-3.0" && p.nullable === !0 && b.length === 1 && b[0] === null)
        return d.null();
      if (b.length === 0)
        return d.never();
      if (b.length === 1)
        return d.literal(b[0]);
      if (b.every((g) => typeof g == "string"))
        return d.enum(b);
      const _ = b.map((g) => d.literal(g));
      return _.length < 2 ? _[0] : d.union([_[0], _[1], ..._.slice(2)]);
    }
    if (p.const !== void 0)
      return d.literal(p.const);
    const y = p.type;
    if (Array.isArray(y)) {
      const b = y.map((_) => {
        const g = { ...p, type: _ };
        return f(g, m);
      });
      return b.length === 0 ? d.never() : b.length === 1 ? b[0] : d.union(b);
    }
    if (!y)
      return d.any();
    let w;
    switch (y) {
      case "string": {
        let b = d.string();
        if (p.format) {
          const _ = p.format;
          _ === "email" ? b = b.check(d.email()) : _ === "uri" || _ === "uri-reference" ? b = b.check(d.url()) : _ === "uuid" || _ === "guid" ? b = b.check(d.uuid()) : _ === "date-time" ? b = b.check(d.iso.datetime()) : _ === "date" ? b = b.check(d.iso.date()) : _ === "time" ? b = b.check(d.iso.time()) : _ === "duration" ? b = b.check(d.iso.duration()) : _ === "ipv4" ? b = b.check(d.ipv4()) : _ === "ipv6" ? b = b.check(d.ipv6()) : _ === "mac" ? b = b.check(d.mac()) : _ === "cidr" ? b = b.check(d.cidrv4()) : _ === "cidr-v6" ? b = b.check(d.cidrv6()) : _ === "base64" ? b = b.check(d.base64()) : _ === "base64url" ? b = b.check(d.base64url()) : _ === "e164" ? b = b.check(d.e164()) : _ === "jwt" ? b = b.check(d.jwt()) : _ === "emoji" ? b = b.check(d.emoji()) : _ === "nanoid" ? b = b.check(d.nanoid()) : _ === "cuid" ? b = b.check(d.cuid()) : _ === "cuid2" ? b = b.check(d.cuid2()) : _ === "ulid" ? b = b.check(d.ulid()) : _ === "xid" ? b = b.check(d.xid()) : _ === "ksuid" && (b = b.check(d.ksuid()));
        }
        typeof p.minLength == "number" && (b = b.min(p.minLength)), typeof p.maxLength == "number" && (b = b.max(p.maxLength)), p.pattern && (b = b.regex(new RegExp(p.pattern))), w = b;
        break;
      }
      case "number":
      case "integer": {
        let b = y === "integer" ? d.number().int() : d.number();
        typeof p.minimum == "number" && (b = b.min(p.minimum)), typeof p.maximum == "number" && (b = b.max(p.maximum)), typeof p.exclusiveMinimum == "number" ? b = b.gt(p.exclusiveMinimum) : p.exclusiveMinimum === !0 && typeof p.minimum == "number" && (b = b.gt(p.minimum)), typeof p.exclusiveMaximum == "number" ? b = b.lt(p.exclusiveMaximum) : p.exclusiveMaximum === !0 && typeof p.maximum == "number" && (b = b.lt(p.maximum)), typeof p.multipleOf == "number" && (b = b.multipleOf(p.multipleOf)), w = b;
        break;
      }
      case "boolean": {
        w = d.boolean();
        break;
      }
      case "null": {
        w = d.null();
        break;
      }
      case "object": {
        const b = {}, _ = p.properties || {}, g = new Set(p.required || []);
        for (const [P, E] of Object.entries(_)) {
          const T = s(E, m);
          b[P] = g.has(P) ? T : T.optional();
        }
        if (p.propertyNames) {
          const P = s(p.propertyNames, m), E = p.additionalProperties && typeof p.additionalProperties == "object" ? s(p.additionalProperties, m) : d.any();
          if (Object.keys(b).length === 0) {
            w = d.record(P, E);
            break;
          }
          const T = d.object(b).passthrough(), D = d.looseRecord(P, E);
          w = d.intersection(T, D);
          break;
        }
        if (p.patternProperties) {
          const P = p.patternProperties, E = Object.keys(P), T = [];
          for (const N of E) {
            const M = s(P[N], m), R = d.string().regex(new RegExp(N));
            T.push(d.looseRecord(R, M));
          }
          const D = [];
          if (Object.keys(b).length > 0 && D.push(d.object(b).passthrough()), D.push(...T), D.length === 0)
            w = d.object({}).passthrough();
          else if (D.length === 1)
            w = D[0];
          else {
            let N = d.intersection(D[0], D[1]);
            for (let M = 2; M < D.length; M++)
              N = d.intersection(N, D[M]);
            w = N;
          }
          break;
        }
        const O = d.object(b);
        p.additionalProperties === !1 ? w = O.strict() : typeof p.additionalProperties == "object" ? w = O.catchall(s(p.additionalProperties, m)) : w = O.passthrough();
        break;
      }
      case "array": {
        const b = p.prefixItems, _ = p.items;
        if (b && Array.isArray(b)) {
          const g = b.map((P) => s(P, m)), O = _ && typeof _ == "object" && !Array.isArray(_) ? s(_, m) : void 0;
          O ? w = d.tuple(g).rest(O) : w = d.tuple(g), typeof p.minItems == "number" && (w = w.check(d.minLength(p.minItems))), typeof p.maxItems == "number" && (w = w.check(d.maxLength(p.maxItems)));
        } else if (Array.isArray(_)) {
          const g = _.map((P) => s(P, m)), O = p.additionalItems && typeof p.additionalItems == "object" ? s(p.additionalItems, m) : void 0;
          O ? w = d.tuple(g).rest(O) : w = d.tuple(g), typeof p.minItems == "number" && (w = w.check(d.minLength(p.minItems))), typeof p.maxItems == "number" && (w = w.check(d.maxLength(p.maxItems)));
        } else if (_ !== void 0) {
          const g = s(_, m);
          let O = d.array(g);
          typeof p.minItems == "number" && (O = O.min(p.minItems)), typeof p.maxItems == "number" && (O = O.max(p.maxItems)), w = O;
        } else
          w = d.array(d.any());
        break;
      }
      default:
        throw new Error(`Unsupported type: ${y}`);
    }
    return p.description && (w = w.describe(p.description)), p.default !== void 0 && (w = w.default(p.default)), w;
  }
  function s(p, m) {
    if (typeof p == "boolean")
      return p ? d.any() : d.never();
    let y = f(p, m);
    const w = p.type || p.enum !== void 0 || p.const !== void 0;
    if (p.anyOf && Array.isArray(p.anyOf)) {
      const O = p.anyOf.map((E) => s(E, m)), P = d.union(O);
      y = w ? d.intersection(y, P) : P;
    }
    if (p.oneOf && Array.isArray(p.oneOf)) {
      const O = p.oneOf.map((E) => s(E, m)), P = d.xor(O);
      y = w ? d.intersection(y, P) : P;
    }
    if (p.allOf && Array.isArray(p.allOf))
      if (p.allOf.length === 0)
        y = w ? y : d.any();
      else {
        let O = w ? y : s(p.allOf[0], m);
        const P = w ? 0 : 1;
        for (let E = P; E < p.allOf.length; E++)
          O = d.intersection(O, s(p.allOf[E], m));
        y = O;
      }
    p.nullable === !0 && m.version === "openapi-3.0" && (y = d.nullable(y)), p.readOnly === !0 && (y = d.readonly(y));
    const b = {}, _ = ["$id", "id", "$comment", "$anchor", "$vocabulary", "$dynamicRef", "$dynamicAnchor"];
    for (const O of _)
      O in p && (b[O] = p[O]);
    const g = ["contentEncoding", "contentMediaType", "contentSchema"];
    for (const O of g)
      O in p && (b[O] = p[O]);
    for (const O of Object.keys(p))
      u.has(O) || (b[O] = p[O]);
    return Object.keys(b).length > 0 && m.registry.add(y, b), y;
  }
  function h(p, m) {
    if (typeof p == "boolean")
      return p ? d.any() : d.never();
    const y = l(p, m?.defaultTarget), w = p.$defs || p.definitions || {}, b = {
      version: y,
      defs: w,
      refs: /* @__PURE__ */ new Map(),
      processing: /* @__PURE__ */ new Set(),
      rootSchema: p,
      registry: m?.registry ?? r.globalRegistry
    };
    return s(p, b);
  }
  return Mn;
}
var Bt = {}, Ey;
function rT() {
  if (Ey) return Bt;
  Ey = 1;
  var e = Bt && Bt.__createBinding || (Object.create ? (function(c, f, s, h) {
    h === void 0 && (h = s);
    var p = Object.getOwnPropertyDescriptor(f, s);
    (!p || ("get" in p ? !f.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return f[s];
    } }), Object.defineProperty(c, h, p);
  }) : (function(c, f, s, h) {
    h === void 0 && (h = s), c[h] = f[s];
  })), t = Bt && Bt.__setModuleDefault || (Object.create ? (function(c, f) {
    Object.defineProperty(c, "default", { enumerable: !0, value: f });
  }) : function(c, f) {
    c.default = f;
  }), n = Bt && Bt.__importStar || function(c) {
    if (c && c.__esModule) return c;
    var f = {};
    if (c != null) for (var s in c) s !== "default" && Object.prototype.hasOwnProperty.call(c, s) && e(f, c, s);
    return t(f, c), f;
  };
  Object.defineProperty(Bt, "__esModule", { value: !0 }), Bt.string = a, Bt.number = o, Bt.boolean = d, Bt.bigint = u, Bt.date = l;
  const r = n(nn()), i = n(ac());
  function a(c) {
    return r._coercedString(i.ZodString, c);
  }
  function o(c) {
    return r._coercedNumber(i.ZodNumber, c);
  }
  function d(c) {
    return r._coercedBoolean(i.ZodBoolean, c);
  }
  function u(c) {
    return r._coercedBigint(i.ZodBigInt, c);
  }
  function l(c) {
    return r._coercedDate(i.ZodDate, c);
  }
  return Bt;
}
var Ty;
function Ny() {
  return Ty || (Ty = 1, (function(e) {
    var t = Jt && Jt.__createBinding || (Object.create ? (function(s, h, p, m) {
      m === void 0 && (m = p);
      var y = Object.getOwnPropertyDescriptor(h, p);
      (!y || ("get" in y ? !h.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
        return h[p];
      } }), Object.defineProperty(s, m, y);
    }) : (function(s, h, p, m) {
      m === void 0 && (m = p), s[m] = h[p];
    })), n = Jt && Jt.__setModuleDefault || (Object.create ? (function(s, h) {
      Object.defineProperty(s, "default", { enumerable: !0, value: h });
    }) : function(s, h) {
      s.default = h;
    }), r = Jt && Jt.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var h = {};
      if (s != null) for (var p in s) p !== "default" && Object.prototype.hasOwnProperty.call(s, p) && t(h, s, p);
      return n(h, s), h;
    }, i = Jt && Jt.__exportStar || function(s, h) {
      for (var p in s) p !== "default" && !Object.prototype.hasOwnProperty.call(h, p) && t(h, s, p);
    }, a = Jt && Jt.__importDefault || function(s) {
      return s && s.__esModule ? s : { default: s };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.coerce = e.iso = e.ZodISODuration = e.ZodISOTime = e.ZodISODate = e.ZodISODateTime = e.locales = e.fromJSONSchema = e.toJSONSchema = e.NEVER = e.util = e.TimePrecision = e.flattenError = e.formatError = e.prettifyError = e.treeifyError = e.regexes = e.clone = e.$brand = e.$input = e.$output = e.config = e.registry = e.globalRegistry = e.core = void 0, e.core = r(nn()), i(ac(), e), i(hp(), e), i(ok(), e), i(ak(), e), i(tT(), e);
    const o = nn(), d = a(tk());
    (0, o.config)((0, d.default)());
    var u = nn();
    Object.defineProperty(e, "globalRegistry", { enumerable: !0, get: function() {
      return u.globalRegistry;
    } }), Object.defineProperty(e, "registry", { enumerable: !0, get: function() {
      return u.registry;
    } }), Object.defineProperty(e, "config", { enumerable: !0, get: function() {
      return u.config;
    } }), Object.defineProperty(e, "$output", { enumerable: !0, get: function() {
      return u.$output;
    } }), Object.defineProperty(e, "$input", { enumerable: !0, get: function() {
      return u.$input;
    } }), Object.defineProperty(e, "$brand", { enumerable: !0, get: function() {
      return u.$brand;
    } }), Object.defineProperty(e, "clone", { enumerable: !0, get: function() {
      return u.clone;
    } }), Object.defineProperty(e, "regexes", { enumerable: !0, get: function() {
      return u.regexes;
    } }), Object.defineProperty(e, "treeifyError", { enumerable: !0, get: function() {
      return u.treeifyError;
    } }), Object.defineProperty(e, "prettifyError", { enumerable: !0, get: function() {
      return u.prettifyError;
    } }), Object.defineProperty(e, "formatError", { enumerable: !0, get: function() {
      return u.formatError;
    } }), Object.defineProperty(e, "flattenError", { enumerable: !0, get: function() {
      return u.flattenError;
    } }), Object.defineProperty(e, "TimePrecision", { enumerable: !0, get: function() {
      return u.TimePrecision;
    } }), Object.defineProperty(e, "util", { enumerable: !0, get: function() {
      return u.util;
    } }), Object.defineProperty(e, "NEVER", { enumerable: !0, get: function() {
      return u.NEVER;
    } });
    var l = oc();
    Object.defineProperty(e, "toJSONSchema", { enumerable: !0, get: function() {
      return l.toJSONSchema;
    } });
    var c = nT();
    Object.defineProperty(e, "fromJSONSchema", { enumerable: !0, get: function() {
      return c.fromJSONSchema;
    } }), e.locales = r(ik());
    var f = vu();
    Object.defineProperty(e, "ZodISODateTime", { enumerable: !0, get: function() {
      return f.ZodISODateTime;
    } }), Object.defineProperty(e, "ZodISODate", { enumerable: !0, get: function() {
      return f.ZodISODate;
    } }), Object.defineProperty(e, "ZodISOTime", { enumerable: !0, get: function() {
      return f.ZodISOTime;
    } }), Object.defineProperty(e, "ZodISODuration", { enumerable: !0, get: function() {
      return f.ZodISODuration;
    } }), e.iso = r(vu()), e.coerce = r(rT());
  })(Jt)), Jt;
}
var Cy;
function pp() {
  return Cy || (Cy = 1, (function(e) {
    var t = vn && vn.__createBinding || (Object.create ? (function(o, d, u, l) {
      l === void 0 && (l = u);
      var c = Object.getOwnPropertyDescriptor(d, u);
      (!c || ("get" in c ? !d.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
        return d[u];
      } }), Object.defineProperty(o, l, c);
    }) : (function(o, d, u, l) {
      l === void 0 && (l = u), o[l] = d[u];
    })), n = vn && vn.__setModuleDefault || (Object.create ? (function(o, d) {
      Object.defineProperty(o, "default", { enumerable: !0, value: d });
    }) : function(o, d) {
      o.default = d;
    }), r = vn && vn.__importStar || function(o) {
      if (o && o.__esModule) return o;
      var d = {};
      if (o != null) for (var u in o) u !== "default" && Object.prototype.hasOwnProperty.call(o, u) && t(d, o, u);
      return n(d, o), d;
    }, i = vn && vn.__exportStar || function(o, d) {
      for (var u in o) u !== "default" && !Object.prototype.hasOwnProperty.call(d, u) && t(d, o, u);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.z = void 0;
    const a = r(Ny());
    e.z = a, i(Ny(), e), e.default = a;
  })(vn)), vn;
}
var Dy;
function iT() {
  return Dy || (Dy = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getFlowInput = e.moveToDatasetInput = e.removeDatasetInput = e.setDatasetInput = e.setFlowNameInput = e.deleteNodeInput = e.setEntryInput = e.updateEdgeInput = e.disconnectInput = e.addGuardrailInput = e.attachConnectorInput = e.connectInput = e.updateScorerInput = e.addScorerInput = e.updateGuardrailInput = e.updateConnectionInput = e.setToolPolicyInput = e.setAgentSettingsInput = e.setMetadataInput = e.setModelInput = e.writePromptInput = e.addAgentInput = e.agentTargetSchema = e.META_OPS = e.concreteOpSchema = e.agentMetadataSchema = e.guardPlacementSchema = e.edgeTypeSchema = e.connectKindSchema = e.toolPolicySchema = e.WIDGET_DESIGN_PART = e.COPILOT_OP_PART = e.WIDGET_DESIGN_AGENT_ID = e.COPILOT_AGENT_ID = void 0, e.isStructuralOp = p, e.isMetaOp = m;
    const t = oE(), n = cp(), r = /* @__PURE__ */ pp();
    e.COPILOT_AGENT_ID = "__builder_copilot", e.WIDGET_DESIGN_AGENT_ID = "widget-design", e.COPILOT_OP_PART = "data-copilot-op", e.WIDGET_DESIGN_PART = "data-widget-design", e.toolPolicySchema = r.z.enum(["allow", "needs_approval", "disallow"]), e.connectKindSchema = r.z.enum([
      "handoff",
      "agent-as-tool",
      "uses-tool",
      "guard-input",
      "guard-output",
      "scores"
    ]), e.edgeTypeSchema = r.z.enum([
      "handoff",
      "uses-tool",
      "uses-agent-as-tool",
      "guards",
      "scores"
    ]), e.guardPlacementSchema = r.z.enum(["input", "output"]), e.agentMetadataSchema = r.z.record(r.z.string(), r.z.unknown());
    const i = r.z.object({ user: r.z.string(), llm: r.z.string() }), a = r.z.number().int().min(1).max(n.FLOW_MAX_TOOL_STEPS), o = r.z.object({
      maxTurns: r.z.number().int().positive(),
      useMemory: r.z.boolean()
    }), d = r.z.literal("all").describe("Every tool the server offers when the agent runs; one the server does not mark read-only asks before running."), u = r.z.union([
      d,
      r.z.array(r.z.object({ name: r.z.string(), policy: e.toolPolicySchema }))
    ]), l = r.z.union([
      d,
      r.z.array(r.z.object({
        name: r.z.string(),
        policy: r.z.enum(["allow", "always_allow", "needs_approval", "disallow"])
      }))
    ]), c = r.z.record(r.z.string(), r.z.unknown()), f = r.z.enum(t.DATA_MEDIA_TYPES), s = r.z.object({
      key: r.z.string(),
      description: r.z.string(),
      mediaType: f,
      content: r.z.string()
    });
    e.concreteOpSchema = r.z.discriminatedUnion("op", [
      r.z.object({
        op: r.z.literal("add_agent"),
        id: r.z.string(),
        name: r.z.string(),
        instructions: r.z.string(),
        model: r.z.string()
      }),
      r.z.object({
        op: r.z.literal("add_ref_agent"),
        id: r.z.string(),
        agentId: r.z.string(),
        name: r.z.string()
      }),
      r.z.object({
        op: r.z.literal("set_ref_agent_input"),
        id: r.z.string(),
        input: r.z.record(r.z.string(), r.z.unknown())
      }),
      r.z.object({ op: r.z.literal("write_prompt"), id: r.z.string(), instructions: r.z.string() }),
      r.z.object({
        op: r.z.literal("set_model"),
        ids: r.z.array(r.z.string()).min(1),
        model: r.z.string().optional(),
        temperature: r.z.number().optional(),
        topP: r.z.number().optional(),
        maxOutputTokens: r.z.number().int().positive().optional(),
        maxToolSteps: a.optional()
      }),
      r.z.object({
        op: r.z.literal("set_metadata"),
        id: r.z.string(),
        name: r.z.string().optional(),
        description: i.optional(),
        memoryConfig: o.optional(),
        metadata: e.agentMetadataSchema.optional()
      }),
      r.z.object({ op: r.z.literal("set_tool_policy"), id: r.z.string(), policy: e.toolPolicySchema }),
      r.z.object({ op: r.z.literal("update_connection"), id: r.z.string(), tools: l }),
      r.z.object({
        op: r.z.literal("update_guardrail"),
        id: r.z.string(),
        criterion: r.z.string().optional(),
        model: r.z.string().optional(),
        name: r.z.string().optional()
      }),
      r.z.object({
        op: r.z.literal("connect"),
        edgeId: r.z.string(),
        edgeType: e.edgeTypeSchema,
        source: r.z.string(),
        target: r.z.string(),
        placement: e.guardPlacementSchema.optional()
      }),
      r.z.object({
        op: r.z.literal("attach_tool"),
        toolNodeId: r.z.string(),
        edgeId: r.z.string(),
        agentId: r.z.string(),
        toolId: r.z.string(),
        config: r.z.record(r.z.string(), r.z.unknown()).optional()
      }),
      r.z.object({
        op: r.z.literal("attach_web_search"),
        webSearchNodeId: r.z.string(),
        edgeId: r.z.string(),
        agentId: r.z.string()
      }),
      r.z.object({
        op: r.z.literal("attach_connector"),
        mcpNodeId: r.z.string(),
        edgeId: r.z.string(),
        agentId: r.z.string(),
        connectionId: r.z.string(),
        tools: l
      }),
      r.z.object({
        op: r.z.literal("add_guardrail"),
        guardrailNodeId: r.z.string(),
        edgeId: r.z.string(),
        agentId: r.z.string(),
        criterion: r.z.string(),
        model: r.z.string().optional(),
        placement: e.guardPlacementSchema
      }),
      r.z.object({
        op: r.z.literal("add_scorer"),
        scorerNodeId: r.z.string(),
        edgeId: r.z.string(),
        agentId: r.z.string(),
        scorerId: r.z.string(),
        name: r.z.string().optional(),
        model: r.z.string().optional(),
        criterion: r.z.string().optional(),
        options: c.optional()
      }),
      r.z.object({
        op: r.z.literal("update_scorer"),
        id: r.z.string(),
        scorerId: r.z.string().optional(),
        name: r.z.string().optional(),
        model: r.z.string().optional(),
        criterion: r.z.string().optional(),
        options: c.optional()
      }),
      r.z.object({ op: r.z.literal("disconnect"), edgeId: r.z.string() }),
      r.z.object({
        op: r.z.literal("update_edge"),
        edgeId: r.z.string(),
        description: r.z.string().optional(),
        toolName: r.z.string().optional(),
        placement: e.guardPlacementSchema.optional()
      }),
      r.z.object({ op: r.z.literal("set_entry"), id: r.z.string() }),
      r.z.object({ op: r.z.literal("delete_node"), id: r.z.string() }),
      r.z.object({ op: r.z.literal("set_flow_name"), name: r.z.string() }),
      r.z.object({ op: r.z.literal("set_dataset"), dataset: s }),
      r.z.object({ op: r.z.literal("remove_dataset"), key: r.z.string() }),
      r.z.object({ op: r.z.literal("undo") }),
      r.z.object({ op: r.z.literal("redo") }),
      r.z.object({ op: r.z.literal("save") }),
      r.z.object({ op: r.z.literal("new_flow") })
    ]);
    const h = /* @__PURE__ */ new Set([
      "add_agent",
      "add_ref_agent",
      "attach_tool",
      "attach_web_search",
      "attach_connector",
      "add_guardrail",
      // Must be here, or the copilot-created scorer node stays stacked at (0,0):
      // relayout is triggered by structural ops, and every node requires ui:{x,y}.
      "add_scorer",
      "connect",
      "disconnect",
      "delete_node"
    ]);
    function p(y) {
      return h.has(y.op);
    }
    e.META_OPS = ["undo", "redo", "save", "new_flow"];
    function m(y) {
      return e.META_OPS.includes(y.op);
    }
    e.agentTargetSchema = r.z.union([r.z.literal("all_agents"), r.z.string().min(1), r.z.array(r.z.string().min(1)).min(1)]).describe('Target agent(s): "all_agents", or an id/name, or a list of ids/names.'), e.addAgentInput = r.z.object({
      name: r.z.string().min(1),
      instructions: r.z.string().optional().describe("The agent system prompt. May be set later via write_prompt."),
      model: r.z.string().optional()
    }), e.writePromptInput = r.z.object({
      target: r.z.string().min(1).describe("An existing agent id or exact name."),
      instructions: r.z.string().min(1)
    }), e.setModelInput = r.z.object({
      target: e.agentTargetSchema,
      model: r.z.string().min(1).optional().describe("An exact model id from the catalog."),
      temperature: r.z.number().min(0).max(2).optional(),
      topP: r.z.number().min(0).max(1).optional(),
      maxOutputTokens: r.z.number().int().positive().optional(),
      maxToolSteps: a.optional().describe("Rounds of tool calls the agent may make before it has to answer.")
    }), e.setMetadataInput = r.z.object({
      target: r.z.string().min(1),
      name: r.z.string().optional(),
      description: i.optional(),
      memoryConfig: o.optional(),
      metadata: e.agentMetadataSchema.optional()
    }), e.setAgentSettingsInput = r.z.object({
      target: r.z.string().min(1).describe("A referenced agent node id or exact name."),
      settings: r.z.string().describe('The settings as a JSON object, replacing any the node has; "{}" clears them. Use the shape the host guidance gives for that agent.')
    }), e.setToolPolicyInput = r.z.object({
      agent: r.z.string().min(1),
      toolId: r.z.string().min(1),
      policy: e.toolPolicySchema
    }), e.updateConnectionInput = r.z.object({
      agent: r.z.string().min(1),
      connectionId: r.z.string().min(1),
      tools: u
    }), e.updateGuardrailInput = r.z.object({
      target: r.z.string().min(1).describe("A guardrail node id or exact name."),
      criterion: r.z.string().min(1).optional(),
      model: r.z.string().optional(),
      name: r.z.string().optional()
    }), e.addScorerInput = r.z.object({
      agent: r.z.string().min(1).describe("An existing agent id or exact name."),
      scorerId: r.z.string().min(1).describe("A scorer id from the catalog (see the system prompt)."),
      name: r.z.string().optional().describe("The key results are reported under. Defaults to the scorerId."),
      model: r.z.string().optional().describe("Only for model-graded scorers."),
      criterion: r.z.string().optional().describe("Only for criterion-driven scorers (closed-qa)."),
      options: c.optional().describe('e.g. { tools: ["web_search"] }.')
    }), e.updateScorerInput = r.z.object({
      target: r.z.string().min(1).describe("A scorer node id or exact name."),
      scorerId: r.z.string().min(1).optional(),
      name: r.z.string().optional(),
      model: r.z.string().optional(),
      criterion: r.z.string().optional(),
      options: c.optional()
    }), e.connectInput = r.z.object({
      from: r.z.string().min(1),
      to: r.z.string().min(1),
      kind: e.connectKindSchema
    }), e.attachConnectorInput = r.z.object({
      agent: r.z.string().min(1),
      connectionId: r.z.string().min(1),
      tools: u.optional()
    }), e.addGuardrailInput = r.z.object({
      agent: r.z.string().min(1),
      criterion: r.z.string().min(1),
      placement: e.guardPlacementSchema,
      model: r.z.string().optional()
    }), e.disconnectInput = r.z.object({
      from: r.z.string().min(1),
      to: r.z.string().min(1),
      kind: e.connectKindSchema.optional().describe("Disambiguates when >1 edge joins the pair.")
    }), e.updateEdgeInput = r.z.object({
      from: r.z.string().min(1),
      to: r.z.string().min(1),
      kind: e.connectKindSchema.optional(),
      description: r.z.string().optional().describe("For handoff / agent-as-tool edges."),
      toolName: r.z.string().optional().describe("For agent-as-tool edges."),
      placement: e.guardPlacementSchema.optional().describe("For guardrail edges.")
    }), e.setEntryInput = r.z.object({ target: r.z.string().min(1) }), e.deleteNodeInput = r.z.object({ target: r.z.string().min(1) }), e.setFlowNameInput = r.z.object({ name: r.z.string().min(1) }), e.setDatasetInput = r.z.object({
      key: r.z.string().describe("How the agent refers to it: lower case letters, digits and underscores, such as campaign_data"),
      description: r.z.string().max(500).describe("What the data is, for the agent choosing between keys"),
      mediaType: f.describe("The format of content"),
      content: r.z.string().describe("The data itself, exactly as given")
    }), e.removeDatasetInput = r.z.object({ key: r.z.string() }), e.moveToDatasetInput = r.z.object({
      agent: r.z.string().min(1).describe("The agent whose instructions hold the data: its id or exact name"),
      tag: r.z.string().min(1).describe("The tag around the data, such as campaign_data for <campaign_data>"),
      key: r.z.string().describe("The dataset key to keep it under"),
      description: r.z.string().max(500).describe("What the data is")
    }), e.getFlowInput = r.z.object({
      target: r.z.string().min(1).optional().describe("Omit for the compact index; pass a node id/name for full detail.")
    });
  })(Xc)), Xc;
}
var co = {}, Ay;
function oT() {
  if (Ay) return co;
  Ay = 1, Object.defineProperty(co, "__esModule", { value: !0 }), co.COPILOT_INLINE_FILE_POLICY = void 0, co.isAllowedMediaType = t;
  const e = 1024 * 1024;
  co.COPILOT_INLINE_FILE_POLICY = {
    allowedMediaTypes: [
      "image/png",
      "image/jpeg",
      "image/webp",
      "image/gif",
      "application/pdf",
      "text"
    ],
    maxFiles: 5,
    maxBytesPerFile: 4 * e,
    maxTotalBytes: 6 * e
  };
  function t(n, r) {
    const i = n.split(";")[0]?.trim().toLowerCase() ?? "";
    return r.some((a) => a.includes("/") ? a.toLowerCase() === i : i.startsWith(`${a.toLowerCase()}/`));
  }
  return co;
}
var id = {}, jy;
function aT() {
  return jy || (jy = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.widgetIdOfTool = e.isWidgetToolId = e.widgetToolId = void 0;
    const t = "widget:", n = (a) => `${t}${a}`;
    e.widgetToolId = n;
    const r = (a) => a.startsWith(t);
    e.isWidgetToolId = r;
    const i = (a) => (0, e.isWidgetToolId)(a) ? a.slice(t.length) : void 0;
    e.widgetIdOfTool = i;
  })(id)), id;
}
var My;
function sT() {
  return My || (My = 1, (function(e) {
    var t = $r && $r.__createBinding || (Object.create ? (function(r, i, a, o) {
      o === void 0 && (o = a);
      var d = Object.getOwnPropertyDescriptor(i, a);
      (!d || ("get" in d ? !i.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return i[a];
      } }), Object.defineProperty(r, o, d);
    }) : (function(r, i, a, o) {
      o === void 0 && (o = a), r[o] = i[a];
    })), n = $r && $r.__exportStar || function(r, i) {
      for (var a in r) a !== "default" && !Object.prototype.hasOwnProperty.call(i, a) && t(i, r, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), n(W0(), e), n(nE(), e), n(G0(), e), n(rE(), e), n(iT(), e), n(H0(), e), n(K0(), e), n(oT(), e), n(aT(), e);
  })($r)), $r;
}
var Ge = sT(), Nl = {}, $y;
function lT() {
  if ($y) return Nl;
  $y = 1, Object.defineProperty(Nl, "__esModule", { value: !0 }), Nl.guardrailNames = t;
  const e = "Guardrail";
  function t(n) {
    const r = new Set(n.nodes.flatMap((o) => o.kind === "guardrail" && o.name ? [o.name] : [])), i = /* @__PURE__ */ new Map();
    let a = 1;
    for (const o of n.nodes) {
      if (o.kind !== "guardrail")
        continue;
      if (o.name) {
        i.set(o.id, o.name);
        continue;
      }
      let d;
      do
        d = a === 1 ? e : `${e} ${a}`, a += 1;
      while (r.has(d));
      r.add(d), i.set(o.id, d);
    }
    return i;
  }
  return Nl;
}
var HK = lT();
const sk = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
const uT = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const cT = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
);
const Ry = (e) => {
  const t = cT(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
};
var od = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const dT = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
  return !1;
}, fT = Wt({}), hT = () => st(fT), pT = ol(
  ({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: o, ...d }, u) => {
    const {
      size: l = 24,
      strokeWidth: c = 2,
      absoluteStrokeWidth: f = !1,
      color: s = "currentColor",
      className: h = ""
    } = hT() ?? {}, p = r ?? f ? Number(n ?? c) * 24 / Number(t ?? l) : n ?? c;
    return yu(
      "svg",
      {
        ref: u,
        ...od,
        width: t ?? l ?? od.width,
        height: t ?? l ?? od.height,
        stroke: e ?? s,
        strokeWidth: p,
        className: sk("lucide", h, i),
        ...!a && !dT(d) && { "aria-hidden": "true" },
        ...d
      },
      [
        ...o.map(([m, y]) => yu(m, y)),
        ...Array.isArray(a) ? a : [a]
      ]
    );
  }
);
const je = (e, t) => {
  const n = ol(
    ({ className: r, ...i }, a) => yu(pT, {
      ref: a,
      iconNode: t,
      className: sk(
        `lucide-${uT(Ry(e))}`,
        `lucide-${e}`,
        r
      ),
      ...i
    })
  );
  return n.displayName = Ry(e), n;
};
const mT = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], gT = je("arrow-down", mT);
const yT = [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
], vT = je("arrow-left-right", yT);
const bT = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], _T = je("arrow-up", bT);
const wT = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
], kT = je("book-open", wT);
const ST = [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
], xT = je("bot", ST);
const IT = [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
], PT = je("boxes", IT);
const OT = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], zT = je("check", OT);
const ET = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], TT = je("chevron-down", ET);
const NT = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], lk = je("chevron-right", NT);
const CT = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], DT = je("chevron-up", CT);
const AT = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], jT = je("circle-alert", AT);
const MT = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], $T = je("circle-check", MT);
const RT = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], uk = je("external-link", RT);
const ZT = [
  ["path", { d: "m15 17 5-5-5-5", key: "nf172w" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
], LT = je("forward", ZT);
const FT = [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
], ck = je("gauge", FT);
const UT = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], BT = je("info", UT);
const VT = [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
], qT = je("layers", VT);
const HT = [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
], WT = je("layout-dashboard", HT);
const GT = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
], KT = je("layout-grid", GT);
const JT = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], XT = je("layout-panel-top", JT);
const YT = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], QT = je("link-2", YT);
const eN = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], tN = je("loader-circle", eN);
const nN = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], dk = je("lock", nN);
const rN = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      key: "1sd12s"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], iN = je("message-circle-question-mark", rN);
const oN = [["path", { d: "M5 12h14", key: "1ays0h" }]], aN = je("minus", oN);
const sN = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], lN = je("palette", sN);
const uN = [
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
      key: "1miecu"
    }
  ]
], cN = je("paperclip", uN);
const dN = [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  [
    "path",
    { d: "M17 8a1 1 0 0 1 1 1v4a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1z", key: "1xoxul" }
  ],
  ["path", { d: "M9 8V2", key: "14iosj" }]
], fN = je("plug", dN);
const hN = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], pN = je("plus", hN);
const mN = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], gN = je("search", mN);
const yN = [
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["path", { d: "M19 7h-9", key: "6i9tg" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
], vN = je("settings-2", yN);
const bN = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], mp = je("shield-check", bN);
const _N = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
], gp = je("shield", _N);
const wN = [
  ["path", { d: "M10 5H3", key: "1qgfaw" }],
  ["path", { d: "M12 19H3", key: "yhmn1j" }],
  ["path", { d: "M14 3v4", key: "1sua03" }],
  ["path", { d: "M16 17v4", key: "1q0r14" }],
  ["path", { d: "M21 12h-9", key: "1o4lsq" }],
  ["path", { d: "M21 19h-5", key: "1rlt1p" }],
  ["path", { d: "M21 5h-7", key: "1oszz2" }],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M8 12H3", key: "a7s4jb" }]
], kN = je("sliders-horizontal", wN);
const SN = [
  [
    "path",
    {
      d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
      key: "1s2grr"
    }
  ],
  ["path", { d: "M20 2v4", key: "1rf3ol" }],
  ["path", { d: "M22 4h-4", key: "gwowj6" }],
  ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
], fk = je("sparkles", SN);
const xN = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
], IN = je("split", xN);
const PN = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
], ON = je("star", PN);
const zN = [
  ["path", { d: "M10 11v6", key: "nco0om" }],
  ["path", { d: "M14 11v6", key: "outv1u" }],
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], EN = je("trash-2", zN);
const TN = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], sc = je("triangle-alert", TN);
const NN = [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
], CN = je("workflow", NN);
const DN = [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
      key: "1ngwbx"
    }
  ]
], yp = je("wrench", DN);
const AN = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], vp = je("x", AN);
function Be(...e) {
  return e.filter(Boolean).join(" ");
}
function un({ children: e, className: t }) {
  return /* @__PURE__ */ x(
    "span",
    {
      className: Be(
        "text-[11px] font-medium uppercase tracking-wide text-muted-foreground",
        t
      ),
      children: e
    }
  );
}
function jN({
  title: e,
  defaultOpen: t = !1,
  children: n
}) {
  const [r, i] = Ae(t);
  return /* @__PURE__ */ te("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ te(
      "button",
      {
        type: "button",
        onClick: () => i(!r),
        className: "-ml-0.5 flex items-center gap-1 py-0.5 text-left",
        children: [
          /* @__PURE__ */ x(
            lk,
            {
              className: Be("size-3.5 text-muted-foreground transition-transform", r && "rotate-90")
            }
          ),
          /* @__PURE__ */ x(un, { children: e })
        ]
      }
    ),
    r && /* @__PURE__ */ x("div", { className: "pt-1.5", children: n })
  ] });
}
function hk({
  cue: e,
  size: t = "lg",
  hint: n,
  action: r,
  className: i,
  children: a
}) {
  const { mascot: o } = dt().branding, d = e !== void 0 || n !== void 0 || r !== void 0;
  return /* @__PURE__ */ te(
    "div",
    {
      className: Be(
        "flex h-full w-full flex-col items-center justify-center gap-2 p-6 text-center",
        i
      ),
      children: [
        e && o?.({ cue: e, size: t }),
        /* @__PURE__ */ x(
          "p",
          {
            className: Be(
              "m-0 text-xs",
              d ? "font-medium text-foreground" : "text-muted-foreground"
            ),
            children: a
          }
        ),
        n && /* @__PURE__ */ x("p", { className: "m-0 max-w-[20rem] text-[11px] leading-relaxed text-muted-foreground", children: n }),
        r
      ]
    }
  );
}
const MN = (e) => e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
function $N(e) {
  return MN(e).replace(
    /("(?:\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*"(?:\s*:)?|\b(?:true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g,
    (t) => {
      let n = "jsonNum";
      return t.startsWith('"') ? n = /:\s*$/.test(t) ? "jsonKey" : "jsonStr" : t === "true" || t === "false" ? n = "jsonBool" : t === "null" && (n = "jsonNull"), `<span class="${n}">${t}</span>`;
    }
  );
}
function ad({ data: e, maxHeight: t = 200 }) {
  if (e == null) return null;
  const n = t == null ? void 0 : { maxHeight: t };
  let r, i = !0;
  if (typeof e == "string")
    try {
      r = JSON.stringify(JSON.parse(e), null, 2);
    } catch {
      r = e, i = !1;
    }
  else
    r = JSON.stringify(e, null, 2);
  const a = "agentic-json m-0 overflow-auto whitespace-pre-wrap break-words rounded-md border border-border-light bg-muted/40 p-2.5 text-[11px] leading-relaxed";
  return i ? /* @__PURE__ */ x(
    "pre",
    {
      className: a,
      style: n,
      dangerouslySetInnerHTML: { __html: $N(r) }
    }
  ) : /* @__PURE__ */ x("pre", { className: a, style: n, children: r });
}
const RN = je("layout-dashboard-sparkle", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "tl" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "tr" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "bl" }],
  [
    "path",
    {
      d: "M17.5 12.5 18.6 15.4 21.5 16.5 18.6 17.6 17.5 20.5 16.4 17.6 13.5 16.5 16.4 15.4Z",
      key: "spark"
    }
  ]
]), Po = {
  agent: { Icon: xT, color: "var(--primary)", tile: "bg-primary/12 text-primary" },
  "ref-agent": { Icon: PT, color: "var(--primary)", tile: "bg-primary/12 text-primary" },
  workflow: {
    Icon: CN,
    color: "var(--badge-lime-foreground)",
    tile: "bg-badge-lime text-badge-lime-foreground"
  },
  tool: {
    Icon: yp,
    color: "var(--badge-blue-foreground)",
    tile: "bg-badge-blue text-badge-blue-foreground"
  },
  guardrail: {
    Icon: gp,
    color: "var(--badge-purple-foreground)",
    tile: "bg-badge-purple text-badge-purple-foreground"
  },
  connector: {
    Icon: fN,
    color: "var(--badge-pink-foreground)",
    tile: "bg-badge-pink text-badge-pink-foreground"
  },
  // A yellow gauge, deliberately unlike the purple guardrail shield: a scorer
  // measures output quality, it never gates the run.
  scorer: {
    Icon: ck,
    color: "var(--badge-yellow-foreground)",
    tile: "bg-badge-yellow text-badge-yellow-foreground"
  },
  // Tools underneath, told apart because what they read is the point of attaching them. Brand
  // shares the workflow hue, which never sits on the same canvas.
  "knowledge-base": {
    Icon: kT,
    color: "var(--badge-orange-foreground)",
    tile: "bg-badge-orange text-badge-orange-foreground"
  },
  "brand-guidelines": {
    Icon: lN,
    color: "var(--badge-lime-foreground)",
    tile: "bg-badge-lime text-badge-lime-foreground"
  },
  // A widget is a tool its agent calls, so it shares the tool hue; the dashboard glyph sets it apart.
  widget: {
    Icon: WT,
    color: "var(--badge-blue-foreground)",
    tile: "bg-badge-blue text-badge-blue-foreground"
  },
  "generative-widget": {
    Icon: RN,
    color: "var(--badge-blue-foreground)",
    tile: "bg-badge-blue text-badge-blue-foreground"
  }
};
function ZN(e, t) {
  switch (e) {
    case "agent":
      return t("entity.agent", "Agent");
    case "ref-agent":
      return t("entity.refAgent", "Existing agent");
    case "workflow":
      return t("entity.workflow", "Workflow");
    case "tool":
      return t("entity.tool", "Tool");
    case "guardrail":
      return t("entity.guardrail", "Guardrail");
    case "connector":
      return t("entity.connector", "Connector");
    case "scorer":
      return t("entity.scorer", "Scorer");
    case "knowledge-base":
      return t("entity.knowledgeBase", "Knowledge base");
    case "brand-guidelines":
      return t("entity.brandGuidelines", "Brand guidelines");
    case "widget":
      return t("entity.widget", "Widget");
    case "generative-widget":
      return t("entity.generativeWidget", "Generative widgets");
  }
}
const pk = {
  sm: { box: "size-6", icon: "size-3.5" },
  md: { box: "size-7", icon: "size-4" },
  lg: { box: "size-9", icon: "size-[18px]" }
};
function LN(e) {
  return pk[e].box;
}
function Wo({
  type: e,
  size: t = "sm",
  shape: n = "square",
  className: r
}) {
  const { Icon: i, tile: a } = Po[e], o = pk[t];
  return /* @__PURE__ */ x(
    "span",
    {
      className: Be(
        "flex shrink-0 items-center justify-center",
        n === "circle" ? "rounded-full" : "rounded-md",
        o.box,
        a,
        r
      ),
      children: /* @__PURE__ */ x(i, { className: o.icon })
    }
  );
}
Wt(null);
function mk(e, {
  direction: t,
  bounds: n,
  onResize: r
}) {
  return Ye(
    (i) => {
      const a = e.current;
      if (!r || !a) return;
      i.preventDefault();
      const o = i.clientX, d = a.offsetWidth, { min: u, max: l } = n(a), c = (s) => {
        r(
          Math.round(Math.max(u, Math.min(l, d + t * (s.clientX - o))))
        );
      }, f = () => {
        window.removeEventListener("mousemove", c), window.removeEventListener("mouseup", f), document.body.style.cursor = "", document.body.style.userSelect = "";
      };
      document.body.style.cursor = "ew-resize", document.body.style.userSelect = "none", window.addEventListener("mousemove", c), window.addEventListener("mouseup", f);
    },
    [e, t, n, r]
  );
}
const FN = 32, UN = 200, BN = 160, sd = 16;
function bp({
  side: e,
  anchor: t = "top",
  fill: n = !1,
  bare: r = !1,
  children: i,
  className: a,
  ariaLabel: o,
  role: d,
  resize: u,
  top: l = sd
}) {
  const c = Ce(null), f = Re(), s = u?.minWidth ?? UN, h = Ye(
    (_) => {
      const g = _.offsetParent;
      return { min: s, max: (g ? g.clientWidth : window.innerWidth) - 48 };
    },
    [s]
  ), p = mk(c, {
    direction: e === "left" ? 1 : -1,
    bounds: h,
    onResize: u?.onResize
  }), m = l + sd, y = Ye(
    (_) => {
      if (!u?.onResizeHeight) return;
      _.preventDefault();
      const g = c.current;
      if (!g) return;
      const O = _.clientY, P = g.offsetHeight, E = u.minHeight ?? BN, T = g.offsetParent, D = (T ? T.clientHeight : window.innerHeight) - m, N = t === "bottom" ? -1 : 1, M = u.onResizeHeight, R = (C) => {
        const B = Math.round(
          Math.max(E, Math.min(D, P + N * (C.clientY - O)))
        );
        M(B);
      }, V = () => {
        window.removeEventListener("mousemove", R), window.removeEventListener("mouseup", V), document.body.style.cursor = "", document.body.style.userSelect = "";
      };
      document.body.style.cursor = "ns-resize", document.body.style.userSelect = "none", window.addEventListener("mousemove", R), window.addEventListener("mouseup", V);
    },
    [u, t, m]
  ), w = !n && u?.height != null, b = !n && t === "top";
  return /* @__PURE__ */ te(
    "div",
    {
      ref: c,
      role: d,
      "aria-label": o,
      style: {
        ...u ? { width: u.width } : {},
        ...w ? { height: u?.height } : {},
        // Hugging its content or at an explicit height, it stops at the bottom gutter.
        ...b ? { top: l, maxHeight: `calc(100% - ${m}px)` } : {},
        ...!n && t === "bottom" ? { maxHeight: `calc(100% - ${2 * sd}px)` } : {}
      },
      className: Be(
        "absolute z-20 flex flex-col",
        !r && "agentic-panel overflow-hidden",
        n ? "top-4 bottom-4" : t === "bottom" && "bottom-4",
        e === "left" ? "left-4" : "right-4",
        a
      ),
      children: [
        i,
        u && /* @__PURE__ */ x(
          "span",
          {
            role: "separator",
            "aria-orientation": "vertical",
            "aria-label": f("canvas.resizeWidth", "Resize panel width"),
            onMouseDown: p,
            className: Be(
              "group absolute top-1/2 z-30 flex w-3 -translate-y-1/2 cursor-ew-resize touch-none items-center justify-center py-4",
              e === "left" ? "right-0" : "left-0"
            ),
            children: /* @__PURE__ */ x("span", { className: "h-10 w-1 rounded-full bg-border-light transition-colors group-hover:bg-primary/60" })
          }
        ),
        u?.onResizeHeight && !n && /* @__PURE__ */ x(
          "span",
          {
            role: "separator",
            "aria-orientation": "horizontal",
            "aria-label": f("canvas.resizeHeight", "Resize panel height"),
            onMouseDown: y,
            className: Be(
              "group absolute left-1/2 z-30 flex h-3 -translate-x-1/2 cursor-ns-resize touch-none items-center justify-center px-4",
              t === "bottom" ? "top-0" : "bottom-0"
            ),
            children: /* @__PURE__ */ x("span", { className: "h-1 w-10 rounded-full bg-border-light transition-colors group-hover:bg-primary/60" })
          }
        )
      ]
    }
  );
}
const Zy = 16;
function VN({
  width: e,
  minWidth: t,
  maxWidth: n,
  defaultWidth: r = 400,
  onResize: i,
  className: a,
  children: o
}) {
  const d = Re(), u = Ce(null), l = (h) => Math.max(t, Math.min(n, h)), c = Ye(() => ({ min: t, max: n }), [t, n]), f = mk(u, { direction: 1, bounds: c, onResize: i }), s = (h) => {
    h.key !== "ArrowLeft" && h.key !== "ArrowRight" || (h.preventDefault(), i(l(e + (h.key === "ArrowRight" ? Zy : -Zy))));
  };
  return /* @__PURE__ */ te(
    "div",
    {
      ref: u,
      style: { width: e },
      className: Be(
        "agentic-dock relative flex h-full shrink-0 flex-col overflow-hidden",
        a
      ),
      children: [
        o,
        /* @__PURE__ */ x(
          "span",
          {
            role: "separator",
            tabIndex: 0,
            "aria-orientation": "vertical",
            "aria-valuenow": e,
            "aria-valuemin": t,
            "aria-valuemax": n,
            "aria-label": d("canvas.resizeWidth", "Resize panel width"),
            onMouseDown: f,
            onKeyDown: s,
            onDoubleClick: () => i(l(r)),
            className: "group absolute top-1/2 right-0 z-30 flex w-3 -translate-y-1/2 cursor-ew-resize touch-none items-center justify-center py-4",
            children: /* @__PURE__ */ x("span", { className: "h-10 w-1 rounded-full bg-border-light transition-colors group-hover:bg-primary/60" })
          }
        )
      ]
    }
  );
}
function qN(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const HN = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, WN = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, GN = {};
function Ly(e, t) {
  return (GN.jsx ? WN : HN).test(e);
}
const KN = /[ \t\n\f\r]/g;
function JN(e) {
  return typeof e == "object" ? e.type === "text" ? Fy(e.value) : !1 : Fy(e);
}
function Fy(e) {
  return e.replace(KN, "") === "";
}
class sl {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
sl.prototype.normal = {};
sl.prototype.property = {};
sl.prototype.space = void 0;
function gk(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new sl(n, r, t);
}
function th(e) {
  return e.toLowerCase();
}
class Gt {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
Gt.prototype.attribute = "";
Gt.prototype.booleanish = !1;
Gt.prototype.boolean = !1;
Gt.prototype.commaOrSpaceSeparated = !1;
Gt.prototype.commaSeparated = !1;
Gt.prototype.defined = !1;
Gt.prototype.mustUseProperty = !1;
Gt.prototype.number = !1;
Gt.prototype.overloadedBoolean = !1;
Gt.prototype.property = "";
Gt.prototype.spaceSeparated = !1;
Gt.prototype.space = void 0;
let XN = 0;
const Me = si(), yt = si(), yk = si(), ge = si(), ot = si(), Oo = si(), Yt = si();
function si() {
  return 2 ** ++XN;
}
const nh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Me,
  booleanish: yt,
  commaOrSpaceSeparated: Yt,
  commaSeparated: Oo,
  number: ge,
  overloadedBoolean: yk,
  spaceSeparated: ot
}, Symbol.toStringTag, { value: "Module" })), ld = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(nh)
);
class _p extends Gt {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), Uy(this, "space", i), typeof r == "number")
      for (; ++a < ld.length; ) {
        const o = ld[a];
        Uy(this, ld[a], (r & nh[o]) === nh[o]);
      }
  }
}
_p.prototype.defined = !0;
function Uy(e, t, n) {
  n && (e[t] = n);
}
function Go(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const a = new _p(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[th(r)] = r, n[th(a.attribute)] = r;
  }
  return new sl(t, n, e.space);
}
const vk = Go({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: yt,
    ariaAutoComplete: null,
    ariaBusy: yt,
    ariaChecked: yt,
    ariaColCount: ge,
    ariaColIndex: ge,
    ariaColSpan: ge,
    ariaControls: ot,
    ariaCurrent: null,
    ariaDescribedBy: ot,
    ariaDetails: null,
    ariaDisabled: yt,
    ariaDropEffect: ot,
    ariaErrorMessage: null,
    ariaExpanded: yt,
    ariaFlowTo: ot,
    ariaGrabbed: yt,
    ariaHasPopup: null,
    ariaHidden: yt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ot,
    ariaLevel: ge,
    ariaLive: null,
    ariaModal: yt,
    ariaMultiLine: yt,
    ariaMultiSelectable: yt,
    ariaOrientation: null,
    ariaOwns: ot,
    ariaPlaceholder: null,
    ariaPosInSet: ge,
    ariaPressed: yt,
    ariaReadOnly: yt,
    ariaRelevant: null,
    ariaRequired: yt,
    ariaRoleDescription: ot,
    ariaRowCount: ge,
    ariaRowIndex: ge,
    ariaRowSpan: ge,
    ariaSelected: yt,
    ariaSetSize: ge,
    ariaSort: null,
    ariaValueMax: ge,
    ariaValueMin: ge,
    ariaValueNow: ge,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function bk(e, t) {
  return t in e ? e[t] : t;
}
function _k(e, t) {
  return bk(e, t.toLowerCase());
}
const YN = Go({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Oo,
    acceptCharset: ot,
    accessKey: ot,
    action: null,
    allow: null,
    allowFullScreen: Me,
    allowPaymentRequest: Me,
    allowUserMedia: Me,
    alt: null,
    as: null,
    async: Me,
    autoCapitalize: null,
    autoComplete: ot,
    autoFocus: Me,
    autoPlay: Me,
    blocking: ot,
    capture: null,
    charSet: null,
    checked: Me,
    cite: null,
    className: ot,
    cols: ge,
    colSpan: null,
    content: null,
    contentEditable: yt,
    controls: Me,
    controlsList: ot,
    coords: ge | Oo,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Me,
    defer: Me,
    dir: null,
    dirName: null,
    disabled: Me,
    download: yk,
    draggable: yt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Me,
    formTarget: null,
    headers: ot,
    height: ge,
    hidden: Me,
    high: ge,
    href: null,
    hrefLang: null,
    htmlFor: ot,
    httpEquiv: ot,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Me,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Me,
    itemId: null,
    itemProp: ot,
    itemRef: ot,
    itemScope: Me,
    itemType: ot,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Me,
    low: ge,
    manifest: null,
    max: null,
    maxLength: ge,
    media: null,
    method: null,
    min: null,
    minLength: ge,
    multiple: Me,
    muted: Me,
    name: null,
    nonce: null,
    noModule: Me,
    noValidate: Me,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Me,
    optimum: ge,
    pattern: null,
    ping: ot,
    placeholder: null,
    playsInline: Me,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Me,
    referrerPolicy: null,
    rel: ot,
    required: Me,
    reversed: Me,
    rows: ge,
    rowSpan: ge,
    sandbox: ot,
    scope: null,
    scoped: Me,
    seamless: Me,
    selected: Me,
    shadowRootClonable: Me,
    shadowRootDelegatesFocus: Me,
    shadowRootMode: null,
    shape: null,
    size: ge,
    sizes: null,
    slot: null,
    span: ge,
    spellCheck: yt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: ge,
    step: null,
    style: null,
    tabIndex: ge,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Me,
    useMap: null,
    value: yt,
    width: ge,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ot,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: ge,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: ge,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Me,
    // Lists. Use CSS to reduce space between items instead
    declare: Me,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: ge,
    // `<img>` and `<object>`
    leftMargin: ge,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: ge,
    // `<body>`
    marginWidth: ge,
    // `<body>`
    noResize: Me,
    // `<frame>`
    noHref: Me,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Me,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Me,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: ge,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: yt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: ge,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: ge,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Me,
    disableRemotePlayback: Me,
    prefix: null,
    property: null,
    results: ge,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: _k
}), QN = Go({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Yt,
    accentHeight: ge,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: ge,
    amplitude: ge,
    arabicForm: null,
    ascent: ge,
    attributeName: null,
    attributeType: null,
    azimuth: ge,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: ge,
    by: null,
    calcMode: null,
    capHeight: ge,
    className: ot,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: ge,
    diffuseConstant: ge,
    direction: null,
    display: null,
    dur: null,
    divisor: ge,
    dominantBaseline: null,
    download: Me,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: ge,
    enableBackground: null,
    end: null,
    event: null,
    exponent: ge,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: ge,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Oo,
    g2: Oo,
    glyphName: Oo,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: ge,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: ge,
    horizOriginX: ge,
    horizOriginY: ge,
    id: null,
    ideographic: ge,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: ge,
    k: ge,
    k1: ge,
    k2: ge,
    k3: ge,
    k4: ge,
    kernelMatrix: Yt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: ge,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: ge,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: ge,
    overlineThickness: ge,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: ge,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ot,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: ge,
    pointsAtY: ge,
    pointsAtZ: ge,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Yt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Yt,
    rev: Yt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Yt,
    requiredFeatures: Yt,
    requiredFonts: Yt,
    requiredFormats: Yt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: ge,
    specularExponent: ge,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: ge,
    strikethroughThickness: ge,
    string: null,
    stroke: null,
    strokeDashArray: Yt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: ge,
    strokeOpacity: ge,
    strokeWidth: null,
    style: null,
    surfaceScale: ge,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Yt,
    tabIndex: ge,
    tableValues: null,
    target: null,
    targetX: ge,
    targetY: ge,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Yt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: ge,
    underlineThickness: ge,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: ge,
    values: null,
    vAlphabetic: ge,
    vMathematical: ge,
    vectorEffect: null,
    vHanging: ge,
    vIdeographic: ge,
    version: null,
    vertAdvY: ge,
    vertOriginX: ge,
    vertOriginY: ge,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: ge,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: bk
}), wk = Go({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), kk = Go({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: _k
}), Sk = Go({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), eC = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, tC = /[A-Z]/g, By = /-[a-z]/g, nC = /^data[-\w.:]+$/i;
function rC(e, t) {
  const n = th(t);
  let r = t, i = Gt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && nC.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(By, oC);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!By.test(a)) {
        let o = a.replace(tC, iC);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = _p;
  }
  return new i(r, t);
}
function iC(e) {
  return "-" + e.toLowerCase();
}
function oC(e) {
  return e.charAt(1).toUpperCase();
}
const aC = gk([vk, YN, wk, kk, Sk], "html"), wp = gk([vk, QN, wk, kk, Sk], "svg");
function sC(e) {
  return e.join(" ").trim();
}
var fo = {}, ud, Vy;
function lC() {
  if (Vy) return ud;
  Vy = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, a = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, o = /^[;\s]*/, d = /^\s+|\s+$/g, u = `
`, l = "/", c = "*", f = "", s = "comment", h = "declaration";
  ud = function(m, y) {
    if (typeof m != "string")
      throw new TypeError("First argument must be a string");
    if (!m) return [];
    y = y || {};
    var w = 1, b = 1;
    function _(V) {
      var C = V.match(t);
      C && (w += C.length);
      var B = V.lastIndexOf(u);
      b = ~B ? V.length - B : b + V.length;
    }
    function g() {
      var V = { line: w, column: b };
      return function(C) {
        return C.position = new O(V), T(), C;
      };
    }
    function O(V) {
      this.start = V, this.end = { line: w, column: b }, this.source = y.source;
    }
    O.prototype.content = m;
    function P(V) {
      var C = new Error(
        y.source + ":" + w + ":" + b + ": " + V
      );
      if (C.reason = V, C.filename = y.source, C.line = w, C.column = b, C.source = m, !y.silent) throw C;
    }
    function E(V) {
      var C = V.exec(m);
      if (C) {
        var B = C[0];
        return _(B), m = m.slice(B.length), C;
      }
    }
    function T() {
      E(n);
    }
    function D(V) {
      var C;
      for (V = V || []; C = N(); )
        C !== !1 && V.push(C);
      return V;
    }
    function N() {
      var V = g();
      if (!(l != m.charAt(0) || c != m.charAt(1))) {
        for (var C = 2; f != m.charAt(C) && (c != m.charAt(C) || l != m.charAt(C + 1)); )
          ++C;
        if (C += 2, f === m.charAt(C - 1))
          return P("End of comment missing");
        var B = m.slice(2, C - 2);
        return b += 2, _(B), m = m.slice(C), b += 2, V({
          type: s,
          comment: B
        });
      }
    }
    function M() {
      var V = g(), C = E(r);
      if (C) {
        if (N(), !E(i)) return P("property missing ':'");
        var B = E(a), G = V({
          type: h,
          property: p(C[0].replace(e, f)),
          value: B ? p(B[0].replace(e, f)) : f
        });
        return E(o), G;
      }
    }
    function R() {
      var V = [];
      D(V);
      for (var C; C = M(); )
        C !== !1 && (V.push(C), D(V));
      return V;
    }
    return T(), R();
  };
  function p(m) {
    return m ? m.replace(d, f) : f;
  }
  return ud;
}
var qy;
function uC() {
  if (qy) return fo;
  qy = 1;
  var e = fo && fo.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(fo, "__esModule", { value: !0 }), fo.default = n;
  var t = e(lC());
  function n(r, i) {
    var a = null;
    if (!r || typeof r != "string")
      return a;
    var o = (0, t.default)(r), d = typeof i == "function";
    return o.forEach(function(u) {
      if (u.type === "declaration") {
        var l = u.property, c = u.value;
        d ? i(l, c, u) : c && (a = a || {}, a[l] = c);
      }
    }), a;
  }
  return fo;
}
var xa = {}, Hy;
function cC() {
  if (Hy) return xa;
  Hy = 1, Object.defineProperty(xa, "__esModule", { value: !0 }), xa.camelCase = void 0;
  var e = /^--[a-zA-Z0-9_-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, i = /^-(ms)-/, a = function(l) {
    return !l || n.test(l) || e.test(l);
  }, o = function(l, c) {
    return c.toUpperCase();
  }, d = function(l, c) {
    return "".concat(c, "-");
  }, u = function(l, c) {
    return c === void 0 && (c = {}), a(l) ? l : (l = l.toLowerCase(), c.reactCompat ? l = l.replace(i, d) : l = l.replace(r, d), l.replace(t, o));
  };
  return xa.camelCase = u, xa;
}
var Ia, Wy;
function dC() {
  if (Wy) return Ia;
  Wy = 1;
  var e = Ia && Ia.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  }, t = e(uC()), n = cC();
  function r(i, a) {
    var o = {};
    return !i || typeof i != "string" || (0, t.default)(i, function(d, u) {
      d && u && (o[(0, n.camelCase)(d, a)] = u);
    }), o;
  }
  return r.default = r, Ia = r, Ia;
}
var fC = dC();
const hC = /* @__PURE__ */ up(fC), xk = Ik("end"), kp = Ik("start");
function Ik(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function pC(e) {
  const t = kp(e), n = xk(e);
  if (t && n)
    return { start: t, end: n };
}
function Ns(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Gy(e.position) : "start" in e || "end" in e ? Gy(e) : "line" in e || "column" in e ? rh(e) : "";
}
function rh(e) {
  return Ky(e && e.line) + ":" + Ky(e && e.column);
}
function Gy(e) {
  return rh(e && e.start) + "-" + rh(e && e.end);
}
function Ky(e) {
  return e && typeof e == "number" ? e : 1;
}
class Dt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", a = {}, o = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? i = t : !a.cause && t && (o = !0, i = t.message, a.cause = t), !a.ruleId && !a.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? a.ruleId = r : (a.source = r.slice(0, u), a.ruleId = r.slice(u + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const u = a.ancestors[a.ancestors.length - 1];
      u && (a.place = u.position);
    }
    const d = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = d ? d.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = d ? d.line : void 0, this.name = Ns(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Dt.prototype.file = "";
Dt.prototype.name = "";
Dt.prototype.reason = "";
Dt.prototype.message = "";
Dt.prototype.stack = "";
Dt.prototype.column = void 0;
Dt.prototype.line = void 0;
Dt.prototype.ancestors = void 0;
Dt.prototype.cause = void 0;
Dt.prototype.fatal = void 0;
Dt.prototype.place = void 0;
Dt.prototype.ruleId = void 0;
Dt.prototype.source = void 0;
const Sp = {}.hasOwnProperty, mC = /* @__PURE__ */ new Map(), gC = /[A-Z]/g, yC = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), vC = /* @__PURE__ */ new Set(["td", "th"]), Pk = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function bC(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = OC(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = PC(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? wp : aC,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, a = Ok(i, e, void 0);
  return a && typeof a != "string" ? a : i.create(
    e,
    i.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function Ok(e, t, n) {
  if (t.type === "element")
    return _C(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return wC(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return SC(e, t, n);
  if (t.type === "mdxjsEsm")
    return kC(e, t);
  if (t.type === "root")
    return xC(e, t, n);
  if (t.type === "text")
    return IC(e, t);
}
function _C(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = wp, e.schema = i), e.ancestors.push(t);
  const a = Ek(e, t.tagName, !1), o = zC(e, t);
  let d = Ip(e, t);
  return yC.has(t.tagName) && (d = d.filter(function(u) {
    return typeof u == "string" ? !JN(u) : !0;
  })), zk(e, o, a, t), xp(o, d), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function wC(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  Zs(e, t.position);
}
function kC(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  Zs(e, t.position);
}
function SC(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = wp, e.schema = i), e.ancestors.push(t);
  const a = t.name === null ? e.Fragment : Ek(e, t.name, !0), o = EC(e, t), d = Ip(e, t);
  return zk(e, o, a, t), xp(o, d), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function xC(e, t, n) {
  const r = {};
  return xp(r, Ip(e, t)), e.create(t, e.Fragment, r, n);
}
function IC(e, t) {
  return t.value;
}
function zk(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function xp(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function PC(e, t, n) {
  return r;
  function r(i, a, o, d) {
    const l = Array.isArray(o.children) ? n : t;
    return d ? l(a, o, d) : l(a, o);
  }
}
function OC(e, t) {
  return n;
  function n(r, i, a, o) {
    const d = Array.isArray(a.children), u = kp(r);
    return t(
      i,
      a,
      o,
      d,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function zC(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && Sp.call(t.properties, i)) {
      const a = TC(e, i, t.properties[i]);
      if (a) {
        const [o, d] = a;
        e.tableCellAlignToStyle && o === "align" && typeof d == "string" && vC.has(t.tagName) ? r = d : n[o] = d;
      }
    }
  if (r) {
    const a = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    a[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function EC(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const a = r.data.estree.body[0];
        a.type;
        const o = a.expression;
        o.type;
        const d = o.properties[0];
        d.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(d.argument)
        );
      } else
        Zs(e, t.position);
    else {
      const i = r.name;
      let a;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const d = r.value.data.estree.body[0];
          d.type, a = e.evaluater.evaluateExpression(d.expression);
        } else
          Zs(e, t.position);
      else
        a = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      a;
    }
  return n;
}
function Ip(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : mC;
  for (; ++r < t.children.length; ) {
    const a = t.children[r];
    let o;
    if (e.passKeys) {
      const u = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (u) {
        const l = i.get(u) || 0;
        o = u + "-" + l, i.set(u, l + 1);
      }
    }
    const d = Ok(e, a, o);
    d !== void 0 && n.push(d);
  }
  return n;
}
function TC(e, t, n) {
  const r = rC(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? qN(n) : sC(n)), r.property === "style") {
      let i = typeof n == "object" ? n : NC(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = CC(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? eC[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function NC(e, t) {
  try {
    return hC(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new Dt("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = Pk + "#cannot-parse-style-attribute", i;
  }
}
function Ek(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let a = -1, o;
    for (; ++a < i.length; ) {
      const d = Ly(i[a]) ? { type: "Identifier", name: i[a] } : { type: "Literal", value: i[a] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: d,
        computed: !!(a && d.type === "Literal"),
        optional: !1
      } : d;
    }
    r = o;
  } else
    r = Ly(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return Sp.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  Zs(e);
}
function Zs(e, t) {
  const n = new Dt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = Pk + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function CC(e) {
  const t = {};
  let n;
  for (n in e)
    Sp.call(e, n) && (t[DC(n)] = e[n]);
  return t;
}
function DC(e) {
  let t = e.replace(gC, AC);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function AC(e) {
  return "-" + e.toLowerCase();
}
const cd = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, jC = {};
function Pp(e, t) {
  const n = jC, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Tk(e, r, i);
}
function Tk(e, t, n) {
  if (MC(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Jy(e.children, t, n);
  }
  return Array.isArray(e) ? Jy(e, t, n) : "";
}
function Jy(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Tk(e[i], t, n);
  return r.join("");
}
function MC(e) {
  return !!(e && typeof e == "object");
}
const Xy = document.createElement("i");
function Op(e) {
  const t = "&" + e + ";";
  Xy.innerHTML = t;
  const n = Xy.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function rn(e, t, n, r) {
  const i = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); a < r.length; )
      o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function ln(e, t) {
  return e.length > 0 ? (rn(e, e.length, 0, t), e) : t;
}
const Yy = {}.hasOwnProperty;
function Nk(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    $C(t, e[n]);
  return t;
}
function $C(e, t) {
  let n;
  for (n in t) {
    const i = (Yy.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let o;
    if (a)
      for (o in a) {
        Yy.call(i, o) || (i[o] = []);
        const d = a[o];
        RC(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(d) ? d : d ? [d] : []
        );
      }
  }
}
function RC(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  rn(e, 0, 0, r);
}
function Ck(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function zn(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const $t = Er(/[A-Za-z]/), Nt = Er(/[\dA-Za-z]/), ZC = Er(/[#-'*+\--9=?A-Z^-~]/);
function bu(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ih = Er(/\d/), LC = Er(/[\dA-Fa-f]/), FC = Er(/[!-/:-@[-`{-~]/);
function ze(e) {
  return e !== null && e < -2;
}
function rt(e) {
  return e !== null && (e < 0 || e === 32);
}
function Fe(e) {
  return e === -2 || e === -1 || e === 32;
}
const lc = Er(new RegExp("\\p{P}|\\p{S}", "u")), ti = Er(/\s/);
function Er(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Ko(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const a = e.charCodeAt(n);
    let o = "";
    if (a === 37 && Nt(e.charCodeAt(n + 1)) && Nt(e.charCodeAt(n + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const d = e.charCodeAt(n + 1);
      a < 56320 && d > 56319 && d < 57344 ? (o = String.fromCharCode(a, d), i = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function He(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(u) {
    return Fe(u) ? (e.enter(n), d(u)) : t(u);
  }
  function d(u) {
    return Fe(u) && a++ < i ? (e.consume(u), d) : (e.exit(n), t(u));
  }
}
const UC = {
  tokenize: BC
};
function BC(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(d) {
    if (d === null) {
      e.consume(d);
      return;
    }
    return e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), He(e, t, "linePrefix");
  }
  function i(d) {
    return e.enter("paragraph"), a(d);
  }
  function a(d) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, o(d);
  }
  function o(d) {
    if (d === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(d);
      return;
    }
    return ze(d) ? (e.consume(d), e.exit("chunkText"), a) : (e.consume(d), o);
  }
}
const VC = {
  tokenize: qC
}, Qy = {
  tokenize: HC
};
function qC(e) {
  const t = this, n = [];
  let r = 0, i, a, o;
  return d;
  function d(_) {
    if (r < n.length) {
      const g = n[r];
      return t.containerState = g[1], e.attempt(g[0].continuation, u, l)(_);
    }
    return l(_);
  }
  function u(_) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && b();
      const g = t.events.length;
      let O = g, P;
      for (; O--; )
        if (t.events[O][0] === "exit" && t.events[O][1].type === "chunkFlow") {
          P = t.events[O][1].end;
          break;
        }
      w(r);
      let E = g;
      for (; E < t.events.length; )
        t.events[E][1].end = {
          ...P
        }, E++;
      return rn(t.events, O + 1, 0, t.events.slice(g)), t.events.length = E, l(_);
    }
    return d(_);
  }
  function l(_) {
    if (r === n.length) {
      if (!i)
        return s(_);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return p(_);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Qy, c, f)(_);
  }
  function c(_) {
    return i && b(), w(r), s(_);
  }
  function f(_) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, p(_);
  }
  function s(_) {
    return t.containerState = {}, e.attempt(Qy, h, p)(_);
  }
  function h(_) {
    return r++, n.push([t.currentConstruct, t.containerState]), s(_);
  }
  function p(_) {
    if (_ === null) {
      i && b(), w(0), e.consume(_);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: a
    }), m(_);
  }
  function m(_) {
    if (_ === null) {
      y(e.exit("chunkFlow"), !0), w(0), e.consume(_);
      return;
    }
    return ze(_) ? (e.consume(_), y(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, d) : (e.consume(_), m);
  }
  function y(_, g) {
    const O = t.sliceStream(_);
    if (g && O.push(null), _.previous = a, a && (a.next = _), a = _, i.defineSkip(_.start), i.write(O), t.parser.lazy[_.start.line]) {
      let P = i.events.length;
      for (; P--; )
        if (
          // The token starts before the line ending…
          i.events[P][1].start.offset < o && // …and either is not ended yet…
          (!i.events[P][1].end || // …or ends after it.
          i.events[P][1].end.offset > o)
        )
          return;
      const E = t.events.length;
      let T = E, D, N;
      for (; T--; )
        if (t.events[T][0] === "exit" && t.events[T][1].type === "chunkFlow") {
          if (D) {
            N = t.events[T][1].end;
            break;
          }
          D = !0;
        }
      for (w(r), P = E; P < t.events.length; )
        t.events[P][1].end = {
          ...N
        }, P++;
      rn(t.events, T + 1, 0, t.events.slice(E)), t.events.length = P;
    }
  }
  function w(_) {
    let g = n.length;
    for (; g-- > _; ) {
      const O = n[g];
      t.containerState = O[1], O[0].exit.call(t, e);
    }
    n.length = _;
  }
  function b() {
    i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function HC(e, t, n) {
  return He(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Co(e) {
  if (e === null || rt(e) || ti(e))
    return 1;
  if (lc(e))
    return 2;
}
function uc(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (t = a(t, n), r.push(a));
  }
  return t;
}
const oh = {
  name: "attention",
  resolveAll: WC,
  tokenize: GC
};
function WC(e, t) {
  let n = -1, r, i, a, o, d, u, l, c;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[r][1].end
          }, s = {
            ...e[n][1].start
          };
          ev(f, -u), ev(s, u), o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[r][1].end
            }
          }, d = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: s
          }, a = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...d.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...d.end
          }, l = [], e[r][1].end.offset - e[r][1].start.offset && (l = ln(l, [["enter", e[r][1], t], ["exit", e[r][1], t]])), l = ln(l, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["enter", a, t]]), l = ln(l, uc(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), l = ln(l, [["exit", a, t], ["enter", d, t], ["exit", d, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (c = 2, l = ln(l, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : c = 0, rn(e, r - 1, n - r + 3, l), n = r + l.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function GC(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Co(r);
  let a;
  return o;
  function o(u) {
    return a = u, e.enter("attentionSequence"), d(u);
  }
  function d(u) {
    if (u === a)
      return e.consume(u), d;
    const l = e.exit("attentionSequence"), c = Co(u), f = !c || c === 2 && i || n.includes(u), s = !i || i === 2 && c || n.includes(r);
    return l._open = !!(a === 42 ? f : f && (i || !s)), l._close = !!(a === 42 ? s : s && (c || !f)), t(u);
  }
}
function ev(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const KC = {
  name: "autolink",
  tokenize: JC
};
function JC(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(h) {
    return $t(h) ? (e.consume(h), o) : h === 64 ? n(h) : l(h);
  }
  function o(h) {
    return h === 43 || h === 45 || h === 46 || Nt(h) ? (r = 1, d(h)) : l(h);
  }
  function d(h) {
    return h === 58 ? (e.consume(h), r = 0, u) : (h === 43 || h === 45 || h === 46 || Nt(h)) && r++ < 32 ? (e.consume(h), d) : (r = 0, l(h));
  }
  function u(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || bu(h) ? n(h) : (e.consume(h), u);
  }
  function l(h) {
    return h === 64 ? (e.consume(h), c) : ZC(h) ? (e.consume(h), l) : n(h);
  }
  function c(h) {
    return Nt(h) ? f(h) : n(h);
  }
  function f(h) {
    return h === 46 ? (e.consume(h), r = 0, c) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : s(h);
  }
  function s(h) {
    if ((h === 45 || Nt(h)) && r++ < 63) {
      const p = h === 45 ? s : f;
      return e.consume(h), p;
    }
    return n(h);
  }
}
const ll = {
  partial: !0,
  tokenize: XC
};
function XC(e, t, n) {
  return r;
  function r(a) {
    return Fe(a) ? He(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || ze(a) ? t(a) : n(a);
  }
}
const Dk = {
  continuation: {
    tokenize: QC
  },
  exit: e1,
  name: "blockQuote",
  tokenize: YC
};
function YC(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const d = r.containerState;
      return d.open || (e.enter("blockQuote", {
        _container: !0
      }), d.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return n(o);
  }
  function a(o) {
    return Fe(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function QC(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return Fe(o) ? He(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : a(o);
  }
  function a(o) {
    return e.attempt(Dk, t, n)(o);
  }
}
function e1(e) {
  e.exit("blockQuote");
}
const Ak = {
  name: "characterEscape",
  tokenize: t1
};
function t1(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return FC(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const jk = {
  name: "characterReference",
  tokenize: n1
};
function n1(e, t, n) {
  const r = this;
  let i = 0, a, o;
  return d;
  function d(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), a = 31, o = Nt, c(f));
  }
  function l(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = LC, c) : (e.enter("characterReferenceValue"), a = 7, o = ih, c(f));
  }
  function c(f) {
    if (f === 59 && i) {
      const s = e.exit("characterReferenceValue");
      return o === Nt && !Op(r.sliceSerialize(s)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(f) && i++ < a ? (e.consume(f), c) : n(f);
  }
}
const tv = {
  partial: !0,
  tokenize: i1
}, nv = {
  concrete: !0,
  name: "codeFenced",
  tokenize: r1
};
function r1(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: O
  };
  let a = 0, o = 0, d;
  return u;
  function u(P) {
    return l(P);
  }
  function l(P) {
    const E = r.events[r.events.length - 1];
    return a = E && E[1].type === "linePrefix" ? E[2].sliceSerialize(E[1], !0).length : 0, d = P, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c(P);
  }
  function c(P) {
    return P === d ? (o++, e.consume(P), c) : o < 3 ? n(P) : (e.exit("codeFencedFenceSequence"), Fe(P) ? He(e, f, "whitespace")(P) : f(P));
  }
  function f(P) {
    return P === null || ze(P) ? (e.exit("codeFencedFence"), r.interrupt ? t(P) : e.check(tv, m, g)(P)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), s(P));
  }
  function s(P) {
    return P === null || ze(P) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(P)) : Fe(P) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), He(e, h, "whitespace")(P)) : P === 96 && P === d ? n(P) : (e.consume(P), s);
  }
  function h(P) {
    return P === null || ze(P) ? f(P) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), p(P));
  }
  function p(P) {
    return P === null || ze(P) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(P)) : P === 96 && P === d ? n(P) : (e.consume(P), p);
  }
  function m(P) {
    return e.attempt(i, g, y)(P);
  }
  function y(P) {
    return e.enter("lineEnding"), e.consume(P), e.exit("lineEnding"), w;
  }
  function w(P) {
    return a > 0 && Fe(P) ? He(e, b, "linePrefix", a + 1)(P) : b(P);
  }
  function b(P) {
    return P === null || ze(P) ? e.check(tv, m, g)(P) : (e.enter("codeFlowValue"), _(P));
  }
  function _(P) {
    return P === null || ze(P) ? (e.exit("codeFlowValue"), b(P)) : (e.consume(P), _);
  }
  function g(P) {
    return e.exit("codeFenced"), t(P);
  }
  function O(P, E, T) {
    let D = 0;
    return N;
    function N(B) {
      return P.enter("lineEnding"), P.consume(B), P.exit("lineEnding"), M;
    }
    function M(B) {
      return P.enter("codeFencedFence"), Fe(B) ? He(P, R, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(B) : R(B);
    }
    function R(B) {
      return B === d ? (P.enter("codeFencedFenceSequence"), V(B)) : T(B);
    }
    function V(B) {
      return B === d ? (D++, P.consume(B), V) : D >= o ? (P.exit("codeFencedFenceSequence"), Fe(B) ? He(P, C, "whitespace")(B) : C(B)) : T(B);
    }
    function C(B) {
      return B === null || ze(B) ? (P.exit("codeFencedFence"), E(B)) : T(B);
    }
  }
}
function i1(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const dd = {
  name: "codeIndented",
  tokenize: a1
}, o1 = {
  partial: !0,
  tokenize: s1
};
function a1(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("codeIndented"), He(e, a, "linePrefix", 5)(l);
  }
  function a(l) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? o(l) : n(l);
  }
  function o(l) {
    return l === null ? u(l) : ze(l) ? e.attempt(o1, o, u)(l) : (e.enter("codeFlowValue"), d(l));
  }
  function d(l) {
    return l === null || ze(l) ? (e.exit("codeFlowValue"), o(l)) : (e.consume(l), d);
  }
  function u(l) {
    return e.exit("codeIndented"), t(l);
  }
}
function s1(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : ze(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : He(e, a, "linePrefix", 5)(o);
  }
  function a(o) {
    const d = r.events[r.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? t(o) : ze(o) ? i(o) : n(o);
  }
}
const l1 = {
  name: "codeText",
  previous: c1,
  resolve: u1,
  tokenize: d1
};
function u1(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function c1(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function d1(e, t, n) {
  let r = 0, i, a;
  return o;
  function o(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), d(f);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), r++, d) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (a = e.enter("codeTextSequence"), i = 0, c(f)) : ze(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), l(f));
  }
  function l(f) {
    return f === null || f === 32 || f === 96 || ze(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), l);
  }
  function c(f) {
    return f === 96 ? (e.consume(f), i++, c) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (a.type = "codeTextData", l(f));
  }
}
class f1 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const a = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Pa(this.left, r), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Pa(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Pa(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Pa(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Pa(this.left, n.reverse());
      }
  }
}
function Pa(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Mk(e) {
  const t = {};
  let n = -1, r, i, a, o, d, u, l;
  const c = new f1(e);
  for (; ++n < c.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = c.get(n), n && r[1].type === "chunkFlow" && c.get(n - 1)[1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, a = 0, a < u.length && u[a][1].type === "lineEndingBlank" && (a += 2), a < u.length && u[a][1].type === "content"))
      for (; ++a < u.length && u[a][1].type !== "content"; )
        u[a][1].type === "chunkText" && (u[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, h1(c, n)), n = t[n], l = !0);
    else if (r[1]._container) {
      for (a = n, i = void 0; a--; )
        if (o = c.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (c.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...c.get(i)[1].start
      }, d = c.slice(i, n), d.unshift(r), c.splice(i, n - i + 1, d));
    }
  }
  return rn(e, 0, Number.POSITIVE_INFINITY, c.slice(0)), !l;
}
function h1(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const a = [];
  let o = n._tokenizer;
  o || (o = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const d = o.events, u = [], l = {};
  let c, f, s = -1, h = n, p = 0, m = 0;
  const y = [m];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    a.push(i), h._tokenizer || (c = r.sliceStream(h), h.next || c.push(null), f && o.defineSkip(h.start), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(c), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), f = h, h = h.next;
  }
  for (h = n; ++s < d.length; )
    // Find a void token that includes a break.
    d[s][0] === "exit" && d[s - 1][0] === "enter" && d[s][1].type === d[s - 1][1].type && d[s][1].start.line !== d[s][1].end.line && (m = s + 1, y.push(m), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (o.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : y.pop(), s = y.length; s--; ) {
    const w = d.slice(y[s], y[s + 1]), b = a.pop();
    u.push([b, b + w.length - 1]), e.splice(b, 2, w);
  }
  for (u.reverse(), s = -1; ++s < u.length; )
    l[p + u[s][0]] = p + u[s][1], p += u[s][1] - u[s][0] - 1;
  return l;
}
const p1 = {
  resolve: g1,
  tokenize: y1
}, m1 = {
  partial: !0,
  tokenize: v1
};
function g1(e) {
  return Mk(e), e;
}
function y1(e, t) {
  let n;
  return r;
  function r(d) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(d);
  }
  function i(d) {
    return d === null ? a(d) : ze(d) ? e.check(m1, o, a)(d) : (e.consume(d), i);
  }
  function a(d) {
    return e.exit("chunkContent"), e.exit("content"), t(d);
  }
  function o(d) {
    return e.consume(d), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function v1(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), He(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || ze(o))
      return n(o);
    const d = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function $k(e, t, n, r, i, a, o, d, u) {
  const l = u || Number.POSITIVE_INFINITY;
  let c = 0;
  return f;
  function f(w) {
    return w === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(w), e.exit(a), s) : w === null || w === 32 || w === 41 || bu(w) ? n(w) : (e.enter(r), e.enter(o), e.enter(d), e.enter("chunkString", {
      contentType: "string"
    }), m(w));
  }
  function s(w) {
    return w === 62 ? (e.enter(a), e.consume(w), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(d), e.enter("chunkString", {
      contentType: "string"
    }), h(w));
  }
  function h(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(d), s(w)) : w === null || w === 60 || ze(w) ? n(w) : (e.consume(w), w === 92 ? p : h);
  }
  function p(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), h) : h(w);
  }
  function m(w) {
    return !c && (w === null || w === 41 || rt(w)) ? (e.exit("chunkString"), e.exit(d), e.exit(o), e.exit(r), t(w)) : c < l && w === 40 ? (e.consume(w), c++, m) : w === 41 ? (e.consume(w), c--, m) : w === null || w === 32 || w === 40 || bu(w) ? n(w) : (e.consume(w), w === 92 ? y : m);
  }
  function y(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), m) : m(w);
  }
}
function Rk(e, t, n, r, i, a) {
  const o = this;
  let d = 0, u;
  return l;
  function l(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(a), c;
  }
  function c(h) {
    return d > 999 || h === null || h === 91 || h === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !d && "_hiddenFootnoteSupport" in o.parser.constructs ? n(h) : h === 93 ? (e.exit(a), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : ze(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), f(h));
  }
  function f(h) {
    return h === null || h === 91 || h === 93 || ze(h) || d++ > 999 ? (e.exit("chunkString"), c(h)) : (e.consume(h), u || (u = !Fe(h)), h === 92 ? s : f);
  }
  function s(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), d++, f) : f(h);
  }
}
function Zk(e, t, n, r, i, a) {
  let o;
  return d;
  function d(s) {
    return s === 34 || s === 39 || s === 40 ? (e.enter(r), e.enter(i), e.consume(s), e.exit(i), o = s === 40 ? 41 : s, u) : n(s);
  }
  function u(s) {
    return s === o ? (e.enter(i), e.consume(s), e.exit(i), e.exit(r), t) : (e.enter(a), l(s));
  }
  function l(s) {
    return s === o ? (e.exit(a), u(o)) : s === null ? n(s) : ze(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), He(e, l, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(s));
  }
  function c(s) {
    return s === o || s === null || ze(s) ? (e.exit("chunkString"), l(s)) : (e.consume(s), s === 92 ? f : c);
  }
  function f(s) {
    return s === o || s === 92 ? (e.consume(s), c) : c(s);
  }
}
function Cs(e, t) {
  let n;
  return r;
  function r(i) {
    return ze(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : Fe(i) ? He(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const b1 = {
  name: "definition",
  tokenize: w1
}, _1 = {
  partial: !0,
  tokenize: k1
};
function w1(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(h) {
    return e.enter("definition"), o(h);
  }
  function o(h) {
    return Rk.call(
      r,
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function d(h) {
    return i = zn(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), u) : n(h);
  }
  function u(h) {
    return rt(h) ? Cs(e, l)(h) : l(h);
  }
  function l(h) {
    return $k(
      e,
      c,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function c(h) {
    return e.attempt(_1, f, f)(h);
  }
  function f(h) {
    return Fe(h) ? He(e, s, "whitespace")(h) : s(h);
  }
  function s(h) {
    return h === null || ze(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function k1(e, t, n) {
  return r;
  function r(d) {
    return rt(d) ? Cs(e, i)(d) : n(d);
  }
  function i(d) {
    return Zk(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(d);
  }
  function a(d) {
    return Fe(d) ? He(e, o, "whitespace")(d) : o(d);
  }
  function o(d) {
    return d === null || ze(d) ? t(d) : n(d);
  }
}
const S1 = {
  name: "hardBreakEscape",
  tokenize: x1
};
function x1(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return ze(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const I1 = {
  name: "headingAtx",
  resolve: P1,
  tokenize: O1
};
function P1(e, t) {
  let n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, rn(e, r, n - r + 1, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]])), e;
}
function O1(e, t, n) {
  let r = 0;
  return i;
  function i(c) {
    return e.enter("atxHeading"), a(c);
  }
  function a(c) {
    return e.enter("atxHeadingSequence"), o(c);
  }
  function o(c) {
    return c === 35 && r++ < 6 ? (e.consume(c), o) : c === null || rt(c) ? (e.exit("atxHeadingSequence"), d(c)) : n(c);
  }
  function d(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), u(c)) : c === null || ze(c) ? (e.exit("atxHeading"), t(c)) : Fe(c) ? He(e, d, "whitespace")(c) : (e.enter("atxHeadingText"), l(c));
  }
  function u(c) {
    return c === 35 ? (e.consume(c), u) : (e.exit("atxHeadingSequence"), d(c));
  }
  function l(c) {
    return c === null || c === 35 || rt(c) ? (e.exit("atxHeadingText"), d(c)) : (e.consume(c), l);
  }
}
const z1 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], rv = ["pre", "script", "style", "textarea"], E1 = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: C1,
  tokenize: D1
}, T1 = {
  partial: !0,
  tokenize: j1
}, N1 = {
  partial: !0,
  tokenize: A1
};
function C1(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function D1(e, t, n) {
  const r = this;
  let i, a, o, d, u;
  return l;
  function l(z) {
    return c(z);
  }
  function c(z) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(z), f;
  }
  function f(z) {
    return z === 33 ? (e.consume(z), s) : z === 47 ? (e.consume(z), a = !0, m) : z === 63 ? (e.consume(z), i = 3, r.interrupt ? t : S) : $t(z) ? (e.consume(z), o = String.fromCharCode(z), y) : n(z);
  }
  function s(z) {
    return z === 45 ? (e.consume(z), i = 2, h) : z === 91 ? (e.consume(z), i = 5, d = 0, p) : $t(z) ? (e.consume(z), i = 4, r.interrupt ? t : S) : n(z);
  }
  function h(z) {
    return z === 45 ? (e.consume(z), r.interrupt ? t : S) : n(z);
  }
  function p(z) {
    const L = "CDATA[";
    return z === L.charCodeAt(d++) ? (e.consume(z), d === L.length ? r.interrupt ? t : R : p) : n(z);
  }
  function m(z) {
    return $t(z) ? (e.consume(z), o = String.fromCharCode(z), y) : n(z);
  }
  function y(z) {
    if (z === null || z === 47 || z === 62 || rt(z)) {
      const L = z === 47, F = o.toLowerCase();
      return !L && !a && rv.includes(F) ? (i = 1, r.interrupt ? t(z) : R(z)) : z1.includes(o.toLowerCase()) ? (i = 6, L ? (e.consume(z), w) : r.interrupt ? t(z) : R(z)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(z) : a ? b(z) : _(z));
    }
    return z === 45 || Nt(z) ? (e.consume(z), o += String.fromCharCode(z), y) : n(z);
  }
  function w(z) {
    return z === 62 ? (e.consume(z), r.interrupt ? t : R) : n(z);
  }
  function b(z) {
    return Fe(z) ? (e.consume(z), b) : N(z);
  }
  function _(z) {
    return z === 47 ? (e.consume(z), N) : z === 58 || z === 95 || $t(z) ? (e.consume(z), g) : Fe(z) ? (e.consume(z), _) : N(z);
  }
  function g(z) {
    return z === 45 || z === 46 || z === 58 || z === 95 || Nt(z) ? (e.consume(z), g) : O(z);
  }
  function O(z) {
    return z === 61 ? (e.consume(z), P) : Fe(z) ? (e.consume(z), O) : _(z);
  }
  function P(z) {
    return z === null || z === 60 || z === 61 || z === 62 || z === 96 ? n(z) : z === 34 || z === 39 ? (e.consume(z), u = z, E) : Fe(z) ? (e.consume(z), P) : T(z);
  }
  function E(z) {
    return z === u ? (e.consume(z), u = null, D) : z === null || ze(z) ? n(z) : (e.consume(z), E);
  }
  function T(z) {
    return z === null || z === 34 || z === 39 || z === 47 || z === 60 || z === 61 || z === 62 || z === 96 || rt(z) ? O(z) : (e.consume(z), T);
  }
  function D(z) {
    return z === 47 || z === 62 || Fe(z) ? _(z) : n(z);
  }
  function N(z) {
    return z === 62 ? (e.consume(z), M) : n(z);
  }
  function M(z) {
    return z === null || ze(z) ? R(z) : Fe(z) ? (e.consume(z), M) : n(z);
  }
  function R(z) {
    return z === 45 && i === 2 ? (e.consume(z), G) : z === 60 && i === 1 ? (e.consume(z), Q) : z === 62 && i === 4 ? (e.consume(z), A) : z === 63 && i === 3 ? (e.consume(z), S) : z === 93 && i === 5 ? (e.consume(z), I) : ze(z) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(T1, j, V)(z)) : z === null || ze(z) ? (e.exit("htmlFlowData"), V(z)) : (e.consume(z), R);
  }
  function V(z) {
    return e.check(N1, C, j)(z);
  }
  function C(z) {
    return e.enter("lineEnding"), e.consume(z), e.exit("lineEnding"), B;
  }
  function B(z) {
    return z === null || ze(z) ? V(z) : (e.enter("htmlFlowData"), R(z));
  }
  function G(z) {
    return z === 45 ? (e.consume(z), S) : R(z);
  }
  function Q(z) {
    return z === 47 ? (e.consume(z), o = "", k) : R(z);
  }
  function k(z) {
    if (z === 62) {
      const L = o.toLowerCase();
      return rv.includes(L) ? (e.consume(z), A) : R(z);
    }
    return $t(z) && o.length < 8 ? (e.consume(z), o += String.fromCharCode(z), k) : R(z);
  }
  function I(z) {
    return z === 93 ? (e.consume(z), S) : R(z);
  }
  function S(z) {
    return z === 62 ? (e.consume(z), A) : z === 45 && i === 2 ? (e.consume(z), S) : R(z);
  }
  function A(z) {
    return z === null || ze(z) ? (e.exit("htmlFlowData"), j(z)) : (e.consume(z), A);
  }
  function j(z) {
    return e.exit("htmlFlow"), t(z);
  }
}
function A1(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return ze(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : n(o);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function j1(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(ll, t, n);
  }
}
const M1 = {
  name: "htmlText",
  tokenize: $1
};
function $1(e, t, n) {
  const r = this;
  let i, a, o;
  return d;
  function d(S) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(S), u;
  }
  function u(S) {
    return S === 33 ? (e.consume(S), l) : S === 47 ? (e.consume(S), O) : S === 63 ? (e.consume(S), _) : $t(S) ? (e.consume(S), T) : n(S);
  }
  function l(S) {
    return S === 45 ? (e.consume(S), c) : S === 91 ? (e.consume(S), a = 0, p) : $t(S) ? (e.consume(S), b) : n(S);
  }
  function c(S) {
    return S === 45 ? (e.consume(S), h) : n(S);
  }
  function f(S) {
    return S === null ? n(S) : S === 45 ? (e.consume(S), s) : ze(S) ? (o = f, Q(S)) : (e.consume(S), f);
  }
  function s(S) {
    return S === 45 ? (e.consume(S), h) : f(S);
  }
  function h(S) {
    return S === 62 ? G(S) : S === 45 ? s(S) : f(S);
  }
  function p(S) {
    const A = "CDATA[";
    return S === A.charCodeAt(a++) ? (e.consume(S), a === A.length ? m : p) : n(S);
  }
  function m(S) {
    return S === null ? n(S) : S === 93 ? (e.consume(S), y) : ze(S) ? (o = m, Q(S)) : (e.consume(S), m);
  }
  function y(S) {
    return S === 93 ? (e.consume(S), w) : m(S);
  }
  function w(S) {
    return S === 62 ? G(S) : S === 93 ? (e.consume(S), w) : m(S);
  }
  function b(S) {
    return S === null || S === 62 ? G(S) : ze(S) ? (o = b, Q(S)) : (e.consume(S), b);
  }
  function _(S) {
    return S === null ? n(S) : S === 63 ? (e.consume(S), g) : ze(S) ? (o = _, Q(S)) : (e.consume(S), _);
  }
  function g(S) {
    return S === 62 ? G(S) : _(S);
  }
  function O(S) {
    return $t(S) ? (e.consume(S), P) : n(S);
  }
  function P(S) {
    return S === 45 || Nt(S) ? (e.consume(S), P) : E(S);
  }
  function E(S) {
    return ze(S) ? (o = E, Q(S)) : Fe(S) ? (e.consume(S), E) : G(S);
  }
  function T(S) {
    return S === 45 || Nt(S) ? (e.consume(S), T) : S === 47 || S === 62 || rt(S) ? D(S) : n(S);
  }
  function D(S) {
    return S === 47 ? (e.consume(S), G) : S === 58 || S === 95 || $t(S) ? (e.consume(S), N) : ze(S) ? (o = D, Q(S)) : Fe(S) ? (e.consume(S), D) : G(S);
  }
  function N(S) {
    return S === 45 || S === 46 || S === 58 || S === 95 || Nt(S) ? (e.consume(S), N) : M(S);
  }
  function M(S) {
    return S === 61 ? (e.consume(S), R) : ze(S) ? (o = M, Q(S)) : Fe(S) ? (e.consume(S), M) : D(S);
  }
  function R(S) {
    return S === null || S === 60 || S === 61 || S === 62 || S === 96 ? n(S) : S === 34 || S === 39 ? (e.consume(S), i = S, V) : ze(S) ? (o = R, Q(S)) : Fe(S) ? (e.consume(S), R) : (e.consume(S), C);
  }
  function V(S) {
    return S === i ? (e.consume(S), i = void 0, B) : S === null ? n(S) : ze(S) ? (o = V, Q(S)) : (e.consume(S), V);
  }
  function C(S) {
    return S === null || S === 34 || S === 39 || S === 60 || S === 61 || S === 96 ? n(S) : S === 47 || S === 62 || rt(S) ? D(S) : (e.consume(S), C);
  }
  function B(S) {
    return S === 47 || S === 62 || rt(S) ? D(S) : n(S);
  }
  function G(S) {
    return S === 62 ? (e.consume(S), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(S);
  }
  function Q(S) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), k;
  }
  function k(S) {
    return Fe(S) ? He(e, I, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(S) : I(S);
  }
  function I(S) {
    return e.enter("htmlTextData"), o(S);
  }
}
const zp = {
  name: "labelEnd",
  resolveAll: F1,
  resolveTo: U1,
  tokenize: B1
}, R1 = {
  tokenize: V1
}, Z1 = {
  tokenize: q1
}, L1 = {
  tokenize: H1
};
function F1(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && rn(e, 0, e.length, n), e;
}
function U1(e, t) {
  let n = e.length, r = 0, i, a, o, d;
  for (; n--; )
    if (i = e[n][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = n);
  const u = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, l = {
    type: "label",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, c = {
    type: "labelText",
    start: {
      ...e[a + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return d = [["enter", u, t], ["enter", l, t]], d = ln(d, e.slice(a + 1, a + r + 3)), d = ln(d, [["enter", c, t]]), d = ln(d, uc(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), t)), d = ln(d, [["exit", c, t], e[o - 2], e[o - 1], ["exit", l, t]]), d = ln(d, e.slice(o + 1)), d = ln(d, [["exit", u, t]]), rn(e, a, e.length, d), e;
}
function B1(e, t, n) {
  const r = this;
  let i = r.events.length, a, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return d;
  function d(s) {
    return a ? a._inactive ? f(s) : (o = r.parser.defined.includes(zn(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(s);
  }
  function u(s) {
    return s === 40 ? e.attempt(R1, c, o ? c : f)(s) : s === 91 ? e.attempt(Z1, c, o ? l : f)(s) : o ? c(s) : f(s);
  }
  function l(s) {
    return e.attempt(L1, c, f)(s);
  }
  function c(s) {
    return t(s);
  }
  function f(s) {
    return a._balanced = !0, n(s);
  }
}
function V1(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return rt(f) ? Cs(e, a)(f) : a(f);
  }
  function a(f) {
    return f === 41 ? c(f) : $k(e, o, d, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function o(f) {
    return rt(f) ? Cs(e, u)(f) : c(f);
  }
  function d(f) {
    return n(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? Zk(e, l, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : c(f);
  }
  function l(f) {
    return rt(f) ? Cs(e, c)(f) : c(f);
  }
  function c(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function q1(e, t, n) {
  const r = this;
  return i;
  function i(d) {
    return Rk.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(d);
  }
  function a(d) {
    return r.parser.defined.includes(zn(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(d) : n(d);
  }
  function o(d) {
    return n(d);
  }
}
function H1(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const W1 = {
  name: "labelStartImage",
  resolveAll: zp.resolveAll,
  tokenize: G1
};
function G1(e, t, n) {
  const r = this;
  return i;
  function i(d) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(d), e.exit("labelImageMarker"), a;
  }
  function a(d) {
    return d === 91 ? (e.enter("labelMarker"), e.consume(d), e.exit("labelMarker"), e.exit("labelImage"), o) : n(d);
  }
  function o(d) {
    return d === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(d) : t(d);
  }
}
const K1 = {
  name: "labelStartLink",
  resolveAll: zp.resolveAll,
  tokenize: J1
};
function J1(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const fd = {
  name: "lineEnding",
  tokenize: X1
};
function X1(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), He(e, t, "linePrefix");
  }
}
const nu = {
  name: "thematicBreak",
  tokenize: Y1
};
function Y1(e, t, n) {
  let r = 0, i;
  return a;
  function a(l) {
    return e.enter("thematicBreak"), o(l);
  }
  function o(l) {
    return i = l, d(l);
  }
  function d(l) {
    return l === i ? (e.enter("thematicBreakSequence"), u(l)) : r >= 3 && (l === null || ze(l)) ? (e.exit("thematicBreak"), t(l)) : n(l);
  }
  function u(l) {
    return l === i ? (e.consume(l), r++, u) : (e.exit("thematicBreakSequence"), Fe(l) ? He(e, d, "whitespace")(l) : d(l));
  }
}
const Vt = {
  continuation: {
    tokenize: nD
  },
  exit: iD,
  name: "list",
  tokenize: tD
}, Q1 = {
  partial: !0,
  tokenize: oD
}, eD = {
  partial: !0,
  tokenize: rD
};
function tD(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return d;
  function d(h) {
    const p = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (p === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : ih(h)) {
      if (r.containerState.type || (r.containerState.type = p, e.enter(p, {
        _container: !0
      })), p === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(nu, n, l)(h) : l(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(h);
    }
    return n(h);
  }
  function u(h) {
    return ih(h) && ++o < 10 ? (e.consume(h), u) : (!r.interrupt || o < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), l(h)) : n(h);
  }
  function l(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      ll,
      // Can’t be empty when interrupting.
      r.interrupt ? n : c,
      e.attempt(Q1, s, f)
    );
  }
  function c(h) {
    return r.containerState.initialBlankLine = !0, a++, s(h);
  }
  function f(h) {
    return Fe(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), s) : n(h);
  }
  function s(h) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function nD(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(ll, i, a);
  function i(d) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, He(e, t, "listItemIndent", r.containerState.size + 1)(d);
  }
  function a(d) {
    return r.containerState.furtherBlankLines || !Fe(d) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(d)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(eD, t, o)(d));
  }
  function o(d) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, He(e, e.attempt(Vt, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(d);
  }
}
function rD(e, t, n) {
  const r = this;
  return He(e, i, "listItemIndent", r.containerState.size + 1);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(a) : n(a);
  }
}
function iD(e) {
  e.exit(this.containerState.type);
}
function oD(e, t, n) {
  const r = this;
  return He(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return !Fe(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const iv = {
  name: "setextUnderline",
  resolveTo: aD,
  tokenize: sD
};
function aD(e, t) {
  let n = e.length, r, i, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[a][1].end
  }) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function sD(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(l) {
    let c = r.events.length, f;
    for (; c--; )
      if (r.events[c][1].type !== "lineEnding" && r.events[c][1].type !== "linePrefix" && r.events[c][1].type !== "content") {
        f = r.events[c][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), i = l, o(l)) : n(l);
  }
  function o(l) {
    return e.enter("setextHeadingLineSequence"), d(l);
  }
  function d(l) {
    return l === i ? (e.consume(l), d) : (e.exit("setextHeadingLineSequence"), Fe(l) ? He(e, u, "lineSuffix")(l) : u(l));
  }
  function u(l) {
    return l === null || ze(l) ? (e.exit("setextHeadingLine"), t(l)) : n(l);
  }
}
const lD = {
  tokenize: uD
};
function uD(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    ll,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, He(e, e.attempt(this.parser.constructs.flow, i, e.attempt(p1, i)), "linePrefix"))
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const cD = {
  resolveAll: Fk()
}, dD = Lk("string"), fD = Lk("text");
function Lk(e) {
  return {
    resolveAll: Fk(e === "text" ? hD : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], a = n.attempt(i, o, d);
    return o;
    function o(c) {
      return l(c) ? a(c) : d(c);
    }
    function d(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), u;
    }
    function u(c) {
      return l(c) ? (n.exit("data"), a(c)) : (n.consume(c), u);
    }
    function l(c) {
      if (c === null)
        return !0;
      const f = i[c];
      let s = -1;
      if (f)
        for (; ++s < f.length; ) {
          const h = f[s];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Fk(e) {
  return t;
  function t(n, r) {
    let i = -1, a;
    for (; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function hD(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let a = i.length, o = -1, d = 0, u;
      for (; a--; ) {
        const l = i[a];
        if (typeof l == "string") {
          for (o = l.length; l.charCodeAt(o - 1) === 32; )
            d++, o--;
          if (o) break;
          o = -1;
        } else if (l === -2)
          u = !0, d++;
        else if (l !== -1) {
          a++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (d = 0), d) {
        const l = {
          type: n === e.length || u || d < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: a ? o : r.start._bufferIndex + o,
            _index: r.start._index + a,
            line: r.end.line,
            column: r.end.column - d,
            offset: r.end.offset - d
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...l.start
        }, r.start.offset === r.end.offset ? Object.assign(r, l) : (e.splice(n, 0, ["enter", l, t], ["exit", l, t]), n += 2);
      }
      n++;
    }
  return e;
}
const pD = {
  42: Vt,
  43: Vt,
  45: Vt,
  48: Vt,
  49: Vt,
  50: Vt,
  51: Vt,
  52: Vt,
  53: Vt,
  54: Vt,
  55: Vt,
  56: Vt,
  57: Vt,
  62: Dk
}, mD = {
  91: b1
}, gD = {
  [-2]: dd,
  [-1]: dd,
  32: dd
}, yD = {
  35: I1,
  42: nu,
  45: [iv, nu],
  60: E1,
  61: iv,
  95: nu,
  96: nv,
  126: nv
}, vD = {
  38: jk,
  92: Ak
}, bD = {
  [-5]: fd,
  [-4]: fd,
  [-3]: fd,
  33: W1,
  38: jk,
  42: oh,
  60: [KC, M1],
  91: K1,
  92: [S1, Ak],
  93: zp,
  95: oh,
  96: l1
}, _D = {
  null: [oh, cD]
}, wD = {
  null: [42, 95]
}, kD = {
  null: []
}, SD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: wD,
  contentInitial: mD,
  disable: kD,
  document: pD,
  flow: yD,
  flowInitial: gD,
  insideSpan: _D,
  string: vD,
  text: bD
}, Symbol.toStringTag, { value: "Module" }));
function xD(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, a = [];
  let o = [], d = [];
  const u = {
    attempt: E(O),
    check: E(P),
    consume: b,
    enter: _,
    exit: g,
    interrupt: E(P, {
      interrupt: !0
    })
  }, l = {
    code: null,
    containerState: {},
    defineSkip: m,
    events: [],
    now: p,
    parser: e,
    previous: null,
    sliceSerialize: s,
    sliceStream: h,
    write: f
  };
  let c = t.tokenize.call(l, u);
  return t.resolveAll && a.push(t), l;
  function f(M) {
    return o = ln(o, M), y(), o[o.length - 1] !== null ? [] : (T(t, 0), l.events = uc(a, l.events, l), l.events);
  }
  function s(M, R) {
    return PD(h(M), R);
  }
  function h(M) {
    return ID(o, M);
  }
  function p() {
    const {
      _bufferIndex: M,
      _index: R,
      line: V,
      column: C,
      offset: B
    } = r;
    return {
      _bufferIndex: M,
      _index: R,
      line: V,
      column: C,
      offset: B
    };
  }
  function m(M) {
    i[M.line] = M.column, N();
  }
  function y() {
    let M;
    for (; r._index < o.length; ) {
      const R = o[r._index];
      if (typeof R == "string")
        for (M = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === M && r._bufferIndex < R.length; )
          w(R.charCodeAt(r._bufferIndex));
      else
        w(R);
    }
  }
  function w(M) {
    c = c(M);
  }
  function b(M) {
    ze(M) ? (r.line++, r.column = 1, r.offset += M === -3 ? 2 : 1, N()) : M !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = M;
  }
  function _(M, R) {
    const V = R || {};
    return V.type = M, V.start = p(), l.events.push(["enter", V, l]), d.push(V), V;
  }
  function g(M) {
    const R = d.pop();
    return R.end = p(), l.events.push(["exit", R, l]), R;
  }
  function O(M, R) {
    T(M, R.from);
  }
  function P(M, R) {
    R.restore();
  }
  function E(M, R) {
    return V;
    function V(C, B, G) {
      let Q, k, I, S;
      return Array.isArray(C) ? (
        /* c8 ignore next 1 */
        j(C)
      ) : "tokenize" in C ? (
        // Looks like a construct.
        j([
          /** @type {Construct} */
          C
        ])
      ) : A(C);
      function A(K) {
        return ee;
        function ee(U) {
          const q = U !== null && K[U], ne = U !== null && K.null, oe = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(q) ? q : q ? [q] : [],
            ...Array.isArray(ne) ? ne : ne ? [ne] : []
          ];
          return j(oe)(U);
        }
      }
      function j(K) {
        return Q = K, k = 0, K.length === 0 ? G : z(K[k]);
      }
      function z(K) {
        return ee;
        function ee(U) {
          return S = D(), I = K, K.partial || (l.currentConstruct = K), K.name && l.parser.constructs.disable.null.includes(K.name) ? F() : K.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            R ? Object.assign(Object.create(l), R) : l,
            u,
            L,
            F
          )(U);
        }
      }
      function L(K) {
        return M(I, S), B;
      }
      function F(K) {
        return S.restore(), ++k < Q.length ? z(Q[k]) : G;
      }
    }
  }
  function T(M, R) {
    M.resolveAll && !a.includes(M) && a.push(M), M.resolve && rn(l.events, R, l.events.length - R, M.resolve(l.events.slice(R), l)), M.resolveTo && (l.events = M.resolveTo(l.events, l));
  }
  function D() {
    const M = p(), R = l.previous, V = l.currentConstruct, C = l.events.length, B = Array.from(d);
    return {
      from: C,
      restore: G
    };
    function G() {
      r = M, l.previous = R, l.currentConstruct = V, l.events.length = C, d = B, N();
    }
  }
  function N() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function ID(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex;
  let o;
  if (n === i)
    o = [e[n].slice(r, a)];
  else {
    if (o = e.slice(n, i), r > -1) {
      const d = o[0];
      typeof d == "string" ? o[0] = d.slice(r) : o.shift();
    }
    a > 0 && o.push(e[i].slice(0, a));
  }
  return o;
}
function PD(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const a = e[n];
    let o;
    if (typeof a == "string")
      o = a;
    else switch (a) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(a);
    }
    i = a === -2, r.push(o);
  }
  return r.join("");
}
function OD(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Nk([SD, ...(e || {}).extensions || []])
    ),
    content: i(UC),
    defined: [],
    document: i(VC),
    flow: i(lD),
    lazy: {},
    string: i(dD),
    text: i(fD)
  };
  return r;
  function i(a) {
    return o;
    function o(d) {
      return xD(r, a, d);
    }
  }
}
function zD(e) {
  for (; !Mk(e); )
    ;
  return e;
}
const ov = /[\0\t\n\r]/g;
function ED() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(a, o, d) {
    const u = [];
    let l, c, f, s, h;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), f = 0, t = "", n && (a.charCodeAt(0) === 65279 && f++, n = void 0); f < a.length; ) {
      if (ov.lastIndex = f, l = ov.exec(a), s = l && l.index !== void 0 ? l.index : a.length, h = a.charCodeAt(s), !l) {
        t = a.slice(f);
        break;
      }
      if (h === 10 && f === s && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), f < s && (u.push(a.slice(f, s)), e += s - f), h) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (c = Math.ceil(e / 4) * 4, u.push(-2); e++ < c; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = s + 1;
    }
    return d && (r && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
const TD = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function ND(e) {
  return e.replace(TD, CD);
}
function CD(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), a = i === 120 || i === 88;
    return Ck(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return Op(n) || e;
}
const Uk = {}.hasOwnProperty;
function DD(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), AD(n)(zD(OD(n).document().write(ED()(e, t, !0))));
}
function AD(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(Ne),
      autolinkProtocol: D,
      autolinkEmail: D,
      atxHeading: a(ve),
      blockQuote: a(ne),
      characterEscape: D,
      characterReference: D,
      codeFenced: a(oe),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a(oe, o),
      codeText: a(Y, o),
      codeTextData: D,
      data: D,
      codeFlowValue: D,
      definition: a(re),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(de),
      hardBreakEscape: a(se),
      hardBreakTrailing: a(se),
      htmlFlow: a(pe, o),
      htmlFlowData: D,
      htmlText: a(pe, o),
      htmlTextData: D,
      image: a(ke),
      label: o,
      link: a(Ne),
      listItem: a(X),
      listItemValue: s,
      listOrdered: a(Ke, f),
      listUnordered: a(Ke),
      paragraph: a(ae),
      reference: z,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(ve),
      strong: a(he),
      thematicBreak: a(Ee)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: O,
      autolink: u(),
      autolinkEmail: q,
      autolinkProtocol: U,
      blockQuote: u(),
      characterEscapeValue: N,
      characterReferenceMarkerHexadecimal: F,
      characterReferenceMarkerNumeric: F,
      characterReferenceValue: K,
      characterReference: ee,
      codeFenced: u(y),
      codeFencedFence: m,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: p,
      codeFlowValue: N,
      codeIndented: u(w),
      codeText: u(B),
      codeTextData: N,
      data: N,
      definition: u(),
      definitionDestinationString: g,
      definitionLabelString: b,
      definitionTitleString: _,
      emphasis: u(),
      hardBreakEscape: u(R),
      hardBreakTrailing: u(R),
      htmlFlow: u(V),
      htmlFlowData: N,
      htmlText: u(C),
      htmlTextData: N,
      image: u(Q),
      label: I,
      labelText: k,
      lineEnding: M,
      link: u(G),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: L,
      resourceDestinationString: S,
      resourceTitleString: A,
      resource: j,
      setextHeading: u(T),
      setextHeadingLineSequence: E,
      setextHeadingText: P,
      strong: u(),
      thematicBreak: u()
    }
  };
  Bk(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(ie) {
    let fe = {
      type: "root",
      children: []
    };
    const be = {
      stack: [fe],
      tokenStack: [],
      config: t,
      enter: d,
      exit: l,
      buffer: o,
      resume: c,
      data: n
    }, Te = [];
    let De = -1;
    for (; ++De < ie.length; )
      if (ie[De][1].type === "listOrdered" || ie[De][1].type === "listUnordered")
        if (ie[De][0] === "enter")
          Te.push(De);
        else {
          const It = Te.pop();
          De = i(ie, It, De);
        }
    for (De = -1; ++De < ie.length; ) {
      const It = t[ie[De][0]];
      Uk.call(It, ie[De][1].type) && It[ie[De][1].type].call(Object.assign({
        sliceSerialize: ie[De][2].sliceSerialize
      }, be), ie[De][1]);
    }
    if (be.tokenStack.length > 0) {
      const It = be.tokenStack[be.tokenStack.length - 1];
      (It[1] || av).call(be, void 0, It[0]);
    }
    for (fe.position = {
      start: gr(ie.length > 0 ? ie[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: gr(ie.length > 0 ? ie[ie.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, De = -1; ++De < t.transforms.length; )
      fe = t.transforms[De](fe) || fe;
    return fe;
  }
  function i(ie, fe, be) {
    let Te = fe - 1, De = -1, It = !1, Ft, At, hn, pn;
    for (; ++Te <= be; ) {
      const St = ie[Te];
      switch (St[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          St[0] === "enter" ? De++ : De--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          St[0] === "enter" && (Ft && !pn && !De && !hn && (hn = Te), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!De && St[0] === "enter" && St[1].type === "listItemPrefix" || De === -1 && St[0] === "exit" && (St[1].type === "listUnordered" || St[1].type === "listOrdered")) {
        if (Ft) {
          let Ut = Te;
          for (At = void 0; Ut--; ) {
            const jt = ie[Ut];
            if (jt[1].type === "lineEnding" || jt[1].type === "lineEndingBlank") {
              if (jt[0] === "exit") continue;
              At && (ie[At][1].type = "lineEndingBlank", It = !0), jt[1].type = "lineEnding", At = Ut;
            } else if (!(jt[1].type === "linePrefix" || jt[1].type === "blockQuotePrefix" || jt[1].type === "blockQuotePrefixWhitespace" || jt[1].type === "blockQuoteMarker" || jt[1].type === "listItemIndent")) break;
          }
          hn && (!At || hn < At) && (Ft._spread = !0), Ft.end = Object.assign({}, At ? ie[At][1].start : St[1].end), ie.splice(At || Te, 0, ["exit", Ft, St[2]]), Te++, be++;
        }
        if (St[1].type === "listItemPrefix") {
          const Ut = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, St[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Ft = Ut, ie.splice(Te, 0, ["enter", Ut, St[2]]), Te++, be++, hn = void 0, pn = !0;
        }
      }
    }
    return ie[fe][1]._spread = It, be;
  }
  function a(ie, fe) {
    return be;
    function be(Te) {
      d.call(this, ie(Te), Te), fe && fe.call(this, Te);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function d(ie, fe, be) {
    this.stack[this.stack.length - 1].children.push(ie), this.stack.push(ie), this.tokenStack.push([fe, be || void 0]), ie.position = {
      start: gr(fe.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(ie) {
    return fe;
    function fe(be) {
      ie && ie.call(this, be), l.call(this, be);
    }
  }
  function l(ie, fe) {
    const be = this.stack.pop(), Te = this.tokenStack.pop();
    if (Te)
      Te[0].type !== ie.type && (fe ? fe.call(this, ie, Te[0]) : (Te[1] || av).call(this, ie, Te[0]));
    else throw new Error("Cannot close `" + ie.type + "` (" + Ns({
      start: ie.start,
      end: ie.end
    }) + "): it’s not open");
    be.position.end = gr(ie.end);
  }
  function c() {
    return Pp(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function s(ie) {
    if (this.data.expectingFirstListItemValue) {
      const fe = this.stack[this.stack.length - 2];
      fe.start = Number.parseInt(this.sliceSerialize(ie), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.lang = ie;
  }
  function p() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.meta = ie;
  }
  function m() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function y() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.value = ie.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.value = ie.replace(/(\r?\n|\r)$/g, "");
  }
  function b(ie) {
    const fe = this.resume(), be = this.stack[this.stack.length - 1];
    be.label = fe, be.identifier = zn(this.sliceSerialize(ie)).toLowerCase();
  }
  function _() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.title = ie;
  }
  function g() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.url = ie;
  }
  function O(ie) {
    const fe = this.stack[this.stack.length - 1];
    if (!fe.depth) {
      const be = this.sliceSerialize(ie).length;
      fe.depth = be;
    }
  }
  function P() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function E(ie) {
    const fe = this.stack[this.stack.length - 1];
    fe.depth = this.sliceSerialize(ie).codePointAt(0) === 61 ? 1 : 2;
  }
  function T() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function D(ie) {
    const be = this.stack[this.stack.length - 1].children;
    let Te = be[be.length - 1];
    (!Te || Te.type !== "text") && (Te = me(), Te.position = {
      start: gr(ie.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, be.push(Te)), this.stack.push(Te);
  }
  function N(ie) {
    const fe = this.stack.pop();
    fe.value += this.sliceSerialize(ie), fe.position.end = gr(ie.end);
  }
  function M(ie) {
    const fe = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const be = fe.children[fe.children.length - 1];
      be.position.end = gr(ie.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(fe.type) && (D.call(this, ie), N.call(this, ie));
  }
  function R() {
    this.data.atHardBreak = !0;
  }
  function V() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.value = ie;
  }
  function C() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.value = ie;
  }
  function B() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.value = ie;
  }
  function G() {
    const ie = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const fe = this.data.referenceType || "shortcut";
      ie.type += "Reference", ie.referenceType = fe, delete ie.url, delete ie.title;
    } else
      delete ie.identifier, delete ie.label;
    this.data.referenceType = void 0;
  }
  function Q() {
    const ie = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const fe = this.data.referenceType || "shortcut";
      ie.type += "Reference", ie.referenceType = fe, delete ie.url, delete ie.title;
    } else
      delete ie.identifier, delete ie.label;
    this.data.referenceType = void 0;
  }
  function k(ie) {
    const fe = this.sliceSerialize(ie), be = this.stack[this.stack.length - 2];
    be.label = ND(fe), be.identifier = zn(fe).toLowerCase();
  }
  function I() {
    const ie = this.stack[this.stack.length - 1], fe = this.resume(), be = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, be.type === "link") {
      const Te = ie.children;
      be.children = Te;
    } else
      be.alt = fe;
  }
  function S() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.url = ie;
  }
  function A() {
    const ie = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.title = ie;
  }
  function j() {
    this.data.inReference = void 0;
  }
  function z() {
    this.data.referenceType = "collapsed";
  }
  function L(ie) {
    const fe = this.resume(), be = this.stack[this.stack.length - 1];
    be.label = fe, be.identifier = zn(this.sliceSerialize(ie)).toLowerCase(), this.data.referenceType = "full";
  }
  function F(ie) {
    this.data.characterReferenceType = ie.type;
  }
  function K(ie) {
    const fe = this.sliceSerialize(ie), be = this.data.characterReferenceType;
    let Te;
    be ? (Te = Ck(fe, be === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Te = Op(fe);
    const De = this.stack[this.stack.length - 1];
    De.value += Te;
  }
  function ee(ie) {
    const fe = this.stack.pop();
    fe.position.end = gr(ie.end);
  }
  function U(ie) {
    N.call(this, ie);
    const fe = this.stack[this.stack.length - 1];
    fe.url = this.sliceSerialize(ie);
  }
  function q(ie) {
    N.call(this, ie);
    const fe = this.stack[this.stack.length - 1];
    fe.url = "mailto:" + this.sliceSerialize(ie);
  }
  function ne() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function oe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Y() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function re() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function de() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ve() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function se() {
    return {
      type: "break"
    };
  }
  function pe() {
    return {
      type: "html",
      value: ""
    };
  }
  function ke() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ne() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ke(ie) {
    return {
      type: "list",
      ordered: ie.type === "listOrdered",
      start: null,
      spread: ie._spread,
      children: []
    };
  }
  function X(ie) {
    return {
      type: "listItem",
      spread: ie._spread,
      checked: null,
      children: []
    };
  }
  function ae() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function he() {
    return {
      type: "strong",
      children: []
    };
  }
  function me() {
    return {
      type: "text",
      value: ""
    };
  }
  function Ee() {
    return {
      type: "thematicBreak"
    };
  }
}
function gr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Bk(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Bk(e, r) : jD(e, r);
  }
}
function jD(e, t) {
  let n;
  for (n in t)
    if (Uk.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function av(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ns({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Ns({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Ns({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function MD(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return DD(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function $D(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function RD(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function ZD(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function LD(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function FD(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function UD(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Ko(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let o, d = e.footnoteCounts.get(r);
  d === void 0 ? (d = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, d += 1, e.footnoteCounts.set(r, d);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (d > 1 ? "-" + d : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, u);
  const l = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, l), e.applyData(t, l);
}
function BD(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function VD(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Vk(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function qD(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Vk(e, t);
  const i = { src: Ko(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function HD(e, t) {
  const n = { src: Ko(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function WD(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function GD(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Vk(e, t);
  const i = { href: Ko(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function KD(e, t) {
  const n = { href: Ko(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function JD(e, t, n) {
  const r = e.all(t), i = n ? XD(n) : qk(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const c = r[0];
    let f;
    c && c.type === "element" && c.tagName === "p" ? f = c : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let d = -1;
  for (; ++d < r.length; ) {
    const c = r[d];
    (i || d !== 0 || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` }), c.type === "element" && c.tagName === "p" && !i ? o.push(...c.children) : o.push(c);
  }
  const u = r[r.length - 1];
  u && (i || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` });
  const l = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, l), e.applyData(t, l);
}
function XD(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = qk(n[r]);
  }
  return t;
}
function qk(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function YD(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function QD(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function eA(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function tA(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function nA(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, d = kp(t.children[1]), u = xk(t.children[t.children.length - 1]);
    d && u && (o.position = { start: d, end: u }), i.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function rA(e, t, n) {
  const r = n ? n.children : void 0, a = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, d = o ? o.length : t.children.length;
  let u = -1;
  const l = [];
  for (; ++u < d; ) {
    const f = t.children[u], s = {}, h = o ? o[u] : void 0;
    h && (s.align = h);
    let p = { type: "element", tagName: a, properties: s, children: [] };
    f && (p.children = e.all(f), e.patch(f, p), p = e.applyData(f, p)), l.push(p);
  }
  const c = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(t, c), e.applyData(t, c);
}
function iA(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const sv = 9, lv = 32;
function oA(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const a = [];
  for (; r; )
    a.push(
      uv(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return a.push(uv(t.slice(i), i > 0, !1)), a.join("");
}
function uv(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let a = e.codePointAt(r);
    for (; a === sv || a === lv; )
      r++, a = e.codePointAt(r);
  }
  if (n) {
    let a = e.codePointAt(i - 1);
    for (; a === sv || a === lv; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function aA(e, t) {
  const n = { type: "text", value: oA(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function sA(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const lA = {
  blockquote: $D,
  break: RD,
  code: ZD,
  delete: LD,
  emphasis: FD,
  footnoteReference: UD,
  heading: BD,
  html: VD,
  imageReference: qD,
  image: HD,
  inlineCode: WD,
  linkReference: GD,
  link: KD,
  listItem: JD,
  list: YD,
  paragraph: QD,
  // @ts-expect-error: root is different, but hard to type.
  root: eA,
  strong: tA,
  table: nA,
  tableCell: iA,
  tableRow: rA,
  text: aA,
  thematicBreak: sA,
  toml: Cl,
  yaml: Cl,
  definition: Cl,
  footnoteDefinition: Cl
};
function Cl() {
}
const Hk = -1, cc = 0, Ds = 1, _u = 2, Ep = 3, Tp = 4, Np = 5, Cp = 6, Wk = 7, Gk = 8, cv = typeof self == "object" ? self : globalThis, uA = (e, t) => {
  const n = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, o] = t[i];
    switch (a) {
      case cc:
      case Hk:
        return n(o, i);
      case Ds: {
        const d = n([], i);
        for (const u of o)
          d.push(r(u));
        return d;
      }
      case _u: {
        const d = n({}, i);
        for (const [u, l] of o)
          d[r(u)] = r(l);
        return d;
      }
      case Ep:
        return n(new Date(o), i);
      case Tp: {
        const { source: d, flags: u } = o;
        return n(new RegExp(d, u), i);
      }
      case Np: {
        const d = n(/* @__PURE__ */ new Map(), i);
        for (const [u, l] of o)
          d.set(r(u), r(l));
        return d;
      }
      case Cp: {
        const d = n(/* @__PURE__ */ new Set(), i);
        for (const u of o)
          d.add(r(u));
        return d;
      }
      case Wk: {
        const { name: d, message: u } = o;
        return n(new cv[d](u), i);
      }
      case Gk:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: d } = new Uint8Array(o);
        return n(new DataView(d), o);
      }
    }
    return n(new cv[a](o), i);
  };
  return r;
}, dv = (e) => uA(/* @__PURE__ */ new Map(), e)(0), ho = "", { toString: cA } = {}, { keys: dA } = Object, Oa = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [cc, t];
  const n = cA.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Ds, ho];
    case "Object":
      return [_u, ho];
    case "Date":
      return [Ep, ho];
    case "RegExp":
      return [Tp, ho];
    case "Map":
      return [Np, ho];
    case "Set":
      return [Cp, ho];
    case "DataView":
      return [Ds, n];
  }
  return n.includes("Array") ? [Ds, n] : n.includes("Error") ? [Wk, n] : [_u, n];
}, Dl = ([e, t]) => e === cc && (t === "function" || t === "symbol"), fA = (e, t, n, r) => {
  const i = (o, d) => {
    const u = r.push(o) - 1;
    return n.set(d, u), u;
  }, a = (o) => {
    if (n.has(o))
      return n.get(o);
    let [d, u] = Oa(o);
    switch (d) {
      case cc: {
        let c = o;
        switch (u) {
          case "bigint":
            d = Gk, c = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            c = null;
            break;
          case "undefined":
            return i([Hk], o);
        }
        return i([d, c], o);
      }
      case Ds: {
        if (u) {
          let s = o;
          return u === "DataView" ? s = new Uint8Array(o.buffer) : u === "ArrayBuffer" && (s = new Uint8Array(o)), i([u, [...s]], o);
        }
        const c = [], f = i([d, c], o);
        for (const s of o)
          c.push(a(s));
        return f;
      }
      case _u: {
        if (u)
          switch (u) {
            case "BigInt":
              return i([u, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([u, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return a(o.toJSON());
        const c = [], f = i([d, c], o);
        for (const s of dA(o))
          (e || !Dl(Oa(o[s]))) && c.push([a(s), a(o[s])]);
        return f;
      }
      case Ep:
        return i([d, o.toISOString()], o);
      case Tp: {
        const { source: c, flags: f } = o;
        return i([d, { source: c, flags: f }], o);
      }
      case Np: {
        const c = [], f = i([d, c], o);
        for (const [s, h] of o)
          (e || !(Dl(Oa(s)) || Dl(Oa(h)))) && c.push([a(s), a(h)]);
        return f;
      }
      case Cp: {
        const c = [], f = i([d, c], o);
        for (const s of o)
          (e || !Dl(Oa(s))) && c.push(a(s));
        return f;
      }
    }
    const { message: l } = o;
    return i([d, { name: u, message: l }], o);
  };
  return a;
}, fv = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return fA(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, wu = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? dv(fv(e, t)) : structuredClone(e)
) : (e, t) => dv(fv(e, t));
function hA(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function pA(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function mA(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || hA, r = e.options.footnoteBackLabel || pA, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, d = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const l = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!l)
      continue;
    const c = e.all(l), f = String(l.identifier).toUpperCase(), s = Ko(f.toLowerCase());
    let h = 0;
    const p = [], m = e.footnoteCounts.get(f);
    for (; m !== void 0 && ++h <= m; ) {
      p.length > 0 && p.push({ type: "text", value: " " });
      let b = typeof n == "string" ? n : n(u, h);
      typeof b == "string" && (b = { type: "text", value: b }), p.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + s + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(b) ? b : [b]
      });
    }
    const y = c[c.length - 1];
    if (y && y.type === "element" && y.tagName === "p") {
      const b = y.children[y.children.length - 1];
      b && b.type === "text" ? b.value += " " : y.children.push({ type: "text", value: " " }), y.children.push(...p);
    } else
      c.push(...p);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + s },
      children: e.wrap(c, !0)
    };
    e.patch(l, w), d.push(w);
  }
  if (d.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...wu(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(d, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const dc = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return bA;
    if (typeof e == "function")
      return fc(e);
    if (typeof e == "object")
      return Array.isArray(e) ? gA(e) : yA(e);
    if (typeof e == "string")
      return vA(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function gA(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = dc(e[n]);
  return fc(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, i)) return !0;
    return !1;
  }
}
function yA(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return fc(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let a;
    for (a in e)
      if (i[a] !== t[a]) return !1;
    return !0;
  }
}
function vA(e) {
  return fc(t);
  function t(n) {
    return n && n.type === e;
  }
}
function fc(e) {
  return t;
  function t(n, r, i) {
    return !!(_A(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function bA() {
  return !0;
}
function _A(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Kk = [], wA = !0, ah = !1, kA = "skip";
function Jk(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const a = dc(i), o = r ? -1 : 1;
  d(e, void 0, [])();
  function d(u, l, c) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const h = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(s, "name", {
        value: "node (" + (u.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return s;
    function s() {
      let h = Kk, p, m, y;
      if ((!t || a(u, l, c[c.length - 1] || void 0)) && (h = SA(n(u, c)), h[0] === ah))
        return h;
      if ("children" in u && u.children) {
        const w = (
          /** @type {UnistParent} */
          u
        );
        if (w.children && h[0] !== kA)
          for (m = (r ? w.children.length : -1) + o, y = c.concat(w); m > -1 && m < w.children.length; ) {
            const b = w.children[m];
            if (p = d(b, m, y)(), p[0] === ah)
              return p;
            m = typeof p[1] == "number" ? p[1] : m + o;
          }
      }
      return h;
    }
  }
}
function SA(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [wA, e] : e == null ? Kk : [e];
}
function Dp(e, t, n, r) {
  let i, a, o;
  typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), Jk(e, a, d, i);
  function d(u, l) {
    const c = l[l.length - 1], f = c ? c.children.indexOf(u) : void 0;
    return o(u, f, c);
  }
}
const sh = {}.hasOwnProperty, xA = {};
function IA(e, t) {
  const n = t || xA, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...lA, ...n.handlers }, d = {
    all: l,
    applyData: OA,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: u,
    options: n,
    patch: PA,
    wrap: EA
  };
  return Dp(e, function(c) {
    if (c.type === "definition" || c.type === "footnoteDefinition") {
      const f = c.type === "definition" ? r : i, s = String(c.identifier).toUpperCase();
      f.has(s) || f.set(s, c);
    }
  }), d;
  function u(c, f) {
    const s = c.type, h = d.handlers[s];
    if (sh.call(d.handlers, s) && h)
      return h(d, c, f);
    if (d.options.passThrough && d.options.passThrough.includes(s)) {
      if ("children" in c) {
        const { children: m, ...y } = c, w = wu(y);
        return w.children = d.all(c), w;
      }
      return wu(c);
    }
    return (d.options.unknownHandler || zA)(d, c, f);
  }
  function l(c) {
    const f = [];
    if ("children" in c) {
      const s = c.children;
      let h = -1;
      for (; ++h < s.length; ) {
        const p = d.one(s[h], c);
        if (p) {
          if (h && s[h - 1].type === "break" && (!Array.isArray(p) && p.type === "text" && (p.value = hv(p.value)), !Array.isArray(p) && p.type === "element")) {
            const m = p.children[0];
            m && m.type === "text" && (m.value = hv(m.value));
          }
          Array.isArray(p) ? f.push(...p) : f.push(p);
        }
      }
    }
    return f;
  }
}
function PA(e, t) {
  e.position && (t.position = pC(e));
}
function OA(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && a && Object.assign(n.properties, wu(a)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function zA(e, t) {
  const n = t.data || {}, r = "value" in t && !(sh.call(n, "hProperties") || sh.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function EA(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function hv(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function pv(e, t) {
  const n = IA(e, t), r = n.one(e, void 0), i = mA(n), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function TA(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      pv(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      pv(n, { file: r, ...e || t })
    );
  };
}
function mv(e) {
  if (e)
    throw e;
}
var hd, gv;
function NA() {
  if (gv) return hd;
  gv = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, i = function(l) {
    return typeof Array.isArray == "function" ? Array.isArray(l) : t.call(l) === "[object Array]";
  }, a = function(l) {
    if (!l || t.call(l) !== "[object Object]")
      return !1;
    var c = e.call(l, "constructor"), f = l.constructor && l.constructor.prototype && e.call(l.constructor.prototype, "isPrototypeOf");
    if (l.constructor && !c && !f)
      return !1;
    var s;
    for (s in l)
      ;
    return typeof s > "u" || e.call(l, s);
  }, o = function(l, c) {
    n && c.name === "__proto__" ? n(l, c.name, {
      enumerable: !0,
      configurable: !0,
      value: c.newValue,
      writable: !0
    }) : l[c.name] = c.newValue;
  }, d = function(l, c) {
    if (c === "__proto__")
      if (e.call(l, c)) {
        if (r)
          return r(l, c).value;
      } else return;
    return l[c];
  };
  return hd = function u() {
    var l, c, f, s, h, p, m = arguments[0], y = 1, w = arguments.length, b = !1;
    for (typeof m == "boolean" && (b = m, m = arguments[1] || {}, y = 2), (m == null || typeof m != "object" && typeof m != "function") && (m = {}); y < w; ++y)
      if (l = arguments[y], l != null)
        for (c in l)
          f = d(m, c), s = d(l, c), m !== s && (b && s && (a(s) || (h = i(s))) ? (h ? (h = !1, p = f && i(f) ? f : []) : p = f && a(f) ? f : {}, o(m, { name: c, newValue: u(b, p, s) })) : typeof s < "u" && o(m, { name: c, newValue: s }));
    return m;
  }, hd;
}
var CA = NA();
const pd = /* @__PURE__ */ up(CA);
function lh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function DA() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let a = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    d(null, ...i);
    function d(u, ...l) {
      const c = e[++a];
      let f = -1;
      if (u) {
        o(u);
        return;
      }
      for (; ++f < i.length; )
        (l[f] === null || l[f] === void 0) && (l[f] = i[f]);
      i = l, c ? AA(c, d)(...l) : o(null, ...l);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function AA(e, t) {
  let n;
  return r;
  function r(...o) {
    const d = e.length > o.length;
    let u;
    d && o.push(i);
    try {
      u = e.apply(this, o);
    } catch (l) {
      const c = (
        /** @type {Error} */
        l
      );
      if (d && n)
        throw c;
      return i(c);
    }
    d || (u && u.then && typeof u.then == "function" ? u.then(a, i) : u instanceof Error ? i(u) : a(u));
  }
  function i(o, ...d) {
    n || (n = !0, t(o, ...d));
  }
  function a(o) {
    i(null, o);
  }
}
const $n = { basename: jA, dirname: MA, extname: $A, join: RA, sep: "/" };
function jA(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  ul(e);
  let n = 0, r = -1, i = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          n = i + 1;
          break;
        }
      } else r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, d = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        n = i + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = i + 1), d > -1 && (e.codePointAt(i) === t.codePointAt(d--) ? d < 0 && (r = i) : (d = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function MA(e) {
  if (ul(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function $A(e) {
  ul(e);
  let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
  for (; t--; ) {
    const d = e.codePointAt(t);
    if (d === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), d === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function RA(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    ul(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : ZA(n);
}
function ZA(e) {
  ul(e);
  const t = e.codePointAt(0) === 47;
  let n = LA(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function LA(e, t) {
  let n = "", r = 0, i = -1, a = 0, o = -1, d, u;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      d = e.codePointAt(o);
    else {
      if (d === 47)
        break;
      d = 47;
    }
    if (d === 47) {
      if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = o, a = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
      i = o, a = 0;
    } else d === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function ul(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const FA = { cwd: UA };
function UA() {
  return "/";
}
function uh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function BA(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!uh(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return VA(e);
}
function VA(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const md = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Xk {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? uh(t) ? n = { path: t } : typeof t == "string" || qA(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : FA.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < md.length; ) {
      const a = md[r];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let i;
    for (i in n)
      md.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? $n.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    yd(t, "basename"), gd(t, "basename"), this.path = $n.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? $n.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    yv(this.basename, "dirname"), this.path = $n.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? $n.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (gd(t, "extname"), yv(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = $n.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    uh(t) && (t = BA(t)), yd(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? $n.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    yd(t, "stem"), gd(t, "stem"), this.path = $n.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Dt(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function gd(e, t) {
  if (e && e.includes($n.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + $n.sep + "`"
    );
}
function yd(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function yv(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function qA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const HA = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, r), a;
  })
), WA = {}.hasOwnProperty;
class Ap extends HA {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = DA();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Ap()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(pd(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (_d("data", this.frozen), this.namespace[t] = n, this) : WA.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (_d("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Al(t), r = this.parser || this.Parser;
    return vd("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), vd("process", this.parser || this.Parser), bd("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(a, o) {
      const d = Al(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(d)
      );
      r.run(u, d, function(c, f, s) {
        if (c || !f || !s)
          return l(c);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), p = r.stringify(h, s);
        JA(p) ? s.value = p : s.result = p, l(
          c,
          /** @type {VFileWithOutput<CompileResult>} */
          s
        );
      });
      function l(c, f) {
        c || !f ? o(c) : a ? a(f) : n(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), vd("processSync", this.parser || this.Parser), bd("processSync", this.compiler || this.Compiler), this.process(t, i), bv("processSync", "process", n), r;
    function i(a, o) {
      n = !0, mv(a), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    vv(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? a(void 0, r) : new Promise(a);
    function a(o, d) {
      const u = Al(n);
      i.run(t, u, l);
      function l(c, f, s) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || t
        );
        c ? d(c) : o ? o(h) : r(void 0, h, s);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, a), bv("runSync", "run", r), i;
    function a(o, d) {
      mv(o), i = d, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = Al(n), i = this.compiler || this.Compiler;
    return bd("stringify", i), vv(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (_d("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? d(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(l) {
      if (typeof l == "function")
        u(l, []);
      else if (typeof l == "object")
        if (Array.isArray(l)) {
          const [c, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            l
          );
          u(c, f);
        } else
          o(l);
      else
        throw new TypeError("Expected usable value, not `" + l + "`");
    }
    function o(l) {
      if (!("plugins" in l) && !("settings" in l))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      d(l.plugins), l.settings && (i.settings = pd(!0, i.settings, l.settings));
    }
    function d(l) {
      let c = -1;
      if (l != null) if (Array.isArray(l))
        for (; ++c < l.length; ) {
          const f = l[c];
          a(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + l + "`");
    }
    function u(l, c) {
      let f = -1, s = -1;
      for (; ++f < r.length; )
        if (r[f][0] === l) {
          s = f;
          break;
        }
      if (s === -1)
        r.push([l, ...c]);
      else if (c.length > 0) {
        let [h, ...p] = c;
        const m = r[s][1];
        lh(m) && lh(h) && (h = pd(!0, m, h)), r[s] = [l, h, ...p];
      }
    }
  }
}
const GA = new Ap().freeze();
function vd(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function bd(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function _d(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function vv(e) {
  if (!lh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function bv(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Al(e) {
  return KA(e) ? e : new Xk(e);
}
function KA(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function JA(e) {
  return typeof e == "string" || XA(e);
}
function XA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const YA = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", _v = [], wv = { allowDangerousHtml: !0 }, QA = /^(https?|ircs?|mailto|xmpp)$/i, ej = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function tj(e) {
  const t = nj(e), n = rj(e);
  return ij(t.runSync(t.parse(n), n), e);
}
function nj(e) {
  const t = e.rehypePlugins || _v, n = e.remarkPlugins || _v, r = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...wv } : wv;
  return GA().use(MD).use(n).use(TA, r).use(t);
}
function rj(e) {
  const t = e.children || "", n = new Xk();
  return typeof t == "string" && (n.value = t), n;
}
function ij(e, t) {
  const n = t.allowedElements, r = t.allowElement, i = t.components, a = t.disallowedElements, o = t.skipHtml, d = t.unwrapDisallowed, u = t.urlTransform || oj;
  for (const c of ej)
    Object.hasOwn(t, c.from) && ("" + c.from + (c.to ? "use `" + c.to + "` instead" : "remove it") + YA + c.id, void 0);
  return Dp(e, l), bC(e, {
    Fragment: Ue,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: x,
    jsxs: te,
    passKeys: !0,
    passNode: !0
  });
  function l(c, f, s) {
    if (c.type === "raw" && s && typeof f == "number")
      return o ? s.children.splice(f, 1) : s.children[f] = { type: "text", value: c.value }, f;
    if (c.type === "element") {
      let h;
      for (h in cd)
        if (Object.hasOwn(cd, h) && Object.hasOwn(c.properties, h)) {
          const p = c.properties[h], m = cd[h];
          (m === null || m.includes(c.tagName)) && (c.properties[h] = u(String(p || ""), h, c));
        }
    }
    if (c.type === "element") {
      let h = n ? !n.includes(c.tagName) : a ? a.includes(c.tagName) : !1;
      if (!h && r && typeof f == "number" && (h = !r(c, f, s)), h && s && typeof f == "number")
        return d && c.children ? s.children.splice(f, 1, ...c.children) : s.children.splice(f, 1), f;
    }
  }
}
function oj(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    QA.test(e.slice(0, t)) ? e : ""
  );
}
function kv(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function aj(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function sj(e, t, n) {
  const i = dc((n || {}).ignore || []), a = lj(t);
  let o = -1;
  for (; ++o < a.length; )
    Jk(e, "text", d);
  function d(l, c) {
    let f = -1, s;
    for (; ++f < c.length; ) {
      const h = c[f], p = s ? s.children : void 0;
      if (i(
        h,
        p ? p.indexOf(h) : void 0,
        s
      ))
        return;
      s = h;
    }
    if (s)
      return u(l, c);
  }
  function u(l, c) {
    const f = c[c.length - 1], s = a[o][0], h = a[o][1];
    let p = 0;
    const y = f.children.indexOf(l);
    let w = !1, b = [];
    s.lastIndex = 0;
    let _ = s.exec(l.value);
    for (; _; ) {
      const g = _.index, O = {
        index: _.index,
        input: _.input,
        stack: [...c, l]
      };
      let P = h(..._, O);
      if (typeof P == "string" && (P = P.length > 0 ? { type: "text", value: P } : void 0), P === !1 ? s.lastIndex = g + 1 : (p !== g && b.push({
        type: "text",
        value: l.value.slice(p, g)
      }), Array.isArray(P) ? b.push(...P) : P && b.push(P), p = g + _[0].length, w = !0), !s.global)
        break;
      _ = s.exec(l.value);
    }
    return w ? (p < l.value.length && b.push({ type: "text", value: l.value.slice(p) }), f.children.splice(y, 1, ...b)) : b = [l], y + b.length;
  }
}
function lj(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    t.push([uj(i[0]), cj(i[1])]);
  }
  return t;
}
function uj(e) {
  return typeof e == "string" ? new RegExp(aj(e), "g") : e;
}
function cj(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const wd = "phrasing", kd = ["autolink", "link", "image", "label"];
function dj() {
  return {
    transforms: [vj],
    enter: {
      literalAutolink: hj,
      literalAutolinkEmail: Sd,
      literalAutolinkHttp: Sd,
      literalAutolinkWww: Sd
    },
    exit: {
      literalAutolink: yj,
      literalAutolinkEmail: gj,
      literalAutolinkHttp: pj,
      literalAutolinkWww: mj
    }
  };
}
function fj() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: wd,
        notInConstruct: kd
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: wd,
        notInConstruct: kd
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: wd,
        notInConstruct: kd
      }
    ]
  };
}
function hj(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Sd(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function pj(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function mj(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function gj(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function yj(e) {
  this.exit(e);
}
function vj(e) {
  sj(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, bj],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), _j]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function bj(e, t, n, r, i) {
  let a = "";
  if (!Yk(i) || (/^w/i.test(t) && (n = t + n, t = "", a = "http://"), !wj(n)))
    return !1;
  const o = kj(n + r);
  if (!o[0]) return !1;
  const d = {
    type: "link",
    title: null,
    url: a + t + o[0],
    children: [{ type: "text", value: t + o[0] }]
  };
  return o[1] ? [d, { type: "text", value: o[1] }] : d;
}
function _j(e, t, n, r) {
  return (
    // Not an expected previous character.
    !Yk(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function wj(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function kj(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = kv(e, "(");
  let a = kv(e, ")");
  for (; r !== -1 && i > a; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), a++;
  return [e, n];
}
function Yk(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || ti(n) || lc(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
Qk.peek = Nj;
function Sj() {
  this.buffer();
}
function xj(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function Ij() {
  this.buffer();
}
function Pj(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function Oj(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = zn(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function zj(e) {
  this.exit(e);
}
function Ej(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = zn(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function Tj(e) {
  this.exit(e);
}
function Nj() {
  return "[";
}
function Qk(e, t, n, r) {
  const i = n.createTracker(r);
  let a = i.move("[^");
  const o = n.enter("footnoteReference"), d = n.enter("reference");
  return a += i.move(
    n.safe(n.associationId(e), { after: "]", before: a })
  ), d(), o(), a += i.move("]"), a;
}
function Cj() {
  return {
    enter: {
      gfmFootnoteCallString: Sj,
      gfmFootnoteCall: xj,
      gfmFootnoteDefinitionLabelString: Ij,
      gfmFootnoteDefinition: Pj
    },
    exit: {
      gfmFootnoteCallString: Oj,
      gfmFootnoteCall: zj,
      gfmFootnoteDefinitionLabelString: Ej,
      gfmFootnoteDefinition: Tj
    }
  };
}
function Dj(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: Qk },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(r, i, a, o) {
    const d = a.createTracker(o);
    let u = d.move("[^");
    const l = a.enter("footnoteDefinition"), c = a.enter("label");
    return u += d.move(
      a.safe(a.associationId(r), { before: u, after: "]" })
    ), c(), u += d.move("]:"), r.children && r.children.length > 0 && (d.shift(4), u += d.move(
      (t ? `
` : " ") + a.indentLines(
        a.containerFlow(r, d.current()),
        t ? eS : Aj
      )
    )), l(), u;
  }
}
function Aj(e, t, n) {
  return t === 0 ? e : eS(e, t, n);
}
function eS(e, t, n) {
  return (n ? "" : "    ") + e;
}
const jj = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
tS.peek = Lj;
function Mj() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: Rj },
    exit: { strikethrough: Zj }
  };
}
function $j() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: jj
      }
    ],
    handlers: { delete: tS }
  };
}
function Rj(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function Zj(e) {
  this.exit(e);
}
function tS(e, t, n, r) {
  const i = n.createTracker(r), a = n.enter("strikethrough");
  let o = i.move("~~");
  return o += n.containerPhrasing(e, {
    ...i.current(),
    before: o,
    after: "~"
  }), o += i.move("~~"), a(), o;
}
function Lj() {
  return "~";
}
function Fj(e) {
  return e.length;
}
function Uj(e, t) {
  const n = t || {}, r = (n.align || []).concat(), i = n.stringLength || Fj, a = [], o = [], d = [], u = [];
  let l = 0, c = -1;
  for (; ++c < e.length; ) {
    const m = [], y = [];
    let w = -1;
    for (e[c].length > l && (l = e[c].length); ++w < e[c].length; ) {
      const b = Bj(e[c][w]);
      if (n.alignDelimiters !== !1) {
        const _ = i(b);
        y[w] = _, (u[w] === void 0 || _ > u[w]) && (u[w] = _);
      }
      m.push(b);
    }
    o[c] = m, d[c] = y;
  }
  let f = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++f < l; )
      a[f] = Sv(r[f]);
  else {
    const m = Sv(r);
    for (; ++f < l; )
      a[f] = m;
  }
  f = -1;
  const s = [], h = [];
  for (; ++f < l; ) {
    const m = a[f];
    let y = "", w = "";
    m === 99 ? (y = ":", w = ":") : m === 108 ? y = ":" : m === 114 && (w = ":");
    let b = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[f] - y.length - w.length
    );
    const _ = y + "-".repeat(b) + w;
    n.alignDelimiters !== !1 && (b = y.length + b + w.length, b > u[f] && (u[f] = b), h[f] = b), s[f] = _;
  }
  o.splice(1, 0, s), d.splice(1, 0, h), c = -1;
  const p = [];
  for (; ++c < o.length; ) {
    const m = o[c], y = d[c];
    f = -1;
    const w = [];
    for (; ++f < l; ) {
      const b = m[f] || "";
      let _ = "", g = "";
      if (n.alignDelimiters !== !1) {
        const O = u[f] - (y[f] || 0), P = a[f];
        P === 114 ? _ = " ".repeat(O) : P === 99 ? O % 2 ? (_ = " ".repeat(O / 2 + 0.5), g = " ".repeat(O / 2 - 0.5)) : (_ = " ".repeat(O / 2), g = _) : g = " ".repeat(O);
      }
      n.delimiterStart !== !1 && !f && w.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && b === "") && (n.delimiterStart !== !1 || f) && w.push(" "), n.alignDelimiters !== !1 && w.push(_), w.push(b), n.alignDelimiters !== !1 && w.push(g), n.padding !== !1 && w.push(" "), (n.delimiterEnd !== !1 || f !== l - 1) && w.push("|");
    }
    p.push(
      n.delimiterEnd === !1 ? w.join("").replace(/ +$/, "") : w.join("")
    );
  }
  return p.join(`
`);
}
function Bj(e) {
  return e == null ? "" : String(e);
}
function Sv(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function Vj(e, t, n, r) {
  const i = n.enter("blockquote"), a = n.createTracker(r);
  a.move("> "), a.shift(2);
  const o = n.indentLines(
    n.containerFlow(e, a.current()),
    qj
  );
  return i(), o;
}
function qj(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function Hj(e, t) {
  return xv(e, t.inConstruct, !0) && !xv(e, t.notInConstruct, !1);
}
function xv(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function Iv(e, t, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length; )
    if (n.unsafe[i].character === `
` && Hj(n.stack, n.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function Wj(e, t) {
  const n = String(e);
  let r = n.indexOf(t), i = r, a = 0, o = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++a > o && (o = a) : a = 1, i = r + t.length, r = n.indexOf(t, i);
  return o;
}
function Gj(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function Kj(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function Jj(e, t, n, r) {
  const i = Kj(n), a = e.value || "", o = i === "`" ? "GraveAccent" : "Tilde";
  if (Gj(e, n)) {
    const f = n.enter("codeIndented"), s = n.indentLines(a, Xj);
    return f(), s;
  }
  const d = n.createTracker(r), u = i.repeat(Math.max(Wj(a, i) + 1, 3)), l = n.enter("codeFenced");
  let c = d.move(u);
  if (e.lang) {
    const f = n.enter(`codeFencedLang${o}`);
    c += d.move(
      n.safe(e.lang, {
        before: c,
        after: " ",
        encode: ["`"],
        ...d.current()
      })
    ), f();
  }
  if (e.lang && e.meta) {
    const f = n.enter(`codeFencedMeta${o}`);
    c += d.move(" "), c += d.move(
      n.safe(e.meta, {
        before: c,
        after: `
`,
        encode: ["`"],
        ...d.current()
      })
    ), f();
  }
  return c += d.move(`
`), a && (c += d.move(a + `
`)), c += d.move(u), l(), c;
}
function Xj(e, t, n) {
  return (n ? "" : "    ") + e;
}
function jp(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function Yj(e, t, n, r) {
  const i = jp(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
  let d = n.enter("label");
  const u = n.createTracker(r);
  let l = u.move("[");
  return l += u.move(
    n.safe(n.associationId(e), {
      before: l,
      after: "]",
      ...u.current()
    })
  ), l += u.move("]: "), d(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (d = n.enter("destinationLiteral"), l += u.move("<"), l += u.move(
    n.safe(e.url, { before: l, after: ">", ...u.current() })
  ), l += u.move(">")) : (d = n.enter("destinationRaw"), l += u.move(
    n.safe(e.url, {
      before: l,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), d(), e.title && (d = n.enter(`title${a}`), l += u.move(" " + i), l += u.move(
    n.safe(e.title, {
      before: l,
      after: i,
      ...u.current()
    })
  ), l += u.move(i), d()), o(), l;
}
function Qj(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function Ls(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function ku(e, t, n) {
  const r = Co(e), i = Co(t);
  return r === void 0 ? i === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : r === 1 ? i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
nS.peek = eM;
function nS(e, t, n, r) {
  const i = Qj(n), a = n.enter("emphasis"), o = n.createTracker(r), d = o.move(i);
  let u = o.move(
    n.containerPhrasing(e, {
      after: i,
      before: d,
      ...o.current()
    })
  );
  const l = u.charCodeAt(0), c = ku(
    r.before.charCodeAt(r.before.length - 1),
    l,
    i
  );
  c.inside && (u = Ls(l) + u.slice(1));
  const f = u.charCodeAt(u.length - 1), s = ku(r.after.charCodeAt(0), f, i);
  s.inside && (u = u.slice(0, -1) + Ls(f));
  const h = o.move(i);
  return a(), n.attentionEncodeSurroundingInfo = {
    after: s.outside,
    before: c.outside
  }, d + u + h;
}
function eM(e, t, n) {
  return n.options.emphasis || "*";
}
function tM(e, t) {
  let n = !1;
  return Dp(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, ah;
  }), !!((!e.depth || e.depth < 3) && Pp(e) && (t.options.setext || n));
}
function nM(e, t, n, r) {
  const i = Math.max(Math.min(6, e.depth || 1), 1), a = n.createTracker(r);
  if (tM(e, n)) {
    const c = n.enter("headingSetext"), f = n.enter("phrasing"), s = n.containerPhrasing(e, {
      ...a.current(),
      before: `
`,
      after: `
`
    });
    return f(), c(), s + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      s.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(s.lastIndexOf("\r"), s.lastIndexOf(`
`)) + 1)
    );
  }
  const o = "#".repeat(i), d = n.enter("headingAtx"), u = n.enter("phrasing");
  a.move(o + " ");
  let l = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...a.current()
  });
  return /^[\t ]/.test(l) && (l = Ls(l.charCodeAt(0)) + l.slice(1)), l = l ? o + " " + l : o, n.options.closeAtx && (l += " " + o), u(), d(), l;
}
rS.peek = rM;
function rS(e) {
  return e.value || "";
}
function rM() {
  return "<";
}
iS.peek = iM;
function iS(e, t, n, r) {
  const i = jp(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
  let d = n.enter("label");
  const u = n.createTracker(r);
  let l = u.move("![");
  return l += u.move(
    n.safe(e.alt, { before: l, after: "]", ...u.current() })
  ), l += u.move("]("), d(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (d = n.enter("destinationLiteral"), l += u.move("<"), l += u.move(
    n.safe(e.url, { before: l, after: ">", ...u.current() })
  ), l += u.move(">")) : (d = n.enter("destinationRaw"), l += u.move(
    n.safe(e.url, {
      before: l,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), d(), e.title && (d = n.enter(`title${a}`), l += u.move(" " + i), l += u.move(
    n.safe(e.title, {
      before: l,
      after: i,
      ...u.current()
    })
  ), l += u.move(i), d()), l += u.move(")"), o(), l;
}
function iM() {
  return "!";
}
oS.peek = oM;
function oS(e, t, n, r) {
  const i = e.referenceType, a = n.enter("imageReference");
  let o = n.enter("label");
  const d = n.createTracker(r);
  let u = d.move("![");
  const l = n.safe(e.alt, {
    before: u,
    after: "]",
    ...d.current()
  });
  u += d.move(l + "]["), o();
  const c = n.stack;
  n.stack = [], o = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...d.current()
  });
  return o(), n.stack = c, a(), i === "full" || !l || l !== f ? u += d.move(f + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += d.move("]"), u;
}
function oM() {
  return "!";
}
aS.peek = aM;
function aS(e, t, n) {
  let r = e.value || "", i = "`", a = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++a < n.unsafe.length; ) {
    const o = n.unsafe[a], d = n.compilePattern(o);
    let u;
    if (o.atBreak)
      for (; u = d.exec(r); ) {
        let l = u.index;
        r.charCodeAt(l) === 10 && r.charCodeAt(l - 1) === 13 && l--, r = r.slice(0, l) + " " + r.slice(u.index + 1);
      }
  }
  return i + r + i;
}
function aM() {
  return "`";
}
function sS(e, t) {
  const n = Pp(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
lS.peek = sM;
function lS(e, t, n, r) {
  const i = jp(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.createTracker(r);
  let d, u;
  if (sS(e, n)) {
    const c = n.stack;
    n.stack = [], d = n.enter("autolink");
    let f = o.move("<");
    return f += o.move(
      n.containerPhrasing(e, {
        before: f,
        after: ">",
        ...o.current()
      })
    ), f += o.move(">"), d(), n.stack = c, f;
  }
  d = n.enter("link"), u = n.enter("label");
  let l = o.move("[");
  return l += o.move(
    n.containerPhrasing(e, {
      before: l,
      after: "](",
      ...o.current()
    })
  ), l += o.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), l += o.move("<"), l += o.move(
    n.safe(e.url, { before: l, after: ">", ...o.current() })
  ), l += o.move(">")) : (u = n.enter("destinationRaw"), l += o.move(
    n.safe(e.url, {
      before: l,
      after: e.title ? " " : ")",
      ...o.current()
    })
  )), u(), e.title && (u = n.enter(`title${a}`), l += o.move(" " + i), l += o.move(
    n.safe(e.title, {
      before: l,
      after: i,
      ...o.current()
    })
  ), l += o.move(i), u()), l += o.move(")"), d(), l;
}
function sM(e, t, n) {
  return sS(e, n) ? "<" : "[";
}
uS.peek = lM;
function uS(e, t, n, r) {
  const i = e.referenceType, a = n.enter("linkReference");
  let o = n.enter("label");
  const d = n.createTracker(r);
  let u = d.move("[");
  const l = n.containerPhrasing(e, {
    before: u,
    after: "]",
    ...d.current()
  });
  u += d.move(l + "]["), o();
  const c = n.stack;
  n.stack = [], o = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...d.current()
  });
  return o(), n.stack = c, a(), i === "full" || !l || l !== f ? u += d.move(f + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += d.move("]"), u;
}
function lM() {
  return "[";
}
function Mp(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function uM(e) {
  const t = Mp(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function cM(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function cS(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function dM(e, t, n, r) {
  const i = n.enter("list"), a = n.bulletCurrent;
  let o = e.ordered ? cM(n) : Mp(n);
  const d = e.ordered ? o === "." ? ")" : "." : uM(n);
  let u = t && n.bulletLastUsed ? o === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const c = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (o === "*" || o === "-") && // Empty first list item:
      c && (!c.children || !c.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), cS(n) === o && c
    ) {
      let f = -1;
      for (; ++f < e.children.length; ) {
        const s = e.children[f];
        if (s && s.type === "listItem" && s.children && s.children[0] && s.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (o = d), n.bulletCurrent = o;
  const l = n.containerFlow(e, r);
  return n.bulletLastUsed = o, n.bulletCurrent = a, i(), l;
}
function fM(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function hM(e, t, n, r) {
  const i = fM(n);
  let a = n.bulletCurrent || Mp(n);
  t && t.type === "list" && t.ordered && (a = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + a);
  let o = a.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
  const d = n.createTracker(r);
  d.move(a + " ".repeat(o - a.length)), d.shift(o);
  const u = n.enter("listItem"), l = n.indentLines(
    n.containerFlow(e, d.current()),
    c
  );
  return u(), l;
  function c(f, s, h) {
    return s ? (h ? "" : " ".repeat(o)) + f : (h ? a : a + " ".repeat(o - a.length)) + f;
  }
}
function pM(e, t, n, r) {
  const i = n.enter("paragraph"), a = n.enter("phrasing"), o = n.containerPhrasing(e, r);
  return a(), i(), o;
}
const mM = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  dc([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function gM(e, t, n, r) {
  return (e.children.some(function(o) {
    return mM(o);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function yM(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
dS.peek = vM;
function dS(e, t, n, r) {
  const i = yM(n), a = n.enter("strong"), o = n.createTracker(r), d = o.move(i + i);
  let u = o.move(
    n.containerPhrasing(e, {
      after: i,
      before: d,
      ...o.current()
    })
  );
  const l = u.charCodeAt(0), c = ku(
    r.before.charCodeAt(r.before.length - 1),
    l,
    i
  );
  c.inside && (u = Ls(l) + u.slice(1));
  const f = u.charCodeAt(u.length - 1), s = ku(r.after.charCodeAt(0), f, i);
  s.inside && (u = u.slice(0, -1) + Ls(f));
  const h = o.move(i + i);
  return a(), n.attentionEncodeSurroundingInfo = {
    after: s.outside,
    before: c.outside
  }, d + u + h;
}
function vM(e, t, n) {
  return n.options.strong || "*";
}
function bM(e, t, n, r) {
  return n.safe(e.value, r);
}
function _M(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function wM(e, t, n) {
  const r = (cS(n) + (n.options.ruleSpaces ? " " : "")).repeat(_M(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const fS = {
  blockquote: Vj,
  break: Iv,
  code: Jj,
  definition: Yj,
  emphasis: nS,
  hardBreak: Iv,
  heading: nM,
  html: rS,
  image: iS,
  imageReference: oS,
  inlineCode: aS,
  link: lS,
  linkReference: uS,
  list: dM,
  listItem: hM,
  paragraph: pM,
  root: gM,
  strong: dS,
  text: bM,
  thematicBreak: wM
};
function kM() {
  return {
    enter: {
      table: SM,
      tableData: Pv,
      tableHeader: Pv,
      tableRow: IM
    },
    exit: {
      codeText: PM,
      table: xM,
      tableData: xd,
      tableHeader: xd,
      tableRow: xd
    }
  };
}
function SM(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function xM(e) {
  this.exit(e), this.data.inTable = void 0;
}
function IM(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function xd(e) {
  this.exit(e);
}
function Pv(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function PM(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, OM));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function OM(e, t) {
  return t === "|" ? t : e;
}
function zM(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, a = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: s,
      table: o,
      tableCell: u,
      tableRow: d
    }
  };
  function o(h, p, m, y) {
    return l(c(h, m, y), h.align);
  }
  function d(h, p, m, y) {
    const w = f(h, m, y), b = l([w]);
    return b.slice(0, b.indexOf(`
`));
  }
  function u(h, p, m, y) {
    const w = m.enter("tableCell"), b = m.enter("phrasing"), _ = m.containerPhrasing(h, {
      ...y,
      before: a,
      after: a
    });
    return b(), w(), _;
  }
  function l(h, p) {
    return Uj(h, {
      align: p,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function c(h, p, m) {
    const y = h.children;
    let w = -1;
    const b = [], _ = p.enter("table");
    for (; ++w < y.length; )
      b[w] = f(y[w], p, m);
    return _(), b;
  }
  function f(h, p, m) {
    const y = h.children;
    let w = -1;
    const b = [], _ = p.enter("tableRow");
    for (; ++w < y.length; )
      b[w] = u(y[w], h, p, m);
    return _(), b;
  }
  function s(h, p, m) {
    let y = fS.inlineCode(h, p, m);
    return m.stack.includes("tableCell") && (y = y.replace(/\|/g, "\\$&")), y;
  }
}
function EM() {
  return {
    exit: {
      taskListCheckValueChecked: Ov,
      taskListCheckValueUnchecked: Ov,
      paragraph: NM
    }
  };
}
function TM() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: CM }
  };
}
function Ov(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function NM(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let a = -1, o;
      for (; ++a < i.length; ) {
        const d = i[a];
        if (d.type === "paragraph") {
          o = d;
          break;
        }
      }
      o === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function CM(e, t, n, r) {
  const i = e.children[0], a = typeof e.checked == "boolean" && i && i.type === "paragraph", o = "[" + (e.checked ? "x" : " ") + "] ", d = n.createTracker(r);
  a && d.move(o);
  let u = fS.listItem(e, t, n, {
    ...r,
    ...d.current()
  });
  return a && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, l)), u;
  function l(c) {
    return c + o;
  }
}
function DM() {
  return [
    dj(),
    Cj(),
    Mj(),
    kM(),
    EM()
  ];
}
function AM(e) {
  return {
    extensions: [
      fj(),
      Dj(e),
      $j(),
      zM(e),
      TM()
    ]
  };
}
const jM = {
  tokenize: FM,
  partial: !0
}, hS = {
  tokenize: UM,
  partial: !0
}, pS = {
  tokenize: BM,
  partial: !0
}, mS = {
  tokenize: VM,
  partial: !0
}, MM = {
  tokenize: qM,
  partial: !0
}, gS = {
  name: "wwwAutolink",
  tokenize: ZM,
  previous: vS
}, yS = {
  name: "protocolAutolink",
  tokenize: LM,
  previous: bS
}, cr = {
  name: "emailAutolink",
  tokenize: RM,
  previous: _S
}, Hn = {};
function $M() {
  return {
    text: Hn
  };
}
let Rr = 48;
for (; Rr < 123; )
  Hn[Rr] = cr, Rr++, Rr === 58 ? Rr = 65 : Rr === 91 && (Rr = 97);
Hn[43] = cr;
Hn[45] = cr;
Hn[46] = cr;
Hn[95] = cr;
Hn[72] = [cr, yS];
Hn[104] = [cr, yS];
Hn[87] = [cr, gS];
Hn[119] = [cr, gS];
function RM(e, t, n) {
  const r = this;
  let i, a;
  return o;
  function o(f) {
    return !ch(f) || !_S.call(r, r.previous) || $p(r.events) ? n(f) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), d(f));
  }
  function d(f) {
    return ch(f) ? (e.consume(f), d) : f === 64 ? (e.consume(f), u) : n(f);
  }
  function u(f) {
    return f === 46 ? e.check(MM, c, l)(f) : f === 45 || f === 95 || Nt(f) ? (a = !0, e.consume(f), u) : c(f);
  }
  function l(f) {
    return e.consume(f), i = !0, u;
  }
  function c(f) {
    return a && i && $t(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(f)) : n(f);
  }
}
function ZM(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o !== 87 && o !== 119 || !vS.call(r, r.previous) || $p(r.events) ? n(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(jM, e.attempt(hS, e.attempt(pS, a), n), n)(o));
  }
  function a(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(o);
  }
}
function LM(e, t, n) {
  const r = this;
  let i = "", a = !1;
  return o;
  function o(f) {
    return (f === 72 || f === 104) && bS.call(r, r.previous) && !$p(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(f), e.consume(f), d) : n(f);
  }
  function d(f) {
    if ($t(f) && i.length < 5)
      return i += String.fromCodePoint(f), e.consume(f), d;
    if (f === 58) {
      const s = i.toLowerCase();
      if (s === "http" || s === "https")
        return e.consume(f), u;
    }
    return n(f);
  }
  function u(f) {
    return f === 47 ? (e.consume(f), a ? l : (a = !0, u)) : n(f);
  }
  function l(f) {
    return f === null || bu(f) || rt(f) || ti(f) || lc(f) ? n(f) : e.attempt(hS, e.attempt(pS, c), n)(f);
  }
  function c(f) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(f);
  }
}
function FM(e, t, n) {
  let r = 0;
  return i;
  function i(o) {
    return (o === 87 || o === 119) && r < 3 ? (r++, e.consume(o), i) : o === 46 && r === 3 ? (e.consume(o), a) : n(o);
  }
  function a(o) {
    return o === null ? n(o) : t(o);
  }
}
function UM(e, t, n) {
  let r, i, a;
  return o;
  function o(l) {
    return l === 46 || l === 95 ? e.check(mS, u, d)(l) : l === null || rt(l) || ti(l) || l !== 45 && lc(l) ? u(l) : (a = !0, e.consume(l), o);
  }
  function d(l) {
    return l === 95 ? r = !0 : (i = r, r = void 0), e.consume(l), o;
  }
  function u(l) {
    return i || r || !a ? n(l) : t(l);
  }
}
function BM(e, t) {
  let n = 0, r = 0;
  return i;
  function i(o) {
    return o === 40 ? (n++, e.consume(o), i) : o === 41 && r < n ? a(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(mS, t, a)(o) : o === null || rt(o) || ti(o) ? t(o) : (e.consume(o), i);
  }
  function a(o) {
    return o === 41 && r++, e.consume(o), i;
  }
}
function VM(e, t, n) {
  return r;
  function r(d) {
    return d === 33 || d === 34 || d === 39 || d === 41 || d === 42 || d === 44 || d === 46 || d === 58 || d === 59 || d === 63 || d === 95 || d === 126 ? (e.consume(d), r) : d === 38 ? (e.consume(d), a) : d === 93 ? (e.consume(d), i) : (
      // `<` is an end.
      d === 60 || // So is whitespace.
      d === null || rt(d) || ti(d) ? t(d) : n(d)
    );
  }
  function i(d) {
    return d === null || d === 40 || d === 91 || rt(d) || ti(d) ? t(d) : r(d);
  }
  function a(d) {
    return $t(d) ? o(d) : n(d);
  }
  function o(d) {
    return d === 59 ? (e.consume(d), r) : $t(d) ? (e.consume(d), o) : n(d);
  }
}
function qM(e, t, n) {
  return r;
  function r(a) {
    return e.consume(a), i;
  }
  function i(a) {
    return Nt(a) ? n(a) : t(a);
  }
}
function vS(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || rt(e);
}
function bS(e) {
  return !$t(e);
}
function _S(e) {
  return !(e === 47 || ch(e));
}
function ch(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Nt(e);
}
function $p(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const HM = {
  tokenize: e$,
  partial: !0
};
function WM() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: XM,
        continuation: {
          tokenize: YM
        },
        exit: QM
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: JM
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: GM,
        resolveTo: KM
      }
    }
  };
}
function GM(e, t, n) {
  const r = this;
  let i = r.events.length;
  const a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o;
  for (; i--; ) {
    const u = r.events[i][1];
    if (u.type === "labelImage") {
      o = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return d;
  function d(u) {
    if (!o || !o._balanced)
      return n(u);
    const l = zn(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }));
    return l.codePointAt(0) !== 94 || !a.includes(l.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function KM(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const a = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, a.start),
    end: Object.assign({}, a.end)
  }, d = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", i, t],
    ["exit", i, t],
    // Everything in between.
    ["enter", a, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", a, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...d), e;
}
function JM(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a = 0, o;
  return d;
  function d(f) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(f) {
    return f !== 94 ? n(f) : (e.enter("gfmFootnoteCallMarker"), e.consume(f), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", l);
  }
  function l(f) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      f === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      f === null || f === 91 || rt(f)
    )
      return n(f);
    if (f === 93) {
      e.exit("chunkString");
      const s = e.exit("gfmFootnoteCallString");
      return i.includes(zn(r.sliceSerialize(s))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(f);
    }
    return rt(f) || (o = !0), a++, e.consume(f), f === 92 ? c : l;
  }
  function c(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), a++, l) : l(f);
  }
}
function XM(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a, o = 0, d;
  return u;
  function u(p) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(p), e.exit("gfmFootnoteDefinitionLabelMarker"), l;
  }
  function l(p) {
    return p === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(p), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", c) : n(p);
  }
  function c(p) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      p === 93 && !d || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      p === null || p === 91 || rt(p)
    )
      return n(p);
    if (p === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteDefinitionLabelString");
      return a = zn(r.sliceSerialize(m)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(p), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), s;
    }
    return rt(p) || (d = !0), o++, e.consume(p), p === 92 ? f : c;
  }
  function f(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, c) : c(p);
  }
  function s(p) {
    return p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), i.includes(a) || i.push(a), He(e, h, "gfmFootnoteDefinitionWhitespace")) : n(p);
  }
  function h(p) {
    return t(p);
  }
}
function YM(e, t, n) {
  return e.check(ll, t, e.attempt(HM, t, n));
}
function QM(e) {
  e.exit("gfmFootnoteDefinition");
}
function e$(e, t, n) {
  const r = this;
  return He(e, i, "gfmFootnoteDefinitionIndent", 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? t(a) : n(a);
  }
}
function t$(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: a,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(o, d) {
    let u = -1;
    for (; ++u < o.length; )
      if (o[u][0] === "enter" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._close) {
        let l = u;
        for (; l--; )
          if (o[l][0] === "exit" && o[l][1].type === "strikethroughSequenceTemporary" && o[l][1]._open && // If the sizes are the same:
          o[u][1].end.offset - o[u][1].start.offset === o[l][1].end.offset - o[l][1].start.offset) {
            o[u][1].type = "strikethroughSequence", o[l][1].type = "strikethroughSequence";
            const c = {
              type: "strikethrough",
              start: Object.assign({}, o[l][1].start),
              end: Object.assign({}, o[u][1].end)
            }, f = {
              type: "strikethroughText",
              start: Object.assign({}, o[l][1].end),
              end: Object.assign({}, o[u][1].start)
            }, s = [["enter", c, d], ["enter", o[l][1], d], ["exit", o[l][1], d], ["enter", f, d]], h = d.parser.constructs.insideSpan.null;
            h && rn(s, s.length, 0, uc(h, o.slice(l + 1, u), d)), rn(s, s.length, 0, [["exit", f, d], ["enter", o[u][1], d], ["exit", o[u][1], d], ["exit", c, d]]), rn(o, l - 1, u - l + 3, s), u = l + s.length - 2;
            break;
          }
      }
    for (u = -1; ++u < o.length; )
      o[u][1].type === "strikethroughSequenceTemporary" && (o[u][1].type = "data");
    return o;
  }
  function a(o, d, u) {
    const l = this.previous, c = this.events;
    let f = 0;
    return s;
    function s(p) {
      return l === 126 && c[c.length - 1][1].type !== "characterEscape" ? u(p) : (o.enter("strikethroughSequenceTemporary"), h(p));
    }
    function h(p) {
      const m = Co(l);
      if (p === 126)
        return f > 1 ? u(p) : (o.consume(p), f++, h);
      if (f < 2 && !n) return u(p);
      const y = o.exit("strikethroughSequenceTemporary"), w = Co(p);
      return y._open = !w || w === 2 && !!m, y._close = !m || m === 2 && !!w, d(p);
    }
  }
}
class n$ {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    r$(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(a, o) {
      return a[0] - o[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push(t.slice()), t.length = 0;
    let i = r.pop();
    for (; i; ) {
      for (const a of i)
        t.push(a);
      i = r.pop();
    }
    this.map.length = 0;
  }
}
function r$(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function i$(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const a = r.length - 1;
          r[a] = r[a] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function o$() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: a$,
        resolveAll: s$
      }
    }
  };
}
function a$(e, t, n) {
  const r = this;
  let i = 0, a = 0, o;
  return d;
  function d(N) {
    let M = r.events.length - 1;
    for (; M > -1; ) {
      const C = r.events[M][1].type;
      if (C === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      C === "linePrefix") M--;
      else break;
    }
    const R = M > -1 ? r.events[M][1].type : null, V = R === "tableHead" || R === "tableRow" ? P : u;
    return V === P && r.parser.lazy[r.now().line] ? n(N) : V(N);
  }
  function u(N) {
    return e.enter("tableHead"), e.enter("tableRow"), l(N);
  }
  function l(N) {
    return N === 124 || (o = !0, a += 1), c(N);
  }
  function c(N) {
    return N === null ? n(N) : ze(N) ? a > 1 ? (a = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), h) : n(N) : Fe(N) ? He(e, c, "whitespace")(N) : (a += 1, o && (o = !1, i += 1), N === 124 ? (e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), o = !0, c) : (e.enter("data"), f(N)));
  }
  function f(N) {
    return N === null || N === 124 || rt(N) ? (e.exit("data"), c(N)) : (e.consume(N), N === 92 ? s : f);
  }
  function s(N) {
    return N === 92 || N === 124 ? (e.consume(N), f) : f(N);
  }
  function h(N) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(N) : (e.enter("tableDelimiterRow"), o = !1, Fe(N) ? He(e, p, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(N) : p(N));
  }
  function p(N) {
    return N === 45 || N === 58 ? y(N) : N === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), m) : O(N);
  }
  function m(N) {
    return Fe(N) ? He(e, y, "whitespace")(N) : y(N);
  }
  function y(N) {
    return N === 58 ? (a += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(N), e.exit("tableDelimiterMarker"), w) : N === 45 ? (a += 1, w(N)) : N === null || ze(N) ? g(N) : O(N);
  }
  function w(N) {
    return N === 45 ? (e.enter("tableDelimiterFiller"), b(N)) : O(N);
  }
  function b(N) {
    return N === 45 ? (e.consume(N), b) : N === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(N), e.exit("tableDelimiterMarker"), _) : (e.exit("tableDelimiterFiller"), _(N));
  }
  function _(N) {
    return Fe(N) ? He(e, g, "whitespace")(N) : g(N);
  }
  function g(N) {
    return N === 124 ? p(N) : N === null || ze(N) ? !o || i !== a ? O(N) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(N)) : O(N);
  }
  function O(N) {
    return n(N);
  }
  function P(N) {
    return e.enter("tableRow"), E(N);
  }
  function E(N) {
    return N === 124 ? (e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), E) : N === null || ze(N) ? (e.exit("tableRow"), t(N)) : Fe(N) ? He(e, E, "whitespace")(N) : (e.enter("data"), T(N));
  }
  function T(N) {
    return N === null || N === 124 || rt(N) ? (e.exit("data"), E(N)) : (e.consume(N), N === 92 ? D : T);
  }
  function D(N) {
    return N === 92 || N === 124 ? (e.consume(N), T) : T(N);
  }
}
function s$(e, t) {
  let n = -1, r = !0, i = 0, a = [0, 0, 0, 0], o = [0, 0, 0, 0], d = !1, u = 0, l, c, f;
  const s = new n$();
  for (; ++n < e.length; ) {
    const h = e[n], p = h[1];
    h[0] === "enter" ? p.type === "tableHead" ? (d = !1, u !== 0 && (zv(s, t, u, l, c), c = void 0, u = 0), l = {
      type: "table",
      start: Object.assign({}, p.start),
      // Note: correct end is set later.
      end: Object.assign({}, p.end)
    }, s.add(n, 0, [["enter", l, t]])) : p.type === "tableRow" || p.type === "tableDelimiterRow" ? (r = !0, f = void 0, a = [0, 0, 0, 0], o = [0, n + 1, 0, 0], d && (d = !1, c = {
      type: "tableBody",
      start: Object.assign({}, p.start),
      // Note: correct end is set later.
      end: Object.assign({}, p.end)
    }, s.add(n, 0, [["enter", c, t]])), i = p.type === "tableDelimiterRow" ? 2 : c ? 3 : 1) : i && (p.type === "data" || p.type === "tableDelimiterMarker" || p.type === "tableDelimiterFiller") ? (r = !1, o[2] === 0 && (a[1] !== 0 && (o[0] = o[1], f = jl(s, t, a, i, void 0, f), a = [0, 0, 0, 0]), o[2] = n)) : p.type === "tableCellDivider" && (r ? r = !1 : (a[1] !== 0 && (o[0] = o[1], f = jl(s, t, a, i, void 0, f)), a = o, o = [a[1], n, 0, 0])) : p.type === "tableHead" ? (d = !0, u = n) : p.type === "tableRow" || p.type === "tableDelimiterRow" ? (u = n, a[1] !== 0 ? (o[0] = o[1], f = jl(s, t, a, i, n, f)) : o[1] !== 0 && (f = jl(s, t, o, i, n, f)), i = 0) : i && (p.type === "data" || p.type === "tableDelimiterMarker" || p.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (u !== 0 && zv(s, t, u, l, c), s.consume(t.events), n = -1; ++n < t.events.length; ) {
    const h = t.events[n];
    h[0] === "enter" && h[1].type === "table" && (h[1]._align = i$(t.events, n));
  }
  return e;
}
function jl(e, t, n, r, i, a) {
  const o = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", d = "tableContent";
  n[0] !== 0 && (a.end = Object.assign({}, go(t.events, n[0])), e.add(n[0], 0, [["exit", a, t]]));
  const u = go(t.events, n[1]);
  if (a = {
    type: o,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", a, t]]), n[2] !== 0) {
    const l = go(t.events, n[2]), c = go(t.events, n[3]), f = {
      type: d,
      start: Object.assign({}, l),
      end: Object.assign({}, c)
    };
    if (e.add(n[2], 0, [["enter", f, t]]), r !== 2) {
      const s = t.events[n[2]], h = t.events[n[3]];
      if (s[1].end = Object.assign({}, h[1].end), s[1].type = "chunkText", s[1].contentType = "text", n[3] > n[2] + 1) {
        const p = n[2] + 1, m = n[3] - n[2] - 1;
        e.add(p, m, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", f, t]]);
  }
  return i !== void 0 && (a.end = Object.assign({}, go(t.events, i)), e.add(i, 0, [["exit", a, t]]), a = void 0), a;
}
function zv(e, t, n, r, i) {
  const a = [], o = go(t.events, n);
  i && (i.end = Object.assign({}, o), a.push(["exit", i, t])), r.end = Object.assign({}, o), a.push(["exit", r, t]), e.add(n + 1, 0, a);
}
function go(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const l$ = {
  name: "tasklistCheck",
  tokenize: c$
};
function u$() {
  return {
    text: {
      91: l$
    }
  };
}
function c$(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), a)
    );
  }
  function a(u) {
    return rt(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), o) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), o) : n(u);
  }
  function o(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), d) : n(u);
  }
  function d(u) {
    return ze(u) ? t(u) : Fe(u) ? e.check({
      tokenize: d$
    }, t, n)(u) : n(u);
  }
}
function d$(e, t, n) {
  return He(e, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : t(i);
  }
}
function f$(e) {
  return Nk([
    $M(),
    WM(),
    t$(e),
    o$(),
    u$()
  ]);
}
const h$ = {};
function p$(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), n = e || h$, r = t.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), a = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), o = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(f$(n)), a.push(DM()), o.push(AM(n));
}
const m$ = {
  a: (e) => /* @__PURE__ */ x(
    "a",
    {
      ...e,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "text-primary underline underline-offset-2 hover:no-underline"
    }
  ),
  p: ({ children: e }) => /* @__PURE__ */ x("p", { className: "my-2 first:mt-0 last:mb-0", children: e }),
  ul: ({ children: e }) => /* @__PURE__ */ x("ul", { className: "my-2 list-disc space-y-1 pl-5 first:mt-0 last:mb-0", children: e }),
  ol: ({ children: e }) => /* @__PURE__ */ x("ol", { className: "my-2 list-decimal space-y-1 pl-5 first:mt-0 last:mb-0", children: e }),
  li: ({ children: e }) => /* @__PURE__ */ x("li", { className: "leading-relaxed", children: e }),
  h1: ({ children: e }) => /* @__PURE__ */ x("h1", { className: "mb-2 mt-4 text-lg font-semibold first:mt-0", children: e }),
  h2: ({ children: e }) => /* @__PURE__ */ x("h2", { className: "mb-2 mt-4 text-base font-semibold first:mt-0", children: e }),
  h3: ({ children: e }) => /* @__PURE__ */ x("h3", { className: "mb-1.5 mt-3 text-sm font-semibold first:mt-0", children: e }),
  h4: ({ children: e }) => /* @__PURE__ */ x("h4", { className: "mb-1.5 mt-3 text-sm font-semibold first:mt-0", children: e }),
  strong: ({ children: e }) => /* @__PURE__ */ x("strong", { className: "font-semibold", children: e }),
  em: ({ children: e }) => /* @__PURE__ */ x("em", { className: "italic", children: e }),
  hr: () => /* @__PURE__ */ x("hr", { className: "my-3 border-border-light" }),
  blockquote: ({ children: e }) => /* @__PURE__ */ x("blockquote", { className: "my-2 border-l-2 border-border-light pl-3 text-foreground-subtle", children: e }),
  code: ({ className: e, children: t, ...n }) => /language-/.test(e ?? "") ? /* @__PURE__ */ x("code", { className: Be("font-mono text-[13px] leading-relaxed", e), ...n, children: t }) : /* @__PURE__ */ x(
    "code",
    {
      className: "rounded bg-surface px-1 py-0.5 font-mono text-[13px] text-foreground",
      ...n,
      children: t
    }
  ),
  pre: ({ children: e }) => /* @__PURE__ */ x("pre", { className: "my-2 overflow-x-auto rounded-lg bg-surface p-3 text-foreground first:mt-0 last:mb-0", children: e }),
  table: ({ children: e }) => /* @__PURE__ */ x("div", { className: "my-2 overflow-x-auto", children: /* @__PURE__ */ x("table", { className: "w-full border-collapse text-[13px]", children: e }) }),
  th: ({ children: e }) => /* @__PURE__ */ x("th", { className: "border border-border-light px-2 py-1 text-left font-semibold", children: e }),
  td: ({ children: e }) => /* @__PURE__ */ x("td", { className: "border border-border-light px-2 py-1 align-top", children: e })
}, g$ = gt(function({ children: t }) {
  return /* @__PURE__ */ x("div", { className: "break-words text-[15px] leading-relaxed text-foreground", children: /* @__PURE__ */ x(tj, { remarkPlugins: [p$], components: m$, children: t }) });
});
function kt(e) {
  if (typeof e == "string" || typeof e == "number") return "" + e;
  let t = "";
  if (Array.isArray(e))
    for (let n = 0, r; n < e.length; n++)
      (r = kt(e[n])) !== "" && (t += (t && " ") + r);
  else
    for (let n in e)
      e[n] && (t += (t && " ") + n);
  return t;
}
var y$ = { value: () => {
} };
function hc() {
  for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
    if (!(r = arguments[e] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new ru(n);
}
function ru(e) {
  this._ = e;
}
function v$(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !t.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
ru.prototype = hc.prototype = {
  constructor: ru,
  on: function(e, t) {
    var n = this._, r = v$(e + "", n), i, a = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++a < o; ) if ((i = (e = r[a]).type) && (i = b$(n[i], e.name))) return i;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++a < o; )
      if (i = (e = r[a]).type) n[i] = Ev(n[i], e.name, t);
      else if (t == null) for (i in n) n[i] = Ev(n[i], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t) e[n] = t[n].slice();
    return new ru(e);
  },
  call: function(e, t) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, a; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (a = this._[e], r = 0, i = a.length; r < i; ++r) a[r].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var r = this._[e], i = 0, a = r.length; i < a; ++i) r[i].value.apply(t, n);
  }
};
function b$(e, t) {
  for (var n = 0, r = e.length, i; n < r; ++n)
    if ((i = e[n]).name === t)
      return i.value;
}
function Ev(e, t, n) {
  for (var r = 0, i = e.length; r < i; ++r)
    if (e[r].name === t) {
      e[r] = y$, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var dh = "http://www.w3.org/1999/xhtml";
const Tv = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: dh,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function pc(e) {
  var t = e += "", n = t.indexOf(":");
  return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), Tv.hasOwnProperty(t) ? { space: Tv[t], local: e } : e;
}
function _$(e) {
  return function() {
    var t = this.ownerDocument, n = this.namespaceURI;
    return n === dh && t.documentElement.namespaceURI === dh ? t.createElement(e) : t.createElementNS(n, e);
  };
}
function w$(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function wS(e) {
  var t = pc(e);
  return (t.local ? w$ : _$)(t);
}
function k$() {
}
function Rp(e) {
  return e == null ? k$ : function() {
    return this.querySelector(e);
  };
}
function S$(e) {
  typeof e != "function" && (e = Rp(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, d = r[i] = new Array(o), u, l, c = 0; c < o; ++c)
      (u = a[c]) && (l = e.call(u, u.__data__, c, a)) && ("__data__" in u && (l.__data__ = u.__data__), d[c] = l);
  return new on(r, this._parents);
}
function x$(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function I$() {
  return [];
}
function kS(e) {
  return e == null ? I$ : function() {
    return this.querySelectorAll(e);
  };
}
function P$(e) {
  return function() {
    return x$(e.apply(this, arguments));
  };
}
function O$(e) {
  typeof e == "function" ? e = P$(e) : e = kS(e);
  for (var t = this._groups, n = t.length, r = [], i = [], a = 0; a < n; ++a)
    for (var o = t[a], d = o.length, u, l = 0; l < d; ++l)
      (u = o[l]) && (r.push(e.call(u, u.__data__, l, o)), i.push(u));
  return new on(r, i);
}
function SS(e) {
  return function() {
    return this.matches(e);
  };
}
function xS(e) {
  return function(t) {
    return t.matches(e);
  };
}
var z$ = Array.prototype.find;
function E$(e) {
  return function() {
    return z$.call(this.children, e);
  };
}
function T$() {
  return this.firstElementChild;
}
function N$(e) {
  return this.select(e == null ? T$ : E$(typeof e == "function" ? e : xS(e)));
}
var C$ = Array.prototype.filter;
function D$() {
  return Array.from(this.children);
}
function A$(e) {
  return function() {
    return C$.call(this.children, e);
  };
}
function j$(e) {
  return this.selectAll(e == null ? D$ : A$(typeof e == "function" ? e : xS(e)));
}
function M$(e) {
  typeof e != "function" && (e = SS(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, d = r[i] = [], u, l = 0; l < o; ++l)
      (u = a[l]) && e.call(u, u.__data__, l, a) && d.push(u);
  return new on(r, this._parents);
}
function IS(e) {
  return new Array(e.length);
}
function $$() {
  return new on(this._enter || this._groups.map(IS), this._parents);
}
function Su(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
Su.prototype = {
  constructor: Su,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function R$(e) {
  return function() {
    return e;
  };
}
function Z$(e, t, n, r, i, a) {
  for (var o = 0, d, u = t.length, l = a.length; o < l; ++o)
    (d = t[o]) ? (d.__data__ = a[o], r[o] = d) : n[o] = new Su(e, a[o]);
  for (; o < u; ++o)
    (d = t[o]) && (i[o] = d);
}
function L$(e, t, n, r, i, a, o) {
  var d, u, l = /* @__PURE__ */ new Map(), c = t.length, f = a.length, s = new Array(c), h;
  for (d = 0; d < c; ++d)
    (u = t[d]) && (s[d] = h = o.call(u, u.__data__, d, t) + "", l.has(h) ? i[d] = u : l.set(h, u));
  for (d = 0; d < f; ++d)
    h = o.call(e, a[d], d, a) + "", (u = l.get(h)) ? (r[d] = u, u.__data__ = a[d], l.delete(h)) : n[d] = new Su(e, a[d]);
  for (d = 0; d < c; ++d)
    (u = t[d]) && l.get(s[d]) === u && (i[d] = u);
}
function F$(e) {
  return e.__data__;
}
function U$(e, t) {
  if (!arguments.length) return Array.from(this, F$);
  var n = t ? L$ : Z$, r = this._parents, i = this._groups;
  typeof e != "function" && (e = R$(e));
  for (var a = i.length, o = new Array(a), d = new Array(a), u = new Array(a), l = 0; l < a; ++l) {
    var c = r[l], f = i[l], s = f.length, h = B$(e.call(c, c && c.__data__, l, r)), p = h.length, m = d[l] = new Array(p), y = o[l] = new Array(p), w = u[l] = new Array(s);
    n(c, f, m, y, w, h, t);
    for (var b = 0, _ = 0, g, O; b < p; ++b)
      if (g = m[b]) {
        for (b >= _ && (_ = b + 1); !(O = y[_]) && ++_ < p; ) ;
        g._next = O || null;
      }
  }
  return o = new on(o, r), o._enter = d, o._exit = u, o;
}
function B$(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function V$() {
  return new on(this._exit || this._groups.map(IS), this._parents);
}
function q$(e, t, n) {
  var r = this.enter(), i = this, a = this.exit();
  return typeof e == "function" ? (r = e(r), r && (r = r.selection())) : r = r.append(e + ""), t != null && (i = t(i), i && (i = i.selection())), n == null ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
}
function H$(e) {
  for (var t = e.selection ? e.selection() : e, n = this._groups, r = t._groups, i = n.length, a = r.length, o = Math.min(i, a), d = new Array(i), u = 0; u < o; ++u)
    for (var l = n[u], c = r[u], f = l.length, s = d[u] = new Array(f), h, p = 0; p < f; ++p)
      (h = l[p] || c[p]) && (s[p] = h);
  for (; u < i; ++u)
    d[u] = n[u];
  return new on(d, this._parents);
}
function W$() {
  for (var e = this._groups, t = -1, n = e.length; ++t < n; )
    for (var r = e[t], i = r.length - 1, a = r[i], o; --i >= 0; )
      (o = r[i]) && (a && o.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(o, a), a = o);
  return this;
}
function G$(e) {
  e || (e = K$);
  function t(f, s) {
    return f && s ? e(f.__data__, s.__data__) : !f - !s;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
    for (var o = n[a], d = o.length, u = i[a] = new Array(d), l, c = 0; c < d; ++c)
      (l = o[c]) && (u[c] = l);
    u.sort(t);
  }
  return new on(i, this._parents).order();
}
function K$(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function J$() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function X$() {
  return Array.from(this);
}
function Y$() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], i = 0, a = r.length; i < a; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function Q$() {
  let e = 0;
  for (const t of this) ++e;
  return e;
}
function e4() {
  return !this.node();
}
function t4(e) {
  for (var t = this._groups, n = 0, r = t.length; n < r; ++n)
    for (var i = t[n], a = 0, o = i.length, d; a < o; ++a)
      (d = i[a]) && e.call(d, d.__data__, a, i);
  return this;
}
function n4(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function r4(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function i4(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function o4(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function a4(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function s4(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function l4(e, t) {
  var n = pc(e);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((t == null ? n.local ? r4 : n4 : typeof t == "function" ? n.local ? s4 : a4 : n.local ? o4 : i4)(n, t));
}
function PS(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function u4(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function c4(e, t, n) {
  return function() {
    this.style.setProperty(e, t, n);
  };
}
function d4(e, t, n) {
  return function() {
    var r = t.apply(this, arguments);
    r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
  };
}
function f4(e, t, n) {
  return arguments.length > 1 ? this.each((t == null ? u4 : typeof t == "function" ? d4 : c4)(e, t, n ?? "")) : Do(this.node(), e);
}
function Do(e, t) {
  return e.style.getPropertyValue(t) || PS(e).getComputedStyle(e, null).getPropertyValue(t);
}
function h4(e) {
  return function() {
    delete this[e];
  };
}
function p4(e, t) {
  return function() {
    this[e] = t;
  };
}
function m4(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function g4(e, t) {
  return arguments.length > 1 ? this.each((t == null ? h4 : typeof t == "function" ? m4 : p4)(e, t)) : this.node()[e];
}
function OS(e) {
  return e.trim().split(/^|\s+/);
}
function Zp(e) {
  return e.classList || new zS(e);
}
function zS(e) {
  this._node = e, this._names = OS(e.getAttribute("class") || "");
}
zS.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function ES(e, t) {
  for (var n = Zp(e), r = -1, i = t.length; ++r < i; ) n.add(t[r]);
}
function TS(e, t) {
  for (var n = Zp(e), r = -1, i = t.length; ++r < i; ) n.remove(t[r]);
}
function y4(e) {
  return function() {
    ES(this, e);
  };
}
function v4(e) {
  return function() {
    TS(this, e);
  };
}
function b4(e, t) {
  return function() {
    (t.apply(this, arguments) ? ES : TS)(this, e);
  };
}
function _4(e, t) {
  var n = OS(e + "");
  if (arguments.length < 2) {
    for (var r = Zp(this.node()), i = -1, a = n.length; ++i < a; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? b4 : t ? y4 : v4)(n, t));
}
function w4() {
  this.textContent = "";
}
function k4(e) {
  return function() {
    this.textContent = e;
  };
}
function S4(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function x4(e) {
  return arguments.length ? this.each(e == null ? w4 : (typeof e == "function" ? S4 : k4)(e)) : this.node().textContent;
}
function I4() {
  this.innerHTML = "";
}
function P4(e) {
  return function() {
    this.innerHTML = e;
  };
}
function O4(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function z4(e) {
  return arguments.length ? this.each(e == null ? I4 : (typeof e == "function" ? O4 : P4)(e)) : this.node().innerHTML;
}
function E4() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function T4() {
  return this.each(E4);
}
function N4() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function C4() {
  return this.each(N4);
}
function D4(e) {
  var t = typeof e == "function" ? e : wS(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function A4() {
  return null;
}
function j4(e, t) {
  var n = typeof e == "function" ? e : wS(e), r = t == null ? A4 : typeof t == "function" ? t : Rp(t);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function M4() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function $4() {
  return this.each(M4);
}
function R4() {
  var e = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function Z4() {
  var e = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function L4(e) {
  return this.select(e ? Z4 : R4);
}
function F4(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function U4(e) {
  return function(t) {
    e.call(this, t, this.__data__);
  };
}
function B4(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var n = "", r = t.indexOf(".");
    return r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), { type: t, name: n };
  });
}
function V4(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var n = 0, r = -1, i = t.length, a; n < i; ++n)
        a = t[n], (!e.type || a.type === e.type) && a.name === e.name ? this.removeEventListener(a.type, a.listener, a.options) : t[++r] = a;
      ++r ? t.length = r : delete this.__on;
    }
  };
}
function q4(e, t, n) {
  return function() {
    var r = this.__on, i, a = U4(t);
    if (r) {
      for (var o = 0, d = r.length; o < d; ++o)
        if ((i = r[o]).type === e.type && i.name === e.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = n), i.value = t;
          return;
        }
    }
    this.addEventListener(e.type, a, n), i = { type: e.type, name: e.name, value: t, listener: a, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function H4(e, t, n) {
  var r = B4(e + ""), i, a = r.length, o;
  if (arguments.length < 2) {
    var d = this.node().__on;
    if (d) {
      for (var u = 0, l = d.length, c; u < l; ++u)
        for (i = 0, c = d[u]; i < a; ++i)
          if ((o = r[i]).type === c.type && o.name === c.name)
            return c.value;
    }
    return;
  }
  for (d = t ? q4 : V4, i = 0; i < a; ++i) this.each(d(r[i], t, n));
  return this;
}
function NS(e, t, n) {
  var r = PS(e), i = r.CustomEvent;
  typeof i == "function" ? i = new i(t, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(t, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(t, !1, !1)), e.dispatchEvent(i);
}
function W4(e, t) {
  return function() {
    return NS(this, e, t);
  };
}
function G4(e, t) {
  return function() {
    return NS(this, e, t.apply(this, arguments));
  };
}
function K4(e, t) {
  return this.each((typeof t == "function" ? G4 : W4)(e, t));
}
function* J4() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], i = 0, a = r.length, o; i < a; ++i)
      (o = r[i]) && (yield o);
}
var CS = [null];
function on(e, t) {
  this._groups = e, this._parents = t;
}
function cl() {
  return new on([[document.documentElement]], CS);
}
function X4() {
  return this;
}
on.prototype = cl.prototype = {
  constructor: on,
  select: S$,
  selectAll: O$,
  selectChild: N$,
  selectChildren: j$,
  filter: M$,
  data: U$,
  enter: $$,
  exit: V$,
  join: q$,
  merge: H$,
  selection: X4,
  order: W$,
  sort: G$,
  call: J$,
  nodes: X$,
  node: Y$,
  size: Q$,
  empty: e4,
  each: t4,
  attr: l4,
  style: f4,
  property: g4,
  classed: _4,
  text: x4,
  html: z4,
  raise: T4,
  lower: C4,
  append: D4,
  insert: j4,
  remove: $4,
  clone: L4,
  datum: F4,
  on: H4,
  dispatch: K4,
  [Symbol.iterator]: J4
};
function en(e) {
  return typeof e == "string" ? new on([[document.querySelector(e)]], [document.documentElement]) : new on([[e]], CS);
}
function Y4(e) {
  let t;
  for (; t = e.sourceEvent; ) e = t;
  return e;
}
function Sn(e, t) {
  if (e = Y4(e), t === void 0 && (t = e.currentTarget), t) {
    var n = t.ownerSVGElement || t;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = e.clientX, r.y = e.clientY, r = r.matrixTransform(t.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (t.getBoundingClientRect) {
      var i = t.getBoundingClientRect();
      return [e.clientX - i.left - t.clientLeft, e.clientY - i.top - t.clientTop];
    }
  }
  return [e.pageX, e.pageY];
}
const Q4 = { passive: !1 }, Fs = { capture: !0, passive: !1 };
function Id(e) {
  e.stopImmediatePropagation();
}
function zo(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function DS(e) {
  var t = e.document.documentElement, n = en(e).on("dragstart.drag", zo, Fs);
  "onselectstart" in t ? n.on("selectstart.drag", zo, Fs) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function AS(e, t) {
  var n = e.document.documentElement, r = en(e).on("dragstart.drag", null);
  t && (r.on("click.drag", zo, Fs), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const Ml = (e) => () => e;
function fh(e, {
  sourceEvent: t,
  subject: n,
  target: r,
  identifier: i,
  active: a,
  x: o,
  y: d,
  dx: u,
  dy: l,
  dispatch: c
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: t, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: i, enumerable: !0, configurable: !0 },
    active: { value: a, enumerable: !0, configurable: !0 },
    x: { value: o, enumerable: !0, configurable: !0 },
    y: { value: d, enumerable: !0, configurable: !0 },
    dx: { value: u, enumerable: !0, configurable: !0 },
    dy: { value: l, enumerable: !0, configurable: !0 },
    _: { value: c }
  });
}
fh.prototype.on = function() {
  var e = this._.on.apply(this._, arguments);
  return e === this._ ? this : e;
};
function eR(e) {
  return !e.ctrlKey && !e.button;
}
function tR() {
  return this.parentNode;
}
function nR(e, t) {
  return t ?? { x: e.x, y: e.y };
}
function rR() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function jS() {
  var e = eR, t = tR, n = nR, r = rR, i = {}, a = hc("start", "drag", "end"), o = 0, d, u, l, c, f = 0;
  function s(g) {
    g.on("mousedown.drag", h).filter(r).on("touchstart.drag", y).on("touchmove.drag", w, Q4).on("touchend.drag touchcancel.drag", b).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function h(g, O) {
    if (!(c || !e.call(this, g, O))) {
      var P = _(this, t.call(this, g, O), g, O, "mouse");
      P && (en(g.view).on("mousemove.drag", p, Fs).on("mouseup.drag", m, Fs), DS(g.view), Id(g), l = !1, d = g.clientX, u = g.clientY, P("start", g));
    }
  }
  function p(g) {
    if (zo(g), !l) {
      var O = g.clientX - d, P = g.clientY - u;
      l = O * O + P * P > f;
    }
    i.mouse("drag", g);
  }
  function m(g) {
    en(g.view).on("mousemove.drag mouseup.drag", null), AS(g.view, l), zo(g), i.mouse("end", g);
  }
  function y(g, O) {
    if (e.call(this, g, O)) {
      var P = g.changedTouches, E = t.call(this, g, O), T = P.length, D, N;
      for (D = 0; D < T; ++D)
        (N = _(this, E, g, O, P[D].identifier, P[D])) && (Id(g), N("start", g, P[D]));
    }
  }
  function w(g) {
    var O = g.changedTouches, P = O.length, E, T;
    for (E = 0; E < P; ++E)
      (T = i[O[E].identifier]) && (zo(g), T("drag", g, O[E]));
  }
  function b(g) {
    var O = g.changedTouches, P = O.length, E, T;
    for (c && clearTimeout(c), c = setTimeout(function() {
      c = null;
    }, 500), E = 0; E < P; ++E)
      (T = i[O[E].identifier]) && (Id(g), T("end", g, O[E]));
  }
  function _(g, O, P, E, T, D) {
    var N = a.copy(), M = Sn(D || P, O), R, V, C;
    if ((C = n.call(g, new fh("beforestart", {
      sourceEvent: P,
      target: s,
      identifier: T,
      active: o,
      x: M[0],
      y: M[1],
      dx: 0,
      dy: 0,
      dispatch: N
    }), E)) != null)
      return R = C.x - M[0] || 0, V = C.y - M[1] || 0, function B(G, Q, k) {
        var I = M, S;
        switch (G) {
          case "start":
            i[T] = B, S = o++;
            break;
          case "end":
            delete i[T], --o;
          // falls through
          case "drag":
            M = Sn(k || Q, O), S = o;
            break;
        }
        N.call(
          G,
          g,
          new fh(G, {
            sourceEvent: Q,
            subject: C,
            target: s,
            identifier: T,
            active: S,
            x: M[0] + R,
            y: M[1] + V,
            dx: M[0] - I[0],
            dy: M[1] - I[1],
            dispatch: N
          }),
          E
        );
      };
  }
  return s.filter = function(g) {
    return arguments.length ? (e = typeof g == "function" ? g : Ml(!!g), s) : e;
  }, s.container = function(g) {
    return arguments.length ? (t = typeof g == "function" ? g : Ml(g), s) : t;
  }, s.subject = function(g) {
    return arguments.length ? (n = typeof g == "function" ? g : Ml(g), s) : n;
  }, s.touchable = function(g) {
    return arguments.length ? (r = typeof g == "function" ? g : Ml(!!g), s) : r;
  }, s.on = function() {
    var g = a.on.apply(a, arguments);
    return g === a ? s : g;
  }, s.clickDistance = function(g) {
    return arguments.length ? (f = (g = +g) * g, s) : Math.sqrt(f);
  }, s;
}
function Lp(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function MS(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function dl() {
}
var Us = 0.7, xu = 1 / Us, Eo = "\\s*([+-]?\\d+)\\s*", Bs = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Fn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", iR = /^#([0-9a-f]{3,8})$/, oR = new RegExp(`^rgb\\(${Eo},${Eo},${Eo}\\)$`), aR = new RegExp(`^rgb\\(${Fn},${Fn},${Fn}\\)$`), sR = new RegExp(`^rgba\\(${Eo},${Eo},${Eo},${Bs}\\)$`), lR = new RegExp(`^rgba\\(${Fn},${Fn},${Fn},${Bs}\\)$`), uR = new RegExp(`^hsl\\(${Bs},${Fn},${Fn}\\)$`), cR = new RegExp(`^hsla\\(${Bs},${Fn},${Fn},${Bs}\\)$`), Nv = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Lp(dl, ni, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Cv,
  // Deprecated! Use color.formatHex.
  formatHex: Cv,
  formatHex8: dR,
  formatHsl: fR,
  formatRgb: Dv,
  toString: Dv
});
function Cv() {
  return this.rgb().formatHex();
}
function dR() {
  return this.rgb().formatHex8();
}
function fR() {
  return $S(this).formatHsl();
}
function Dv() {
  return this.rgb().formatRgb();
}
function ni(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = iR.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Av(t) : n === 3 ? new qt(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? $l(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? $l(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = oR.exec(e)) ? new qt(t[1], t[2], t[3], 1) : (t = aR.exec(e)) ? new qt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = sR.exec(e)) ? $l(t[1], t[2], t[3], t[4]) : (t = lR.exec(e)) ? $l(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = uR.exec(e)) ? $v(t[1], t[2] / 100, t[3] / 100, 1) : (t = cR.exec(e)) ? $v(t[1], t[2] / 100, t[3] / 100, t[4]) : Nv.hasOwnProperty(e) ? Av(Nv[e]) : e === "transparent" ? new qt(NaN, NaN, NaN, 0) : null;
}
function Av(e) {
  return new qt(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function $l(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new qt(e, t, n, r);
}
function hR(e) {
  return e instanceof dl || (e = ni(e)), e ? (e = e.rgb(), new qt(e.r, e.g, e.b, e.opacity)) : new qt();
}
function hh(e, t, n, r) {
  return arguments.length === 1 ? hR(e) : new qt(e, t, n, r ?? 1);
}
function qt(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Lp(qt, hh, MS(dl, {
  brighter(e) {
    return e = e == null ? xu : Math.pow(xu, e), new qt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Us : Math.pow(Us, e), new qt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new qt(Xr(this.r), Xr(this.g), Xr(this.b), Iu(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: jv,
  // Deprecated! Use color.formatHex.
  formatHex: jv,
  formatHex8: pR,
  formatRgb: Mv,
  toString: Mv
}));
function jv() {
  return `#${Gr(this.r)}${Gr(this.g)}${Gr(this.b)}`;
}
function pR() {
  return `#${Gr(this.r)}${Gr(this.g)}${Gr(this.b)}${Gr((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Mv() {
  const e = Iu(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Xr(this.r)}, ${Xr(this.g)}, ${Xr(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Iu(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Xr(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Gr(e) {
  return e = Xr(e), (e < 16 ? "0" : "") + e.toString(16);
}
function $v(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new xn(e, t, n, r);
}
function $S(e) {
  if (e instanceof xn) return new xn(e.h, e.s, e.l, e.opacity);
  if (e instanceof dl || (e = ni(e)), !e) return new xn();
  if (e instanceof xn) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, d = a - i, u = (a + i) / 2;
  return d ? (t === a ? o = (n - r) / d + (n < r) * 6 : n === a ? o = (r - t) / d + 2 : o = (t - n) / d + 4, d /= u < 0.5 ? a + i : 2 - a - i, o *= 60) : d = u > 0 && u < 1 ? 0 : o, new xn(o, d, u, e.opacity);
}
function mR(e, t, n, r) {
  return arguments.length === 1 ? $S(e) : new xn(e, t, n, r ?? 1);
}
function xn(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Lp(xn, mR, MS(dl, {
  brighter(e) {
    return e = e == null ? xu : Math.pow(xu, e), new xn(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Us : Math.pow(Us, e), new xn(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new qt(
      Pd(e >= 240 ? e - 240 : e + 120, i, r),
      Pd(e, i, r),
      Pd(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new xn(Rv(this.h), Rl(this.s), Rl(this.l), Iu(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Iu(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Rv(this.h)}, ${Rl(this.s) * 100}%, ${Rl(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Rv(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Rl(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Pd(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const Fp = (e) => () => e;
function gR(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function yR(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function vR(e) {
  return (e = +e) == 1 ? RS : function(t, n) {
    return n - t ? yR(t, n, e) : Fp(isNaN(t) ? n : t);
  };
}
function RS(e, t) {
  var n = t - e;
  return n ? gR(e, n) : Fp(isNaN(e) ? t : e);
}
const Pu = (function e(t) {
  var n = vR(t);
  function r(i, a) {
    var o = n((i = hh(i)).r, (a = hh(a)).r), d = n(i.g, a.g), u = n(i.b, a.b), l = RS(i.opacity, a.opacity);
    return function(c) {
      return i.r = o(c), i.g = d(c), i.b = u(c), i.opacity = l(c), i + "";
    };
  }
  return r.gamma = e, r;
})(1);
function bR(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(a) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - a) + t[i] * a;
    return r;
  };
}
function _R(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function wR(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = As(e[o], t[o]);
  for (; o < n; ++o) a[o] = t[o];
  return function(d) {
    for (o = 0; o < r; ++o) a[o] = i[o](d);
    return a;
  };
}
function kR(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function Zn(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function SR(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = As(e[i], t[i]) : r[i] = t[i];
  return function(a) {
    for (i in n) r[i] = n[i](a);
    return r;
  };
}
var ph = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Od = new RegExp(ph.source, "g");
function xR(e) {
  return function() {
    return e;
  };
}
function IR(e) {
  return function(t) {
    return e(t) + "";
  };
}
function ZS(e, t) {
  var n = ph.lastIndex = Od.lastIndex = 0, r, i, a, o = -1, d = [], u = [];
  for (e = e + "", t = t + ""; (r = ph.exec(e)) && (i = Od.exec(t)); )
    (a = i.index) > n && (a = t.slice(n, a), d[o] ? d[o] += a : d[++o] = a), (r = r[0]) === (i = i[0]) ? d[o] ? d[o] += i : d[++o] = i : (d[++o] = null, u.push({ i: o, x: Zn(r, i) })), n = Od.lastIndex;
  return n < t.length && (a = t.slice(n), d[o] ? d[o] += a : d[++o] = a), d.length < 2 ? u[0] ? IR(u[0].x) : xR(t) : (t = u.length, function(l) {
    for (var c = 0, f; c < t; ++c) d[(f = u[c]).i] = f.x(l);
    return d.join("");
  });
}
function As(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? Fp(t) : (n === "number" ? Zn : n === "string" ? (r = ni(t)) ? (t = r, Pu) : ZS : t instanceof ni ? Pu : t instanceof Date ? kR : _R(t) ? bR : Array.isArray(t) ? wR : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? SR : Zn)(e, t);
}
var Zv = 180 / Math.PI, mh = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function LS(e, t, n, r, i, a) {
  var o, d, u;
  return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (u = e * n + t * r) && (n -= e * u, r -= t * u), (d = Math.sqrt(n * n + r * r)) && (n /= d, r /= d, u /= d), e * r < t * n && (e = -e, t = -t, u = -u, o = -o), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(t, e) * Zv,
    skewX: Math.atan(u) * Zv,
    scaleX: o,
    scaleY: d
  };
}
var Zl;
function PR(e) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return t.isIdentity ? mh : LS(t.a, t.b, t.c, t.d, t.e, t.f);
}
function OR(e) {
  return e == null || (Zl || (Zl = document.createElementNS("http://www.w3.org/2000/svg", "g")), Zl.setAttribute("transform", e), !(e = Zl.transform.baseVal.consolidate())) ? mh : (e = e.matrix, LS(e.a, e.b, e.c, e.d, e.e, e.f));
}
function FS(e, t, n, r) {
  function i(l) {
    return l.length ? l.pop() + " " : "";
  }
  function a(l, c, f, s, h, p) {
    if (l !== f || c !== s) {
      var m = h.push("translate(", null, t, null, n);
      p.push({ i: m - 4, x: Zn(l, f) }, { i: m - 2, x: Zn(c, s) });
    } else (f || s) && h.push("translate(" + f + t + s + n);
  }
  function o(l, c, f, s) {
    l !== c ? (l - c > 180 ? c += 360 : c - l > 180 && (l += 360), s.push({ i: f.push(i(f) + "rotate(", null, r) - 2, x: Zn(l, c) })) : c && f.push(i(f) + "rotate(" + c + r);
  }
  function d(l, c, f, s) {
    l !== c ? s.push({ i: f.push(i(f) + "skewX(", null, r) - 2, x: Zn(l, c) }) : c && f.push(i(f) + "skewX(" + c + r);
  }
  function u(l, c, f, s, h, p) {
    if (l !== f || c !== s) {
      var m = h.push(i(h) + "scale(", null, ",", null, ")");
      p.push({ i: m - 4, x: Zn(l, f) }, { i: m - 2, x: Zn(c, s) });
    } else (f !== 1 || s !== 1) && h.push(i(h) + "scale(" + f + "," + s + ")");
  }
  return function(l, c) {
    var f = [], s = [];
    return l = e(l), c = e(c), a(l.translateX, l.translateY, c.translateX, c.translateY, f, s), o(l.rotate, c.rotate, f, s), d(l.skewX, c.skewX, f, s), u(l.scaleX, l.scaleY, c.scaleX, c.scaleY, f, s), l = c = null, function(h) {
      for (var p = -1, m = s.length, y; ++p < m; ) f[(y = s[p]).i] = y.x(h);
      return f.join("");
    };
  };
}
var zR = FS(PR, "px, ", "px)", "deg)"), ER = FS(OR, ", ", ")", ")"), TR = 1e-12;
function Lv(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function NR(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function CR(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
const iu = (function e(t, n, r) {
  function i(a, o) {
    var d = a[0], u = a[1], l = a[2], c = o[0], f = o[1], s = o[2], h = c - d, p = f - u, m = h * h + p * p, y, w;
    if (m < TR)
      w = Math.log(s / l) / t, y = function(E) {
        return [
          d + E * h,
          u + E * p,
          l * Math.exp(t * E * w)
        ];
      };
    else {
      var b = Math.sqrt(m), _ = (s * s - l * l + r * m) / (2 * l * n * b), g = (s * s - l * l - r * m) / (2 * s * n * b), O = Math.log(Math.sqrt(_ * _ + 1) - _), P = Math.log(Math.sqrt(g * g + 1) - g);
      w = (P - O) / t, y = function(E) {
        var T = E * w, D = Lv(O), N = l / (n * b) * (D * CR(t * T + O) - NR(O));
        return [
          d + N * h,
          u + N * p,
          l * D / Lv(t * T + O)
        ];
      };
    }
    return y.duration = w * 1e3 * t / Math.SQRT2, y;
  }
  return i.rho = function(a) {
    var o = Math.max(1e-3, +a), d = o * o, u = d * d;
    return e(o, d, u);
  }, i;
})(Math.SQRT2, 2, 4);
var Ao = 0, Os = 0, za = 0, US = 1e3, Ou, zs, zu = 0, ri = 0, mc = 0, Vs = typeof performance == "object" && performance.now ? performance : Date, BS = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function Up() {
  return ri || (BS(DR), ri = Vs.now() + mc);
}
function DR() {
  ri = 0;
}
function Eu() {
  this._call = this._time = this._next = null;
}
Eu.prototype = VS.prototype = {
  constructor: Eu,
  restart: function(e, t, n) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    n = (n == null ? Up() : +n) + (t == null ? 0 : +t), !this._next && zs !== this && (zs ? zs._next = this : Ou = this, zs = this), this._call = e, this._time = n, gh();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, gh());
  }
};
function VS(e, t, n) {
  var r = new Eu();
  return r.restart(e, t, n), r;
}
function AR() {
  Up(), ++Ao;
  for (var e = Ou, t; e; )
    (t = ri - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --Ao;
}
function Fv() {
  ri = (zu = Vs.now()) + mc, Ao = Os = 0;
  try {
    AR();
  } finally {
    Ao = 0, MR(), ri = 0;
  }
}
function jR() {
  var e = Vs.now(), t = e - zu;
  t > US && (mc -= t, zu = e);
}
function MR() {
  for (var e, t = Ou, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : Ou = n);
  zs = e, gh(r);
}
function gh(e) {
  if (!Ao) {
    Os && (Os = clearTimeout(Os));
    var t = e - ri;
    t > 24 ? (e < 1 / 0 && (Os = setTimeout(Fv, e - Vs.now() - mc)), za && (za = clearInterval(za))) : (za || (zu = Vs.now(), za = setInterval(jR, US)), Ao = 1, BS(Fv));
  }
}
function Uv(e, t, n) {
  var r = new Eu();
  return t = t == null ? 0 : +t, r.restart((i) => {
    r.stop(), e(i + t);
  }, t, n), r;
}
var $R = hc("start", "end", "cancel", "interrupt"), RR = [], qS = 0, Bv = 1, yh = 2, ou = 3, Vv = 4, vh = 5, au = 6;
function gc(e, t, n, r, i, a) {
  var o = e.__transition;
  if (!o) e.__transition = {};
  else if (n in o) return;
  ZR(e, n, {
    name: t,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: $R,
    tween: RR,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: qS
  });
}
function Bp(e, t) {
  var n = Dn(e, t);
  if (n.state > qS) throw new Error("too late; already scheduled");
  return n;
}
function Wn(e, t) {
  var n = Dn(e, t);
  if (n.state > ou) throw new Error("too late; already running");
  return n;
}
function Dn(e, t) {
  var n = e.__transition;
  if (!n || !(n = n[t])) throw new Error("transition not found");
  return n;
}
function ZR(e, t, n) {
  var r = e.__transition, i;
  r[t] = n, n.timer = VS(a, 0, n.time);
  function a(l) {
    n.state = Bv, n.timer.restart(o, n.delay, n.time), n.delay <= l && o(l - n.delay);
  }
  function o(l) {
    var c, f, s, h;
    if (n.state !== Bv) return u();
    for (c in r)
      if (h = r[c], h.name === n.name) {
        if (h.state === ou) return Uv(o);
        h.state === Vv ? (h.state = au, h.timer.stop(), h.on.call("interrupt", e, e.__data__, h.index, h.group), delete r[c]) : +c < t && (h.state = au, h.timer.stop(), h.on.call("cancel", e, e.__data__, h.index, h.group), delete r[c]);
      }
    if (Uv(function() {
      n.state === ou && (n.state = Vv, n.timer.restart(d, n.delay, n.time), d(l));
    }), n.state = yh, n.on.call("start", e, e.__data__, n.index, n.group), n.state === yh) {
      for (n.state = ou, i = new Array(s = n.tween.length), c = 0, f = -1; c < s; ++c)
        (h = n.tween[c].value.call(e, e.__data__, n.index, n.group)) && (i[++f] = h);
      i.length = f + 1;
    }
  }
  function d(l) {
    for (var c = l < n.duration ? n.ease.call(null, l / n.duration) : (n.timer.restart(u), n.state = vh, 1), f = -1, s = i.length; ++f < s; )
      i[f].call(e, c);
    n.state === vh && (n.on.call("end", e, e.__data__, n.index, n.group), u());
  }
  function u() {
    n.state = au, n.timer.stop(), delete r[t];
    for (var l in r) return;
    delete e.__transition;
  }
}
function su(e, t) {
  var n = e.__transition, r, i, a = !0, o;
  if (n) {
    t = t == null ? null : t + "";
    for (o in n) {
      if ((r = n[o]).name !== t) {
        a = !1;
        continue;
      }
      i = r.state > yh && r.state < vh, r.state = au, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", e, e.__data__, r.index, r.group), delete n[o];
    }
    a && delete e.__transition;
  }
}
function LR(e) {
  return this.each(function() {
    su(this, e);
  });
}
function FR(e, t) {
  var n, r;
  return function() {
    var i = Wn(this, e), a = i.tween;
    if (a !== n) {
      r = n = a;
      for (var o = 0, d = r.length; o < d; ++o)
        if (r[o].name === t) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function UR(e, t, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var a = Wn(this, e), o = a.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var d = { name: t, value: n }, u = 0, l = i.length; u < l; ++u)
        if (i[u].name === t) {
          i[u] = d;
          break;
        }
      u === l && i.push(d);
    }
    a.tween = i;
  };
}
function BR(e, t) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var r = Dn(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i)
      if ((o = r[i]).name === e)
        return o.value;
    return null;
  }
  return this.each((t == null ? FR : UR)(n, e, t));
}
function Vp(e, t, n) {
  var r = e._id;
  return e.each(function() {
    var i = Wn(this, r);
    (i.value || (i.value = {}))[t] = n.apply(this, arguments);
  }), function(i) {
    return Dn(i, r).value[t];
  };
}
function HS(e, t) {
  var n;
  return (typeof t == "number" ? Zn : t instanceof ni ? Pu : (n = ni(t)) ? (t = n, Pu) : ZS)(e, t);
}
function VR(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function qR(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function HR(e, t, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttribute(e);
    return o === i ? null : o === r ? a : a = t(r = o, n);
  };
}
function WR(e, t, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttributeNS(e.space, e.local);
    return o === i ? null : o === r ? a : a = t(r = o, n);
  };
}
function GR(e, t, n) {
  var r, i, a;
  return function() {
    var o, d = n(this), u;
    return d == null ? void this.removeAttribute(e) : (o = this.getAttribute(e), u = d + "", o === u ? null : o === r && u === i ? a : (i = u, a = t(r = o, d)));
  };
}
function KR(e, t, n) {
  var r, i, a;
  return function() {
    var o, d = n(this), u;
    return d == null ? void this.removeAttributeNS(e.space, e.local) : (o = this.getAttributeNS(e.space, e.local), u = d + "", o === u ? null : o === r && u === i ? a : (i = u, a = t(r = o, d)));
  };
}
function JR(e, t) {
  var n = pc(e), r = n === "transform" ? ER : HS;
  return this.attrTween(e, typeof t == "function" ? (n.local ? KR : GR)(n, r, Vp(this, "attr." + e, t)) : t == null ? (n.local ? qR : VR)(n) : (n.local ? WR : HR)(n, r, t));
}
function XR(e, t) {
  return function(n) {
    this.setAttribute(e, t.call(this, n));
  };
}
function YR(e, t) {
  return function(n) {
    this.setAttributeNS(e.space, e.local, t.call(this, n));
  };
}
function QR(e, t) {
  var n, r;
  function i() {
    var a = t.apply(this, arguments);
    return a !== r && (n = (r = a) && YR(e, a)), n;
  }
  return i._value = t, i;
}
function eZ(e, t) {
  var n, r;
  function i() {
    var a = t.apply(this, arguments);
    return a !== r && (n = (r = a) && XR(e, a)), n;
  }
  return i._value = t, i;
}
function tZ(e, t) {
  var n = "attr." + e;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  var r = pc(e);
  return this.tween(n, (r.local ? QR : eZ)(r, t));
}
function nZ(e, t) {
  return function() {
    Bp(this, e).delay = +t.apply(this, arguments);
  };
}
function rZ(e, t) {
  return t = +t, function() {
    Bp(this, e).delay = t;
  };
}
function iZ(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? nZ : rZ)(t, e)) : Dn(this.node(), t).delay;
}
function oZ(e, t) {
  return function() {
    Wn(this, e).duration = +t.apply(this, arguments);
  };
}
function aZ(e, t) {
  return t = +t, function() {
    Wn(this, e).duration = t;
  };
}
function sZ(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? oZ : aZ)(t, e)) : Dn(this.node(), t).duration;
}
function lZ(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Wn(this, e).ease = t;
  };
}
function uZ(e) {
  var t = this._id;
  return arguments.length ? this.each(lZ(t, e)) : Dn(this.node(), t).ease;
}
function cZ(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Wn(this, e).ease = n;
  };
}
function dZ(e) {
  if (typeof e != "function") throw new Error();
  return this.each(cZ(this._id, e));
}
function fZ(e) {
  typeof e != "function" && (e = SS(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = t[i], o = a.length, d = r[i] = [], u, l = 0; l < o; ++l)
      (u = a[l]) && e.call(u, u.__data__, l, a) && d.push(u);
  return new ur(r, this._parents, this._name, this._id);
}
function hZ(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, n = e._groups, r = t.length, i = n.length, a = Math.min(r, i), o = new Array(r), d = 0; d < a; ++d)
    for (var u = t[d], l = n[d], c = u.length, f = o[d] = new Array(c), s, h = 0; h < c; ++h)
      (s = u[h] || l[h]) && (f[h] = s);
  for (; d < r; ++d)
    o[d] = t[d];
  return new ur(o, this._parents, this._name, this._id);
}
function pZ(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var n = t.indexOf(".");
    return n >= 0 && (t = t.slice(0, n)), !t || t === "start";
  });
}
function mZ(e, t, n) {
  var r, i, a = pZ(t) ? Bp : Wn;
  return function() {
    var o = a(this, e), d = o.on;
    d !== r && (i = (r = d).copy()).on(t, n), o.on = i;
  };
}
function gZ(e, t) {
  var n = this._id;
  return arguments.length < 2 ? Dn(this.node(), n).on.on(e) : this.each(mZ(n, e, t));
}
function yZ(e) {
  return function() {
    var t = this.parentNode;
    for (var n in this.__transition) if (+n !== e) return;
    t && t.removeChild(this);
  };
}
function vZ() {
  return this.on("end.remove", yZ(this._id));
}
function bZ(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Rp(e));
  for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o)
    for (var d = r[o], u = d.length, l = a[o] = new Array(u), c, f, s = 0; s < u; ++s)
      (c = d[s]) && (f = e.call(c, c.__data__, s, d)) && ("__data__" in c && (f.__data__ = c.__data__), l[s] = f, gc(l[s], t, n, s, l, Dn(c, n)));
  return new ur(a, this._parents, t, n);
}
function _Z(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = kS(e));
  for (var r = this._groups, i = r.length, a = [], o = [], d = 0; d < i; ++d)
    for (var u = r[d], l = u.length, c, f = 0; f < l; ++f)
      if (c = u[f]) {
        for (var s = e.call(c, c.__data__, f, u), h, p = Dn(c, n), m = 0, y = s.length; m < y; ++m)
          (h = s[m]) && gc(h, t, n, m, s, p);
        a.push(s), o.push(c);
      }
  return new ur(a, o, t, n);
}
var wZ = cl.prototype.constructor;
function kZ() {
  return new wZ(this._groups, this._parents);
}
function SZ(e, t) {
  var n, r, i;
  return function() {
    var a = Do(this, e), o = (this.style.removeProperty(e), Do(this, e));
    return a === o ? null : a === n && o === r ? i : i = t(n = a, r = o);
  };
}
function WS(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function xZ(e, t, n) {
  var r, i = n + "", a;
  return function() {
    var o = Do(this, e);
    return o === i ? null : o === r ? a : a = t(r = o, n);
  };
}
function IZ(e, t, n) {
  var r, i, a;
  return function() {
    var o = Do(this, e), d = n(this), u = d + "";
    return d == null && (u = d = (this.style.removeProperty(e), Do(this, e))), o === u ? null : o === r && u === i ? a : (i = u, a = t(r = o, d));
  };
}
function PZ(e, t) {
  var n, r, i, a = "style." + t, o = "end." + a, d;
  return function() {
    var u = Wn(this, e), l = u.on, c = u.value[a] == null ? d || (d = WS(t)) : void 0;
    (l !== n || i !== c) && (r = (n = l).copy()).on(o, i = c), u.on = r;
  };
}
function OZ(e, t, n) {
  var r = (e += "") == "transform" ? zR : HS;
  return t == null ? this.styleTween(e, SZ(e, r)).on("end.style." + e, WS(e)) : typeof t == "function" ? this.styleTween(e, IZ(e, r, Vp(this, "style." + e, t))).each(PZ(this._id, e)) : this.styleTween(e, xZ(e, r, t), n).on("end.style." + e, null);
}
function zZ(e, t, n) {
  return function(r) {
    this.style.setProperty(e, t.call(this, r), n);
  };
}
function EZ(e, t, n) {
  var r, i;
  function a() {
    var o = t.apply(this, arguments);
    return o !== i && (r = (i = o) && zZ(e, o, n)), r;
  }
  return a._value = t, a;
}
function TZ(e, t, n) {
  var r = "style." + (e += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (t == null) return this.tween(r, null);
  if (typeof t != "function") throw new Error();
  return this.tween(r, EZ(e, t, n ?? ""));
}
function NZ(e) {
  return function() {
    this.textContent = e;
  };
}
function CZ(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function DZ(e) {
  return this.tween("text", typeof e == "function" ? CZ(Vp(this, "text", e)) : NZ(e == null ? "" : e + ""));
}
function AZ(e) {
  return function(t) {
    this.textContent = e.call(this, t);
  };
}
function jZ(e) {
  var t, n;
  function r() {
    var i = e.apply(this, arguments);
    return i !== n && (t = (n = i) && AZ(i)), t;
  }
  return r._value = e, r;
}
function MZ(e) {
  var t = "text";
  if (arguments.length < 1) return (t = this.tween(t)) && t._value;
  if (e == null) return this.tween(t, null);
  if (typeof e != "function") throw new Error();
  return this.tween(t, jZ(e));
}
function $Z() {
  for (var e = this._name, t = this._id, n = GS(), r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], d = o.length, u, l = 0; l < d; ++l)
      if (u = o[l]) {
        var c = Dn(u, t);
        gc(u, e, n, l, o, {
          time: c.time + c.delay + c.duration,
          delay: 0,
          duration: c.duration,
          ease: c.ease
        });
      }
  return new ur(r, this._parents, e, n);
}
function RZ() {
  var e, t, n = this, r = n._id, i = n.size();
  return new Promise(function(a, o) {
    var d = { value: o }, u = { value: function() {
      --i === 0 && a();
    } };
    n.each(function() {
      var l = Wn(this, r), c = l.on;
      c !== e && (t = (e = c).copy(), t._.cancel.push(d), t._.interrupt.push(d), t._.end.push(u)), l.on = t;
    }), i === 0 && a();
  });
}
var ZZ = 0;
function ur(e, t, n, r) {
  this._groups = e, this._parents = t, this._name = n, this._id = r;
}
function GS() {
  return ++ZZ;
}
var nr = cl.prototype;
ur.prototype = {
  constructor: ur,
  select: bZ,
  selectAll: _Z,
  selectChild: nr.selectChild,
  selectChildren: nr.selectChildren,
  filter: fZ,
  merge: hZ,
  selection: kZ,
  transition: $Z,
  call: nr.call,
  nodes: nr.nodes,
  node: nr.node,
  size: nr.size,
  empty: nr.empty,
  each: nr.each,
  on: gZ,
  attr: JR,
  attrTween: tZ,
  style: OZ,
  styleTween: TZ,
  text: DZ,
  textTween: MZ,
  remove: vZ,
  tween: BR,
  delay: iZ,
  duration: sZ,
  ease: uZ,
  easeVarying: dZ,
  end: RZ,
  [Symbol.iterator]: nr[Symbol.iterator]
};
function LZ(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var FZ = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: LZ
};
function UZ(e, t) {
  for (var n; !(n = e.__transition) || !(n = n[t]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${t} not found`);
  return n;
}
function BZ(e) {
  var t, n;
  e instanceof ur ? (t = e._id, e = e._name) : (t = GS(), (n = FZ).time = Up(), e = e == null ? null : e + "");
  for (var r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], d = o.length, u, l = 0; l < d; ++l)
      (u = o[l]) && gc(u, e, t, l, o, n || UZ(u, t));
  return new ur(r, this._parents, e, t);
}
cl.prototype.interrupt = LR;
cl.prototype.transition = BZ;
const Ll = (e) => () => e;
function VZ(e, {
  sourceEvent: t,
  target: n,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: t, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function lr(e, t, n) {
  this.k = e, this.x = t, this.y = n;
}
lr.prototype = {
  constructor: lr,
  scale: function(e) {
    return e === 1 ? this : new lr(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new lr(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var yc = new lr(1, 0, 0);
KS.prototype = lr.prototype;
function KS(e) {
  for (; !e.__zoom; ) if (!(e = e.parentNode)) return yc;
  return e.__zoom;
}
function zd(e) {
  e.stopImmediatePropagation();
}
function Ea(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function qZ(e) {
  return (!e.ctrlKey || e.type === "wheel") && !e.button;
}
function HZ() {
  var e = this;
  return e instanceof SVGElement ? (e = e.ownerSVGElement || e, e.hasAttribute("viewBox") ? (e = e.viewBox.baseVal, [[e.x, e.y], [e.x + e.width, e.y + e.height]]) : [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]]) : [[0, 0], [e.clientWidth, e.clientHeight]];
}
function qv() {
  return this.__zoom || yc;
}
function WZ(e) {
  return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * (e.ctrlKey ? 10 : 1);
}
function GZ() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function KZ(e, t, n) {
  var r = e.invertX(t[0][0]) - n[0][0], i = e.invertX(t[1][0]) - n[1][0], a = e.invertY(t[0][1]) - n[0][1], o = e.invertY(t[1][1]) - n[1][1];
  return e.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o)
  );
}
function JS() {
  var e = qZ, t = HZ, n = KZ, r = WZ, i = GZ, a = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], d = 250, u = iu, l = hc("start", "zoom", "end"), c, f, s, h = 500, p = 150, m = 0, y = 10;
  function w(C) {
    C.property("__zoom", qv).on("wheel.zoom", T, { passive: !1 }).on("mousedown.zoom", D).on("dblclick.zoom", N).filter(i).on("touchstart.zoom", M).on("touchmove.zoom", R).on("touchend.zoom touchcancel.zoom", V).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  w.transform = function(C, B, G, Q) {
    var k = C.selection ? C.selection() : C;
    k.property("__zoom", qv), C !== k ? O(C, B, G, Q) : k.interrupt().each(function() {
      P(this, arguments).event(Q).start().zoom(null, typeof B == "function" ? B.apply(this, arguments) : B).end();
    });
  }, w.scaleBy = function(C, B, G, Q) {
    w.scaleTo(C, function() {
      var k = this.__zoom.k, I = typeof B == "function" ? B.apply(this, arguments) : B;
      return k * I;
    }, G, Q);
  }, w.scaleTo = function(C, B, G, Q) {
    w.transform(C, function() {
      var k = t.apply(this, arguments), I = this.__zoom, S = G == null ? g(k) : typeof G == "function" ? G.apply(this, arguments) : G, A = I.invert(S), j = typeof B == "function" ? B.apply(this, arguments) : B;
      return n(_(b(I, j), S, A), k, o);
    }, G, Q);
  }, w.translateBy = function(C, B, G, Q) {
    w.transform(C, function() {
      return n(this.__zoom.translate(
        typeof B == "function" ? B.apply(this, arguments) : B,
        typeof G == "function" ? G.apply(this, arguments) : G
      ), t.apply(this, arguments), o);
    }, null, Q);
  }, w.translateTo = function(C, B, G, Q, k) {
    w.transform(C, function() {
      var I = t.apply(this, arguments), S = this.__zoom, A = Q == null ? g(I) : typeof Q == "function" ? Q.apply(this, arguments) : Q;
      return n(yc.translate(A[0], A[1]).scale(S.k).translate(
        typeof B == "function" ? -B.apply(this, arguments) : -B,
        typeof G == "function" ? -G.apply(this, arguments) : -G
      ), I, o);
    }, Q, k);
  };
  function b(C, B) {
    return B = Math.max(a[0], Math.min(a[1], B)), B === C.k ? C : new lr(B, C.x, C.y);
  }
  function _(C, B, G) {
    var Q = B[0] - G[0] * C.k, k = B[1] - G[1] * C.k;
    return Q === C.x && k === C.y ? C : new lr(C.k, Q, k);
  }
  function g(C) {
    return [(+C[0][0] + +C[1][0]) / 2, (+C[0][1] + +C[1][1]) / 2];
  }
  function O(C, B, G, Q) {
    C.on("start.zoom", function() {
      P(this, arguments).event(Q).start();
    }).on("interrupt.zoom end.zoom", function() {
      P(this, arguments).event(Q).end();
    }).tween("zoom", function() {
      var k = this, I = arguments, S = P(k, I).event(Q), A = t.apply(k, I), j = G == null ? g(A) : typeof G == "function" ? G.apply(k, I) : G, z = Math.max(A[1][0] - A[0][0], A[1][1] - A[0][1]), L = k.__zoom, F = typeof B == "function" ? B.apply(k, I) : B, K = u(L.invert(j).concat(z / L.k), F.invert(j).concat(z / F.k));
      return function(ee) {
        if (ee === 1) ee = F;
        else {
          var U = K(ee), q = z / U[2];
          ee = new lr(q, j[0] - U[0] * q, j[1] - U[1] * q);
        }
        S.zoom(null, ee);
      };
    });
  }
  function P(C, B, G) {
    return !G && C.__zooming || new E(C, B);
  }
  function E(C, B) {
    this.that = C, this.args = B, this.active = 0, this.sourceEvent = null, this.extent = t.apply(C, B), this.taps = 0;
  }
  E.prototype = {
    event: function(C) {
      return C && (this.sourceEvent = C), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(C, B) {
      return this.mouse && C !== "mouse" && (this.mouse[1] = B.invert(this.mouse[0])), this.touch0 && C !== "touch" && (this.touch0[1] = B.invert(this.touch0[0])), this.touch1 && C !== "touch" && (this.touch1[1] = B.invert(this.touch1[0])), this.that.__zoom = B, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(C) {
      var B = en(this.that).datum();
      l.call(
        C,
        this.that,
        new VZ(C, {
          sourceEvent: this.sourceEvent,
          target: w,
          transform: this.that.__zoom,
          dispatch: l
        }),
        B
      );
    }
  };
  function T(C, ...B) {
    if (!e.apply(this, arguments)) return;
    var G = P(this, B).event(C), Q = this.__zoom, k = Math.max(a[0], Math.min(a[1], Q.k * Math.pow(2, r.apply(this, arguments)))), I = Sn(C);
    if (G.wheel)
      (G.mouse[0][0] !== I[0] || G.mouse[0][1] !== I[1]) && (G.mouse[1] = Q.invert(G.mouse[0] = I)), clearTimeout(G.wheel);
    else {
      if (Q.k === k) return;
      G.mouse = [I, Q.invert(I)], su(this), G.start();
    }
    Ea(C), G.wheel = setTimeout(S, p), G.zoom("mouse", n(_(b(Q, k), G.mouse[0], G.mouse[1]), G.extent, o));
    function S() {
      G.wheel = null, G.end();
    }
  }
  function D(C, ...B) {
    if (s || !e.apply(this, arguments)) return;
    var G = C.currentTarget, Q = P(this, B, !0).event(C), k = en(C.view).on("mousemove.zoom", j, !0).on("mouseup.zoom", z, !0), I = Sn(C, G), S = C.clientX, A = C.clientY;
    DS(C.view), zd(C), Q.mouse = [I, this.__zoom.invert(I)], su(this), Q.start();
    function j(L) {
      if (Ea(L), !Q.moved) {
        var F = L.clientX - S, K = L.clientY - A;
        Q.moved = F * F + K * K > m;
      }
      Q.event(L).zoom("mouse", n(_(Q.that.__zoom, Q.mouse[0] = Sn(L, G), Q.mouse[1]), Q.extent, o));
    }
    function z(L) {
      k.on("mousemove.zoom mouseup.zoom", null), AS(L.view, Q.moved), Ea(L), Q.event(L).end();
    }
  }
  function N(C, ...B) {
    if (e.apply(this, arguments)) {
      var G = this.__zoom, Q = Sn(C.changedTouches ? C.changedTouches[0] : C, this), k = G.invert(Q), I = G.k * (C.shiftKey ? 0.5 : 2), S = n(_(b(G, I), Q, k), t.apply(this, B), o);
      Ea(C), d > 0 ? en(this).transition().duration(d).call(O, S, Q, C) : en(this).call(w.transform, S, Q, C);
    }
  }
  function M(C, ...B) {
    if (e.apply(this, arguments)) {
      var G = C.touches, Q = G.length, k = P(this, B, C.changedTouches.length === Q).event(C), I, S, A, j;
      for (zd(C), S = 0; S < Q; ++S)
        A = G[S], j = Sn(A, this), j = [j, this.__zoom.invert(j), A.identifier], k.touch0 ? !k.touch1 && k.touch0[2] !== j[2] && (k.touch1 = j, k.taps = 0) : (k.touch0 = j, I = !0, k.taps = 1 + !!c);
      c && (c = clearTimeout(c)), I && (k.taps < 2 && (f = j[0], c = setTimeout(function() {
        c = null;
      }, h)), su(this), k.start());
    }
  }
  function R(C, ...B) {
    if (this.__zooming) {
      var G = P(this, B).event(C), Q = C.changedTouches, k = Q.length, I, S, A, j;
      for (Ea(C), I = 0; I < k; ++I)
        S = Q[I], A = Sn(S, this), G.touch0 && G.touch0[2] === S.identifier ? G.touch0[0] = A : G.touch1 && G.touch1[2] === S.identifier && (G.touch1[0] = A);
      if (S = G.that.__zoom, G.touch1) {
        var z = G.touch0[0], L = G.touch0[1], F = G.touch1[0], K = G.touch1[1], ee = (ee = F[0] - z[0]) * ee + (ee = F[1] - z[1]) * ee, U = (U = K[0] - L[0]) * U + (U = K[1] - L[1]) * U;
        S = b(S, Math.sqrt(ee / U)), A = [(z[0] + F[0]) / 2, (z[1] + F[1]) / 2], j = [(L[0] + K[0]) / 2, (L[1] + K[1]) / 2];
      } else if (G.touch0) A = G.touch0[0], j = G.touch0[1];
      else return;
      G.zoom("touch", n(_(S, A, j), G.extent, o));
    }
  }
  function V(C, ...B) {
    if (this.__zooming) {
      var G = P(this, B).event(C), Q = C.changedTouches, k = Q.length, I, S;
      for (zd(C), s && clearTimeout(s), s = setTimeout(function() {
        s = null;
      }, h), I = 0; I < k; ++I)
        S = Q[I], G.touch0 && G.touch0[2] === S.identifier ? delete G.touch0 : G.touch1 && G.touch1[2] === S.identifier && delete G.touch1;
      if (G.touch1 && !G.touch0 && (G.touch0 = G.touch1, delete G.touch1), G.touch0) G.touch0[1] = this.__zoom.invert(G.touch0[0]);
      else if (G.end(), G.taps === 2 && (S = Sn(S, this), Math.hypot(f[0] - S[0], f[1] - S[1]) < y)) {
        var A = en(this).on("dblclick.zoom");
        A && A.apply(this, arguments);
      }
    }
  }
  return w.wheelDelta = function(C) {
    return arguments.length ? (r = typeof C == "function" ? C : Ll(+C), w) : r;
  }, w.filter = function(C) {
    return arguments.length ? (e = typeof C == "function" ? C : Ll(!!C), w) : e;
  }, w.touchable = function(C) {
    return arguments.length ? (i = typeof C == "function" ? C : Ll(!!C), w) : i;
  }, w.extent = function(C) {
    return arguments.length ? (t = typeof C == "function" ? C : Ll([[+C[0][0], +C[0][1]], [+C[1][0], +C[1][1]]]), w) : t;
  }, w.scaleExtent = function(C) {
    return arguments.length ? (a[0] = +C[0], a[1] = +C[1], w) : [a[0], a[1]];
  }, w.translateExtent = function(C) {
    return arguments.length ? (o[0][0] = +C[0][0], o[1][0] = +C[1][0], o[0][1] = +C[0][1], o[1][1] = +C[1][1], w) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, w.constrain = function(C) {
    return arguments.length ? (n = C, w) : n;
  }, w.duration = function(C) {
    return arguments.length ? (d = +C, w) : d;
  }, w.interpolate = function(C) {
    return arguments.length ? (u = C, w) : u;
  }, w.on = function() {
    var C = l.on.apply(l, arguments);
    return C === l ? w : C;
  }, w.clickDistance = function(C) {
    return arguments.length ? (m = (C = +C) * C, w) : Math.sqrt(m);
  }, w.tapDistance = function(C) {
    return arguments.length ? (y = +C, w) : y;
  }, w;
}
const an = {
  error001: (e = "react") => `Seems like you have not used ${e === "svelte" ? "SvelteFlowProvider" : "ReactFlowProvider"} as an ancestor. Help: https://${e}flow.dev/error#001`,
  error002: () => "It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
  error003: (e) => `Node type "${e}" not found. Using fallback type "default".`,
  error004: () => "The parent container needs a width and a height to render the graph.",
  error005: () => "Only child nodes can use a parent extent.",
  error006: () => "Can't create edge. An edge needs a source and a target.",
  error007: (e) => `The old edge with id=${e} does not exist.`,
  error009: (e) => `Marker type "${e}" doesn't exist.`,
  error008: (e, { id: t, sourceHandle: n, targetHandle: r }) => `Couldn't create edge for ${e} handle id: "${e === "source" ? n : r}", edge id: ${t}.`,
  error010: () => "Handle: No node id found. Make sure to only use a Handle inside a custom Node.",
  error011: (e) => `Edge type "${e}" not found. Using fallback type "default".`,
  error012: (e) => `Node with id "${e}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`,
  error013: (e = "react") => `It seems that you haven't loaded the styles. Please import '@xyflow/${e}/dist/style.css' or base.css to make sure everything is working properly.`,
  error014: () => "useNodeConnections: No node ID found. Call useNodeConnections inside a custom Node or provide a node ID.",
  error015: () => "It seems that you are trying to drag a node that is not initialized. Please use onNodesChange as explained in the docs.",
  error016: (e) => `Edge with id "${e}" does not exist, it may have been removed. This can happen when an edge is deleted before the "onEdgeClick" handler is called.`
}, qs = [
  [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
  [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
], XS = ["Enter", " ", "Escape"], YS = {
  "node.a11yDescription.default": "Press enter or space to select a node. Press delete to remove it and escape to cancel.",
  "node.a11yDescription.keyboardDisabled": "Press enter or space to select a node. You can then use the arrow keys to move the node around. Press delete to remove it and escape to cancel.",
  "node.a11yDescription.ariaLiveMessage": ({ direction: e, x: t, y: n }) => `Moved selected node ${e}. New position, x: ${t}, y: ${n}`,
  "edge.a11yDescription.default": "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel.",
  // Control elements
  "controls.ariaLabel": "Control Panel",
  "controls.zoomIn.ariaLabel": "Zoom In",
  "controls.zoomOut.ariaLabel": "Zoom Out",
  "controls.fitView.ariaLabel": "Fit View",
  "controls.interactive.ariaLabel": "Toggle Interactivity",
  // Mini map
  "minimap.ariaLabel": "Mini Map",
  // Handle
  "handle.ariaLabel": "Handle"
};
var jo;
(function(e) {
  e.Strict = "strict", e.Loose = "loose";
})(jo || (jo = {}));
var Yr;
(function(e) {
  e.Free = "free", e.Vertical = "vertical", e.Horizontal = "horizontal";
})(Yr || (Yr = {}));
var Hs;
(function(e) {
  e.Partial = "partial", e.Full = "full";
})(Hs || (Hs = {}));
const QS = {
  inProgress: !1,
  isValid: null,
  from: null,
  fromHandle: null,
  fromPosition: null,
  fromNode: null,
  to: null,
  toHandle: null,
  toPosition: null,
  toNode: null,
  pointer: null
};
var wr;
(function(e) {
  e.Bezier = "default", e.Straight = "straight", e.Step = "step", e.SmoothStep = "smoothstep", e.SimpleBezier = "simplebezier";
})(wr || (wr = {}));
var Ws;
(function(e) {
  e.Arrow = "arrow", e.ArrowClosed = "arrowclosed";
})(Ws || (Ws = {}));
var Ie;
(function(e) {
  e.Left = "left", e.Top = "top", e.Right = "right", e.Bottom = "bottom";
})(Ie || (Ie = {}));
const Hv = {
  [Ie.Left]: Ie.Right,
  [Ie.Right]: Ie.Left,
  [Ie.Top]: Ie.Bottom,
  [Ie.Bottom]: Ie.Top
};
function ex(e) {
  return e === null ? null : e ? "valid" : "invalid";
}
const tx = (e) => !!e && typeof e == "object" && "id" in e && "source" in e && "target" in e, JZ = (e) => !!e && typeof e == "object" && "id" in e && "position" in e && !("source" in e) && !("target" in e), qp = (e) => !!e && typeof e == "object" && "id" in e && "internals" in e && !("source" in e) && !("target" in e), fl = (e, t = [0, 0]) => {
  const { width: n, height: r } = Gn(e), i = e.origin ?? t, a = n * i[0], o = r * i[1];
  return {
    x: e.position.x - a,
    y: e.position.y - o
  };
}, XZ = (e, t = { nodeOrigin: [0, 0] }) => {
  if (process.env.NODE_ENV === "development" && !t.nodeLookup && console.warn("Please use `getNodesBounds` from `useReactFlow`/`useSvelteFlow` hook to ensure correct values for sub flows. If not possible, you have to provide a nodeLookup to support sub flows."), e.length === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  const n = e.reduce((r, i) => {
    const a = typeof i == "string";
    let o = !t.nodeLookup && !a ? i : void 0;
    t.nodeLookup && (o = a ? t.nodeLookup.get(i) : qp(i) ? i : t.nodeLookup.get(i.id));
    const d = o ? Tu(o, t.nodeOrigin) : { x: 0, y: 0, x2: 0, y2: 0 };
    return vc(r, d);
  }, { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 });
  return bc(n);
}, hl = (e, t = {}) => {
  let n = { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 }, r = !1;
  return e.forEach((i) => {
    (t.filter === void 0 || t.filter(i)) && (n = vc(n, Tu(i)), r = !0);
  }), r ? bc(n) : { x: 0, y: 0, width: 0, height: 0 };
}, Hp = (e, t, [n, r, i] = [0, 0, 1], a = !1, o = !1) => {
  const d = (t.x - n) / i, u = (t.y - r) / i, l = t.width / i, c = t.height / i, f = [];
  for (const s of e.values()) {
    const { measured: h, selectable: p = !0, hidden: m = !1 } = s;
    if (o && !p || m)
      continue;
    const y = h.width ?? s.width ?? s.initialWidth ?? 0, w = h.height ?? s.height ?? s.initialHeight ?? 0, { x: b, y: _ } = s.internals.positionAbsolute, g = ox(d, u, l, c, b, _, y, w), O = y * w, P = a && g > 0;
    (!s.internals.handleBounds || P || g >= O || s.dragging) && f.push(s);
  }
  return f;
}, YZ = (e, t) => {
  const n = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    n.add(r.id);
  }), t.filter((r) => n.has(r.source) || n.has(r.target));
};
function QZ(e, t) {
  const n = /* @__PURE__ */ new Map(), r = t?.nodes ? new Set(t.nodes.map((i) => i.id)) : null;
  return e.forEach((i) => {
    let a;
    if (t?.includeHiddenNodes) {
      const { width: o, height: d } = Gn(i);
      a = o > 0 && d > 0;
    } else
      a = !!(i.measured.width && i.measured.height && !i.hidden);
    a && (!r || r.has(i.id)) && n.set(i.id, i);
  }), n;
}
async function e2({ nodes: e, width: t, height: n, panZoom: r, minZoom: i, maxZoom: a }, o) {
  if (e.size === 0)
    return !0;
  const d = QZ(e, o), u = hl(d), l = Gp(u, t, n, o?.minZoom ?? i, o?.maxZoom ?? a, o?.padding ?? 0.1);
  return await r.setViewport(l, {
    duration: o?.duration,
    ease: o?.ease,
    interpolate: o?.interpolate
  }), !0;
}
function nx({ nodeId: e, nextPosition: t, nodeLookup: n, nodeOrigin: r = [0, 0], nodeExtent: i, onError: a }) {
  const o = n.get(e), d = o.parentId ? n.get(o.parentId) : void 0, { x: u, y: l } = d ? d.internals.positionAbsolute : { x: 0, y: 0 }, c = o.origin ?? r;
  let f = o.extent || i;
  if (o.extent === "parent" && !o.expandParent)
    if (!d)
      a?.("005", an.error005());
    else {
      const h = d.measured.width, p = d.measured.height;
      h && p && (f = [
        [u, l],
        [u + h, l + p]
      ]);
    }
  else d && oi(o.extent) && (f = [
    [o.extent[0][0] + u, o.extent[0][1] + l],
    [o.extent[1][0] + u, o.extent[1][1] + l]
  ]);
  const s = oi(f) ? ii(t, f, o.measured) : t;
  return (o.measured.width === void 0 || o.measured.height === void 0) && a?.("015", an.error015()), {
    position: {
      x: s.x - u + (o.measured.width ?? 0) * c[0],
      y: s.y - l + (o.measured.height ?? 0) * c[1]
    },
    positionAbsolute: s
  };
}
async function t2({ nodesToRemove: e = [], edgesToRemove: t = [], nodes: n, edges: r, onBeforeDelete: i }) {
  const a = new Set(e.map((s) => s.id)), o = [];
  for (const s of n) {
    if (s.deletable === !1)
      continue;
    const h = a.has(s.id), p = !h && s.parentId && o.find((m) => m.id === s.parentId);
    (h || p) && o.push(s);
  }
  const d = new Set(t.map((s) => s.id)), u = r.filter((s) => s.deletable !== !1), c = YZ(o, u);
  for (const s of u)
    d.has(s.id) && !c.find((p) => p.id === s.id) && c.push(s);
  if (!i)
    return {
      edges: c,
      nodes: o
    };
  const f = await i({
    nodes: o,
    edges: c
  });
  return typeof f == "boolean" ? f ? { edges: c, nodes: o } : { edges: [], nodes: [] } : f;
}
const Mo = (e, t = 0, n = 1) => Math.min(Math.max(e, t), n), ii = (e = { x: 0, y: 0 }, t, n) => ({
  x: Mo(e.x, t[0][0], t[1][0] - (n?.width ?? 0)),
  y: Mo(e.y, t[0][1], t[1][1] - (n?.height ?? 0))
});
function rx(e, t, n) {
  const { width: r, height: i } = Gn(n), { x: a, y: o } = n.internals.positionAbsolute;
  return ii(e, [
    [a, o],
    [a + r, o + i]
  ], t);
}
const Wv = (e, t, n) => e < t ? Mo(Math.abs(e - t), 1, t) / t : e > n ? -Mo(Math.abs(e - n), 1, t) / t : 0, Wp = (e, t, n = 15, r = 40) => {
  const i = Wv(e.x, r, t.width - r) * n, a = Wv(e.y, r, t.height - r) * n;
  return [i, a];
}, vc = (e, t) => ({
  x: Math.min(e.x, t.x),
  y: Math.min(e.y, t.y),
  x2: Math.max(e.x2, t.x2),
  y2: Math.max(e.y2, t.y2)
}), bh = ({ x: e, y: t, width: n, height: r }) => ({
  x: e,
  y: t,
  x2: e + n,
  y2: t + r
}), bc = ({ x: e, y: t, x2: n, y2: r }) => ({
  x: e,
  y: t,
  width: n - e,
  height: r - t
}), Gs = (e, t = [0, 0]) => {
  const { x: n, y: r } = qp(e) ? e.internals.positionAbsolute : fl(e, t);
  return {
    x: n,
    y: r,
    width: e.measured?.width ?? e.width ?? e.initialWidth ?? 0,
    height: e.measured?.height ?? e.height ?? e.initialHeight ?? 0
  };
}, Tu = (e, t = [0, 0]) => {
  const { x: n, y: r } = qp(e) ? e.internals.positionAbsolute : fl(e, t);
  return {
    x: n,
    y: r,
    x2: n + (e.measured?.width ?? e.width ?? e.initialWidth ?? 0),
    y2: r + (e.measured?.height ?? e.height ?? e.initialHeight ?? 0)
  };
}, ix = (e, t) => bc(vc(bh(e), bh(t))), ox = (e, t, n, r, i, a, o, d) => {
  const u = Math.max(0, Math.min(e + n, i + o) - Math.max(e, i)), l = Math.max(0, Math.min(t + r, a + d) - Math.max(t, a));
  return Math.ceil(u * l);
}, Nu = (e, t) => ox(e.x, e.y, e.width, e.height, t.x, t.y, t.width, t.height), Gv = (e) => In(e.width) && In(e.height) && In(e.x) && In(e.y), In = (e) => !isNaN(e) && isFinite(e), ax = (e, t) => (n, r) => {
  process.env.NODE_ENV === "development" && console.warn(`[${e}]: ${r} Help: ${t}error#${n}`);
}, pl = (e, t = [1, 1]) => ({
  x: t[0] * Math.round(e.x / t[0]),
  y: t[1] * Math.round(e.y / t[1])
}), ml = ({ x: e, y: t }, [n, r, i], a = !1, o = [1, 1]) => {
  const d = {
    x: (e - n) / i,
    y: (t - r) / i
  };
  return a ? pl(d, o) : d;
}, $o = ({ x: e, y: t }, [n, r, i]) => ({
  x: e * i + n,
  y: t * i + r
});
function po(e, t) {
  if (typeof e == "number")
    return Math.floor((t - t / (1 + e)) * 0.5);
  if (typeof e == "string" && e.endsWith("px")) {
    const n = parseFloat(e);
    if (!Number.isNaN(n))
      return Math.floor(n);
  }
  if (typeof e == "string" && e.endsWith("%")) {
    const n = parseFloat(e);
    if (!Number.isNaN(n))
      return Math.floor(t * n * 0.01);
  }
  return console.error(`The padding value "${e}" is invalid. Please provide a number or a string with a valid unit (px or %).`), 0;
}
function n2(e, t, n) {
  if (typeof e == "string" || typeof e == "number") {
    const r = po(e, n), i = po(e, t);
    return {
      top: r,
      right: i,
      bottom: r,
      left: i,
      x: i * 2,
      y: r * 2
    };
  }
  if (typeof e == "object") {
    const r = po(e.top ?? e.y ?? 0, n), i = po(e.bottom ?? e.y ?? 0, n), a = po(e.left ?? e.x ?? 0, t), o = po(e.right ?? e.x ?? 0, t);
    return { top: r, right: o, bottom: i, left: a, x: a + o, y: r + i };
  }
  return { top: 0, right: 0, bottom: 0, left: 0, x: 0, y: 0 };
}
function r2(e, t, n, r, i, a) {
  const { x: o, y: d } = $o(e, [t, n, r]), { x: u, y: l } = $o({ x: e.x + e.width, y: e.y + e.height }, [t, n, r]), c = i - u, f = a - l;
  return {
    left: Math.floor(o),
    top: Math.floor(d),
    right: Math.floor(c),
    bottom: Math.floor(f)
  };
}
const Gp = (e, t, n, r, i, a) => {
  const o = n2(a, t, n), d = (t - o.x) / e.width, u = (n - o.y) / e.height, l = Math.min(d, u), c = Mo(l, r, i), f = e.x + e.width / 2, s = e.y + e.height / 2, h = t / 2 - f * c, p = n / 2 - s * c, m = r2(e, h, p, c, t, n), y = {
    left: Math.min(m.left - o.left, 0),
    top: Math.min(m.top - o.top, 0),
    right: Math.min(m.right - o.right, 0),
    bottom: Math.min(m.bottom - o.bottom, 0)
  };
  return {
    x: h - y.left + y.right,
    y: p - y.top + y.bottom,
    zoom: c
  };
}, Ks = () => typeof navigator < "u" && navigator?.userAgent?.indexOf("Mac") >= 0;
function oi(e) {
  return e != null && e !== "parent";
}
function Gn(e) {
  return {
    width: e.measured?.width ?? e.width ?? e.initialWidth ?? 0,
    height: e.measured?.height ?? e.height ?? e.initialHeight ?? 0
  };
}
function Kp(e) {
  return (e.measured?.width ?? e.width ?? e.initialWidth) !== void 0 && (e.measured?.height ?? e.height ?? e.initialHeight) !== void 0;
}
function sx(e, t = { width: 0, height: 0 }, n, r, i) {
  const a = { ...e }, o = r.get(n);
  if (o) {
    const d = o.origin || i;
    a.x += o.internals.positionAbsolute.x - (t.width ?? 0) * d[0], a.y += o.internals.positionAbsolute.y - (t.height ?? 0) * d[1];
  }
  return a;
}
function Kv(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
}
function i2() {
  let e, t;
  return { promise: new Promise((r, i) => {
    e = r, t = i;
  }), resolve: e, reject: t };
}
function o2(e) {
  return { ...YS, ...e || {} };
}
function js(e, { snapGrid: t = [0, 0], snapToGrid: n = !1, transform: r, containerBounds: i }) {
  const { x: a, y: o } = Pn(e), d = ml({ x: a - (i?.left ?? 0), y: o - (i?.top ?? 0) }, r), { x: u, y: l } = n ? pl(d, t) : d;
  return {
    xSnapped: u,
    ySnapped: l,
    ...d
  };
}
const Jp = (e) => ({
  width: e.offsetWidth,
  height: e.offsetHeight
}), lx = (e) => e?.getRootNode?.() || window?.document, a2 = ["INPUT", "SELECT", "TEXTAREA"];
function ux(e) {
  const t = e.composedPath?.()?.[0] || e.target;
  return t?.nodeType !== 1 ? !1 : a2.includes(t.nodeName) || t.hasAttribute("contenteditable") || !!t.closest(".nokey");
}
const cx = (e) => "clientX" in e, Pn = (e, t) => {
  const n = cx(e), r = n ? e.clientX : e.touches?.[0].clientX, i = n ? e.clientY : e.touches?.[0].clientY;
  return {
    x: r - (t?.left ?? 0),
    y: i - (t?.top ?? 0)
  };
}, Jv = (e, t, n, r, i) => {
  const a = t.querySelectorAll(`.${e}`);
  return !a || !a.length ? null : Array.from(a).map((o) => {
    const d = o.getBoundingClientRect();
    return {
      id: o.getAttribute("data-handleid"),
      type: e,
      nodeId: i,
      position: o.getAttribute("data-handlepos"),
      x: (d.left - n.left) / r,
      y: (d.top - n.top) / r,
      ...Jp(o)
    };
  });
};
function dx({ sourceX: e, sourceY: t, targetX: n, targetY: r, sourceControlX: i, sourceControlY: a, targetControlX: o, targetControlY: d }) {
  const u = e * 0.125 + i * 0.375 + o * 0.375 + n * 0.125, l = t * 0.125 + a * 0.375 + d * 0.375 + r * 0.125, c = Math.abs(u - e), f = Math.abs(l - t);
  return [u, l, c, f];
}
function Fl(e, t) {
  return e >= 0 ? 0.5 * e : t * 25 * Math.sqrt(-e);
}
function Xv({ pos: e, x1: t, y1: n, x2: r, y2: i, c: a }) {
  switch (e) {
    case Ie.Left:
      return [t - Fl(t - r, a), n];
    case Ie.Right:
      return [t + Fl(r - t, a), n];
    case Ie.Top:
      return [t, n - Fl(n - i, a)];
    case Ie.Bottom:
      return [t, n + Fl(i - n, a)];
  }
}
function _c({ sourceX: e, sourceY: t, sourcePosition: n = Ie.Bottom, targetX: r, targetY: i, targetPosition: a = Ie.Top, curvature: o = 0.25 }) {
  const [d, u] = Xv({
    pos: n,
    x1: e,
    y1: t,
    x2: r,
    y2: i,
    c: o
  }), [l, c] = Xv({
    pos: a,
    x1: r,
    y1: i,
    x2: e,
    y2: t,
    c: o
  }), [f, s, h, p] = dx({
    sourceX: e,
    sourceY: t,
    targetX: r,
    targetY: i,
    sourceControlX: d,
    sourceControlY: u,
    targetControlX: l,
    targetControlY: c
  });
  return [
    `M${e},${t} C${d},${u} ${l},${c} ${r},${i}`,
    f,
    s,
    h,
    p
  ];
}
function fx({ sourceX: e, sourceY: t, targetX: n, targetY: r }) {
  const i = Math.abs(n - e) / 2, a = n < e ? n + i : n - i, o = Math.abs(r - t) / 2, d = r < t ? r + o : r - o;
  return [a, d, i, o];
}
function s2({ sourceNode: e, targetNode: t, selected: n = !1, zIndex: r = 0, elevateOnSelect: i = !1, zIndexMode: a = "basic" }) {
  if (a === "manual")
    return r;
  const o = i && n ? r + 1e3 : r, d = Math.max(e.parentId || i && e.selected ? e.internals.z : 0, t.parentId || i && t.selected ? t.internals.z : 0);
  return o + d;
}
function l2({ sourceNode: e, targetNode: t, width: n, height: r, transform: i }) {
  const a = vc(Tu(e), Tu(t));
  a.x === a.x2 && (a.x2 += 1), a.y === a.y2 && (a.y2 += 1);
  const o = {
    x: -i[0] / i[2],
    y: -i[1] / i[2],
    width: n / i[2],
    height: r / i[2]
  };
  return Nu(o, bc(a)) > 0;
}
const u2 = ({ source: e, sourceHandle: t, target: n, targetHandle: r }) => `xy-edge__${e}${t || ""}-${n}${r || ""}`, c2 = (e, t) => t.some((n) => n.source === e.source && n.target === e.target && (n.sourceHandle === e.sourceHandle || !n.sourceHandle && !e.sourceHandle) && (n.targetHandle === e.targetHandle || !n.targetHandle && !e.targetHandle)), d2 = (e, t, n = {}) => {
  if (!e.source || !e.target)
    return n.onError?.("006", an.error006()), t;
  const r = n.getEdgeId || u2;
  let i;
  return tx(e) ? i = { ...e } : i = {
    ...e,
    id: r(e)
  }, c2(i, t) ? t : (i.sourceHandle === null && delete i.sourceHandle, i.targetHandle === null && delete i.targetHandle, t.concat(i));
};
function hx({ sourceX: e, sourceY: t, targetX: n, targetY: r }) {
  const [i, a, o, d] = fx({
    sourceX: e,
    sourceY: t,
    targetX: n,
    targetY: r
  });
  return [`M ${e},${t}L ${n},${r}`, i, a, o, d];
}
const Yv = {
  [Ie.Left]: { x: -1, y: 0 },
  [Ie.Right]: { x: 1, y: 0 },
  [Ie.Top]: { x: 0, y: -1 },
  [Ie.Bottom]: { x: 0, y: 1 }
}, f2 = ({ source: e, sourcePosition: t = Ie.Bottom, target: n }) => t === Ie.Left || t === Ie.Right ? e.x < n.x ? { x: 1, y: 0 } : { x: -1, y: 0 } : e.y < n.y ? { x: 0, y: 1 } : { x: 0, y: -1 }, Qv = (e, t) => Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
function h2({ source: e, sourcePosition: t = Ie.Bottom, target: n, targetPosition: r = Ie.Top, center: i, offset: a, stepPosition: o }) {
  const d = Yv[t], u = Yv[r], l = { x: e.x + d.x * a, y: e.y + d.y * a }, c = { x: n.x + u.x * a, y: n.y + u.y * a }, f = f2({
    source: l,
    sourcePosition: t,
    target: c
  }), s = f.x !== 0 ? "x" : "y", h = f[s];
  let p = [], m, y;
  const w = { x: 0, y: 0 }, b = { x: 0, y: 0 }, [, , _, g] = fx({
    sourceX: e.x,
    sourceY: e.y,
    targetX: n.x,
    targetY: n.y
  });
  if (d[s] * u[s] === -1) {
    s === "x" ? (m = i.x ?? l.x + (c.x - l.x) * o, y = i.y ?? (l.y + c.y) / 2) : (m = i.x ?? (l.x + c.x) / 2, y = i.y ?? l.y + (c.y - l.y) * o);
    const T = [
      { x: m, y: l.y },
      { x: m, y: c.y }
    ], D = [
      { x: l.x, y },
      { x: c.x, y }
    ];
    d[s] === h ? p = s === "x" ? T : D : p = s === "x" ? D : T;
  } else {
    const T = [{ x: l.x, y: c.y }], D = [{ x: c.x, y: l.y }];
    if (s === "x" ? p = d.x === h ? D : T : p = d.y === h ? T : D, t === r) {
      const C = Math.abs(e[s] - n[s]);
      if (C <= a) {
        const B = Math.min(a - 1, a - C);
        d[s] === h ? w[s] = (l[s] > e[s] ? -1 : 1) * B : b[s] = (c[s] > n[s] ? -1 : 1) * B;
      }
    }
    if (t !== r) {
      const C = s === "x" ? "y" : "x", B = d[s] === u[C], G = l[C] > c[C], Q = l[C] < c[C];
      (d[s] === 1 && (!B && G || B && Q) || d[s] !== 1 && (!B && Q || B && G)) && (p = s === "x" ? T : D);
    }
    const N = { x: l.x + w.x, y: l.y + w.y }, M = { x: c.x + b.x, y: c.y + b.y }, R = Math.max(Math.abs(N.x - p[0].x), Math.abs(M.x - p[0].x)), V = Math.max(Math.abs(N.y - p[0].y), Math.abs(M.y - p[0].y));
    R >= V ? (m = (N.x + M.x) / 2, y = p[0].y) : (m = p[0].x, y = (N.y + M.y) / 2);
  }
  const O = { x: l.x + w.x, y: l.y + w.y }, P = { x: c.x + b.x, y: c.y + b.y };
  return [[
    e,
    // we only want to add the gapped source/target if they are different from the first/last point to avoid duplicates which can cause issues with the bends
    ...O.x !== p[0].x || O.y !== p[0].y ? [O] : [],
    ...p,
    ...P.x !== p[p.length - 1].x || P.y !== p[p.length - 1].y ? [P] : [],
    n
  ], m, y, _, g];
}
function p2(e, t, n, r) {
  const i = Math.min(Qv(e, t) / 2, Qv(t, n) / 2, r), { x: a, y: o } = t;
  if (e.x === a && a === n.x || e.y === o && o === n.y)
    return `L${a} ${o}`;
  if (e.y === o) {
    const l = e.x < n.x ? -1 : 1, c = e.y < n.y ? 1 : -1;
    return `L ${a + i * l},${o}Q ${a},${o} ${a},${o + i * c}`;
  }
  const d = e.x < n.x ? 1 : -1, u = e.y < n.y ? -1 : 1;
  return `L ${a},${o + i * u}Q ${a},${o} ${a + i * d},${o}`;
}
function _h({ sourceX: e, sourceY: t, sourcePosition: n = Ie.Bottom, targetX: r, targetY: i, targetPosition: a = Ie.Top, borderRadius: o = 5, centerX: d, centerY: u, offset: l = 20, stepPosition: c = 0.5 }) {
  const [f, s, h, p, m] = h2({
    source: { x: e, y: t },
    sourcePosition: n,
    target: { x: r, y: i },
    targetPosition: a,
    center: { x: d, y: u },
    offset: l,
    stepPosition: c
  });
  let y = `M${f[0].x} ${f[0].y}`;
  for (let w = 1; w < f.length - 1; w++)
    y += p2(f[w - 1], f[w], f[w + 1], o);
  return y += `L${f[f.length - 1].x} ${f[f.length - 1].y}`, [y, s, h, p, m];
}
function eb(e) {
  return e && !!(e.internals.handleBounds || e.handles?.length) && !!(e.measured.width || e.width || e.initialWidth);
}
function m2(e) {
  const { sourceNode: t, targetNode: n } = e;
  if (!eb(t) || !eb(n))
    return null;
  const r = t.internals.handleBounds || tb(t.handles), i = n.internals.handleBounds || tb(n.handles), a = nb(r?.source ?? [], e.sourceHandle), o = nb(
    // when connection type is loose we can define all handles as sources and connect source -> source
    e.connectionMode === jo.Strict ? i?.target ?? [] : (i?.target ?? []).concat(i?.source ?? []),
    e.targetHandle
  );
  if (!a || !o)
    return e.onError?.("008", an.error008(a ? "target" : "source", {
      id: e.id,
      sourceHandle: e.sourceHandle,
      targetHandle: e.targetHandle
    })), null;
  const d = a?.position || Ie.Bottom, u = o?.position || Ie.Top, l = ai(t, a, d), c = ai(n, o, u);
  return {
    sourceX: l.x,
    sourceY: l.y,
    targetX: c.x,
    targetY: c.y,
    sourcePosition: d,
    targetPosition: u
  };
}
function tb(e) {
  if (!e)
    return null;
  const t = [], n = [];
  for (const r of e)
    r.width = r.width ?? 1, r.height = r.height ?? 1, r.type === "source" ? t.push(r) : r.type === "target" && n.push(r);
  return {
    source: t,
    target: n
  };
}
function ai(e, t, n = Ie.Left, r = !1) {
  const i = (t?.x ?? 0) + e.internals.positionAbsolute.x, a = (t?.y ?? 0) + e.internals.positionAbsolute.y, { width: o, height: d } = t ?? Gn(e);
  if (r)
    return { x: i + o / 2, y: a + d / 2 };
  switch (t?.position ?? n) {
    case Ie.Top:
      return { x: i + o / 2, y: a };
    case Ie.Right:
      return { x: i + o, y: a + d / 2 };
    case Ie.Bottom:
      return { x: i + o / 2, y: a + d };
    case Ie.Left:
      return { x: i, y: a + d / 2 };
  }
}
function nb(e, t) {
  return e && (t ? e.find((n) => n.id === t) : e[0]) || null;
}
function wh(e, t) {
  return e ? typeof e == "string" ? e : `${t ? `${t}__` : ""}${Object.keys(e).sort().map((r) => `${r}=${e[r]}`).join("&")}` : "";
}
function g2(e, { id: t, defaultColor: n, defaultMarkerStart: r, defaultMarkerEnd: i }) {
  const a = /* @__PURE__ */ new Set();
  return e.reduce((o, d) => ([d.markerStart || r, d.markerEnd || i].forEach((u) => {
    if (u && typeof u == "object") {
      const l = wh(u, t);
      a.has(l) || (o.push({ id: l, color: u.color || n, ...u }), a.add(l));
    }
  }), o), []).sort((o, d) => o.id.localeCompare(d.id));
}
const px = 1e3, y2 = 10, Xp = {
  nodeOrigin: [0, 0],
  nodeExtent: qs,
  elevateNodesOnSelect: !0,
  zIndexMode: "basic",
  defaults: {}
}, v2 = {
  ...Xp,
  checkEquality: !0
};
function Yp(e, t) {
  const n = { ...e };
  for (const r in t)
    t[r] !== void 0 && (n[r] = t[r]);
  return n;
}
function b2(e, t, n) {
  const r = Yp(Xp, n);
  for (const i of e.values())
    if (i.parentId)
      em(i, e, t, r);
    else {
      const a = fl(i, r.nodeOrigin), o = oi(i.extent) ? i.extent : r.nodeExtent, d = ii(a, o, Gn(i));
      i.internals.positionAbsolute = d;
    }
}
function _2(e, t) {
  if (!e.handles)
    return e.measured ? t?.internals.handleBounds : void 0;
  const n = [], r = [];
  for (const i of e.handles) {
    const a = {
      id: i.id,
      width: i.width ?? 1,
      height: i.height ?? 1,
      nodeId: e.id,
      x: i.x,
      y: i.y,
      position: i.position,
      type: i.type
    };
    i.type === "source" ? n.push(a) : i.type === "target" && r.push(a);
  }
  return {
    source: n,
    target: r
  };
}
function Qp(e) {
  return e === "manual";
}
function kh(e, t, n, r = {}) {
  const i = Yp(v2, r), a = { i: 0 }, o = new Map(t), d = i?.elevateNodesOnSelect && !Qp(i.zIndexMode) ? px : 0;
  let u = e.length > 0, l = !1;
  t.clear(), n.clear();
  for (const c of e) {
    let f = o.get(c.id);
    if (i.checkEquality && c === f?.internals.userNode)
      t.set(c.id, f);
    else {
      const s = fl(c, i.nodeOrigin), h = oi(c.extent) ? c.extent : i.nodeExtent, p = ii(s, h, Gn(c));
      f = {
        ...i.defaults,
        ...c,
        measured: {
          width: c.measured?.width,
          height: c.measured?.height
        },
        internals: {
          positionAbsolute: p,
          // if user re-initializes the node or removes `measured` for whatever reason, we reset the handleBounds so that the node gets re-measured
          handleBounds: _2(c, f),
          z: mx(c, d, i.zIndexMode),
          userNode: c
        }
      }, t.set(c.id, f);
    }
    (f.measured === void 0 || f.measured.width === void 0 || f.measured.height === void 0) && !f.hidden && (u = !1), c.parentId && em(f, t, n, r, a), l ||= c.selected ?? !1;
  }
  return { nodesInitialized: u, hasSelectedNodes: l };
}
function w2(e, t) {
  if (!e.parentId)
    return;
  const n = t.get(e.parentId);
  n ? n.set(e.id, e) : t.set(e.parentId, /* @__PURE__ */ new Map([[e.id, e]]));
}
function em(e, t, n, r, i) {
  const { elevateNodesOnSelect: a, nodeOrigin: o, nodeExtent: d, zIndexMode: u } = Yp(Xp, r), l = e.parentId, c = t.get(l);
  if (!c) {
    console.warn(`Parent node ${l} not found. Please make sure that parent nodes are in front of their child nodes in the nodes array.`);
    return;
  }
  w2(e, n), i && !c.parentId && c.internals.rootParentIndex === void 0 && u === "auto" && (c.internals.rootParentIndex = ++i.i, c.internals.z = c.internals.z + i.i * y2), i && c.internals.rootParentIndex !== void 0 && (i.i = c.internals.rootParentIndex);
  const f = a && !Qp(u) ? px : 0, { x: s, y: h, z: p } = k2(e, c, o, d, f, u), { positionAbsolute: m } = e.internals, y = s !== m.x || h !== m.y;
  (y || p !== e.internals.z) && t.set(e.id, {
    ...e,
    internals: {
      ...e.internals,
      positionAbsolute: y ? { x: s, y: h } : m,
      z: p
    }
  });
}
function mx(e, t, n) {
  const r = In(e.zIndex) ? e.zIndex : 0;
  return Qp(n) ? r : r + (e.selected ? t : 0);
}
function k2(e, t, n, r, i, a) {
  const { x: o, y: d } = t.internals.positionAbsolute, u = Gn(e), l = fl(e, n), c = oi(e.extent) ? ii(l, e.extent, u) : l;
  let f = ii({ x: o + c.x, y: d + c.y }, r, u);
  e.extent === "parent" && (f = rx(f, u, t));
  const s = mx(e, i, a), h = t.internals.z ?? 0;
  return {
    x: f.x,
    y: f.y,
    z: h >= s ? h + 1 : s
  };
}
function tm(e, t, n, r = [0, 0]) {
  const i = [], a = /* @__PURE__ */ new Map();
  for (const o of e) {
    const d = t.get(o.parentId);
    if (!d)
      continue;
    const u = a.get(o.parentId)?.expandedRect ?? Gs(d), l = ix(u, o.rect);
    a.set(o.parentId, { expandedRect: l, parent: d });
  }
  return a.size > 0 && a.forEach(({ expandedRect: o, parent: d }, u) => {
    const l = d.internals.positionAbsolute, c = Gn(d), f = d.origin ?? r, s = o.x < l.x ? Math.round(Math.abs(l.x - o.x)) : 0, h = o.y < l.y ? Math.round(Math.abs(l.y - o.y)) : 0, p = Math.max(c.width, Math.round(o.width)), m = Math.max(c.height, Math.round(o.height)), y = (p - c.width) * f[0], w = (m - c.height) * f[1];
    (s > 0 || h > 0 || y || w) && (i.push({
      id: u,
      type: "position",
      position: {
        x: d.position.x - s + y,
        y: d.position.y - h + w
      }
    }), n.get(u)?.forEach((b) => {
      e.some((_) => _.id === b.id) || i.push({
        id: b.id,
        type: "position",
        position: {
          x: b.position.x + s,
          y: b.position.y + h
        }
      });
    })), (c.width < o.width || c.height < o.height || s || h) && i.push({
      id: u,
      type: "dimensions",
      setAttributes: !0,
      dimensions: {
        width: p + (s ? f[0] * s - y : 0),
        height: m + (h ? f[1] * h - w : 0)
      }
    });
  }), i;
}
function S2(e, t, n, r, i, a, o) {
  const d = r?.querySelector(".xyflow__viewport");
  let u = !1;
  if (!d)
    return { changes: [], updatedInternals: u };
  const l = [], c = window.getComputedStyle(d), { m22: f } = new window.DOMMatrixReadOnly(c.transform), s = [];
  for (const h of e.values()) {
    const p = t.get(h.id);
    if (!p)
      continue;
    if (p.hidden) {
      t.set(p.id, {
        ...p,
        internals: {
          ...p.internals,
          handleBounds: void 0
        }
      }), u = !0;
      continue;
    }
    const m = Jp(h.nodeElement), y = p.measured.width !== m.width || p.measured.height !== m.height;
    if (!!(m.width && m.height && (y || !p.internals.handleBounds || h.force))) {
      const b = h.nodeElement.getBoundingClientRect(), _ = oi(p.extent) ? p.extent : a;
      let { positionAbsolute: g } = p.internals;
      if (p.parentId && p.extent === "parent") {
        const P = t.get(p.parentId);
        P && (g = rx(g, m, P));
      } else _ && (g = ii(g, _, m));
      const O = {
        ...p,
        measured: m,
        internals: {
          ...p.internals,
          positionAbsolute: g,
          handleBounds: {
            source: Jv("source", h.nodeElement, b, f, p.id),
            target: Jv("target", h.nodeElement, b, f, p.id)
          }
        }
      };
      t.set(p.id, O), p.parentId && em(O, t, n, { nodeOrigin: i, zIndexMode: o }), u = !0, y && (l.push({
        id: p.id,
        type: "dimensions",
        dimensions: m
      }), p.expandParent && p.parentId && s.push({
        id: p.id,
        parentId: p.parentId,
        rect: Gs(O, i)
      }));
    }
  }
  if (s.length > 0) {
    const h = tm(s, t, n, i);
    l.push(...h);
  }
  return { changes: l, updatedInternals: u };
}
async function x2({ delta: e, panZoom: t, transform: n, translateExtent: r, width: i, height: a }) {
  if (!t || !e.x && !e.y)
    return !1;
  const o = await t.setViewportConstrained({
    x: n[0] + e.x,
    y: n[1] + e.y,
    zoom: n[2]
  }, [
    [0, 0],
    [i, a]
  ], r);
  return !!o && (o.x !== n[0] || o.y !== n[1] || o.k !== n[2]);
}
function rb(e, t, n, r, i, a) {
  let o = i;
  const d = r.get(o) || /* @__PURE__ */ new Map();
  r.set(o, d.set(n, t)), o = `${i}-${e}`;
  const u = r.get(o) || /* @__PURE__ */ new Map();
  if (r.set(o, u.set(n, t)), a) {
    o = `${i}-${e}-${a}`;
    const l = r.get(o) || /* @__PURE__ */ new Map();
    r.set(o, l.set(n, t));
  }
}
function gx(e, t, n) {
  e.clear(), t.clear();
  for (const r of n) {
    const { source: i, target: a, sourceHandle: o = null, targetHandle: d = null } = r, u = { edgeId: r.id, source: i, target: a, sourceHandle: o, targetHandle: d }, l = `${i}-${o}--${a}-${d}`, c = `${a}-${d}--${i}-${o}`;
    rb("source", u, c, e, i, o), rb("target", u, l, e, a, d), t.set(r.id, r);
  }
}
function yx(e, t) {
  if (!e.parentId)
    return !1;
  const n = t.get(e.parentId);
  return n ? n.selected ? !0 : yx(n, t) : !1;
}
function ib(e, t, n) {
  let r = e;
  do {
    if (r?.matches?.(t))
      return !0;
    if (r === n)
      return !1;
    r = r?.parentElement;
  } while (r);
  return !1;
}
function I2(e, t, n, r) {
  const i = /* @__PURE__ */ new Map();
  for (const [a, o] of e)
    if ((o.selected || o.id === r) && (!o.parentId || !yx(o, e)) && (o.draggable || t && typeof o.draggable > "u")) {
      const d = e.get(a);
      d && i.set(a, {
        id: a,
        position: d.position || { x: 0, y: 0 },
        distance: {
          x: n.x - d.internals.positionAbsolute.x,
          y: n.y - d.internals.positionAbsolute.y
        },
        extent: d.extent,
        parentId: d.parentId,
        origin: d.origin,
        expandParent: d.expandParent,
        internals: {
          positionAbsolute: d.internals.positionAbsolute || { x: 0, y: 0 }
        },
        measured: {
          width: d.measured.width ?? 0,
          height: d.measured.height ?? 0
        }
      });
    }
  return i;
}
function Ed({ nodeId: e, dragItems: t, nodeLookup: n, dragging: r = !0 }) {
  const i = [];
  for (const [o, d] of t) {
    const u = n.get(o)?.internals.userNode;
    u && i.push({
      ...u,
      position: d.position,
      dragging: r
    });
  }
  if (!e)
    return [i[0], i];
  const a = n.get(e)?.internals.userNode;
  return [
    a ? {
      ...a,
      position: t.get(e)?.position || a.position,
      dragging: r
    } : i[0],
    i
  ];
}
function P2({ dragItems: e, snapGrid: t, x: n, y: r }) {
  const i = e.values().next().value;
  if (!i)
    return null;
  const a = {
    x: n - i.distance.x,
    y: r - i.distance.y
  }, o = pl(a, t);
  return {
    x: o.x - a.x,
    y: o.y - a.y
  };
}
function O2({ onNodeMouseDown: e, getStoreItems: t, onDragStart: n, onDrag: r, onDragStop: i }) {
  let a = { x: null, y: null }, o = 0, d = /* @__PURE__ */ new Map(), u = !1, l = { x: 0, y: 0 }, c = null, f = !1, s = null, h = !1, p = !1, m = null;
  function y({ noDragClassName: b, handleSelector: _, domNode: g, isSelectable: O, nodeId: P, nodeClickDistance: E = 0 }) {
    s = en(g);
    function T({ x: R, y: V }) {
      const { nodeLookup: C, nodeExtent: B, snapGrid: G, snapToGrid: Q, nodeOrigin: k, onNodeDrag: I, onSelectionDrag: S, onError: A, updateNodePositions: j } = t();
      a = { x: R, y: V };
      let z = !1;
      const L = d.size > 1, F = L && B ? bh(hl(d)) : null, K = L && Q ? P2({
        dragItems: d,
        snapGrid: G,
        x: R,
        y: V
      }) : null;
      for (const [ee, U] of d) {
        if (!C.has(ee))
          continue;
        let q = { x: R - U.distance.x, y: V - U.distance.y };
        Q && (q = K ? {
          x: Math.round(q.x + K.x),
          y: Math.round(q.y + K.y)
        } : pl(q, G));
        let ne = null;
        if (L && B && !U.extent && F) {
          const { positionAbsolute: re } = U.internals, de = re.x - F.x + B[0][0], ve = re.x + U.measured.width - F.x2 + B[1][0], se = re.y - F.y + B[0][1], pe = re.y + U.measured.height - F.y2 + B[1][1];
          ne = [
            [de, se],
            [ve, pe]
          ];
        }
        const { position: oe, positionAbsolute: Y } = nx({
          nodeId: ee,
          nextPosition: q,
          nodeLookup: C,
          nodeExtent: ne || B,
          nodeOrigin: k,
          onError: A
        });
        z = z || U.position.x !== oe.x || U.position.y !== oe.y, U.position = oe, U.internals.positionAbsolute = Y;
      }
      if (p = p || z, !!z && (j(d, !0), m && (r || I || !P && S))) {
        const [ee, U] = Ed({
          nodeId: P,
          dragItems: d,
          nodeLookup: C
        });
        r?.(m, d, ee, U), I?.(m, ee, U), P || S?.(m, U);
      }
    }
    async function D() {
      if (!c)
        return;
      const { transform: R, panBy: V, autoPanSpeed: C, autoPanOnNodeDrag: B } = t();
      if (!B) {
        u = !1, cancelAnimationFrame(o);
        return;
      }
      const [G, Q] = Wp(l, c, C);
      (G !== 0 || Q !== 0) && (a.x = (a.x ?? 0) - G / R[2], a.y = (a.y ?? 0) - Q / R[2], await V({ x: G, y: Q }) && T(a)), o = requestAnimationFrame(D);
    }
    function N(R) {
      const { nodeLookup: V, multiSelectionActive: C, nodesDraggable: B, transform: G, snapGrid: Q, snapToGrid: k, selectNodesOnDrag: I, onNodeDragStart: S, onSelectionDragStart: A, unselectNodesAndEdges: j } = t();
      f = !0, (!I || !O) && !C && P && (V.get(P)?.selected || j()), O && I && P && e?.(P);
      const z = js(R.sourceEvent, { transform: G, snapGrid: Q, snapToGrid: k, containerBounds: c });
      if (a = z, d = I2(V, B, z, P), d.size > 0 && (n || S || !P && A)) {
        const [L, F] = Ed({
          nodeId: P,
          dragItems: d,
          nodeLookup: V
        });
        n?.(R.sourceEvent, d, L, F), S?.(R.sourceEvent, L, F), P || A?.(R.sourceEvent, F);
      }
    }
    const M = jS().clickDistance(E).on("start", (R) => {
      const { domNode: V, nodeDragThreshold: C, transform: B, snapGrid: G, snapToGrid: Q } = t();
      c = V?.getBoundingClientRect() || null, h = !1, p = !1, m = R.sourceEvent, C === 0 && N(R), a = js(R.sourceEvent, { transform: B, snapGrid: G, snapToGrid: Q, containerBounds: c }), l = Pn(R.sourceEvent, c);
    }).on("drag", (R) => {
      const { autoPanOnNodeDrag: V, transform: C, snapGrid: B, snapToGrid: G, nodeDragThreshold: Q, nodeLookup: k } = t(), I = js(R.sourceEvent, { transform: C, snapGrid: B, snapToGrid: G, containerBounds: c });
      if (m = R.sourceEvent, (R.sourceEvent.type === "touchmove" && R.sourceEvent.touches.length > 1 || // if user deletes a node while dragging, we need to abort the drag to prevent errors
      P && !k.has(P)) && (h = !0), !h) {
        if (!u && V && f && (u = !0, D()), !f) {
          const S = Pn(R.sourceEvent, c), A = S.x - l.x, j = S.y - l.y;
          Math.sqrt(A * A + j * j) > Q && N(R);
        }
        (a.x !== I.xSnapped || a.y !== I.ySnapped) && d && f && (l = Pn(R.sourceEvent, c), T(I));
      }
    }).on("end", (R) => {
      if (!f || h) {
        h && d.size > 0 && t().updateNodePositions(d, !1);
        return;
      }
      if (u = !1, f = !1, cancelAnimationFrame(o), d.size > 0) {
        const { nodeLookup: V, updateNodePositions: C, onNodeDragStop: B, onSelectionDragStop: G } = t();
        if (p && (C(d, !1), p = !1), i || B || !P && G) {
          const [Q, k] = Ed({
            nodeId: P,
            dragItems: d,
            nodeLookup: V,
            dragging: !1
          });
          i?.(R.sourceEvent, d, Q, k), B?.(R.sourceEvent, Q, k), P || G?.(R.sourceEvent, k);
        }
      }
    }).filter((R) => {
      const V = R.target;
      return !R.button && (!b || !ib(V, `.${b}`, g)) && (!_ || ib(V, _, g));
    });
    s.call(M);
  }
  function w() {
    s?.on(".drag", null);
  }
  return {
    update: y,
    destroy: w
  };
}
function z2(e, t, n) {
  const r = [], i = {
    x: e.x - n,
    y: e.y - n,
    width: n * 2,
    height: n * 2
  };
  for (const a of t.values())
    Nu(i, Gs(a)) > 0 && r.push(a);
  return r;
}
const E2 = 250;
function T2(e, t, n, r) {
  let i = [], a = 1 / 0;
  const o = z2(e, n, t + E2);
  for (const d of o) {
    const u = [...d.internals.handleBounds?.source ?? [], ...d.internals.handleBounds?.target ?? []];
    for (const l of u) {
      if (r.nodeId === l.nodeId && r.type === l.type && r.id === l.id)
        continue;
      const { x: c, y: f } = ai(d, l, l.position, !0), s = Math.sqrt(Math.pow(c - e.x, 2) + Math.pow(f - e.y, 2));
      s > t || (s < a ? (i = [{ ...l, x: c, y: f }], a = s) : s === a && i.push({ ...l, x: c, y: f }));
    }
  }
  if (!i.length)
    return null;
  if (i.length > 1) {
    const d = r.type === "source" ? "target" : "source";
    return i.find((u) => u.type === d) ?? i[0];
  }
  return i[0];
}
function vx(e, t, n, r, i, a = !1) {
  const o = r.get(e);
  if (!o)
    return null;
  const d = i === "strict" ? o.internals.handleBounds?.[t] : [...o.internals.handleBounds?.source ?? [], ...o.internals.handleBounds?.target ?? []], u = (n ? d?.find((l) => l.id === n) : d?.[0]) ?? null;
  return u && a ? { ...u, ...ai(o, u, u.position, !0) } : u;
}
function bx(e, t) {
  return e || (t?.classList.contains("target") ? "target" : t?.classList.contains("source") ? "source" : null);
}
function N2(e, t) {
  let n = null;
  return t ? n = !0 : e && !t && (n = !1), n;
}
const _x = () => !0;
function C2(e, { connectionMode: t, connectionRadius: n, handleId: r, nodeId: i, edgeUpdaterType: a, isTarget: o, domNode: d, nodeLookup: u, lib: l, autoPanOnConnect: c, flowId: f, panBy: s, cancelConnection: h, onConnectStart: p, onConnect: m, onConnectEnd: y, isValidConnection: w = _x, onReconnectEnd: b, updateConnection: _, getTransform: g, getFromHandle: O, autoPanSpeed: P, dragThreshold: E = 1, handleDomNode: T }) {
  const D = lx(e.target);
  let N = 0, M;
  const { x: R, y: V } = Pn(e), C = bx(a, T), B = d?.getBoundingClientRect();
  let G = !1;
  if (!B || !C)
    return;
  const Q = vx(i, C, r, u, t);
  if (!Q)
    return;
  let k = Pn(e, B), I = !1, S = null, A = !1, j = null;
  function z() {
    if (!c || !B)
      return;
    const [oe, Y] = Wp(k, B, P);
    s({ x: oe, y: Y }), N = requestAnimationFrame(z);
  }
  const L = {
    ...Q,
    nodeId: i,
    type: C,
    position: Q.position
  }, F = u.get(i);
  let ee = {
    inProgress: !0,
    isValid: null,
    from: ai(F, L, Ie.Left, !0),
    fromHandle: L,
    fromPosition: L.position,
    fromNode: F,
    to: k,
    toHandle: null,
    toPosition: Hv[L.position],
    toNode: null,
    pointer: k
  };
  function U() {
    G = !0, _(ee), p?.(e, { nodeId: i, handleId: r, handleType: C });
  }
  E === 0 && U();
  function q(oe) {
    if (!G) {
      const { x: pe, y: ke } = Pn(oe), Ne = pe - R, Ke = ke - V;
      if (!(Ne * Ne + Ke * Ke > E * E))
        return;
      U();
    }
    if (!O() || !L) {
      ne(oe);
      return;
    }
    const Y = g();
    k = Pn(oe, B), M = T2(ml(k, Y, !1, [1, 1]), n, u, L), I || (z(), I = !0);
    const re = wx(oe, {
      handle: M,
      connectionMode: t,
      fromNodeId: i,
      fromHandleId: r,
      fromType: o ? "target" : "source",
      isValidConnection: w,
      doc: D,
      lib: l,
      flowId: f,
      nodeLookup: u
    });
    j = re.handleDomNode, S = re.connection, A = N2(!!M, re.isValid);
    const de = u.get(i), ve = de ? ai(de, L, Ie.Left, !0) : ee.from, se = {
      ...ee,
      from: ve,
      isValid: A,
      to: re.toHandle && A ? $o({ x: re.toHandle.x, y: re.toHandle.y }, Y) : k,
      toHandle: re.toHandle,
      toPosition: A && re.toHandle ? re.toHandle.position : Hv[L.position],
      toNode: re.toHandle ? u.get(re.toHandle.nodeId) : null,
      pointer: k
    };
    _(se), ee = se;
  }
  function ne(oe) {
    if (!("touches" in oe && oe.touches.length > 0)) {
      if (G) {
        (M || j) && S && A && m?.(S);
        const { inProgress: Y, ...re } = ee, de = {
          ...re,
          toPosition: ee.toHandle ? ee.toPosition : null
        };
        y?.(oe, de), a && b?.(oe, de);
      }
      h(), cancelAnimationFrame(N), I = !1, A = !1, S = null, j = null, D.removeEventListener("mousemove", q), D.removeEventListener("mouseup", ne), D.removeEventListener("touchmove", q), D.removeEventListener("touchend", ne);
    }
  }
  D.addEventListener("mousemove", q), D.addEventListener("mouseup", ne), D.addEventListener("touchmove", q), D.addEventListener("touchend", ne);
}
function wx(e, { handle: t, connectionMode: n, fromNodeId: r, fromHandleId: i, fromType: a, doc: o, lib: d, flowId: u, isValidConnection: l = _x, nodeLookup: c }) {
  const f = a === "target", s = t ? o.querySelector(`.${d}-flow__handle[data-id="${u}-${t?.nodeId}-${t?.id}-${t?.type}"]`) : null, { x: h, y: p } = Pn(e), m = o.elementFromPoint(h, p), y = m?.classList.contains(`${d}-flow__handle`) ? m : s, w = {
    handleDomNode: y,
    isValid: !1,
    connection: null,
    toHandle: null
  };
  if (y) {
    const b = bx(void 0, y), _ = y.getAttribute("data-nodeid"), g = y.getAttribute("data-handleid"), O = y.classList.contains("connectable"), P = y.classList.contains("connectableend");
    if (!_ || !b)
      return w;
    const E = {
      source: f ? _ : r,
      sourceHandle: f ? g : i,
      target: f ? r : _,
      targetHandle: f ? i : g
    };
    w.connection = E;
    const D = O && P && (n === jo.Strict ? f && b === "source" || !f && b === "target" : _ !== r || g !== i);
    w.isValid = D && l(E), w.toHandle = vx(_, b, g, c, n, !0);
  }
  return w;
}
const Sh = {
  onPointerDown: C2,
  isValid: wx
};
function D2({ domNode: e, panZoom: t, getTransform: n, getViewScale: r }) {
  const i = en(e);
  function a({ translateExtent: d, width: u, height: l, zoomStep: c = 1, pannable: f = !0, zoomable: s = !0, inversePan: h = !1 }) {
    const p = (_) => {
      if (_.sourceEvent.type !== "wheel" || !t)
        return;
      const g = n(), O = _.sourceEvent.ctrlKey && Ks() ? 10 : 1, P = -_.sourceEvent.deltaY * (_.sourceEvent.deltaMode === 1 ? 0.05 : _.sourceEvent.deltaMode ? 1 : 2e-3) * c, E = g[2] * Math.pow(2, P * O);
      t.scaleTo(E);
    };
    let m = [0, 0];
    const y = (_) => {
      (_.sourceEvent.type === "mousedown" || _.sourceEvent.type === "touchstart") && (m = [
        _.sourceEvent.clientX ?? _.sourceEvent.touches[0].clientX,
        _.sourceEvent.clientY ?? _.sourceEvent.touches[0].clientY
      ]);
    }, w = (_) => {
      const g = n();
      if (_.sourceEvent.type !== "mousemove" && _.sourceEvent.type !== "touchmove" || !t)
        return;
      const O = [
        _.sourceEvent.clientX ?? _.sourceEvent.touches[0].clientX,
        _.sourceEvent.clientY ?? _.sourceEvent.touches[0].clientY
      ], P = [O[0] - m[0], O[1] - m[1]];
      m = O;
      const E = r() * Math.max(g[2], Math.log(g[2])) * (h ? -1 : 1), T = {
        x: g[0] - P[0] * E,
        y: g[1] - P[1] * E
      }, D = [
        [0, 0],
        [u, l]
      ];
      t.setViewportConstrained({
        x: T.x,
        y: T.y,
        zoom: g[2]
      }, D, d);
    }, b = JS().on("start", y).on("zoom", f ? w : null).on("zoom.wheel", s ? p : null);
    i.call(b, {});
  }
  function o() {
    i.on("zoom", null);
  }
  return {
    update: a,
    destroy: o,
    pointer: Sn
  };
}
const wc = (e) => ({
  x: e.x,
  y: e.y,
  zoom: e.k
}), Td = ({ x: e, y: t, zoom: n }) => yc.translate(e, t).scale(n), vo = (e, t) => e.target.closest(`.${t}`), kx = (e, t) => t === 2 && Array.isArray(e) && e.includes(2), A2 = (e) => ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2, Nd = (e, t = 0, n = A2, r = () => {
}) => {
  const i = typeof t == "number" && t > 0;
  return i || r(), i ? e.transition().duration(t).ease(n).on("end", r) : e;
}, Sx = (e) => {
  const t = e.ctrlKey && Ks() ? 10 : 1;
  return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * t;
};
function j2({ zoomPanValues: e, noWheelClassName: t, d3Selection: n, d3Zoom: r, panOnScrollMode: i, panOnScrollSpeed: a, zoomOnPinch: o, onPanZoomStart: d, onPanZoom: u, onPanZoomEnd: l }) {
  return (c) => {
    if (vo(c, t))
      return c.ctrlKey && c.preventDefault(), !1;
    c.preventDefault(), c.stopImmediatePropagation();
    const f = n.property("__zoom").k || 1;
    if (c.ctrlKey && o) {
      const y = Sn(c), w = Sx(c), b = f * Math.pow(2, w);
      r.scaleTo(n, b, y, c);
      return;
    }
    const s = c.deltaMode === 1 ? 20 : 1;
    let h = i === Yr.Vertical ? 0 : c.deltaX * s, p = i === Yr.Horizontal ? 0 : c.deltaY * s;
    !Ks() && c.shiftKey && i !== Yr.Vertical && (h = c.deltaY * s, p = 0), r.translateBy(
      n,
      -(h / f) * a,
      -(p / f) * a,
      // @ts-ignore
      { internal: !0 }
    );
    const m = wc(n.property("__zoom"));
    clearTimeout(e.panScrollTimeout), e.isPanScrolling ? u?.(c, m) : (e.isPanScrolling = !0, d?.(c, m)), e.panScrollTimeout = setTimeout(() => {
      l?.(c, m), e.isPanScrolling = !1;
    }, 150);
  };
}
function M2({ noWheelClassName: e, preventScrolling: t, d3ZoomHandler: n }) {
  return function(r, i) {
    const a = r.type === "wheel", o = !t && a && !r.ctrlKey, d = vo(r, e);
    if (r.ctrlKey && a && d && r.preventDefault(), o || d)
      return null;
    r.preventDefault(), n.call(this, r, i);
  };
}
function $2({ zoomPanValues: e, onDraggingChange: t, onPanZoomStart: n }) {
  return (r) => {
    if (r.sourceEvent?.internal)
      return;
    const i = wc(r.transform);
    e.mouseButton = r.sourceEvent?.button || 0, e.isZoomingOrPanning = !0, e.prevViewport = i, r.sourceEvent?.type === "mousedown" && t(!0), n && n?.(r.sourceEvent, i);
  };
}
function R2({ zoomPanValues: e, panOnDrag: t, onPaneContextMenu: n, onTransformChange: r, onPanZoom: i }) {
  return (a) => {
    e.usedRightMouseButton = !!(n && kx(t, e.mouseButton ?? 0)), a.sourceEvent?.sync || r([a.transform.x, a.transform.y, a.transform.k]), i && !a.sourceEvent?.internal && i?.(a.sourceEvent, wc(a.transform));
  };
}
function Z2({ zoomPanValues: e, panOnDrag: t, panOnScroll: n, onDraggingChange: r, onPanZoomEnd: i, onPaneContextMenu: a }) {
  return (o) => {
    if (!o.sourceEvent?.internal && (e.isZoomingOrPanning = !1, a && kx(t, e.mouseButton ?? 0) && !e.usedRightMouseButton && o.sourceEvent && a(o.sourceEvent), e.usedRightMouseButton = !1, r(!1), i)) {
      const d = wc(o.transform);
      e.prevViewport = d, clearTimeout(e.timerId), e.timerId = setTimeout(
        () => {
          i?.(o.sourceEvent, d);
        },
        // we need a setTimeout for panOnScroll to suppress multiple end events fired during scroll
        n ? 150 : 0
      );
    }
  };
}
function L2({ zoomActivationKeyPressed: e, zoomOnScroll: t, zoomOnPinch: n, panOnDrag: r, panOnScroll: i, zoomOnDoubleClick: a, userSelectionActive: o, noWheelClassName: d, noPanClassName: u, lib: l, connectionInProgress: c }) {
  return (f) => {
    const s = e || t, h = n && f.ctrlKey, p = f.type === "wheel";
    if (f.button === 1 && f.type === "mousedown" && (vo(f, `${l}-flow__node`) || vo(f, `${l}-flow__edge`)))
      return !0;
    if (!r && !s && !i && !a && !n || o || c && !p || vo(f, d) && p || vo(f, u) && (!p || i && p && !e) || !n && f.ctrlKey && p)
      return !1;
    if (!n && f.type === "touchstart" && f.touches?.length > 1)
      return f.preventDefault(), !1;
    if (!s && !i && !h && p || !r && (f.type === "mousedown" || f.type === "touchstart") || Array.isArray(r) && !r.includes(f.button) && f.type === "mousedown")
      return !1;
    const m = Array.isArray(r) && r.includes(f.button) || !f.button || f.button <= 1;
    return (!f.ctrlKey || p) && m;
  };
}
function F2({ domNode: e, minZoom: t, maxZoom: n, translateExtent: r, viewport: i, onPanZoom: a, onPanZoomStart: o, onPanZoomEnd: d, onDraggingChange: u }) {
  const l = {
    isZoomingOrPanning: !1,
    usedRightMouseButton: !1,
    prevViewport: {},
    mouseButton: 0,
    timerId: void 0,
    panScrollTimeout: void 0,
    isPanScrolling: !1
  }, c = e.getBoundingClientRect();
  let f = [
    [0, 0],
    [c.width, c.height]
  ];
  (typeof ResizeObserver < "u" ? new ResizeObserver((V) => {
    const C = V[0];
    C && (f = [
      [0, 0],
      [C.contentRect.width, C.contentRect.height]
    ]);
  }) : null)?.observe(e);
  const h = JS().extent(() => f).scaleExtent([t, n]).translateExtent(r), p = en(e).call(h);
  g({
    x: i.x,
    y: i.y,
    zoom: Mo(i.zoom, t, n)
  }, [
    [0, 0],
    [c.width, c.height]
  ], r);
  const m = p.on("wheel.zoom"), y = p.on("dblclick.zoom");
  h.wheelDelta(Sx);
  async function w(V, C) {
    return p ? new Promise((B) => {
      h?.interpolate(C?.interpolate === "linear" ? As : iu).transform(Nd(p, C?.duration, C?.ease, () => B(!0)), V);
    }) : !1;
  }
  function b({ noWheelClassName: V, noPanClassName: C, onPaneContextMenu: B, userSelectionActive: G, panOnScroll: Q, panOnDrag: k, panOnScrollMode: I, panOnScrollSpeed: S, preventScrolling: A, zoomOnPinch: j, zoomOnScroll: z, zoomOnDoubleClick: L, zoomActivationKeyPressed: F, lib: K, onTransformChange: ee, connectionInProgress: U, paneClickDistance: q, selectionOnDrag: ne }) {
    G && !l.isZoomingOrPanning && _();
    const oe = Q && !F && !G;
    h.clickDistance(ne ? 1 / 0 : !In(q) || q < 0 ? 0 : q);
    const Y = oe ? j2({
      zoomPanValues: l,
      noWheelClassName: V,
      d3Selection: p,
      d3Zoom: h,
      panOnScrollMode: I,
      panOnScrollSpeed: S,
      zoomOnPinch: j,
      onPanZoomStart: o,
      onPanZoom: a,
      onPanZoomEnd: d
    }) : M2({
      noWheelClassName: V,
      preventScrolling: A,
      d3ZoomHandler: m
    });
    p.on("wheel.zoom", Y, { passive: !1 });
    const re = $2({
      zoomPanValues: l,
      onDraggingChange: u,
      onPanZoomStart: o
    });
    h.on("start", re);
    const de = R2({
      zoomPanValues: l,
      panOnDrag: k,
      onPaneContextMenu: !!B,
      onPanZoom: a,
      onTransformChange: ee
    });
    h.on("zoom", de);
    const ve = Z2({
      zoomPanValues: l,
      panOnDrag: k,
      panOnScroll: Q,
      onPaneContextMenu: B,
      onPanZoomEnd: d,
      onDraggingChange: u
    });
    h.on("end", ve);
    const se = L2({
      zoomActivationKeyPressed: F,
      panOnDrag: k,
      zoomOnScroll: z,
      panOnScroll: Q,
      zoomOnDoubleClick: L,
      zoomOnPinch: j,
      userSelectionActive: G,
      noPanClassName: C,
      noWheelClassName: V,
      lib: K,
      connectionInProgress: U
    });
    h.filter(se), L ? p.on("dblclick.zoom", y) : p.on("dblclick.zoom", null);
  }
  function _() {
    h.on("zoom", null);
  }
  async function g(V, C, B) {
    const G = Td(V), Q = h?.constrain()(G, C, B);
    return Q && await w(Q), Q;
  }
  async function O(V, C) {
    const B = Td(V);
    return await w(B, C), B;
  }
  function P(V) {
    if (p) {
      const C = Td(V), B = p.property("__zoom");
      (B.k !== V.zoom || B.x !== V.x || B.y !== V.y) && h?.transform(p, C, null, { sync: !0 });
    }
  }
  function E() {
    const V = p ? KS(p.node()) : { x: 0, y: 0, k: 1 };
    return { x: V.x, y: V.y, zoom: V.k };
  }
  async function T(V, C) {
    return p ? new Promise((B) => {
      h?.interpolate(C?.interpolate === "linear" ? As : iu).scaleTo(Nd(p, C?.duration, C?.ease, () => B(!0)), V);
    }) : !1;
  }
  async function D(V, C) {
    return p ? new Promise((B) => {
      h?.interpolate(C?.interpolate === "linear" ? As : iu).scaleBy(Nd(p, C?.duration, C?.ease, () => B(!0)), V);
    }) : !1;
  }
  function N(V) {
    h?.scaleExtent(V);
  }
  function M(V) {
    h?.translateExtent(V);
  }
  function R(V) {
    const C = !In(V) || V < 0 ? 0 : V;
    h?.clickDistance(C);
  }
  return {
    update: b,
    destroy: _,
    setViewport: O,
    setViewportConstrained: g,
    getViewport: E,
    scaleTo: T,
    scaleBy: D,
    setScaleExtent: N,
    setTranslateExtent: M,
    syncViewport: P,
    setClickDistance: R
  };
}
var Ro;
(function(e) {
  e.Line = "line", e.Handle = "handle";
})(Ro || (Ro = {}));
function U2({ width: e, prevWidth: t, height: n, prevHeight: r, affectsX: i, affectsY: a }) {
  const o = e - t, d = n - r, u = [o > 0 ? 1 : o < 0 ? -1 : 0, d > 0 ? 1 : d < 0 ? -1 : 0];
  return o && i && (u[0] = u[0] * -1), d && a && (u[1] = u[1] * -1), u;
}
function ob(e) {
  const t = e.includes("right") || e.includes("left"), n = e.includes("bottom") || e.includes("top"), r = e.includes("left"), i = e.includes("top");
  return {
    isHorizontal: t,
    isVertical: n,
    affectsX: r,
    affectsY: i
  };
}
function yr(e, t) {
  return Math.max(0, t - e);
}
function vr(e, t) {
  return Math.max(0, e - t);
}
function Ul(e, t, n) {
  return Math.max(0, t - e, e - n);
}
function ab(e, t) {
  return e ? !t : t;
}
function B2(e, t, n, r, i, a, o, d) {
  let { affectsX: u, affectsY: l } = t;
  const { isHorizontal: c, isVertical: f } = t, s = c && f, { xSnapped: h, ySnapped: p } = n, { minWidth: m, maxWidth: y, minHeight: w, maxHeight: b } = r, { x: _, y: g, width: O, height: P, aspectRatio: E } = e;
  let T = Math.floor(c ? h - e.pointerX : 0), D = Math.floor(f ? p - e.pointerY : 0);
  const N = O + (u ? -T : T), M = P + (l ? -D : D), R = -a[0] * O, V = -a[1] * P;
  let C = Ul(N, m, y), B = Ul(M, w, b);
  if (o) {
    let k = 0, I = 0;
    u && T < 0 ? k = yr(_ + T + R, o[0][0]) : !u && T > 0 && (k = vr(_ + N + R, o[1][0])), l && D < 0 ? I = yr(g + D + V, o[0][1]) : !l && D > 0 && (I = vr(g + M + V, o[1][1])), C = Math.max(C, k), B = Math.max(B, I);
  }
  if (d) {
    let k = 0, I = 0;
    u && T > 0 ? k = vr(_ + T, d[0][0]) : !u && T < 0 && (k = yr(_ + N, d[1][0])), l && D > 0 ? I = vr(g + D, d[0][1]) : !l && D < 0 && (I = yr(g + M, d[1][1])), C = Math.max(C, k), B = Math.max(B, I);
  }
  if (i) {
    if (c) {
      const k = Ul(N / E, w, b) * E;
      if (C = Math.max(C, k), o) {
        let I = 0;
        !u && !l || u && !l && s ? I = vr(g + V + N / E, o[1][1]) * E : I = yr(g + V + (u ? T : -T) / E, o[0][1]) * E, C = Math.max(C, I);
      }
      if (d) {
        let I = 0;
        !u && !l || u && !l && s ? I = yr(g + N / E, d[1][1]) * E : I = vr(g + (u ? T : -T) / E, d[0][1]) * E, C = Math.max(C, I);
      }
    }
    if (f) {
      const k = Ul(M * E, m, y) / E;
      if (B = Math.max(B, k), o) {
        let I = 0;
        !u && !l || l && !u && s ? I = vr(_ + M * E + R, o[1][0]) / E : I = yr(_ + (l ? D : -D) * E + R, o[0][0]) / E, B = Math.max(B, I);
      }
      if (d) {
        let I = 0;
        !u && !l || l && !u && s ? I = yr(_ + M * E, d[1][0]) / E : I = vr(_ + (l ? D : -D) * E, d[0][0]) / E, B = Math.max(B, I);
      }
    }
  }
  D = D + (D < 0 ? B : -B), T = T + (T < 0 ? C : -C), i && (s ? N > M * E ? D = (ab(u, l) ? -T : T) / E : T = (ab(u, l) ? -D : D) * E : c ? (D = T / E, l = u) : (T = D * E, u = l));
  const G = u ? _ + T : _, Q = l ? g + D : g;
  return {
    width: O + (u ? -T : T),
    height: P + (l ? -D : D),
    x: a[0] * T * (u ? -1 : 1) + G,
    y: a[1] * D * (l ? -1 : 1) + Q
  };
}
const xx = { width: 0, height: 0, x: 0, y: 0 }, V2 = {
  ...xx,
  pointerX: 0,
  pointerY: 0,
  aspectRatio: 1
};
function q2(e, t, n) {
  const r = t.position.x + e.position.x, i = t.position.y + e.position.y, a = e.measured.width ?? 0, o = e.measured.height ?? 0, d = n[0] * a, u = n[1] * o;
  return [
    [r - d, i - u],
    [r + a - d, i + o - u]
  ];
}
function H2({ domNode: e, nodeId: t, getStoreItems: n, onChange: r, onEnd: i }) {
  const a = en(e);
  let o = {
    controlDirection: ob("bottom-right"),
    boundaries: {
      minWidth: 0,
      minHeight: 0,
      maxWidth: Number.MAX_VALUE,
      maxHeight: Number.MAX_VALUE
    },
    resizeDirection: void 0,
    keepAspectRatio: !1
  };
  function d({ controlPosition: l, boundaries: c, keepAspectRatio: f, resizeDirection: s, onResizeStart: h, onResize: p, onResizeEnd: m, shouldResize: y }) {
    let w = { ...xx }, b = { ...V2 };
    o = {
      boundaries: c,
      resizeDirection: s,
      keepAspectRatio: f,
      controlDirection: ob(l)
    };
    let _, g = null, O = [], P, E, T, D = !1;
    const N = jS().on("start", (M) => {
      const { nodeLookup: R, transform: V, snapGrid: C, snapToGrid: B, nodeOrigin: G, paneDomNode: Q } = n();
      if (_ = R.get(t), !_)
        return;
      g = Q?.getBoundingClientRect() ?? null;
      const { xSnapped: k, ySnapped: I } = js(M.sourceEvent, {
        transform: V,
        snapGrid: C,
        snapToGrid: B,
        containerBounds: g
      });
      w = {
        width: _.measured.width ?? 0,
        height: _.measured.height ?? 0,
        x: _.position.x ?? 0,
        y: _.position.y ?? 0
      }, b = {
        ...w,
        pointerX: k,
        pointerY: I,
        aspectRatio: w.width / w.height
      }, P = void 0, E = oi(_.extent) ? _.extent : void 0, _.parentId && (_.extent === "parent" || _.expandParent) && (P = R.get(_.parentId)), P && _.extent === "parent" && (E = [
        [0, 0],
        [P.measured.width, P.measured.height]
      ]), O = [], T = void 0;
      for (const [S, A] of R)
        if (A.parentId === t && (O.push({
          id: S,
          position: { ...A.position },
          extent: A.extent
        }), A.extent === "parent" || A.expandParent)) {
          const j = q2(A, _, A.origin ?? G);
          T ? T = [
            [Math.min(j[0][0], T[0][0]), Math.min(j[0][1], T[0][1])],
            [Math.max(j[1][0], T[1][0]), Math.max(j[1][1], T[1][1])]
          ] : T = j;
        }
      h?.(M, { ...w });
    }).on("drag", (M) => {
      const { transform: R, snapGrid: V, snapToGrid: C, nodeOrigin: B } = n(), G = js(M.sourceEvent, {
        transform: R,
        snapGrid: V,
        snapToGrid: C,
        containerBounds: g
      }), Q = [];
      if (!_)
        return;
      const { x: k, y: I, width: S, height: A } = w, j = {}, z = _.origin ?? B, { width: L, height: F, x: K, y: ee } = B2(b, o.controlDirection, G, o.boundaries, o.keepAspectRatio, z, E, T), U = L !== S, q = F !== A, ne = K !== k && U, oe = ee !== I && q;
      if (!ne && !oe && !U && !q)
        return;
      if ((ne || oe || z[0] === 1 || z[1] === 1) && (j.x = ne ? K : w.x, j.y = oe ? ee : w.y, w.x = j.x, w.y = j.y, O.length > 0)) {
        const ve = K - k, se = ee - I;
        for (const pe of O)
          pe.position = {
            x: pe.position.x - ve + z[0] * (L - S),
            y: pe.position.y - se + z[1] * (F - A)
          }, Q.push(pe);
      }
      if ((U || q) && (j.width = U && (!o.resizeDirection || o.resizeDirection === "horizontal") ? L : w.width, j.height = q && (!o.resizeDirection || o.resizeDirection === "vertical") ? F : w.height, w.width = j.width, w.height = j.height), P && _.expandParent) {
        const ve = z[0] * (j.width ?? 0);
        j.x && j.x < ve && (w.x = ve, b.x = b.x - (j.x - ve));
        const se = z[1] * (j.height ?? 0);
        j.y && j.y < se && (w.y = se, b.y = b.y - (j.y - se));
      }
      const Y = U2({
        width: w.width,
        prevWidth: S,
        height: w.height,
        prevHeight: A,
        affectsX: o.controlDirection.affectsX,
        affectsY: o.controlDirection.affectsY
      }), re = { ...w, direction: Y };
      y?.(M, re) !== !1 && (D = !0, p?.(M, re), r(j, Q));
    }).on("end", (M) => {
      D && (m?.(M, { ...w }), i?.({ ...w }), D = !1);
    });
    a.call(N);
  }
  function u() {
    a.on(".drag", null);
  }
  return {
    update: d,
    destroy: u
  };
}
const kc = Wt(null), W2 = kc.Provider, Ix = an.error001("react");
function Ve(e, t) {
  const n = st(kc);
  if (n === null)
    throw new Error(Ix);
  return Wz(n, e, t);
}
function at() {
  const e = st(kc);
  if (e === null)
    throw new Error(Ix);
  return Le(() => ({
    getState: e.getState,
    setState: e.setState,
    subscribe: e.subscribe
  }), [e]);
}
const sb = { display: "none" }, G2 = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  border: 0,
  padding: 0,
  overflow: "hidden",
  clip: "rect(0px, 0px, 0px, 0px)",
  clipPath: "inset(100%)"
}, Px = "react-flow__node-desc", Ox = "react-flow__edge-desc", K2 = "react-flow__aria-live", J2 = (e) => e.ariaLiveMessage, X2 = (e) => e.ariaLabelConfig;
function Y2({ rfId: e }) {
  const t = Ve(J2);
  return x("div", { id: `${K2}-${e}`, "aria-live": "assertive", "aria-atomic": "true", style: G2, children: t });
}
function Q2({ rfId: e, disableKeyboardA11y: t }) {
  const n = Ve(X2);
  return te(Ue, { children: [x("div", { id: `${Px}-${e}`, style: sb, children: t ? n["node.a11yDescription.default"] : n["node.a11yDescription.keyboardDisabled"] }), x("div", { id: `${Ox}-${e}`, style: sb, children: n["edge.a11yDescription.default"] }), !t && x(Y2, { rfId: e })] });
}
const Sc = ol(({ position: e = "top-left", children: t, className: n, style: r, ...i }, a) => {
  const o = `${e}`.split("-");
  return x("div", { className: kt(["react-flow__panel", n, ...o]), style: r, ref: a, ...i, children: t });
});
Sc.displayName = "Panel";
const lb = `https://reactflow.dev${process.env.NODE_ENV === "production" ? "?utm_source=attribution" : "/attribution"}`;
function e6({ proOptions: e, position: t = "bottom-right" }) {
  return e?.hideAttribution ? null : x(Sc, { position: t, className: "react-flow__attribution", "data-message": `Please only hide this attribution when you are subscribed to React Flow Pro: ${lb}`, children: x("a", { href: lb, target: "_blank", rel: "noopener noreferrer", "aria-label": "React Flow attribution", children: "React Flow" }) });
}
const t6 = (e) => {
  const t = [], n = [];
  for (const [, r] of e.nodeLookup)
    r.selected && t.push(r.internals.userNode);
  for (const [, r] of e.edgeLookup)
    r.selected && n.push(r);
  return { selectedNodes: t, selectedEdges: n };
}, Bl = (e) => e.id;
function n6(e, t) {
  return ct(e.selectedNodes.map(Bl), t.selectedNodes.map(Bl)) && ct(e.selectedEdges.map(Bl), t.selectedEdges.map(Bl));
}
function r6({ onSelectionChange: e }) {
  const t = at(), { selectedNodes: n, selectedEdges: r } = Ve(t6, n6);
  return Ze(() => {
    const i = { nodes: n, edges: r };
    e?.(i), t.getState().onSelectionChangeHandlers.forEach((a) => a(i));
  }, [n, r, e]), null;
}
const i6 = (e) => !!e.onSelectionChangeHandlers;
function o6({ onSelectionChange: e }) {
  const t = Ve(i6);
  return e || t ? x(r6, { onSelectionChange: e }) : null;
}
const zx = [0, 0], a6 = { x: 0, y: 0, zoom: 1 }, s6 = [
  "nodes",
  "edges",
  "defaultNodes",
  "defaultEdges",
  "onConnect",
  "onConnectStart",
  "onConnectEnd",
  "onClickConnectStart",
  "onClickConnectEnd",
  "nodesDraggable",
  "autoPanOnNodeFocus",
  "nodesConnectable",
  "nodesFocusable",
  "edgesFocusable",
  "edgesReconnectable",
  "elevateNodesOnSelect",
  "elevateEdgesOnSelect",
  "minZoom",
  "maxZoom",
  "nodeExtent",
  "onNodesChange",
  "onEdgesChange",
  "elementsSelectable",
  "connectionMode",
  "snapGrid",
  "snapToGrid",
  "translateExtent",
  "connectOnClick",
  "defaultEdgeOptions",
  "fitView",
  "fitViewOptions",
  "onNodesDelete",
  "onEdgesDelete",
  "onDelete",
  "onNodeDrag",
  "onNodeDragStart",
  "onNodeDragStop",
  "onSelectionDrag",
  "onSelectionDragStart",
  "onSelectionDragStop",
  "onMoveStart",
  "onMove",
  "onMoveEnd",
  "noPanClassName",
  "nodeOrigin",
  "autoPanOnConnect",
  "autoPanOnNodeDrag",
  "onError",
  "connectionRadius",
  "isValidConnection",
  "selectNodesOnDrag",
  "nodeDragThreshold",
  "connectionDragThreshold",
  "onBeforeDelete",
  "debug",
  "autoPanSpeed",
  "ariaLabelConfig",
  "zIndexMode"
], ub = [...s6, "rfId"], l6 = (e) => ({
  setNodes: e.setNodes,
  setEdges: e.setEdges,
  setMinZoom: e.setMinZoom,
  setMaxZoom: e.setMaxZoom,
  setTranslateExtent: e.setTranslateExtent,
  setNodeExtent: e.setNodeExtent,
  reset: e.reset,
  setDefaultNodesAndEdges: e.setDefaultNodesAndEdges
}), cb = {
  /*
   * these are values that are also passed directly to other components
   * than the StoreUpdater. We can reduce the number of setStore calls
   * by setting the same values here as prev fields.
   */
  translateExtent: qs,
  nodeOrigin: zx,
  minZoom: 0.5,
  maxZoom: 2,
  elementsSelectable: !0,
  noPanClassName: "nopan",
  rfId: "1"
};
function u6(e) {
  const { setNodes: t, setEdges: n, setMinZoom: r, setMaxZoom: i, setTranslateExtent: a, setNodeExtent: o, reset: d, setDefaultNodesAndEdges: u } = Ve(l6, ct), l = at();
  Ze(() => (u(e.defaultNodes, e.defaultEdges), () => {
    c.current = cb, d();
  }), []);
  const c = Ce(cb);
  return Ze(
    () => {
      for (const f of ub) {
        const s = e[f], h = c.current[f];
        s !== h && (typeof e[f] > "u" || (f === "nodes" ? t(s) : f === "edges" ? n(s) : f === "minZoom" ? r(s) : f === "maxZoom" ? i(s) : f === "translateExtent" ? a(s) : f === "nodeExtent" ? o(s) : f === "ariaLabelConfig" ? l.setState({ ariaLabelConfig: o2(s) }) : f === "fitView" ? l.setState({ fitViewQueued: s }) : f === "fitViewOptions" ? l.setState({ fitViewOptions: s }) : l.setState({ [f]: s })));
      }
      c.current = e;
    },
    // Only re-run the effect if one of the fields we track changes
    ub.map((f) => e[f])
  ), null;
}
function db() {
  return typeof window > "u" || !window.matchMedia ? null : window.matchMedia("(prefers-color-scheme: dark)");
}
function c6(e) {
  const [t, n] = Ae(e === "system" ? null : e);
  return Ze(() => {
    if (e !== "system") {
      n(e);
      return;
    }
    const r = db(), i = () => n(r?.matches ? "dark" : "light");
    return i(), r?.addEventListener("change", i), () => {
      r?.removeEventListener("change", i);
    };
  }, [e]), t !== null ? t : db()?.matches ? "dark" : "light";
}
const fb = typeof document < "u" ? document : null;
function Js(e = null, t = { target: fb, actInsideInputWithModifier: !0 }) {
  const [n, r] = Ae(!1), i = Ce(!1), a = Ce(/* @__PURE__ */ new Set([])), [o, d] = Le(() => {
    if (e !== null) {
      const l = (Array.isArray(e) ? e : [e]).filter((f) => typeof f == "string").map((f) => f.replace("+", `
`).replace(`

`, `
+`).split(`
`)), c = l.reduce((f, s) => f.concat(...s), []);
      return [l, c];
    }
    return [[], []];
  }, [e]);
  return Ze(() => {
    const u = t?.target ?? fb, l = t?.actInsideInputWithModifier ?? !0;
    if (e !== null) {
      const c = (h) => {
        if (i.current = h.ctrlKey || h.metaKey || h.shiftKey || h.altKey, (!i.current || i.current && !l) && ux(h))
          return !1;
        const m = pb(h.code, d);
        if (a.current.add(h[m]), hb(o, a.current, !1)) {
          const y = h.composedPath?.()?.[0] || h.target, w = y?.nodeName === "BUTTON" || y?.nodeName === "A";
          t.preventDefault !== !1 && (i.current || !w) && h.preventDefault(), r(!0);
        }
      }, f = (h) => {
        const p = pb(h.code, d);
        hb(o, a.current, !0) ? (r(!1), a.current.clear()) : a.current.delete(h[p]), h.key === "Meta" && a.current.clear(), i.current = !1;
      }, s = () => {
        a.current.clear(), r(!1);
      };
      return u?.addEventListener("keydown", c), u?.addEventListener("keyup", f), window.addEventListener("blur", s), window.addEventListener("contextmenu", s), () => {
        u?.removeEventListener("keydown", c), u?.removeEventListener("keyup", f), window.removeEventListener("blur", s), window.removeEventListener("contextmenu", s);
      };
    }
  }, [e, r]), n;
}
function hb(e, t, n) {
  return e.filter((r) => n || r.length === t.size).some((r) => r.every((i) => t.has(i)));
}
function pb(e, t) {
  return t.includes(e) ? "code" : "key";
}
const d6 = () => {
  const e = at();
  return Le(() => ({
    zoomIn: async (t) => {
      const { panZoom: n } = e.getState();
      return n ? n.scaleBy(1.2, t) : !1;
    },
    zoomOut: async (t) => {
      const { panZoom: n } = e.getState();
      return n ? n.scaleBy(1 / 1.2, t) : !1;
    },
    zoomTo: async (t, n) => {
      const { panZoom: r } = e.getState();
      return r ? r.scaleTo(t, n) : !1;
    },
    getZoom: () => e.getState().transform[2],
    setViewport: async (t, n) => {
      const { transform: [r, i, a], panZoom: o } = e.getState();
      return o ? (await o.setViewport({
        x: t.x ?? r,
        y: t.y ?? i,
        zoom: t.zoom ?? a
      }, n), !0) : !1;
    },
    getViewport: () => {
      const [t, n, r] = e.getState().transform;
      return { x: t, y: n, zoom: r };
    },
    setCenter: async (t, n, r) => e.getState().setCenter(t, n, r),
    fitBounds: async (t, n) => {
      const { width: r, height: i, minZoom: a, maxZoom: o, panZoom: d } = e.getState(), u = Gp(t, r, i, a, o, n?.padding ?? 0.1);
      return d ? (await d.setViewport(u, {
        duration: n?.duration,
        ease: n?.ease,
        interpolate: n?.interpolate
      }), !0) : !1;
    },
    screenToFlowPosition: (t, n = {}) => {
      const { transform: r, snapGrid: i, snapToGrid: a, domNode: o } = e.getState();
      if (!o)
        return t;
      const { x: d, y: u } = o.getBoundingClientRect(), l = {
        x: t.x - d,
        y: t.y - u
      }, c = n.snapGrid ?? i, f = n.snapToGrid ?? a;
      return ml(l, r, f, c);
    },
    flowToScreenPosition: (t) => {
      const { transform: n, domNode: r } = e.getState();
      if (!r)
        return t;
      const { x: i, y: a } = r.getBoundingClientRect(), o = $o(t, n);
      return {
        x: o.x + i,
        y: o.y + a
      };
    }
  }), []);
};
function Ex(e, t) {
  const n = [], r = /* @__PURE__ */ new Map(), i = [];
  for (const a of e)
    if (a.type === "add") {
      i.push(a);
      continue;
    } else if (a.type === "remove" || a.type === "replace")
      r.set(a.id, [a]);
    else {
      const o = r.get(a.id);
      o ? o.push(a) : r.set(a.id, [a]);
    }
  for (const a of t) {
    const o = r.get(a.id);
    if (!o) {
      n.push(a);
      continue;
    }
    if (o[0].type === "remove")
      continue;
    if (o[0].type === "replace") {
      n.push({ ...o[0].item });
      continue;
    }
    const d = { ...a };
    for (const u of o)
      f6(u, d);
    n.push(d);
  }
  return i.length && i.forEach((a) => {
    a.index !== void 0 ? n.splice(a.index, 0, { ...a.item }) : n.push({ ...a.item });
  }), n;
}
function f6(e, t) {
  switch (e.type) {
    case "select": {
      t.selected = e.selected;
      break;
    }
    case "position": {
      typeof e.position < "u" && (t.position = e.position), typeof e.dragging < "u" && (t.dragging = e.dragging);
      break;
    }
    case "dimensions": {
      typeof e.dimensions < "u" && (t.measured = {
        ...e.dimensions
      }, e.setAttributes && ((e.setAttributes === !0 || e.setAttributes === "width") && (t.width = e.dimensions.width), (e.setAttributes === !0 || e.setAttributes === "height") && (t.height = e.dimensions.height))), typeof e.resizing == "boolean" && (t.resizing = e.resizing);
      break;
    }
  }
}
function Tx(e, t) {
  return Ex(e, t);
}
function Nx(e, t) {
  return Ex(e, t);
}
function qr(e, t) {
  return {
    id: e,
    type: "select",
    selected: t
  };
}
function bo(e, t = /* @__PURE__ */ new Set(), n = !1) {
  const r = [];
  for (const [i, a] of e) {
    const o = t.has(i);
    !(a.selected === void 0 && !o) && a.selected !== o && (n && (a.selected = o), r.push(qr(a.id, o)));
  }
  return r;
}
function mb({ items: e = [], lookup: t }) {
  const n = [], r = new Map(e.map((i) => [i.id, i]));
  for (const [i, a] of e.entries()) {
    const o = t.get(a.id), d = o?.internals?.userNode ?? o;
    d !== void 0 && d !== a && n.push({ id: a.id, item: a, type: "replace" }), d === void 0 && n.push({ item: a, type: "add", index: i });
  }
  for (const [i] of t)
    r.get(i) === void 0 && n.push({ id: i, type: "remove" });
  return n;
}
function gb(e) {
  return {
    id: e.id,
    type: "remove"
  };
}
const h6 = ax("React Flow", "https://reactflow.dev/");
function p6(e, t, n = {}) {
  return d2(e, t, {
    ...n,
    onError: n.onError ?? h6
  });
}
const yb = (e) => JZ(e), m6 = (e) => tx(e);
function Cx(e) {
  return ol(e);
}
const Dx = typeof window < "u" ? D0 : Ze;
function vb(e) {
  const [t, n] = Ae(BigInt(0)), [r] = Ae(() => g6(() => n((i) => i + BigInt(1))));
  return Dx(() => {
    const i = r.get();
    i.length && (e(i), r.reset());
  }, [t]), r;
}
function g6(e) {
  let t = [];
  return {
    get: () => t,
    reset: () => {
      t = [];
    },
    push: (n) => {
      t.push(n), e();
    }
  };
}
const Ax = Wt(null);
function y6({ children: e }) {
  const t = at(), n = Ye((d) => {
    const { nodes: u = [], setNodes: l, hasDefaultNodes: c, onNodesChange: f, nodeLookup: s, fitViewQueued: h, onNodesChangeMiddlewareMap: p } = t.getState();
    let m = u;
    for (const w of d)
      m = typeof w == "function" ? w(m) : w;
    let y = mb({
      items: m,
      lookup: s
    });
    for (const w of p.values())
      y = w(y);
    c && l(m), y.length > 0 ? f?.(y) : h && window.requestAnimationFrame(() => {
      const { fitViewQueued: w, nodes: b, setNodes: _ } = t.getState();
      w && _(b);
    });
  }, []), r = vb(n), i = Ye((d) => {
    const { edges: u = [], setEdges: l, hasDefaultEdges: c, onEdgesChange: f, edgeLookup: s } = t.getState();
    let h = u;
    for (const p of d)
      h = typeof p == "function" ? p(h) : p;
    c ? l(h) : f && f(mb({
      items: h,
      lookup: s
    }));
  }, []), a = vb(i), o = Le(() => ({ nodeQueue: r, edgeQueue: a }), []);
  return x(Ax.Provider, { value: o, children: e });
}
function v6() {
  const e = st(Ax);
  if (!e)
    throw new Error("useBatchContext must be used within a BatchProvider");
  return e;
}
const b6 = (e) => !!e.panZoom;
function Jo() {
  const e = d6(), t = at(), n = v6(), r = Ve(b6), i = Le(() => {
    const a = (f) => t.getState().nodeLookup.get(f), o = (f) => {
      n.nodeQueue.push(f);
    }, d = (f) => {
      n.edgeQueue.push(f);
    }, u = (f) => {
      const { nodeLookup: s, nodeOrigin: h } = t.getState(), p = yb(f) ? f : s.get(f.id), m = p.parentId ? sx(p.position, p.measured, p.parentId, s, h) : p.position, y = {
        ...p,
        position: m,
        width: p.measured?.width ?? p.width,
        height: p.measured?.height ?? p.height
      };
      return Gs(y);
    }, l = (f, s, h = { replace: !1 }) => {
      o((p) => p.map((m) => {
        if (m.id === f) {
          const y = typeof s == "function" ? s(m) : s;
          return h.replace && yb(y) ? y : { ...m, ...y };
        }
        return m;
      }));
    }, c = (f, s, h = { replace: !1 }) => {
      d((p) => p.map((m) => {
        if (m.id === f) {
          const y = typeof s == "function" ? s(m) : s;
          return h.replace && m6(y) ? y : { ...m, ...y };
        }
        return m;
      }));
    };
    return {
      getNodes: () => t.getState().nodes.map((f) => ({ ...f })),
      getNode: (f) => a(f)?.internals.userNode,
      getInternalNode: a,
      getEdges: () => {
        const { edges: f = [] } = t.getState();
        return f.map((s) => ({ ...s }));
      },
      getEdge: (f) => t.getState().edgeLookup.get(f),
      setNodes: o,
      setEdges: d,
      addNodes: (f) => {
        const s = Array.isArray(f) ? f : [f];
        n.nodeQueue.push((h) => [...h, ...s]);
      },
      addEdges: (f) => {
        const s = Array.isArray(f) ? f : [f];
        n.edgeQueue.push((h) => [...h, ...s]);
      },
      toObject: () => {
        const { nodes: f = [], edges: s = [], transform: h } = t.getState(), [p, m, y] = h;
        return {
          nodes: f.map((w) => ({ ...w })),
          edges: s.map((w) => ({ ...w })),
          viewport: {
            x: p,
            y: m,
            zoom: y
          }
        };
      },
      deleteElements: async ({ nodes: f = [], edges: s = [] }) => {
        const { nodes: h, edges: p, onNodesDelete: m, onEdgesDelete: y, triggerNodeChanges: w, triggerEdgeChanges: b, onDelete: _, onBeforeDelete: g } = t.getState(), { nodes: O, edges: P } = await t2({
          nodesToRemove: f,
          edgesToRemove: s,
          nodes: h,
          edges: p,
          onBeforeDelete: g
        }), E = P.length > 0, T = O.length > 0;
        if (E) {
          const D = P.map(gb);
          y?.(P), b(D);
        }
        if (T) {
          const D = O.map(gb);
          m?.(O), w(D);
        }
        return (T || E) && _?.({ nodes: O, edges: P }), { deletedNodes: O, deletedEdges: P };
      },
      /**
       * Partial is defined as "the 2 nodes/areas are intersecting partially".
       * If a is contained in b or b is contained in a, they are both
       * considered fully intersecting.
       */
      getIntersectingNodes: (f, s = !0, h) => {
        const p = Gv(f), m = p ? f : u(f), y = h !== void 0;
        return m ? (h || t.getState().nodes).filter((w) => {
          const b = t.getState().nodeLookup.get(w.id);
          if (b && !p && (w.id === f.id || !b.internals.positionAbsolute))
            return !1;
          const _ = Gs(y ? w : b), g = Nu(_, m);
          return s && g > 0 || g >= _.width * _.height || g >= m.width * m.height;
        }) : [];
      },
      isNodeIntersecting: (f, s, h = !0) => {
        const m = Gv(f) ? f : u(f);
        if (!m)
          return !1;
        const y = Nu(m, s);
        return h && y > 0 || y >= s.width * s.height || y >= m.width * m.height;
      },
      updateNode: l,
      updateNodeData: (f, s, h = { replace: !1 }) => {
        l(f, (p) => {
          const m = typeof s == "function" ? s(p) : s;
          return h.replace ? { ...p, data: m } : { ...p, data: { ...p.data, ...m } };
        }, h);
      },
      updateEdge: c,
      updateEdgeData: (f, s, h = { replace: !1 }) => {
        c(f, (p) => {
          const m = typeof s == "function" ? s(p) : s;
          return h.replace ? { ...p, data: m } : { ...p, data: { ...p.data, ...m } };
        }, h);
      },
      getNodesBounds: (f) => {
        const { nodeLookup: s, nodeOrigin: h } = t.getState();
        return XZ(f, { nodeLookup: s, nodeOrigin: h });
      },
      getHandleConnections: ({ type: f, id: s, nodeId: h }) => Array.from(t.getState().connectionLookup.get(`${h}-${f}${s ? `-${s}` : ""}`)?.values() ?? []),
      getNodeConnections: ({ type: f, handleId: s, nodeId: h }) => Array.from(t.getState().connectionLookup.get(`${h}${f ? s ? `-${f}-${s}` : `-${f}` : ""}`)?.values() ?? []),
      fitView: async (f) => {
        const s = t.getState().fitViewResolver ?? i2();
        return t.setState({ fitViewQueued: !0, fitViewOptions: f, fitViewResolver: s }), n.nodeQueue.push((h) => [...h]), s.promise;
      }
    };
  }, []);
  return Le(() => ({
    ...i,
    ...e,
    viewportInitialized: r
  }), [r]);
}
const bb = (e) => e.selected, _6 = typeof window < "u" ? window : void 0;
function w6({ deleteKeyCode: e, multiSelectionKeyCode: t }) {
  const n = at(), { deleteElements: r } = Jo(), i = Js(e, { actInsideInputWithModifier: !1 }), a = Js(t, { target: _6 });
  Ze(() => {
    if (i) {
      const { edges: o, nodes: d } = n.getState();
      r({ nodes: d.filter(bb), edges: o.filter(bb) }), n.setState({ nodesSelectionActive: !1 });
    }
  }, [i]), Ze(() => {
    n.setState({ multiSelectionActive: a });
  }, [a]);
}
function k6(e) {
  const t = at();
  Ze(() => {
    const n = () => {
      if (!e.current || !(e.current.checkVisibility?.() ?? !0))
        return !1;
      const r = Jp(e.current);
      (r.height === 0 || r.width === 0) && t.getState().onError?.("004", an.error004()), t.setState({ width: r.width || 500, height: r.height || 500 });
    };
    if (e.current) {
      n(), window.addEventListener("resize", n);
      const r = new ResizeObserver(() => n());
      return r.observe(e.current), () => {
        window.removeEventListener("resize", n), r && e.current && r.unobserve(e.current);
      };
    }
  }, []);
}
const xc = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
}, S6 = (e) => ({
  userSelectionActive: e.userSelectionActive,
  lib: e.lib,
  connectionInProgress: e.connection.inProgress
});
function x6({ onPaneContextMenu: e, zoomOnScroll: t = !0, zoomOnPinch: n = !0, panOnScroll: r = !1, panOnScrollSpeed: i = 0.5, panOnScrollMode: a = Yr.Free, zoomOnDoubleClick: o = !0, panOnDrag: d = !0, defaultViewport: u, translateExtent: l, minZoom: c, maxZoom: f, zoomActivationKeyCode: s, preventScrolling: h = !0, children: p, noWheelClassName: m, noPanClassName: y, onViewportChange: w, isControlledViewport: b, paneClickDistance: _, selectionOnDrag: g }) {
  const O = at(), P = Ce(null), { userSelectionActive: E, lib: T, connectionInProgress: D } = Ve(S6, ct), N = Js(s), M = Ce();
  k6(P);
  const R = Ye((V) => {
    w?.({ x: V[0], y: V[1], zoom: V[2] }), b || O.setState({ transform: V });
  }, [w, b]);
  return Ze(() => {
    if (P.current) {
      M.current = F2({
        domNode: P.current,
        minZoom: c,
        maxZoom: f,
        translateExtent: l,
        viewport: u,
        onDraggingChange: (G) => O.setState((Q) => Q.paneDragging === G ? Q : { paneDragging: G }),
        onPanZoomStart: (G, Q) => {
          const { onViewportChangeStart: k, onMoveStart: I } = O.getState();
          I?.(G, Q), k?.(Q);
        },
        onPanZoom: (G, Q) => {
          const { onViewportChange: k, onMove: I } = O.getState();
          I?.(G, Q), k?.(Q);
        },
        onPanZoomEnd: (G, Q) => {
          const { onViewportChangeEnd: k, onMoveEnd: I } = O.getState();
          I?.(G, Q), k?.(Q);
        }
      });
      const { x: V, y: C, zoom: B } = M.current.getViewport();
      return O.setState({
        panZoom: M.current,
        transform: [V, C, B],
        domNode: P.current.closest(".react-flow")
      }), () => {
        M.current?.destroy();
      };
    }
  }, []), Ze(() => {
    M.current?.update({
      onPaneContextMenu: e,
      zoomOnScroll: t,
      zoomOnPinch: n,
      panOnScroll: r,
      panOnScrollSpeed: i,
      panOnScrollMode: a,
      zoomOnDoubleClick: o,
      panOnDrag: d,
      zoomActivationKeyPressed: N,
      preventScrolling: h,
      noPanClassName: y,
      userSelectionActive: E,
      noWheelClassName: m,
      lib: T,
      onTransformChange: R,
      connectionInProgress: D,
      selectionOnDrag: g,
      paneClickDistance: _
    });
  }, [
    e,
    t,
    n,
    r,
    i,
    a,
    o,
    d,
    N,
    h,
    y,
    E,
    m,
    T,
    R,
    D,
    g,
    _
  ]), x("div", { className: "react-flow__renderer", ref: P, style: xc, children: p });
}
const I6 = (e) => ({
  userSelectionActive: e.userSelectionActive,
  userSelectionRect: e.userSelectionRect
});
function P6() {
  const { userSelectionActive: e, userSelectionRect: t } = Ve(I6, ct);
  return e && t ? x("div", { className: "react-flow__selection react-flow__container", style: {
    width: t.width,
    height: t.height,
    transform: `translate(${t.x}px, ${t.y}px)`
  } }) : null;
}
const Cd = (e, t) => (n) => {
  n.target === t.current && e?.(n);
}, O6 = (e) => ({
  userSelectionActive: e.userSelectionActive,
  elementsSelectable: e.elementsSelectable,
  dragging: e.paneDragging,
  panBy: e.panBy,
  autoPanSpeed: e.autoPanSpeed
});
function z6({ isSelecting: e, selectionKeyPressed: t, selectionMode: n = Hs.Full, panOnDrag: r, autoPanOnSelection: i, paneClickDistance: a, selectionOnDrag: o, onSelectionStart: d, onSelectionEnd: u, onPaneClick: l, onPaneContextMenu: c, onPaneScroll: f, onPaneMouseEnter: s, onPaneMouseMove: h, onPaneMouseLeave: p, children: m }) {
  const y = Ce(0), w = at(), { userSelectionActive: b, elementsSelectable: _, dragging: g, panBy: O, autoPanSpeed: P } = Ve(O6, ct), E = _ && (e || b), T = Ce(null), D = Ce(), N = Ce(/* @__PURE__ */ new Set()), M = Ce(/* @__PURE__ */ new Set()), R = Ce(!1), V = Ce(!1), C = Ce({ x: 0, y: 0 }), B = Ce(!1), G = (U) => {
    if (V.current || R.current || w.getState().connection.inProgress) {
      V.current = !1, R.current = !1;
      return;
    }
    l?.(U), w.getState().resetSelectedElements(), w.setState({ nodesSelectionActive: !1 });
  }, Q = (U) => {
    if (Array.isArray(r) && r?.includes(2)) {
      U.preventDefault();
      return;
    }
    c?.(U);
  }, k = f ? (U) => f(U) : void 0, I = (U) => {
    V.current && (U.stopPropagation(), V.current = !1);
  }, S = (U) => {
    const { domNode: q, transform: ne } = w.getState();
    if (D.current = q?.getBoundingClientRect(), !D.current)
      return;
    const oe = U.target === T.current;
    if (!oe && !!U.target.closest(".nokey") || !e || !(o && oe || t) || U.button !== 0 || !U.isPrimary)
      return;
    U.target?.setPointerCapture?.(U.pointerId), V.current = !1;
    const { x: de, y: ve } = Pn(U.nativeEvent, D.current), se = ml({ x: de, y: ve }, ne);
    w.setState({
      userSelectionRect: {
        width: 0,
        height: 0,
        startX: se.x,
        startY: se.y,
        x: de,
        y: ve
      }
    }), oe || (U.stopPropagation(), U.preventDefault());
  };
  function A(U, q) {
    const { userSelectionRect: ne } = w.getState();
    if (!ne)
      return;
    const { transform: oe, nodeLookup: Y, edgeLookup: re, connectionLookup: de, triggerNodeChanges: ve, triggerEdgeChanges: se, defaultEdgeOptions: pe } = w.getState(), ke = { x: ne.startX, y: ne.startY }, { x: Ne, y: Ke } = $o(ke, oe), X = {
      startX: ke.x,
      startY: ke.y,
      x: U < Ne ? U : Ne,
      y: q < Ke ? q : Ke,
      width: Math.abs(U - Ne),
      height: Math.abs(q - Ke)
    }, ae = N.current, he = M.current;
    N.current = new Set(Hp(Y, X, oe, n === Hs.Partial, !0).map((Ee) => Ee.id)), M.current = /* @__PURE__ */ new Set();
    const me = pe?.selectable ?? !0;
    for (const Ee of N.current) {
      const ie = de.get(Ee);
      if (ie)
        for (const { edgeId: fe } of ie.values()) {
          const be = re.get(fe);
          be && (be.selectable ?? me) && M.current.add(fe);
        }
    }
    if (!Kv(ae, N.current)) {
      const Ee = bo(Y, N.current, !0);
      ve(Ee);
    }
    if (!Kv(he, M.current)) {
      const Ee = bo(re, M.current);
      se(Ee);
    }
    w.setState({
      userSelectionRect: X,
      userSelectionActive: !0,
      nodesSelectionActive: !1
    });
  }
  function j() {
    if (!i || !D.current)
      return;
    const [U, q] = Wp(C.current, D.current, P);
    O({ x: U, y: q }).then((ne) => {
      if (!V.current || !ne) {
        y.current = requestAnimationFrame(j);
        return;
      }
      const { x: oe, y: Y } = C.current;
      A(oe, Y), y.current = requestAnimationFrame(j);
    });
  }
  const z = () => {
    cancelAnimationFrame(y.current), y.current = 0, B.current = !1;
  };
  Ze(() => () => z(), []);
  const L = (U) => {
    const { userSelectionRect: q, transform: ne, resetSelectedElements: oe } = w.getState();
    if (!D.current || !q)
      return;
    const { x: Y, y: re } = Pn(U.nativeEvent, D.current);
    C.current = { x: Y, y: re };
    const de = $o({ x: q.startX, y: q.startY }, ne);
    if (!V.current) {
      const ve = t ? 0 : a;
      if (Math.hypot(Y - de.x, re - de.y) <= ve)
        return;
      oe(), d?.(U);
    }
    V.current = !0, B.current || (j(), B.current = !0), A(Y, re);
  }, F = (U) => {
    if (!E) {
      U.target === T.current && w.getState().connection.inProgress && (R.current = !0);
      return;
    }
    U.button === 0 && (U.target?.releasePointerCapture?.(U.pointerId), !b && U.target === T.current && w.getState().userSelectionRect && G?.(U), w.setState({
      userSelectionActive: !1,
      userSelectionRect: null
    }), V.current && (u?.(U), w.setState({
      nodesSelectionActive: N.current.size > 0
    })), z());
  }, K = (U) => {
    U.target?.releasePointerCapture?.(U.pointerId), z();
  }, ee = r === !0 || Array.isArray(r) && r.includes(0);
  return te("div", { className: kt(["react-flow__pane", { draggable: ee, dragging: g, selection: e }]), onClick: E ? void 0 : Cd(G, T), onContextMenu: Cd(Q, T), onWheel: Cd(k, T), onPointerEnter: E ? void 0 : s, onPointerMove: E ? L : h, onPointerUp: F, onPointerCancel: E ? K : void 0, onPointerDownCapture: E ? S : void 0, onClickCapture: E ? I : void 0, onPointerLeave: p, ref: T, style: xc, children: [m, x(P6, {})] });
}
function xh({ id: e, store: t, unselect: n = !1, nodeRef: r }) {
  const { addSelectedNodes: i, unselectNodesAndEdges: a, multiSelectionActive: o, nodeLookup: d, onError: u } = t.getState(), l = d.get(e);
  if (!l) {
    u?.("012", an.error012(e));
    return;
  }
  t.setState({ nodesSelectionActive: !1 }), l.selected ? (n || l.selected && o) && (a({ nodes: [l], edges: [] }), requestAnimationFrame(() => r?.current?.blur())) : i([e]);
}
function jx({ nodeRef: e, disabled: t = !1, noDragClassName: n, handleSelector: r, nodeId: i, isSelectable: a, nodeClickDistance: o }) {
  const d = at(), [u, l] = Ae(!1), c = Ce();
  return Ze(() => {
    if (!t)
      return c.current = O2({
        getStoreItems: () => d.getState(),
        onNodeMouseDown: (f) => {
          xh({
            id: f,
            store: d,
            nodeRef: e
          });
        },
        onDragStart: () => {
          l(!0);
        },
        onDragStop: () => {
          l(!1);
        }
      }), () => {
        c.current?.destroy(), c.current = void 0;
      };
  }, [t, d, e]), Ze(() => {
    t || !e.current || !c.current || c.current.update({
      noDragClassName: n,
      handleSelector: r,
      domNode: e.current,
      isSelectable: a,
      nodeId: i,
      nodeClickDistance: o
    });
  }, [n, r, t, a, e, i, o]), u;
}
const E6 = (e) => (t) => t.selected && (t.draggable || e && typeof t.draggable > "u");
function Mx() {
  const e = at();
  return Ye((n) => {
    const { nodeExtent: r, snapToGrid: i, snapGrid: a, nodesDraggable: o, onError: d, updateNodePositions: u, nodeLookup: l, nodeOrigin: c } = e.getState(), f = /* @__PURE__ */ new Map(), s = E6(o), h = i ? a[0] : 5, p = i ? a[1] : 5, m = n.direction.x * h * n.factor, y = n.direction.y * p * n.factor;
    for (const [, w] of l) {
      if (!s(w))
        continue;
      let b = {
        x: w.internals.positionAbsolute.x + m,
        y: w.internals.positionAbsolute.y + y
      };
      i && (b = pl(b, a));
      const { position: _, positionAbsolute: g } = nx({
        nodeId: w.id,
        nextPosition: b,
        nodeLookup: l,
        nodeExtent: r,
        nodeOrigin: c,
        onError: d
      });
      w.position = _, w.internals.positionAbsolute = g, f.set(w.id, w);
    }
    u(f);
  }, []);
}
const nm = Wt(null), T6 = nm.Provider;
nm.Consumer;
const $x = () => st(nm), N6 = (e) => ({
  connectOnClick: e.connectOnClick,
  noPanClassName: e.noPanClassName,
  rfId: e.rfId
}), Rx = Wt(null);
function C6({ children: e }) {
  const t = Ve(N6, ct);
  return x(Rx.Provider, { value: t, children: e });
}
function D6() {
  const e = st(Rx);
  if (!e)
    throw new Error("useHandleConfig must be used within a HandleConfigProvider");
  return e;
}
const A6 = {
  connectingFrom: !1,
  connectingTo: !1,
  clickConnecting: !1,
  isPossibleEndHandle: !0,
  connectionInProcess: !1,
  clickConnectionInProcess: !1,
  valid: !1
}, j6 = (e, t, n) => (r) => {
  const { connectionClickStartHandle: i, connectionMode: a, connection: o } = r, { fromHandle: d, toHandle: u, isValid: l } = o;
  if (!d && !i)
    return A6;
  const c = u?.nodeId === e && u?.id === t && u?.type === n;
  return {
    connectingFrom: d?.nodeId === e && d?.id === t && d?.type === n,
    connectingTo: c,
    clickConnecting: i?.nodeId === e && i?.id === t && i?.type === n,
    isPossibleEndHandle: a === jo.Strict ? d?.type !== n : e !== d?.nodeId || t !== d?.id,
    connectionInProcess: !!d,
    clickConnectionInProcess: !!i,
    valid: c && l
  };
};
function M6({ type: e = "source", position: t = Ie.Top, isValidConnection: n, isConnectable: r = !0, isConnectableStart: i = !0, isConnectableEnd: a = !0, id: o, onConnect: d, children: u, className: l, onMouseDown: c, onTouchStart: f, ...s }, h) {
  const p = o || null, m = e === "target", y = at(), w = $x(), { connectOnClick: b, noPanClassName: _, rfId: g } = D6(), { connectingFrom: O, connectingTo: P, clickConnecting: E, isPossibleEndHandle: T, connectionInProcess: D, clickConnectionInProcess: N, valid: M } = Ve(j6(w, p, e), ct);
  w || y.getState().onError?.("010", an.error010());
  const R = (B) => {
    const { defaultEdgeOptions: G, onConnect: Q, hasDefaultEdges: k } = y.getState(), I = {
      ...G,
      ...B
    };
    if (k) {
      const { edges: S, setEdges: A, onError: j } = y.getState();
      A(p6(I, S, { onError: j }));
    }
    Q?.(I), d?.(I);
  }, V = (B) => {
    if (!w)
      return;
    const G = cx(B.nativeEvent);
    if (i && (G && B.button === 0 || !G)) {
      const Q = y.getState();
      Sh.onPointerDown(B.nativeEvent, {
        handleDomNode: B.currentTarget,
        autoPanOnConnect: Q.autoPanOnConnect,
        connectionMode: Q.connectionMode,
        connectionRadius: Q.connectionRadius,
        domNode: Q.domNode,
        nodeLookup: Q.nodeLookup,
        lib: Q.lib,
        isTarget: m,
        handleId: p,
        nodeId: w,
        flowId: Q.rfId,
        panBy: Q.panBy,
        cancelConnection: Q.cancelConnection,
        onConnectStart: Q.onConnectStart,
        onConnectEnd: (...k) => y.getState().onConnectEnd?.(...k),
        updateConnection: Q.updateConnection,
        onConnect: R,
        isValidConnection: n || ((...k) => y.getState().isValidConnection?.(...k) ?? !0),
        getTransform: () => y.getState().transform,
        getFromHandle: () => y.getState().connection.fromHandle,
        autoPanSpeed: Q.autoPanSpeed,
        dragThreshold: Q.connectionDragThreshold
      });
    }
    G ? c?.(B) : f?.(B);
  }, C = (B) => {
    const { onClickConnectStart: G, onClickConnectEnd: Q, connectionClickStartHandle: k, connectionMode: I, isValidConnection: S, lib: A, rfId: j, nodeLookup: z, connection: L } = y.getState();
    if (!w || !k && !i)
      return;
    if (!k) {
      G?.(B.nativeEvent, { nodeId: w, handleId: p, handleType: e }), y.setState({ connectionClickStartHandle: { nodeId: w, type: e, id: p } });
      return;
    }
    const F = lx(B.target), K = n || S, { connection: ee, isValid: U } = Sh.isValid(B.nativeEvent, {
      handle: {
        nodeId: w,
        id: p,
        type: e
      },
      connectionMode: I,
      fromNodeId: k.nodeId,
      fromHandleId: k.id || null,
      fromType: k.type,
      isValidConnection: K,
      flowId: j,
      doc: F,
      lib: A,
      nodeLookup: z
    });
    U && ee && R(ee);
    const q = structuredClone(L);
    delete q.inProgress, q.toPosition = q.toHandle ? q.toHandle.position : null, Q?.(B, q), y.setState({ connectionClickStartHandle: null });
  };
  return x("div", { "data-handleid": p, "data-nodeid": w, "data-handlepos": t, "data-id": `${g}-${w}-${p}-${e}`, className: kt([
    "react-flow__handle",
    `react-flow__handle-${t}`,
    "nodrag",
    _,
    l,
    {
      source: !m,
      target: m,
      connectable: r,
      connectablestart: i,
      connectableend: a,
      clickconnecting: E,
      connectingfrom: O,
      connectingto: P,
      valid: M,
      /*
       * shows where you can start a connection from
       * and where you can end it while connecting
       */
      connectionindicator: r && (!D || T) && (D || N ? a : i)
    }
  ]), onMouseDown: V, onTouchStart: V, onClick: b ? C : void 0, ref: h, ...s, children: u });
}
const Zo = gt(Cx(M6));
function $6({ data: e, isConnectable: t, sourcePosition: n = Ie.Bottom }) {
  return te(Ue, { children: [e?.label, x(Zo, { type: "source", position: n, isConnectable: t })] });
}
function R6({ data: e, isConnectable: t, targetPosition: n = Ie.Top, sourcePosition: r = Ie.Bottom }) {
  return te(Ue, { children: [x(Zo, { type: "target", position: n, isConnectable: t }), e?.label, x(Zo, { type: "source", position: r, isConnectable: t })] });
}
function Z6() {
  return null;
}
function L6({ data: e, isConnectable: t, targetPosition: n = Ie.Top }) {
  return te(Ue, { children: [x(Zo, { type: "target", position: n, isConnectable: t }), e?.label] });
}
const Cu = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 }
}, _b = {
  input: $6,
  default: R6,
  output: L6,
  group: Z6
};
function F6(e) {
  return e.internals.handleBounds === void 0 ? {
    width: e.width ?? e.initialWidth ?? e.style?.width,
    height: e.height ?? e.initialHeight ?? e.style?.height
  } : {
    width: e.width ?? e.style?.width,
    height: e.height ?? e.style?.height
  };
}
const U6 = (e) => {
  const { width: t, height: n, x: r, y: i } = hl(e.nodeLookup, {
    filter: (a) => !!a.selected
  });
  return {
    width: In(t) ? t : null,
    height: In(n) ? n : null,
    userSelectionActive: e.userSelectionActive,
    transformString: `translate(${e.transform[0]}px,${e.transform[1]}px) scale(${e.transform[2]}) translate(${r}px,${i}px)`
  };
};
function B6({ onSelectionContextMenu: e, noPanClassName: t, disableKeyboardA11y: n }) {
  const r = at(), { width: i, height: a, transformString: o, userSelectionActive: d } = Ve(U6, ct), u = Mx(), l = Ce(null);
  Ze(() => {
    n || l.current?.focus({
      preventScroll: !0
    });
  }, [n]);
  const c = !d && i !== null && a !== null;
  if (jx({
    nodeRef: l,
    disabled: !c
  }), !c)
    return null;
  const f = e ? (h) => {
    const p = r.getState().nodes.filter((m) => m.selected);
    e(h, p);
  } : void 0, s = (h) => {
    Object.prototype.hasOwnProperty.call(Cu, h.key) && (h.preventDefault(), u({
      direction: Cu[h.key],
      factor: h.shiftKey ? 4 : 1
    }));
  };
  return x("div", { className: kt(["react-flow__nodesselection", "react-flow__container", t]), style: {
    transform: o
  }, children: x("div", { ref: l, className: "react-flow__nodesselection-rect", onContextMenu: f, tabIndex: n ? void 0 : -1, onKeyDown: n ? void 0 : s, style: {
    width: i,
    height: a
  } }) });
}
const wb = typeof window < "u" ? window : void 0, V6 = (e) => ({ nodesSelectionActive: e.nodesSelectionActive, userSelectionActive: e.userSelectionActive });
function Zx({ children: e, onPaneClick: t, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: i, onPaneContextMenu: a, onPaneScroll: o, paneClickDistance: d, deleteKeyCode: u, selectionKeyCode: l, selectionOnDrag: c, selectionMode: f, onSelectionStart: s, onSelectionEnd: h, multiSelectionKeyCode: p, panActivationKeyCode: m, zoomActivationKeyCode: y, elementsSelectable: w, zoomOnScroll: b, zoomOnPinch: _, panOnScroll: g, panOnScrollSpeed: O, panOnScrollMode: P, zoomOnDoubleClick: E, panOnDrag: T, autoPanOnSelection: D, defaultViewport: N, translateExtent: M, minZoom: R, maxZoom: V, preventScrolling: C, onSelectionContextMenu: B, noWheelClassName: G, noPanClassName: Q, disableKeyboardA11y: k, onViewportChange: I, isControlledViewport: S }) {
  const { nodesSelectionActive: A, userSelectionActive: j } = Ve(V6, ct), z = Js(l, { target: wb }), L = Js(m, { target: wb }), F = L || T, K = L || g, ee = c && F !== !0, U = z || j || ee;
  return w6({ deleteKeyCode: u, multiSelectionKeyCode: p }), x(x6, { onPaneContextMenu: a, elementsSelectable: w, zoomOnScroll: b, zoomOnPinch: _, panOnScroll: K, panOnScrollSpeed: O, panOnScrollMode: P, zoomOnDoubleClick: E, panOnDrag: !z && F, defaultViewport: N, translateExtent: M, minZoom: R, maxZoom: V, zoomActivationKeyCode: y, preventScrolling: C, noWheelClassName: G, noPanClassName: Q, onViewportChange: I, isControlledViewport: S, paneClickDistance: d, selectionOnDrag: ee, children: te(z6, { onSelectionStart: s, onSelectionEnd: h, onPaneClick: t, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: i, onPaneContextMenu: a, onPaneScroll: o, panOnDrag: F, autoPanOnSelection: D, isSelecting: !!U, selectionMode: f, selectionKeyPressed: z, paneClickDistance: d, selectionOnDrag: ee, children: [e, A && x(B6, { onSelectionContextMenu: B, noPanClassName: Q, disableKeyboardA11y: k })] }) });
}
Zx.displayName = "FlowRenderer";
const q6 = gt(Zx), H6 = (e) => (t) => e ? Hp(t.nodeLookup, { x: 0, y: 0, width: t.width, height: t.height }, t.transform, !0).map((n) => n.id) : Array.from(t.nodeLookup.keys());
function W6(e) {
  return Ve(Ye(H6(e), [e]), ct);
}
const G6 = (e) => e.updateNodeInternals;
function K6() {
  const e = Ve(G6), [t] = Ae(() => typeof ResizeObserver > "u" ? null : new ResizeObserver((n) => {
    const r = /* @__PURE__ */ new Map();
    n.forEach((i) => {
      const a = i.target.getAttribute("data-id");
      r.set(a, {
        id: a,
        nodeElement: i.target,
        force: !0
      });
    }), e(r);
  }));
  return Ze(() => () => {
    t?.disconnect();
  }, [t]), t;
}
function J6({ node: e, nodeType: t, hasDimensions: n, resizeObserver: r }) {
  const i = at(), a = Ce(null), o = Ce(null), d = Ce(e.sourcePosition), u = Ce(e.targetPosition), l = Ce(t), c = n && !!e.internals.handleBounds;
  return Ze(() => {
    a.current && !e.hidden && (!c || o.current !== a.current) && (o.current && r?.unobserve(o.current), r?.observe(a.current), o.current = a.current);
  }, [c, e.hidden]), Ze(() => () => {
    o.current && (r?.unobserve(o.current), o.current = null);
  }, []), Ze(() => {
    if (a.current) {
      const f = l.current !== t, s = d.current !== e.sourcePosition, h = u.current !== e.targetPosition;
      (f || s || h) && (l.current = t, d.current = e.sourcePosition, u.current = e.targetPosition, i.getState().updateNodeInternals(/* @__PURE__ */ new Map([[e.id, { id: e.id, nodeElement: a.current, force: !0 }]])));
    }
  }, [e.id, t, e.sourcePosition, e.targetPosition]), a;
}
function X6({ id: e, onClick: t, onMouseEnter: n, onMouseMove: r, onMouseLeave: i, onContextMenu: a, onDoubleClick: o, nodesDraggable: d, elementsSelectable: u, nodesConnectable: l, nodesFocusable: c, resizeObserver: f, noDragClassName: s, noPanClassName: h, disableKeyboardA11y: p, rfId: m, nodeTypes: y, nodeClickDistance: w, onError: b }) {
  const { node: _, internals: g, isParent: O } = Ve((U) => {
    const q = U.nodeLookup.get(e), ne = U.parentLookup.has(e);
    return {
      node: q,
      internals: q.internals,
      isParent: ne
    };
  }, ct);
  let P = _.type || "default", E = y?.[P] || _b[P];
  E === void 0 && (b?.("003", an.error003(P)), P = "default", E = y?.default || _b.default);
  const T = !!(_.draggable || d && typeof _.draggable > "u"), D = !!(_.selectable || u && typeof _.selectable > "u"), N = !!(_.connectable || l && typeof _.connectable > "u"), M = !!(_.focusable || c && typeof _.focusable > "u"), R = at(), V = Kp(_), C = J6({ node: _, nodeType: P, hasDimensions: V, resizeObserver: f }), B = jx({
    nodeRef: C,
    disabled: _.hidden || !T,
    noDragClassName: s,
    handleSelector: _.dragHandle,
    nodeId: e,
    isSelectable: D,
    nodeClickDistance: w
  }), G = Mx();
  if (_.hidden)
    return null;
  const Q = Gn(_), k = F6(_), I = D || T || t || n || r || i, S = n ? (U) => n(U, { ...g.userNode }) : void 0, A = r ? (U) => r(U, { ...g.userNode }) : void 0, j = i ? (U) => i(U, { ...g.userNode }) : void 0, z = a ? (U) => a(U, { ...g.userNode }) : void 0, L = o ? (U) => o(U, { ...g.userNode }) : void 0, F = (U) => {
    const { selectNodesOnDrag: q, nodeDragThreshold: ne } = R.getState();
    D && (!q || !T || ne > 0) && xh({
      id: e,
      store: R,
      nodeRef: C
    }), t && t(U, { ...g.userNode });
  }, K = (U) => {
    if (!(ux(U.nativeEvent) || p)) {
      if (XS.includes(U.key) && D) {
        const q = U.key === "Escape";
        xh({
          id: e,
          store: R,
          unselect: q,
          nodeRef: C
        });
      } else if (T && _.selected && Object.prototype.hasOwnProperty.call(Cu, U.key)) {
        U.preventDefault();
        const { ariaLabelConfig: q } = R.getState();
        R.setState({
          ariaLiveMessage: q["node.a11yDescription.ariaLiveMessage"]({
            direction: U.key.replace("Arrow", "").toLowerCase(),
            x: ~~g.positionAbsolute.x,
            y: ~~g.positionAbsolute.y
          })
        }), G({
          direction: Cu[U.key],
          factor: U.shiftKey ? 4 : 1
        });
      }
    }
  }, ee = () => {
    if (p || !C.current?.matches(":focus-visible"))
      return;
    const { transform: U, width: q, height: ne, autoPanOnNodeFocus: oe, setCenter: Y } = R.getState();
    if (!oe)
      return;
    Hp(/* @__PURE__ */ new Map([[e, _]]), { x: 0, y: 0, width: q, height: ne }, U, !0).length > 0 || Y(_.position.x + Q.width / 2, _.position.y + Q.height / 2, {
      zoom: U[2]
    });
  };
  return x("div", { className: kt([
    "react-flow__node",
    `react-flow__node-${P}`,
    {
      // this is overwritable by passing `nopan` as a class name
      [h]: T
    },
    _.className,
    {
      selected: _.selected,
      selectable: D,
      parent: O,
      draggable: T,
      dragging: B
    }
  ]), ref: C, style: {
    zIndex: g.z,
    transform: `translate(${g.positionAbsolute.x}px,${g.positionAbsolute.y}px)`,
    pointerEvents: I ? "all" : "none",
    visibility: V ? "visible" : "hidden",
    ..._.style,
    ...k
  }, "data-id": e, "data-testid": `rf__node-${e}`, onMouseEnter: S, onMouseMove: A, onMouseLeave: j, onContextMenu: z, onClick: F, onDoubleClick: L, onKeyDown: M ? K : void 0, tabIndex: M ? 0 : void 0, onFocus: M ? ee : void 0, role: _.ariaRole ?? (M ? "group" : void 0), "aria-roledescription": "node", "aria-describedby": p ? void 0 : `${Px}-${m}`, "aria-label": _.ariaLabel, ..._.domAttributes, children: x(T6, { value: e, children: x(E, { id: e, data: _.data, type: P, positionAbsoluteX: g.positionAbsolute.x, positionAbsoluteY: g.positionAbsolute.y, selected: _.selected ?? !1, selectable: D, draggable: T, deletable: _.deletable ?? !0, isConnectable: N, sourcePosition: _.sourcePosition, targetPosition: _.targetPosition, dragging: B, dragHandle: _.dragHandle, zIndex: g.z, parentId: _.parentId, ...Q }) }) });
}
var Y6 = gt(X6);
const Q6 = (e) => ({
  nodesConnectable: e.nodesConnectable,
  nodesFocusable: e.nodesFocusable,
  elementsSelectable: e.elementsSelectable,
  onError: e.onError
});
function Lx(e) {
  const { nodesConnectable: t, nodesFocusable: n, elementsSelectable: r, onError: i } = Ve(Q6, ct), a = W6(e.onlyRenderVisibleElements), o = K6();
  return x("div", { className: "react-flow__nodes", style: xc, children: a.map((d) => (
    /*
     * The split of responsibilities between NodeRenderer and
     * NodeComponentWrapper may appear weird. However, it’s designed to
     * minimize the cost of updates when individual nodes change.
     *
     * For example, when you’re dragging a single node, that node gets
     * updated multiple times per second. If `NodeRenderer` were to update
     * every time, it would have to re-run the `nodes.map()` loop every
     * time. This gets pricey with hundreds of nodes, especially if every
     * loop cycle does more than just rendering a JSX element!
     *
     * As a result of this choice, we took the following implementation
     * decisions:
     * - NodeRenderer subscribes *only* to node IDs – and therefore
     *   rerender *only* when visible nodes are added or removed.
     * - NodeRenderer performs all operations the result of which can be
     *   shared between nodes (such as creating the `ResizeObserver`
     *   instance, or subscribing to `selector`). This means extra prop
     *   drilling into `NodeComponentWrapper`, but it means we need to run
     *   these operations only once – instead of once per node.
     * - Any operations that you’d normally write inside `nodes.map` are
     *   moved into `NodeComponentWrapper`. This ensures they are
     *   memorized – so if `NodeRenderer` *has* to rerender, it only
     *   needs to regenerate the list of nodes, nothing else.
     */
    x(Y6, { id: d, nodeTypes: e.nodeTypes, nodeExtent: e.nodeExtent, onClick: e.onNodeClick, onMouseEnter: e.onNodeMouseEnter, onMouseMove: e.onNodeMouseMove, onMouseLeave: e.onNodeMouseLeave, onContextMenu: e.onNodeContextMenu, onDoubleClick: e.onNodeDoubleClick, noDragClassName: e.noDragClassName, noPanClassName: e.noPanClassName, rfId: e.rfId, disableKeyboardA11y: e.disableKeyboardA11y, resizeObserver: o, nodesDraggable: e.nodesDraggable ?? !0, nodesConnectable: t, nodesFocusable: n, elementsSelectable: r, nodeClickDistance: e.nodeClickDistance, onError: i }, d)
  )) });
}
Lx.displayName = "NodeRenderer";
const eL = gt(Lx);
function tL(e) {
  return Ve(Ye((n) => {
    if (!e)
      return n.edges.map((i) => i.id);
    const r = [];
    if (n.width && n.height)
      for (const i of n.edges) {
        const a = n.nodeLookup.get(i.source), o = n.nodeLookup.get(i.target);
        a && o && l2({
          sourceNode: a,
          targetNode: o,
          width: n.width,
          height: n.height,
          transform: n.transform
        }) && r.push(i.id);
      }
    return r;
  }, [e]), ct);
}
const nL = ({ color: e = "none", strokeWidth: t = 1 }) => {
  const n = {
    strokeWidth: t,
    ...e && { stroke: e }
  };
  return x("polyline", { className: "arrow", style: n, strokeLinecap: "round", fill: "none", strokeLinejoin: "round", points: "-5,-4 0,0 -5,4" });
}, rL = ({ color: e = "none", strokeWidth: t = 1 }) => {
  const n = {
    strokeWidth: t,
    ...e && { stroke: e, fill: e }
  };
  return x("polyline", { className: "arrowclosed", style: n, strokeLinecap: "round", strokeLinejoin: "round", points: "-5,-4 0,0 -5,4 -5,-4" });
}, kb = {
  [Ws.Arrow]: nL,
  [Ws.ArrowClosed]: rL
};
function iL(e) {
  const t = at();
  return Le(() => Object.prototype.hasOwnProperty.call(kb, e) ? kb[e] : (t.getState().onError?.("009", an.error009(e)), null), [e]);
}
const oL = ({ id: e, type: t, color: n, width: r = 12.5, height: i = 12.5, markerUnits: a = "strokeWidth", strokeWidth: o, orient: d = "auto-start-reverse" }) => {
  const u = iL(t);
  return u ? x("marker", { className: "react-flow__arrowhead", id: e, markerWidth: `${r}`, markerHeight: `${i}`, viewBox: "-10 -10 20 20", markerUnits: a, orient: d, refX: "0", refY: "0", children: x(u, { color: n, strokeWidth: o }) }) : null;
}, Fx = ({ defaultColor: e, rfId: t }) => {
  const n = Ve((a) => a.edges), r = Ve((a) => a.defaultEdgeOptions), i = Le(() => g2(n, {
    id: t,
    defaultColor: e,
    defaultMarkerStart: r?.markerStart,
    defaultMarkerEnd: r?.markerEnd
  }), [n, r, t, e]);
  return i.length ? x("svg", { className: "react-flow__marker", "aria-hidden": "true", children: x("defs", { children: i.map((a) => x(oL, { id: a.id, type: a.type, color: a.color, width: a.width, height: a.height, markerUnits: a.markerUnits, strokeWidth: a.strokeWidth, orient: a.orient }, a.id)) }) }) : null;
};
Fx.displayName = "MarkerDefinitions";
var aL = gt(Fx);
function Ux({ x: e, y: t, label: n, labelStyle: r, labelShowBg: i = !0, labelBgStyle: a, labelBgPadding: o = [2, 4], labelBgBorderRadius: d = 2, children: u, className: l, ...c }) {
  const [f, s] = Ae({ x: 1, y: 0, width: 0, height: 0 }), h = kt(["react-flow__edge-textwrapper", l]), p = Ce(null);
  return Ze(() => {
    if (p.current) {
      const m = p.current.getBBox();
      s({
        x: m.x,
        y: m.y,
        width: m.width,
        height: m.height
      });
    }
  }, [n]), n ? te("g", { transform: `translate(${e - f.width / 2} ${t - f.height / 2})`, className: h, visibility: f.width ? "visible" : "hidden", ...c, children: [i && x("rect", { width: f.width + 2 * o[0], x: -o[0], y: -o[1], height: f.height + 2 * o[1], className: "react-flow__edge-textbg", style: a, rx: d, ry: d }), x("text", { className: "react-flow__edge-text", y: f.height / 2, dy: "0.3em", ref: p, style: r, children: n }), u] }) : null;
}
Ux.displayName = "EdgeText";
const sL = gt(Ux);
function Lo({ path: e, labelX: t, labelY: n, label: r, labelStyle: i, labelShowBg: a, labelBgStyle: o, labelBgPadding: d, labelBgBorderRadius: u, interactionWidth: l = 20, ...c }) {
  return te(Ue, { children: [x("path", { ...c, d: e, fill: "none", className: kt(["react-flow__edge-path", c.className]) }), l ? x("path", { d: e, fill: "none", strokeOpacity: 0, strokeWidth: l, className: "react-flow__edge-interaction" }) : null, r && In(t) && In(n) ? x(sL, { x: t, y: n, label: r, labelStyle: i, labelShowBg: a, labelBgStyle: o, labelBgPadding: d, labelBgBorderRadius: u }) : null] });
}
function Sb({ pos: e, x1: t, y1: n, x2: r, y2: i }) {
  return e === Ie.Left || e === Ie.Right ? [0.5 * (t + r), n] : [t, 0.5 * (n + i)];
}
function Bx({ sourceX: e, sourceY: t, sourcePosition: n = Ie.Bottom, targetX: r, targetY: i, targetPosition: a = Ie.Top }) {
  const [o, d] = Sb({
    pos: n,
    x1: e,
    y1: t,
    x2: r,
    y2: i
  }), [u, l] = Sb({
    pos: a,
    x1: r,
    y1: i,
    x2: e,
    y2: t
  }), [c, f, s, h] = dx({
    sourceX: e,
    sourceY: t,
    targetX: r,
    targetY: i,
    sourceControlX: o,
    sourceControlY: d,
    targetControlX: u,
    targetControlY: l
  });
  return [
    `M${e},${t} C${o},${d} ${u},${l} ${r},${i}`,
    c,
    f,
    s,
    h
  ];
}
function Vx(e) {
  return gt(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: a, sourcePosition: o, targetPosition: d, label: u, labelStyle: l, labelShowBg: c, labelBgStyle: f, labelBgPadding: s, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: y, interactionWidth: w }) => {
    const [b, _, g] = Bx({
      sourceX: n,
      sourceY: r,
      sourcePosition: o,
      targetX: i,
      targetY: a,
      targetPosition: d
    }), O = e.isInternal ? void 0 : t;
    return x(Lo, { id: O, path: b, labelX: _, labelY: g, label: u, labelStyle: l, labelShowBg: c, labelBgStyle: f, labelBgPadding: s, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: y, interactionWidth: w });
  });
}
const lL = Vx({ isInternal: !1 }), qx = Vx({ isInternal: !0 });
lL.displayName = "SimpleBezierEdge";
qx.displayName = "SimpleBezierEdgeInternal";
function Hx(e) {
  return gt(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: a, label: o, labelStyle: d, labelShowBg: u, labelBgStyle: l, labelBgPadding: c, labelBgBorderRadius: f, style: s, sourcePosition: h = Ie.Bottom, targetPosition: p = Ie.Top, markerEnd: m, markerStart: y, pathOptions: w, interactionWidth: b }) => {
    const [_, g, O] = _h({
      sourceX: n,
      sourceY: r,
      sourcePosition: h,
      targetX: i,
      targetY: a,
      targetPosition: p,
      borderRadius: w?.borderRadius,
      offset: w?.offset,
      stepPosition: w?.stepPosition
    }), P = e.isInternal ? void 0 : t;
    return x(Lo, { id: P, path: _, labelX: g, labelY: O, label: o, labelStyle: d, labelShowBg: u, labelBgStyle: l, labelBgPadding: c, labelBgBorderRadius: f, style: s, markerEnd: m, markerStart: y, interactionWidth: b });
  });
}
const Wx = Hx({ isInternal: !1 }), Gx = Hx({ isInternal: !0 });
Wx.displayName = "SmoothStepEdge";
Gx.displayName = "SmoothStepEdgeInternal";
function Kx(e) {
  return gt(({ id: t, ...n }) => {
    const r = e.isInternal ? void 0 : t;
    return x(Wx, { ...n, id: r, pathOptions: Le(() => ({ borderRadius: 0, offset: n.pathOptions?.offset }), [n.pathOptions?.offset]) });
  });
}
const uL = Kx({ isInternal: !1 }), Jx = Kx({ isInternal: !0 });
uL.displayName = "StepEdge";
Jx.displayName = "StepEdgeInternal";
function Xx(e) {
  return gt(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: a, label: o, labelStyle: d, labelShowBg: u, labelBgStyle: l, labelBgPadding: c, labelBgBorderRadius: f, style: s, markerEnd: h, markerStart: p, interactionWidth: m }) => {
    const [y, w, b] = hx({ sourceX: n, sourceY: r, targetX: i, targetY: a }), _ = e.isInternal ? void 0 : t;
    return x(Lo, { id: _, path: y, labelX: w, labelY: b, label: o, labelStyle: d, labelShowBg: u, labelBgStyle: l, labelBgPadding: c, labelBgBorderRadius: f, style: s, markerEnd: h, markerStart: p, interactionWidth: m });
  });
}
const cL = Xx({ isInternal: !1 }), Yx = Xx({ isInternal: !0 });
cL.displayName = "StraightEdge";
Yx.displayName = "StraightEdgeInternal";
function Qx(e) {
  return gt(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: a, sourcePosition: o = Ie.Bottom, targetPosition: d = Ie.Top, label: u, labelStyle: l, labelShowBg: c, labelBgStyle: f, labelBgPadding: s, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: y, pathOptions: w, interactionWidth: b }) => {
    const [_, g, O] = _c({
      sourceX: n,
      sourceY: r,
      sourcePosition: o,
      targetX: i,
      targetY: a,
      targetPosition: d,
      curvature: w?.curvature
    }), P = e.isInternal ? void 0 : t;
    return x(Lo, { id: P, path: _, labelX: g, labelY: O, label: u, labelStyle: l, labelShowBg: c, labelBgStyle: f, labelBgPadding: s, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: y, interactionWidth: b });
  });
}
const dL = Qx({ isInternal: !1 }), eI = Qx({ isInternal: !0 });
dL.displayName = "BezierEdge";
eI.displayName = "BezierEdgeInternal";
const xb = {
  default: eI,
  straight: Yx,
  step: Jx,
  smoothstep: Gx,
  simplebezier: qx
}, Ib = {
  sourceX: null,
  sourceY: null,
  targetX: null,
  targetY: null,
  sourcePosition: null,
  targetPosition: null,
  zIndex: void 0
}, fL = (e, t, n) => n === Ie.Left ? e - t : n === Ie.Right ? e + t : e, hL = (e, t, n) => n === Ie.Top ? e - t : n === Ie.Bottom ? e + t : e, Pb = "react-flow__edgeupdater";
function Ob({ position: e, centerX: t, centerY: n, radius: r = 10, onMouseDown: i, onMouseEnter: a, onMouseOut: o, type: d }) {
  return x("circle", { onMouseDown: i, onMouseEnter: a, onMouseOut: o, className: kt([Pb, `${Pb}-${d}`]), cx: fL(t, r, e), cy: hL(n, r, e), r, stroke: "transparent", fill: "transparent" });
}
function pL({ isReconnectable: e, reconnectRadius: t, edge: n, sourceX: r, sourceY: i, targetX: a, targetY: o, sourcePosition: d, targetPosition: u, onReconnect: l, onReconnectStart: c, onReconnectEnd: f, setReconnecting: s, setUpdateHover: h }) {
  const p = at(), m = (g, O) => {
    if (g.button !== 0)
      return;
    const { autoPanOnConnect: P, domNode: E, connectionMode: T, connectionRadius: D, lib: N, onConnectStart: M, cancelConnection: R, nodeLookup: V, rfId: C, panBy: B, updateConnection: G } = p.getState(), Q = O.type === "target", k = (A, j) => {
      s(!1), f?.(A, n, O.type, j);
    }, I = (A) => l?.(n, A), S = (A, j) => {
      s(!0), c?.(g, n, O.type), M?.(A, j);
    };
    Sh.onPointerDown(g.nativeEvent, {
      autoPanOnConnect: P,
      connectionMode: T,
      connectionRadius: D,
      domNode: E,
      handleId: O.id,
      nodeId: O.nodeId,
      nodeLookup: V,
      isTarget: Q,
      edgeUpdaterType: O.type,
      lib: N,
      flowId: C,
      cancelConnection: R,
      panBy: B,
      isValidConnection: (...A) => p.getState().isValidConnection?.(...A) ?? !0,
      onConnect: I,
      onConnectStart: S,
      onConnectEnd: (...A) => p.getState().onConnectEnd?.(...A),
      onReconnectEnd: k,
      updateConnection: G,
      getTransform: () => p.getState().transform,
      getFromHandle: () => p.getState().connection.fromHandle,
      dragThreshold: p.getState().connectionDragThreshold,
      handleDomNode: g.currentTarget
    });
  }, y = (g) => m(g, { nodeId: n.target, id: n.targetHandle ?? null, type: "target" }), w = (g) => m(g, { nodeId: n.source, id: n.sourceHandle ?? null, type: "source" }), b = () => h(!0), _ = () => h(!1);
  return te(Ue, { children: [(e === !0 || e === "source") && x(Ob, { position: d, centerX: r, centerY: i, radius: t, onMouseDown: y, onMouseEnter: b, onMouseOut: _, type: "source" }), (e === !0 || e === "target") && x(Ob, { position: u, centerX: a, centerY: o, radius: t, onMouseDown: w, onMouseEnter: b, onMouseOut: _, type: "target" })] });
}
function mL({ id: e, edgesFocusable: t, edgesReconnectable: n, elementsSelectable: r, onClick: i, onDoubleClick: a, onContextMenu: o, onMouseEnter: d, onMouseMove: u, onMouseLeave: l, reconnectRadius: c, onReconnect: f, onReconnectStart: s, onReconnectEnd: h, rfId: p, edgeTypes: m, noPanClassName: y, onError: w, disableKeyboardA11y: b }) {
  let _ = Ve((Y) => Y.edgeLookup.get(e));
  const g = Ve((Y) => Y.defaultEdgeOptions);
  _ = g ? { ...g, ..._ } : _;
  let O = _.type || "default", P = m?.[O] || xb[O];
  P === void 0 && (w?.("011", an.error011(O)), O = "default", P = m?.default || xb.default);
  const E = !!(_.focusable || t && typeof _.focusable > "u"), T = typeof f < "u" && (_.reconnectable || n && typeof _.reconnectable > "u"), D = !!(_.selectable || r && typeof _.selectable > "u"), N = Ce(null), [M, R] = Ae(!1), [V, C] = Ae(!1), B = at(), { zIndex: G = _.zIndex, sourceX: Q, sourceY: k, targetX: I, targetY: S, sourcePosition: A, targetPosition: j } = Ve(Ye((Y) => {
    const re = Y.nodeLookup.get(_.source), de = Y.nodeLookup.get(_.target);
    if (!re || !de)
      return Ib;
    const ve = m2({
      id: e,
      sourceNode: re,
      targetNode: de,
      sourceHandle: _.sourceHandle || null,
      targetHandle: _.targetHandle || null,
      connectionMode: Y.connectionMode,
      onError: w
    }), se = s2({
      selected: _.selected,
      zIndex: _.zIndex,
      sourceNode: re,
      targetNode: de,
      elevateOnSelect: Y.elevateEdgesOnSelect,
      zIndexMode: Y.zIndexMode
    });
    return {
      ...ve || Ib,
      zIndex: se
    };
  }, [_.source, _.target, _.sourceHandle, _.targetHandle, _.selected, _.zIndex]), ct), z = Le(() => _.markerStart ? `url('#${wh(_.markerStart, p)}')` : void 0, [_.markerStart, p]), L = Le(() => _.markerEnd ? `url('#${wh(_.markerEnd, p)}')` : void 0, [_.markerEnd, p]);
  if (_.hidden || Q === null || k === null || I === null || S === null)
    return null;
  const F = (Y) => {
    const { addSelectedEdges: re, unselectNodesAndEdges: de, multiSelectionActive: ve } = B.getState();
    D && (B.setState({ nodesSelectionActive: !1 }), _.selected && ve ? (de({ nodes: [], edges: [_] }), N.current?.blur()) : re([e])), i && i(Y, _);
  }, K = a ? (Y) => {
    a(Y, { ..._ });
  } : void 0, ee = o ? (Y) => {
    o(Y, { ..._ });
  } : void 0, U = d ? (Y) => {
    d(Y, { ..._ });
  } : void 0, q = u ? (Y) => {
    u(Y, { ..._ });
  } : void 0, ne = l ? (Y) => {
    l(Y, { ..._ });
  } : void 0, oe = (Y) => {
    if (!b && XS.includes(Y.key) && D) {
      const { unselectNodesAndEdges: re, addSelectedEdges: de } = B.getState();
      Y.key === "Escape" ? (N.current?.blur(), re({ edges: [_] })) : de([e]);
    }
  };
  return x("svg", { style: { zIndex: G }, children: te("g", { className: kt([
    "react-flow__edge",
    `react-flow__edge-${O}`,
    _.className,
    y,
    {
      selected: _.selected,
      animated: _.animated,
      inactive: !D && !i,
      updating: M,
      selectable: D
    }
  ]), onClick: F, onDoubleClick: K, onContextMenu: ee, onMouseEnter: U, onMouseMove: q, onMouseLeave: ne, onKeyDown: E ? oe : void 0, tabIndex: E ? 0 : void 0, role: _.ariaRole ?? (E ? "group" : "img"), "aria-roledescription": "edge", "data-id": e, "data-testid": `rf__edge-${e}`, "aria-label": _.ariaLabel === null ? void 0 : _.ariaLabel || `Edge from ${_.source} to ${_.target}`, "aria-describedby": E ? `${Ox}-${p}` : void 0, ref: N, ..._.domAttributes, children: [!V && x(P, { id: e, source: _.source, target: _.target, type: _.type, selected: _.selected, animated: _.animated, selectable: D, deletable: _.deletable ?? !0, label: _.label, labelStyle: _.labelStyle, labelShowBg: _.labelShowBg, labelBgStyle: _.labelBgStyle, labelBgPadding: _.labelBgPadding, labelBgBorderRadius: _.labelBgBorderRadius, sourceX: Q, sourceY: k, targetX: I, targetY: S, sourcePosition: A, targetPosition: j, data: _.data, style: _.style, sourceHandleId: _.sourceHandle, targetHandleId: _.targetHandle, markerStart: z, markerEnd: L, pathOptions: "pathOptions" in _ ? _.pathOptions : void 0, interactionWidth: _.interactionWidth }), T && x(pL, { edge: _, isReconnectable: T, reconnectRadius: c, onReconnect: f, onReconnectStart: s, onReconnectEnd: h, sourceX: Q, sourceY: k, targetX: I, targetY: S, sourcePosition: A, targetPosition: j, setUpdateHover: R, setReconnecting: C })] }) });
}
var gL = gt(mL);
const yL = (e) => ({
  edgesFocusable: e.edgesFocusable,
  edgesReconnectable: e.edgesReconnectable,
  elementsSelectable: e.elementsSelectable,
  connectionMode: e.connectionMode,
  onError: e.onError
});
function tI({ defaultMarkerColor: e, onlyRenderVisibleElements: t, rfId: n, edgeTypes: r, noPanClassName: i, onReconnect: a, onEdgeContextMenu: o, onEdgeMouseEnter: d, onEdgeMouseMove: u, onEdgeMouseLeave: l, onEdgeClick: c, reconnectRadius: f, onEdgeDoubleClick: s, onReconnectStart: h, onReconnectEnd: p, disableKeyboardA11y: m }) {
  const { edgesFocusable: y, edgesReconnectable: w, elementsSelectable: b, onError: _ } = Ve(yL, ct), g = tL(t);
  return te("div", { className: "react-flow__edges", children: [x(aL, { defaultColor: e, rfId: n }), g.map((O) => x(gL, { id: O, edgesFocusable: y, edgesReconnectable: w, elementsSelectable: b, noPanClassName: i, onReconnect: a, onContextMenu: o, onMouseEnter: d, onMouseMove: u, onMouseLeave: l, onClick: c, reconnectRadius: f, onDoubleClick: s, onReconnectStart: h, onReconnectEnd: p, rfId: n, onError: _, edgeTypes: r, disableKeyboardA11y: m }, O))] });
}
tI.displayName = "EdgeRenderer";
const vL = gt(tI), zb = (e) => `translate(${e[0]}px,${e[1]}px) scale(${e[2]})`;
function bL({ children: e }) {
  const t = at(), n = Ce(null), [r] = Ae(() => t.getState().transform);
  return Dx(() => {
    let i = null;
    const a = () => {
      const o = t.getState().transform;
      i && o[0] === i[0] && o[1] === i[1] && o[2] === i[2] || (i = o, n.current && (n.current.style.transform = zb(o)));
    };
    return a(), t.subscribe(a);
  }, [t]), x("div", { ref: n, className: "react-flow__viewport xyflow__viewport react-flow__container", style: { transform: zb(r) }, children: e });
}
function _L(e) {
  const t = Jo(), n = Ce(!1);
  Ze(() => {
    !n.current && t.viewportInitialized && e && (setTimeout(() => e(t), 1), n.current = !0);
  }, [e, t.viewportInitialized]);
}
const wL = (e) => e.panZoom?.syncViewport;
function kL(e) {
  const t = Ve(wL), n = at();
  return Ze(() => {
    e && (t?.(e), n.setState({ transform: [e.x, e.y, e.zoom] }));
  }, [e, t]), null;
}
function Eb(e) {
  return e.connection.inProgress ? { ...e.connection, to: ml(e.connection.to, e.transform) } : { ...e.connection };
}
function SL(e) {
  return e ? (n) => {
    const r = Eb(n);
    return e(r);
  } : Eb;
}
function nI(e) {
  const t = SL(e);
  return Ve(t, ct);
}
const xL = (e) => ({
  nodesConnectable: e.nodesConnectable,
  isValid: e.connection.isValid,
  inProgress: e.connection.inProgress,
  width: e.width,
  height: e.height
});
function IL({ containerStyle: e, style: t, type: n, component: r }) {
  const { nodesConnectable: i, width: a, height: o, isValid: d, inProgress: u } = Ve(xL, ct);
  return !(a && i && u) ? null : x("svg", { style: e, width: a, height: o, className: "react-flow__connectionline react-flow__container", children: x("g", { className: kt(["react-flow__connection", ex(d)]), children: x(rI, { style: t, type: n, CustomComponent: r, isValid: d }) }) });
}
const rI = ({ style: e, type: t = wr.Bezier, CustomComponent: n, isValid: r }) => {
  const { inProgress: i, from: a, fromNode: o, fromHandle: d, fromPosition: u, to: l, toNode: c, toHandle: f, toPosition: s, pointer: h } = nI();
  if (!i)
    return;
  if (n)
    return x(n, { connectionLineType: t, connectionLineStyle: e, fromNode: o, fromHandle: d, fromX: a.x, fromY: a.y, toX: l.x, toY: l.y, fromPosition: u, toPosition: s, connectionStatus: ex(r), toNode: c, toHandle: f, pointer: h });
  let p = "";
  const m = {
    sourceX: a.x,
    sourceY: a.y,
    sourcePosition: u,
    targetX: l.x,
    targetY: l.y,
    targetPosition: s
  };
  switch (t) {
    case wr.Bezier:
      [p] = _c(m);
      break;
    case wr.SimpleBezier:
      [p] = Bx(m);
      break;
    case wr.Step:
      [p] = _h({
        ...m,
        borderRadius: 0
      });
      break;
    case wr.SmoothStep:
      [p] = _h(m);
      break;
    default:
      [p] = hx(m);
  }
  return x("path", { d: p, fill: "none", className: "react-flow__connection-path", style: e });
};
rI.displayName = "ConnectionLine";
const PL = {};
function Tb(e = PL) {
  const t = Ce(e), n = at();
  Ze(() => {
    if (process.env.NODE_ENV === "development") {
      const r = /* @__PURE__ */ new Set([...Object.keys(t.current), ...Object.keys(e)]);
      for (const i of r)
        if (t.current[i] !== e[i]) {
          n.getState().onError?.("002", an.error002());
          break;
        }
      t.current = e;
    }
  }, [e]);
}
function OL() {
  const e = at(), t = Ce(!1);
  Ze(() => {
    if (process.env.NODE_ENV === "development" && !t.current) {
      const n = document.querySelector(".react-flow__pane");
      n && window.getComputedStyle(n).zIndex !== "1" && e.getState().onError?.("013", an.error013("react")), t.current = !0;
    }
  }, []);
}
function iI({ nodeTypes: e, edgeTypes: t, onInit: n, onNodeClick: r, onEdgeClick: i, onNodeDoubleClick: a, onEdgeDoubleClick: o, onNodeMouseEnter: d, onNodeMouseMove: u, onNodeMouseLeave: l, onNodeContextMenu: c, onSelectionContextMenu: f, onSelectionStart: s, onSelectionEnd: h, connectionLineType: p, connectionLineStyle: m, connectionLineComponent: y, connectionLineContainerStyle: w, selectionKeyCode: b, selectionOnDrag: _, selectionMode: g, multiSelectionKeyCode: O, panActivationKeyCode: P, zoomActivationKeyCode: E, deleteKeyCode: T, onlyRenderVisibleElements: D, elementsSelectable: N, defaultViewport: M, translateExtent: R, minZoom: V, maxZoom: C, preventScrolling: B, defaultMarkerColor: G, zoomOnScroll: Q, zoomOnPinch: k, panOnScroll: I, panOnScrollSpeed: S, panOnScrollMode: A, zoomOnDoubleClick: j, panOnDrag: z, autoPanOnSelection: L, onPaneClick: F, onPaneMouseEnter: K, onPaneMouseMove: ee, onPaneMouseLeave: U, onPaneScroll: q, onPaneContextMenu: ne, paneClickDistance: oe, nodeClickDistance: Y, onEdgeContextMenu: re, onEdgeMouseEnter: de, onEdgeMouseMove: ve, onEdgeMouseLeave: se, reconnectRadius: pe, onReconnect: ke, onReconnectStart: Ne, onReconnectEnd: Ke, noDragClassName: X, noWheelClassName: ae, noPanClassName: he, disableKeyboardA11y: me, nodeExtent: Ee, rfId: ie, viewport: fe, onViewportChange: be, nodesDraggable: Te }) {
  return Tb(e), Tb(t), OL(), _L(n), kL(fe), x(q6, { onPaneClick: F, onPaneMouseEnter: K, onPaneMouseMove: ee, onPaneMouseLeave: U, onPaneContextMenu: ne, onPaneScroll: q, paneClickDistance: oe, deleteKeyCode: T, selectionKeyCode: b, selectionOnDrag: _, selectionMode: g, onSelectionStart: s, onSelectionEnd: h, multiSelectionKeyCode: O, panActivationKeyCode: P, zoomActivationKeyCode: E, elementsSelectable: N, zoomOnScroll: Q, zoomOnPinch: k, zoomOnDoubleClick: j, panOnScroll: I, panOnScrollSpeed: S, panOnScrollMode: A, panOnDrag: z, autoPanOnSelection: L, defaultViewport: M, translateExtent: R, minZoom: V, maxZoom: C, onSelectionContextMenu: f, preventScrolling: B, noDragClassName: X, noWheelClassName: ae, noPanClassName: he, disableKeyboardA11y: me, onViewportChange: be, isControlledViewport: !!fe, children: te(bL, { children: [x(vL, { edgeTypes: t, onEdgeClick: i, onEdgeDoubleClick: o, onReconnect: ke, onReconnectStart: Ne, onReconnectEnd: Ke, onlyRenderVisibleElements: D, onEdgeContextMenu: re, onEdgeMouseEnter: de, onEdgeMouseMove: ve, onEdgeMouseLeave: se, reconnectRadius: pe, defaultMarkerColor: G, noPanClassName: he, disableKeyboardA11y: me, rfId: ie }), x(IL, { style: m, type: p, component: y, containerStyle: w }), x("div", { className: "react-flow__edgelabel-renderer" }), x(eL, { nodeTypes: e, onNodeClick: r, onNodeDoubleClick: a, onNodeMouseEnter: d, onNodeMouseMove: u, onNodeMouseLeave: l, onNodeContextMenu: c, nodeClickDistance: Y, onlyRenderVisibleElements: D, noPanClassName: he, noDragClassName: X, disableKeyboardA11y: me, nodeExtent: Ee, rfId: ie, nodesDraggable: Te }), x("div", { className: "react-flow__viewport-portal" })] }) });
}
iI.displayName = "GraphView";
const zL = gt(iI), EL = ax("React Flow", "https://reactflow.dev/"), Nb = ({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, width: i, height: a, fitView: o, fitViewOptions: d, minZoom: u = 0.5, maxZoom: l = 2, nodeOrigin: c, nodeExtent: f, zIndexMode: s = "basic" } = {}) => {
  const h = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), w = r ?? t ?? [], b = n ?? e ?? [], _ = c ?? [0, 0], g = f ?? qs;
  gx(m, y, w);
  const { nodesInitialized: O } = kh(b, h, p, {
    nodeOrigin: _,
    nodeExtent: g,
    zIndexMode: s
  });
  let P = [0, 0, 1];
  if (o && i && a) {
    const E = hl(h, {
      filter: (M) => !!((M.width || M.initialWidth) && (M.height || M.initialHeight))
    }), { x: T, y: D, zoom: N } = Gp(E, i, a, u, l, d?.padding ?? 0.1);
    P = [T, D, N];
  }
  return {
    rfId: "1",
    width: i ?? 0,
    height: a ?? 0,
    transform: P,
    nodes: b,
    nodesInitialized: O,
    nodeLookup: h,
    parentLookup: p,
    edges: w,
    edgeLookup: y,
    connectionLookup: m,
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: n !== void 0,
    hasDefaultEdges: r !== void 0,
    panZoom: null,
    minZoom: u,
    maxZoom: l,
    translateExtent: qs,
    nodeExtent: g,
    nodesSelectionActive: !1,
    userSelectionActive: !1,
    userSelectionRect: null,
    connectionMode: jo.Strict,
    domNode: null,
    paneDragging: !1,
    noPanClassName: "nopan",
    nodeOrigin: _,
    nodeDragThreshold: 1,
    connectionDragThreshold: 1,
    snapGrid: [15, 15],
    snapToGrid: !1,
    nodesDraggable: !0,
    nodesConnectable: !0,
    nodesFocusable: !0,
    edgesFocusable: !0,
    edgesReconnectable: !0,
    elementsSelectable: !0,
    elevateNodesOnSelect: !0,
    elevateEdgesOnSelect: !0,
    selectNodesOnDrag: !0,
    multiSelectionActive: !1,
    fitViewQueued: o ?? !1,
    fitViewOptions: d,
    fitViewResolver: null,
    connection: { ...QS },
    connectionClickStartHandle: null,
    connectOnClick: !0,
    ariaLiveMessage: "",
    autoPanOnConnect: !0,
    autoPanOnNodeDrag: !0,
    autoPanOnNodeFocus: !0,
    autoPanSpeed: 15,
    connectionRadius: 20,
    onError: EL,
    isValidConnection: void 0,
    onSelectionChangeHandlers: [],
    lib: "react",
    debug: !1,
    ariaLabelConfig: YS,
    zIndexMode: s,
    onNodesChangeMiddlewareMap: /* @__PURE__ */ new Map(),
    onEdgesChangeMiddlewareMap: /* @__PURE__ */ new Map()
  };
}, TL = ({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, width: i, height: a, fitView: o, fitViewOptions: d, minZoom: u, maxZoom: l, nodeOrigin: c, nodeExtent: f, zIndexMode: s }) => Hz((h, p) => {
  async function m() {
    const { nodeLookup: y, panZoom: w, fitViewOptions: b, fitViewResolver: _, width: g, height: O, minZoom: P, maxZoom: E } = p();
    w && (await e2({
      nodes: y,
      width: g,
      height: O,
      panZoom: w,
      minZoom: P,
      maxZoom: E
    }, b), _?.resolve(!0), h({ fitViewResolver: null }));
  }
  return {
    ...Nb({
      nodes: e,
      edges: t,
      width: i,
      height: a,
      fitView: o,
      fitViewOptions: d,
      minZoom: u,
      maxZoom: l,
      nodeOrigin: c,
      nodeExtent: f,
      defaultNodes: n,
      defaultEdges: r,
      zIndexMode: s
    }),
    setNodes: (y) => {
      const { nodeLookup: w, parentLookup: b, nodeOrigin: _, elevateNodesOnSelect: g, fitViewQueued: O, zIndexMode: P, nodesSelectionActive: E } = p(), { nodesInitialized: T, hasSelectedNodes: D } = kh(y, w, b, {
        nodeOrigin: _,
        nodeExtent: f,
        elevateNodesOnSelect: g,
        checkEquality: !0,
        zIndexMode: P
      }), N = E && D;
      O && T ? (m(), h({
        nodes: y,
        nodesInitialized: T,
        fitViewQueued: !1,
        fitViewOptions: void 0,
        nodesSelectionActive: N
      })) : h({ nodes: y, nodesInitialized: T, nodesSelectionActive: N });
    },
    setEdges: (y) => {
      const { connectionLookup: w, edgeLookup: b } = p();
      gx(w, b, y), h({ edges: y });
    },
    setDefaultNodesAndEdges: (y, w) => {
      if (y) {
        const { setNodes: b } = p();
        b(y), h({ hasDefaultNodes: !0 });
      }
      if (w) {
        const { setEdges: b } = p();
        b(w), h({ hasDefaultEdges: !0 });
      }
    },
    /*
     * Every node gets registered at a ResizeObserver. Whenever a node
     * changes its dimensions, this function is called to measure the
     * new dimensions and update the nodes.
     */
    updateNodeInternals: (y) => {
      const { triggerNodeChanges: w, nodeLookup: b, parentLookup: _, domNode: g, nodeOrigin: O, nodeExtent: P, debug: E, fitViewQueued: T, zIndexMode: D } = p(), { changes: N, updatedInternals: M } = S2(y, b, _, g, O, P, D);
      M && (b2(b, _, { nodeOrigin: O, nodeExtent: P, zIndexMode: D }), T ? (m(), h({ fitViewQueued: !1, fitViewOptions: void 0 })) : h({}), N?.length > 0 && (E && console.log("React Flow: trigger node changes", N), w?.(N)));
    },
    updateNodePositions: (y, w = !1) => {
      const b = [];
      let _ = [];
      const { nodeLookup: g, triggerNodeChanges: O, connection: P, updateConnection: E, onNodesChangeMiddlewareMap: T } = p();
      for (const [D, N] of y) {
        const M = g.get(D), R = !!(M?.expandParent && M?.parentId && N?.position), V = {
          id: D,
          type: "position",
          position: R ? {
            x: Math.max(0, N.position.x),
            y: Math.max(0, N.position.y)
          } : N.position,
          dragging: w
        };
        if (M && P.inProgress && P.fromNode.id === M.id) {
          const C = ai(M, P.fromHandle, Ie.Left, !0);
          E({ ...P, from: C });
        }
        R && M.parentId && b.push({
          id: D,
          parentId: M.parentId,
          rect: {
            ...N.internals.positionAbsolute,
            width: N.measured.width ?? 0,
            height: N.measured.height ?? 0
          }
        }), _.push(V);
      }
      if (b.length > 0) {
        const { parentLookup: D, nodeOrigin: N } = p(), M = tm(b, g, D, N);
        _.push(...M);
      }
      for (const D of T.values())
        _ = D(_);
      O(_);
    },
    triggerNodeChanges: (y) => {
      const { onNodesChange: w, setNodes: b, nodes: _, hasDefaultNodes: g, debug: O } = p();
      if (y?.length) {
        if (g) {
          const P = Tx(y, _);
          b(P);
        }
        O && console.log("React Flow: trigger node changes", y), w?.(y);
      }
    },
    triggerEdgeChanges: (y) => {
      const { onEdgesChange: w, setEdges: b, edges: _, hasDefaultEdges: g, debug: O } = p();
      if (y?.length) {
        if (g) {
          const P = Nx(y, _);
          b(P);
        }
        O && console.log("React Flow: trigger edge changes", y), w?.(y);
      }
    },
    addSelectedNodes: (y) => {
      const { multiSelectionActive: w, edgeLookup: b, nodeLookup: _, triggerNodeChanges: g, triggerEdgeChanges: O } = p();
      if (w) {
        const P = y.map((E) => qr(E, !0));
        g(P);
        return;
      }
      g(bo(_, /* @__PURE__ */ new Set([...y]), !0)), O(bo(b));
    },
    addSelectedEdges: (y) => {
      const { multiSelectionActive: w, edgeLookup: b, nodeLookup: _, triggerNodeChanges: g, triggerEdgeChanges: O } = p();
      if (w) {
        const P = y.map((E) => qr(E, !0));
        O(P);
        return;
      }
      O(bo(b, /* @__PURE__ */ new Set([...y]))), g(bo(_, /* @__PURE__ */ new Set(), !0));
    },
    unselectNodesAndEdges: ({ nodes: y, edges: w } = {}) => {
      const { edges: b, nodes: _, nodeLookup: g, triggerNodeChanges: O, triggerEdgeChanges: P } = p(), E = y || _, T = w || b, D = [];
      for (const M of E) {
        if (!M.selected)
          continue;
        const R = g.get(M.id);
        R && (R.selected = !1), D.push(qr(M.id, !1));
      }
      const N = [];
      for (const M of T)
        M.selected && N.push(qr(M.id, !1));
      O(D), P(N);
    },
    setMinZoom: (y) => {
      const { panZoom: w, maxZoom: b } = p();
      w?.setScaleExtent([y, b]), h({ minZoom: y });
    },
    setMaxZoom: (y) => {
      const { panZoom: w, minZoom: b } = p();
      w?.setScaleExtent([b, y]), h({ maxZoom: y });
    },
    setTranslateExtent: (y) => {
      p().panZoom?.setTranslateExtent(y), h({ translateExtent: y });
    },
    resetSelectedElements: () => {
      const { edges: y, nodes: w, triggerNodeChanges: b, triggerEdgeChanges: _, elementsSelectable: g } = p();
      if (!g)
        return;
      const O = w.reduce((E, T) => T.selected ? [...E, qr(T.id, !1)] : E, []), P = y.reduce((E, T) => T.selected ? [...E, qr(T.id, !1)] : E, []);
      b(O), _(P);
    },
    setNodeExtent: (y) => {
      const { nodes: w, nodeLookup: b, parentLookup: _, nodeOrigin: g, elevateNodesOnSelect: O, nodeExtent: P, zIndexMode: E } = p();
      y[0][0] === P[0][0] && y[0][1] === P[0][1] && y[1][0] === P[1][0] && y[1][1] === P[1][1] || (kh(w, b, _, {
        nodeOrigin: g,
        nodeExtent: y,
        elevateNodesOnSelect: O,
        checkEquality: !1,
        zIndexMode: E
      }), h({ nodeExtent: y }));
    },
    panBy: (y) => {
      const { transform: w, width: b, height: _, panZoom: g, translateExtent: O } = p();
      return x2({ delta: y, panZoom: g, transform: w, translateExtent: O, width: b, height: _ });
    },
    setCenter: async (y, w, b) => {
      const { width: _, height: g, maxZoom: O, panZoom: P } = p();
      if (!P)
        return !1;
      const E = typeof b?.zoom < "u" ? b.zoom : O;
      return await P.setViewport({
        x: _ / 2 - y * E,
        y: g / 2 - w * E,
        zoom: E
      }, { duration: b?.duration, ease: b?.ease, interpolate: b?.interpolate }), !0;
    },
    cancelConnection: () => {
      h({
        connection: { ...QS }
      });
    },
    updateConnection: (y) => {
      h({ connection: y });
    },
    reset: () => h({ ...Nb() })
  };
}, Object.is);
function rm({ initialNodes: e, initialEdges: t, defaultNodes: n, defaultEdges: r, initialWidth: i, initialHeight: a, initialMinZoom: o, initialMaxZoom: d, initialFitViewOptions: u, fitView: l, nodeOrigin: c, nodeExtent: f, zIndexMode: s, children: h }) {
  const [p] = Ae(() => TL({
    nodes: e,
    edges: t,
    defaultNodes: n,
    defaultEdges: r,
    width: i,
    height: a,
    fitView: l,
    minZoom: o,
    maxZoom: d,
    fitViewOptions: u,
    nodeOrigin: c,
    nodeExtent: f,
    zIndexMode: s
  }));
  return x(W2, { value: p, children: x(y6, { children: x(C6, { children: h }) }) });
}
function NL({ children: e, nodes: t, edges: n, defaultNodes: r, defaultEdges: i, width: a, height: o, fitView: d, fitViewOptions: u, minZoom: l, maxZoom: c, nodeOrigin: f, nodeExtent: s, zIndexMode: h }) {
  return st(kc) ? x(Ue, { children: e }) : x(rm, { initialNodes: t, initialEdges: n, defaultNodes: r, defaultEdges: i, initialWidth: a, initialHeight: o, fitView: d, initialFitViewOptions: u, initialMinZoom: l, initialMaxZoom: c, nodeOrigin: f, nodeExtent: s, zIndexMode: h, children: e });
}
const CL = {
  width: "100%",
  height: "100%",
  overflow: "hidden",
  position: "relative",
  zIndex: 0
};
function DL({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, className: i, nodeTypes: a, edgeTypes: o, onNodeClick: d, onEdgeClick: u, onInit: l, onMove: c, onMoveStart: f, onMoveEnd: s, onConnect: h, onConnectStart: p, onConnectEnd: m, onClickConnectStart: y, onClickConnectEnd: w, onNodeMouseEnter: b, onNodeMouseMove: _, onNodeMouseLeave: g, onNodeContextMenu: O, onNodeDoubleClick: P, onNodeDragStart: E, onNodeDrag: T, onNodeDragStop: D, onNodesDelete: N, onEdgesDelete: M, onDelete: R, onSelectionChange: V, onSelectionDragStart: C, onSelectionDrag: B, onSelectionDragStop: G, onSelectionContextMenu: Q, onSelectionStart: k, onSelectionEnd: I, onBeforeDelete: S, connectionMode: A, connectionLineType: j = wr.Bezier, connectionLineStyle: z, connectionLineComponent: L, connectionLineContainerStyle: F, deleteKeyCode: K = "Backspace", selectionKeyCode: ee = "Shift", selectionOnDrag: U = !1, selectionMode: q = Hs.Full, panActivationKeyCode: ne = "Space", multiSelectionKeyCode: oe = Ks() ? "Meta" : "Control", zoomActivationKeyCode: Y = Ks() ? "Meta" : "Control", snapToGrid: re, snapGrid: de, onlyRenderVisibleElements: ve = !1, selectNodesOnDrag: se, nodesDraggable: pe, autoPanOnNodeFocus: ke, nodesConnectable: Ne, nodesFocusable: Ke, nodeOrigin: X = zx, edgesFocusable: ae, edgesReconnectable: he, elementsSelectable: me = !0, defaultViewport: Ee = a6, minZoom: ie = 0.5, maxZoom: fe = 2, translateExtent: be = qs, preventScrolling: Te = !0, nodeExtent: De, defaultMarkerColor: It = "#b1b1b7", zoomOnScroll: Ft = !0, zoomOnPinch: At = !0, panOnScroll: hn = !1, panOnScrollSpeed: pn = 0.5, panOnScrollMode: St = Yr.Free, zoomOnDoubleClick: Ut = !0, panOnDrag: jt = !0, onPaneClick: na, onPaneMouseEnter: ra, onPaneMouseMove: Dr, onPaneMouseLeave: fr, onPaneScroll: ui, onPaneContextMenu: hr, paneClickDistance: ia = 1, nodeClickDistance: mn = 0, children: ci, onReconnect: di, onReconnectStart: oa, onReconnectEnd: fi, onEdgeContextMenu: aa, onEdgeDoubleClick: pr, onEdgeMouseEnter: sa, onEdgeMouseMove: hi, onEdgeMouseLeave: la, reconnectRadius: pi = 10, onNodesChange: ua, onEdgesChange: mr, noDragClassName: ca = "nodrag", noWheelClassName: da = "nowheel", noPanClassName: Ar = "nopan", fitView: jr, fitViewOptions: mi, connectOnClick: fa, attributionPosition: ha, proOptions: pa, defaultEdgeOptions: v, elevateNodesOnSelect: $ = !0, elevateEdgesOnSelect: Z = !1, disableKeyboardA11y: H = !1, autoPanOnConnect: le, autoPanOnNodeDrag: Qe, autoPanOnSelection: mt = !0, autoPanSpeed: Mc, connectionRadius: $c, isValidConnection: Rc, onError: Zc, style: Lc, id: Sl, nodeDragThreshold: xl, connectionDragThreshold: Fc, viewport: Uc, onViewportChange: Bc, width: Vc, height: W, colorMode: J = "light", debug: ye, onScroll: $e, ariaLabelConfig: qe, zIndexMode: jn = "basic", ...Mr }, ma) {
  const ga = Sl || "1", qc = c6(J), Hc = Ye((Il) => {
    Il.currentTarget.scrollTo({ top: 0, left: 0, behavior: "instant" }), $e?.(Il);
  }, [$e]);
  return x("div", { "data-testid": "rf__wrapper", ...Mr, onScroll: Hc, style: { ...Lc, ...CL }, ref: ma, className: kt(["react-flow", i, qc]), id: Sl, role: "application", children: te(NL, { nodes: e, edges: t, width: Vc, height: W, fitView: jr, fitViewOptions: mi, minZoom: ie, maxZoom: fe, nodeOrigin: X, nodeExtent: De, zIndexMode: jn, children: [x(u6, { nodes: e, edges: t, defaultNodes: n, defaultEdges: r, onConnect: h, onConnectStart: p, onConnectEnd: m, onClickConnectStart: y, onClickConnectEnd: w, nodesDraggable: pe, autoPanOnNodeFocus: ke, nodesConnectable: Ne, nodesFocusable: Ke, edgesFocusable: ae, edgesReconnectable: he, elementsSelectable: me, elevateNodesOnSelect: $, elevateEdgesOnSelect: Z, minZoom: ie, maxZoom: fe, nodeExtent: De, onNodesChange: ua, onEdgesChange: mr, snapToGrid: re, snapGrid: de, connectionMode: A, translateExtent: be, connectOnClick: fa, defaultEdgeOptions: v, fitView: jr, fitViewOptions: mi, onNodesDelete: N, onEdgesDelete: M, onDelete: R, onNodeDragStart: E, onNodeDrag: T, onNodeDragStop: D, onSelectionDrag: B, onSelectionDragStart: C, onSelectionDragStop: G, onMove: c, onMoveStart: f, onMoveEnd: s, noPanClassName: Ar, nodeOrigin: X, rfId: ga, autoPanOnConnect: le, autoPanOnNodeDrag: Qe, autoPanSpeed: Mc, onError: Zc, connectionRadius: $c, isValidConnection: Rc, selectNodesOnDrag: se, nodeDragThreshold: xl, connectionDragThreshold: Fc, onBeforeDelete: S, debug: ye, ariaLabelConfig: qe, zIndexMode: jn }), x(zL, { onInit: l, onNodeClick: d, onEdgeClick: u, onNodeMouseEnter: b, onNodeMouseMove: _, onNodeMouseLeave: g, onNodeContextMenu: O, onNodeDoubleClick: P, nodeTypes: a, edgeTypes: o, connectionLineType: j, connectionLineStyle: z, connectionLineComponent: L, connectionLineContainerStyle: F, selectionKeyCode: ee, selectionOnDrag: U, selectionMode: q, deleteKeyCode: K, multiSelectionKeyCode: oe, panActivationKeyCode: ne, zoomActivationKeyCode: Y, onlyRenderVisibleElements: ve, defaultViewport: Ee, translateExtent: be, minZoom: ie, maxZoom: fe, preventScrolling: Te, zoomOnScroll: Ft, zoomOnPinch: At, zoomOnDoubleClick: Ut, panOnScroll: hn, panOnScrollSpeed: pn, panOnScrollMode: St, panOnDrag: jt, autoPanOnSelection: mt, onPaneClick: na, onPaneMouseEnter: ra, onPaneMouseMove: Dr, onPaneMouseLeave: fr, onPaneScroll: ui, onPaneContextMenu: hr, paneClickDistance: ia, nodeClickDistance: mn, onSelectionContextMenu: Q, onSelectionStart: k, onSelectionEnd: I, onReconnect: di, onReconnectStart: oa, onReconnectEnd: fi, onEdgeContextMenu: aa, onEdgeDoubleClick: pr, onEdgeMouseEnter: sa, onEdgeMouseMove: hi, onEdgeMouseLeave: la, reconnectRadius: pi, defaultMarkerColor: It, noDragClassName: ca, noWheelClassName: da, noPanClassName: Ar, rfId: ga, disableKeyboardA11y: H, nodeExtent: De, viewport: Uc, onViewportChange: Bc, nodesDraggable: pe }), x(o6, { onSelectionChange: V }), ci, x(e6, { proOptions: pa, position: ha }), x(Q2, { rfId: ga, disableKeyboardA11y: H })] }) });
}
var oI = Cx(DL);
const AL = (e) => e.domNode?.querySelector(".react-flow__edgelabel-renderer");
function jL({ children: e }) {
  const t = Ve(AL);
  return t ? kz(e, t) : null;
}
function ML(e) {
  const [t, n] = Ae(e), r = Ye((i) => n((a) => Tx(i, a)), []);
  return [t, n, r];
}
function $L(e) {
  const [t, n] = Ae(e), r = Ye((i) => n((a) => Nx(i, a)), []);
  return [t, n, r];
}
const RL = (e) => (t) => {
  if (!e.includeHiddenNodes)
    return t.nodesInitialized;
  if (t.nodeLookup.size === 0)
    return !1;
  for (const [, { internals: n }] of t.nodeLookup)
    if (n.handleBounds === void 0 || !Kp(n.userNode))
      return !1;
  return !0;
};
function ZL(e = {
  includeHiddenNodes: !1
}) {
  return Ve(RL(e));
}
function LL({ dimensions: e, lineWidth: t, variant: n, className: r }) {
  return x("path", { strokeWidth: t, d: `M${e[0] / 2} 0 V${e[1]} M0 ${e[1] / 2} H${e[0]}`, className: kt(["react-flow__background-pattern", n, r]) });
}
function FL({ radius: e, className: t }) {
  return x("circle", { cx: e, cy: e, r: e, className: kt(["react-flow__background-pattern", "dots", t]) });
}
var Un;
(function(e) {
  e.Lines = "lines", e.Dots = "dots", e.Cross = "cross";
})(Un || (Un = {}));
const UL = {
  [Un.Dots]: 1,
  [Un.Lines]: 1,
  [Un.Cross]: 6
}, BL = (e) => ({ transform: e.transform, patternId: `pattern-${e.rfId}` });
function aI({
  id: e,
  variant: t = Un.Dots,
  // only used for dots and cross
  gap: n = 20,
  // only used for lines and cross
  size: r,
  lineWidth: i = 1,
  offset: a = 0,
  color: o,
  bgColor: d,
  style: u,
  className: l,
  patternClassName: c
}) {
  const f = Ce(null), { transform: s, patternId: h } = Ve(BL, ct), p = r || UL[t], m = t === Un.Dots, y = t === Un.Cross, w = Array.isArray(n) ? n : [n, n], b = [w[0] * s[2] || 1, w[1] * s[2] || 1], _ = p * s[2], g = Array.isArray(a) ? a : [a, a], O = y ? [_, _] : b, P = [
    g[0] * s[2] || 1 + O[0] / 2,
    g[1] * s[2] || 1 + O[1] / 2
  ], E = `${h}${e || ""}`;
  return te("svg", { className: kt(["react-flow__background", l]), style: {
    ...u,
    ...xc,
    "--xy-background-color-props": d,
    "--xy-background-pattern-color-props": o
  }, ref: f, "data-testid": "rf__background", children: [x("pattern", { id: E, x: s[0] % b[0], y: s[1] % b[1], width: b[0], height: b[1], patternUnits: "userSpaceOnUse", patternTransform: `translate(-${P[0]},-${P[1]})`, children: m ? x(FL, { radius: _ / 2, className: c }) : x(LL, { dimensions: O, lineWidth: i, variant: t, className: c }) }), x("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: `url(#${E})` })] });
}
aI.displayName = "Background";
const sI = gt(aI);
function VL() {
  return x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: x("path", { d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z" }) });
}
function qL() {
  return x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 5", children: x("path", { d: "M0 0h32v4.2H0z" }) });
}
function HL() {
  return x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 30", children: x("path", { d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z" }) });
}
function WL() {
  return x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: x("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z" }) });
}
function GL() {
  return x("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: x("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z" }) });
}
function Vl({ children: e, className: t, ...n }) {
  return x("button", { type: "button", className: kt(["react-flow__controls-button", t]), ...n, children: e });
}
const KL = (e) => ({
  isInteractive: e.nodesDraggable || e.nodesConnectable || e.elementsSelectable,
  minZoomReached: e.transform[2] <= e.minZoom,
  maxZoomReached: e.transform[2] >= e.maxZoom,
  ariaLabelConfig: e.ariaLabelConfig
});
function lI({ style: e, showZoom: t = !0, showFitView: n = !0, showInteractive: r = !0, fitViewOptions: i, onZoomIn: a, onZoomOut: o, onFitView: d, onInteractiveChange: u, className: l, children: c, position: f = "bottom-left", orientation: s = "vertical", "aria-label": h }) {
  const p = at(), { isInteractive: m, minZoomReached: y, maxZoomReached: w, ariaLabelConfig: b } = Ve(KL, ct), { zoomIn: _, zoomOut: g, fitView: O } = Jo(), P = () => {
    _(), a?.();
  }, E = () => {
    g(), o?.();
  }, T = () => {
    O(i), d?.();
  }, D = () => {
    p.setState({
      nodesDraggable: !m,
      nodesConnectable: !m,
      elementsSelectable: !m
    }), u?.(!m);
  };
  return te(Sc, { className: kt(["react-flow__controls", s === "horizontal" ? "horizontal" : "vertical", l]), position: f, style: e, "data-testid": "rf__controls", "aria-label": h ?? b["controls.ariaLabel"], children: [t && te(Ue, { children: [x(Vl, { onClick: P, className: "react-flow__controls-zoomin", title: b["controls.zoomIn.ariaLabel"], "aria-label": b["controls.zoomIn.ariaLabel"], disabled: w, children: x(VL, {}) }), x(Vl, { onClick: E, className: "react-flow__controls-zoomout", title: b["controls.zoomOut.ariaLabel"], "aria-label": b["controls.zoomOut.ariaLabel"], disabled: y, children: x(qL, {}) })] }), n && x(Vl, { className: "react-flow__controls-fitview", onClick: T, title: b["controls.fitView.ariaLabel"], "aria-label": b["controls.fitView.ariaLabel"], children: x(HL, {}) }), r && x(Vl, { className: "react-flow__controls-interactive", onClick: D, title: b["controls.interactive.ariaLabel"], "aria-label": b["controls.interactive.ariaLabel"], children: m ? x(GL, {}) : x(WL, {}) }), c] });
}
lI.displayName = "Controls";
const JL = gt(lI);
function XL({ id: e, x: t, y: n, width: r, height: i, style: a, color: o, strokeColor: d, strokeWidth: u, className: l, borderRadius: c, shapeRendering: f, selected: s, onClick: h }) {
  const { background: p, backgroundColor: m } = a || {}, y = o || p || m;
  return x("rect", { className: kt(["react-flow__minimap-node", { selected: s }, l]), x: t, y: n, rx: c, ry: c, width: r, height: i, style: {
    fill: y,
    stroke: d,
    strokeWidth: u
  }, shapeRendering: f, onClick: h ? (w) => h(w, e) : void 0 });
}
const YL = gt(XL), QL = (e) => e.nodes.map((t) => t.id), Dd = (e) => e instanceof Function ? e : () => e;
function eF({
  nodeStrokeColor: e,
  nodeColor: t,
  nodeClassName: n = "",
  nodeBorderRadius: r = 5,
  nodeStrokeWidth: i,
  /*
   * We need to rename the prop to be `CapitalCase` so that JSX will render it as
   * a component properly.
   */
  nodeComponent: a = YL,
  onClick: o
}) {
  const d = Ve(QL, ct), u = Dd(t), l = Dd(e), c = Dd(n), f = typeof window > "u" || window.chrome ? "crispEdges" : "geometricPrecision";
  return x(Ue, { children: d.map((s) => (
    /*
     * The split of responsibilities between MiniMapNodes and
     * NodeComponentWrapper may appear weird. However, it’s designed to
     * minimize the cost of updates when individual nodes change.
     *
     * For more details, see a similar commit in `NodeRenderer/index.tsx`.
     */
    x(nF, { id: s, nodeColorFunc: u, nodeStrokeColorFunc: l, nodeClassNameFunc: c, nodeBorderRadius: r, nodeStrokeWidth: i, NodeComponent: a, onClick: o, shapeRendering: f }, s)
  )) });
}
function tF({ id: e, nodeColorFunc: t, nodeStrokeColorFunc: n, nodeClassNameFunc: r, nodeBorderRadius: i, nodeStrokeWidth: a, shapeRendering: o, NodeComponent: d, onClick: u }) {
  const { node: l, x: c, y: f, width: s, height: h } = Ve((p) => {
    const m = p.nodeLookup.get(e);
    if (!m)
      return { node: void 0, x: 0, y: 0, width: 0, height: 0 };
    const y = m.internals.userNode, { x: w, y: b } = m.internals.positionAbsolute, { width: _, height: g } = Gn(y);
    return {
      node: y,
      x: w,
      y: b,
      width: _,
      height: g
    };
  }, ct);
  return !l || l.hidden || !Kp(l) ? null : x(d, { x: c, y: f, width: s, height: h, style: l.style, selected: !!l.selected, className: r(l), color: t(l), borderRadius: i, strokeColor: n(l), strokeWidth: a, shapeRendering: o, onClick: u, id: l.id });
}
const nF = gt(tF);
var rF = gt(eF);
const iF = 200, oF = 150, aF = (e) => !e.hidden, sF = (e) => {
  const t = {
    x: -e.transform[0] / e.transform[2],
    y: -e.transform[1] / e.transform[2],
    width: e.width / e.transform[2],
    height: e.height / e.transform[2]
  };
  return {
    viewBB: t,
    boundingRect: e.nodeLookup.size > 0 ? ix(hl(e.nodeLookup, { filter: aF }), t) : t,
    rfId: e.rfId,
    panZoom: e.panZoom,
    translateExtent: e.translateExtent,
    flowWidth: e.width,
    flowHeight: e.height,
    ariaLabelConfig: e.ariaLabelConfig
  };
}, Cb = (e, t) => e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height, lF = (e, t) => Cb(e.viewBB, t.viewBB) && Cb(e.boundingRect, t.boundingRect) && e.rfId === t.rfId && e.panZoom === t.panZoom && e.translateExtent === t.translateExtent && e.flowWidth === t.flowWidth && e.flowHeight === t.flowHeight && e.ariaLabelConfig === t.ariaLabelConfig, uF = "react-flow__minimap-desc";
function uI({
  style: e,
  className: t,
  nodeStrokeColor: n,
  nodeColor: r,
  nodeClassName: i = "",
  nodeBorderRadius: a = 5,
  nodeStrokeWidth: o,
  /*
   * We need to rename the prop to be `CapitalCase` so that JSX will render it as
   * a component properly.
   */
  nodeComponent: d,
  bgColor: u,
  maskColor: l,
  maskStrokeColor: c,
  maskStrokeWidth: f,
  position: s = "bottom-right",
  onClick: h,
  onNodeClick: p,
  pannable: m = !1,
  zoomable: y = !1,
  ariaLabel: w,
  inversePan: b,
  zoomStep: _ = 1,
  offsetScale: g = 5
}) {
  const O = at(), P = Ce(null), { boundingRect: E, viewBB: T, rfId: D, panZoom: N, translateExtent: M, flowWidth: R, flowHeight: V, ariaLabelConfig: C } = Ve(sF, lF), B = e?.width ?? iF, G = e?.height ?? oF, Q = E.width / B, k = E.height / G, I = Math.max(Q, k), S = I * B, A = I * G, j = g * I, z = E.x - (S - E.width) / 2 - j, L = E.y - (A - E.height) / 2 - j, F = S + j * 2, K = A + j * 2, ee = `${uF}-${D}`, U = Ce(0), q = Ce();
  U.current = I, Ze(() => {
    if (P.current && N)
      return q.current = D2({
        domNode: P.current,
        panZoom: N,
        getTransform: () => O.getState().transform,
        getViewScale: () => U.current
      }), () => {
        q.current?.destroy();
      };
  }, [N]), Ze(() => {
    q.current?.update({
      translateExtent: M,
      width: R,
      height: V,
      inversePan: b,
      pannable: m,
      zoomStep: _,
      zoomable: y
    });
  }, [m, y, b, _, M, R, V]);
  const ne = h ? (re) => {
    const [de, ve] = q.current?.pointer(re) || [0, 0];
    h(re, { x: de, y: ve });
  } : void 0, oe = p ? Ye((re, de) => {
    const ve = O.getState().nodeLookup.get(de).internals.userNode;
    p(re, ve);
  }, []) : void 0, Y = w ?? C["minimap.ariaLabel"];
  return x(Sc, { position: s, style: {
    ...e,
    "--xy-minimap-background-color-props": typeof u == "string" ? u : void 0,
    "--xy-minimap-mask-background-color-props": typeof l == "string" ? l : void 0,
    "--xy-minimap-mask-stroke-color-props": typeof c == "string" ? c : void 0,
    "--xy-minimap-mask-stroke-width-props": typeof f == "number" ? f * I : void 0,
    "--xy-minimap-node-background-color-props": typeof r == "string" ? r : void 0,
    "--xy-minimap-node-stroke-color-props": typeof n == "string" ? n : void 0,
    "--xy-minimap-node-stroke-width-props": typeof o == "number" ? o : void 0
  }, className: kt(["react-flow__minimap", t]), "data-testid": "rf__minimap", children: te("svg", { width: B, height: G, viewBox: `${z} ${L} ${F} ${K}`, className: "react-flow__minimap-svg", role: "img", "aria-labelledby": ee, ref: P, onClick: ne, children: [Y && x("title", { id: ee, children: Y }), x(rF, { onClick: oe, nodeColor: r, nodeStrokeColor: n, nodeBorderRadius: a, nodeClassName: i, nodeStrokeWidth: o, nodeComponent: d }), x("path", { className: "react-flow__minimap-mask", d: `M${z - j},${L - j}h${F + j * 2}v${K + j * 2}h${-F - j * 2}z
        M${T.x},${T.y}h${T.width}v${T.height}h${-T.width}z`, fillRule: "evenodd", pointerEvents: "none" })] }) });
}
uI.displayName = "MiniMap";
gt(uI);
const cF = (e) => (t) => e ? `${Math.max(1 / t.transform[2], 1)}` : void 0, dF = {
  [Ro.Line]: "right",
  [Ro.Handle]: "bottom-right"
};
function fF({ nodeId: e, position: t, variant: n = Ro.Handle, className: r, style: i = void 0, children: a, color: o, minWidth: d = 10, minHeight: u = 10, maxWidth: l = Number.MAX_VALUE, maxHeight: c = Number.MAX_VALUE, keepAspectRatio: f = !1, resizeDirection: s, autoScale: h = !0, shouldResize: p, onResizeStart: m, onResize: y, onResizeEnd: w }) {
  const b = $x(), _ = typeof e == "string" ? e : b, g = at(), O = Ce(null), P = n === Ro.Handle, E = Ve(Ye(cF(P && h), [P, h]), ct), T = Ce(null), D = t ?? dF[n];
  Ze(() => {
    if (!(!O.current || !_))
      return T.current || (T.current = H2({
        domNode: O.current,
        nodeId: _,
        getStoreItems: () => {
          const { nodeLookup: M, transform: R, snapGrid: V, snapToGrid: C, nodeOrigin: B, domNode: G } = g.getState();
          return {
            nodeLookup: M,
            transform: R,
            snapGrid: V,
            snapToGrid: C,
            nodeOrigin: B,
            paneDomNode: G
          };
        },
        onChange: (M, R) => {
          const { triggerNodeChanges: V, nodeLookup: C, parentLookup: B, nodeOrigin: G } = g.getState(), Q = [], k = { x: M.x, y: M.y }, I = C.get(_);
          if (I && I.expandParent && I.parentId) {
            const S = I.origin ?? G, A = M.width ?? I.measured.width ?? 0, j = M.height ?? I.measured.height ?? 0, z = {
              id: I.id,
              parentId: I.parentId,
              rect: {
                width: A,
                height: j,
                ...sx({
                  x: M.x ?? I.position.x,
                  y: M.y ?? I.position.y
                }, { width: A, height: j }, I.parentId, C, S)
              }
            }, L = tm([z], C, B, G);
            Q.push(...L), k.x = M.x ? Math.max(S[0] * A, M.x) : void 0, k.y = M.y ? Math.max(S[1] * j, M.y) : void 0;
          }
          if (k.x !== void 0 && k.y !== void 0) {
            const S = {
              id: _,
              type: "position",
              position: { ...k }
            };
            Q.push(S);
          }
          if (M.width !== void 0 && M.height !== void 0) {
            const A = {
              id: _,
              type: "dimensions",
              resizing: !0,
              setAttributes: s ? s === "horizontal" ? "width" : "height" : !0,
              dimensions: {
                width: M.width,
                height: M.height
              }
            };
            Q.push(A);
          }
          for (const S of R) {
            const A = {
              ...S,
              type: "position"
            };
            Q.push(A);
          }
          V(Q);
        },
        onEnd: ({ width: M, height: R }) => {
          const V = {
            id: _,
            type: "dimensions",
            resizing: !1,
            dimensions: {
              width: M,
              height: R
            }
          };
          g.getState().triggerNodeChanges([V]);
        }
      })), T.current.update({
        controlPosition: D,
        boundaries: {
          minWidth: d,
          minHeight: u,
          maxWidth: l,
          maxHeight: c
        },
        keepAspectRatio: f,
        resizeDirection: s,
        onResizeStart: m,
        onResize: y,
        onResizeEnd: w,
        shouldResize: p
      }), () => {
        T.current?.destroy();
      };
  }, [
    D,
    d,
    u,
    l,
    c,
    f,
    m,
    y,
    w,
    p
  ]);
  const N = D.split("-");
  return x("div", { className: kt(["react-flow__resize-control", "nodrag", ...N, n, r]), ref: O, style: {
    ...i,
    scale: E,
    ...o && { [P ? "backgroundColor" : "borderColor"]: o }
  }, children: a });
}
gt(fF);
const hF = "w-full rounded-md border border-border-light bg-card px-2 py-1.5 text-sm text-foreground", pF = "text-[11px] font-medium uppercase tracking-wide text-muted-foreground";
function cI({ aside: e, children: t }) {
  return e === void 0 ? /* @__PURE__ */ x(Ue, { children: t }) : /* @__PURE__ */ te("div", { className: "flex items-center justify-between gap-2", children: [
    t,
    e
  ] });
}
function Xe({
  label: e,
  hint: t,
  aside: n,
  as: r = "label",
  children: i
}) {
  const a = Ho(), o = r === "label" && yz(i) ? i : void 0, d = o?.props.id ?? a;
  return /* @__PURE__ */ te(j0, { className: "gap-1.5", children: [
    /* @__PURE__ */ x(cI, { aside: n, children: o ? /* @__PURE__ */ x(M0, { htmlFor: d, children: e }) : /* @__PURE__ */ x(Sz, { children: e }) }),
    o ? vz(o, { id: d }) : i,
    t !== void 0 && /* @__PURE__ */ x(Xu, { children: t })
  ] });
}
function dI({
  label: e,
  hint: t,
  aside: n,
  checked: r,
  onCheckedChange: i
}) {
  const a = Ho();
  return /* @__PURE__ */ te(j0, { orientation: "horizontal", children: [
    /* @__PURE__ */ te(xz, { className: "min-w-0", children: [
      /* @__PURE__ */ x(cI, { aside: n, children: /* @__PURE__ */ x(M0, { htmlFor: a, children: e }) }),
      t !== void 0 && /* @__PURE__ */ x(Xu, { children: t })
    ] }),
    /* @__PURE__ */ x($0, { id: a, checked: r, onCheckedChange: i, className: "shrink-0" })
  ] });
}
function Ih({
  label: e,
  value: t,
  min: n,
  max: r,
  step: i,
  restAt: a,
  format: o = (u) => u.toFixed(2),
  onChange: d
}) {
  const u = Re(), l = t !== void 0, c = t ?? a;
  return /* @__PURE__ */ te("div", { className: "flex flex-col gap-1.5", children: [
    /* @__PURE__ */ te("div", { className: "flex items-baseline justify-between gap-2", children: [
      /* @__PURE__ */ x("span", { className: pF, children: e }),
      /* @__PURE__ */ te("div", { className: "flex items-baseline gap-2", children: [
        l && /* @__PURE__ */ x(
          "button",
          {
            type: "button",
            onClick: () => d(void 0),
            className: "text-[11px] font-medium text-muted-foreground transition-colors hover:text-foreground",
            children: u("inspector.sampling.reset", "Reset")
          }
        ),
        /* @__PURE__ */ x(
          "span",
          {
            className: Be(
              "text-[12px] tabular-nums",
              l ? "font-medium text-foreground" : "text-muted-foreground/70"
            ),
            children: l ? o(c) : u("inspector.sampling.auto", "Auto")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ x(
      Oz,
      {
        "aria-label": e,
        min: n,
        max: r,
        step: i,
        value: [c],
        onValueChange: ([f]) => d(f),
        className: Be(!l && "opacity-50")
      }
    )
  ] });
}
function Ph(e) {
  return [
    { value: "allow", label: e("inspector.policy.allow", "Allow") },
    { value: "needs_approval", label: e("inspector.policy.needsApproval", "Needs approval") },
    { value: "disallow", label: e("inspector.policy.deny", "Deny") }
  ];
}
function Fo({
  options: e,
  value: t,
  onChange: n,
  size: r = "sm",
  fill: i = !0,
  className: a
}) {
  return /* @__PURE__ */ x(
    Iz,
    {
      type: "single",
      spacing: 0.5,
      value: t ?? "",
      onValueChange: (o) => {
        o && n(o);
      },
      className: Be("w-auto rounded-lg bg-muted/60 p-0.5", a),
      children: e.map((o) => /* @__PURE__ */ x(
        Pz,
        {
          value: o.value,
          className: Be(
            "h-auto min-w-0 rounded-md font-medium",
            r === "sm" ? "px-2 py-1 text-[11px]" : "px-3 py-1 text-xs",
            i && "flex-1",
            t === o.value ? "bg-card text-foreground shadow-sm hover:bg-card hover:text-foreground data-[state=on]:bg-card data-[state=on]:text-foreground" : "text-muted-foreground hover:bg-transparent hover:text-foreground"
          ),
          children: o.label
        },
        o.value
      ))
    }
  );
}
zr((e) => ({
  mode: "explore",
  setMode: (t) => e({ mode: t }),
  pendingInspectorTab: null,
  openInspectorTab: (t) => e({ mode: "explore", pendingInspectorTab: t }),
  consumePendingInspectorTab: () => e({ pendingInspectorTab: null })
}));
const fI = 400, Ot = zr()(
  Lz(
    (e) => ({
      paletteWidth: 360,
      paletteHeight: 640,
      inspectorWidth: 380,
      copilotWidth: fI,
      inspectorSplitHeight: null,
      paletteMinimized: !1,
      inspectorMinimized: !1,
      setPaletteWidth: (t) => e({ paletteWidth: t }),
      setPaletteHeight: (t) => e({ paletteHeight: t }),
      setInspectorWidth: (t) => e({ inspectorWidth: t }),
      setCopilotWidth: (t) => e({ copilotWidth: t }),
      setInspectorSplitHeight: (t) => e({ inspectorSplitHeight: t }),
      setPaletteMinimized: (t) => e({ paletteMinimized: t }),
      setInspectorMinimized: (t) => e({ inspectorMinimized: t })
    }),
    {
      name: "agentic-ui:panel-sizes",
      partialize: ({
        paletteWidth: e,
        paletteHeight: t,
        inspectorWidth: n,
        copilotWidth: r,
        inspectorSplitHeight: i
      }) => ({
        paletteWidth: e,
        paletteHeight: t,
        inspectorWidth: n,
        copilotWidth: r,
        inspectorSplitHeight: i
      })
    }
  )
);
function hI({
  icon: e,
  label: t,
  title: n,
  onRestore: r
}) {
  return /* @__PURE__ */ te(
    Tt,
    {
      size: "sm",
      variant: "outline",
      className: "max-w-[14rem] gap-xs bg-background",
      "aria-label": n,
      title: n,
      onClick: r,
      children: [
        e,
        /* @__PURE__ */ x("span", { className: "truncate", children: t })
      ]
    }
  );
}
function im({ label: e, onClick: t }) {
  return /* @__PURE__ */ x(
    "button",
    {
      type: "button",
      "aria-label": e,
      title: e,
      onClick: t,
      className: "flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-muted",
      children: /* @__PURE__ */ x(aN, { className: "size-4" })
    }
  );
}
var Ad, Db;
function om() {
  if (Db) return Ad;
  Db = 1;
  var e = "\0", t = "\0", n = "";
  class r {
    _isDirected = !0;
    _isMultigraph = !1;
    _isCompound = !1;
    // Label for the graph itself
    _label;
    // Defaults to be set when creating a new node
    _defaultNodeLabelFn = () => {
    };
    // Defaults to be set when creating a new edge
    _defaultEdgeLabelFn = () => {
    };
    // v -> label
    _nodes = {};
    // v -> edgeObj
    _in = {};
    // u -> v -> Number
    _preds = {};
    // v -> edgeObj
    _out = {};
    // v -> w -> Number
    _sucs = {};
    // e -> edgeObj
    _edgeObjs = {};
    // e -> label
    _edgeLabels = {};
    /* Number of nodes in the graph. Should only be changed by the implementation. */
    _nodeCount = 0;
    /* Number of edges in the graph. Should only be changed by the implementation. */
    _edgeCount = 0;
    _parent;
    _children;
    constructor(c) {
      c && (this._isDirected = Object.hasOwn(c, "directed") ? c.directed : !0, this._isMultigraph = Object.hasOwn(c, "multigraph") ? c.multigraph : !1, this._isCompound = Object.hasOwn(c, "compound") ? c.compound : !1), this._isCompound && (this._parent = {}, this._children = {}, this._children[t] = {});
    }
    /* === Graph functions ========= */
    /**
     * Whether graph was created with 'directed' flag set to true or not.
     */
    isDirected() {
      return this._isDirected;
    }
    /**
     * Whether graph was created with 'multigraph' flag set to true or not.
     */
    isMultigraph() {
      return this._isMultigraph;
    }
    /**
     * Whether graph was created with 'compound' flag set to true or not.
     */
    isCompound() {
      return this._isCompound;
    }
    /**
     * Sets the label of the graph.
     */
    setGraph(c) {
      return this._label = c, this;
    }
    /**
     * Gets the graph label.
     */
    graph() {
      return this._label;
    }
    /* === Node functions ========== */
    /**
     * Sets the default node label. If newDefault is a function, it will be
     * invoked ach time when setting a label for a node. Otherwise, this label
     * will be assigned as default label in case if no label was specified while
     * setting a node.
     * Complexity: O(1).
     */
    setDefaultNodeLabel(c) {
      return this._defaultNodeLabelFn = c, typeof c != "function" && (this._defaultNodeLabelFn = () => c), this;
    }
    /**
     * Gets the number of nodes in the graph.
     * Complexity: O(1).
     */
    nodeCount() {
      return this._nodeCount;
    }
    /**
     * Gets all nodes of the graph. Note, the in case of compound graph subnodes are
     * not included in list.
     * Complexity: O(1).
     */
    nodes() {
      return Object.keys(this._nodes);
    }
    /**
     * Gets list of nodes without in-edges.
     * Complexity: O(|V|).
     */
    sources() {
      var c = this;
      return this.nodes().filter((f) => Object.keys(c._in[f]).length === 0);
    }
    /**
     * Gets list of nodes without out-edges.
     * Complexity: O(|V|).
     */
    sinks() {
      var c = this;
      return this.nodes().filter((f) => Object.keys(c._out[f]).length === 0);
    }
    /**
     * Invokes setNode method for each node in names list.
     * Complexity: O(|names|).
     */
    setNodes(c, f) {
      var s = arguments, h = this;
      return c.forEach(function(p) {
        s.length > 1 ? h.setNode(p, f) : h.setNode(p);
      }), this;
    }
    /**
     * Creates or updates the value for the node v in the graph. If label is supplied
     * it is set as the value for the node. If label is not supplied and the node was
     * created by this call then the default node label will be assigned.
     * Complexity: O(1).
     */
    setNode(c, f) {
      return Object.hasOwn(this._nodes, c) ? (arguments.length > 1 && (this._nodes[c] = f), this) : (this._nodes[c] = arguments.length > 1 ? f : this._defaultNodeLabelFn(c), this._isCompound && (this._parent[c] = t, this._children[c] = {}, this._children[t][c] = !0), this._in[c] = {}, this._preds[c] = {}, this._out[c] = {}, this._sucs[c] = {}, ++this._nodeCount, this);
    }
    /**
     * Gets the label of node with specified name.
     * Complexity: O(|V|).
     */
    node(c) {
      return this._nodes[c];
    }
    /**
     * Detects whether graph has a node with specified name or not.
     */
    hasNode(c) {
      return Object.hasOwn(this._nodes, c);
    }
    /**
     * Remove the node with the name from the graph or do nothing if the node is not in
     * the graph. If the node was removed this function also removes any incident
     * edges.
     * Complexity: O(1).
     */
    removeNode(c) {
      var f = this;
      if (Object.hasOwn(this._nodes, c)) {
        var s = (h) => f.removeEdge(f._edgeObjs[h]);
        delete this._nodes[c], this._isCompound && (this._removeFromParentsChildList(c), delete this._parent[c], this.children(c).forEach(function(h) {
          f.setParent(h);
        }), delete this._children[c]), Object.keys(this._in[c]).forEach(s), delete this._in[c], delete this._preds[c], Object.keys(this._out[c]).forEach(s), delete this._out[c], delete this._sucs[c], --this._nodeCount;
      }
      return this;
    }
    /**
     * Sets node p as a parent for node v if it is defined, or removes the
     * parent for v if p is undefined. Method throws an exception in case of
     * invoking it in context of noncompound graph.
     * Average-case complexity: O(1).
     */
    setParent(c, f) {
      if (!this._isCompound)
        throw new Error("Cannot set parent in a non-compound graph");
      if (f === void 0)
        f = t;
      else {
        f += "";
        for (var s = f; s !== void 0; s = this.parent(s))
          if (s === c)
            throw new Error("Setting " + f + " as parent of " + c + " would create a cycle");
        this.setNode(f);
      }
      return this.setNode(c), this._removeFromParentsChildList(c), this._parent[c] = f, this._children[f][c] = !0, this;
    }
    _removeFromParentsChildList(c) {
      delete this._children[this._parent[c]][c];
    }
    /**
     * Gets parent node for node v.
     * Complexity: O(1).
     */
    parent(c) {
      if (this._isCompound) {
        var f = this._parent[c];
        if (f !== t)
          return f;
      }
    }
    /**
     * Gets list of direct children of node v.
     * Complexity: O(1).
     */
    children(c = t) {
      if (this._isCompound) {
        var f = this._children[c];
        if (f)
          return Object.keys(f);
      } else {
        if (c === t)
          return this.nodes();
        if (this.hasNode(c))
          return [];
      }
    }
    /**
     * Return all nodes that are predecessors of the specified node or undefined if node v is not in
     * the graph. Behavior is undefined for undirected graphs - use neighbors instead.
     * Complexity: O(|V|).
     */
    predecessors(c) {
      var f = this._preds[c];
      if (f)
        return Object.keys(f);
    }
    /**
     * Return all nodes that are successors of the specified node or undefined if node v is not in
     * the graph. Behavior is undefined for undirected graphs - use neighbors instead.
     * Complexity: O(|V|).
     */
    successors(c) {
      var f = this._sucs[c];
      if (f)
        return Object.keys(f);
    }
    /**
     * Return all nodes that are predecessors or successors of the specified node or undefined if
     * node v is not in the graph.
     * Complexity: O(|V|).
     */
    neighbors(c) {
      var f = this.predecessors(c);
      if (f) {
        const h = new Set(f);
        for (var s of this.successors(c))
          h.add(s);
        return Array.from(h.values());
      }
    }
    isLeaf(c) {
      var f;
      return this.isDirected() ? f = this.successors(c) : f = this.neighbors(c), f.length === 0;
    }
    /**
     * Creates new graph with nodes filtered via filter. Edges incident to rejected node
     * are also removed. In case of compound graph, if parent is rejected by filter,
     * than all its children are rejected too.
     * Average-case complexity: O(|E|+|V|).
     */
    filterNodes(c) {
      var f = new this.constructor({
        directed: this._isDirected,
        multigraph: this._isMultigraph,
        compound: this._isCompound
      });
      f.setGraph(this.graph());
      var s = this;
      Object.entries(this._nodes).forEach(function([m, y]) {
        c(m) && f.setNode(m, y);
      }), Object.values(this._edgeObjs).forEach(function(m) {
        f.hasNode(m.v) && f.hasNode(m.w) && f.setEdge(m, s.edge(m));
      });
      var h = {};
      function p(m) {
        var y = s.parent(m);
        return y === void 0 || f.hasNode(y) ? (h[m] = y, y) : y in h ? h[y] : p(y);
      }
      return this._isCompound && f.nodes().forEach((m) => f.setParent(m, p(m))), f;
    }
    /* === Edge functions ========== */
    /**
     * Sets the default edge label or factory function. This label will be
     * assigned as default label in case if no label was specified while setting
     * an edge or this function will be invoked each time when setting an edge
     * with no label specified and returned value * will be used as a label for edge.
     * Complexity: O(1).
     */
    setDefaultEdgeLabel(c) {
      return this._defaultEdgeLabelFn = c, typeof c != "function" && (this._defaultEdgeLabelFn = () => c), this;
    }
    /**
     * Gets the number of edges in the graph.
     * Complexity: O(1).
     */
    edgeCount() {
      return this._edgeCount;
    }
    /**
     * Gets edges of the graph. In case of compound graph subgraphs are not considered.
     * Complexity: O(|E|).
     */
    edges() {
      return Object.values(this._edgeObjs);
    }
    /**
     * Establish an edges path over the nodes in nodes list. If some edge is already
     * exists, it will update its label, otherwise it will create an edge between pair
     * of nodes with label provided or default label if no label provided.
     * Complexity: O(|nodes|).
     */
    setPath(c, f) {
      var s = this, h = arguments;
      return c.reduce(function(p, m) {
        return h.length > 1 ? s.setEdge(p, m, f) : s.setEdge(p, m), m;
      }), this;
    }
    /**
     * Creates or updates the label for the edge (v, w) with the optionally supplied
     * name. If label is supplied it is set as the value for the edge. If label is not
     * supplied and the edge was created by this call then the default edge label will
     * be assigned. The name parameter is only useful with multigraphs.
     */
    setEdge() {
      var c, f, s, h, p = !1, m = arguments[0];
      typeof m == "object" && m !== null && "v" in m ? (c = m.v, f = m.w, s = m.name, arguments.length === 2 && (h = arguments[1], p = !0)) : (c = m, f = arguments[1], s = arguments[3], arguments.length > 2 && (h = arguments[2], p = !0)), c = "" + c, f = "" + f, s !== void 0 && (s = "" + s);
      var y = o(this._isDirected, c, f, s);
      if (Object.hasOwn(this._edgeLabels, y))
        return p && (this._edgeLabels[y] = h), this;
      if (s !== void 0 && !this._isMultigraph)
        throw new Error("Cannot set a named edge when isMultigraph = false");
      this.setNode(c), this.setNode(f), this._edgeLabels[y] = p ? h : this._defaultEdgeLabelFn(c, f, s);
      var w = d(this._isDirected, c, f, s);
      return c = w.v, f = w.w, Object.freeze(w), this._edgeObjs[y] = w, i(this._preds[f], c), i(this._sucs[c], f), this._in[f][y] = w, this._out[c][y] = w, this._edgeCount++, this;
    }
    /**
     * Gets the label for the specified edge.
     * Complexity: O(1).
     */
    edge(c, f, s) {
      var h = arguments.length === 1 ? u(this._isDirected, arguments[0]) : o(this._isDirected, c, f, s);
      return this._edgeLabels[h];
    }
    /**
     * Gets the label for the specified edge and converts it to an object.
     * Complexity: O(1)
     */
    edgeAsObj() {
      const c = this.edge(...arguments);
      return typeof c != "object" ? { label: c } : c;
    }
    /**
     * Detects whether the graph contains specified edge or not. No subgraphs are considered.
     * Complexity: O(1).
     */
    hasEdge(c, f, s) {
      var h = arguments.length === 1 ? u(this._isDirected, arguments[0]) : o(this._isDirected, c, f, s);
      return Object.hasOwn(this._edgeLabels, h);
    }
    /**
     * Removes the specified edge from the graph. No subgraphs are considered.
     * Complexity: O(1).
     */
    removeEdge(c, f, s) {
      var h = arguments.length === 1 ? u(this._isDirected, arguments[0]) : o(this._isDirected, c, f, s), p = this._edgeObjs[h];
      return p && (c = p.v, f = p.w, delete this._edgeLabels[h], delete this._edgeObjs[h], a(this._preds[f], c), a(this._sucs[c], f), delete this._in[f][h], delete this._out[c][h], this._edgeCount--), this;
    }
    /**
     * Return all edges that point to the node v. Optionally filters those edges down to just those
     * coming from node u. Behavior is undefined for undirected graphs - use nodeEdges instead.
     * Complexity: O(|E|).
     */
    inEdges(c, f) {
      var s = this._in[c];
      if (s) {
        var h = Object.values(s);
        return f ? h.filter((p) => p.v === f) : h;
      }
    }
    /**
     * Return all edges that are pointed at by node v. Optionally filters those edges down to just
     * those point to w. Behavior is undefined for undirected graphs - use nodeEdges instead.
     * Complexity: O(|E|).
     */
    outEdges(c, f) {
      var s = this._out[c];
      if (s) {
        var h = Object.values(s);
        return f ? h.filter((p) => p.w === f) : h;
      }
    }
    /**
     * Returns all edges to or from node v regardless of direction. Optionally filters those edges
     * down to just those between nodes v and w regardless of direction.
     * Complexity: O(|E|).
     */
    nodeEdges(c, f) {
      var s = this.inEdges(c, f);
      if (s)
        return s.concat(this.outEdges(c, f));
    }
  }
  function i(l, c) {
    l[c] ? l[c]++ : l[c] = 1;
  }
  function a(l, c) {
    --l[c] || delete l[c];
  }
  function o(l, c, f, s) {
    var h = "" + c, p = "" + f;
    if (!l && h > p) {
      var m = h;
      h = p, p = m;
    }
    return h + n + p + n + (s === void 0 ? e : s);
  }
  function d(l, c, f, s) {
    var h = "" + c, p = "" + f;
    if (!l && h > p) {
      var m = h;
      h = p, p = m;
    }
    var y = { v: h, w: p };
    return s && (y.name = s), y;
  }
  function u(l, c) {
    return o(l, c.v, c.w, c.name);
  }
  return Ad = r, Ad;
}
var jd, Ab;
function mF() {
  return Ab || (Ab = 1, jd = "2.2.4"), jd;
}
var Md, jb;
function gF() {
  return jb || (jb = 1, Md = {
    Graph: om(),
    version: mF()
  }), Md;
}
var $d, Mb;
function yF() {
  if (Mb) return $d;
  Mb = 1;
  var e = om();
  $d = {
    write: t,
    read: i
  };
  function t(a) {
    var o = {
      options: {
        directed: a.isDirected(),
        multigraph: a.isMultigraph(),
        compound: a.isCompound()
      },
      nodes: n(a),
      edges: r(a)
    };
    return a.graph() !== void 0 && (o.value = structuredClone(a.graph())), o;
  }
  function n(a) {
    return a.nodes().map(function(o) {
      var d = a.node(o), u = a.parent(o), l = { v: o };
      return d !== void 0 && (l.value = d), u !== void 0 && (l.parent = u), l;
    });
  }
  function r(a) {
    return a.edges().map(function(o) {
      var d = a.edge(o), u = { v: o.v, w: o.w };
      return o.name !== void 0 && (u.name = o.name), d !== void 0 && (u.value = d), u;
    });
  }
  function i(a) {
    var o = new e(a.options).setGraph(a.value);
    return a.nodes.forEach(function(d) {
      o.setNode(d.v, d.value), d.parent && o.setParent(d.v, d.parent);
    }), a.edges.forEach(function(d) {
      o.setEdge({ v: d.v, w: d.w, name: d.name }, d.value);
    }), o;
  }
  return $d;
}
var Rd, $b;
function vF() {
  if ($b) return Rd;
  $b = 1, Rd = e;
  function e(t) {
    var n = {}, r = [], i;
    function a(o) {
      Object.hasOwn(n, o) || (n[o] = !0, i.push(o), t.successors(o).forEach(a), t.predecessors(o).forEach(a));
    }
    return t.nodes().forEach(function(o) {
      i = [], a(o), i.length && r.push(i);
    }), r;
  }
  return Rd;
}
var Zd, Rb;
function pI() {
  if (Rb) return Zd;
  Rb = 1;
  class e {
    _arr = [];
    _keyIndices = {};
    /**
     * Returns the number of elements in the queue. Takes `O(1)` time.
     */
    size() {
      return this._arr.length;
    }
    /**
     * Returns the keys that are in the queue. Takes `O(n)` time.
     */
    keys() {
      return this._arr.map(function(n) {
        return n.key;
      });
    }
    /**
     * Returns `true` if **key** is in the queue and `false` if not.
     */
    has(n) {
      return Object.hasOwn(this._keyIndices, n);
    }
    /**
     * Returns the priority for **key**. If **key** is not present in the queue
     * then this function returns `undefined`. Takes `O(1)` time.
     *
     * @param {Object} key
     */
    priority(n) {
      var r = this._keyIndices[n];
      if (r !== void 0)
        return this._arr[r].priority;
    }
    /**
     * Returns the key for the minimum element in this queue. If the queue is
     * empty this function throws an Error. Takes `O(1)` time.
     */
    min() {
      if (this.size() === 0)
        throw new Error("Queue underflow");
      return this._arr[0].key;
    }
    /**
     * Inserts a new key into the priority queue. If the key already exists in
     * the queue this function returns `false`; otherwise it will return `true`.
     * Takes `O(n)` time.
     *
     * @param {Object} key the key to add
     * @param {Number} priority the initial priority for the key
     */
    add(n, r) {
      var i = this._keyIndices;
      if (n = String(n), !Object.hasOwn(i, n)) {
        var a = this._arr, o = a.length;
        return i[n] = o, a.push({ key: n, priority: r }), this._decrease(o), !0;
      }
      return !1;
    }
    /**
     * Removes and returns the smallest key in the queue. Takes `O(log n)` time.
     */
    removeMin() {
      this._swap(0, this._arr.length - 1);
      var n = this._arr.pop();
      return delete this._keyIndices[n.key], this._heapify(0), n.key;
    }
    /**
     * Decreases the priority for **key** to **priority**. If the new priority is
     * greater than the previous priority, this function will throw an Error.
     *
     * @param {Object} key the key for which to raise priority
     * @param {Number} priority the new priority for the key
     */
    decrease(n, r) {
      var i = this._keyIndices[n];
      if (r > this._arr[i].priority)
        throw new Error("New priority is greater than current priority. Key: " + n + " Old: " + this._arr[i].priority + " New: " + r);
      this._arr[i].priority = r, this._decrease(i);
    }
    _heapify(n) {
      var r = this._arr, i = 2 * n, a = i + 1, o = n;
      i < r.length && (o = r[i].priority < r[o].priority ? i : o, a < r.length && (o = r[a].priority < r[o].priority ? a : o), o !== n && (this._swap(n, o), this._heapify(o)));
    }
    _decrease(n) {
      for (var r = this._arr, i = r[n].priority, a; n !== 0 && (a = n >> 1, !(r[a].priority < i)); )
        this._swap(n, a), n = a;
    }
    _swap(n, r) {
      var i = this._arr, a = this._keyIndices, o = i[n], d = i[r];
      i[n] = d, i[r] = o, a[d.key] = n, a[o.key] = r;
    }
  }
  return Zd = e, Zd;
}
var Ld, Zb;
function mI() {
  if (Zb) return Ld;
  Zb = 1;
  var e = pI();
  Ld = n;
  var t = () => 1;
  function n(i, a, o, d) {
    return r(
      i,
      String(a),
      o || t,
      d || function(u) {
        return i.outEdges(u);
      }
    );
  }
  function r(i, a, o, d) {
    var u = {}, l = new e(), c, f, s = function(h) {
      var p = h.v !== c ? h.v : h.w, m = u[p], y = o(h), w = f.distance + y;
      if (y < 0)
        throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + h + " Weight: " + y);
      w < m.distance && (m.distance = w, m.predecessor = c, l.decrease(p, w));
    };
    for (i.nodes().forEach(function(h) {
      var p = h === a ? 0 : Number.POSITIVE_INFINITY;
      u[h] = { distance: p }, l.add(h, p);
    }); l.size() > 0 && (c = l.removeMin(), f = u[c], f.distance !== Number.POSITIVE_INFINITY); )
      d(c).forEach(s);
    return u;
  }
  return Ld;
}
var Fd, Lb;
function bF() {
  if (Lb) return Fd;
  Lb = 1;
  var e = mI();
  Fd = t;
  function t(n, r, i) {
    return n.nodes().reduce(function(a, o) {
      return a[o] = e(n, o, r, i), a;
    }, {});
  }
  return Fd;
}
var Ud, Fb;
function gI() {
  if (Fb) return Ud;
  Fb = 1, Ud = e;
  function e(t) {
    var n = 0, r = [], i = {}, a = [];
    function o(d) {
      var u = i[d] = {
        onStack: !0,
        lowlink: n,
        index: n++
      };
      if (r.push(d), t.successors(d).forEach(function(f) {
        Object.hasOwn(i, f) ? i[f].onStack && (u.lowlink = Math.min(u.lowlink, i[f].index)) : (o(f), u.lowlink = Math.min(u.lowlink, i[f].lowlink));
      }), u.lowlink === u.index) {
        var l = [], c;
        do
          c = r.pop(), i[c].onStack = !1, l.push(c);
        while (d !== c);
        a.push(l);
      }
    }
    return t.nodes().forEach(function(d) {
      Object.hasOwn(i, d) || o(d);
    }), a;
  }
  return Ud;
}
var Bd, Ub;
function _F() {
  if (Ub) return Bd;
  Ub = 1;
  var e = gI();
  Bd = t;
  function t(n) {
    return e(n).filter(function(r) {
      return r.length > 1 || r.length === 1 && n.hasEdge(r[0], r[0]);
    });
  }
  return Bd;
}
var Vd, Bb;
function wF() {
  if (Bb) return Vd;
  Bb = 1, Vd = t;
  var e = () => 1;
  function t(r, i, a) {
    return n(
      r,
      i || e,
      a || function(o) {
        return r.outEdges(o);
      }
    );
  }
  function n(r, i, a) {
    var o = {}, d = r.nodes();
    return d.forEach(function(u) {
      o[u] = {}, o[u][u] = { distance: 0 }, d.forEach(function(l) {
        u !== l && (o[u][l] = { distance: Number.POSITIVE_INFINITY });
      }), a(u).forEach(function(l) {
        var c = l.v === u ? l.w : l.v, f = i(l);
        o[u][c] = { distance: f, predecessor: u };
      });
    }), d.forEach(function(u) {
      var l = o[u];
      d.forEach(function(c) {
        var f = o[c];
        d.forEach(function(s) {
          var h = f[u], p = l[s], m = f[s], y = h.distance + p.distance;
          y < m.distance && (m.distance = y, m.predecessor = p.predecessor);
        });
      });
    }), o;
  }
  return Vd;
}
var qd, Vb;
function yI() {
  if (Vb) return qd;
  Vb = 1;
  function e(n) {
    var r = {}, i = {}, a = [];
    function o(d) {
      if (Object.hasOwn(i, d))
        throw new t();
      Object.hasOwn(r, d) || (i[d] = !0, r[d] = !0, n.predecessors(d).forEach(o), delete i[d], a.push(d));
    }
    if (n.sinks().forEach(o), Object.keys(r).length !== n.nodeCount())
      throw new t();
    return a;
  }
  class t extends Error {
    constructor() {
      super(...arguments);
    }
  }
  return qd = e, e.CycleException = t, qd;
}
var Hd, qb;
function kF() {
  if (qb) return Hd;
  qb = 1;
  var e = yI();
  Hd = t;
  function t(n) {
    try {
      e(n);
    } catch (r) {
      if (r instanceof e.CycleException)
        return !1;
      throw r;
    }
    return !0;
  }
  return Hd;
}
var Wd, Hb;
function vI() {
  if (Hb) return Wd;
  Hb = 1, Wd = e;
  function e(i, a, o) {
    Array.isArray(a) || (a = [a]);
    var d = i.isDirected() ? (f) => i.successors(f) : (f) => i.neighbors(f), u = o === "post" ? t : n, l = [], c = {};
    return a.forEach((f) => {
      if (!i.hasNode(f))
        throw new Error("Graph does not have node: " + f);
      u(f, d, c, l);
    }), l;
  }
  function t(i, a, o, d) {
    for (var u = [[i, !1]]; u.length > 0; ) {
      var l = u.pop();
      l[1] ? d.push(l[0]) : Object.hasOwn(o, l[0]) || (o[l[0]] = !0, u.push([l[0], !0]), r(a(l[0]), (c) => u.push([c, !1])));
    }
  }
  function n(i, a, o, d) {
    for (var u = [i]; u.length > 0; ) {
      var l = u.pop();
      Object.hasOwn(o, l) || (o[l] = !0, d.push(l), r(a(l), (c) => u.push(c)));
    }
  }
  function r(i, a) {
    for (var o = i.length; o--; )
      a(i[o], o, i);
    return i;
  }
  return Wd;
}
var Gd, Wb;
function SF() {
  if (Wb) return Gd;
  Wb = 1;
  var e = vI();
  Gd = t;
  function t(n, r) {
    return e(n, r, "post");
  }
  return Gd;
}
var Kd, Gb;
function xF() {
  if (Gb) return Kd;
  Gb = 1;
  var e = vI();
  Kd = t;
  function t(n, r) {
    return e(n, r, "pre");
  }
  return Kd;
}
var Jd, Kb;
function IF() {
  if (Kb) return Jd;
  Kb = 1;
  var e = om(), t = pI();
  Jd = n;
  function n(r, i) {
    var a = new e(), o = {}, d = new t(), u;
    function l(f) {
      var s = f.v === u ? f.w : f.v, h = d.priority(s);
      if (h !== void 0) {
        var p = i(f);
        p < h && (o[s] = u, d.decrease(s, p));
      }
    }
    if (r.nodeCount() === 0)
      return a;
    r.nodes().forEach(function(f) {
      d.add(f, Number.POSITIVE_INFINITY), a.setNode(f);
    }), d.decrease(r.nodes()[0], 0);
    for (var c = !1; d.size() > 0; ) {
      if (u = d.removeMin(), Object.hasOwn(o, u))
        a.setEdge(u, o[u]);
      else {
        if (c)
          throw new Error("Input graph is not connected: " + r);
        c = !0;
      }
      r.nodeEdges(u).forEach(l);
    }
    return a;
  }
  return Jd;
}
var Xd, Jb;
function PF() {
  return Jb || (Jb = 1, Xd = {
    components: vF(),
    dijkstra: mI(),
    dijkstraAll: bF(),
    findCycles: _F(),
    floydWarshall: wF(),
    isAcyclic: kF(),
    postorder: SF(),
    preorder: xF(),
    prim: IF(),
    tarjan: gI(),
    topsort: yI()
  }), Xd;
}
var Yd, Xb;
function Nn() {
  if (Xb) return Yd;
  Xb = 1;
  var e = gF();
  return Yd = {
    Graph: e.Graph,
    json: yF(),
    alg: PF(),
    version: e.version
  }, Yd;
}
var Qd, Yb;
function OF() {
  if (Yb) return Qd;
  Yb = 1;
  class e {
    constructor() {
      let i = {};
      i._next = i._prev = i, this._sentinel = i;
    }
    dequeue() {
      let i = this._sentinel, a = i._prev;
      if (a !== i)
        return t(a), a;
    }
    enqueue(i) {
      let a = this._sentinel;
      i._prev && i._next && t(i), i._next = a._next, a._next._prev = i, a._next = i, i._prev = a;
    }
    toString() {
      let i = [], a = this._sentinel, o = a._prev;
      for (; o !== a; )
        i.push(JSON.stringify(o, n)), o = o._prev;
      return "[" + i.join(", ") + "]";
    }
  }
  function t(r) {
    r._prev._next = r._next, r._next._prev = r._prev, delete r._next, delete r._prev;
  }
  function n(r, i) {
    if (r !== "_next" && r !== "_prev")
      return i;
  }
  return Qd = e, Qd;
}
var ef, Qb;
function zF() {
  if (Qb) return ef;
  Qb = 1;
  let e = Nn().Graph, t = OF();
  ef = r;
  let n = () => 1;
  function r(l, c) {
    if (l.nodeCount() <= 1)
      return [];
    let f = o(l, c || n);
    return i(f.graph, f.buckets, f.zeroIdx).flatMap((h) => l.outEdges(h.v, h.w));
  }
  function i(l, c, f) {
    let s = [], h = c[c.length - 1], p = c[0], m;
    for (; l.nodeCount(); ) {
      for (; m = p.dequeue(); )
        a(l, c, f, m);
      for (; m = h.dequeue(); )
        a(l, c, f, m);
      if (l.nodeCount()) {
        for (let y = c.length - 2; y > 0; --y)
          if (m = c[y].dequeue(), m) {
            s = s.concat(a(l, c, f, m, !0));
            break;
          }
      }
    }
    return s;
  }
  function a(l, c, f, s, h) {
    let p = h ? [] : void 0;
    return l.inEdges(s.v).forEach((m) => {
      let y = l.edge(m), w = l.node(m.v);
      h && p.push({ v: m.v, w: m.w }), w.out -= y, d(c, f, w);
    }), l.outEdges(s.v).forEach((m) => {
      let y = l.edge(m), w = m.w, b = l.node(w);
      b.in -= y, d(c, f, b);
    }), l.removeNode(s.v), p;
  }
  function o(l, c) {
    let f = new e(), s = 0, h = 0;
    l.nodes().forEach((y) => {
      f.setNode(y, { v: y, in: 0, out: 0 });
    }), l.edges().forEach((y) => {
      let w = f.edge(y.v, y.w) || 0, b = c(y), _ = w + b;
      f.setEdge(y.v, y.w, _), h = Math.max(h, f.node(y.v).out += b), s = Math.max(s, f.node(y.w).in += b);
    });
    let p = u(h + s + 3).map(() => new t()), m = s + 1;
    return f.nodes().forEach((y) => {
      d(p, m, f.node(y));
    }), { graph: f, buckets: p, zeroIdx: m };
  }
  function d(l, c, f) {
    f.out ? f.in ? l[f.out - f.in + c].enqueue(f) : l[l.length - 1].enqueue(f) : l[0].enqueue(f);
  }
  function u(l) {
    const c = [];
    for (let f = 0; f < l; f++)
      c.push(f);
    return c;
  }
  return ef;
}
var tf, e_;
function _t() {
  if (e_) return tf;
  e_ = 1;
  let e = Nn().Graph;
  tf = {
    addBorderNode: c,
    addDummyNode: t,
    applyWithChunking: h,
    asNonCompoundGraph: r,
    buildLayerMatrix: d,
    intersectRect: o,
    mapValues: P,
    maxRank: p,
    normalizeRanks: u,
    notime: w,
    partition: m,
    pick: O,
    predecessorWeights: a,
    range: g,
    removeEmptyRanks: l,
    simplify: n,
    successorWeights: i,
    time: y,
    uniqueId: _,
    zipObject: E
  };
  function t(T, D, N, M) {
    for (var R = M; T.hasNode(R); )
      R = _(M);
    return N.dummy = D, T.setNode(R, N), R;
  }
  function n(T) {
    let D = new e().setGraph(T.graph());
    return T.nodes().forEach((N) => D.setNode(N, T.node(N))), T.edges().forEach((N) => {
      let M = D.edge(N.v, N.w) || { weight: 0, minlen: 1 }, R = T.edge(N);
      D.setEdge(N.v, N.w, {
        weight: M.weight + R.weight,
        minlen: Math.max(M.minlen, R.minlen)
      });
    }), D;
  }
  function r(T) {
    let D = new e({ multigraph: T.isMultigraph() }).setGraph(T.graph());
    return T.nodes().forEach((N) => {
      T.children(N).length || D.setNode(N, T.node(N));
    }), T.edges().forEach((N) => {
      D.setEdge(N, T.edge(N));
    }), D;
  }
  function i(T) {
    let D = T.nodes().map((N) => {
      let M = {};
      return T.outEdges(N).forEach((R) => {
        M[R.w] = (M[R.w] || 0) + T.edge(R).weight;
      }), M;
    });
    return E(T.nodes(), D);
  }
  function a(T) {
    let D = T.nodes().map((N) => {
      let M = {};
      return T.inEdges(N).forEach((R) => {
        M[R.v] = (M[R.v] || 0) + T.edge(R).weight;
      }), M;
    });
    return E(T.nodes(), D);
  }
  function o(T, D) {
    let N = T.x, M = T.y, R = D.x - N, V = D.y - M, C = T.width / 2, B = T.height / 2;
    if (!R && !V)
      throw new Error("Not possible to find intersection inside of the rectangle");
    let G, Q;
    return Math.abs(V) * C > Math.abs(R) * B ? (V < 0 && (B = -B), G = B * R / V, Q = B) : (R < 0 && (C = -C), G = C, Q = C * V / R), { x: N + G, y: M + Q };
  }
  function d(T) {
    let D = g(p(T) + 1).map(() => []);
    return T.nodes().forEach((N) => {
      let M = T.node(N), R = M.rank;
      R !== void 0 && (D[R][M.order] = N);
    }), D;
  }
  function u(T) {
    let D = T.nodes().map((M) => {
      let R = T.node(M).rank;
      return R === void 0 ? Number.MAX_VALUE : R;
    }), N = h(Math.min, D);
    T.nodes().forEach((M) => {
      let R = T.node(M);
      Object.hasOwn(R, "rank") && (R.rank -= N);
    });
  }
  function l(T) {
    let D = T.nodes().map((C) => T.node(C).rank), N = h(Math.min, D), M = [];
    T.nodes().forEach((C) => {
      let B = T.node(C).rank - N;
      M[B] || (M[B] = []), M[B].push(C);
    });
    let R = 0, V = T.graph().nodeRankFactor;
    Array.from(M).forEach((C, B) => {
      C === void 0 && B % V !== 0 ? --R : C !== void 0 && R && C.forEach((G) => T.node(G).rank += R);
    });
  }
  function c(T, D, N, M) {
    let R = {
      width: 0,
      height: 0
    };
    return arguments.length >= 4 && (R.rank = N, R.order = M), t(T, "border", R, D);
  }
  function f(T, D = s) {
    const N = [];
    for (let M = 0; M < T.length; M += D) {
      const R = T.slice(M, M + D);
      N.push(R);
    }
    return N;
  }
  const s = 65535;
  function h(T, D) {
    if (D.length > s) {
      const N = f(D);
      return T.apply(null, N.map((M) => T.apply(null, M)));
    } else
      return T.apply(null, D);
  }
  function p(T) {
    const N = T.nodes().map((M) => {
      let R = T.node(M).rank;
      return R === void 0 ? Number.MIN_VALUE : R;
    });
    return h(Math.max, N);
  }
  function m(T, D) {
    let N = { lhs: [], rhs: [] };
    return T.forEach((M) => {
      D(M) ? N.lhs.push(M) : N.rhs.push(M);
    }), N;
  }
  function y(T, D) {
    let N = Date.now();
    try {
      return D();
    } finally {
      console.log(T + " time: " + (Date.now() - N) + "ms");
    }
  }
  function w(T, D) {
    return D();
  }
  let b = 0;
  function _(T) {
    var D = ++b;
    return T + ("" + D);
  }
  function g(T, D, N = 1) {
    D == null && (D = T, T = 0);
    let M = (V) => V < D;
    N < 0 && (M = (V) => D < V);
    const R = [];
    for (let V = T; M(V); V += N)
      R.push(V);
    return R;
  }
  function O(T, D) {
    const N = {};
    for (const M of D)
      T[M] !== void 0 && (N[M] = T[M]);
    return N;
  }
  function P(T, D) {
    let N = D;
    return typeof D == "string" && (N = (M) => M[D]), Object.entries(T).reduce((M, [R, V]) => (M[R] = N(V, R), M), {});
  }
  function E(T, D) {
    return T.reduce((N, M, R) => (N[M] = D[R], N), {});
  }
  return tf;
}
var nf, t_;
function EF() {
  if (t_) return nf;
  t_ = 1;
  let e = zF(), t = _t().uniqueId;
  nf = {
    run: n,
    undo: i
  };
  function n(a) {
    (a.graph().acyclicer === "greedy" ? e(a, d(a)) : r(a)).forEach((u) => {
      let l = a.edge(u);
      a.removeEdge(u), l.forwardName = u.name, l.reversed = !0, a.setEdge(u.w, u.v, l, t("rev"));
    });
    function d(u) {
      return (l) => u.edge(l).weight;
    }
  }
  function r(a) {
    let o = [], d = {}, u = {};
    function l(c) {
      Object.hasOwn(u, c) || (u[c] = !0, d[c] = !0, a.outEdges(c).forEach((f) => {
        Object.hasOwn(d, f.w) ? o.push(f) : l(f.w);
      }), delete d[c]);
    }
    return a.nodes().forEach(l), o;
  }
  function i(a) {
    a.edges().forEach((o) => {
      let d = a.edge(o);
      if (d.reversed) {
        a.removeEdge(o);
        let u = d.forwardName;
        delete d.reversed, delete d.forwardName, a.setEdge(o.w, o.v, d, u);
      }
    });
  }
  return nf;
}
var rf, n_;
function TF() {
  if (n_) return rf;
  n_ = 1;
  let e = _t();
  rf = {
    run: t,
    undo: r
  };
  function t(i) {
    i.graph().dummyChains = [], i.edges().forEach((a) => n(i, a));
  }
  function n(i, a) {
    let o = a.v, d = i.node(o).rank, u = a.w, l = i.node(u).rank, c = a.name, f = i.edge(a), s = f.labelRank;
    if (l === d + 1) return;
    i.removeEdge(a);
    let h, p, m;
    for (m = 0, ++d; d < l; ++m, ++d)
      f.points = [], p = {
        width: 0,
        height: 0,
        edgeLabel: f,
        edgeObj: a,
        rank: d
      }, h = e.addDummyNode(i, "edge", p, "_d"), d === s && (p.width = f.width, p.height = f.height, p.dummy = "edge-label", p.labelpos = f.labelpos), i.setEdge(o, h, { weight: f.weight }, c), m === 0 && i.graph().dummyChains.push(h), o = h;
    i.setEdge(o, u, { weight: f.weight }, c);
  }
  function r(i) {
    i.graph().dummyChains.forEach((a) => {
      let o = i.node(a), d = o.edgeLabel, u;
      for (i.setEdge(o.edgeObj, d); o.dummy; )
        u = i.successors(a)[0], i.removeNode(a), d.points.push({ x: o.x, y: o.y }), o.dummy === "edge-label" && (d.x = o.x, d.y = o.y, d.width = o.width, d.height = o.height), a = u, o = i.node(a);
    });
  }
  return rf;
}
var of, r_;
function Du() {
  if (r_) return of;
  r_ = 1;
  const { applyWithChunking: e } = _t();
  of = {
    longestPath: t,
    slack: n
  };
  function t(r) {
    var i = {};
    function a(o) {
      var d = r.node(o);
      if (Object.hasOwn(i, o))
        return d.rank;
      i[o] = !0;
      let u = r.outEdges(o).map((c) => c == null ? Number.POSITIVE_INFINITY : a(c.w) - r.edge(c).minlen);
      var l = e(Math.min, u);
      return l === Number.POSITIVE_INFINITY && (l = 0), d.rank = l;
    }
    r.sources().forEach(a);
  }
  function n(r, i) {
    return r.node(i.w).rank - r.node(i.v).rank - r.edge(i).minlen;
  }
  return of;
}
var af, i_;
function bI() {
  if (i_) return af;
  i_ = 1;
  var e = Nn().Graph, t = Du().slack;
  af = n;
  function n(o) {
    var d = new e({ directed: !1 }), u = o.nodes()[0], l = o.nodeCount();
    d.setNode(u, {});
    for (var c, f; r(d, o) < l; )
      c = i(d, o), f = d.hasNode(c.v) ? t(o, c) : -t(o, c), a(d, o, f);
    return d;
  }
  function r(o, d) {
    function u(l) {
      d.nodeEdges(l).forEach((c) => {
        var f = c.v, s = l === f ? c.w : f;
        !o.hasNode(s) && !t(d, c) && (o.setNode(s, {}), o.setEdge(l, s, {}), u(s));
      });
    }
    return o.nodes().forEach(u), o.nodeCount();
  }
  function i(o, d) {
    return d.edges().reduce((l, c) => {
      let f = Number.POSITIVE_INFINITY;
      return o.hasNode(c.v) !== o.hasNode(c.w) && (f = t(d, c)), f < l[0] ? [f, c] : l;
    }, [Number.POSITIVE_INFINITY, null])[1];
  }
  function a(o, d, u) {
    o.nodes().forEach((l) => d.node(l).rank += u);
  }
  return af;
}
var sf, o_;
function NF() {
  if (o_) return sf;
  o_ = 1;
  var e = bI(), t = Du().slack, n = Du().longestPath, r = Nn().alg.preorder, i = Nn().alg.postorder, a = _t().simplify;
  sf = o, o.initLowLimValues = c, o.initCutValues = d, o.calcCutValue = l, o.leaveEdge = s, o.enterEdge = h, o.exchangeEdges = p;
  function o(b) {
    b = a(b), n(b);
    var _ = e(b);
    c(_), d(_, b);
    for (var g, O; g = s(_); )
      O = h(_, b, g), p(_, b, g, O);
  }
  function d(b, _) {
    var g = i(b, b.nodes());
    g = g.slice(0, g.length - 1), g.forEach((O) => u(b, _, O));
  }
  function u(b, _, g) {
    var O = b.node(g), P = O.parent;
    b.edge(g, P).cutvalue = l(b, _, g);
  }
  function l(b, _, g) {
    var O = b.node(g), P = O.parent, E = !0, T = _.edge(g, P), D = 0;
    return T || (E = !1, T = _.edge(P, g)), D = T.weight, _.nodeEdges(g).forEach((N) => {
      var M = N.v === g, R = M ? N.w : N.v;
      if (R !== P) {
        var V = M === E, C = _.edge(N).weight;
        if (D += V ? C : -C, y(b, g, R)) {
          var B = b.edge(g, R).cutvalue;
          D += V ? -B : B;
        }
      }
    }), D;
  }
  function c(b, _) {
    arguments.length < 2 && (_ = b.nodes()[0]), f(b, {}, 1, _);
  }
  function f(b, _, g, O, P) {
    var E = g, T = b.node(O);
    return _[O] = !0, b.neighbors(O).forEach((D) => {
      Object.hasOwn(_, D) || (g = f(b, _, g, D, O));
    }), T.low = E, T.lim = g++, P ? T.parent = P : delete T.parent, g;
  }
  function s(b) {
    return b.edges().find((_) => b.edge(_).cutvalue < 0);
  }
  function h(b, _, g) {
    var O = g.v, P = g.w;
    _.hasEdge(O, P) || (O = g.w, P = g.v);
    var E = b.node(O), T = b.node(P), D = E, N = !1;
    E.lim > T.lim && (D = T, N = !0);
    var M = _.edges().filter((R) => N === w(b, b.node(R.v), D) && N !== w(b, b.node(R.w), D));
    return M.reduce((R, V) => t(_, V) < t(_, R) ? V : R);
  }
  function p(b, _, g, O) {
    var P = g.v, E = g.w;
    b.removeEdge(P, E), b.setEdge(O.v, O.w, {}), c(b), d(b, _), m(b, _);
  }
  function m(b, _) {
    var g = b.nodes().find((P) => !_.node(P).parent), O = r(b, g);
    O = O.slice(1), O.forEach((P) => {
      var E = b.node(P).parent, T = _.edge(P, E), D = !1;
      T || (T = _.edge(E, P), D = !0), _.node(P).rank = _.node(E).rank + (D ? T.minlen : -T.minlen);
    });
  }
  function y(b, _, g) {
    return b.hasEdge(_, g);
  }
  function w(b, _, g) {
    return g.low <= _.lim && _.lim <= g.lim;
  }
  return sf;
}
var lf, a_;
function CF() {
  if (a_) return lf;
  a_ = 1;
  var e = Du(), t = e.longestPath, n = bI(), r = NF();
  lf = i;
  function i(u) {
    var l = u.graph().ranker;
    if (l instanceof Function)
      return l(u);
    switch (u.graph().ranker) {
      case "network-simplex":
        d(u);
        break;
      case "tight-tree":
        o(u);
        break;
      case "longest-path":
        a(u);
        break;
      case "none":
        break;
      default:
        d(u);
    }
  }
  var a = t;
  function o(u) {
    t(u), n(u);
  }
  function d(u) {
    r(u);
  }
  return lf;
}
var uf, s_;
function DF() {
  if (s_) return uf;
  s_ = 1, uf = e;
  function e(r) {
    let i = n(r);
    r.graph().dummyChains.forEach((a) => {
      let o = r.node(a), d = o.edgeObj, u = t(r, i, d.v, d.w), l = u.path, c = u.lca, f = 0, s = l[f], h = !0;
      for (; a !== d.w; ) {
        if (o = r.node(a), h) {
          for (; (s = l[f]) !== c && r.node(s).maxRank < o.rank; )
            f++;
          s === c && (h = !1);
        }
        if (!h) {
          for (; f < l.length - 1 && r.node(s = l[f + 1]).minRank <= o.rank; )
            f++;
          s = l[f];
        }
        r.setParent(a, s), a = r.successors(a)[0];
      }
    });
  }
  function t(r, i, a, o) {
    let d = [], u = [], l = Math.min(i[a].low, i[o].low), c = Math.max(i[a].lim, i[o].lim), f, s;
    f = a;
    do
      f = r.parent(f), d.push(f);
    while (f && (i[f].low > l || c > i[f].lim));
    for (s = f, f = o; (f = r.parent(f)) !== s; )
      u.push(f);
    return { path: d.concat(u.reverse()), lca: s };
  }
  function n(r) {
    let i = {}, a = 0;
    function o(d) {
      let u = a;
      r.children(d).forEach(o), i[d] = { low: u, lim: a++ };
    }
    return r.children().forEach(o), i;
  }
  return uf;
}
var cf, l_;
function AF() {
  if (l_) return cf;
  l_ = 1;
  let e = _t();
  cf = {
    run: t,
    cleanup: a
  };
  function t(o) {
    let d = e.addDummyNode(o, "root", {}, "_root"), u = r(o), l = Object.values(u), c = e.applyWithChunking(Math.max, l) - 1, f = 2 * c + 1;
    o.graph().nestingRoot = d, o.edges().forEach((h) => o.edge(h).minlen *= f);
    let s = i(o) + 1;
    o.children().forEach((h) => n(o, d, f, s, c, u, h)), o.graph().nodeRankFactor = f;
  }
  function n(o, d, u, l, c, f, s) {
    let h = o.children(s);
    if (!h.length) {
      s !== d && o.setEdge(d, s, { weight: 0, minlen: u });
      return;
    }
    let p = e.addBorderNode(o, "_bt"), m = e.addBorderNode(o, "_bb"), y = o.node(s);
    o.setParent(p, s), y.borderTop = p, o.setParent(m, s), y.borderBottom = m, h.forEach((w) => {
      n(o, d, u, l, c, f, w);
      let b = o.node(w), _ = b.borderTop ? b.borderTop : w, g = b.borderBottom ? b.borderBottom : w, O = b.borderTop ? l : 2 * l, P = _ !== g ? 1 : c - f[s] + 1;
      o.setEdge(p, _, {
        weight: O,
        minlen: P,
        nestingEdge: !0
      }), o.setEdge(g, m, {
        weight: O,
        minlen: P,
        nestingEdge: !0
      });
    }), o.parent(s) || o.setEdge(d, p, { weight: 0, minlen: c + f[s] });
  }
  function r(o) {
    var d = {};
    function u(l, c) {
      var f = o.children(l);
      f && f.length && f.forEach((s) => u(s, c + 1)), d[l] = c;
    }
    return o.children().forEach((l) => u(l, 1)), d;
  }
  function i(o) {
    return o.edges().reduce((d, u) => d + o.edge(u).weight, 0);
  }
  function a(o) {
    var d = o.graph();
    o.removeNode(d.nestingRoot), delete d.nestingRoot, o.edges().forEach((u) => {
      var l = o.edge(u);
      l.nestingEdge && o.removeEdge(u);
    });
  }
  return cf;
}
var df, u_;
function jF() {
  if (u_) return df;
  u_ = 1;
  let e = _t();
  df = t;
  function t(r) {
    function i(a) {
      let o = r.children(a), d = r.node(a);
      if (o.length && o.forEach(i), Object.hasOwn(d, "minRank")) {
        d.borderLeft = [], d.borderRight = [];
        for (let u = d.minRank, l = d.maxRank + 1; u < l; ++u)
          n(r, "borderLeft", "_bl", a, d, u), n(r, "borderRight", "_br", a, d, u);
      }
    }
    r.children().forEach(i);
  }
  function n(r, i, a, o, d, u) {
    let l = { width: 0, height: 0, rank: u, borderType: i }, c = d[i][u - 1], f = e.addDummyNode(r, "border", l, a);
    d[i][u] = f, r.setParent(f, o), c && r.setEdge(c, f, { weight: 1 });
  }
  return df;
}
var ff, c_;
function MF() {
  if (c_) return ff;
  c_ = 1, ff = {
    adjust: e,
    undo: t
  };
  function e(u) {
    let l = u.graph().rankdir.toLowerCase();
    (l === "lr" || l === "rl") && n(u);
  }
  function t(u) {
    let l = u.graph().rankdir.toLowerCase();
    (l === "bt" || l === "rl") && i(u), (l === "lr" || l === "rl") && (o(u), n(u));
  }
  function n(u) {
    u.nodes().forEach((l) => r(u.node(l))), u.edges().forEach((l) => r(u.edge(l)));
  }
  function r(u) {
    let l = u.width;
    u.width = u.height, u.height = l;
  }
  function i(u) {
    u.nodes().forEach((l) => a(u.node(l))), u.edges().forEach((l) => {
      let c = u.edge(l);
      c.points.forEach(a), Object.hasOwn(c, "y") && a(c);
    });
  }
  function a(u) {
    u.y = -u.y;
  }
  function o(u) {
    u.nodes().forEach((l) => d(u.node(l))), u.edges().forEach((l) => {
      let c = u.edge(l);
      c.points.forEach(d), Object.hasOwn(c, "x") && d(c);
    });
  }
  function d(u) {
    let l = u.x;
    u.x = u.y, u.y = l;
  }
  return ff;
}
var hf, d_;
function $F() {
  if (d_) return hf;
  d_ = 1;
  let e = _t();
  hf = t;
  function t(n) {
    let r = {}, i = n.nodes().filter((c) => !n.children(c).length), a = i.map((c) => n.node(c).rank), o = e.applyWithChunking(Math.max, a), d = e.range(o + 1).map(() => []);
    function u(c) {
      if (r[c]) return;
      r[c] = !0;
      let f = n.node(c);
      d[f.rank].push(c), n.successors(c).forEach(u);
    }
    return i.sort((c, f) => n.node(c).rank - n.node(f).rank).forEach(u), d;
  }
  return hf;
}
var pf, f_;
function RF() {
  if (f_) return pf;
  f_ = 1;
  let e = _t().zipObject;
  pf = t;
  function t(r, i) {
    let a = 0;
    for (let o = 1; o < i.length; ++o)
      a += n(r, i[o - 1], i[o]);
    return a;
  }
  function n(r, i, a) {
    let o = e(a, a.map((s, h) => h)), d = i.flatMap((s) => r.outEdges(s).map((h) => ({ pos: o[h.w], weight: r.edge(h).weight })).sort((h, p) => h.pos - p.pos)), u = 1;
    for (; u < a.length; ) u <<= 1;
    let l = 2 * u - 1;
    u -= 1;
    let c = new Array(l).fill(0), f = 0;
    return d.forEach((s) => {
      let h = s.pos + u;
      c[h] += s.weight;
      let p = 0;
      for (; h > 0; )
        h % 2 && (p += c[h + 1]), h = h - 1 >> 1, c[h] += s.weight;
      f += s.weight * p;
    }), f;
  }
  return pf;
}
var mf, h_;
function ZF() {
  if (h_) return mf;
  h_ = 1, mf = e;
  function e(t, n = []) {
    return n.map((r) => {
      let i = t.inEdges(r);
      if (i.length) {
        let a = i.reduce((o, d) => {
          let u = t.edge(d), l = t.node(d.v);
          return {
            sum: o.sum + u.weight * l.order,
            weight: o.weight + u.weight
          };
        }, { sum: 0, weight: 0 });
        return {
          v: r,
          barycenter: a.sum / a.weight,
          weight: a.weight
        };
      } else
        return { v: r };
    });
  }
  return mf;
}
var gf, p_;
function LF() {
  if (p_) return gf;
  p_ = 1;
  let e = _t();
  gf = t;
  function t(i, a) {
    let o = {};
    i.forEach((u, l) => {
      let c = o[u.v] = {
        indegree: 0,
        in: [],
        out: [],
        vs: [u.v],
        i: l
      };
      u.barycenter !== void 0 && (c.barycenter = u.barycenter, c.weight = u.weight);
    }), a.edges().forEach((u) => {
      let l = o[u.v], c = o[u.w];
      l !== void 0 && c !== void 0 && (c.indegree++, l.out.push(o[u.w]));
    });
    let d = Object.values(o).filter((u) => !u.indegree);
    return n(d);
  }
  function n(i) {
    let a = [];
    function o(u) {
      return (l) => {
        l.merged || (l.barycenter === void 0 || u.barycenter === void 0 || l.barycenter >= u.barycenter) && r(u, l);
      };
    }
    function d(u) {
      return (l) => {
        l.in.push(u), --l.indegree === 0 && i.push(l);
      };
    }
    for (; i.length; ) {
      let u = i.pop();
      a.push(u), u.in.reverse().forEach(o(u)), u.out.forEach(d(u));
    }
    return a.filter((u) => !u.merged).map((u) => e.pick(u, ["vs", "i", "barycenter", "weight"]));
  }
  function r(i, a) {
    let o = 0, d = 0;
    i.weight && (o += i.barycenter * i.weight, d += i.weight), a.weight && (o += a.barycenter * a.weight, d += a.weight), i.vs = a.vs.concat(i.vs), i.barycenter = o / d, i.weight = d, i.i = Math.min(a.i, i.i), a.merged = !0;
  }
  return gf;
}
var yf, m_;
function FF() {
  if (m_) return yf;
  m_ = 1;
  let e = _t();
  yf = t;
  function t(i, a) {
    let o = e.partition(i, (p) => Object.hasOwn(p, "barycenter")), d = o.lhs, u = o.rhs.sort((p, m) => m.i - p.i), l = [], c = 0, f = 0, s = 0;
    d.sort(r(!!a)), s = n(l, u, s), d.forEach((p) => {
      s += p.vs.length, l.push(p.vs), c += p.barycenter * p.weight, f += p.weight, s = n(l, u, s);
    });
    let h = { vs: l.flat(!0) };
    return f && (h.barycenter = c / f, h.weight = f), h;
  }
  function n(i, a, o) {
    let d;
    for (; a.length && (d = a[a.length - 1]).i <= o; )
      a.pop(), i.push(d.vs), o++;
    return o;
  }
  function r(i) {
    return (a, o) => a.barycenter < o.barycenter ? -1 : a.barycenter > o.barycenter ? 1 : i ? o.i - a.i : a.i - o.i;
  }
  return yf;
}
var vf, g_;
function UF() {
  if (g_) return vf;
  g_ = 1;
  let e = ZF(), t = LF(), n = FF();
  vf = r;
  function r(o, d, u, l) {
    let c = o.children(d), f = o.node(d), s = f ? f.borderLeft : void 0, h = f ? f.borderRight : void 0, p = {};
    s && (c = c.filter((b) => b !== s && b !== h));
    let m = e(o, c);
    m.forEach((b) => {
      if (o.children(b.v).length) {
        let _ = r(o, b.v, u, l);
        p[b.v] = _, Object.hasOwn(_, "barycenter") && a(b, _);
      }
    });
    let y = t(m, u);
    i(y, p);
    let w = n(y, l);
    if (s && (w.vs = [s, w.vs, h].flat(!0), o.predecessors(s).length)) {
      let b = o.node(o.predecessors(s)[0]), _ = o.node(o.predecessors(h)[0]);
      Object.hasOwn(w, "barycenter") || (w.barycenter = 0, w.weight = 0), w.barycenter = (w.barycenter * w.weight + b.order + _.order) / (w.weight + 2), w.weight += 2;
    }
    return w;
  }
  function i(o, d) {
    o.forEach((u) => {
      u.vs = u.vs.flatMap((l) => d[l] ? d[l].vs : l);
    });
  }
  function a(o, d) {
    o.barycenter !== void 0 ? (o.barycenter = (o.barycenter * o.weight + d.barycenter * d.weight) / (o.weight + d.weight), o.weight += d.weight) : (o.barycenter = d.barycenter, o.weight = d.weight);
  }
  return vf;
}
var bf, y_;
function BF() {
  if (y_) return bf;
  y_ = 1;
  let e = Nn().Graph, t = _t();
  bf = n;
  function n(i, a, o, d) {
    d || (d = i.nodes());
    let u = r(i), l = new e({ compound: !0 }).setGraph({ root: u }).setDefaultNodeLabel((c) => i.node(c));
    return d.forEach((c) => {
      let f = i.node(c), s = i.parent(c);
      (f.rank === a || f.minRank <= a && a <= f.maxRank) && (l.setNode(c), l.setParent(c, s || u), i[o](c).forEach((h) => {
        let p = h.v === c ? h.w : h.v, m = l.edge(p, c), y = m !== void 0 ? m.weight : 0;
        l.setEdge(p, c, { weight: i.edge(h).weight + y });
      }), Object.hasOwn(f, "minRank") && l.setNode(c, {
        borderLeft: f.borderLeft[a],
        borderRight: f.borderRight[a]
      }));
    }), l;
  }
  function r(i) {
    for (var a; i.hasNode(a = t.uniqueId("_root")); ) ;
    return a;
  }
  return bf;
}
var _f, v_;
function VF() {
  if (v_) return _f;
  v_ = 1, _f = e;
  function e(t, n, r) {
    let i = {}, a;
    r.forEach((o) => {
      let d = t.parent(o), u, l;
      for (; d; ) {
        if (u = t.parent(d), u ? (l = i[u], i[u] = d) : (l = a, a = d), l && l !== d) {
          n.setEdge(l, d);
          return;
        }
        d = u;
      }
    });
  }
  return _f;
}
var wf, b_;
function qF() {
  if (b_) return wf;
  b_ = 1;
  let e = $F(), t = RF(), n = UF(), r = BF(), i = VF(), a = Nn().Graph, o = _t();
  wf = d;
  function d(f, s) {
    if (s && typeof s.customOrder == "function") {
      s.customOrder(f, d);
      return;
    }
    let h = o.maxRank(f), p = u(f, o.range(1, h + 1), "inEdges"), m = u(f, o.range(h - 1, -1, -1), "outEdges"), y = e(f);
    if (c(f, y), s && s.disableOptimalOrderHeuristic)
      return;
    let w = Number.POSITIVE_INFINITY, b;
    for (let _ = 0, g = 0; g < 4; ++_, ++g) {
      l(_ % 2 ? p : m, _ % 4 >= 2), y = o.buildLayerMatrix(f);
      let O = t(f, y);
      O < w && (g = 0, b = Object.assign({}, y), w = O);
    }
    c(f, b);
  }
  function u(f, s, h) {
    const p = /* @__PURE__ */ new Map(), m = (y, w) => {
      p.has(y) || p.set(y, []), p.get(y).push(w);
    };
    for (const y of f.nodes()) {
      const w = f.node(y);
      if (typeof w.rank == "number" && m(w.rank, y), typeof w.minRank == "number" && typeof w.maxRank == "number")
        for (let b = w.minRank; b <= w.maxRank; b++)
          b !== w.rank && m(b, y);
    }
    return s.map(function(y) {
      return r(f, y, h, p.get(y) || []);
    });
  }
  function l(f, s) {
    let h = new a();
    f.forEach(function(p) {
      let m = p.graph().root, y = n(p, m, h, s);
      y.vs.forEach((w, b) => p.node(w).order = b), i(p, h, y.vs);
    });
  }
  function c(f, s) {
    Object.values(s).forEach((h) => h.forEach((p, m) => f.node(p).order = m));
  }
  return wf;
}
var kf, __;
function HF() {
  if (__) return kf;
  __ = 1;
  let e = Nn().Graph, t = _t();
  kf = {
    positionX: h,
    findType1Conflicts: n,
    findType2Conflicts: r,
    addConflict: a,
    hasConflict: o,
    verticalAlignment: d,
    horizontalCompaction: u,
    alignCoordinates: f,
    findSmallestWidthAlignment: c,
    balance: s
  };
  function n(y, w) {
    let b = {};
    function _(g, O) {
      let P = 0, E = 0, T = g.length, D = O[O.length - 1];
      return O.forEach((N, M) => {
        let R = i(y, N), V = R ? y.node(R).order : T;
        (R || N === D) && (O.slice(E, M + 1).forEach((C) => {
          y.predecessors(C).forEach((B) => {
            let G = y.node(B), Q = G.order;
            (Q < P || V < Q) && !(G.dummy && y.node(C).dummy) && a(b, B, C);
          });
        }), E = M + 1, P = V);
      }), O;
    }
    return w.length && w.reduce(_), b;
  }
  function r(y, w) {
    let b = {};
    function _(O, P, E, T, D) {
      let N;
      t.range(P, E).forEach((M) => {
        N = O[M], y.node(N).dummy && y.predecessors(N).forEach((R) => {
          let V = y.node(R);
          V.dummy && (V.order < T || V.order > D) && a(b, R, N);
        });
      });
    }
    function g(O, P) {
      let E = -1, T, D = 0;
      return P.forEach((N, M) => {
        if (y.node(N).dummy === "border") {
          let R = y.predecessors(N);
          R.length && (T = y.node(R[0]).order, _(P, D, M, E, T), D = M, E = T);
        }
        _(P, D, P.length, T, O.length);
      }), P;
    }
    return w.length && w.reduce(g), b;
  }
  function i(y, w) {
    if (y.node(w).dummy)
      return y.predecessors(w).find((b) => y.node(b).dummy);
  }
  function a(y, w, b) {
    if (w > b) {
      let g = w;
      w = b, b = g;
    }
    let _ = y[w];
    _ || (y[w] = _ = {}), _[b] = !0;
  }
  function o(y, w, b) {
    if (w > b) {
      let _ = w;
      w = b, b = _;
    }
    return !!y[w] && Object.hasOwn(y[w], b);
  }
  function d(y, w, b, _) {
    let g = {}, O = {}, P = {};
    return w.forEach((E) => {
      E.forEach((T, D) => {
        g[T] = T, O[T] = T, P[T] = D;
      });
    }), w.forEach((E) => {
      let T = -1;
      E.forEach((D) => {
        let N = _(D);
        if (N.length) {
          N = N.sort((R, V) => P[R] - P[V]);
          let M = (N.length - 1) / 2;
          for (let R = Math.floor(M), V = Math.ceil(M); R <= V; ++R) {
            let C = N[R];
            O[D] === D && T < P[C] && !o(b, D, C) && (O[C] = D, O[D] = g[D] = g[C], T = P[C]);
          }
        }
      });
    }), { root: g, align: O };
  }
  function u(y, w, b, _, g) {
    let O = {}, P = l(y, w, b, g), E = g ? "borderLeft" : "borderRight";
    function T(M, R) {
      let V = P.nodes(), C = V.pop(), B = {};
      for (; C; )
        B[C] ? M(C) : (B[C] = !0, V.push(C), V = V.concat(R(C))), C = V.pop();
    }
    function D(M) {
      O[M] = P.inEdges(M).reduce((R, V) => Math.max(R, O[V.v] + P.edge(V)), 0);
    }
    function N(M) {
      let R = P.outEdges(M).reduce((C, B) => Math.min(C, O[B.w] - P.edge(B)), Number.POSITIVE_INFINITY), V = y.node(M);
      R !== Number.POSITIVE_INFINITY && V.borderType !== E && (O[M] = Math.max(O[M], R));
    }
    return T(D, P.predecessors.bind(P)), T(N, P.successors.bind(P)), Object.keys(_).forEach((M) => O[M] = O[b[M]]), O;
  }
  function l(y, w, b, _) {
    let g = new e(), O = y.graph(), P = p(O.nodesep, O.edgesep, _);
    return w.forEach((E) => {
      let T;
      E.forEach((D) => {
        let N = b[D];
        if (g.setNode(N), T) {
          var M = b[T], R = g.edge(M, N);
          g.setEdge(M, N, Math.max(P(y, D, T), R || 0));
        }
        T = D;
      });
    }), g;
  }
  function c(y, w) {
    return Object.values(w).reduce((b, _) => {
      let g = Number.NEGATIVE_INFINITY, O = Number.POSITIVE_INFINITY;
      Object.entries(_).forEach(([E, T]) => {
        let D = m(y, E) / 2;
        g = Math.max(T + D, g), O = Math.min(T - D, O);
      });
      const P = g - O;
      return P < b[0] && (b = [P, _]), b;
    }, [Number.POSITIVE_INFINITY, null])[1];
  }
  function f(y, w) {
    let b = Object.values(w), _ = t.applyWithChunking(Math.min, b), g = t.applyWithChunking(Math.max, b);
    ["u", "d"].forEach((O) => {
      ["l", "r"].forEach((P) => {
        let E = O + P, T = y[E];
        if (T === w) return;
        let D = Object.values(T), N = _ - t.applyWithChunking(Math.min, D);
        P !== "l" && (N = g - t.applyWithChunking(Math.max, D)), N && (y[E] = t.mapValues(T, (M) => M + N));
      });
    });
  }
  function s(y, w) {
    return t.mapValues(y.ul, (b, _) => {
      if (w)
        return y[w.toLowerCase()][_];
      {
        let g = Object.values(y).map((O) => O[_]).sort((O, P) => O - P);
        return (g[1] + g[2]) / 2;
      }
    });
  }
  function h(y) {
    let w = t.buildLayerMatrix(y), b = Object.assign(
      n(y, w),
      r(y, w)
    ), _ = {}, g;
    ["u", "d"].forEach((P) => {
      g = P === "u" ? w : Object.values(w).reverse(), ["l", "r"].forEach((E) => {
        E === "r" && (g = g.map((M) => Object.values(M).reverse()));
        let T = (P === "u" ? y.predecessors : y.successors).bind(y), D = d(y, g, b, T), N = u(
          y,
          g,
          D.root,
          D.align,
          E === "r"
        );
        E === "r" && (N = t.mapValues(N, (M) => -M)), _[P + E] = N;
      });
    });
    let O = c(y, _);
    return f(_, O), s(_, y.graph().align);
  }
  function p(y, w, b) {
    return (_, g, O) => {
      let P = _.node(g), E = _.node(O), T = 0, D;
      if (T += P.width / 2, Object.hasOwn(P, "labelpos"))
        switch (P.labelpos.toLowerCase()) {
          case "l":
            D = -P.width / 2;
            break;
          case "r":
            D = P.width / 2;
            break;
        }
      if (D && (T += b ? D : -D), D = 0, T += (P.dummy ? w : y) / 2, T += (E.dummy ? w : y) / 2, T += E.width / 2, Object.hasOwn(E, "labelpos"))
        switch (E.labelpos.toLowerCase()) {
          case "l":
            D = E.width / 2;
            break;
          case "r":
            D = -E.width / 2;
            break;
        }
      return D && (T += b ? D : -D), D = 0, T;
    };
  }
  function m(y, w) {
    return y.node(w).width;
  }
  return kf;
}
var Sf, w_;
function WF() {
  if (w_) return Sf;
  w_ = 1;
  let e = _t(), t = HF().positionX;
  Sf = n;
  function n(i) {
    i = e.asNonCompoundGraph(i), r(i), Object.entries(t(i)).forEach(([a, o]) => i.node(a).x = o);
  }
  function r(i) {
    let a = e.buildLayerMatrix(i), o = i.graph().ranksep, d = 0;
    a.forEach((u) => {
      const l = u.reduce((c, f) => {
        const s = i.node(f).height;
        return c > s ? c : s;
      }, 0);
      u.forEach((c) => i.node(c).y = d + l / 2), d += l + o;
    });
  }
  return Sf;
}
var xf, k_;
function GF() {
  if (k_) return xf;
  k_ = 1;
  let e = EF(), t = TF(), n = CF(), r = _t().normalizeRanks, i = DF(), a = _t().removeEmptyRanks, o = AF(), d = jF(), u = MF(), l = qF(), c = WF(), f = _t(), s = Nn().Graph;
  xf = h;
  function h(z, L) {
    let F = L && L.debugTiming ? f.time : f.notime;
    F("layout", () => {
      let K = F("  buildLayoutGraph", () => T(z));
      F("  runLayout", () => p(K, F, L)), F("  updateInputGraph", () => m(z, K));
    });
  }
  function p(z, L, F) {
    L("    makeSpaceForEdgeLabels", () => D(z)), L("    removeSelfEdges", () => k(z)), L("    acyclic", () => e.run(z)), L("    nestingGraph.run", () => o.run(z)), L("    rank", () => n(f.asNonCompoundGraph(z))), L("    injectEdgeLabelProxies", () => N(z)), L("    removeEmptyRanks", () => a(z)), L("    nestingGraph.cleanup", () => o.cleanup(z)), L("    normalizeRanks", () => r(z)), L("    assignRankMinMax", () => M(z)), L("    removeEdgeLabelProxies", () => R(z)), L("    normalize.run", () => t.run(z)), L("    parentDummyChains", () => i(z)), L("    addBorderSegments", () => d(z)), L("    order", () => l(z, F)), L("    insertSelfEdges", () => I(z)), L("    adjustCoordinateSystem", () => u.adjust(z)), L("    position", () => c(z)), L("    positionSelfEdges", () => S(z)), L("    removeBorderNodes", () => Q(z)), L("    normalize.undo", () => t.undo(z)), L("    fixupEdgeLabelCoords", () => B(z)), L("    undoCoordinateSystem", () => u.undo(z)), L("    translateGraph", () => V(z)), L("    assignNodeIntersects", () => C(z)), L("    reversePoints", () => G(z)), L("    acyclic.undo", () => e.undo(z));
  }
  function m(z, L) {
    z.nodes().forEach((F) => {
      let K = z.node(F), ee = L.node(F);
      K && (K.x = ee.x, K.y = ee.y, K.rank = ee.rank, L.children(F).length && (K.width = ee.width, K.height = ee.height));
    }), z.edges().forEach((F) => {
      let K = z.edge(F), ee = L.edge(F);
      K.points = ee.points, Object.hasOwn(ee, "x") && (K.x = ee.x, K.y = ee.y);
    }), z.graph().width = L.graph().width, z.graph().height = L.graph().height;
  }
  let y = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"], w = { ranksep: 50, edgesep: 20, nodesep: 50, rankdir: "tb" }, b = ["acyclicer", "ranker", "rankdir", "align"], _ = ["width", "height", "rank"], g = { width: 0, height: 0 }, O = ["minlen", "weight", "width", "height", "labeloffset"], P = {
    minlen: 1,
    weight: 1,
    width: 0,
    height: 0,
    labeloffset: 10,
    labelpos: "r"
  }, E = ["labelpos"];
  function T(z) {
    let L = new s({ multigraph: !0, compound: !0 }), F = j(z.graph());
    return L.setGraph(Object.assign(
      {},
      w,
      A(F, y),
      f.pick(F, b)
    )), z.nodes().forEach((K) => {
      let ee = j(z.node(K));
      const U = A(ee, _);
      Object.keys(g).forEach((q) => {
        U[q] === void 0 && (U[q] = g[q]);
      }), L.setNode(K, U), L.setParent(K, z.parent(K));
    }), z.edges().forEach((K) => {
      let ee = j(z.edge(K));
      L.setEdge(K, Object.assign(
        {},
        P,
        A(ee, O),
        f.pick(ee, E)
      ));
    }), L;
  }
  function D(z) {
    let L = z.graph();
    L.ranksep /= 2, z.edges().forEach((F) => {
      let K = z.edge(F);
      K.minlen *= 2, K.labelpos.toLowerCase() !== "c" && (L.rankdir === "TB" || L.rankdir === "BT" ? K.width += K.labeloffset : K.height += K.labeloffset);
    });
  }
  function N(z) {
    z.edges().forEach((L) => {
      let F = z.edge(L);
      if (F.width && F.height) {
        let K = z.node(L.v), U = { rank: (z.node(L.w).rank - K.rank) / 2 + K.rank, e: L };
        f.addDummyNode(z, "edge-proxy", U, "_ep");
      }
    });
  }
  function M(z) {
    let L = 0;
    z.nodes().forEach((F) => {
      let K = z.node(F);
      K.borderTop && (K.minRank = z.node(K.borderTop).rank, K.maxRank = z.node(K.borderBottom).rank, L = Math.max(L, K.maxRank));
    }), z.graph().maxRank = L;
  }
  function R(z) {
    z.nodes().forEach((L) => {
      let F = z.node(L);
      F.dummy === "edge-proxy" && (z.edge(F.e).labelRank = F.rank, z.removeNode(L));
    });
  }
  function V(z) {
    let L = Number.POSITIVE_INFINITY, F = 0, K = Number.POSITIVE_INFINITY, ee = 0, U = z.graph(), q = U.marginx || 0, ne = U.marginy || 0;
    function oe(Y) {
      let re = Y.x, de = Y.y, ve = Y.width, se = Y.height;
      L = Math.min(L, re - ve / 2), F = Math.max(F, re + ve / 2), K = Math.min(K, de - se / 2), ee = Math.max(ee, de + se / 2);
    }
    z.nodes().forEach((Y) => oe(z.node(Y))), z.edges().forEach((Y) => {
      let re = z.edge(Y);
      Object.hasOwn(re, "x") && oe(re);
    }), L -= q, K -= ne, z.nodes().forEach((Y) => {
      let re = z.node(Y);
      re.x -= L, re.y -= K;
    }), z.edges().forEach((Y) => {
      let re = z.edge(Y);
      re.points.forEach((de) => {
        de.x -= L, de.y -= K;
      }), Object.hasOwn(re, "x") && (re.x -= L), Object.hasOwn(re, "y") && (re.y -= K);
    }), U.width = F - L + q, U.height = ee - K + ne;
  }
  function C(z) {
    z.edges().forEach((L) => {
      let F = z.edge(L), K = z.node(L.v), ee = z.node(L.w), U, q;
      F.points ? (U = F.points[0], q = F.points[F.points.length - 1]) : (F.points = [], U = ee, q = K), F.points.unshift(f.intersectRect(K, U)), F.points.push(f.intersectRect(ee, q));
    });
  }
  function B(z) {
    z.edges().forEach((L) => {
      let F = z.edge(L);
      if (Object.hasOwn(F, "x"))
        switch ((F.labelpos === "l" || F.labelpos === "r") && (F.width -= F.labeloffset), F.labelpos) {
          case "l":
            F.x -= F.width / 2 + F.labeloffset;
            break;
          case "r":
            F.x += F.width / 2 + F.labeloffset;
            break;
        }
    });
  }
  function G(z) {
    z.edges().forEach((L) => {
      let F = z.edge(L);
      F.reversed && F.points.reverse();
    });
  }
  function Q(z) {
    z.nodes().forEach((L) => {
      if (z.children(L).length) {
        let F = z.node(L), K = z.node(F.borderTop), ee = z.node(F.borderBottom), U = z.node(F.borderLeft[F.borderLeft.length - 1]), q = z.node(F.borderRight[F.borderRight.length - 1]);
        F.width = Math.abs(q.x - U.x), F.height = Math.abs(ee.y - K.y), F.x = U.x + F.width / 2, F.y = K.y + F.height / 2;
      }
    }), z.nodes().forEach((L) => {
      z.node(L).dummy === "border" && z.removeNode(L);
    });
  }
  function k(z) {
    z.edges().forEach((L) => {
      if (L.v === L.w) {
        var F = z.node(L.v);
        F.selfEdges || (F.selfEdges = []), F.selfEdges.push({ e: L, label: z.edge(L) }), z.removeEdge(L);
      }
    });
  }
  function I(z) {
    var L = f.buildLayerMatrix(z);
    L.forEach((F) => {
      var K = 0;
      F.forEach((ee, U) => {
        var q = z.node(ee);
        q.order = U + K, (q.selfEdges || []).forEach((ne) => {
          f.addDummyNode(z, "selfedge", {
            width: ne.label.width,
            height: ne.label.height,
            rank: q.rank,
            order: U + ++K,
            e: ne.e,
            label: ne.label
          }, "_se");
        }), delete q.selfEdges;
      });
    });
  }
  function S(z) {
    z.nodes().forEach((L) => {
      var F = z.node(L);
      if (F.dummy === "selfedge") {
        var K = z.node(F.e.v), ee = K.x + K.width / 2, U = K.y, q = F.x - ee, ne = K.height / 2;
        z.setEdge(F.e, F.label), z.removeNode(L), F.label.points = [
          { x: ee + 2 * q / 3, y: U - ne },
          { x: ee + 5 * q / 6, y: U - ne },
          { x: ee + q, y: U },
          { x: ee + 5 * q / 6, y: U + ne },
          { x: ee + 2 * q / 3, y: U + ne }
        ], F.label.x = F.x, F.label.y = F.y;
      }
    });
  }
  function A(z, L) {
    return f.mapValues(f.pick(z, L), Number);
  }
  function j(z) {
    var L = {};
    return z && Object.entries(z).forEach(([F, K]) => {
      typeof F == "string" && (F = F.toLowerCase()), L[F] = K;
    }), L;
  }
  return xf;
}
var If, S_;
function KF() {
  if (S_) return If;
  S_ = 1;
  let e = _t(), t = Nn().Graph;
  If = {
    debugOrdering: n
  };
  function n(r) {
    let i = e.buildLayerMatrix(r), a = new t({ compound: !0, multigraph: !0 }).setGraph({});
    return r.nodes().forEach((o) => {
      a.setNode(o, { label: o }), a.setParent(o, "layer" + r.node(o).rank);
    }), r.edges().forEach((o) => a.setEdge(o.v, o.w, {}, o.name)), i.forEach((o, d) => {
      let u = "layer" + d;
      a.setNode(u, { rank: "same" }), o.reduce((l, c) => (a.setEdge(l, c, { style: "invis" }), c));
    }), a;
  }
  return If;
}
var Pf, x_;
function JF() {
  return x_ || (x_ = 1, Pf = "1.1.8"), Pf;
}
var Of, I_;
function XF() {
  return I_ || (I_ = 1, Of = {
    graphlib: Nn(),
    layout: GF(),
    debug: KF(),
    util: {
      time: _t().time,
      notime: _t().notime
    },
    version: JF()
  }), Of;
}
var YF = XF();
const P_ = /* @__PURE__ */ up(YF), QF = 210, eU = 54;
function tU(e, t, n = {}) {
  const r = n.rankdir ?? "TB", i = n.nodeWidth ?? QF, a = n.nodeHeight ?? eU, o = new P_.graphlib.Graph();
  o.setDefaultEdgeLabel(() => ({})), o.setGraph({ rankdir: r, nodesep: 28, ranksep: 56, marginx: 16, marginy: 16 });
  for (const u of e)
    o.setNode(u.id, { width: i, height: a });
  for (const u of t)
    o.setEdge(u.source, u.target);
  P_.layout(o);
  const d = r === "LR";
  return e.map((u) => {
    const { x: l, y: c } = o.node(u.id);
    return {
      ...u,
      position: { x: l - i / 2, y: c - a / 2 },
      targetPosition: d ? Ie.Left : Ie.Top,
      sourcePosition: d ? Ie.Right : Ie.Bottom
    };
  });
}
const zf = "var(--badge-orange-foreground)", nU = "var(--muted-foreground)";
function Ta(e, t, n, r = {}) {
  const i = r.variant === "handoff";
  return {
    id: e,
    source: t,
    target: n,
    type: "smoothstep",
    ...r.label ? { label: r.label } : {},
    labelStyle: {
      fill: i ? zf : "var(--muted-foreground)",
      fontSize: 9,
      textTransform: "uppercase",
      letterSpacing: 0.4
    },
    labelBgStyle: { fill: "var(--card)" },
    labelBgPadding: [4, 2],
    labelBgBorderRadius: 4,
    style: {
      stroke: i ? zf : "var(--border)",
      strokeWidth: 1.5,
      ...i ? { strokeDasharray: "5 3" } : {}
    },
    markerEnd: {
      type: Ws.ArrowClosed,
      color: i ? zf : nU,
      width: 16,
      height: 16
    }
  };
}
function rU(e) {
  return e.split(",").map((t) => t.trim()).filter(Boolean);
}
function O_(e) {
  return e.join(", ");
}
function iU(e) {
  const [t, n] = Ae(e);
  return e && !t && n(!0), t || e;
}
const En = (e, t) => t >= 1e6 ? e("debug.megaTokens", "{{value}}M", { value: Number((t / 1e6).toFixed(2)) }) : t >= 1e3 ? e("debug.kiloTokens", "{{value}}k", { value: (t / 1e3).toFixed(1) }) : String(t);
function _I({
  type: e,
  title: t,
  subtitle: n,
  icon: r,
  action: i,
  aside: a,
  badge: o,
  create: d = !1,
  selected: u = !1,
  className: l,
  ...c
}) {
  return /* @__PURE__ */ te(
    "div",
    {
      ...c,
      className: Be(
        "group flex items-center gap-2.5 rounded-lg border bg-card px-2.5 py-2",
        d ? "border-dashed border-border" : u ? "border-foreground" : "border-border-light",
        l
      ),
      children: [
        r ?? /* @__PURE__ */ x(Wo, { type: e, size: "md" }),
        /* @__PURE__ */ te("div", { className: "flex min-w-0 flex-col", children: [
          /* @__PURE__ */ x("span", { className: "truncate text-body-md font-medium text-foreground", children: t }),
          n || o ? /* @__PURE__ */ te("span", { className: "flex min-w-0 items-center gap-xs", children: [
            n ? /* @__PURE__ */ x("span", { className: "truncate text-body-sm text-muted-foreground", children: n }) : null,
            o
          ] }) : null
        ] }),
        a || i ? /* @__PURE__ */ te("div", { className: "ml-auto flex shrink-0 items-center gap-xs", children: [
          a,
          i ? /* @__PURE__ */ x("div", { className: "flex items-center opacity-0 transition-opacity duration-fast ease-out group-focus-within:opacity-100 group-hover:opacity-100 has-[[data-state=open]]:opacity-100", children: i }) : null
        ] }) : null
      ]
    }
  );
}
const wI = Wt({});
function oU(e) {
  const t = Ce(null);
  return t.current === null && (t.current = e()), t.current;
}
const aU = typeof window < "u", sU = aU ? D0 : Ze, am = /* @__PURE__ */ Wt(null);
function sm(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Au(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const Vn = (e, t, n) => n > t ? t : n < e ? e : n;
function Oh(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let Xo = () => {
}, qn = () => {
};
typeof process < "u" && process.env?.NODE_ENV !== "production" && (Xo = (e, t, n) => {
  !e && typeof console < "u" && console.warn(Oh(t, n));
}, qn = (e, t, n) => {
  if (!e)
    throw new Error(Oh(t, n));
});
const Sr = {}, kI = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), SI = (e) => typeof e == "object" && e !== null, xI = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function II(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const dn = /* @__NO_SIDE_EFFECTS__ */ (e) => e, gl = (...e) => e.reduce((t, n) => (r) => n(t(r))), Xs = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r ? (n - e) / r : 1;
};
class lm {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return sm(this.subscriptions, t), () => Au(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let a = 0; a < i; a++) {
          const o = this.subscriptions[a];
          o && o(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Ht = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, cn = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, PI = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? e * (1e3 / t) : 0, z_ = /* @__PURE__ */ new Set();
function Ic(e, t, n) {
  e || z_.has(t) || (console.warn(Oh(t, n)), z_.add(t));
}
const OI = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, lU = 1e-7, uU = 12;
function cU(e, t, n, r, i) {
  let a, o, d = 0;
  do
    o = t + (n - t) / 2, a = OI(o, r, i) - e, a > 0 ? n = o : t = o;
  while (Math.abs(a) > lU && ++d < uU);
  return o;
}
// @__NO_SIDE_EFFECTS__
function yl(e, t, n, r) {
  if (e === t && n === r)
    return dn;
  const i = (a) => cU(a, 0, 1, e, n);
  return (a) => a === 0 || a === 1 ? a : OI(i(a), t, r);
}
const zI = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, EI = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), TI = /* @__PURE__ */ yl(0.33, 1.53, 0.69, 0.99), um = /* @__PURE__ */ EI(TI), NI = /* @__PURE__ */ zI(um), CI = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? 0.5 * um(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), cm = (e) => 1 - Math.sin(Math.acos(e)), DI = /* @__PURE__ */ EI(cm), AI = /* @__PURE__ */ zI(cm), dU = /* @__PURE__ */ yl(0.42, 0, 1, 1), fU = /* @__PURE__ */ yl(0, 0, 0.58, 1), jI = /* @__PURE__ */ yl(0.42, 0, 0.58, 1), hU = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] != "number", MI = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", E_ = {
  linear: dn,
  easeIn: dU,
  easeInOut: jI,
  easeOut: fU,
  circIn: cm,
  circInOut: AI,
  circOut: DI,
  backIn: um,
  backInOut: NI,
  backOut: TI,
  anticipate: CI
}, pU = (e) => typeof e == "string", T_ = (e) => {
  if (/* @__PURE__ */ MI(e)) {
    qn(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, i] = e;
    return /* @__PURE__ */ yl(t, n, r, i);
  } else if (pU(e))
    return qn(E_[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), E_[e];
  return e;
}, ql = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function mU(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function d(l) {
    a.has(l) && (u.schedule(l), e()), l(o);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (l, c = !1, f = !1) => {
      const h = f && r ? t : n;
      return c && a.add(l), h.add(l), l;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (l) => {
      n.delete(l), a.delete(l);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (l) => {
      if (o = l, r) {
        i = !0;
        return;
      }
      r = !0;
      const c = t;
      t = n, n = c, t.forEach(d), t.clear(), r = !1, i && (i = !1, u.process(l));
    }
  };
  return u;
}
const gU = 40;
function $I(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, o = ql.reduce((_, g) => (_[g] = mU(a), _), {}), { setup: d, read: u, resolveKeyframes: l, preUpdate: c, update: f, preRender: s, render: h, postRender: p } = o, m = () => {
    const _ = Sr.useManualTiming, g = _ ? i.timestamp : performance.now();
    n = !1, _ || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(g - i.timestamp, gU), 1)), i.timestamp = g, i.isProcessing = !0, d.process(i), u.process(i), l.process(i), c.process(i), f.process(i), s.process(i), h.process(i), p.process(i), i.isProcessing = !1, n && t && (r = !1, e(m));
  }, y = () => {
    n = !0, r = !0, i.isProcessing || e(m);
  };
  return { schedule: ql.reduce((_, g) => {
    const O = o[g];
    return _[g] = (P, E = !1, T = !1) => (n || y(), O.schedule(P, E, T)), _;
  }, {}), cancel: (_) => {
    for (let g = 0; g < ql.length; g++)
      o[ql[g]].cancel(_);
  }, state: i, steps: o };
}
const { schedule: tt, cancel: xr, state: zt, steps: Ef } = /* @__PURE__ */ $I(typeof requestAnimationFrame < "u" ? requestAnimationFrame : dn, !0);
let lu;
function yU() {
  lu = void 0;
}
const Rt = {
  now: () => (lu === void 0 && Rt.set(zt.isProcessing || Sr.useManualTiming ? zt.timestamp : performance.now()), lu),
  set: (e) => {
    lu = e, queueMicrotask(yU);
  }
}, RI = (e) => (t) => typeof t == "string" && t.startsWith(e), ZI = /* @__PURE__ */ RI("--"), vU = /* @__PURE__ */ RI("var(--"), dm = (e) => vU(e) ? bU.test(e.split("/*")[0].trim()) : !1, bU = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function N_(e) {
  return typeof e != "string" ? !1 : e.split("/*")[0].includes("var(--");
}
const Yo = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Ys = {
  ...Yo,
  transform: (e) => Vn(0, 1, e)
}, Hl = {
  ...Yo,
  default: 1
}, Ms = (e) => Math.round(e * 1e5) / 1e5, fm = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function _U(e) {
  return e == null;
}
const wU = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, hm = (e, t) => (n) => !!(typeof n == "string" && wU.test(n) && n.startsWith(e) || t && !_U(n) && Object.prototype.hasOwnProperty.call(n, t)), LI = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, a, o, d] = r.match(fm);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: d !== void 0 ? parseFloat(d) : 1
  };
}, kU = (e) => Vn(0, 255, e), Tf = {
  ...Yo,
  transform: (e) => Math.round(kU(e))
}, Kr = {
  test: /* @__PURE__ */ hm("rgb", "red"),
  parse: /* @__PURE__ */ LI("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Tf.transform(e) + ", " + Tf.transform(t) + ", " + Tf.transform(n) + ", " + Ms(Ys.transform(r)) + ")"
};
function SU(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const zh = {
  test: /* @__PURE__ */ hm("#"),
  parse: SU,
  transform: Kr.transform
}, vl = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), or = /* @__PURE__ */ vl("deg"), Bn = /* @__PURE__ */ vl("%"), Se = /* @__PURE__ */ vl("px"), xU = /* @__PURE__ */ vl("vh"), IU = /* @__PURE__ */ vl("vw"), C_ = {
  ...Bn,
  parse: (e) => Bn.parse(e) / 100,
  transform: (e) => Bn.transform(e * 100)
}, _o = {
  test: /* @__PURE__ */ hm("hsl", "hue"),
  parse: /* @__PURE__ */ LI("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Bn.transform(Ms(t)) + ", " + Bn.transform(Ms(n)) + ", " + Ms(Ys.transform(r)) + ")"
}, vt = {
  test: (e) => Kr.test(e) || zh.test(e) || _o.test(e),
  parse: (e) => Kr.test(e) ? Kr.parse(e) : _o.test(e) ? _o.parse(e) : zh.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Kr.transform(e) : _o.transform(e),
  getAnimatableNone: (e) => {
    const t = vt.parse(e);
    return t.alpha = 0, vt.transform(t);
  }
}, PU = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function OU(e) {
  return isNaN(e) && typeof e == "string" && (e.match(fm)?.length || 0) + (e.match(PU)?.length || 0) > 0;
}
const FI = "number", UI = "color", zU = "var", EU = "var(", D_ = "${}", TU = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Uo(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let a = 0;
  const d = t.replace(TU, (u) => (vt.test(u) ? (r.color.push(a), i.push(UI), n.push(vt.parse(u))) : u.startsWith(EU) ? (r.var.push(a), i.push(zU), n.push(u)) : (r.number.push(a), i.push(FI), n.push(parseFloat(u))), ++a, D_)).split(D_);
  return { values: n, split: d, indexes: r, types: i };
}
function NU(e) {
  return Uo(e).values;
}
function BI({ split: e, types: t }) {
  const n = e.length;
  return (r) => {
    let i = "";
    for (let a = 0; a < n; a++)
      if (i += e[a], r[a] !== void 0) {
        const o = t[a];
        o === FI ? i += Ms(r[a]) : o === UI ? i += vt.transform(r[a]) : i += r[a];
      }
    return i;
  };
}
function CU(e) {
  return BI(Uo(e));
}
const DU = (e) => typeof e == "number" ? 0 : vt.test(e) ? vt.getAnimatableNone(e) : e, AU = (e, t) => typeof e == "number" ? t?.trim().endsWith("/") ? e : 0 : DU(e);
function jU(e) {
  const t = Uo(e);
  return BI(t)(t.values.map((r, i) => AU(r, t.split[i])));
}
const Tn = {
  test: OU,
  parse: NU,
  createTransformer: CU,
  getAnimatableNone: jU
};
function Nf(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function MU({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, a = 0, o = 0;
  if (!t)
    i = a = o = n;
  else {
    const d = n < 0.5 ? n * (1 + t) : n + t - n * t, u = 2 * n - d;
    i = Nf(u, d, e + 1 / 3), a = Nf(u, d, e), o = Nf(u, d, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function ju(e, t) {
  return (n) => n > 0 ? t : e;
}
const et = (e, t, n) => e + (t - e) * n, Cf = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, $U = [zh, Kr, _o], RU = (e) => $U.find((t) => t.test(e));
function A_(e) {
  const t = RU(e);
  if (Xo(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === _o && (n = MU(n)), n;
}
const j_ = (e, t) => {
  const n = A_(e), r = A_(t);
  if (!n || !r)
    return ju(e, t);
  const i = { ...n };
  return (a) => (i.red = Cf(n.red, r.red, a), i.green = Cf(n.green, r.green, a), i.blue = Cf(n.blue, r.blue, a), i.alpha = et(n.alpha, r.alpha, a), Kr.transform(i));
}, Eh = /* @__PURE__ */ new Set(["none", "hidden"]);
function ZU(e, t) {
  return Eh.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function LU(e, t) {
  return (n) => et(e, t, n);
}
function pm(e) {
  return typeof e == "number" ? LU : typeof e == "string" ? dm(e) ? ju : vt.test(e) ? j_ : BU : Array.isArray(e) ? VI : typeof e == "object" ? vt.test(e) ? j_ : FU : ju;
}
function VI(e, t) {
  const n = [...e], r = n.length, i = e.map((a, o) => pm(a)(a, t[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](a);
    return n;
  };
}
function FU(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = pm(e[i])(e[i], t[i]));
  return (i) => {
    for (const a in r)
      n[a] = r[a](i);
    return n;
  };
}
function UU(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const a = t.types[i], o = e.indexes[a][r[a]], d = e.values[o] ?? 0;
    n[i] = d, r[a]++;
  }
  return n;
}
const BU = (e, t) => {
  const n = Tn.createTransformer(t), r = Uo(e), i = Uo(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? Eh.has(e) && !i.values.length || Eh.has(t) && !r.values.length ? ZU(e, t) : gl(VI(UU(r, i), i.values), n) : (Xo(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), ju(e, t));
};
function qI(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? et(e, t, n) : pm(e)(e, t);
}
const VU = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => tt.update(t, n),
    stop: () => xr(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => zt.isProcessing ? zt.timestamp : Rt.now()
  };
}, HI = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let a = 0; a < i; a++)
    r += Math.round(e(a / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Mu = 2e4;
function mm(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Mu; )
    t += n, r = e.next(t);
  return t >= Mu ? 1 / 0 : t;
}
function qU(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(mm(r), Mu);
  return {
    type: "keyframes",
    ease: (a) => r.next(i * a).value / t,
    duration: /* @__PURE__ */ cn(i)
  };
}
const ut = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function Th(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const HU = 12;
function WU(e, t, n) {
  let r = n;
  for (let i = 1; i < HU; i++)
    r = r - e(r) / t(r);
  return r;
}
const Df = 1e-3;
function GU({ duration: e = ut.duration, bounce: t = ut.bounce, velocity: n = ut.velocity, mass: r = ut.mass }) {
  let i, a;
  Xo(e <= /* @__PURE__ */ Ht(ut.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - t;
  o = Vn(ut.minDamping, ut.maxDamping, o), e = Vn(ut.minDuration, ut.maxDuration, /* @__PURE__ */ cn(e)), o < 1 ? (i = (l) => {
    const c = l * o, f = c * e, s = c - n, h = Th(l, o), p = Math.exp(-f);
    return Df - s / h * p;
  }, a = (l) => {
    const f = l * o * e, s = f * n + n, h = Math.pow(o, 2) * Math.pow(l, 2) * e, p = Math.exp(-f), m = Th(Math.pow(l, 2), o);
    return (-i(l) + Df > 0 ? -1 : 1) * ((s - h) * p) / m;
  }) : (i = (l) => {
    const c = Math.exp(-l * e), f = (l - n) * e + 1;
    return -Df + c * f;
  }, a = (l) => {
    const c = Math.exp(-l * e), f = (n - l) * (e * e);
    return c * f;
  });
  const d = 5 / e, u = WU(i, a, d);
  if (e = /* @__PURE__ */ Ht(e), isNaN(u))
    return {
      stiffness: ut.stiffness,
      damping: ut.damping,
      duration: e
    };
  {
    const l = Math.pow(u, 2) * r;
    return {
      stiffness: l,
      damping: o * 2 * Math.sqrt(r * l),
      duration: e
    };
  }
}
const KU = ["duration", "bounce"], JU = ["stiffness", "damping", "mass"];
function M_(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function XU(e) {
  let t = {
    velocity: ut.velocity,
    stiffness: ut.stiffness,
    damping: ut.damping,
    mass: ut.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!M_(e, JU) && M_(e, KU))
    if (t.velocity = 0, e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, a = 2 * Vn(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: ut.mass,
        stiffness: i,
        damping: a
      };
    } else {
      const n = GU({ ...e, velocity: 0 });
      t = {
        ...t,
        ...n,
        mass: ut.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function $u(e = ut.visualDuration, t = ut.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], d = { done: !1, value: a }, { stiffness: u, damping: l, mass: c, duration: f, velocity: s, isResolvedFromDuration: h } = XU({
    ...n,
    velocity: -/* @__PURE__ */ cn(n.velocity || 0)
  }), p = s || 0, m = l / (2 * Math.sqrt(u * c)), y = o - a, w = /* @__PURE__ */ cn(Math.sqrt(u / c)), b = Math.abs(y) < 5;
  r || (r = b ? ut.restSpeed.granular : ut.restSpeed.default), i || (i = b ? ut.restDelta.granular : ut.restDelta.default);
  let _, g, O, P, E, T;
  if (m < 1)
    O = Th(w, m), P = (p + m * w * y) / O, _ = (N) => {
      const M = Math.exp(-m * w * N);
      return o - M * (P * Math.sin(O * N) + y * Math.cos(O * N));
    }, E = m * w * P + y * O, T = m * w * y - P * O, g = (N) => Math.exp(-m * w * N) * (E * Math.sin(O * N) + T * Math.cos(O * N));
  else if (m === 1) {
    _ = (M) => o - Math.exp(-w * M) * (y + (p + w * y) * M);
    const N = p + w * y;
    g = (M) => Math.exp(-w * M) * (w * N * M - p);
  } else {
    const N = w * Math.sqrt(m * m - 1);
    _ = (C) => {
      const B = Math.exp(-m * w * C), G = Math.min(N * C, 300);
      return o - B * ((p + m * w * y) * Math.sinh(G) + N * y * Math.cosh(G)) / N;
    };
    const M = (p + m * w * y) / N, R = m * w * M - y * N, V = m * w * y - M * N;
    g = (C) => {
      const B = Math.exp(-m * w * C), G = Math.min(N * C, 300);
      return B * (R * Math.sinh(G) + V * Math.cosh(G));
    };
  }
  const D = {
    calculatedDuration: h && f || null,
    velocity: (N) => /* @__PURE__ */ Ht(g(N)),
    next: (N) => {
      if (!h && m < 1) {
        const R = Math.exp(-m * w * N), V = Math.sin(O * N), C = Math.cos(O * N), B = o - R * (P * V + y * C), G = /* @__PURE__ */ Ht(R * (E * V + T * C));
        return d.done = Math.abs(G) <= r && Math.abs(o - B) <= i, d.value = d.done ? o : B, d;
      }
      const M = _(N);
      if (h)
        d.done = N >= f;
      else {
        const R = /* @__PURE__ */ Ht(g(N));
        d.done = Math.abs(R) <= r && Math.abs(o - M) <= i;
      }
      return d.value = d.done ? o : M, d;
    },
    toString: () => {
      const N = Math.min(mm(D), Mu), M = HI((R) => D.next(N * R).value, N, 30);
      return N + "ms " + M;
    },
    toTransition: () => {
    }
  };
  return D;
}
$u.applyToOptions = (e) => {
  const t = qU(e, 100, $u);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Ht(t.duration), e.type = "keyframes", e;
};
const YU = 5;
function WI(e, t, n) {
  const r = Math.max(t - YU, 0);
  return /* @__PURE__ */ PI(n - e(r), t - r);
}
function Nh({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: d, max: u, restDelta: l = 0.5, restSpeed: c }) {
  const f = e[0], s = {
    done: !1,
    value: f
  }, h = (T) => d !== void 0 && T < d || u !== void 0 && T > u, p = (T) => d === void 0 ? u : u === void 0 || Math.abs(d - T) < Math.abs(u - T) ? d : u;
  let m = n * t;
  const y = f + m, w = o === void 0 ? y : o(y);
  w !== y && (m = w - f);
  const b = (T) => -m * Math.exp(-T / r), _ = (T) => w + b(T), g = (T) => {
    const D = b(T), N = _(T);
    s.done = Math.abs(D) <= l, s.value = s.done ? w : N;
  };
  let O, P;
  const E = (T) => {
    h(s.value) && (O = T, P = $u({
      keyframes: [s.value, p(s.value)],
      velocity: WI(_, T, s.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: a,
      restDelta: l,
      restSpeed: c
    }));
  };
  return E(0), {
    calculatedDuration: null,
    next: (T) => {
      let D = !1;
      return !P && O === void 0 && (D = !0, g(T), E(T)), O !== void 0 && T >= O ? P.next(T - O) : (!D && g(T), s);
    }
  };
}
function QU(e, t, n) {
  const r = [], i = n || Sr.mix || qI, a = e.length - 1;
  for (let o = 0; o < a; o++) {
    let d = i(e[o], e[o + 1]);
    if (t) {
      const u = Array.isArray(t) ? t[o] || dn : t;
      d = gl(u, d);
    }
    r.push(d);
  }
  return r;
}
function eB(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const a = e.length;
  if (qn(a === t.length, "Both input and output ranges must be the same length", "range-length"), a === 1)
    return () => t[0];
  if (a === 2 && t[0] === t[1])
    return () => t[1];
  const o = e[0] === e[1];
  e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const d = QU(t, r, i), u = d.length, l = (c) => {
    if (o && c < e[0])
      return t[0];
    let f = 0;
    if (u > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const s = /* @__PURE__ */ Xs(e[f], e[f + 1], c);
    return d[f](s);
  };
  return n ? (c) => l(Vn(e[0], e[a - 1], c)) : l;
}
function tB(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ Xs(0, t, r);
    e.push(et(n, 1, i));
  }
}
function nB(e) {
  const t = [0];
  return tB(t, e.length - 1), t;
}
function rB(e, t) {
  return e.map((n) => n * t);
}
function iB(e, t) {
  return e.map(() => t || jI).splice(0, e.length - 1);
}
function wo({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = /* @__PURE__ */ hU(r) ? r.map(T_) : T_(r), a = {
    done: !1,
    value: t[0]
  }, o = rB(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : nB(t),
    e
  ), d = eB(o, t, {
    ease: Array.isArray(i) ? i : iB(t, i)
  });
  return {
    calculatedDuration: e,
    next: (u) => (a.value = d(u), a.done = u >= e, a)
  };
}
const oB = (e) => e !== null;
function Pc(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
  const a = e.filter(oB), d = i < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : a.length - 1;
  return !d || r === void 0 ? a[d] : r;
}
const aB = {
  decay: Nh,
  inertia: Nh,
  tween: wo,
  keyframes: wo,
  spring: $u
};
function GI(e) {
  typeof e.type == "string" && (e.type = aB[e.type]);
}
class gm {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const sB = (e) => e / 100;
class Ru extends gm {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      const { motionValue: n } = this.options;
      n && n.updatedAt !== Rt.now() && this.tick(Rt.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    GI(t);
    const { type: n = wo, repeat: r = 0, repeatDelay: i = 0, repeatType: a, velocity: o = 0 } = t;
    let { keyframes: d } = t;
    const u = n || wo;
    process.env.NODE_ENV !== "production" && u !== wo && qn(d.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${d}`, "spring-two-frames"), u !== wo && typeof d[0] != "number" && (this.mixKeyframes = gl(sB, qI(d[0], d[1])), d = [0, 100]);
    const l = u({ ...t, keyframes: d });
    a === "mirror" && (this.mirroredGenerator = u({
      ...t,
      keyframes: [...d].reverse(),
      velocity: -o
    })), l.calculatedDuration === null && (l.calculatedDuration = mm(l));
    const { calculatedDuration: c } = l;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = l;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: a, mirroredGenerator: o, resolvedDuration: d, calculatedDuration: u } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: l = 0, keyframes: c, repeat: f, repeatType: s, repeatDelay: h, type: p, onUpdate: m, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const w = this.currentTime - l * (this.playbackSpeed >= 0 ? 1 : -1), b = this.playbackSpeed >= 0 ? w < 0 : w > i;
    this.currentTime = Math.max(w, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let _ = this.currentTime, g = r;
    if (f) {
      const T = Math.min(this.currentTime, i) / d;
      let D = Math.floor(T), N = T % 1;
      !N && T >= 1 && (N = 1), N === 1 && D--, D = Math.min(D, f + 1), D % 2 && (s === "reverse" ? (N = 1 - N, h && (N -= h / d)) : s === "mirror" && (g = o)), _ = Vn(0, 1, N) * d;
    }
    let O;
    b ? (this.delayState.value = c[0], O = this.delayState) : O = g.next(_), a && !b && (O.value = a(O.value));
    let { done: P } = O;
    !b && u !== null && (P = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const E = this.holdTime === null && (this.state === "finished" || this.state === "running" && P);
    return E && p !== Nh && (O.value = Pc(c, this.options, y, this.speed)), m && m(O.value), E && this.finish(), O;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ cn(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ cn(t);
  }
  get time() {
    return /* @__PURE__ */ cn(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Ht(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = t, this.tick(t));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const t = this.currentTime;
    if (t <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(t);
    const n = this.generator.next(t).value;
    return WI((r) => this.generator.next(r).value, t, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    n && this.driver && this.updateTime(Rt.now()), this.playbackSpeed = t, n && this.driver && (this.time = /* @__PURE__ */ cn(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: t = VU, startTime: n } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), this.options.onPlay?.();
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Rt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), t.observe(this);
  }
}
function lB(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const Jr = (e) => e * 180 / Math.PI, Ch = (e) => {
  const t = Jr(Math.atan2(e[1], e[0]));
  return Dh(t);
}, uB = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: Ch,
  rotateZ: Ch,
  skewX: (e) => Jr(Math.atan(e[1])),
  skewY: (e) => Jr(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, Dh = (e) => (e = e % 360, e < 0 && (e += 360), e), $_ = Ch, R_ = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Z_ = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), cB = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: R_,
  scaleY: Z_,
  scale: (e) => (R_(e) + Z_(e)) / 2,
  rotateX: (e) => Dh(Jr(Math.atan2(e[6], e[5]))),
  rotateY: (e) => Dh(Jr(Math.atan2(-e[2], e[0]))),
  rotateZ: $_,
  rotate: $_,
  skewX: (e) => Jr(Math.atan(e[4])),
  skewY: (e) => Jr(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function Ah(e) {
  return e.includes("scale") ? 1 : 0;
}
function jh(e, t) {
  if (!e || e === "none")
    return Ah(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = cB, i = n;
  else {
    const d = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = uB, i = d;
  }
  if (!i)
    return Ah(t);
  const a = r[t], o = i[1].split(",").map(fB);
  return typeof a == "function" ? a(o) : o[a];
}
const dB = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return jh(n, t);
};
function fB(e) {
  return parseFloat(e.trim());
}
const Qo = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], ea = /* @__PURE__ */ new Set([...Qo, "pathRotation"]), L_ = (e) => e === Yo || e === Se, hB = /* @__PURE__ */ new Set(["x", "y", "z"]), pB = Qo.filter((e) => !hB.has(e));
function mB(e) {
  const t = [];
  return pB.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const kr = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0", boxSizing: r }) => {
    const i = e.max - e.min;
    return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
  },
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0", boxSizing: r }) => {
    const i = e.max - e.min;
    return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
  },
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => jh(t, "x"),
  y: (e, { transform: t }) => jh(t, "y")
};
kr.translateX = kr.x;
kr.translateY = kr.y;
const Qr = /* @__PURE__ */ new Set();
let Mh = !1, $h = !1, Rh = !1;
function KI() {
  if ($h) {
    const e = Array.from(Qr).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = mB(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([a, o]) => {
        r.getValue(a)?.set(o);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  $h = !1, Mh = !1, Qr.forEach((e) => e.complete(Rh)), Qr.clear();
}
function JI() {
  Qr.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && ($h = !0);
  });
}
function gB() {
  Rh = !0, JI(), KI(), Rh = !1;
}
class ym {
  constructor(t, n, r, i, a, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Qr.add(this), Mh || (Mh = !0, tt.read(JI), tt.resolveKeyframes(KI))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const a = i?.get(), o = t[t.length - 1];
      if (a !== void 0)
        t[0] = a;
      else if (r && n) {
        const d = r.readValue(n, o);
        d != null && (t[0] = d);
      }
      t[0] === void 0 && (t[0] = o), i && a === void 0 && i.set(t[0]);
    }
    lB(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), Qr.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Qr.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const yB = (e) => e.startsWith("--");
function XI(e, t, n) {
  yB(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const vB = {};
function YI(e, t) {
  const n = /* @__PURE__ */ II(e);
  return () => vB[t] ?? n();
}
const bB = /* @__PURE__ */ YI(() => window.ScrollTimeline !== void 0, "scrollTimeline"), QI = /* @__PURE__ */ YI(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Es = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, F_ = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Es([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Es([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Es([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Es([0.33, 1.53, 0.69, 0.99])
};
function eP(e, t) {
  if (e)
    return typeof e == "function" ? QI() ? HI(e, t) : "ease-out" : /* @__PURE__ */ MI(e) ? Es(e) : Array.isArray(e) ? e.map((n) => eP(n, t) || F_.easeOut) : F_[e];
}
function _B(e, t, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: d = "easeOut", times: u } = {}, l = void 0) {
  const c = {
    [t]: n
  };
  u && (c.offset = u);
  const f = eP(d, i);
  Array.isArray(f) && (c.easing = f);
  const s = {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return l && (s.pseudoElement = l), e.animate(c, s);
}
function tP(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function wB({ type: e, ...t }) {
  return tP(e) && QI() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class nP extends gm {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !t)
      return;
    const { element: n, name: r, keyframes: i, pseudoElement: a, allowFlatten: o = !1, finalKeyframe: d, onComplete: u } = t;
    this.isPseudoElement = !!a, this.allowFlatten = o, this.options = t, qn(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const l = wB(t);
    this.animation = _B(n, r, i, l, a), l.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !a) {
        const c = Pc(i, this.options, d, this.speed);
        this.updateMotionValue && this.updateMotionValue(c), XI(n, r, c), this.animation.cancel();
      }
      u?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    const t = this.options?.element;
    !this.isPseudoElement && t?.isConnected && this.animation.commitStyles?.();
  }
  get duration() {
    const t = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ cn(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ cn(t);
  }
  get time() {
    return /* @__PURE__ */ cn(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Ht(t), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(t) {
    this.manualStartTime = this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, rangeStart: n, rangeEnd: r, observe: i }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, t && bB() ? (this.animation.timeline = t, n && (this.animation.rangeStart = n), r && (this.animation.rangeEnd = r), dn) : i(this);
  }
}
const rP = {
  anticipate: CI,
  backInOut: NI,
  circInOut: AI
};
function kB(e) {
  return e in rP;
}
function SB(e) {
  typeof e.ease == "string" && kB(e.ease) && (e.ease = rP[e.ease]);
}
const Af = 10;
class xB extends nP {
  constructor(t) {
    SB(t), GI(t), super(t), t.startTime !== void 0 && t.autoplay !== !1 && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: i, element: a, ...o } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const d = new Ru({
      ...o,
      autoplay: !1
    }), u = Math.max(Af, Rt.now() - this.startTime), l = Vn(0, Af, u - Af), c = d.sample(u).value, { name: f } = this.options;
    a && f && XI(a, f, c), n.setWithVelocity(d.sample(Math.max(0, u - l)).value, c, l), d.stop();
  }
}
const U_ = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Tn.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function IB(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function PB(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const a = e[e.length - 1], o = U_(i, t), d = U_(a, t);
  return Xo(o === d, `You are trying to animate ${t} from "${i}" to "${a}". "${o ? a : i}" is not an animatable value.`, "value-not-animatable"), !o || !d ? !1 : IB(e) || (n === "spring" || tP(n)) && r;
}
function Zh(e) {
  e.duration = 0, e.type = "keyframes";
}
const iP = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), OB = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function zB(e) {
  for (let t = 0; t < e.length; t++)
    if (typeof e[t] == "string" && OB.test(e[t]))
      return !0;
  return !1;
}
const EB = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), TB = /* @__PURE__ */ II(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function NB(e) {
  const { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: a, type: o, keyframes: d } = e, u = t?.owner?.current;
  if (!(u instanceof HTMLElement) && !(u instanceof SVGElement))
    return !1;
  const { onUpdate: l, transformTemplate: c } = t.owner.getProps();
  return TB() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (iP.has(n) || EB.has(n) && zB(d)) && (n !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !r && i !== "mirror" && a !== 0 && o !== "inertia";
}
const CB = 40;
class DB extends gm {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: o = "loop", keyframes: d, name: u, motionValue: l, element: c, ...f }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = Rt.now();
    const s = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: a,
      repeatType: o,
      name: u,
      motionValue: l,
      element: c,
      ...f
    }, h = c?.KeyframeResolver || ym;
    this.keyframeResolver = new h(d, (p, m, y) => this.onKeyframesResolved(p, m, s, !y), u, l, c), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, i) {
    this.keyframeResolver = void 0;
    const { name: a, type: o, velocity: d, delay: u, isHandoff: l, onUpdate: c } = r;
    this.resolvedAt = Rt.now();
    let f = !0;
    PB(t, a, o, d) || (f = !1, (Sr.instantAnimations || !u) && c?.(Pc(t, r, n)), t[0] = t[t.length - 1], Zh(r), r.repeat = 0);
    const h = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > CB ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, p = f && !l && NB(h), m = h.motionValue?.owner?.current;
    let y;
    if (p)
      try {
        y = new xB({
          ...h,
          element: m
        });
      } catch {
        y = new Ru(h);
      }
    else
      y = new Ru(h);
    y.finished.then(() => {
      this.notifyFinished();
    }).catch(dn), this.pendingTimeline && (this.stopTimeline = y.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = y;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), gB()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
function oP(e, t, n, r = 0, i = 1) {
  const a = Array.from(e).sort((l, c) => l.sortNodePosition(c)).indexOf(t), o = e.size, d = (o - 1) * r;
  return typeof n == "function" ? n(a, o) : i === 1 ? a * r : d - a * r;
}
const B_ = 30, AB = (e) => !isNaN(parseFloat(e));
class jB {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      const i = Rt.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const a of this.dependents)
          a.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Rt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = AB(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Ic(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new lm());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), tt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Rt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > B_)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, B_);
    return /* @__PURE__ */ PI(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Bo(e, t) {
  return new jB(e, t);
}
function aP(e, t) {
  if (e?.inherit && t) {
    const { inherit: n, ...r } = e;
    return { ...t, ...r };
  }
  return e;
}
function vm(e, t) {
  const n = e?.[t] ?? e?.default ?? e;
  return n !== e ? aP(n, e) : n;
}
const MB = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, $B = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), RB = {
  type: "keyframes",
  duration: 0.8
}, ZB = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, LB = (e, { keyframes: t }) => t.length > 2 ? RB : ea.has(e) ? e.startsWith("scale") ? $B(t[1]) : MB : ZB, FB = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function UB(e) {
  for (const t in e)
    if (!FB.has(t))
      return !0;
  return !1;
}
const bm = (e, t, n, r = {}, i, a) => (o) => {
  const d = vm(r, e) || {}, u = d.delay || r.delay || 0;
  let { elapsed: l = 0 } = r;
  l = l - /* @__PURE__ */ Ht(u);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...d,
    delay: -l,
    onUpdate: (s) => {
      t.set(s), d.onUpdate && d.onUpdate(s);
    },
    onComplete: () => {
      o(), d.onComplete && d.onComplete();
    },
    name: e,
    motionValue: t,
    element: a ? void 0 : i
  };
  UB(d) || Object.assign(c, LB(e, c)), c.duration && (c.duration = /* @__PURE__ */ Ht(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ Ht(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let f = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (Zh(c), c.delay === 0 && (f = !0)), (Sr.instantAnimations || Sr.skipAnimations || i?.shouldSkipAnimations || d.skipAnimations) && (f = !0, Zh(c), c.delay = 0), c.allowFlatten = !d.type && !d.ease, f && !a && t.get() !== void 0) {
    const s = Pc(c.keyframes, d);
    if (s !== void 0) {
      tt.update(() => {
        c.onUpdate(s), c.onComplete();
      });
      return;
    }
  }
  return d.isSync ? new Ru(c) : new DB(c);
}, BB = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function VB(e) {
  const t = BB.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const qB = 4;
function sP(e, t, n = 1) {
  qn(n <= qB, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, i] = VB(e);
  if (!r)
    return;
  const a = window.getComputedStyle(t).getPropertyValue(r);
  if (a) {
    const o = a.trim();
    return kI(o) ? parseFloat(o) : o;
  }
  return dm(i) ? sP(i, t, n + 1) : i;
}
function V_(e) {
  const t = [{}, {}];
  return e?.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function _m(e, t, n, r) {
  if (typeof t == "function") {
    const [i, a] = V_(r);
    t = t(n !== void 0 ? n : e.custom, i, a);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, a] = V_(r);
    t = t(n !== void 0 ? n : e.custom, i, a);
  }
  return t;
}
function ei(e, t, n) {
  const r = e.getProps();
  return _m(r, t, n !== void 0 ? n : r.custom, e);
}
const lP = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Qo
]), Lh = (e) => Array.isArray(e);
function HB(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Bo(n));
}
function WB(e) {
  return Lh(e) ? e[e.length - 1] || 0 : e;
}
function GB(e, t) {
  const n = ei(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const o in a) {
    const d = WB(a[o]);
    HB(e, o, d);
  }
}
const Et = (e) => !!(e && e.getVelocity);
function KB(e) {
  return !!(Et(e) && e.add);
}
function Fh(e, t) {
  const n = e.getValue("willChange");
  if (KB(n))
    return n.add(t);
  if (!n && Sr.WillChange) {
    const r = new Sr.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function wm(e) {
  return e.replace(/([A-Z])/g, (t) => `-${t.toLowerCase()}`);
}
const JB = "framerAppearId", uP = "data-" + wm(JB);
function cP(e) {
  return e.props[uP];
}
function XB({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function dP(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: a, transitionEnd: o, ...d } = t;
  const u = e.getDefaultTransition();
  a = a ? aP(a, u) : u;
  const l = a?.reduceMotion, c = a?.skipAnimations;
  r && (a = r);
  const f = [], s = i && e.animationState && e.animationState.getState()[i], h = a?.path;
  h && h.animateVisualElement(e, d, a, n, f);
  for (const p in d) {
    const m = e.getValue(p, e.latestValues[p] ?? null), y = d[p];
    if (y === void 0 || s && XB(s, p))
      continue;
    const w = {
      delay: n,
      ...vm(a || {}, p)
    };
    c && (w.skipAnimations = !0);
    const b = m.get();
    if (b !== void 0 && !m.isAnimating() && !Array.isArray(y) && y === b && !w.velocity) {
      tt.update(() => m.set(y));
      continue;
    }
    let _ = !1;
    if (window.MotionHandoffAnimation) {
      const P = cP(e);
      if (P) {
        const E = window.MotionHandoffAnimation(P, p, tt);
        E !== null && (w.startTime = E, _ = !0);
      }
    }
    Fh(e, p);
    const g = l ?? e.shouldReduceMotion;
    m.start(bm(p, m, y, g && lP.has(p) ? { type: !1 } : w, e, _));
    const O = m.animation;
    O && f.push(O);
  }
  if (o) {
    const p = () => tt.update(() => {
      o && GB(e, o);
    });
    f.length ? Promise.all(f).then(p) : p();
  }
  return f;
}
function Uh(e, t, n = {}) {
  const r = ei(e, t, n.type === "exit" ? e.presenceContext?.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const a = r ? () => Promise.all(dP(e, r, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (u = 0) => {
    const { delayChildren: l = 0, staggerChildren: c, staggerDirection: f } = i;
    return YB(e, t, u, l, c, f, n);
  } : () => Promise.resolve(), { when: d } = i;
  if (d) {
    const [u, l] = d === "beforeChildren" ? [a, o] : [o, a];
    return u().then(() => l());
  } else
    return Promise.all([a(), o(n.delay)]);
}
function YB(e, t, n = 0, r = 0, i = 0, a = 1, o) {
  const d = [];
  for (const u of e.variantChildren)
    u.notify("AnimationStart", t), d.push(Uh(u, t, {
      ...o,
      delay: n + (typeof r == "function" ? 0 : r) + oP(e.variantChildren, u, r, i, a)
    }).then(() => u.notify("AnimationComplete", t)));
  return Promise.all(d);
}
function QB(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((a) => Uh(e, a, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = Uh(e, t, n);
  else {
    const i = typeof t == "function" ? ei(e, t, n.custom) : t;
    r = Promise.all(dP(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const eV = {
  test: (e) => e === "auto",
  parse: (e) => e
}, fP = (e) => (t) => t.test(e), hP = [Yo, Se, Bn, or, IU, xU, eV], q_ = (e) => hP.find(fP(e));
function tV(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || xI(e) : !0;
}
const nV = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function rV(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(fm) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let a = nV.has(t) ? 1 : 0;
  return r !== n && (a *= 100), t + "(" + a + i + ")";
}
const iV = /\b([a-z-]*)\(.*?\)/gu, Bh = {
  ...Tn,
  getAnimatableNone: (e) => {
    const t = e.match(iV);
    return t ? t.map(rV).join(" ") : e;
  }
}, Vh = {
  ...Tn,
  getAnimatableNone: (e) => {
    const t = Tn.parse(e);
    return Tn.createTransformer(e)(t.map((r) => typeof r == "number" ? 0 : typeof r == "object" ? { ...r, alpha: 1 } : r));
  }
}, H_ = {
  ...Yo,
  transform: Math.round
}, oV = {
  rotate: or,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: or,
  rotateX: or,
  rotateY: or,
  rotateZ: or,
  scale: Hl,
  scaleX: Hl,
  scaleY: Hl,
  scaleZ: Hl,
  skew: or,
  skewX: or,
  skewY: or,
  distance: Se,
  translateX: Se,
  translateY: Se,
  translateZ: Se,
  x: Se,
  y: Se,
  z: Se,
  perspective: Se,
  transformPerspective: Se,
  opacity: Ys,
  originX: C_,
  originY: C_,
  originZ: Se
}, Zu = {
  // Border props
  borderWidth: Se,
  borderTopWidth: Se,
  borderRightWidth: Se,
  borderBottomWidth: Se,
  borderLeftWidth: Se,
  borderRadius: Se,
  borderTopLeftRadius: Se,
  borderTopRightRadius: Se,
  borderBottomRightRadius: Se,
  borderBottomLeftRadius: Se,
  // Positioning props
  width: Se,
  maxWidth: Se,
  height: Se,
  maxHeight: Se,
  top: Se,
  right: Se,
  bottom: Se,
  left: Se,
  inset: Se,
  insetBlock: Se,
  insetBlockStart: Se,
  insetBlockEnd: Se,
  insetInline: Se,
  insetInlineStart: Se,
  insetInlineEnd: Se,
  // Spacing props
  padding: Se,
  paddingTop: Se,
  paddingRight: Se,
  paddingBottom: Se,
  paddingLeft: Se,
  paddingBlock: Se,
  paddingBlockStart: Se,
  paddingBlockEnd: Se,
  paddingInline: Se,
  paddingInlineStart: Se,
  paddingInlineEnd: Se,
  margin: Se,
  marginTop: Se,
  marginRight: Se,
  marginBottom: Se,
  marginLeft: Se,
  marginBlock: Se,
  marginBlockStart: Se,
  marginBlockEnd: Se,
  marginInline: Se,
  marginInlineStart: Se,
  marginInlineEnd: Se,
  // Typography
  fontSize: Se,
  // Misc
  backgroundPositionX: Se,
  backgroundPositionY: Se,
  ...oV,
  zIndex: H_,
  // SVG
  fillOpacity: Ys,
  strokeOpacity: Ys,
  numOctaves: H_
}, aV = {
  ...Zu,
  // Color props
  color: vt,
  backgroundColor: vt,
  outlineColor: vt,
  fill: vt,
  stroke: vt,
  // Border props
  borderColor: vt,
  borderTopColor: vt,
  borderRightColor: vt,
  borderBottomColor: vt,
  borderLeftColor: vt,
  filter: Bh,
  WebkitFilter: Bh,
  mask: Vh,
  WebkitMask: Vh
}, pP = (e) => aV[e], sV = /* @__PURE__ */ new Set([Bh, Vh]);
function mP(e, t) {
  let n = pP(e);
  return sV.has(n) || (n = Tn), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const lV = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function uV(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const a = e[r];
    typeof a == "string" && !lV.has(a) && Uo(a).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const a of t)
      e[a] = mP(n, i);
}
class cV extends ym {
  constructor(t, n, r, i, a) {
    super(t, n, r, i, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < t.length; c++) {
      let f = t[c];
      if (typeof f == "string" && (f = f.trim(), dm(f))) {
        const s = sP(f, n.current);
        s !== void 0 && (t[c] = s), c === t.length - 1 && (this.finalKeyframe = f);
      }
    }
    if (this.resolveNoneKeyframes(), !lP.has(r) || t.length !== 2)
      return;
    const [i, a] = t, o = q_(i), d = q_(a), u = N_(i), l = N_(a);
    if (u !== l && kr[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (o !== d)
      if (L_(o) && L_(d))
        for (let c = 0; c < t.length; c++) {
          const f = t[c];
          typeof f == "string" && (t[c] = parseFloat(f));
        }
      else kr[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || tV(t[i])) && r.push(i);
    r.length && uV(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = kr[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const a = r.length - 1, o = r[a];
    r[a] = kr[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), this.removedTransforms?.length && this.removedTransforms.forEach(([d, u]) => {
      t.getValue(d).set(u);
    }), this.resolveNoneKeyframes();
  }
}
const km = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius"
];
function gP(e, t, n) {
  if (e == null)
    return [];
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const i = n?.[e] ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e).filter((r) => r != null);
}
const qh = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function dV(e) {
  return SI(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
const { schedule: Sm } = /* @__PURE__ */ $I(queueMicrotask, !1), kn = {
  x: !1,
  y: !1
};
function yP() {
  return kn.x || kn.y;
}
function fV(e) {
  return e === "x" || e === "y" ? kn[e] ? null : (kn[e] = !0, () => {
    kn[e] = !1;
  }) : kn.x || kn.y ? null : (kn.x = kn.y = !0, () => {
    kn.x = kn.y = !1;
  });
}
function vP(e, t) {
  const n = gP(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function hV(e) {
  return !(e.pointerType === "touch" || yP());
}
function pV(e, t, n = {}) {
  const [r, i, a] = vP(e, n);
  return r.forEach((o) => {
    let d = !1, u = !1, l;
    const c = () => {
      o.removeEventListener("pointerleave", p);
    }, f = (y) => {
      l && (l(y), l = void 0), c();
    }, s = (y) => {
      d = !1, window.removeEventListener("pointerup", s), window.removeEventListener("pointercancel", s), u && (u = !1, f(y));
    }, h = () => {
      d = !0, window.addEventListener("pointerup", s, i), window.addEventListener("pointercancel", s, i);
    }, p = (y) => {
      if (y.pointerType !== "touch") {
        if (d) {
          u = !0;
          return;
        }
        f(y);
      }
    }, m = (y) => {
      if (!hV(y))
        return;
      u = !1;
      const w = t(o, y);
      typeof w == "function" && (l = w, o.addEventListener("pointerleave", p, i));
    };
    o.addEventListener("pointerenter", m, i), o.addEventListener("pointerdown", h, i);
  }), a;
}
const bP = (e, t) => t ? e === t ? !0 : bP(e, t.parentElement) : !1, xm = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, mV = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function gV(e) {
  return mV.has(e.tagName) || e.isContentEditable === !0;
}
const yV = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function vV(e) {
  return yV.has(e.tagName) || e.isContentEditable === !0;
}
const uu = /* @__PURE__ */ new WeakSet();
function W_(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function jf(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const bV = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = W_(() => {
    if (uu.has(n))
      return;
    jf(n, "down");
    const i = W_(() => {
      jf(n, "up");
    }), a = () => jf(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", a, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function G_(e) {
  return xm(e) && !yP();
}
const K_ = /* @__PURE__ */ new WeakSet();
function _V(e, t, n = {}) {
  const [r, i, a] = vP(e, n), o = (d) => {
    const u = d.currentTarget;
    if (!G_(d) || K_.has(d))
      return;
    uu.add(u), n.stopPropagation && K_.add(d);
    const l = t(u, d), c = { ...i, capture: !0 }, f = (p, m) => {
      window.removeEventListener("pointerup", s, c), window.removeEventListener("pointercancel", h, c), uu.has(u) && uu.delete(u), G_(p) && typeof l == "function" && l(p, { success: m });
    }, s = (p) => {
      f(p, u === window || u === document || n.useGlobalTarget || bP(u, p.target));
    }, h = (p) => {
      f(p, !1);
    };
    window.addEventListener("pointerup", s, c), window.addEventListener("pointercancel", h, c);
  };
  return r.forEach((d) => {
    (n.useGlobalTarget ? window : d).addEventListener("pointerdown", o, i), dV(d) && (d.addEventListener("focus", (l) => bV(l, i)), !gV(d) && !d.hasAttribute("tabindex") && (d.tabIndex = 0));
  }), a;
}
function Im(e) {
  return SI(e) && "ownerSVGElement" in e;
}
const cu = /* @__PURE__ */ new WeakMap();
let du;
const _P = (e, t, n) => (r, i) => i && i[0] ? i[0][e + "Size"] : Im(r) && "getBBox" in r ? r.getBBox()[t] : r[n], wV = /* @__PURE__ */ _P("inline", "width", "offsetWidth"), kV = /* @__PURE__ */ _P("block", "height", "offsetHeight");
function SV({ target: e, borderBoxSize: t }) {
  cu.get(e)?.forEach((n) => {
    n(e, {
      get width() {
        return wV(e, t);
      },
      get height() {
        return kV(e, t);
      }
    });
  });
}
function xV(e) {
  e.forEach(SV);
}
function IV() {
  typeof ResizeObserver > "u" || (du = new ResizeObserver(xV));
}
function PV(e, t) {
  du || IV();
  const n = gP(e);
  return n.forEach((r) => {
    let i = cu.get(r);
    i || (i = /* @__PURE__ */ new Set(), cu.set(r, i)), i.add(t), du?.observe(r);
  }), () => {
    n.forEach((r) => {
      const i = cu.get(r);
      i?.delete(t), i?.size || du?.unobserve(r);
    });
  };
}
const fu = /* @__PURE__ */ new Set();
let ko;
function OV() {
  ko = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    fu.forEach((t) => t(e));
  }, window.addEventListener("resize", ko);
}
function zV(e) {
  return fu.add(e), ko || OV(), () => {
    fu.delete(e), !fu.size && typeof ko == "function" && (window.removeEventListener("resize", ko), ko = void 0);
  };
}
function J_(e, t) {
  return typeof e == "function" ? zV(e) : PV(e, t);
}
function EV(e) {
  return Im(e) && e.tagName === "svg";
}
const TV = [...hP, vt, Tn], NV = (e) => TV.find(fP(e)), X_ = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), So = () => ({
  x: X_(),
  y: X_()
}), Y_ = () => ({ min: 0, max: 0 }), xt = () => ({
  x: Y_(),
  y: Y_()
}), CV = /* @__PURE__ */ new WeakMap();
function Oc(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Qs(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Pm = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Om = ["initial", ...Pm];
function zc(e) {
  return Oc(e.animate) || Om.some((t) => Qs(e[t]));
}
function wP(e) {
  return !!(zc(e) || e.variants);
}
function DV(e, t, n) {
  for (const r in t) {
    const i = t[r], a = n[r];
    if (Et(i))
      e.addValue(r, i);
    else if (Et(a))
      e.addValue(r, Bo(i, { owner: e }));
    else if (a !== i)
      if (e.hasValue(r)) {
        const o = e.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = e.getStaticValue(r);
        e.addValue(r, Bo(o !== void 0 ? o : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Lu = { current: null }, zm = { current: !1 }, AV = typeof window < "u";
function kP() {
  if (zm.current = !0, !!AV)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Lu.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Lu.current = !1;
}
const Q_ = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Fu = {};
function SP(e) {
  Fu = e;
}
function jV() {
  return Fu;
}
class MV {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, skipAnimations: a, blockInitialAnimation: o, visualState: d }, u = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = ym, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const h = Rt.now();
      this.renderScheduledAt < h && (this.renderScheduledAt = h, tt.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = d;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.skipAnimationsConfig = a, this.options = u, this.blockInitialAnimation = !!o, this.isControllingVariants = zc(n), this.isVariantNode = wP(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...s } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const h in s) {
      const p = s[h];
      l[h] !== void 0 && Et(p) && p.set(l[h]);
    }
  }
  mount(t) {
    if (this.hasBeenMounted)
      for (const n in this.initialValues)
        this.values.get(n)?.jump(this.initialValues[n]), this.latestValues[n] = this.initialValues[n];
    this.current = t, CV.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (zm.current || kP(), this.shouldReduceMotion = Lu.current), process.env.NODE_ENV !== "production" && Ic(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, this.parent?.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    this.projection && this.projection.unmount(), xr(this.notifyUpdate), xr(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    if (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(), n.accelerate && iP.has(t) && this.current instanceof HTMLElement) {
      const { factory: o, keyframes: d, times: u, ease: l, duration: c } = n.accelerate, f = new nP({
        element: this.current,
        name: t,
        keyframes: d,
        times: u,
        ease: l,
        duration: /* @__PURE__ */ Ht(c)
      }), s = o(f);
      this.valueSubscriptions.set(t, () => {
        s(), f.cancel();
      });
      return;
    }
    const r = ea.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && tt.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let a;
    typeof window < "u" && window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), a && a();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Fu) {
      const n = Fu[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const a = this.features[t];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : xt();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Q_.length; r++) {
      const i = Q_[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = "on" + i, o = t[a];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = DV(this, this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Bo(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (kI(r) || xI(r)) ? r = parseFloat(r) : !NV(r) && Tn.test(n) && (r = mP(t, n)), this.setBaseTarget(t, Et(r) ? r.get() : r)), Et(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const a = _m(this.props, n, this.presenceContext?.custom);
      a && (r = a[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !Et(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new lm()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    Sm.render(this.render);
  }
}
class xP extends MV {
  constructor() {
    super(...arguments), this.KeyframeResolver = cV;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    const r = t.style;
    return r ? r[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Et(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Tr {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function IP({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function $V({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function RV(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Mf(e) {
  return e === void 0 || e === 1;
}
function Hh({ scale: e, scaleX: t, scaleY: n }) {
  return !Mf(e) || !Mf(t) || !Mf(n);
}
function Hr(e) {
  return Hh(e) || PP(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function PP(e) {
  return ew(e.x) || ew(e.y);
}
function ew(e) {
  return e && e !== "0%";
}
function Uu(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function tw(e, t, n, r, i) {
  return i !== void 0 && (e = Uu(e, i, r)), Uu(e, n, r) + t;
}
function Wh(e, t = 0, n = 1, r, i) {
  e.min = tw(e.min, t, n, r, i), e.max = tw(e.max, t, n, r, i);
}
function OP(e, { x: t, y: n }) {
  Wh(e.x, t.translate, t.scale, t.originPoint), Wh(e.y, n.translate, n.scale, n.originPoint);
}
const nw = 0.999999999999, rw = 1.0000000000001;
function ZV(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let a, o;
  for (let d = 0; d < i; d++) {
    a = n[d], o = a.projectionDelta;
    const { visualElement: u } = a.options;
    u && u.props.style && u.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && (Ln(e.x, -a.scroll.offset.x), Ln(e.y, -a.scroll.offset.y)), o && (t.x *= o.x.scale, t.y *= o.y.scale, OP(e, o)), r && Hr(a.latestValues) && hu(e, a.latestValues, a.layout?.layoutBox));
  }
  t.x < rw && t.x > nw && (t.x = 1), t.y < rw && t.y > nw && (t.y = 1);
}
function Ln(e, t) {
  e.min += t, e.max += t;
}
function iw(e, t, n, r, i = 0.5) {
  const a = et(e.min, e.max, i);
  Wh(e, t, n, a, r);
}
function ow(e, t) {
  return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function hu(e, t, n) {
  const r = n ?? e;
  iw(e.x, ow(t.x, r.x), t.scaleX, t.scale, t.originX), iw(e.y, ow(t.y, r.y), t.scaleY, t.scale, t.originY);
}
function zP(e, t) {
  return IP(RV(e.getBoundingClientRect(), t));
}
function LV(e, t, n) {
  const r = zP(e, n), { scroll: i } = t;
  return i && (Ln(r.x, i.offset.x), Ln(r.y, i.offset.y)), r;
}
const FV = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, UV = Qo.length;
function BV(e, t, n) {
  let r = "", i = !0;
  for (let o = 0; o < UV; o++) {
    const d = Qo[o], u = e[d];
    if (u === void 0)
      continue;
    let l = !0;
    if (typeof u == "number")
      l = u === (d.startsWith("scale") ? 1 : 0);
    else {
      const c = parseFloat(u);
      l = d.startsWith("scale") ? c === 1 : c === 0;
    }
    if (!l || n) {
      const c = qh(u, Zu[d]);
      if (!l) {
        i = !1;
        const f = FV[d] || d;
        r += `${f}(${c}) `;
      }
      n && (t[d] = c);
    }
  }
  const a = e.pathRotation;
  return a && (i = !1, r += `rotate(${qh(a, Zu.pathRotation)}) `), r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function Em(e, t, n) {
  const { style: r, vars: i, transformOrigin: a } = e;
  let o = !1, d = !1;
  for (const u in t) {
    const l = t[u];
    if (ea.has(u)) {
      o = !0;
      continue;
    } else if (ZI(u)) {
      i[u] = l;
      continue;
    } else {
      const c = qh(l, Zu[u]);
      u.startsWith("origin") ? (d = !0, a[u] = c) : r[u] = c;
    }
  }
  if (t.transform || (o || n ? r.transform = BV(t, e.transform, n) : r.transform && (r.transform = "none")), d) {
    const { originX: u = "50%", originY: l = "50%", originZ: c = 0 } = a;
    r.transformOrigin = `${u} ${l} ${c}`;
  }
}
function EP(e, { style: t, vars: n }, r, i) {
  const a = e.style;
  let o;
  for (o in t)
    a[o] = t[o];
  i?.applyProjectionStyles(a, r);
  for (o in n)
    a.setProperty(o, n[o]);
}
function aw(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Na = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Se.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = aw(e, t.target.x), r = aw(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, VV = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = Tn.parse(e);
    if (i.length > 5)
      return r;
    const a = Tn.createTransformer(e), o = typeof i[0] != "number" ? 1 : 0, d = n.x.scale * t.x, u = n.y.scale * t.y;
    i[0 + o] /= d, i[1 + o] /= u;
    const l = et(d, u, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= l), typeof i[3 + o] == "number" && (i[3 + o] /= l), a(i);
  }
}, Gh = {
  borderRadius: {
    ...Na,
    applyTo: [...km]
  },
  borderTopLeftRadius: Na,
  borderTopRightRadius: Na,
  borderBottomLeftRadius: Na,
  borderBottomRightRadius: Na,
  boxShadow: VV
};
function TP(e, { layout: t, layoutId: n }) {
  return ea.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Gh[e] || e === "opacity");
}
function Tm(e, t, n) {
  const r = e.style, i = t?.style, a = {};
  if (!r)
    return a;
  for (const o in r)
    (Et(r[o]) || i && Et(i[o]) || TP(o, e) || n?.getValue(o)?.liveStyle !== void 0) && (a[o] = r[o]);
  return a;
}
function qV(e) {
  return window.getComputedStyle(e);
}
class HV extends xP {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = EP;
  }
  mount(t) {
    qn(!!t.style, "motion.create() components must forward their ref to a HTML or SVG element", "custom-component-ref"), super.mount(t);
  }
  readValueFromInstance(t, n) {
    if (ea.has(n))
      return this.projection?.isProjecting ? Ah(n) : dB(t, n);
    {
      const r = qV(t), i = (ZI(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return zP(t, n);
  }
  build(t, n, r) {
    Em(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Tm(t, n, r);
  }
}
const WV = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, GV = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function KV(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const a = i ? WV : GV;
  e[a.offset] = `${-r}`, e[a.array] = `${t} ${n}`;
}
const JV = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function NP(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: i,
  pathSpacing: a = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...d
}, u, l, c) {
  if (Em(e, d, l), u) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: s } = e;
  f.transform && (s.transform = f.transform, delete f.transform), (s.transform || f.transformOrigin) && (s.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), s.transform && (s.transformBox = c?.transformBox ?? "fill-box", delete f.transformBox);
  for (const h of JV)
    f[h] !== void 0 && (s[h] = f[h], delete f[h]);
  t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), i !== void 0 && KV(f, i, a, o, !1);
}
const CP = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), DP = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function XV(e, t, n, r) {
  EP(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(CP.has(i) ? i : wm(i), t.attrs[i]);
}
function AP(e, t, n) {
  const r = Tm(e, t, n);
  for (const i in e)
    if (Et(e[i]) || Et(t[i])) {
      const a = Qo.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[a] = e[i];
    }
  return r;
}
class YV extends xP {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = xt;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (ea.has(n)) {
      const r = pP(n);
      return r && r.default || 0;
    }
    return n = CP.has(n) ? n : wm(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return AP(t, n, r);
  }
  build(t, n, r) {
    NP(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, i) {
    XV(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = DP(t.tagName), super.mount(t);
  }
}
const QV = Om.length;
function jP(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? jP(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < QV; n++) {
    const r = Om[n], i = e.props[r];
    (Qs(i) || i === !1) && (t[r] = i);
  }
  return t;
}
function MP(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const e5 = [...Pm].reverse(), t5 = Pm.length;
function n5(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => QB(e, n, r)));
}
function r5(e) {
  let t = n5(e), n = sw(), r = !0, i = !1;
  const a = (l) => (c, f) => {
    const s = ei(e, f, l === "exit" ? e.presenceContext?.custom : void 0);
    if (s) {
      const { transition: h, transitionEnd: p, ...m } = s;
      c = { ...c, ...m, ...p };
    }
    return c;
  };
  function o(l) {
    t = l(e);
  }
  function d(l) {
    const { props: c } = e, f = jP(e.parent) || {}, s = [], h = /* @__PURE__ */ new Set();
    let p = {}, m = 1 / 0;
    for (let w = 0; w < t5; w++) {
      const b = e5[w], _ = n[b], g = c[b] !== void 0 ? c[b] : f[b], O = Qs(g), P = b === l ? _.isActive : null;
      P === !1 && (m = w);
      let E = g === f[b] && g !== c[b] && O;
      if (E && (r || i) && e.manuallyAnimateOnMount && (E = !1), _.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !_.isActive && P === null || // If we didn't and don't have any defined prop for this animation type
      !g && !_.prevProp || // Or if the prop doesn't define an animation
      Oc(g) || typeof g == "boolean")
        continue;
      if (b === "exit" && _.isActive && P !== !0) {
        _.prevResolvedValues && (p = {
          ...p,
          ..._.prevResolvedValues
        });
        continue;
      }
      const T = i5(_.prevProp, g);
      let D = T || // If we're making this variant active, we want to always make it active
      b === l && _.isActive && !E && O || // If we removed a higher-priority variant (i is in reverse order)
      w > m && O, N = !1;
      const M = Array.isArray(g) ? g : [g];
      let R = M.reduce(a(b), {});
      P === !1 && (R = {});
      const { prevResolvedValues: V = {} } = _, C = {
        ...V,
        ...R
      }, B = (k) => {
        D = !0, h.has(k) && (N = !0, h.delete(k)), _.needsAnimating[k] = !0;
        const I = e.getValue(k);
        I && (I.liveStyle = !1);
      };
      for (const k in C) {
        const I = R[k], S = V[k];
        if (p.hasOwnProperty(k))
          continue;
        let A = !1;
        Lh(I) && Lh(S) ? A = !MP(I, S) || T : A = I !== S, A ? I != null ? B(k) : h.add(k) : I !== void 0 && h.has(k) ? B(k) : _.protectedKeys[k] = !0;
      }
      _.prevProp = g, _.prevResolvedValues = R, _.isActive && (p = { ...p, ...R }), (r || i) && e.blockInitialAnimation && (D = !1);
      const G = E && T;
      D && (!G || N) && s.push(...M.map((k) => {
        const I = { type: b };
        if (typeof k == "string" && (r || i) && !G && e.manuallyAnimateOnMount && e.parent) {
          const { parent: S } = e, A = ei(S, k);
          if (S.enteringChildren && A) {
            const { delayChildren: j } = A.transition || {};
            I.delay = oP(S.enteringChildren, e, j);
          }
        }
        return {
          animation: k,
          options: I
        };
      }));
    }
    if (h.size) {
      const w = {};
      if (typeof c.initial != "boolean") {
        const b = ei(e, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        b && b.transition && (w.transition = b.transition);
      }
      h.forEach((b) => {
        const _ = e.getBaseTarget(b), g = e.getValue(b);
        g && (g.liveStyle = !0), w[b] = _ ?? null;
      }), s.push({ animation: w });
    }
    let y = !!s.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, i = !1, y ? t(s) : Promise.resolve();
  }
  function u(l, c) {
    if (n[l].isActive === c)
      return Promise.resolve();
    e.variantChildren?.forEach((s) => s.animationState?.setActive(l, c)), n[l].isActive = c;
    const f = d(l);
    for (const s in n)
      n[s].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: d,
    setActive: u,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = sw(), i = !0;
    }
  };
}
function i5(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !MP(t, e) : !1;
}
function Zr(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function sw() {
  return {
    animate: Zr(!0),
    whileInView: Zr(),
    whileHover: Zr(),
    whileTap: Zr(),
    whileDrag: Zr(),
    whileFocus: Zr(),
    exit: Zr()
  };
}
function Kh(e, t) {
  e.min = t.min, e.max = t.max;
}
function _n(e, t) {
  Kh(e.x, t.x), Kh(e.y, t.y);
}
function lw(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
const $P = 1e-4, o5 = 1 - $P, a5 = 1 + $P, RP = 0.01, s5 = 0 - RP, l5 = 0 + RP;
function Zt(e) {
  return e.max - e.min;
}
function u5(e, t, n) {
  return Math.abs(e - t) <= n;
}
function uw(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = et(t.min, t.max, e.origin), e.scale = Zt(n) / Zt(t), e.translate = et(n.min, n.max, e.origin) - e.originPoint, (e.scale >= o5 && e.scale <= a5 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= s5 && e.translate <= l5 || isNaN(e.translate)) && (e.translate = 0);
}
function $s(e, t, n, r) {
  uw(e.x, t.x, n.x, r ? r.originX : void 0), uw(e.y, t.y, n.y, r ? r.originY : void 0);
}
function cw(e, t, n, r = 0) {
  const i = r ? et(n.min, n.max, r) : n.min;
  e.min = i + t.min, e.max = e.min + Zt(t);
}
function c5(e, t, n, r) {
  cw(e.x, t.x, n.x, r?.x), cw(e.y, t.y, n.y, r?.y);
}
function dw(e, t, n, r = 0) {
  const i = r ? et(n.min, n.max, r) : n.min;
  e.min = t.min - i, e.max = e.min + Zt(t);
}
function Bu(e, t, n, r) {
  dw(e.x, t.x, n.x, r?.x), dw(e.y, t.y, n.y, r?.y);
}
function fw(e, t, n, r, i) {
  return e -= t, e = Uu(e, 1 / n, r), i !== void 0 && (e = Uu(e, 1 / i, r)), e;
}
function d5(e, t = 0, n = 1, r = 0.5, i, a = e, o = e) {
  if (Bn.test(t) && (t = parseFloat(t), t = et(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let d = et(a.min, a.max, r);
  e === a && (d -= t), e.min = fw(e.min, t, n, d, i), e.max = fw(e.max, t, n, d, i);
}
function hw(e, t, [n, r, i], a, o) {
  d5(e, t[n], t[r], t[i], t.scale, a, o);
}
const f5 = ["x", "scaleX", "originX"], h5 = ["y", "scaleY", "originY"];
function pw(e, t, n, r) {
  hw(e.x, t, f5, n ? n.x : void 0, r ? r.x : void 0), hw(e.y, t, h5, n ? n.y : void 0, r ? r.y : void 0);
}
function mw(e) {
  return e.translate === 0 && e.scale === 1;
}
function ZP(e) {
  return mw(e.x) && mw(e.y);
}
function gw(e, t) {
  return e.min === t.min && e.max === t.max;
}
function p5(e, t) {
  return gw(e.x, t.x) && gw(e.y, t.y);
}
function yw(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function LP(e, t) {
  return yw(e.x, t.x) && yw(e.y, t.y);
}
function vw(e) {
  return Zt(e.x) / Zt(e.y);
}
function bw(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
function Rn(e) {
  return [e("x"), e("y")];
}
function m5(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, a = e.y.translate / t.y, o = n?.z || 0;
  if ((i || a || o) && (r = `translate3d(${i}px, ${a}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: l, rotate: c, pathRotation: f, rotateX: s, rotateY: h, skewX: p, skewY: m } = n;
    l && (r = `perspective(${l}px) ${r}`), c && (r += `rotate(${c}deg) `), f && (r += `rotate(${f}deg) `), s && (r += `rotateX(${s}deg) `), h && (r += `rotateY(${h}deg) `), p && (r += `skewX(${p}deg) `), m && (r += `skewY(${m}deg) `);
  }
  const d = e.x.scale * t.x, u = e.y.scale * t.y;
  return (d !== 1 || u !== 1) && (r += `scale(${d}, ${u})`), r || "none";
}
const g5 = km.length, _w = (e) => typeof e == "string" ? parseFloat(e) : e, ww = (e) => typeof e == "number" || Se.test(e);
function y5(e, t, n, r, i, a) {
  i ? (e.opacity = et(0, n.opacity ?? 1, v5(r)), e.opacityExit = et(t.opacity ?? 1, 0, b5(r))) : a && (e.opacity = et(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let o = 0; o < g5; o++) {
    const d = km[o];
    let u = kw(t, d), l = kw(n, d);
    if (u === void 0 && l === void 0)
      continue;
    u || (u = 0), l || (l = 0), u === 0 || l === 0 || ww(u) === ww(l) ? (e[d] = Math.max(et(_w(u), _w(l), r), 0), (Bn.test(l) || Bn.test(u)) && (e[d] += "%")) : e[d] = l;
  }
  (t.rotate || n.rotate) && (e.rotate = et(t.rotate || 0, n.rotate || 0, r));
}
function kw(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const v5 = /* @__PURE__ */ FP(0, 0.5, DI), b5 = /* @__PURE__ */ FP(0.5, 0.95, dn);
function FP(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ Xs(e, t, r));
}
function _5(e, t, n) {
  const r = Et(e) ? e : Bo(e);
  return r.start(bm("", r, t, n)), r.animation;
}
function el(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
}
const w5 = (e, t) => e.depth - t.depth;
class k5 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    sm(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Au(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(w5), this.isDirty = !1, this.children.forEach(t);
  }
}
function S5(e, t) {
  const n = Rt.now(), r = ({ timestamp: i }) => {
    const a = i - n;
    a >= t && (xr(r), e(a - t));
  };
  return tt.setup(r, !0), () => xr(r);
}
function pu(e) {
  return Et(e) ? e.get() : e;
}
class x5 {
  constructor() {
    this.members = [];
  }
  add(t) {
    sm(this.members, t);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r === t || r === this.lead || r === this.prevLead)
        continue;
      const i = r.instance;
      (!i || i.isConnected === !1) && !r.snapshot && (Au(this.members, r), r.unmount());
    }
    t.scheduleRender();
  }
  remove(t) {
    if (Au(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    for (let n = this.members.indexOf(t) - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r.isPresent !== !1 && r.instance?.isConnected !== !1)
        return this.promote(r), !0;
    }
    return !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.updateSnapshot(), t.scheduleRender();
      const { layoutDependency: i } = r.options, { layoutDependency: a } = t.options;
      (i === void 0 || i !== a) && (t.resumeFrom = r, n && (r.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root?.isUpdating && (t.isLayoutDirty = !0)), t.options.crossfade === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      t.options.onExitComplete?.(), t.resumingFrom?.options.onExitComplete?.();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => t.instance && t.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    this.lead?.snapshot && (this.lead.snapshot = void 0);
  }
}
const mu = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, $f = ["", "X", "Y", "Z"], I5 = 1e3;
let P5 = 0;
function Rf(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function UP(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = cP(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: a } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", tt, !(i || a));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && UP(r);
}
function BP({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(o = {}, d = t?.()) {
      this.id = P5++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(E5), this.nodes.forEach(j5), this.nodes.forEach(M5), this.nodes.forEach(T5);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = d ? d.root || d : this, this.path = d ? [...d.path, d] : [], this.parent = d, this.depth = d ? d.depth + 1 : 0;
      for (let u = 0; u < this.path.length; u++)
        this.path[u].shouldResetTransform = !0;
      this.root === this && (this.nodes = new k5());
    }
    addEventListener(o, d) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new lm()), this.eventHandlers.get(o).add(d);
    }
    notifyListeners(o, ...d) {
      const u = this.eventHandlers.get(o);
      u && u.notify(...d);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = Im(o) && !EV(o), this.instance = o;
      const { layoutId: d, layout: u, visualElement: l } = this.options;
      if (l && !l.current && l.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (u || d) && (this.isLayoutDirty = !0), e) {
        let c, f = 0;
        const s = () => this.root.updateBlockedByResize = !1;
        tt.read(() => {
          f = window.innerWidth;
        }), e(o, () => {
          const h = window.innerWidth;
          h !== f && (f = h, this.root.updateBlockedByResize = !0, c && c(), c = S5(s, 250), mu.hasAnimatedSinceResize && (mu.hasAnimatedSinceResize = !1, this.nodes.forEach(Iw)));
        });
      }
      d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && l && (d || u) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: f, hasRelativeLayoutChanged: s, layout: h }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || l.getDefaultTransition() || F5, { onLayoutAnimationStart: m, onLayoutAnimationComplete: y } = l.getProps(), w = !this.targetLayout || !LP(this.targetLayout, h), b = !f && s;
        if (this.options.layoutRoot || this.resumeFrom || b || f && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const _ = {
            ...vm(p, "layout"),
            onPlay: m,
            onComplete: y
          };
          (l.shouldReduceMotion || this.options.layoutRoot) && (_.delay = 0, _.type = !1), this.startAnimation(_), this.setAnimationOrigin(c, b, _.path);
        } else
          f || Iw(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = h;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), xr(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach($5), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && UP(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        f.shouldResetTransform = !0, (typeof f.latestValues.x == "string" || typeof f.latestValues.y == "string") && (f.isLayoutDirty = !0), f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: d, layout: u } = this.options;
      if (d === void 0 && !u)
        return;
      const l = this.getTransformTemplate();
      this.prevTransformTemplateValue = l ? l(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const u = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), u && this.nodes.forEach(C5), this.nodes.forEach(Sw);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(xw);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(D5), this.nodes.forEach(A5), this.nodes.forEach(O5), this.nodes.forEach(z5)) : this.nodes.forEach(xw), this.clearAllSnapshots();
      const d = Rt.now();
      zt.delta = Vn(0, 1e3 / 60, d - zt.timestamp), zt.timestamp = d, zt.isProcessing = !0, Ef.update.process(zt), Ef.preRender.process(zt), Ef.render.process(zt), zt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Sm.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(N5), this.sharedNodes.forEach(R5);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, tt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      tt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Zt(this.snapshot.measuredBox.x) && !Zt(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let u = 0; u < this.path.length; u++)
          this.path[u].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = xt()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: d } = this.options;
      d && d.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let d = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (d = !1), d && this.instance) {
        const u = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: u,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : u
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, d = this.projectionDelta && !ZP(this.projectionDelta), u = this.getTransformTemplate(), l = u ? u(this.latestValues, "") : void 0, c = l !== this.prevTransformTemplateValue;
      o && this.instance && (d || Hr(this.latestValues) || c) && (i(this.instance, l), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const d = this.measurePageBox();
      let u = this.removeElementScroll(d);
      return o && (u = this.removeTransform(u)), U5(u), {
        animationId: this.root.animationId,
        measuredBox: d,
        layoutBox: u,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: o } = this.options;
      if (!o)
        return xt();
      const d = o.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(B5))) {
        const { scroll: l } = this.root;
        l && (Ln(d.x, l.offset.x), Ln(d.y, l.offset.y));
      }
      return d;
    }
    removeElementScroll(o) {
      const d = xt();
      if (_n(d, o), this.scroll?.wasRoot)
        return d;
      for (let u = 0; u < this.path.length; u++) {
        const l = this.path[u], { scroll: c, options: f } = l;
        l !== this.root && c && f.layoutScroll && (c.wasRoot && _n(d, o), Ln(d.x, c.offset.x), Ln(d.y, c.offset.y));
      }
      return d;
    }
    applyTransform(o, d = !1, u) {
      const l = u || xt();
      _n(l, o);
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        !d && f.options.layoutScroll && f.scroll && f !== f.root && (Ln(l.x, -f.scroll.offset.x), Ln(l.y, -f.scroll.offset.y)), Hr(f.latestValues) && hu(l, f.latestValues, f.layout?.layoutBox);
      }
      return Hr(this.latestValues) && hu(l, this.latestValues, this.layout?.layoutBox), l;
    }
    removeTransform(o) {
      const d = xt();
      _n(d, o);
      for (let u = 0; u < this.path.length; u++) {
        const l = this.path[u];
        if (!Hr(l.latestValues))
          continue;
        let c;
        l.instance && (Hh(l.latestValues) && l.updateSnapshot(), c = xt(), _n(c, l.measurePageBox())), pw(d, l.latestValues, l.snapshot?.layoutBox, c);
      }
      return Hr(this.latestValues) && pw(d, this.latestValues), d;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== zt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      const d = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = d.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = d.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = d.isSharedProjectionDirty);
      const u = !!this.resumingFrom || this !== d;
      if (!(o || u && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: f } = this.options;
      if (!this.layout || !(c || f))
        return;
      this.resolvedRelativeTargetAt = zt.timestamp;
      const s = this.getClosestProjectingParent();
      s && this.linkedParentVersion !== s.layoutVersion && !s.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && s && s.layout ? this.createRelativeTarget(s, this.layout.layoutBox, s.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = xt(), this.targetWithTransforms = xt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), c5(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : _n(this.target, this.layout.layoutBox), OP(this.target, this.targetDelta)) : _n(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && s && !!s.resumingFrom == !!this.resumingFrom && !s.options.layoutScroll && s.target && this.animationProgress !== 1 ? this.createRelativeTarget(s, this.target, s.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Hh(this.parent.latestValues) || PP(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(o, d, u) {
      this.relativeParent = o, this.linkedParentVersion = o.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = xt(), this.relativeTargetOrigin = xt(), Bu(this.relativeTargetOrigin, d, u, this.options.layoutAnchor || void 0), _n(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      const o = this.getLead(), d = !!this.resumingFrom || this !== o;
      let u = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (u = !1), d && (this.isSharedProjectionDirty || this.isTransformDirty) && (u = !1), this.resolvedRelativeTargetAt === zt.timestamp && (u = !1), u)
        return;
      const { layout: l, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(l || c))
        return;
      _n(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, s = this.treeScale.y;
      ZV(this.layoutCorrected, this.treeScale, this.path, d), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = xt());
      const { target: h } = o;
      if (!h) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (lw(this.prevProjectionDelta.x, this.projectionDelta.x), lw(this.prevProjectionDelta.y, this.projectionDelta.y)), $s(this.projectionDelta, this.layoutCorrected, h, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== s || !bw(this.projectionDelta.x, this.prevProjectionDelta.x) || !bw(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      if (this.options.visualElement?.scheduleRender(), o) {
        const d = this.getStack();
        d && d.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = So(), this.projectionDelta = So(), this.projectionDeltaWithTransform = So();
    }
    setAnimationOrigin(o, d = !1, u) {
      const l = this.snapshot, c = l ? l.latestValues : {}, f = { ...this.latestValues }, s = So();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !d;
      const h = xt(), p = l ? l.source : void 0, m = this.layout ? this.layout.source : void 0, y = p !== m, w = this.getStack(), b = !w || w.members.length <= 1, _ = !!(y && !b && this.options.crossfade === !0 && !this.path.some(L5));
      this.animationProgress = 0;
      let g;
      const O = u?.interpolateProjection(o);
      this.mixTargetDelta = (P) => {
        const E = P / 1e3, T = O?.(E);
        T ? (s.x.translate = T.x, s.x.scale = et(o.x.scale, 1, E), s.x.origin = o.x.origin, s.x.originPoint = o.x.originPoint, s.y.translate = T.y, s.y.scale = et(o.y.scale, 1, E), s.y.origin = o.y.origin, s.y.originPoint = o.y.originPoint) : (Pw(s.x, o.x, E), Pw(s.y, o.y, E)), this.setTargetDelta(s), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Bu(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), Z5(this.relativeTarget, this.relativeTargetOrigin, h, E), g && p5(this.relativeTarget, g) && (this.isProjectionDirty = !1), g || (g = xt()), _n(g, this.relativeTarget)), y && (this.animationValues = f, y5(f, c, this.latestValues, E, _, b)), T && T.rotate !== void 0 && (this.animationValues || (this.animationValues = f), this.animationValues.pathRotation = T.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = E;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (xr(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = tt.update(() => {
        mu.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Bo(0)), this.motionValue.jump(0, !1), this.currentAnimation = _5(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (d) => {
            this.mixTargetDelta(d), o.onUpdate && o.onUpdate(d);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(I5), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: d, target: u, layout: l, latestValues: c } = o;
      if (!(!d || !u || !l)) {
        if (this !== o && this.layout && l && VP(this.options.animationType, this.layout.layoutBox, l.layoutBox)) {
          u = this.target || xt();
          const f = Zt(this.layout.layoutBox.x);
          u.x.min = o.target.x.min, u.x.max = u.x.min + f;
          const s = Zt(this.layout.layoutBox.y);
          u.y.min = o.target.y.min, u.y.max = u.y.min + s;
        }
        _n(d, u), hu(d, c), $s(this.projectionDeltaWithTransform, this.layoutCorrected, d, c);
      }
    }
    registerSharedNode(o, d) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new x5()), this.sharedNodes.get(o).add(d);
      const l = d.options.initialPromotionConfig;
      d.promote({
        transition: l ? l.transition : void 0,
        preserveFollowOpacity: l && l.shouldPreserveFollowOpacity ? l.shouldPreserveFollowOpacity(d) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      const { layoutId: o } = this.options;
      return o ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: o } = this.options;
      return o ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: d, preserveFollowOpacity: u } = {}) {
      const l = this.getStack();
      l && l.promote(this, u), o && (this.projectionDelta = void 0, this.needsReset = !0), d && this.setOptions({ transition: d });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let d = !1;
      const { latestValues: u } = o;
      if ((u.z || u.rotate || u.rotateX || u.rotateY || u.rotateZ || u.skewX || u.skewY) && (d = !0), !d)
        return;
      const l = {};
      u.z && Rf("z", o, l, this.animationValues);
      for (let c = 0; c < $f.length; c++)
        Rf(`rotate${$f[c]}`, o, l, this.animationValues), Rf(`skew${$f[c]}`, o, l, this.animationValues);
      o.render();
      for (const c in l)
        o.setStaticValue(c, l[c]), this.animationValues && (this.animationValues[c] = l[c]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, d) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const u = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = pu(d?.pointerEvents) || "", o.transform = u ? u(this.latestValues, "") : "none";
        return;
      }
      const l = this.getLead();
      if (!this.projectionDelta || !this.layout || !l.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = pu(d?.pointerEvents) || ""), this.hasProjected && !Hr(this.latestValues) && (o.transform = u ? u({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const c = l.animationValues || l.latestValues;
      this.applyTransformsToTarget();
      let f = m5(this.projectionDeltaWithTransform, this.treeScale, c);
      u && (f = u(c, f)), o.transform = f;
      const { x: s, y: h } = this.projectionDelta;
      o.transformOrigin = `${s.origin * 100}% ${h.origin * 100}% 0`, l.animationValues ? o.opacity = l === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : o.opacity = l === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const p in Gh) {
        if (c[p] === void 0)
          continue;
        const { correct: m, applyTo: y, isCSSVariable: w } = Gh[p], b = f === "none" ? c[p] : m(c[p], l);
        if (y) {
          const _ = y.length;
          for (let g = 0; g < _; g++)
            o[y[g]] = b;
        } else
          w ? this.options.visualElement.renderState.vars[p] = b : o[p] = b;
      }
      this.options.layoutId && (o.pointerEvents = l === this ? pu(d?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => o.currentAnimation?.stop()), this.root.nodes.forEach(Sw), this.root.sharedNodes.clear();
    }
  };
}
function O5(e) {
  e.updateLayout();
}
function z5(e) {
  const t = e.resumeFrom?.snapshot || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: r } = e.layout, { animationType: i } = e.options, a = t.source !== e.layout.source;
    if (i === "size")
      Rn((c) => {
        const f = a ? t.measuredBox[c] : t.layoutBox[c], s = Zt(f);
        f.min = n[c].min, f.max = f.min + s;
      });
    else if (i === "x" || i === "y") {
      const c = i === "x" ? "y" : "x";
      Kh(a ? t.measuredBox[c] : t.layoutBox[c], n[c]);
    } else VP(i, t.layoutBox, n) && Rn((c) => {
      const f = a ? t.measuredBox[c] : t.layoutBox[c], s = Zt(n[c]);
      f.max = f.min + s, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[c].max = e.relativeTarget[c].min + s);
    });
    const o = So();
    $s(o, n, t.layoutBox);
    const d = So();
    a ? $s(d, e.applyTransform(r, !0), t.measuredBox) : $s(d, n, t.layoutBox);
    const u = !ZP(o);
    let l = !1;
    if (!e.resumeFrom) {
      const c = e.getClosestProjectingParent();
      if (c && !c.resumeFrom) {
        const { snapshot: f, layout: s } = c;
        if (f && s) {
          const h = e.options.layoutAnchor || void 0, p = xt();
          Bu(p, t.layoutBox, f.layoutBox, h);
          const m = xt();
          Bu(m, n, s.layoutBox, h), LP(p, m) || (l = !0), c.options.layoutRoot && (e.relativeTarget = m, e.relativeTargetOrigin = p, e.relativeParent = c);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: n,
      snapshot: t,
      delta: d,
      layoutDelta: o,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: l
    });
  } else if (e.isLead()) {
    const { onExitComplete: n } = e.options;
    n && n();
  }
  e.options.transition = void 0;
}
function E5(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function T5(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function N5(e) {
  e.clearSnapshot();
}
function Sw(e) {
  e.clearMeasurements();
}
function C5(e) {
  e.isLayoutDirty = !0, e.updateLayout();
}
function xw(e) {
  e.isLayoutDirty = !1;
}
function D5(e) {
  e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function A5(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Iw(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function j5(e) {
  e.resolveTargetDelta();
}
function M5(e) {
  e.calcProjection();
}
function $5(e) {
  e.resetSkewAndRotation();
}
function R5(e) {
  e.removeLeadSnapshot();
}
function Pw(e, t, n) {
  e.translate = et(t.translate, 0, n), e.scale = et(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Ow(e, t, n, r) {
  e.min = et(t.min, n.min, r), e.max = et(t.max, n.max, r);
}
function Z5(e, t, n, r) {
  Ow(e.x, t.x, n.x, r), Ow(e.y, t.y, n.y, r);
}
function L5(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const F5 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, zw = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Ew = zw("applewebkit/") && !zw("chrome/") ? Math.round : dn;
function Tw(e) {
  e.min = Ew(e.min), e.max = Ew(e.max);
}
function U5(e) {
  Tw(e.x), Tw(e.y);
}
function VP(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !u5(vw(t), vw(n), 0.2);
}
function B5(e) {
  return e !== e.root && e.scroll?.wasRoot;
}
const V5 = BP({
  attachResizeListener: (e, t) => el(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
    y: document.documentElement.scrollTop || document.body?.scrollTop || 0
  }),
  checkIsScrollRoot: () => !0
}), Zf = {
  current: void 0
}, qP = BP({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Zf.current) {
      const e = new V5({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Zf.current = e;
    }
    return Zf.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), HP = Wt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function q5(e = !0) {
  const t = st(am);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = t, a = Ho();
  Ze(() => {
    if (e)
      return i(a);
  }, [e]);
  const o = Ye(() => e && r && r(a), [a, r, e]);
  return !n && r ? [!1, o] : [!0];
}
const WP = Wt({ strict: !1 }), Nw = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let Cw = !1;
function H5() {
  if (Cw)
    return;
  const e = {};
  for (const t in Nw)
    e[t] = {
      isEnabled: (n) => Nw[t].some((r) => !!n[r])
    };
  SP(e), Cw = !0;
}
function GP() {
  return H5(), jV();
}
function W5(e) {
  const t = GP();
  for (const n in e)
    t[n] = {
      ...t[n],
      ...e[n]
    };
  SP(t);
}
const G5 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function Vu(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || G5.has(e);
}
let KP = (e) => !Vu(e);
function K5(e) {
  typeof e == "function" && (KP = (t) => t.startsWith("on") ? !Vu(t) : e(t));
}
try {
  K5(require("@emotion/is-prop-valid").default);
} catch {
}
function J5(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || Et(e[i]) || (KP(i) || n === !0 && Vu(i) || !t && !Vu(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
const Ec = /* @__PURE__ */ Wt({});
function X5(e, t) {
  if (zc(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Qs(n) ? n : void 0,
      animate: Qs(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Y5(e) {
  const { initial: t, animate: n } = X5(e, st(Ec));
  return Le(() => ({ initial: t, animate: n }), [Dw(t), Dw(n)]);
}
function Dw(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Nm = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function JP(e, t, n) {
  for (const r in t)
    !Et(t[r]) && !TP(r, n) && (e[r] = t[r]);
}
function Q5({ transformTemplate: e }, t) {
  return Le(() => {
    const n = Nm();
    return Em(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function e3(e, t) {
  const n = e.style || {}, r = {};
  return JP(r, n, e), Object.assign(r, Q5(e, t)), r;
}
function t3(e, t) {
  const n = {}, r = e3(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const XP = () => ({
  ...Nm(),
  attrs: {}
});
function n3(e, t, n, r) {
  const i = Le(() => {
    const a = XP();
    return NP(a, t, DP(r), e.transformTemplate, e.style), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [t]);
  if (e.style) {
    const a = {};
    JP(a, e.style, e), i.style = { ...a, ...i.style };
  }
  return i;
}
const r3 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Cm(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(r3.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function i3(e, t, n, { latestValues: r }, i, a = !1, o) {
  const u = (o ?? Cm(e) ? n3 : t3)(t, r, i, e), l = J5(t, typeof e == "string", a), c = e !== il ? { ...l, ...u, ref: n } : {}, { children: f } = t, s = Le(() => Et(f) ? f.get() : f, [f]);
  return yu(e, {
    ...c,
    children: s
  });
}
function o3({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
  return {
    latestValues: a3(n, r, i, e),
    renderState: t()
  };
}
function a3(e, t, n, r) {
  const i = {}, a = r(e, {});
  for (const s in a)
    i[s] = pu(a[s]);
  let { initial: o, animate: d } = e;
  const u = zc(e), l = wP(e);
  t && l && !u && e.inherit !== !1 && (o === void 0 && (o = t.initial), d === void 0 && (d = t.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || o === !1;
  const f = c ? d : o;
  if (f && typeof f != "boolean" && !Oc(f)) {
    const s = Array.isArray(f) ? f : [f];
    for (let h = 0; h < s.length; h++) {
      const p = _m(e, s[h]);
      if (p) {
        const { transitionEnd: m, transition: y, ...w } = p;
        for (const b in w) {
          let _ = w[b];
          if (Array.isArray(_)) {
            const g = c ? _.length - 1 : 0;
            _ = _[g];
          }
          _ !== null && (i[b] = _);
        }
        for (const b in m)
          i[b] = m[b];
      }
    }
  }
  return i;
}
const YP = (e) => (t, n) => {
  const r = st(Ec), i = st(am), a = () => o3(e, t, r, i);
  return n ? a() : oU(a);
}, s3 = /* @__PURE__ */ YP({
  scrapeMotionValuesFromProps: Tm,
  createRenderState: Nm
}), l3 = /* @__PURE__ */ YP({
  scrapeMotionValuesFromProps: AP,
  createRenderState: XP
}), u3 = /* @__PURE__ */ Symbol.for("motionComponentSymbol");
function c3(e, t, n) {
  const r = Ce(n);
  A0(() => {
    r.current = n;
  });
  const i = Ce(null);
  return Ye((a) => {
    a && e.onMount?.(a), t && (a ? t.mount(a) : t.unmount());
    const o = r.current;
    if (typeof o == "function")
      if (a) {
        const d = o(a);
        typeof d == "function" && (i.current = d);
      } else i.current ? (i.current(), i.current = null) : o(a);
    else o && (o.current = a);
  }, [t]);
}
const QP = Wt({});
function yo(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function d3(e, t, n, r, i, a) {
  const { visualElement: o } = st(Ec), d = st(WP), u = st(am), l = st(HP), c = l.reducedMotion, f = l.skipAnimations, s = Ce(null), h = Ce(!1);
  r = r || d.renderer, !s.current && r && (s.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: u,
    blockInitialAnimation: u ? u.initial === !1 : !1,
    reducedMotionConfig: c,
    skipAnimations: f,
    isSVG: a
  }), h.current && s.current && (s.current.manuallyAnimateOnMount = !0));
  const p = s.current, m = st(QP);
  p && !p.projection && i && (p.type === "html" || p.type === "svg") && f3(s.current, n, i, m);
  const y = Ce(!1);
  A0(() => {
    p && y.current && p.update(n, u);
  });
  const w = n[uP], b = Ce(!!w && typeof window < "u" && !window.MotionHandoffIsComplete?.(w) && window.MotionHasOptimisedAnimation?.(w));
  return sU(() => {
    h.current = !0, p && (y.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), p.scheduleRenderMicrotask(), b.current && p.animationState && p.animationState.animateChanges());
  }), Ze(() => {
    p && (!b.current && p.animationState && p.animationState.animateChanges(), b.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(w);
    }), b.current = !1), p.enteringChildren = void 0);
  }), p;
}
function f3(e, t, n, r) {
  const { layoutId: i, layout: a, drag: o, dragConstraints: d, layoutScroll: u, layoutRoot: l, layoutAnchor: c, layoutCrossfade: f } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : eO(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!o || d && yo(d),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    crossfade: f,
    layoutScroll: u,
    layoutRoot: l,
    layoutAnchor: c
  });
}
function eO(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : eO(e.parent);
}
function Lf(e, { forwardMotionProps: t = !1, type: n } = {}, r, i) {
  r && W5(r);
  const a = n ? n === "svg" : Cm(e), o = a ? l3 : s3;
  function d(l, c) {
    let f;
    const s = {
      ...st(HP),
      ...l,
      layoutId: h3(l)
    }, { isStatic: h } = s, p = Y5(l), m = o(l, h);
    if (!h && typeof window < "u") {
      p3(s, r);
      const y = m3(s);
      f = y.MeasureLayout, p.visualElement = d3(e, m, s, i, y.ProjectionNode, a);
    }
    return te(Ec.Provider, { value: p, children: [f && p.visualElement ? x(f, { visualElement: p.visualElement, ...s }) : null, i3(e, l, c3(m, p.visualElement, c), m, h, t, a)] });
  }
  d.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const u = ol(d);
  return u[u3] = e, u;
}
function h3({ layoutId: e }) {
  const t = st(wI).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function p3(e, t) {
  const n = st(WP).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? Xo(!1, r, "lazy-strict-mode") : qn(!1, r, "lazy-strict-mode");
  }
}
function m3(e) {
  const t = GP(), { drag: n, layout: r } = t;
  if (!n && !r)
    return {};
  const i = { ...n, ...r };
  return {
    MeasureLayout: n?.isEnabled(e) || r?.isEnabled(e) ? i.MeasureLayout : void 0,
    ProjectionNode: i.ProjectionNode
  };
}
function g3(e, t) {
  if (typeof Proxy > "u")
    return Lf;
  const n = /* @__PURE__ */ new Map(), r = (a, o) => Lf(a, o, e, t), i = (a, o) => (process.env.NODE_ENV !== "production" && Ic(!1, "motion() is deprecated. Use motion.create() instead."), r(a, o));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (a, o) => o === "create" ? r : (n.has(o) || n.set(o, Lf(o, void 0, e, t)), n.get(o))
  });
}
const y3 = (e, t) => t.isSVG ?? Cm(e) ? new YV(t) : new HV(t, {
  allowProjection: e !== il
});
class v3 extends Tr {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = r5(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Oc(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let b3 = 0;
class _3 extends Tr {
  constructor() {
    super(...arguments), this.id = b3++, this.isExitComplete = !1;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    if (t && r === !1) {
      if (this.isExitComplete) {
        const { initial: a, custom: o } = this.node.getProps();
        if (typeof a == "string" || typeof a == "object" && a !== null && !Array.isArray(a)) {
          const d = ei(this.node, a, o);
          if (d) {
            const { transition: u, transitionEnd: l, ...c } = d;
            for (const f in c)
              this.node.getValue(f)?.jump(c[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const w3 = {
  animation: {
    Feature: v3
  },
  exit: {
    Feature: _3
  }
};
function bl(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const k3 = (e) => (t) => xm(t) && e(t, bl(t));
function Rs(e, t, n, r) {
  return el(e, t, k3(n), r);
}
const tO = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Aw = (e, t) => Math.abs(e - t);
function S3(e, t) {
  const n = Aw(e.x, t.x), r = Aw(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
const jw = /* @__PURE__ */ new Set(["auto", "scroll"]);
class nO {
  constructor(t, n, { transformPagePoint: r, contextWindow: i = window, dragSnapToOrigin: a = !1, distanceThreshold: o = 3, element: d } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (p) => {
      this.handleScroll(p.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = Wl(this.lastRawMoveEventInfo, this.transformPagePoint));
      const p = Ff(this.lastMoveEventInfo, this.history), m = this.startEvent !== null, y = S3(p.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!m && !y)
        return;
      const { point: w } = p, { timestamp: b } = zt;
      this.history.push({ ...w, timestamp: b });
      const { onStart: _, onMove: g } = this.handlers;
      m || (_ && _(this.lastMoveEvent, p), this.startEvent = this.lastMoveEvent), g && g(this.lastMoveEvent, p);
    }, this.handlePointerMove = (p, m) => {
      this.lastMoveEvent = p, this.lastRawMoveEventInfo = m, this.lastMoveEventInfo = Wl(m, this.transformPagePoint), tt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (p, m) => {
      this.end();
      const { onEnd: y, onSessionEnd: w, resumeAnimation: b } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && b && b(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const _ = Ff(p.type === "pointercancel" ? this.lastMoveEventInfo : Wl(m, this.transformPagePoint), this.history);
      this.startEvent && y && y(p, _), w && w(p, _);
    }, !xm(t))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = o, this.contextWindow = i || window;
    const u = bl(t), l = Wl(u, this.transformPagePoint), { point: c } = l, { timestamp: f } = zt;
    this.history = [{ ...c, timestamp: f }];
    const { onSessionStart: s } = n;
    s && s(t, Ff(l, this.history));
    const h = { passive: !0, capture: !0 };
    this.removeListeners = gl(Rs(this.contextWindow, "pointermove", this.handlePointerMove, h), Rs(this.contextWindow, "pointerup", this.handlePointerUp, h), Rs(this.contextWindow, "pointercancel", this.handlePointerUp, h)), d && this.startScrollTracking(d);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(t) {
    let n = t.parentElement;
    for (; n; ) {
      const r = getComputedStyle(n);
      (jw.has(r.overflowX) || jw.has(r.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(t) {
    const n = this.scrollPositions.get(t);
    if (!n)
      return;
    const r = t === window, i = r ? { x: window.scrollX, y: window.scrollY } : {
      x: t.scrollLeft,
      y: t.scrollTop
    }, a = { x: i.x - n.x, y: i.y - n.y };
    a.x === 0 && a.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += a.x, this.lastMoveEventInfo.point.y += a.y) : this.history.length > 0 && (this.history[0].x -= a.x, this.history[0].y -= a.y), this.scrollPositions.set(t, i), tt.update(this.updatePoint, !0));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), xr(this.updatePoint);
  }
}
function Wl(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Mw(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ff({ point: e }, t) {
  return {
    point: e,
    delta: Mw(e, rO(t)),
    offset: Mw(e, x3(t)),
    velocity: I3(t, 0.1)
  };
}
function x3(e) {
  return e[0];
}
function rO(e) {
  return e[e.length - 1];
}
function I3(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = rO(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ Ht(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  r === e[0] && e.length > 2 && i.timestamp - r.timestamp > /* @__PURE__ */ Ht(t) * 2 && (r = e[1]);
  const a = /* @__PURE__ */ cn(i.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / a,
    y: (i.y - r.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function P3(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? et(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? et(n, e, r.max) : Math.min(e, n)), e;
}
function $w(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function O3(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: $w(e.x, n, i),
    y: $w(e.y, t, r)
  };
}
function Rw(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function z3(e, t) {
  return {
    x: Rw(e.x, t.x),
    y: Rw(e.y, t.y)
  };
}
function E3(e, t) {
  let n = 0.5;
  const r = Zt(e), i = Zt(t);
  return i > r ? n = /* @__PURE__ */ Xs(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ Xs(e.min, e.max - i, t.min)), Vn(0, 1, n);
}
function T3(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Jh = 0.35;
function N3(e = Jh) {
  return e === !1 ? e = 0 : e === !0 && (e = Jh), {
    x: Zw(e, "left", "right"),
    y: Zw(e, "top", "bottom")
  };
}
function Zw(e, t, n) {
  return {
    min: Lw(e, t),
    max: Lw(e, n)
  };
}
function Lw(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const C3 = /* @__PURE__ */ new WeakMap();
class D3 {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = xt(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const a = (f) => {
      n && this.snapToCursor(bl(f).point), this.stopAnimation();
    }, o = (f, s) => {
      const { drag: h, dragPropagation: p, onDragStart: m } = this.getProps();
      if (h && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = fV(h), !this.openDragLock))
        return;
      this.latestPointerEvent = f, this.latestPanInfo = s, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Rn((w) => {
        let b = this.getAxisMotionValue(w).get() || 0;
        if (Bn.test(b)) {
          const { projection: _ } = this.visualElement;
          if (_ && _.layout) {
            const g = _.layout.layoutBox[w];
            g && (b = Zt(g) * (parseFloat(b) / 100));
          }
        }
        this.originPoint[w] = b;
      }), m && tt.update(() => m(f, s), !1, !0), Fh(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, d = (f, s) => {
      this.latestPointerEvent = f, this.latestPanInfo = s;
      const { dragPropagation: h, dragDirectionLock: p, onDirectionLock: m, onDrag: y } = this.getProps();
      if (!h && !this.openDragLock)
        return;
      const { offset: w } = s;
      if (p && this.currentDirection === null) {
        this.currentDirection = j3(w), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", s.point, w), this.updateAxis("y", s.point, w), this.visualElement.render(), y && tt.update(() => y(f, s), !1, !0);
    }, u = (f, s) => {
      this.latestPointerEvent = f, this.latestPanInfo = s, this.stop(f, s), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, l = () => {
      const { dragSnapToOrigin: f } = this.getProps();
      (f || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new nO(t, {
      onSessionStart: a,
      onStart: o,
      onMove: d,
      onSessionEnd: u,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: r,
      contextWindow: tO(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, i = n || this.latestPanInfo, a = this.isDragging;
    if (this.cancel(), !a || !i || !r)
      return;
    const { velocity: o } = i;
    this.startAnimation(o);
    const { onDragEnd: d } = this.getProps();
    d && tt.postRender(() => d(r, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !Gl(t, i, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (o = P3(o, this.constraints[t], this.elastic[t])), a.set(o);
  }
  resolveConstraints() {
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, i = this.constraints;
    t && yo(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = O3(r.layoutBox, t) : this.constraints = !1, this.elastic = N3(n), i !== this.constraints && !yo(t) && r && this.constraints && !this.hasMutatedConstraints && Rn((a) => {
      this.constraints !== !1 && this.getAxisMotionValue(a) && (this.constraints[a] = T3(r.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !yo(t))
      return !1;
    const r = t.current;
    qn(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    i.root && (i.root.scroll = void 0, i.root.updateScroll());
    const a = LV(r, i.root, this.visualElement.getTransformPagePoint());
    let o = z3(i.layout.layoutBox, a);
    if (n) {
      const d = n($V(o));
      this.hasMutatedConstraints = !!d, d && (o = IP(d));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: d } = this.getProps(), u = this.constraints || {}, l = Rn((c) => {
      if (!Gl(c, n, this.currentDirection))
        return;
      let f = u && u[c] || {};
      (o === !0 || o === c) && (f = { min: 0, max: 0 });
      const s = i ? 200 : 1e6, h = i ? 40 : 1e7, p = {
        type: "inertia",
        velocity: r ? t[c] : 0,
        bounceStiffness: s,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...f
      };
      return this.startAxisValueAnimation(c, p);
    });
    return Promise.all(l).then(d);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return Fh(this.visualElement, t), r.start(bm(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Rn((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, i = this.visualElement.getProps()[n];
    return i || this.visualElement.getValue(t, this.visualElement.latestValues[t] ?? 0);
  }
  snapToCursor(t) {
    Rn((n) => {
      const { drag: r } = this.getProps();
      if (!Gl(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, a = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: o, max: d } = i.layout.layoutBox[n], u = a.get() || 0;
        a.set(t[n] - et(o, d, 0.5) + u);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!yo(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Rn((o) => {
      const d = this.getAxisMotionValue(o);
      if (d && this.constraints !== !1) {
        const u = d.get();
        i[o] = E3({ min: u, max: u }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.constraints = !1, this.resolveConstraints(), Rn((o) => {
      if (!Gl(o, t, null))
        return;
      const d = this.getAxisMotionValue(o), { min: u, max: l } = this.constraints[o];
      d.set(et(u, l, i[o]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    C3.set(this.visualElement, this);
    const t = this.visualElement.current, n = Rs(t, "pointerdown", (l) => {
      const { drag: c, dragListener: f = !0 } = this.getProps(), s = l.target, h = s !== t && vV(s);
      c && f && !h && this.start(l);
    });
    let r;
    const i = () => {
      const { dragConstraints: l } = this.getProps();
      yo(l) && l.current && (this.constraints = this.resolveRefConstraints(), r || (r = A3(t, l.current, () => this.scalePositionWithinConstraints())));
    }, { projection: a } = this.visualElement, o = a.addEventListener("measure", i);
    a && !a.layout && (a.root && a.root.updateScroll(), a.updateLayout()), tt.read(i);
    const d = el(window, "resize", () => this.scalePositionWithinConstraints()), u = a.addEventListener("didUpdate", (({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (Rn((f) => {
        const s = this.getAxisMotionValue(f);
        s && (this.originPoint[f] += l[f].translate, s.set(s.get() + l[f].translate));
      }), this.visualElement.render());
    }));
    return () => {
      d(), n(), o(), u && u(), r && r();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: a = !1, dragElastic: o = Jh, dragMomentum: d = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: d
    };
  }
}
function Fw(e) {
  let t = !0;
  return () => {
    if (t) {
      t = !1;
      return;
    }
    e();
  };
}
function A3(e, t, n) {
  const r = J_(e, Fw(n)), i = J_(t, Fw(n));
  return () => {
    r(), i();
  };
}
function Gl(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function j3(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class M3 extends Tr {
  constructor(t) {
    super(t), this.removeGroupControls = dn, this.removeListeners = dn, this.controls = new D3(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || dn;
  }
  update() {
    const { dragControls: t } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    t !== n && (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const Uf = (e) => (t, n) => {
  e && tt.update(() => e(t, n), !1, !0);
};
class $3 extends Tr {
  constructor() {
    super(...arguments), this.removePointerDownListener = dn;
  }
  onPointerDown(t) {
    this.session = new nO(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: tO(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: Uf(t),
      onStart: Uf(n),
      onMove: Uf(r),
      onEnd: (a, o) => {
        delete this.session, i && tt.postRender(() => i(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Rs(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let Bf = !1;
class R3 extends bz {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: a } = t;
    a && (n.group && n.group.add(a), r && r.register && i && r.register(a), Bf && a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), mu.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: a } = this.props, { projection: o } = r;
    return o && (o.isPresent = a, t.layoutDependency !== n && o.setOptions({
      ...o.options,
      layoutDependency: n
    }), Bf = !0, i || t.layoutDependency !== n || n === void 0 || t.isPresent !== a ? o.willUpdate() : this.safeToRemove(), t.isPresent !== a && (a ? o.promote() : o.relegate() || tt.postRender(() => {
      const d = o.getStack();
      (!d || !d.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: t, layoutAnchor: n } = this.props, { projection: r } = t;
    r && (r.options.layoutAnchor = n, r.root.didUpdate(), Sm.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    Bf = !0, i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function iO(e) {
  const [t, n] = q5(), r = st(wI);
  return x(R3, { ...e, layoutGroup: r, switchLayoutGroup: st(QP), isPresent: t, safeToRemove: n });
}
const Z3 = {
  pan: {
    Feature: $3
  },
  drag: {
    Feature: M3,
    ProjectionNode: qP,
    MeasureLayout: iO
  }
};
function Uw(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, a = r[i];
  a && tt.postRender(() => a(t, bl(t)));
}
class L3 extends Tr {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = pV(t, (n, r) => (Uw(this.node, r, "Start"), (i) => Uw(this.node, i, "End"))));
  }
  unmount() {
  }
}
class F3 extends Tr {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = gl(el(this.node.current, "focus", () => this.onFocus()), el(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Bw(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), a = r[i];
  a && tt.postRender(() => a(t, bl(t)));
}
class U3 extends Tr {
  mount() {
    const { current: t } = this.node;
    if (!t)
      return;
    const { globalTapTarget: n, propagate: r } = this.node.props;
    this.unmount = _V(t, (i, a) => (Bw(this.node, a, "Start"), (o, { success: d }) => Bw(this.node, o, d ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: r?.tap === !1
    });
  }
  unmount() {
  }
}
const Xh = /* @__PURE__ */ new WeakMap(), Vf = /* @__PURE__ */ new WeakMap(), B3 = (e) => {
  const t = Xh.get(e.target);
  t && t(e);
}, V3 = (e) => {
  e.forEach(B3);
};
function q3({ root: e, ...t }) {
  const n = e || document;
  Vf.has(n) || Vf.set(n, {});
  const r = Vf.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(V3, { root: e, ...t })), r[i];
}
function H3(e, t, n) {
  const r = q3(t);
  return Xh.set(e, n), r.observe(e), () => {
    Xh.delete(e), r.unobserve(e);
  };
}
const W3 = {
  some: 0,
  all: 1
};
class G3 extends Tr {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.stopObserver?.();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: a } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : W3[i]
    }, d = (u) => {
      const { isIntersecting: l } = u;
      if (this.isInView === l || (this.isInView = l, a && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: c, onViewportLeave: f } = this.node.getProps(), s = l ? c : f;
      s && s(u);
    };
    this.stopObserver = H3(this.node.current, o, d);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(K3(t, n)) && this.startObserver();
  }
  unmount() {
    this.stopObserver?.(), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function K3({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const J3 = {
  inView: {
    Feature: G3
  },
  tap: {
    Feature: U3
  },
  focus: {
    Feature: F3
  },
  hover: {
    Feature: L3
  }
}, X3 = {
  layout: {
    ProjectionNode: qP,
    MeasureLayout: iO
  }
}, Y3 = {
  ...w3,
  ...J3,
  ...Z3,
  ...X3
}, Q3 = /* @__PURE__ */ g3(Y3, y3);
function e9() {
  !zm.current && kP();
  const [e] = Ae(Lu.current);
  return process.env.NODE_ENV !== "production" && Ic(e !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), e;
}
const t9 = Q3;
function n9(e) {
  const t = e.nodes.map((o) => ({ id: o.id, position: o.ui, data: {} })), n = e.edges.map((o) => ({ id: o.id, source: o.source, target: o.target })), r = tU(t, n, { rankdir: "TB" }), i = new Map(r.map((o) => [o.id, o.position])), a = e.nodes.map((o) => {
    const d = i.get(o.id);
    return d ? { ...o, ui: { x: d.x, y: d.y } } : o;
  });
  return { ...e, nodes: a };
}
const r9 = "gpt-6.1-sol", Vw = { x: 238, y: 110 };
function rr(e) {
  return `${e}-${crypto.randomUUID().slice(0, 8)}`;
}
function it(e) {
  return e.doc ? { past: [...e.past, e.doc].slice(-50), future: [] } : {};
}
function qw(e, t, n) {
  return {
    selectedNodeId: e.nodes.some((r) => r.id === t) ? t : null,
    selectedEdgeId: e.edges.some((r) => r.id === n) ? n : null
  };
}
const we = zr((e) => ({
  doc: null,
  selectedNodeId: null,
  selectedEdgeId: null,
  dirty: !1,
  past: [],
  future: [],
  copilotTurnActive: !1,
  // Undoable, unlike a plain reset: the Copilot can call this via its `new_flow` op, and the
  // only thing that used to stop it discarding unsaved work was prose in the tool description
  // asking the model to confirm first. `record` keeps the outgoing doc on the undo stack, so
  // the Keep/Undo bar the Copilot turn already surfaces can actually bring the canvas back.
  newFlow: () => e((t) => ({
    ...it(t),
    doc: {
      version: "1",
      id: rr("flow"),
      name: "Untitled flow",
      entryNodeId: "",
      nodes: [],
      edges: []
    },
    selectedNodeId: null,
    selectedEdgeId: null,
    dirty: !0
  })),
  loadFlow: (t) => e({ doc: t, selectedNodeId: null, selectedEdgeId: null, dirty: !1, past: [], future: [] }),
  addAgentNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = rr("agent"), a = {
      kind: "agent",
      id: i,
      source: "inline",
      name: "New agent",
      instructions: "You are a helpful assistant.",
      llm: { model: n ?? r9 },
      ui: t
    }, o = [...r.doc.nodes, a], d = r.doc.entryNodeId === "" ? i : r.doc.entryNodeId;
    return {
      ...it(r),
      doc: { ...r.doc, nodes: o, entryNodeId: d },
      selectedNodeId: i,
      selectedEdgeId: null,
      dirty: !0
    };
  }),
  moveNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.nodes.map((a) => a.id === t ? { ...a, ui: n } : a);
    return { ...it(r), doc: { ...r.doc, nodes: i }, dirty: !0 };
  }),
  deleteNode: (t) => e((n) => {
    if (!n.doc) return n;
    const r = n.doc.nodes.filter((u) => u.id !== t), i = n.doc.edges.filter((u) => u.source !== t && u.target !== t);
    let a = n.doc.entryNodeId;
    if (a === t) {
      const u = r.find((l) => l.kind === "agent");
      a = u ? u.id : "";
    }
    const o = n.selectedNodeId === t ? null : n.selectedNodeId, d = i.some((u) => u.id === n.selectedEdgeId) ? n.selectedEdgeId : null;
    return {
      ...it(n),
      doc: { ...n.doc, nodes: r, edges: i, entryNodeId: a },
      selectedNodeId: o,
      selectedEdgeId: d,
      dirty: !0
    };
  }),
  addEdge: (t, n, r) => e((i) => {
    if (!i.doc) return i;
    const a = i.doc.nodes.find((l) => l.id === n), o = a ? Ge.resolveEdgeType(r, a.kind) : null;
    if (!o) return i;
    const d = Ge.guardsPlacement(r);
    if (Ge.edgeExists(i.doc.edges, o, t, n, d) || Ge.loopClosedBy(i.doc.edges, o, t, n)) return i;
    const u = Ge.buildFlowEdge(o, rr("edge"), t, n, d);
    return { ...it(i), doc: { ...i.doc, edges: [...i.doc.edges, u] }, dirty: !0 };
  }),
  addToolNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = rr("tool"), a = { kind: "tool", id: i, toolId: n, policy: "allow", ui: t };
    return {
      ...it(r),
      doc: { ...r.doc, nodes: [...r.doc.nodes, a] },
      selectedNodeId: i,
      selectedEdgeId: null,
      dirty: !0
    };
  }),
  addRefAgentNode: (t, n, r) => e((i) => {
    if (!i.doc) return i;
    const a = rr("ref"), o = { kind: "agent", id: a, source: "ref", agentId: n, name: r, ui: t }, d = i.doc.entryNodeId === "" ? a : i.doc.entryNodeId;
    return {
      ...it(i),
      doc: { ...i.doc, nodes: [...i.doc.nodes, o], entryNodeId: d },
      selectedNodeId: a,
      selectedEdgeId: null,
      dirty: !0
    };
  }),
  addGuardrailNode: (t) => e((n) => {
    if (!n.doc) return n;
    const r = rr("guardrail"), i = { kind: "guardrail", id: r, criterion: "", ui: t };
    return {
      ...it(n),
      doc: { ...n.doc, nodes: [...n.doc.nodes, i] },
      selectedNodeId: r,
      selectedEdgeId: null,
      dirty: !0
    };
  }),
  addWebSearchNode: (t) => e((n) => {
    if (!n.doc) return n;
    const r = rr("web-search"), i = { kind: "web-search", id: r, ui: t };
    return {
      ...it(n),
      doc: { ...n.doc, nodes: [...n.doc.nodes, i] },
      selectedNodeId: r,
      selectedEdgeId: null,
      dirty: !0
    };
  }),
  addScorerNode: (t) => e((n) => {
    if (!n.doc) return n;
    const r = rr("scorer"), i = { kind: "scorer", id: r, scorerId: "", ui: t };
    return {
      ...it(n),
      doc: { ...n.doc, nodes: [...n.doc.nodes, i] },
      selectedNodeId: r,
      selectedEdgeId: null,
      dirty: !0
    };
  }),
  addMcpConnectionNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = rr("mcp"), a = { kind: "mcp-connection", id: i, connectionId: n, tools: [], ui: t };
    return {
      ...it(r),
      doc: { ...r.doc, nodes: [...r.doc.nodes, a] },
      selectedNodeId: i,
      selectedEdgeId: null,
      dirty: !0
    };
  }),
  updateMcpConnectionNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.nodes.map(
      (a) => a.id === t && a.kind === "mcp-connection" ? { ...a, tools: n } : a
    );
    return { ...it(r), doc: { ...r.doc, nodes: i }, dirty: !0 };
  }),
  updateToolNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.nodes.map(
      (a) => a.id === t && a.kind === "tool" ? {
        ...a,
        policy: n.policy ?? a.policy,
        ...n.config ? { config: n.config } : {}
      } : a
    );
    return { ...it(r), doc: { ...r.doc, nodes: i }, dirty: !0 };
  }),
  deleteEdge: (t) => e((n) => {
    if (!n.doc) return n;
    const r = n.doc.edges.filter((i) => i.id !== t);
    return {
      ...it(n),
      doc: { ...n.doc, edges: r },
      selectedEdgeId: n.selectedEdgeId === t ? null : n.selectedEdgeId,
      dirty: !0
    };
  }),
  updateWebSearchNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.nodes.map((a) => {
      if (a.id !== t || a.kind !== "web-search") return a;
      const { config: o, ...d } = a;
      return Object.keys(n).length > 0 ? { ...d, config: n } : d;
    });
    return { ...it(r), doc: { ...r.doc, nodes: i }, dirty: !0 };
  }),
  updateAgentNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.nodes.map(
      (a) => a.id === t && a.kind === "agent" ? Ge.applyAgentPatch(a, n) : a
    );
    return { ...it(r), doc: { ...r.doc, nodes: i }, dirty: !0 };
  }),
  updateRefAgentInput: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = Ge.applyCanvasOp(r.doc, { op: "set_ref_agent_input", id: t, input: n ?? {} });
    return { ...it(r), doc: i, dirty: !0 };
  }),
  updateScorerNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.nodes.map(
      (a) => a.id === t && a.kind === "scorer" ? Ge.applyScorerPatch(a, n) : a
    );
    return { ...it(r), doc: { ...r.doc, nodes: i }, dirty: !0 };
  }),
  updateGuardrailNode: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.nodes.map(
      (a) => a.id === t && a.kind === "guardrail" ? {
        ...a,
        name: "name" in n ? n.name : a.name,
        criterion: n.criterion ?? a.criterion,
        model: "model" in n ? n.model : a.model
      } : a
    );
    return { ...it(r), doc: { ...r.doc, nodes: i }, dirty: !0 };
  }),
  updateGuardsPlacement: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.edges.map(
      (a) => a.id === t && a.type === "guards" ? { ...a, placement: n } : a
    );
    return { ...it(r), doc: { ...r.doc, edges: i }, dirty: !0 };
  }),
  updateHandoffDescription: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.edges.map(
      (a) => a.id === t && a.type === "handoff" ? { ...a, description: n } : a
    );
    return { ...it(r), doc: { ...r.doc, edges: i }, dirty: !0 };
  }),
  updateAgentAsToolEdge: (t, n) => e((r) => {
    if (!r.doc) return r;
    const i = r.doc.edges.map(
      (a) => a.id === t && a.type === "uses-agent-as-tool" ? {
        ...a,
        toolName: "toolName" in n ? n.toolName : a.toolName,
        description: "description" in n ? n.description : a.description
      } : a
    );
    return { ...it(r), doc: { ...r.doc, edges: i }, dirty: !0 };
  }),
  setEntryNode: (t) => e((n) => n.doc ? { ...it(n), doc: { ...n.doc, entryNodeId: t }, dirty: !0 } : n),
  selectNode: (t) => e({ selectedNodeId: t, selectedEdgeId: null }),
  selectEdge: (t) => e({ selectedEdgeId: t, selectedNodeId: null }),
  setFlowName: (t) => e((n) => n.doc ? { ...it(n), doc: { ...n.doc, name: t }, dirty: !0 } : n),
  markSaved: () => e({ dirty: !1 }),
  undo: () => e((t) => {
    if (!t.doc || t.past.length === 0) return t;
    const n = t.past[t.past.length - 1];
    return {
      doc: n,
      past: t.past.slice(0, -1),
      future: [t.doc, ...t.future],
      dirty: !0,
      ...qw(n, t.selectedNodeId, t.selectedEdgeId)
    };
  }),
  redo: () => e((t) => {
    if (!t.doc || t.future.length === 0) return t;
    const n = t.future[0];
    return {
      doc: n,
      past: [...t.past, t.doc],
      future: t.future.slice(1),
      dirty: !0,
      ...qw(n, t.selectedNodeId, t.selectedEdgeId)
    };
  }),
  beginCopilotTurn: () => e(() => ({ copilotTurnActive: !0 })),
  applyCopilotOp: (t) => e((n) => {
    if (!n.doc) return n;
    const r = Ge.applyCanvasOp(n.doc, t), i = Ge.isStructuralOp(t) ? n9(r) : r;
    return {
      ...it(n),
      doc: i,
      dirty: !0
    };
  }),
  attachToolBelowAgent: (t) => e((n) => {
    if (!n.doc) return n;
    const r = n.doc.nodes.find((u) => u.id === t.agentId);
    if (!r) return n;
    const i = n.doc.edges.filter(
      (u) => u.type === "uses-tool" && u.source === t.agentId
    ).length, a = { x: r.ui.x + i * Vw.x, y: r.ui.y + Vw.y }, o = Ge.applyCanvasOp(n.doc, t), d = o.nodes.map((u) => u.id === t.toolNodeId ? { ...u, ui: a } : u);
    return { ...it(n), doc: { ...o, nodes: d }, dirty: !0 };
  })
}));
var qu = cp();
function oO(e, t) {
  switch (e) {
    case "tool":
    case "web-search":
      return "tool";
    case "guardrail":
      return "guardrail";
    case "mcp-connection":
      return "connector";
    case "scorer":
      return "scorer";
    case "agent":
      return t ? "ref-agent" : "agent";
  }
}
function i9(e) {
  return oO(e.kind, e.kind === "agent" && e.source === "ref");
}
function aO(e, t) {
  if (e.kind === "tool")
    return e.config?.source === "agent-files" ? t("canvas.agentFiles", "This agent's files") : typeof e.config?.name == "string" && e.config.name ? e.config.name : void 0;
}
function Tc(e, t, n) {
  switch (e.kind) {
    case "tool":
      return t.tool(e.toolId);
    case "web-search":
      return n("entity.webSearch", "Web Search");
    case "guardrail":
      return e.name ?? n("entity.guardrail", "Guardrail");
    case "mcp-connection":
      return t.connector(e.connectionId);
    // A draft scorer may have a blank scorerId, so fall through to the node id.
    case "scorer":
      return e.name ?? (e.scorerId || void 0) ?? e.id;
    case "agent":
      return e.name ? e.name : e.source !== "ref" || !e.agentId ? e.id : t.agent?.(e.agentId) ?? e.agentId;
  }
}
function sO(e, t) {
  const n = [], r = [];
  switch (e.kind) {
    case "agent":
      e.source === "ref" ? (e.agentId || n.push(t("completeness.missingAgent", "Missing agent reference")), e.maxToolSteps !== void 0 && n.push(
        t(
          "completeness.refToolSteps",
          "A referenced agent runs the tool-step budget it was registered with"
        )
      )) : (e.name?.trim() || n.push(t("completeness.addName", "Add a name")), e.instructions?.trim() || n.push(t("completeness.addInstructions", "Add instructions")), e.maxToolSteps !== void 0 && !qu.isFlowToolStepBudget(e.maxToolSteps) && n.push(
        t(
          "completeness.toolStepsRange",
          "Tool steps must be a whole number from 1 to {{max}}",
          {
            max: qu.FLOW_MAX_TOOL_STEPS
          }
        )
      ));
      break;
    case "tool":
      e.toolId.trim() || n.push(t("completeness.missingTool", "Missing tool reference"));
      break;
    case "mcp-connection":
      e.connectionId.trim() || n.push(t("completeness.missingConnection", "Missing connection")), e.tools !== "all" && e.tools.length === 0 && r.push(t("completeness.noToolsSelected", "No tools selected"));
      break;
    case "guardrail":
      e.criterion.trim() === "" && n.push(t("completeness.addCriterion", "Add a criterion"));
      break;
    case "scorer":
      e.scorerId.trim() || n.push(t("completeness.pickScorer", "Pick a scorer"));
      break;
    case "web-search":
      break;
    default:
      return e;
  }
  return { issues: n, warnings: r };
}
function lO(e, t, n, r = () => {
}) {
  const i = {};
  for (const a of e) {
    const o = sO(a, n);
    if (a.kind === "tool" && a.toolId && !t.has(a.toolId) && o.issues.push(n("completeness.unknownTool", "Unknown tool")), a.kind === "tool")
      for (const d of r(a.toolId)?.configFields ?? []) {
        const u = a.config?.[d.key];
        d.optional || typeof u == "string" && u.length > 0 || d.kind === "knowledge-base" && a.config?.source === "agent-files" || o.issues.push(
          d.kind === "knowledge-base" ? n("completeness.pickKnowledgeBase", "Choose a knowledge base") : n("completeness.pickGuidelinesFolder", "Choose a guidelines folder")
        );
      }
    i[a.id] = o;
  }
  return i;
}
function uO(e) {
  if (!e.nodes.some((r) => r.id === e.entryNodeId)) return /* @__PURE__ */ new Set();
  const t = /* @__PURE__ */ new Set([e.entryNodeId]), n = [e.entryNodeId];
  for (let r = n.pop(); r !== void 0; r = n.pop())
    for (const i of e.edges)
      i.source !== r || t.has(i.target) || (t.add(i.target), n.push(i.target));
  return new Set(e.nodes.filter((r) => !t.has(r.id)).map((r) => r.id));
}
function cO(e, t, n) {
  return [
    ...e?.warnings ?? [],
    ...t ? [n("completeness.unreachable", "Never runs: nothing from the entry agent reaches it")] : []
  ];
}
const To = zr((e) => ({
  issuesByNode: {},
  runByNode: {},
  setIssues: (t) => {
    e({ issuesByNode: t });
  },
  setRun: (t) => {
    e({ runByNode: t });
  },
  clear: () => {
    e({ issuesByNode: {}, runByNode: {} });
  }
})), GK = {
  load(e) {
    we.getState().loadFlow(e);
  },
  current() {
    return we.getState().doc;
  },
  isDirty() {
    return we.getState().dirty;
  },
  /**
   * Clears the unsaved mark, but only while the open document is still the one that was saved.
   * An edit made while the save was in flight stays unsaved, so the next save picks it up.
   */
  markSaved(e) {
    const t = we.getState();
    t.doc === e && t.markSaved();
  },
  /** Calls `listener` whenever the open document changes, until the returned function is called. */
  subscribe(e) {
    return we.subscribe((t, n) => {
      (t.doc !== n.doc || t.dirty !== n.dirty) && e(t.doc, t.dirty);
    });
  },
  select(e) {
    we.getState().selectNode(e);
  },
  /**
   * Puts a published widget on the canvas, wired to the selected inline agent or else the entry
   * agent, and selects it. Returns the new node's id, or null with no agent to wire it to.
   */
  attachWidget(e) {
    const t = we.getState(), n = t.doc;
    if (!n) return null;
    const r = (d) => n.nodes.some((u) => u.id === d && u.kind === "agent" && u.source === "inline"), i = r(t.selectedNodeId) ? t.selectedNodeId : n.entryNodeId;
    if (!i || !r(i)) return null;
    const a = crypto.randomUUID().slice(0, 8), o = `tool-${a}`;
    return t.attachToolBelowAgent({
      op: "attach_tool",
      toolNodeId: o,
      edgeId: `edge-${a}`,
      agentId: i,
      toolId: Ge.widgetToolId(e)
    }), we.getState().selectNode(o), o;
  },
  /** Removes a node and the edges touching it, as deleting it on the canvas does. */
  removeNode(e) {
    we.getState().deleteNode(e);
  },
  setIssues(e) {
    To.getState().setIssues(e);
  },
  setRun(e) {
    To.getState().setRun(e);
  },
  clearOverlay() {
    To.getState().clear();
  }
};
function KK() {
  const e = we((n) => n.doc), t = we((n) => n.dirty);
  return { doc: e, dirty: t };
}
const bt = {
  all: ["agentic-ui", "catalog"],
  models: () => [...bt.all, "models"],
  tools: () => [...bt.all, "tools"],
  scorers: () => [...bt.all, "scorers"],
  refAgents: () => [...bt.all, "ref-agents"],
  connections: () => [...bt.all, "connections"],
  connectorTypes: () => [...bt.all, "connector-types"],
  connectionTools: (e) => [...bt.all, "connection-tools", e],
  metadataSchema: () => [...bt.all, "metadata-schema"],
  knowledgeBases: () => [...bt.all, "knowledge-bases"],
  guidelineFolders: () => [...bt.all, "guideline-folders"]
};
function o9(e) {
  return {
    models: () => [...bt.models(), e],
    tools: () => [...bt.tools(), e],
    scorers: () => [...bt.scorers(), e],
    refAgents: () => [...bt.refAgents(), e],
    connections: () => [...bt.connections(), e],
    connectorTypes: () => [...bt.connectorTypes(), e],
    connectionTools: (t) => [...bt.connectionTools(t), e],
    metadataSchema: () => [...bt.metadataSchema(), e],
    knowledgeBases: () => [...bt.knowledgeBases(), e],
    guidelineFolders: () => [...bt.guidelineFolders(), e]
  };
}
function dO(e, t) {
  return e.find((n) => n.id === t)?.name ?? t;
}
function fO(e, t) {
  return e.find((n) => n.id === t)?.label ?? t;
}
function sr(e) {
  return e?.category === "knowledge" ? "knowledge-base" : e?.category === "brand" ? "brand-guidelines" : e?.widget ? "widget" : e?.category === "widget" ? "generative-widget" : "tool";
}
function Dm(e, t) {
  const n = e.placement === "inline" ? t("widget.placement.inline", "Inline") : t("widget.placement.panel", "Panel"), r = e.publishedVersion === null ? t("widget.draft", "Draft") : e.hasUnpublishedChanges ? t("widget.versionChanged", "v{{version}}, changed", { version: e.publishedVersion }) : t("widget.version", "v{{version}}", { version: e.publishedVersion });
  return `${n} · ${r}`;
}
function An() {
  const { dataKey: e } = dt();
  return Le(() => o9(e), [e]);
}
function _l() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.models(),
    staleTime: 1 / 0,
    queryFn: () => e.models()
  });
}
function dr() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.tools(),
    queryFn: () => e.tools().catch(() => [])
  });
}
function a9() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.scorers(),
    staleTime: 1 / 0,
    queryFn: () => e.scorers?.() ?? Promise.resolve([])
  });
}
function wl() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.refAgents(),
    queryFn: () => e.refAgents()
  });
}
function kl() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.connections(),
    queryFn: () => e.connections().catch(() => [])
  });
}
function s9() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.connectorTypes(),
    queryFn: () => (e.connectorTypes?.() ?? Promise.resolve([])).catch(() => [])
  });
}
function l9(e) {
  const { data: t } = dt(), n = An();
  return Cn({
    queryKey: n.connectionTools(e),
    queryFn: () => t.connectionTools(e),
    retry: !1
  });
}
function Nc() {
  const e = dr().data, t = kl().data, n = wl().data;
  return Le(
    () => ({
      tool: (r) => dO(e ?? [], r),
      connector: (r) => fO(t ?? [], r),
      agent: (r) => n?.find((i) => i.id === r)?.name
    }),
    [e, t, n]
  );
}
const u9 = /* @__PURE__ */ new Set();
function Am(e) {
  const { data: t } = dt(), n = An(), r = kl().data, i = qz({
    queries: e.map((o) => ({
      queryKey: n.connectionTools(o),
      queryFn: () => t.connectionTools(o),
      retry: !1
    })),
    combine: (o) => o.map((d) => d.data)
  }), a = Le(
    () => new Map(
      e.map((o, d) => {
        const u = r?.find((c) => c.id === o)?.writeTools ?? [], l = (i[d] ?? []).filter((c) => c.readOnly === !1).map((c) => c.name);
        return [o, /* @__PURE__ */ new Set([...u, ...l])];
      })
    ),
    [e, r, i]
  );
  return Ye((o) => a.get(o) ?? u9, [a]);
}
function JK() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.metadataSchema(),
    staleTime: 1 / 0,
    queryFn: () => e.metadataSchema?.() ?? Promise.resolve(null)
  });
}
const Hu = { items: [] };
function c9() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.knowledgeBases(),
    queryFn: () => (e.knowledgeBases?.() ?? Promise.resolve(Hu)).catch(() => Hu)
  });
}
function d9() {
  const { data: e } = dt(), t = An();
  return Cn({
    queryKey: t.guidelineFolders(),
    queryFn: () => (e.guidelineFolders?.() ?? Promise.resolve(Hu)).catch(() => Hu)
  });
}
function f9(e) {
  const t = [], n = /* @__PURE__ */ new Map();
  for (const r of e) {
    let i = n.get(r.provider);
    i || (i = { provider: r.provider, label: r.providerLabel, models: [] }, n.set(r.provider, i), t.push(i)), i.models.push(r);
  }
  return t;
}
function jm(e, t) {
  return e.find((n) => n.id === t);
}
function hO(e, t) {
  return jm(e, t)?.label ?? t;
}
function Mm(e, t) {
  return jm(e, t)?.provider;
}
function h9(e, t) {
  if (!e) return;
  const n = (r) => `$${r.toFixed(2)}`;
  return t("model.price", "{{input}} / {{output}} per 1M", {
    input: n(e.input),
    output: n(e.output)
  });
}
function p9(e) {
  return e === "openai" || e === "anthropic" || e === "google";
}
function m9() {
  return /* @__PURE__ */ x(
    "path",
    {
      fill: "currentColor",
      d: "M22.282 9.821a6 6 0 0 0-.516-4.91 6.05 6.05 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a6 6 0 0 0-3.998 2.9 6.05 6.05 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.05 6.05 0 0 0 6.515 2.9A6 6 0 0 0 13.26 24a6.06 6.06 0 0 0 5.772-4.206 6 6 0 0 0 3.997-2.9 6.06 6.06 0 0 0-.747-7.073M13.26 22.43a4.48 4.48 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.8.8 0 0 0 .392-.681v-6.737l2.02 1.168a.07.07 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494M3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.77.77 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646M2.34 7.896a4.5 4.5 0 0 1 2.366-1.973V11.6a.77.77 0 0 0 .388.677l5.815 3.354-2.02 1.168a.08.08 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855-5.833-3.387L15.119 7.2a.08.08 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667m2.01-3.023-.141-.085-4.774-2.782a.78.78 0 0 0-.785 0L9.409 9.23V6.897a.07.07 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.8.8 0 0 0-.393.681zm1.097-2.365 2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5Z"
    }
  );
}
function g9() {
  return /* @__PURE__ */ te(Ue, { children: [
    /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "m13.788825 3.932 6.43325 16.136075h3.5279L17.316725 3.932H13.788825Z"
      }
    ),
    /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        d: "m6.325375 13.682775 2.20125 -5.67065 2.201275 5.67065H6.325375ZM6.68225 3.932 0.25 20.068075h3.596525l1.3155 -3.3886h6.729425l1.315275 3.3886h3.59655L10.371 3.932H6.68225Z"
      }
    )
  ] });
}
function y9({ gradientId: e }) {
  return /* @__PURE__ */ te(Ue, { children: [
    /* @__PURE__ */ x("defs", { children: /* @__PURE__ */ te(
      "linearGradient",
      {
        id: e,
        x1: "2",
        y1: "3",
        x2: "21",
        y2: "22",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ x("stop", { offset: "0", stopColor: "#F44336" }),
          /* @__PURE__ */ x("stop", { offset: "0.3", stopColor: "#FBBC04" }),
          /* @__PURE__ */ x("stop", { offset: "0.6", stopColor: "#1FA463" }),
          /* @__PURE__ */ x("stop", { offset: "1", stopColor: "#4285F4" })
        ]
      }
    ) }),
    /* @__PURE__ */ x(
      "path",
      {
        fill: `url(#${e})`,
        d: "M12 1c.8 6 5 10.2 11 11-6 .8-10.2 5-11 11-.8-6-5-10.2-11-11C7 11.2 11.2 7 12 1Z"
      }
    )
  ] });
}
function pO({ provider: e, className: t }) {
  const n = Ho(), r = Re();
  return /* @__PURE__ */ te(
    "svg",
    {
      viewBox: "0 0 24 24",
      className: Be("size-4 shrink-0", t),
      role: "img",
      "aria-label": r("model.providerLogo", "{{provider}} logo", { provider: e }),
      children: [
        e === "openai" && /* @__PURE__ */ x(m9, {}),
        e === "anthropic" && /* @__PURE__ */ x(g9, {}),
        e === "google" && /* @__PURE__ */ x(y9, { gradientId: n })
      ]
    }
  );
}
function v9(e, t) {
  const n = h9(e.pricing, t), r = e.tier ? ` · ${e.tier}` : "";
  return `${e.label}${r}${n ? ` · ${n}` : ""}`;
}
const b9 = "w-full rounded-md border border-border-light bg-card py-1.5 pr-2 text-sm text-foreground";
function gu({
  id: e,
  value: t,
  onChange: n,
  placeholder: r,
  className: i,
  "aria-label": a
}) {
  const o = Re(), d = _l().data?.models ?? [], u = t ? Mm(d, t) : void 0, l = u !== void 0 && p9(u), c = Le(() => {
    const s = d.filter((h) => h.userSelectable);
    return s.length ? f9(s) : void 0;
  }, [d]), f = c && t && !d.some((s) => s.userSelectable && s.id === t) ? d.find((s) => s.id === t) ?? { id: t, label: t } : void 0;
  return /* @__PURE__ */ te("div", { className: "relative flex items-center", children: [
    l && u && /* @__PURE__ */ x(pO, { provider: u, className: "pointer-events-none absolute left-2 size-4" }),
    /* @__PURE__ */ te(
      "select",
      {
        id: e,
        "aria-label": a,
        className: Be(b9, l ? "pl-8" : "pl-2", i),
        value: t ?? "",
        onChange: (s) => n(s.target.value === "" ? void 0 : s.target.value),
        children: [
          r !== void 0 && /* @__PURE__ */ x("option", { value: "", children: r }),
          f && /* @__PURE__ */ x("option", { value: f.id, children: f.label }),
          c ? c.map((s) => /* @__PURE__ */ x("optgroup", { label: s.label, children: s.models.map((h) => /* @__PURE__ */ x("option", { value: h.id, children: v9(h, o) }, h.id)) }, s.provider)) : (
            // Catalog not loaded yet: keep the current value selectable so the control isn't empty.
            t && /* @__PURE__ */ x("option", { value: t, children: t })
          )
        ]
      }
    )
  ] });
}
function $m({
  agentId: e,
  agent: t,
  size: n = "sm"
}) {
  const { branding: r } = dt(), i = wl().data, a = t ?? i?.find((d) => d.id === e), o = a && r.agentIcon?.({ agent: a, size: n });
  return o ? /* @__PURE__ */ x(
    "span",
    {
      "data-testid": "ref-agent-icon",
      className: `flex shrink-0 items-center justify-center overflow-hidden ${LN(n)}`,
      children: o
    }
  ) : /* @__PURE__ */ x(Wo, { type: "ref-agent", size: n });
}
function XK({ widget: e, thumbnail: t, action: n, aside: r, badge: i, selected: a }) {
  const o = Re();
  return /* @__PURE__ */ x(
    _I,
    {
      type: "widget",
      title: e.name,
      subtitle: Dm(e, o),
      ...t ? { icon: t } : {},
      ...n ? { action: n } : {},
      ...r ? { aside: r } : {},
      ...i ? { badge: i } : {},
      ...a ? { selected: a } : {}
    }
  );
}
function _9(e, t) {
  const n = [], r = [];
  for (const i of e)
    (t === void 0 || Ge.isAllowedMediaType(i.type, t) ? n : r).push(
      i
    );
  return { accepted: n, rejected: r };
}
function w9(e, t) {
  return [...e, ...t];
}
function k9(e, t) {
  return e.filter((n, r) => r !== t);
}
function S9(e, t) {
  return t === void 0 ? { accepted: [...e], rejected: [] } : {
    accepted: e.filter((n) => n.size <= t),
    rejected: e.filter((n) => n.size > t)
  };
}
function x9(e, t, n) {
  if (n === void 0) return { accepted: [...t], rejected: [] };
  let r = e.reduce((o, d) => o + d.size, 0);
  const i = [], a = [];
  for (const o of t) {
    if (r + o.size > n) {
      a.push(o);
      continue;
    }
    r += o.size, i.push(o);
  }
  return { accepted: i, rejected: a };
}
function I9(e) {
  if (!(e === void 0 || e.length === 0))
    return e.map((t) => t.includes("/") ? t : `${t}/*`).join(",");
}
function P9(e) {
  return e !== void 0 && e.length === 0;
}
function O9(e, t, n = !1) {
  return n ? !1 : e.trim().length > 0 || t.length > 0;
}
function z9(e, t, n) {
  if (n === void 0) return { accepted: [...t], rejected: [] };
  const r = Math.max(0, n - e.length);
  return { accepted: t.slice(0, r), rejected: t.slice(r) };
}
function E9() {
  const { data: e } = dt();
  return Cn({
    queryKey: ["agentic-ui", "attachment-policy"],
    staleTime: 1 / 0,
    queryFn: () => e.attachmentPolicy?.() ?? Promise.resolve({})
  });
}
function T9(e) {
  return [
    "flex flex-col rounded-2xl border bg-background transition-colors",
    e ? "border-primary" : "border-border-light"
  ].join(" ");
}
function N9({
  value: e,
  onChange: t,
  onSend: n,
  onStop: r,
  isLoading: i,
  placeholder: a,
  disabled: o = !1,
  pending: d
}) {
  const u = Re(), l = Ce(null), [c, f] = Ae([]), [s, h] = Ae(!1), [p, m] = Ae([]), { data: y } = E9(), w = O9(e, c, o), b = I9(y?.allowedMediaTypes), _ = P9(y?.allowedMediaTypes), g = () => {
    !w || i || (n(e.trim(), c), f([]));
  }, O = (E) => {
    E.key === "Enter" && !E.shiftKey && (E.preventDefault(), g());
  };
  return /* @__PURE__ */ te("div", { className: "px-4 pb-4 pt-1", children: [
    /* @__PURE__ */ x(
      "input",
      {
        ref: l,
        type: "file",
        multiple: !0,
        hidden: !0,
        ...b !== void 0 ? { accept: b } : {},
        onChange: (E) => {
          const T = E.target.files;
          if (T) {
            const D = _9(Array.from(T), y?.allowedMediaTypes), N = S9(D.accepted, y?.maxBytesPerFile), M = x9(c, N.accepted, y?.maxTotalBytes), R = z9(c, M.accepted, y?.maxFiles);
            R.accepted.length > 0 && f((B) => w9(B, R.accepted));
            const V = (B) => B.map((G) => G.name).join(", "), C = [...N.rejected, ...M.rejected];
            m([
              ...C.length > 0 ? [u("composer.tooLarge", "Too large to send: {{files}}", { files: V(C) })] : [],
              ...D.rejected.length > 0 ? [
                u("composer.unsupportedType", "This type of file cannot be sent: {{files}}", {
                  files: V(D.rejected)
                })
              ] : [],
              ...R.rejected.length > 0 && y?.maxFiles !== void 0 ? [
                u("composer.tooMany", "At most {{count}} files can be sent at once: {{files}}", {
                  count: y.maxFiles,
                  files: V(R.rejected)
                })
              ] : []
            ]);
          }
          E.target.value = "";
        }
      }
    ),
    /* @__PURE__ */ te(
      "div",
      {
        className: T9(s),
        style: {
          boxShadow: s ? "0 0 0 3px color-mix(in oklab, var(--primary) 20%, transparent), var(--shadow-sm)" : "var(--shadow-xs)"
        },
        children: [
          d,
          p.map((E) => /* @__PURE__ */ x(
            "div",
            {
              className: "border-b border-border-lighter px-3 py-2 text-[11px] text-destructive",
              children: E
            },
            E
          )),
          c.length > 0 && /* @__PURE__ */ x("div", { className: "flex flex-wrap gap-1.5 border-b border-border-lighter px-3 py-2", children: c.map((E, T) => /* @__PURE__ */ te(
            "span",
            {
              className: "flex items-center gap-1 rounded-md bg-surface px-2 py-0.5 text-[11px] text-foreground-subtle",
              children: [
                /* @__PURE__ */ x("span", { className: "max-w-[160px] truncate", children: E.name }),
                /* @__PURE__ */ x(
                  "button",
                  {
                    type: "button",
                    onClick: () => f((D) => k9(D, T)),
                    className: "text-muted-foreground hover:text-foreground",
                    "aria-label": u("composer.removeFile", "Remove {{name}}", { name: E.name }),
                    children: /* @__PURE__ */ x(vp, { className: "size-3" })
                  }
                )
              ]
            },
            T
          )) }),
          /* @__PURE__ */ te("div", { className: "flex items-end gap-2 p-2", children: [
            /* @__PURE__ */ x(
              Tt,
              {
                variant: "ghost",
                size: "mini",
                className: "size-8 shrink-0 rounded-lg p-0 text-muted-foreground",
                onClick: () => l.current?.click(),
                disabled: o || _,
                "aria-label": _ ? u("composer.attachDisabled", "Attachments are not allowed") : u("composer.attach", "Attach file"),
                children: /* @__PURE__ */ x(cN, { className: "size-4" })
              }
            ),
            /* @__PURE__ */ x(
              mo,
              {
                rows: 1,
                placeholder: a ?? u("composer.placeholder", "Message the agent…"),
                value: e,
                disabled: o,
                onChange: (E) => t(E.target.value),
                onKeyDown: O,
                onFocus: () => h(!0),
                onBlur: () => h(!1),
                className: "max-h-40 min-h-9 flex-1 resize-none border-0 bg-transparent px-1 py-1.5 text-[15px] shadow-none outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
              }
            ),
            i ? /* @__PURE__ */ x(
              Tt,
              {
                variant: "secondary",
                size: "mini",
                className: "flex size-8 shrink-0 items-center justify-center rounded-full bg-primary p-0 hover:bg-primary-hover",
                onClick: r,
                "aria-label": u("composer.stop", "Stop"),
                children: /* @__PURE__ */ x("span", { className: "size-3 rounded-[3px] bg-primary-foreground" })
              }
            ) : /* @__PURE__ */ x(
              Tt,
              {
                size: "mini",
                className: "size-8 shrink-0 rounded-lg p-0",
                onClick: g,
                disabled: !w,
                "aria-label": u("composer.send", "Send"),
                children: /* @__PURE__ */ x(_T, { className: "size-4" })
              }
            )
          ] })
        ]
      }
    )
  ] });
}
function YK({
  compaction: e
}) {
  const t = Re(), { inputTokens: n, cachedInputTokens: r, outputTokens: i } = e.usage, a = t(
    "chat.compactionDetail",
    "Turns 1 to {{turns}} summarized: read {{input}} tokens, {{cached}} from cache, wrote {{output}}.",
    {
      turns: e.coveredTurns,
      input: En(t, n),
      cached: En(t, r),
      output: En(t, i)
    }
  );
  return /* @__PURE__ */ te("div", { className: "flex items-center gap-3 py-2 text-xs text-muted-foreground", children: [
    /* @__PURE__ */ x("span", { "aria-hidden": !0, className: "h-px flex-1 bg-border" }),
    /* @__PURE__ */ x(Yu, { delayDuration: 200, children: /* @__PURE__ */ te(Qu, { children: [
      /* @__PURE__ */ x(ec, { asChild: !0, children: /* @__PURE__ */ x("span", { tabIndex: 0, "aria-description": a, children: t("chat.compactionMarker", "Earlier messages summarized") }) }),
      /* @__PURE__ */ x(tc, { children: a })
    ] }) }),
    /* @__PURE__ */ x("span", { "aria-hidden": !0, className: "h-px flex-1 bg-border" })
  ] });
}
function C9(e, t) {
  return e.parts.some(
    (n) => n.type === "text" && n.text.trim() !== "" || t && n.type.startsWith("tool-")
  );
}
function D9({
  messages: e,
  showToolParts: t,
  renderToolPart: n,
  renderAssistantHeader: r,
  resolvePartAgent: i,
  loadingIndicator: a,
  emptyState: o,
  dense: d = !1,
  renderAfterMessage: u
}) {
  const l = Re(), c = Ce(null);
  return Ze(() => {
    c.current?.scrollIntoView({ behavior: "smooth" });
  }, [e]), /* @__PURE__ */ x("div", { className: "flex min-h-0 flex-1 flex-col overflow-y-auto", children: /* @__PURE__ */ te("div", { className: Be("flex w-full flex-1 flex-col", d ? "gap-3 p-3" : "gap-6 px-5 py-6"), children: [
    e.length === 0 && o,
    A9(e, u, (f) => {
      if (f.role === "user") {
        const p = f.parts.filter((y) => y.type === "text").map((y) => y.text).join(""), m = f.parts.filter((y) => y.type === "file");
        return /* @__PURE__ */ te("div", { className: "flex flex-col items-end gap-1.5", children: [
          m.length > 0 && /* @__PURE__ */ x("div", { className: "flex flex-wrap justify-end gap-1", children: m.map((y, w) => /* @__PURE__ */ x(
            "span",
            {
              className: "rounded-md bg-surface px-2 py-0.5 text-[11px] text-foreground-subtle",
              children: y.filename ?? l("messages.file", "file")
            },
            w
          )) }),
          p && /* @__PURE__ */ x(
            "div",
            {
              className: Be(
                "w-fit max-w-[80%] whitespace-pre-wrap break-words bg-[var(--theme-background)] text-foreground",
                d ? "rounded-lg rounded-tr-none px-3 py-2 text-[13px]" : "rounded-xl rounded-tr-none px-4 py-3 text-[15px] leading-relaxed"
              ),
              children: p
            }
          )
        ] }, f.id);
      }
      if (!C9(f, t)) return null;
      const s = f.parts.map((p, m) => ({ part: p, i: m })).filter(
        ({ part: p }) => p.type === "text" && p.text.trim() !== "" || t && p.type.startsWith("tool-")
      ), h = [];
      for (const p of s) {
        const m = i?.(f, p.i), y = h[h.length - 1];
        y && y.agentId === m ? y.items.push(p) : h.push({ agentId: m, items: [p] });
      }
      return /* @__PURE__ */ x("div", { className: "flex flex-col gap-2", children: h.map((p, m) => /* @__PURE__ */ te("div", { className: "flex flex-col gap-2", children: [
        p.agentId !== void 0 && r?.(p.agentId),
        /* @__PURE__ */ x(
          "div",
          {
            className: Be(
              "flex flex-col gap-2",
              d && "text-[13px]",
              !d && r && "pl-9"
            ),
            children: p.items.map(({ part: y, i: w }) => {
              if (y.type === "text" && y.text)
                return /* @__PURE__ */ x(g$, { children: y.text }, w);
              if (t && y.type.startsWith("tool-")) {
                const b = n?.(y, { message: f, index: w });
                return b == null ? null : /* @__PURE__ */ x(il, { children: b }, w);
              }
              return null;
            })
          }
        )
      ] }, m)) }, f.id);
    }),
    a,
    /* @__PURE__ */ x("div", { ref: c })
  ] }) });
}
function A9(e, t, n) {
  return t ? e.map((r) => /* @__PURE__ */ te(il, { children: [
    n(r),
    t(r)
  ] }, r.id)) : e.map(n);
}
function j9(e, t, n, r) {
  if (n.length === 0) {
    e({ text: t }, r);
    return;
  }
  const i = new DataTransfer();
  for (const a of n) i.items.add(a);
  e({ text: t || " ", files: i.files }, r);
}
const Ir = zr((e) => ({
  open: !1,
  model: void 0,
  toggle: () => e((t) => ({ open: !t.open })),
  setOpen: (t) => e({ open: t }),
  setModel: (t) => e({ model: t })
}));
function M9(e, t, n) {
  return {
    flow: e,
    selection: { nodeId: t.selectedNodeId, edgeId: t.selectedEdgeId },
    catalog: {
      tools: n.tools.map((r) => ({ id: r.id, name: r.name, description: r.description })),
      connectors: n.connectors.map((r) => ({ id: r.id, label: r.label })),
      connectorTypes: n.connectorTypes.map((r) => ({
        id: r.id,
        label: r.label,
        description: r.description
      })),
      refAgents: n.refAgents.map((r) => ({ id: r.id, name: r.name }))
    }
  };
}
function $9(e, t, n) {
  switch (t.op) {
    case "add_agent":
    case "add_ref_agent":
      return e("copilot.step.addAgent", "Added agent {{name}}", { name: t.name });
    case "set_ref_agent_input":
      return e("copilot.step.settings", "Changed agent settings");
    case "write_prompt":
      return e("copilot.step.prompt", "Wrote the system prompt");
    case "set_model":
      return e("copilot.step.model", "Changed the model");
    case "set_metadata":
      return e("copilot.step.metadata", "Updated agent details");
    case "set_tool_policy":
      return e("copilot.step.policy", "Changed a tool policy");
    case "update_connection":
      return e("copilot.step.connection", "Updated connector tools");
    case "add_guardrail":
      return e("copilot.step.addGuardrail", "Added a guardrail");
    case "update_guardrail":
      return e("copilot.step.guardrail", "Updated a guardrail");
    case "add_scorer":
      return e("copilot.step.addScorer", "Added a scorer");
    case "update_scorer":
      return e("copilot.step.scorer", "Updated a scorer");
    case "connect":
      return e("copilot.step.connect", "Connected two nodes");
    case "attach_tool":
      return e("copilot.step.tool", "Attached tool {{name}}", { name: n.tool(t.toolId) });
    case "attach_web_search":
      return e("copilot.step.webSearch", "Attached web search");
    case "attach_connector":
      return e("copilot.step.connector", "Attached connector {{name}}", {
        name: n.connector(t.connectionId)
      });
    case "disconnect":
      return e("copilot.step.disconnect", "Removed a connection");
    case "update_edge":
      return e("copilot.step.edge", "Updated a connection");
    case "set_entry":
      return e("copilot.step.entry", "Set the entry agent");
    case "delete_node":
      return e("copilot.step.delete", "Deleted a node");
    case "set_flow_name":
      return e("copilot.step.rename", "Renamed to {{name}}", { name: t.name });
    case "set_dataset":
      return e("copilot.step.dataset", "Kept {{key}} as a dataset", { key: t.dataset.key });
    case "remove_dataset":
      return e("copilot.step.datasetRemoved", "Removed the dataset {{key}}", { key: t.key });
    case "undo":
      return e("copilot.step.undo", "Undid the last change");
    case "redo":
      return e("copilot.step.redo", "Redid a change");
    case "save":
      return e("copilot.step.save", "Saved the flow");
    case "new_flow":
      return e("copilot.step.newFlow", "Started a new flow");
  }
}
function R9(e, t, n) {
  const r = Ge.concreteOpSchema.safeParse(t);
  return r.success ? $9(e, r.data, n) : void 0;
}
function Z9() {
  const e = Re(), t = dr().data, n = kl().data;
  return Ye(
    (r) => {
      const i = r.find((a) => a.type === Ge.COPILOT_OP_PART);
      if (i)
        return R9(e, i.data, {
          tool: (a) => dO(t ?? [], a),
          connector: (a) => fO(n ?? [], a)
        });
    },
    [e, t, n]
  );
}
function L9({
  part: e,
  message: t,
  stepTitle: n
}) {
  const { toolCallId: r, state: i } = e;
  if (!r) return null;
  const a = t.parts.flatMap((d) => {
    const { id: u, data: l } = d;
    return d.type.startsWith("data-") && u === r ? [{ type: d.type, data: l }] : [];
  }), o = n(a);
  return o ? /* @__PURE__ */ te(
    "div",
    {
      "data-testid": "copilot-step",
      className: "flex items-center gap-1.5 text-[12px] text-foreground-subtle",
      children: [
        i === "output-error" ? /* @__PURE__ */ x(sc, { "aria-hidden": !0, className: "size-3 shrink-0 text-destructive" }) : i === "output-available" ? /* @__PURE__ */ x(zT, { "aria-hidden": !0, className: "size-3 shrink-0 text-primary" }) : /* @__PURE__ */ x(tN, { "aria-hidden": !0, className: "size-3 shrink-0 animate-spin motion-reduce:animate-none" }),
        /* @__PURE__ */ x("span", { className: "truncate", children: o })
      ]
    }
  ) : null;
}
function F9({ transport: e, chat: t, onSaveFlow: n }) {
  const r = Ir((d) => d.setOpen), [i, a] = Ae(() => crypto.randomUUID().slice(0, 8));
  return /* @__PURE__ */ x(
    B9,
    {
      ...e ? { transport: e } : {},
      ...t ? { chat: t } : {},
      sessionId: i,
      onNewConversation: () => {
        we.setState({ copilotTurnActive: !1 }), a(crypto.randomUUID().slice(0, 8));
      },
      onClose: () => r(!1),
      ...n ? { onSaveFlow: n } : {}
    },
    i
  );
}
function mO(e, t) {
  const n = Ge.concreteOpSchema.safeParse(e);
  if (!n.success) return;
  const r = n.data, i = we.getState();
  if (Ge.isMetaOp(r)) {
    r.op === "undo" ? i.undo() : r.op === "redo" ? i.redo() : r.op === "new_flow" ? i.newFlow() : r.op === "save" && i.doc && t?.(i.doc);
    return;
  }
  i.applyCopilotOp(r);
}
function U9() {
  const e = dr().data ?? [], t = kl().data ?? [], n = s9().data ?? [], r = wl().data ?? [];
  return () => {
    we.getState().beginCopilotTurn();
    const i = we.getState();
    return i.doc ? {
      builderContext: M9(
        i.doc,
        { selectedNodeId: i.selectedNodeId, selectedEdgeId: i.selectedEdgeId },
        { tools: e, connectors: t, connectorTypes: n, refAgents: r }
      )
    } : {};
  };
}
const Yh = () => {
  we.setState({ copilotTurnActive: !1 });
};
function B9({
  transport: e,
  chat: t,
  sessionId: n,
  onNewConversation: r,
  onClose: i,
  onSaveFlow: a
}) {
  const o = Re(), d = U9(), u = Z9(), l = /* @__PURE__ */ te("div", { className: "flex flex-1 flex-col items-center justify-center gap-3 px-6 py-8 text-center", children: [
    /* @__PURE__ */ x(
      "span",
      {
        className: "flex size-12 items-center justify-center rounded-md text-primary",
        style: { background: "color-mix(in oklab, var(--primary) 14%, transparent)" },
        children: /* @__PURE__ */ x(fk, { className: "size-6", "aria-hidden": !0 })
      }
    ),
    /* @__PURE__ */ te("div", { className: "flex flex-col items-center gap-1", children: [
      /* @__PURE__ */ x("p", { className: "text-lg font-medium text-foreground", children: o("copilot.title", "Flow.Assist") }),
      /* @__PURE__ */ x("p", { className: "text-sm text-muted-foreground", children: o(
        "copilot.empty",
        "Describe what you want to build and I'll draw it on the canvas: agents, connections, tools and prompts."
      ) })
    ] })
  ] });
  return /* @__PURE__ */ te(
    "div",
    {
      className: "flex h-full min-h-0 flex-col",
      role: "complementary",
      "aria-label": o("copilot.title", "Flow.Assist"),
      children: [
        /* @__PURE__ */ x(
          V9,
          {
            onNewConversation: r,
            onClose: i,
            showModel: !t
          }
        ),
        t ? /* @__PURE__ */ x(
          t,
          {
            sessionId: n,
            beginTurn: d,
            onOp: (c) => {
              mO(c, a);
            },
            onTurnEnd: Yh,
            stepTitle: u,
            empty: l
          }
        ) : e ? /* @__PURE__ */ x(
          q9,
          {
            transport: e,
            sessionId: n,
            beginTurn: d,
            stepTitle: u,
            empty: l,
            ...a ? { onSaveFlow: a } : {}
          }
        ) : null
      ]
    }
  );
}
function V9({
  onNewConversation: e,
  onClose: t,
  showModel: n
}) {
  const r = Re(), i = Ir((d) => d.model), a = Ir((d) => d.setModel), o = we((d) => d.copilotTurnActive);
  return /* @__PURE__ */ te("div", { className: "flex h-9 shrink-0 items-center justify-end gap-2 px-3", children: [
    n && /* @__PURE__ */ x(
      gu,
      {
        value: i,
        onChange: a,
        placeholder: r("copilot.defaultModel", "Default model"),
        "aria-label": r("copilot.model", "Flow.Assist model"),
        className: "max-w-[170px] py-1 text-xs"
      }
    ),
    /* @__PURE__ */ x(
      "button",
      {
        type: "button",
        "aria-label": r("copilot.newConversation", "New conversation"),
        title: r("copilot.newConversation", "New conversation"),
        onClick: e,
        disabled: o,
        className: "text-muted-foreground hover:text-foreground disabled:opacity-40",
        children: /* @__PURE__ */ x(pN, { className: "size-4" })
      }
    ),
    /* @__PURE__ */ x(im, { label: r("copilot.minimize", "Minimize Flow.Assist"), onClick: t })
  ] });
}
function q9({
  transport: e,
  sessionId: t,
  beginTurn: n,
  stepTitle: r,
  empty: i,
  onSaveFlow: a
}) {
  const o = Re(), d = we((b) => b.doc), u = Ir((b) => b.model), [l, c] = Ae(""), { messages: f, sendMessage: s, status: h, stop: p } = Fz({
    id: `copilot-${t}`,
    transport: e,
    onData: (b) => {
      b.type === "data-copilot-op" && mO(b.data, a);
    },
    onFinish: Yh
  });
  return /* @__PURE__ */ te(Ue, { children: [
    /* @__PURE__ */ x(
      D9,
      {
        messages: f,
        showToolParts: !0,
        renderToolPart: (b, { message: _ }) => /* @__PURE__ */ x(L9, { part: b, message: _, stepTitle: r }),
        dense: !0,
        emptyState: i
      }
    ),
    /* @__PURE__ */ x("div", { className: "shrink-0 border-t border-border-light", children: /* @__PURE__ */ x(
      N9,
      {
        value: l,
        onChange: c,
        onSend: (b, _) => {
          const g = { ...n(), ...u ? { model: u } : {} };
          j9(s, b, _, Object.keys(g).length > 0 ? { body: g } : void 0), c("");
        },
        onStop: () => {
          p(), Yh();
        },
        isLoading: h === "streaming" || h === "submitted",
        disabled: !d,
        placeholder: o("copilot.placeholder", "Describe what to build…")
      }
    ) })
  ] });
}
const QK = {
  open() {
    Ir.getState().setOpen(!0);
  }
}, Hw = {
  width: 18,
  height: 18,
  background: "var(--primary)",
  border: "2px solid var(--card)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, Ww = { color: "var(--card)" }, H9 = {
  // Four bottom handles share the edge, so they are spaced evenly at 20/40/60/80%.
  handoff: {
    Icon: IN,
    title: (e) => e("node.handle.handoffs", "Handoffs"),
    position: Ie.Bottom,
    left: "20%"
  },
  uses: {
    Icon: yp,
    title: (e) => e("node.handle.tools", "Tools"),
    position: Ie.Bottom,
    left: "40%"
  },
  "guards-output": {
    Icon: mp,
    title: (e) => e("node.handle.outputGuardrails", "Output guardrails"),
    position: Ie.Bottom,
    left: "60%"
  },
  scores: {
    Icon: ck,
    title: (e) => e("node.handle.scorers", "Scorers"),
    position: Ie.Bottom,
    left: "80%"
  },
  // Top edge, aligned above the output-guardrail handle so the two read as a
  // guardrails column (input above, output below) beside the input arrow.
  "guards-input": {
    Icon: gp,
    title: (e) => e("node.handle.inputGuardrails", "Input guardrails"),
    position: Ie.Top,
    left: "60%"
  }
};
function W9(e, t) {
  const n = [];
  return e.durationMs !== void 0 && n.push(t("node.run.seconds", "{{value}}s", { value: (e.durationMs / 1e3).toFixed(1) })), e.tokens !== void 0 && n.push(
    e.tokens >= 1e3 ? t("node.run.kiloTokens", "{{value}}k tok", { value: (e.tokens / 1e3).toFixed(1) }) : t("node.run.tokens", "{{value}} tok", { value: e.tokens })
  ), n.length > 0 ? n.join(" · ") : void 0;
}
const G9 = {
  approval: dk,
  "always-allowed": $T
};
function K9({ stat: e }) {
  const t = G9[e.kind];
  return /* @__PURE__ */ x(
    "span",
    {
      title: e.label,
      "aria-label": e.label,
      className: "inline-flex items-center gap-0.5 rounded bg-muted px-1 text-[10px] tabular-nums text-muted-foreground",
      children: t ? /* @__PURE__ */ te(Ue, { children: [
        /* @__PURE__ */ x(t, { "aria-hidden": !0, className: "size-2.5" }),
        e.count
      ] }) : e.label
    }
  );
}
function J9({
  type: e,
  icon: t,
  label: n,
  sublabel: r,
  stats: i,
  badge: a,
  selected: o,
  dropTarget: d,
  dimmed: u = !1,
  incompleteReason: l,
  problems: c = [],
  run: f,
  target: s,
  sources: h = [],
  onRename: p
}) {
  const m = Re(), y = o || d, w = f?.status === "error" || c.length > 0, b = f && f.status !== "running" ? W9(f, m) : void 0, [_, g] = Ae(null), O = _ !== null, P = () => {
    const E = _?.trim() ?? "";
    E && E !== n && p?.(E), g(null);
  };
  return /* @__PURE__ */ te(
    "div",
    {
      className: Be(
        "relative flex items-center gap-2.5 rounded-lg border bg-card px-2.5 py-2 text-xs shadow-sm transition-colors",
        f?.status === "running" && "agentic-node-running"
      ),
      "data-run-status": f?.status,
      style: {
        width: 210,
        opacity: u ? 0.55 : 1,
        borderColor: w ? "var(--destructive)" : y || f?.status === "running" ? "var(--primary)" : "var(--border-light)",
        ...d ? { boxShadow: "0 0 0 2px color-mix(in oklab, var(--primary) 45%, transparent)" } : {}
      },
      children: [
        s && /* @__PURE__ */ x(
          Zo,
          {
            type: "target",
            position: Ie.Top,
            title: m("node.handle.input", "Input"),
            style: Hw,
            children: /* @__PURE__ */ x(gT, { className: "pointer-events-none size-2.5", style: Ww })
          }
        ),
        t ?? /* @__PURE__ */ x(Wo, { type: e }),
        /* @__PURE__ */ te("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ te("div", { className: "flex items-start gap-1", children: [
            p && O ? /* @__PURE__ */ x(
              "input",
              {
                className: "nodrag min-w-0 flex-1 rounded border border-primary bg-card px-1 text-xs font-medium text-foreground outline-none",
                value: _,
                autoFocus: !0,
                onFocus: (E) => E.currentTarget.select(),
                onChange: (E) => g(E.target.value),
                onKeyDown: (E) => {
                  E.key === "Enter" && P(), E.key === "Escape" && g(null);
                },
                onBlur: P,
                onClick: (E) => E.stopPropagation(),
                onDoubleClick: (E) => E.stopPropagation()
              }
            ) : /* @__PURE__ */ x(
              "span",
              {
                className: Be(
                  "line-clamp-2 min-w-0 flex-1 font-medium break-words text-foreground",
                  p && "cursor-text"
                ),
                style: u ? { textDecoration: "line-through" } : void 0,
                onDoubleClick: p ? (E) => {
                  E.stopPropagation(), g(n);
                } : void 0,
                title: p ? m("node.rename", "Double-click to rename") : n,
                children: n
              }
            ),
            c.length > 0 ? /* @__PURE__ */ x(
              "span",
              {
                title: c.join(" · "),
                "aria-label": c.join(" · "),
                className: "flex shrink-0 items-center text-destructive",
                children: /* @__PURE__ */ x(jT, { className: "size-3.5" })
              }
            ) : l && /* @__PURE__ */ x(
              "span",
              {
                title: l,
                className: "flex shrink-0 items-center",
                style: { color: "var(--warning-foreground)" },
                children: /* @__PURE__ */ x(sc, { className: "size-3.5" })
              }
            ),
            a
          ] }),
          r && /* @__PURE__ */ x("div", { className: "line-clamp-2 text-[10px] break-words text-muted-foreground", children: r }),
          i && i.length > 0 && /* @__PURE__ */ x("div", { className: "mt-0.5 flex flex-wrap gap-1", children: i.map((E) => /* @__PURE__ */ x(K9, { stat: E }, E.kind)) }),
          b && /* @__PURE__ */ x("div", { className: "truncate text-[10px] tabular-nums text-muted-foreground", children: b })
        ] }),
        h.map((E) => {
          const { Icon: T, title: D, position: N, left: M } = H9[E], R = D(m);
          return /* @__PURE__ */ x(
            Zo,
            {
              id: E,
              type: "source",
              position: N,
              title: R,
              style: { ...Hw, left: M },
              children: /* @__PURE__ */ x(T, { className: "pointer-events-none size-2.5", style: Ww })
            },
            E
          );
        })
      ]
    }
  );
}
function X9(e) {
  return /* @__PURE__ */ te(
    "span",
    {
      title: e("node.entryPoint", "Entry point"),
      className: "flex shrink-0 items-center gap-0.5 rounded px-1 text-[9px] font-semibold uppercase",
      style: {
        background: "color-mix(in oklab, var(--primary) 16%, transparent)",
        color: "var(--primary)"
      },
      children: [
        /* @__PURE__ */ x(ON, { className: "size-2.5" }),
        " ",
        e("node.entry", "entry")
      ]
    }
  );
}
function Y9(e, t) {
  if (!e || e === "allow") return null;
  const n = e === "disallow";
  return /* @__PURE__ */ x(
    "span",
    {
      className: "shrink-0 rounded px-1 text-[9px] font-semibold uppercase",
      style: {
        background: n ? "var(--destructive-soft)" : "var(--warning)",
        color: n ? "var(--destructive-soft-foreground)" : "var(--warning-foreground)"
      },
      children: n ? t("node.policy.denied", "denied") : t("node.policy.approval", "approval")
    }
  );
}
function Q9({ id: e, data: t, selected: n }) {
  const r = we((y) => y.updateAgentNode), i = we((y) => y.updateGuardrailNode), a = we((y) => y.updateScorerNode), o = we((y) => y.doc?.edges), d = Re(), { branding: u } = dt(), l = To((y) => y.issuesByNode[e]), c = To((y) => y.runByNode[e]), f = nI((y) => {
    if (!y.inProgress || y.fromNode?.id === e) return !1;
    const w = y.fromHandle?.id;
    if (!Ge.isBuilderSourceHandle(w)) return !1;
    const b = Ge.resolveEdgeType(w, t.kind);
    return b !== null && !Ge.loopClosedBy(o ?? [], b, y.fromNode.id, e);
  }), s = t.entityType ?? oO(t.kind, !!t.isRef), h = s === "agent", p = h || s === "ref-agent", m = t.readOnly ? void 0 : s === "agent" ? (y) => r(e, { name: y }) : s === "guardrail" ? (y) => i(e, { name: y }) : s === "scorer" ? (y) => a(e, { name: y }) : void 0;
  return /* @__PURE__ */ x(
    J9,
    {
      type: s,
      ...s === "ref-agent" ? { icon: /* @__PURE__ */ x($m, { agentId: t.agentId }) } : {},
      ...s === "widget" && t.widgetId && u.widgetThumbnail ? { icon: u.widgetThumbnail({ widgetId: t.widgetId, size: "md" }) } : {},
      label: t.label,
      sublabel: t.sublabel,
      stats: t.stats,
      badge: s === "tool" || s === "widget" || s === "generative-widget" ? Y9(t.policy, d) : p && t.isEntry ? X9(d) : null,
      incompleteReason: t.incompleteReason,
      ...t.readOnly ? t.showRun ? { run: c } : {} : { problems: l, run: c },
      selected: !!n,
      dropTarget: f,
      dimmed: t.kind === "tool" && t.policy === "disallow",
      target: !0,
      sources: h ? ["handoff", "uses", "guards-input", "guards-output", "scores"] : [],
      onRename: m
    }
  );
}
const eq = {
  handoff: "var(--badge-orange-foreground)",
  denied: "var(--destructive)",
  default: "var(--muted-foreground)",
  guards: "var(--badge-purple-foreground)",
  scores: "var(--badge-yellow-foreground)"
};
function tq({
  id: e,
  sourceX: t,
  sourceY: n,
  sourcePosition: r,
  targetX: i,
  targetY: a,
  targetPosition: o,
  markerEnd: d,
  style: u,
  label: l,
  data: c,
  selected: f
}) {
  const s = we((b) => b.deleteEdge), h = Re(), [p, m, y] = _c({
    sourceX: t,
    sourceY: n,
    sourcePosition: r,
    targetX: i,
    targetY: a,
    targetPosition: o
  }), w = c?.variant ?? "default";
  return /* @__PURE__ */ te(Ue, { children: [
    f && /* @__PURE__ */ x(
      Lo,
      {
        id: `${e}__halo`,
        className: "agentic-edge-halo",
        path: p,
        style: {
          stroke: "var(--primary)",
          strokeWidth: 4,
          opacity: 0.25,
          strokeLinecap: "round"
        }
      }
    ),
    /* @__PURE__ */ x(Lo, { id: e, path: p, markerEnd: d, style: u }),
    /* @__PURE__ */ x(jL, { children: /* @__PURE__ */ te(
      "div",
      {
        className: "group nodrag nopan absolute flex items-center gap-1",
        style: {
          transform: `translate(-50%, -50%) translate(${m}px, ${y}px)`,
          pointerEvents: "all"
        },
        children: [
          l && /* @__PURE__ */ x(
            "span",
            {
              className: "rounded border px-1 text-[9px] font-medium uppercase tracking-wide",
              style: {
                color: eq[w],
                borderColor: f ? "var(--primary)" : "var(--border-light)",
                background: f ? "color-mix(in oklab, var(--primary) 12%, var(--card))" : "var(--card)",
                boxShadow: f ? "0 0 0 2px color-mix(in oklab, var(--primary) 30%, transparent)" : void 0
              },
              children: l
            }
          ),
          /* @__PURE__ */ x(
            "button",
            {
              type: "button",
              "aria-label": h("edge.remove", "Remove link"),
              onClick: () => s(e),
              className: `flex size-4 items-center justify-center rounded-full border bg-card shadow-sm transition-opacity hover:border-destructive hover:text-destructive ${f ? "border-[var(--primary)] text-[var(--primary)] opacity-100" : "border-border-light text-muted-foreground opacity-0 group-hover:opacity-100"}`,
              children: /* @__PURE__ */ x(vp, { className: "size-2.5" })
            }
          )
        ]
      }
    ) })
  ] });
}
function ce(e, t, n) {
  function r(d, u) {
    if (d._zod || Object.defineProperty(d, "_zod", {
      value: {
        def: u,
        constr: o,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), d._zod.traits.has(e))
      return;
    d._zod.traits.add(e), t(d, u);
    const l = o.prototype, c = Object.keys(l);
    for (let f = 0; f < c.length; f++) {
      const s = c[f];
      s in d || (d[s] = l[s].bind(d));
    }
  }
  const i = n?.Parent ?? Object;
  class a extends i {
  }
  Object.defineProperty(a, "name", { value: e });
  function o(d) {
    var u;
    const l = n?.Parent ? new a() : this;
    r(l, d), (u = l._zod).deferred ?? (u.deferred = []);
    for (const c of l._zod.deferred)
      c();
    return l;
  }
  return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, {
    value: (d) => n?.Parent && d instanceof n.Parent ? !0 : d?._zod?.traits?.has(e)
  }), Object.defineProperty(o, "name", { value: e }), o;
}
class No extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class gO extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const yO = {};
function Pr(e) {
  return yO;
}
function vO(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, i]) => t.indexOf(+r) === -1).map(([r, i]) => i);
}
function Qh(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Cc(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Rm(e) {
  return e == null;
}
function Zm(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function nq(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const u = r.match(/\d?e-(\d?)/);
    u?.[1] && (i = Number.parseInt(u[1]));
  }
  const a = n > i ? n : i, o = Number.parseInt(e.toFixed(a).replace(".", "")), d = Number.parseInt(t.toFixed(a).replace(".", ""));
  return o % d / 10 ** a;
}
const Gw = /* @__PURE__ */ Symbol("evaluating");
function Je(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== Gw)
        return r === void 0 && (r = Gw, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function li(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Nr(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function Kw(e) {
  return JSON.stringify(e);
}
function rq(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const bO = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function tl(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const iq = Cc(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function Vo(e) {
  if (tl(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(tl(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function _O(e) {
  return Vo(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const oq = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function qo(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Cr(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (r._zod.parent = e), r;
}
function Oe(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function aq(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const sq = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function lq(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const a = Nr(e._zod.def, {
    get shape() {
      const o = {};
      for (const d in t) {
        if (!(d in n.shape))
          throw new Error(`Unrecognized key: "${d}"`);
        t[d] && (o[d] = n.shape[d]);
      }
      return li(this, "shape", o), o;
    },
    checks: []
  });
  return Cr(e, a);
}
function uq(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const a = Nr(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const d in t) {
        if (!(d in n.shape))
          throw new Error(`Unrecognized key: "${d}"`);
        t[d] && delete o[d];
      }
      return li(this, "shape", o), o;
    },
    checks: []
  });
  return Cr(e, a);
}
function cq(e, t) {
  if (!Vo(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const a = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(a, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const i = Nr(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape, ...t };
      return li(this, "shape", a), a;
    }
  });
  return Cr(e, i);
}
function dq(e, t) {
  if (!Vo(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Nr(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return li(this, "shape", r), r;
    }
  });
  return Cr(e, n);
}
function fq(e, t) {
  const n = Nr(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return li(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Cr(e, n);
}
function hq(e, t, n) {
  const i = t._zod.def.checks;
  if (i && i.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const o = Nr(t._zod.def, {
    get shape() {
      const d = t._zod.def.shape, u = { ...d };
      if (n)
        for (const l in n) {
          if (!(l in d))
            throw new Error(`Unrecognized key: "${l}"`);
          n[l] && (u[l] = e ? new e({
            type: "optional",
            innerType: d[l]
          }) : d[l]);
        }
      else
        for (const l in d)
          u[l] = e ? new e({
            type: "optional",
            innerType: d[l]
          }) : d[l];
      return li(this, "shape", u), u;
    },
    checks: []
  });
  return Cr(t, o);
}
function pq(e, t, n) {
  const r = Nr(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, a = { ...i };
      if (n)
        for (const o in n) {
          if (!(o in a))
            throw new Error(`Unrecognized key: "${o}"`);
          n[o] && (a[o] = new e({
            type: "nonoptional",
            innerType: i[o]
          }));
        }
      else
        for (const o in i)
          a[o] = new e({
            type: "nonoptional",
            innerType: i[o]
          });
      return li(this, "shape", a), a;
    }
  });
  return Cr(t, r);
}
function xo(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function Io(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function Kl(e) {
  return typeof e == "string" ? e : e?.message;
}
function Or(e, t, n) {
  const r = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const i = Kl(e.inst?._zod.def?.error?.(e)) ?? Kl(t?.error?.(e)) ?? Kl(n.customError?.(e)) ?? Kl(n.localeError?.(e)) ?? "Invalid input";
    r.message = i;
  }
  return delete r.inst, delete r.continue, t?.reportInput || delete r.input, r;
}
function Lm(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function nl(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const wO = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Qh, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, kO = ce("$ZodError", wO), SO = ce("$ZodError", wO, { Parent: Error });
function mq(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function gq(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const a of i.issues)
      if (a.code === "invalid_union" && a.errors.length)
        a.errors.map((o) => r({ issues: o }));
      else if (a.code === "invalid_key")
        r({ issues: a.issues });
      else if (a.code === "invalid_element")
        r({ issues: a.issues });
      else if (a.path.length === 0)
        n._errors.push(t(a));
      else {
        let o = n, d = 0;
        for (; d < a.path.length; ) {
          const u = a.path[d];
          d === a.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(t(a))) : o[u] = o[u] || { _errors: [] }, o = o[u], d++;
        }
      }
  };
  return r(e), n;
}
const Fm = (e) => (t, n, r, i) => {
  const a = r ? Object.assign(r, { async: !1 }) : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, a);
  if (o instanceof Promise)
    throw new No();
  if (o.issues.length) {
    const d = new (i?.Err ?? e)(o.issues.map((u) => Or(u, a, Pr())));
    throw bO(d, i?.callee), d;
  }
  return o.value;
}, Um = (e) => async (t, n, r, i) => {
  const a = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, a);
  if (o instanceof Promise && (o = await o), o.issues.length) {
    const d = new (i?.Err ?? e)(o.issues.map((u) => Or(u, a, Pr())));
    throw bO(d, i?.callee), d;
  }
  return o.value;
}, Dc = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, i);
  if (a instanceof Promise)
    throw new No();
  return a.issues.length ? {
    success: !1,
    error: new (e ?? kO)(a.issues.map((o) => Or(o, i, Pr())))
  } : { success: !0, data: a.value };
}, yq = /* @__PURE__ */ Dc(SO), Ac = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, i);
  return a instanceof Promise && (a = await a), a.issues.length ? {
    success: !1,
    error: new e(a.issues.map((o) => Or(o, i, Pr())))
  } : { success: !0, data: a.value };
}, vq = /* @__PURE__ */ Ac(SO), bq = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Fm(e)(t, n, i);
}, _q = (e) => (t, n, r) => Fm(e)(t, n, r), wq = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Um(e)(t, n, i);
}, kq = (e) => async (t, n, r) => Um(e)(t, n, r), Sq = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Dc(e)(t, n, i);
}, xq = (e) => (t, n, r) => Dc(e)(t, n, r), Iq = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Ac(e)(t, n, i);
}, Pq = (e) => async (t, n, r) => Ac(e)(t, n, r), Oq = /^[cC][^\s-]{8,}$/, zq = /^[0-9a-z]+$/, Eq = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Tq = /^[0-9a-vA-V]{20}$/, Nq = /^[A-Za-z0-9]{27}$/, Cq = /^[a-zA-Z0-9_-]{21}$/, Dq = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Aq = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Jw = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, jq = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Mq = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function $q() {
  return new RegExp(Mq, "u");
}
const Rq = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Zq = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Lq = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Fq = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Uq = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, xO = /^[A-Za-z0-9_-]*$/, Bq = /^\+[1-9]\d{6,14}$/, IO = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Vq = /* @__PURE__ */ new RegExp(`^${IO}$`);
function PO(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function qq(e) {
  return new RegExp(`^${PO(e)}$`);
}
function Hq(e) {
  const t = PO({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${IO}T(?:${r})$`);
}
const Wq = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Gq = /^-?\d+$/, OO = /^-?\d+(?:\.\d+)?$/, Kq = /^(?:true|false)$/i, Jq = /^[^A-Z]*$/, Xq = /^[^a-z]*$/, Kt = /* @__PURE__ */ ce("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), zO = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, EO = /* @__PURE__ */ ce("$ZodCheckLessThan", (e, t) => {
  Kt.init(e, t);
  const n = zO[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, a = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < a && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), TO = /* @__PURE__ */ ce("$ZodCheckGreaterThan", (e, t) => {
  Kt.init(e, t);
  const n = zO[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, a = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > a && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Yq = /* @__PURE__ */ ce("$ZodCheckMultipleOf", (e, t) => {
  Kt.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : nq(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Qq = /* @__PURE__ */ ce("$ZodCheckNumberFormat", (e, t) => {
  Kt.init(e, t), t.format = t.format || "float64";
  const n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = sq[t.format];
  e._zod.onattach.push((o) => {
    const d = o._zod.bag;
    d.format = t.format, d.minimum = i, d.maximum = a, n && (d.pattern = Gq);
  }), e._zod.check = (o) => {
    const d = o.value;
    if (n) {
      if (!Number.isInteger(d)) {
        o.issues.push({
          expected: r,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: d,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(d)) {
        d > 0 ? o.issues.push({
          input: d,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        }) : o.issues.push({
          input: d,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    d < i && o.issues.push({
      origin: "number",
      input: d,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), d > a && o.issues.push({
      origin: "number",
      input: d,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), eH = /* @__PURE__ */ ce("$ZodCheckMaxLength", (e, t) => {
  var n;
  Kt.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Rm(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = Lm(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), tH = /* @__PURE__ */ ce("$ZodCheckMinLength", (e, t) => {
  var n;
  Kt.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Rm(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = Lm(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), nH = /* @__PURE__ */ ce("$ZodCheckLengthEquals", (e, t) => {
  var n;
  Kt.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Rm(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, a = i.length;
    if (a === t.length)
      return;
    const o = Lm(i), d = a > t.length;
    r.issues.push({
      origin: o,
      ...d ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), jc = /* @__PURE__ */ ce("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  Kt.init(e, t), e._zod.onattach.push((i) => {
    const a = i._zod.bag;
    a.format = t.format, t.pattern && (a.patterns ?? (a.patterns = /* @__PURE__ */ new Set()), a.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), rH = /* @__PURE__ */ ce("$ZodCheckRegex", (e, t) => {
  jc.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), iH = /* @__PURE__ */ ce("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Jq), jc.init(e, t);
}), oH = /* @__PURE__ */ ce("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Xq), jc.init(e, t);
}), aH = /* @__PURE__ */ ce("$ZodCheckIncludes", (e, t) => {
  Kt.init(e, t);
  const n = qo(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const a = i._zod.bag;
    a.patterns ?? (a.patterns = /* @__PURE__ */ new Set()), a.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), sH = /* @__PURE__ */ ce("$ZodCheckStartsWith", (e, t) => {
  Kt.init(e, t);
  const n = new RegExp(`^${qo(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), lH = /* @__PURE__ */ ce("$ZodCheckEndsWith", (e, t) => {
  Kt.init(e, t);
  const n = new RegExp(`.*${qo(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), uH = /* @__PURE__ */ ce("$ZodCheckOverwrite", (e, t) => {
  Kt.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class cH {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((o) => o), i = Math.min(...r.map((o) => o.length - o.trimStart().length)), a = r.map((o) => o.slice(i)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of a)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this?.args, i = [...(this?.content ?? [""]).map((a) => `  ${a}`)];
    return new t(...n, i.join(`
`));
  }
}
const dH = {
  major: 4,
  minor: 3,
  patch: 6
}, ft = /* @__PURE__ */ ce("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = dH;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const i of r)
    for (const a of i._zod.onattach)
      a(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (o, d, u) => {
      let l = xo(o), c;
      for (const f of d) {
        if (f._zod.def.when) {
          if (!f._zod.def.when(o))
            continue;
        } else if (l)
          continue;
        const s = o.issues.length, h = f._zod.check(o);
        if (h instanceof Promise && u?.async === !1)
          throw new No();
        if (c || h instanceof Promise)
          c = (c ?? Promise.resolve()).then(async () => {
            await h, o.issues.length !== s && (l || (l = xo(o, s)));
          });
        else {
          if (o.issues.length === s)
            continue;
          l || (l = xo(o, s));
        }
      }
      return c ? c.then(() => o) : o;
    }, a = (o, d, u) => {
      if (xo(o))
        return o.aborted = !0, o;
      const l = i(d, r, u);
      if (l instanceof Promise) {
        if (u.async === !1)
          throw new No();
        return l.then((c) => e._zod.parse(c, u));
      }
      return e._zod.parse(l, u);
    };
    e._zod.run = (o, d) => {
      if (d.skipChecks)
        return e._zod.parse(o, d);
      if (d.direction === "backward") {
        const l = e._zod.parse({ value: o.value, issues: [] }, { ...d, skipChecks: !0 });
        return l instanceof Promise ? l.then((c) => a(c, o, d)) : a(l, o, d);
      }
      const u = e._zod.parse(o, d);
      if (u instanceof Promise) {
        if (d.async === !1)
          throw new No();
        return u.then((l) => i(l, r, d));
      }
      return i(u, r, d);
    };
  }
  Je(e, "~standard", () => ({
    validate: (i) => {
      try {
        const a = yq(e, i);
        return a.success ? { value: a.data } : { issues: a.error?.issues };
      } catch {
        return vq(e, i).then((o) => o.success ? { value: o.data } : { issues: o.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Bm = /* @__PURE__ */ ce("$ZodString", (e, t) => {
  ft.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? Wq(e._zod.bag), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), lt = /* @__PURE__ */ ce("$ZodStringFormat", (e, t) => {
  jc.init(e, t), Bm.init(e, t);
}), fH = /* @__PURE__ */ ce("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Aq), lt.init(e, t);
}), hH = /* @__PURE__ */ ce("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Jw(r));
  } else
    t.pattern ?? (t.pattern = Jw());
  lt.init(e, t);
}), pH = /* @__PURE__ */ ce("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = jq), lt.init(e, t);
}), mH = /* @__PURE__ */ ce("$ZodURL", (e, t) => {
  lt.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), gH = /* @__PURE__ */ ce("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = $q()), lt.init(e, t);
}), yH = /* @__PURE__ */ ce("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Cq), lt.init(e, t);
}), vH = /* @__PURE__ */ ce("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Oq), lt.init(e, t);
}), bH = /* @__PURE__ */ ce("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = zq), lt.init(e, t);
}), _H = /* @__PURE__ */ ce("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Eq), lt.init(e, t);
}), wH = /* @__PURE__ */ ce("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = Tq), lt.init(e, t);
}), kH = /* @__PURE__ */ ce("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Nq), lt.init(e, t);
}), SH = /* @__PURE__ */ ce("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Hq(t)), lt.init(e, t);
}), xH = /* @__PURE__ */ ce("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Vq), lt.init(e, t);
}), IH = /* @__PURE__ */ ce("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = qq(t)), lt.init(e, t);
}), PH = /* @__PURE__ */ ce("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Dq), lt.init(e, t);
}), OH = /* @__PURE__ */ ce("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Rq), lt.init(e, t), e._zod.bag.format = "ipv4";
}), zH = /* @__PURE__ */ ce("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Zq), lt.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), EH = /* @__PURE__ */ ce("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Lq), lt.init(e, t);
}), TH = /* @__PURE__ */ ce("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Fq), lt.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, a] = r;
      if (!a)
        throw new Error();
      const o = Number(a);
      if (`${o}` !== a)
        throw new Error();
      if (o < 0 || o > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function NO(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const NH = /* @__PURE__ */ ce("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Uq), lt.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    NO(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function CH(e) {
  if (!xO.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return NO(n);
}
const DH = /* @__PURE__ */ ce("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = xO), lt.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    CH(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), AH = /* @__PURE__ */ ce("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Bq), lt.init(e, t);
});
function jH(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const MH = /* @__PURE__ */ ce("$ZodJWT", (e, t) => {
  lt.init(e, t), e._zod.check = (n) => {
    jH(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), CO = /* @__PURE__ */ ce("$ZodNumber", (e, t) => {
  ft.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? OO, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...a ? { received: a } : {}
    }), n;
  };
}), $H = /* @__PURE__ */ ce("$ZodNumberFormat", (e, t) => {
  Qq.init(e, t), CO.init(e, t);
}), RH = /* @__PURE__ */ ce("$ZodBoolean", (e, t) => {
  ft.init(e, t), e._zod.pattern = Kq, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), ZH = /* @__PURE__ */ ce("$ZodUnknown", (e, t) => {
  ft.init(e, t), e._zod.parse = (n) => n;
}), LH = /* @__PURE__ */ ce("$ZodNever", (e, t) => {
  ft.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function Xw(e, t, n) {
  e.issues.length && t.issues.push(...Io(n, e.issues)), t.value[n] = e.value;
}
const FH = /* @__PURE__ */ ce("$ZodArray", (e, t) => {
  ft.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const a = [];
    for (let o = 0; o < i.length; o++) {
      const d = i[o], u = t.element._zod.run({
        value: d,
        issues: []
      }, r);
      u instanceof Promise ? a.push(u.then((l) => Xw(l, n, o))) : Xw(u, n, o);
    }
    return a.length ? Promise.all(a).then(() => n) : n;
  };
});
function Wu(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...Io(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function DO(e) {
  const t = Object.keys(e.shape);
  for (const r of t)
    if (!e.shape?.[r]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${r}": expected a Zod schema`);
  const n = aq(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function AO(e, t, n, r, i, a) {
  const o = [], d = i.keySet, u = i.catchall._zod, l = u.def.type, c = u.optout === "optional";
  for (const f in t) {
    if (d.has(f))
      continue;
    if (l === "never") {
      o.push(f);
      continue;
    }
    const s = u.run({ value: t[f], issues: [] }, r);
    s instanceof Promise ? e.push(s.then((h) => Wu(h, n, f, t, c))) : Wu(s, n, f, t, c);
  }
  return o.length && n.issues.push({
    code: "unrecognized_keys",
    keys: o,
    input: t,
    inst: a
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const UH = /* @__PURE__ */ ce("$ZodObject", (e, t) => {
  if (ft.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const d = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const u = { ...d };
        return Object.defineProperty(t, "shape", {
          value: u
        }), u;
      }
    });
  }
  const r = Cc(() => DO(t));
  Je(e._zod, "propValues", () => {
    const d = t.shape, u = {};
    for (const l in d) {
      const c = d[l]._zod;
      if (c.values) {
        u[l] ?? (u[l] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          u[l].add(f);
      }
    }
    return u;
  });
  const i = tl, a = t.catchall;
  let o;
  e._zod.parse = (d, u) => {
    o ?? (o = r.value);
    const l = d.value;
    if (!i(l))
      return d.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), d;
    d.value = {};
    const c = [], f = o.shape;
    for (const s of o.keys) {
      const h = f[s], p = h._zod.optout === "optional", m = h._zod.run({ value: l[s], issues: [] }, u);
      m instanceof Promise ? c.push(m.then((y) => Wu(y, d, s, l, p))) : Wu(m, d, s, l, p);
    }
    return a ? AO(c, l, d, u, r.value, e) : c.length ? Promise.all(c).then(() => d) : d;
  };
}), BH = /* @__PURE__ */ ce("$ZodObjectJIT", (e, t) => {
  UH.init(e, t);
  const n = e._zod.parse, r = Cc(() => DO(t)), i = (s) => {
    const h = new cH(["shape", "payload", "ctx"]), p = r.value, m = (_) => {
      const g = Kw(_);
      return `shape[${g}]._zod.run({ value: input[${g}], issues: [] }, ctx)`;
    };
    h.write("const input = payload.value;");
    const y = /* @__PURE__ */ Object.create(null);
    let w = 0;
    for (const _ of p.keys)
      y[_] = `key_${w++}`;
    h.write("const newResult = {};");
    for (const _ of p.keys) {
      const g = y[_], O = Kw(_), E = s[_]?._zod?.optout === "optional";
      h.write(`const ${g} = ${m(_)};`), E ? h.write(`
        if (${g}.issues.length) {
          if (${O} in input) {
            payload.issues = payload.issues.concat(${g}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${O}, ...iss.path] : [${O}]
            })));
          }
        }
        
        if (${g}.value === undefined) {
          if (${O} in input) {
            newResult[${O}] = undefined;
          }
        } else {
          newResult[${O}] = ${g}.value;
        }
        
      `) : h.write(`
        if (${g}.issues.length) {
          payload.issues = payload.issues.concat(${g}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${O}, ...iss.path] : [${O}]
          })));
        }
        
        if (${g}.value === undefined) {
          if (${O} in input) {
            newResult[${O}] = undefined;
          }
        } else {
          newResult[${O}] = ${g}.value;
        }
        
      `);
    }
    h.write("payload.value = newResult;"), h.write("return payload;");
    const b = h.compile();
    return (_, g) => b(s, _, g);
  };
  let a;
  const o = tl, d = !yO.jitless, l = d && iq.value, c = t.catchall;
  let f;
  e._zod.parse = (s, h) => {
    f ?? (f = r.value);
    const p = s.value;
    return o(p) ? d && l && h?.async === !1 && h.jitless !== !0 ? (a || (a = i(t.shape)), s = a(s, h), c ? AO([], p, s, h, f, e) : s) : n(s, h) : (s.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), s);
  };
});
function Yw(e, t, n, r) {
  for (const a of e)
    if (a.issues.length === 0)
      return t.value = a.value, t;
  const i = e.filter((a) => !xo(a));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((a) => a.issues.map((o) => Or(o, r, Pr())))
  }), t);
}
const jO = /* @__PURE__ */ ce("$ZodUnion", (e, t) => {
  ft.init(e, t), Je(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), Je(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), Je(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), Je(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((a) => a._zod.pattern);
      return new RegExp(`^(${i.map((a) => Zm(a.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, a) => {
    if (n)
      return r(i, a);
    let o = !1;
    const d = [];
    for (const u of t.options) {
      const l = u._zod.run({
        value: i.value,
        issues: []
      }, a);
      if (l instanceof Promise)
        d.push(l), o = !0;
      else {
        if (l.issues.length === 0)
          return l;
        d.push(l);
      }
    }
    return o ? Promise.all(d).then((u) => Yw(u, i, e, a)) : Yw(d, i, e, a);
  };
}), VH = /* @__PURE__ */ ce("$ZodDiscriminatedUnion", (e, t) => {
  t.inclusive = !1, jO.init(e, t);
  const n = e._zod.parse;
  Je(e._zod, "propValues", () => {
    const i = {};
    for (const a of t.options) {
      const o = a._zod.propValues;
      if (!o || Object.keys(o).length === 0)
        throw new Error(`Invalid discriminated union option at index "${t.options.indexOf(a)}"`);
      for (const [d, u] of Object.entries(o)) {
        i[d] || (i[d] = /* @__PURE__ */ new Set());
        for (const l of u)
          i[d].add(l);
      }
    }
    return i;
  });
  const r = Cc(() => {
    const i = t.options, a = /* @__PURE__ */ new Map();
    for (const o of i) {
      const d = o._zod.propValues?.[t.discriminator];
      if (!d || d.size === 0)
        throw new Error(`Invalid discriminated union option at index "${t.options.indexOf(o)}"`);
      for (const u of d) {
        if (a.has(u))
          throw new Error(`Duplicate discriminator value "${String(u)}"`);
        a.set(u, o);
      }
    }
    return a;
  });
  e._zod.parse = (i, a) => {
    const o = i.value;
    if (!tl(o))
      return i.issues.push({
        code: "invalid_type",
        expected: "object",
        input: o,
        inst: e
      }), i;
    const d = r.value.get(o?.[t.discriminator]);
    return d ? d._zod.run(i, a) : t.unionFallback ? n(i, a) : (i.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: t.discriminator,
      input: o,
      path: [t.discriminator],
      inst: e
    }), i);
  };
}), qH = /* @__PURE__ */ ce("$ZodIntersection", (e, t) => {
  ft.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, a = t.left._zod.run({ value: i, issues: [] }, r), o = t.right._zod.run({ value: i, issues: [] }, r);
    return a instanceof Promise || o instanceof Promise ? Promise.all([a, o]).then(([u, l]) => Qw(n, u, l)) : Qw(n, a, o);
  };
});
function ep(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Vo(e) && Vo(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((a) => n.indexOf(a) !== -1), i = { ...e, ...t };
    for (const a of r) {
      const o = ep(e[a], t[a]);
      if (!o.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...o.mergeErrorPath]
        };
      i[a] = o.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], a = t[r], o = ep(i, a);
      if (!o.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...o.mergeErrorPath]
        };
      n.push(o.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Qw(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const d of t.issues)
    if (d.code === "unrecognized_keys") {
      i ?? (i = d);
      for (const u of d.keys)
        r.has(u) || r.set(u, {}), r.get(u).l = !0;
    } else
      e.issues.push(d);
  for (const d of n.issues)
    if (d.code === "unrecognized_keys")
      for (const u of d.keys)
        r.has(u) || r.set(u, {}), r.get(u).r = !0;
    else
      e.issues.push(d);
  const a = [...r].filter(([, d]) => d.l && d.r).map(([d]) => d);
  if (a.length && i && e.issues.push({ ...i, keys: a }), xo(e))
    return e;
  const o = ep(t.value, n.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const HH = /* @__PURE__ */ ce("$ZodRecord", (e, t) => {
  ft.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Vo(i))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    const a = [], o = t.keyType._zod.values;
    if (o) {
      n.value = {};
      const d = /* @__PURE__ */ new Set();
      for (const l of o)
        if (typeof l == "string" || typeof l == "number" || typeof l == "symbol") {
          d.add(typeof l == "number" ? l.toString() : l);
          const c = t.valueType._zod.run({ value: i[l], issues: [] }, r);
          c instanceof Promise ? a.push(c.then((f) => {
            f.issues.length && n.issues.push(...Io(l, f.issues)), n.value[l] = f.value;
          })) : (c.issues.length && n.issues.push(...Io(l, c.issues)), n.value[l] = c.value);
        }
      let u;
      for (const l in i)
        d.has(l) || (u = u ?? [], u.push(l));
      u && u.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: u
      });
    } else {
      n.value = {};
      for (const d of Reflect.ownKeys(i)) {
        if (d === "__proto__")
          continue;
        let u = t.keyType._zod.run({ value: d, issues: [] }, r);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof d == "string" && OO.test(d) && u.issues.length) {
          const f = t.keyType._zod.run({ value: Number(d), issues: [] }, r);
          if (f instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          f.issues.length === 0 && (u = f);
        }
        if (u.issues.length) {
          t.mode === "loose" ? n.value[d] = i[d] : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((f) => Or(f, r, Pr())),
            input: d,
            path: [d],
            inst: e
          });
          continue;
        }
        const c = t.valueType._zod.run({ value: i[d], issues: [] }, r);
        c instanceof Promise ? a.push(c.then((f) => {
          f.issues.length && n.issues.push(...Io(d, f.issues)), n.value[u.value] = f.value;
        })) : (c.issues.length && n.issues.push(...Io(d, c.issues)), n.value[u.value] = c.value);
      }
    }
    return a.length ? Promise.all(a).then(() => n) : n;
  };
}), WH = /* @__PURE__ */ ce("$ZodEnum", (e, t) => {
  ft.init(e, t);
  const n = vO(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => oq.has(typeof i)).map((i) => typeof i == "string" ? qo(i) : i.toString()).join("|")})$`), e._zod.parse = (i, a) => {
    const o = i.value;
    return r.has(o) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: o,
      inst: e
    }), i;
  };
}), GH = /* @__PURE__ */ ce("$ZodLiteral", (e, t) => {
  if (ft.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${t.values.map((r) => typeof r == "string" ? qo(r) : r ? qo(r.toString()) : String(r)).join("|")})$`), e._zod.parse = (r, i) => {
    const a = r.value;
    return n.has(a) || r.issues.push({
      code: "invalid_value",
      values: t.values,
      input: a,
      inst: e
    }), r;
  };
}), KH = /* @__PURE__ */ ce("$ZodTransform", (e, t) => {
  ft.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new gO(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new No();
    return n.value = i, n;
  };
});
function e0(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const MO = /* @__PURE__ */ ce("$ZodOptional", (e, t) => {
  ft.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Je(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Je(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Zm(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((a) => e0(a, n.value)) : e0(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), JH = /* @__PURE__ */ ce("$ZodExactOptional", (e, t) => {
  MO.init(e, t), Je(e._zod, "values", () => t.innerType._zod.values), Je(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), XH = /* @__PURE__ */ ce("$ZodNullable", (e, t) => {
  ft.init(e, t), Je(e._zod, "optin", () => t.innerType._zod.optin), Je(e._zod, "optout", () => t.innerType._zod.optout), Je(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Zm(n.source)}|null)$`) : void 0;
  }), Je(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), YH = /* @__PURE__ */ ce("$ZodDefault", (e, t) => {
  ft.init(e, t), e._zod.optin = "optional", Je(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => t0(a, t)) : t0(i, t);
  };
});
function t0(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const QH = /* @__PURE__ */ ce("$ZodPrefault", (e, t) => {
  ft.init(e, t), e._zod.optin = "optional", Je(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), eW = /* @__PURE__ */ ce("$ZodNonOptional", (e, t) => {
  ft.init(e, t), Je(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => n0(a, e)) : n0(i, e);
  };
});
function n0(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const tW = /* @__PURE__ */ ce("$ZodCatch", (e, t) => {
  ft.init(e, t), Je(e._zod, "optin", () => t.innerType._zod.optin), Je(e._zod, "optout", () => t.innerType._zod.optout), Je(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => (n.value = a.value, a.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: a.issues.map((o) => Or(o, r, Pr()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((a) => Or(a, r, Pr()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), nW = /* @__PURE__ */ ce("$ZodPipe", (e, t) => {
  ft.init(e, t), Je(e._zod, "values", () => t.in._zod.values), Je(e._zod, "optin", () => t.in._zod.optin), Je(e._zod, "optout", () => t.out._zod.optout), Je(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const a = t.out._zod.run(n, r);
      return a instanceof Promise ? a.then((o) => Jl(o, t.in, r)) : Jl(a, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => Jl(a, t.out, r)) : Jl(i, t.out, r);
  };
});
function Jl(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const rW = /* @__PURE__ */ ce("$ZodReadonly", (e, t) => {
  ft.init(e, t), Je(e._zod, "propValues", () => t.innerType._zod.propValues), Je(e._zod, "values", () => t.innerType._zod.values), Je(e._zod, "optin", () => t.innerType?._zod?.optin), Je(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(r0) : r0(i);
  };
});
function r0(e) {
  return e.value = Object.freeze(e.value), e;
}
const iW = /* @__PURE__ */ ce("$ZodCustom", (e, t) => {
  Kt.init(e, t), ft.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((a) => i0(a, n, r, e));
    i0(i, n, r, e);
  };
});
function i0(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(nl(i));
  }
}
var o0;
class oW {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function aW() {
  return new oW();
}
(o0 = globalThis).__zod_globalRegistry ?? (o0.__zod_globalRegistry = aW());
const Ts = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function sW(e, t) {
  return new e({
    type: "string",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lW(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function a0(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hW(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pW(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mW(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gW(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yW(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vW(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bW(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _W(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function wW(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kW(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function SW(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xW(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function IW(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function PW(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function OW(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zW(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function EW(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function TW(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function NW(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function CW(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function DW(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function AW(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jW(e, t) {
  return new e({
    type: "boolean",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function MW(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function $W(e, t) {
  return new e({
    type: "never",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function s0(e, t) {
  return new EO({
    check: "less_than",
    ...Oe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function qf(e, t) {
  return new EO({
    check: "less_than",
    ...Oe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function l0(e, t) {
  return new TO({
    check: "greater_than",
    ...Oe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Hf(e, t) {
  return new TO({
    check: "greater_than",
    ...Oe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function u0(e, t) {
  return new Yq({
    check: "multiple_of",
    ...Oe(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function $O(e, t) {
  return new eH({
    check: "max_length",
    ...Oe(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Gu(e, t) {
  return new tH({
    check: "min_length",
    ...Oe(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function RO(e, t) {
  return new nH({
    check: "length_equals",
    ...Oe(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function RW(e, t) {
  return new rH({
    check: "string_format",
    format: "regex",
    ...Oe(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function ZW(e) {
  return new iH({
    check: "string_format",
    format: "lowercase",
    ...Oe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function LW(e) {
  return new oH({
    check: "string_format",
    format: "uppercase",
    ...Oe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function FW(e, t) {
  return new aH({
    check: "string_format",
    format: "includes",
    ...Oe(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function UW(e, t) {
  return new sH({
    check: "string_format",
    format: "starts_with",
    ...Oe(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function BW(e, t) {
  return new lH({
    check: "string_format",
    format: "ends_with",
    ...Oe(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function ta(e) {
  return new uH({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function VW(e) {
  return /* @__PURE__ */ ta((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function qW() {
  return /* @__PURE__ */ ta((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function HW() {
  return /* @__PURE__ */ ta((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function WW() {
  return /* @__PURE__ */ ta((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function GW() {
  return /* @__PURE__ */ ta((e) => rq(e));
}
// @__NO_SIDE_EFFECTS__
function KW(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Oe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function JW(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Oe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function XW(e) {
  const t = /* @__PURE__ */ YW((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(nl(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(nl(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function YW(e, t) {
  const n = new Kt({
    check: "custom",
    ...Oe(t)
  });
  return n._zod.check = e, n;
}
function ZO(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? Ts,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function wt(e, t, n = { path: [], schemaPath: [] }) {
  var r;
  const i = e._zod.def, a = t.seen.get(e);
  if (a)
    return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
  const o = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, o);
  const d = e._zod.toJSONSchema?.();
  if (d)
    o.schema = d;
  else {
    const c = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, o.schema, c);
    else {
      const s = o.schema, h = t.processors[i.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      h(e, t, s, c);
    }
    const f = e._zod.parent;
    f && (o.ref || (o.ref = f), wt(f, t, c), t.seen.get(f).isParent = !0);
  }
  const u = t.metadataRegistry.get(e);
  return u && Object.assign(o.schema, u), t.io === "input" && Mt(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && o.schema._prefault && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function LO(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = /* @__PURE__ */ new Map();
  for (const o of e.seen.entries()) {
    const d = e.metadataRegistry.get(o[0])?.id;
    if (d) {
      const u = r.get(d);
      if (u && u !== o[0])
        throw new Error(`Duplicate schema id "${d}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      r.set(d, o[0]);
    }
  }
  const i = (o) => {
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const f = e.external.registry.get(o[0])?.id, s = e.external.uri ?? ((p) => p);
      if (f)
        return { ref: s(f) };
      const h = o[1].defId ?? o[1].schema.id ?? `schema${e.counter++}`;
      return o[1].defId = h, { defId: h, ref: `${s("__shared")}#/${d}/${h}` };
    }
    if (o[1] === n)
      return { ref: "#" };
    const l = `#/${d}/`, c = o[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: c, ref: l + c };
  }, a = (o) => {
    if (o[1].schema.$ref)
      return;
    const d = o[1], { ref: u, defId: l } = i(o);
    d.def = { ...d.schema }, l && (d.defId = l);
    const c = d.schema;
    for (const f in c)
      delete c[f];
    c.$ref = u;
  };
  if (e.cycles === "throw")
    for (const o of e.seen.entries()) {
      const d = o[1];
      if (d.cycle)
        throw new Error(`Cycle detected: #/${d.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const o of e.seen.entries()) {
    const d = o[1];
    if (t === o[0]) {
      a(o);
      continue;
    }
    if (e.external) {
      const l = e.external.registry.get(o[0])?.id;
      if (t !== o[0] && l) {
        a(o);
        continue;
      }
    }
    if (e.metadataRegistry.get(o[0])?.id) {
      a(o);
      continue;
    }
    if (d.cycle) {
      a(o);
      continue;
    }
    if (d.count > 1 && e.reused === "ref") {
      a(o);
      continue;
    }
  }
}
function FO(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = (o) => {
    const d = e.seen.get(o);
    if (d.ref === null)
      return;
    const u = d.def ?? d.schema, l = { ...u }, c = d.ref;
    if (d.ref = null, c) {
      r(c);
      const s = e.seen.get(c), h = s.schema;
      if (h.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (u.allOf = u.allOf ?? [], u.allOf.push(h)) : Object.assign(u, h), Object.assign(u, l), o._zod.parent === c)
        for (const m in u)
          m === "$ref" || m === "allOf" || m in l || delete u[m];
      if (h.$ref && s.def)
        for (const m in u)
          m === "$ref" || m === "allOf" || m in s.def && JSON.stringify(u[m]) === JSON.stringify(s.def[m]) && delete u[m];
    }
    const f = o._zod.parent;
    if (f && f !== c) {
      r(f);
      const s = e.seen.get(f);
      if (s?.schema.$ref && (u.$ref = s.schema.$ref, s.def))
        for (const h in u)
          h === "$ref" || h === "allOf" || h in s.def && JSON.stringify(u[h]) === JSON.stringify(s.def[h]) && delete u[h];
    }
    e.override({
      zodSchema: o,
      jsonSchema: u,
      path: d.path ?? []
    });
  };
  for (const o of [...e.seen.entries()].reverse())
    r(o[0]);
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
    const o = e.external.registry.get(t)?.id;
    if (!o)
      throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(o);
  }
  Object.assign(i, n.def ?? n.schema);
  const a = e.external?.defs ?? {};
  for (const o of e.seen.entries()) {
    const d = o[1];
    d.def && d.defId && (a[d.defId] = d.def);
  }
  e.external || Object.keys(a).length > 0 && (e.target === "draft-2020-12" ? i.$defs = a : i.definitions = a);
  try {
    const o = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(o, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Ku(t, "input", e.processors),
          output: Ku(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), o;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Mt(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Mt(r.element, n);
  if (r.type === "set")
    return Mt(r.valueType, n);
  if (r.type === "lazy")
    return Mt(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return Mt(r.innerType, n);
  if (r.type === "intersection")
    return Mt(r.left, n) || Mt(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Mt(r.keyType, n) || Mt(r.valueType, n);
  if (r.type === "pipe")
    return Mt(r.in, n) || Mt(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (Mt(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (Mt(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (Mt(i, n))
        return !0;
    return !!(r.rest && Mt(r.rest, n));
  }
  return !1;
}
const QW = (e, t = {}) => (n) => {
  const r = ZO({ ...n, processors: t });
  return wt(e, r), LO(r, e), FO(r, e);
}, Ku = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: a } = r ?? {}, o = ZO({ ...i ?? {}, target: a, io: t, processors: n });
  return wt(e, o), LO(o, e), FO(o, e);
}, e8 = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, t8 = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: a, maximum: o, format: d, patterns: u, contentEncoding: l } = e._zod.bag;
  if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), d && (i.format = e8[d] ?? d, i.format === "" && delete i.format, d === "time" && delete i.format), l && (i.contentEncoding = l), u && u.size > 0) {
    const c = [...u];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, n8 = (e, t, n, r) => {
  const i = n, { minimum: a, maximum: o, format: d, multipleOf: u, exclusiveMaximum: l, exclusiveMinimum: c } = e._zod.bag;
  typeof d == "string" && d.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof a == "number" && (i.minimum = a, typeof c == "number" && t.target !== "draft-04" && (c >= a ? delete i.minimum : delete i.exclusiveMinimum)), typeof l == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = l, i.exclusiveMaximum = !0) : i.exclusiveMaximum = l), typeof o == "number" && (i.maximum = o, typeof l == "number" && t.target !== "draft-04" && (l <= o ? delete i.maximum : delete i.exclusiveMaximum)), typeof u == "number" && (i.multipleOf = u);
}, r8 = (e, t, n, r) => {
  n.type = "boolean";
}, i8 = (e, t, n, r) => {
  n.not = {};
}, o8 = (e, t, n, r) => {
}, a8 = (e, t, n, r) => {
  const i = e._zod.def, a = vO(i.entries);
  a.every((o) => typeof o == "number") && (n.type = "number"), a.every((o) => typeof o == "string") && (n.type = "string"), n.enum = a;
}, s8 = (e, t, n, r) => {
  const i = e._zod.def, a = [];
  for (const o of i.values)
    if (o === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof o == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      a.push(Number(o));
    } else
      a.push(o);
  if (a.length !== 0) if (a.length === 1) {
    const o = a[0];
    n.type = o === null ? "null" : typeof o, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [o] : n.const = o;
  } else
    a.every((o) => typeof o == "number") && (n.type = "number"), a.every((o) => typeof o == "string") && (n.type = "string"), a.every((o) => typeof o == "boolean") && (n.type = "boolean"), a.every((o) => o === null) && (n.type = "null"), n.enum = a;
}, l8 = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, u8 = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, c8 = (e, t, n, r) => {
  const i = n, a = e._zod.def, { minimum: o, maximum: d } = e._zod.bag;
  typeof o == "number" && (i.minItems = o), typeof d == "number" && (i.maxItems = d), i.type = "array", i.items = wt(a.element, t, { ...r, path: [...r.path, "items"] });
}, d8 = (e, t, n, r) => {
  const i = n, a = e._zod.def;
  i.type = "object", i.properties = {};
  const o = a.shape;
  for (const l in o)
    i.properties[l] = wt(o[l], t, {
      ...r,
      path: [...r.path, "properties", l]
    });
  const d = new Set(Object.keys(o)), u = new Set([...d].filter((l) => {
    const c = a.shape[l]._zod;
    return t.io === "input" ? c.optin === void 0 : c.optout === void 0;
  }));
  u.size > 0 && (i.required = Array.from(u)), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = wt(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, f8 = (e, t, n, r) => {
  const i = e._zod.def, a = i.inclusive === !1, o = i.options.map((d, u) => wt(d, t, {
    ...r,
    path: [...r.path, a ? "oneOf" : "anyOf", u]
  }));
  a ? n.oneOf = o : n.anyOf = o;
}, h8 = (e, t, n, r) => {
  const i = e._zod.def, a = wt(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), o = wt(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), d = (l) => "allOf" in l && Object.keys(l).length === 1, u = [
    ...d(a) ? a.allOf : [a],
    ...d(o) ? o.allOf : [o]
  ];
  n.allOf = u;
}, p8 = (e, t, n, r) => {
  const i = n, a = e._zod.def;
  i.type = "object";
  const o = a.keyType, u = o._zod.bag?.patterns;
  if (a.mode === "loose" && u && u.size > 0) {
    const c = wt(a.valueType, t, {
      ...r,
      path: [...r.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const f of u)
      i.patternProperties[f.source] = c;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = wt(a.keyType, t, {
      ...r,
      path: [...r.path, "propertyNames"]
    })), i.additionalProperties = wt(a.valueType, t, {
      ...r,
      path: [...r.path, "additionalProperties"]
    });
  const l = o._zod.values;
  if (l) {
    const c = [...l].filter((f) => typeof f == "string" || typeof f == "number");
    c.length > 0 && (i.required = c);
  }
}, m8 = (e, t, n, r) => {
  const i = e._zod.def, a = wt(i.innerType, t, r), o = t.seen.get(e);
  t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, g8 = (e, t, n, r) => {
  const i = e._zod.def;
  wt(i.innerType, t, r);
  const a = t.seen.get(e);
  a.ref = i.innerType;
}, y8 = (e, t, n, r) => {
  const i = e._zod.def;
  wt(i.innerType, t, r);
  const a = t.seen.get(e);
  a.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, v8 = (e, t, n, r) => {
  const i = e._zod.def;
  wt(i.innerType, t, r);
  const a = t.seen.get(e);
  a.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, b8 = (e, t, n, r) => {
  const i = e._zod.def;
  wt(i.innerType, t, r);
  const a = t.seen.get(e);
  a.ref = i.innerType;
  let o;
  try {
    o = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = o;
}, _8 = (e, t, n, r) => {
  const i = e._zod.def, a = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  wt(a, t, r);
  const o = t.seen.get(e);
  o.ref = a;
}, w8 = (e, t, n, r) => {
  const i = e._zod.def;
  wt(i.innerType, t, r);
  const a = t.seen.get(e);
  a.ref = i.innerType, n.readOnly = !0;
}, UO = (e, t, n, r) => {
  const i = e._zod.def;
  wt(i.innerType, t, r);
  const a = t.seen.get(e);
  a.ref = i.innerType;
}, k8 = /* @__PURE__ */ ce("ZodISODateTime", (e, t) => {
  SH.init(e, t), pt.init(e, t);
});
function S8(e) {
  return /* @__PURE__ */ EW(k8, e);
}
const x8 = /* @__PURE__ */ ce("ZodISODate", (e, t) => {
  xH.init(e, t), pt.init(e, t);
});
function I8(e) {
  return /* @__PURE__ */ TW(x8, e);
}
const P8 = /* @__PURE__ */ ce("ZodISOTime", (e, t) => {
  IH.init(e, t), pt.init(e, t);
});
function O8(e) {
  return /* @__PURE__ */ NW(P8, e);
}
const z8 = /* @__PURE__ */ ce("ZodISODuration", (e, t) => {
  PH.init(e, t), pt.init(e, t);
});
function E8(e) {
  return /* @__PURE__ */ CW(z8, e);
}
const T8 = (e, t) => {
  kO.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => gq(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => mq(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Qh, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Qh, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, fn = ce("ZodError", T8, {
  Parent: Error
}), N8 = /* @__PURE__ */ Fm(fn), C8 = /* @__PURE__ */ Um(fn), D8 = /* @__PURE__ */ Dc(fn), A8 = /* @__PURE__ */ Ac(fn), j8 = /* @__PURE__ */ bq(fn), M8 = /* @__PURE__ */ _q(fn), $8 = /* @__PURE__ */ wq(fn), R8 = /* @__PURE__ */ kq(fn), Z8 = /* @__PURE__ */ Sq(fn), L8 = /* @__PURE__ */ xq(fn), F8 = /* @__PURE__ */ Iq(fn), U8 = /* @__PURE__ */ Pq(fn), ht = /* @__PURE__ */ ce("ZodType", (e, t) => (ft.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: Ku(e, "input"),
    output: Ku(e, "output")
  }
}), e.toJSONSchema = QW(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(Nr(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => Cr(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => N8(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => D8(e, n, r), e.parseAsync = async (n, r) => C8(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => A8(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => j8(e, n, r), e.decode = (n, r) => M8(e, n, r), e.encodeAsync = async (n, r) => $8(e, n, r), e.decodeAsync = async (n, r) => R8(e, n, r), e.safeEncode = (n, r) => Z8(e, n, r), e.safeDecode = (n, r) => L8(e, n, r), e.safeEncodeAsync = async (n, r) => F8(e, n, r), e.safeDecodeAsync = async (n, r) => U8(e, n, r), e.refine = (n, r) => e.check($7(n, r)), e.superRefine = (n) => e.check(R7(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ ta(n)), e.optional = () => f0(e), e.exactOptional = () => x7(e), e.nullable = () => h0(e), e.nullish = () => f0(h0(e)), e.nonoptional = (n) => T7(e, n), e.array = () => Ct(e), e.or = (n) => p7([e, n]), e.and = (n) => v7(e, n), e.transform = (n) => p0(e, k7(n)), e.default = (n) => O7(e, n), e.prefault = (n) => E7(e, n), e.catch = (n) => C7(e, n), e.pipe = (n) => p0(e, n), e.readonly = () => j7(e), e.describe = (n) => {
  const r = e.clone();
  return Ts.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    return Ts.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Ts.get(e);
  const r = e.clone();
  return Ts.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), BO = /* @__PURE__ */ ce("_ZodString", (e, t) => {
  Bm.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (r, i, a) => t8(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ RW(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ FW(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ UW(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ BW(...r)), e.min = (...r) => e.check(/* @__PURE__ */ Gu(...r)), e.max = (...r) => e.check(/* @__PURE__ */ $O(...r)), e.length = (...r) => e.check(/* @__PURE__ */ RO(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ Gu(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ ZW(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ LW(r)), e.trim = () => e.check(/* @__PURE__ */ qW()), e.normalize = (...r) => e.check(/* @__PURE__ */ VW(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ HW()), e.toUpperCase = () => e.check(/* @__PURE__ */ WW()), e.slugify = () => e.check(/* @__PURE__ */ GW());
}), B8 = /* @__PURE__ */ ce("ZodString", (e, t) => {
  Bm.init(e, t), BO.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ lW(V8, n)), e.url = (n) => e.check(/* @__PURE__ */ hW(q8, n)), e.jwt = (n) => e.check(/* @__PURE__ */ zW(a7, n)), e.emoji = (n) => e.check(/* @__PURE__ */ pW(H8, n)), e.guid = (n) => e.check(/* @__PURE__ */ a0(c0, n)), e.uuid = (n) => e.check(/* @__PURE__ */ uW(Xl, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ cW(Xl, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ dW(Xl, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ fW(Xl, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ mW(W8, n)), e.guid = (n) => e.check(/* @__PURE__ */ a0(c0, n)), e.cuid = (n) => e.check(/* @__PURE__ */ gW(G8, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ yW(K8, n)), e.ulid = (n) => e.check(/* @__PURE__ */ vW(J8, n)), e.base64 = (n) => e.check(/* @__PURE__ */ IW(r7, n)), e.base64url = (n) => e.check(/* @__PURE__ */ PW(i7, n)), e.xid = (n) => e.check(/* @__PURE__ */ bW(X8, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ _W(Y8, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ wW(Q8, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ kW(e7, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ SW(t7, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ xW(n7, n)), e.e164 = (n) => e.check(/* @__PURE__ */ OW(o7, n)), e.datetime = (n) => e.check(S8(n)), e.date = (n) => e.check(I8(n)), e.time = (n) => e.check(O8(n)), e.duration = (n) => e.check(E8(n));
});
function xe(e) {
  return /* @__PURE__ */ sW(B8, e);
}
const pt = /* @__PURE__ */ ce("ZodStringFormat", (e, t) => {
  lt.init(e, t), BO.init(e, t);
}), V8 = /* @__PURE__ */ ce("ZodEmail", (e, t) => {
  pH.init(e, t), pt.init(e, t);
}), c0 = /* @__PURE__ */ ce("ZodGUID", (e, t) => {
  fH.init(e, t), pt.init(e, t);
}), Xl = /* @__PURE__ */ ce("ZodUUID", (e, t) => {
  hH.init(e, t), pt.init(e, t);
}), q8 = /* @__PURE__ */ ce("ZodURL", (e, t) => {
  mH.init(e, t), pt.init(e, t);
}), H8 = /* @__PURE__ */ ce("ZodEmoji", (e, t) => {
  gH.init(e, t), pt.init(e, t);
}), W8 = /* @__PURE__ */ ce("ZodNanoID", (e, t) => {
  yH.init(e, t), pt.init(e, t);
}), G8 = /* @__PURE__ */ ce("ZodCUID", (e, t) => {
  vH.init(e, t), pt.init(e, t);
}), K8 = /* @__PURE__ */ ce("ZodCUID2", (e, t) => {
  bH.init(e, t), pt.init(e, t);
}), J8 = /* @__PURE__ */ ce("ZodULID", (e, t) => {
  _H.init(e, t), pt.init(e, t);
}), X8 = /* @__PURE__ */ ce("ZodXID", (e, t) => {
  wH.init(e, t), pt.init(e, t);
}), Y8 = /* @__PURE__ */ ce("ZodKSUID", (e, t) => {
  kH.init(e, t), pt.init(e, t);
}), Q8 = /* @__PURE__ */ ce("ZodIPv4", (e, t) => {
  OH.init(e, t), pt.init(e, t);
}), e7 = /* @__PURE__ */ ce("ZodIPv6", (e, t) => {
  zH.init(e, t), pt.init(e, t);
}), t7 = /* @__PURE__ */ ce("ZodCIDRv4", (e, t) => {
  EH.init(e, t), pt.init(e, t);
}), n7 = /* @__PURE__ */ ce("ZodCIDRv6", (e, t) => {
  TH.init(e, t), pt.init(e, t);
}), r7 = /* @__PURE__ */ ce("ZodBase64", (e, t) => {
  NH.init(e, t), pt.init(e, t);
}), i7 = /* @__PURE__ */ ce("ZodBase64URL", (e, t) => {
  DH.init(e, t), pt.init(e, t);
}), o7 = /* @__PURE__ */ ce("ZodE164", (e, t) => {
  AH.init(e, t), pt.init(e, t);
}), a7 = /* @__PURE__ */ ce("ZodJWT", (e, t) => {
  MH.init(e, t), pt.init(e, t);
}), VO = /* @__PURE__ */ ce("ZodNumber", (e, t) => {
  CO.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (r, i, a) => n8(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ l0(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ Hf(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ Hf(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ s0(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ qf(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ qf(r, i)), e.int = (r) => e.check(d0(r)), e.safe = (r) => e.check(d0(r)), e.positive = (r) => e.check(/* @__PURE__ */ l0(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ Hf(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ s0(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ qf(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ u0(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ u0(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function tn(e) {
  return /* @__PURE__ */ DW(VO, e);
}
const s7 = /* @__PURE__ */ ce("ZodNumberFormat", (e, t) => {
  $H.init(e, t), VO.init(e, t);
});
function d0(e) {
  return /* @__PURE__ */ AW(s7, e);
}
const l7 = /* @__PURE__ */ ce("ZodBoolean", (e, t) => {
  RH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => r8(e, n, r);
});
function On(e) {
  return /* @__PURE__ */ jW(l7, e);
}
const u7 = /* @__PURE__ */ ce("ZodUnknown", (e, t) => {
  ZH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => o8();
});
function tp() {
  return /* @__PURE__ */ MW(u7);
}
const c7 = /* @__PURE__ */ ce("ZodNever", (e, t) => {
  LH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => i8(e, n, r);
});
function d7(e) {
  return /* @__PURE__ */ $W(c7, e);
}
const f7 = /* @__PURE__ */ ce("ZodArray", (e, t) => {
  FH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => c8(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ Gu(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ Gu(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ $O(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ RO(n, r)), e.unwrap = () => e.element;
});
function Ct(e, t) {
  return /* @__PURE__ */ KW(f7, e, t);
}
const h7 = /* @__PURE__ */ ce("ZodObject", (e, t) => {
  BH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => d8(e, n, r, i), Je(e, "shape", () => t.shape), e.keyof = () => Lt(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: tp() }), e.loose = () => e.clone({ ...e._zod.def, catchall: tp() }), e.strict = () => e.clone({ ...e._zod.def, catchall: d7() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => cq(e, n), e.safeExtend = (n) => dq(e, n), e.merge = (n) => fq(e, n), e.pick = (n) => lq(e, n), e.omit = (n) => uq(e, n), e.partial = (...n) => hq(WO, e, n[0]), e.required = (...n) => pq(GO, e, n[0]);
});
function nt(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Oe(t)
  };
  return new h7(n);
}
const qO = /* @__PURE__ */ ce("ZodUnion", (e, t) => {
  jO.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => f8(e, n, r, i), e.options = t.options;
});
function p7(e, t) {
  return new qO({
    type: "union",
    options: e,
    ...Oe(t)
  });
}
const m7 = /* @__PURE__ */ ce("ZodDiscriminatedUnion", (e, t) => {
  qO.init(e, t), VH.init(e, t);
});
function g7(e, t, n) {
  return new m7({
    type: "union",
    options: t,
    discriminator: e,
    ...Oe(n)
  });
}
const y7 = /* @__PURE__ */ ce("ZodIntersection", (e, t) => {
  qH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => h8(e, n, r, i);
});
function v7(e, t) {
  return new y7({
    type: "intersection",
    left: e,
    right: t
  });
}
const b7 = /* @__PURE__ */ ce("ZodRecord", (e, t) => {
  HH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => p8(e, n, r, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function HO(e, t, n) {
  return new b7({
    type: "record",
    keyType: e,
    valueType: t,
    ...Oe(n)
  });
}
const np = /* @__PURE__ */ ce("ZodEnum", (e, t) => {
  WH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (r, i, a) => a8(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const a = {};
    for (const o of r)
      if (n.has(o))
        a[o] = t.entries[o];
      else
        throw new Error(`Key ${o} not found in enum`);
    return new np({
      ...t,
      checks: [],
      ...Oe(i),
      entries: a
    });
  }, e.exclude = (r, i) => {
    const a = { ...t.entries };
    for (const o of r)
      if (n.has(o))
        delete a[o];
      else
        throw new Error(`Key ${o} not found in enum`);
    return new np({
      ...t,
      checks: [],
      ...Oe(i),
      entries: a
    });
  };
});
function Lt(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new np({
    type: "enum",
    entries: n,
    ...Oe(t)
  });
}
const _7 = /* @__PURE__ */ ce("ZodLiteral", (e, t) => {
  GH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => s8(e, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function Yl(e, t) {
  return new _7({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...Oe(t)
  });
}
const w7 = /* @__PURE__ */ ce("ZodTransform", (e, t) => {
  KH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => u8(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new gO(e.constructor.name);
    n.addIssue = (a) => {
      if (typeof a == "string")
        n.issues.push(nl(a, n.value, t));
      else {
        const o = a;
        o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = e), n.issues.push(nl(o));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((a) => (n.value = a, n)) : (n.value = i, n);
  };
});
function k7(e) {
  return new w7({
    type: "transform",
    transform: e
  });
}
const WO = /* @__PURE__ */ ce("ZodOptional", (e, t) => {
  MO.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => UO(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function f0(e) {
  return new WO({
    type: "optional",
    innerType: e
  });
}
const S7 = /* @__PURE__ */ ce("ZodExactOptional", (e, t) => {
  JH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => UO(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function x7(e) {
  return new S7({
    type: "optional",
    innerType: e
  });
}
const I7 = /* @__PURE__ */ ce("ZodNullable", (e, t) => {
  XH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => m8(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function h0(e) {
  return new I7({
    type: "nullable",
    innerType: e
  });
}
const P7 = /* @__PURE__ */ ce("ZodDefault", (e, t) => {
  YH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => y8(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function O7(e, t) {
  return new P7({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : _O(t);
    }
  });
}
const z7 = /* @__PURE__ */ ce("ZodPrefault", (e, t) => {
  QH.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => v8(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function E7(e, t) {
  return new z7({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : _O(t);
    }
  });
}
const GO = /* @__PURE__ */ ce("ZodNonOptional", (e, t) => {
  eW.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => g8(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function T7(e, t) {
  return new GO({
    type: "nonoptional",
    innerType: e,
    ...Oe(t)
  });
}
const N7 = /* @__PURE__ */ ce("ZodCatch", (e, t) => {
  tW.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => b8(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function C7(e, t) {
  return new N7({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const D7 = /* @__PURE__ */ ce("ZodPipe", (e, t) => {
  nW.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => _8(e, n, r, i), e.in = t.in, e.out = t.out;
});
function p0(e, t) {
  return new D7({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const A7 = /* @__PURE__ */ ce("ZodReadonly", (e, t) => {
  rW.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => w8(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function j7(e) {
  return new A7({
    type: "readonly",
    innerType: e
  });
}
const M7 = /* @__PURE__ */ ce("ZodCustom", (e, t) => {
  iW.init(e, t), ht.init(e, t), e._zod.processJSONSchema = (n, r, i) => l8(e, n);
});
function $7(e, t = {}) {
  return /* @__PURE__ */ JW(M7, e, t);
}
function R7(e) {
  return /* @__PURE__ */ XW(e);
}
const Z7 = nt({
  kind: Lt(["agent", "tool", "web-search", "ref", "guardrail", "mcp-connection", "scorer"]),
  id: xe().optional(),
  name: xe().optional()
});
function L7(e) {
  return {
    ...e,
    markerEnd: void 0,
    style: {
      stroke: "var(--muted-foreground)",
      strokeWidth: 1.5,
      strokeDasharray: "2 4",
      opacity: 0.6
    },
    labelStyle: { ...e.labelStyle, fill: "var(--destructive)" }
  };
}
function F7(e) {
  return {
    ...e,
    style: {
      stroke: "var(--badge-yellow-foreground)",
      strokeWidth: 1.5,
      strokeDasharray: "1 4",
      opacity: 0.75
    }
  };
}
function KO(e, t, n, r) {
  const i = [];
  for (const a of e)
    switch (a.type) {
      case "handoff": {
        const o = Ta(a.id, a.source, a.target, {
          label: r("edge.handoff", "handoff"),
          variant: "handoff"
        });
        i.push({ ...o, type: "builder", sourceHandle: "handoff", data: { variant: "handoff" } });
        break;
      }
      case "uses-agent-as-tool": {
        const o = Ta(a.id, a.source, a.target, { label: r("edge.asTool", "as tool") });
        i.push({ ...o, type: "builder", sourceHandle: "uses", data: { variant: "default" } });
        break;
      }
      case "uses-tool": {
        const o = t.has(a.target), d = Ta(a.id, a.source, a.target, {
          label: o ? r("edge.denied", "denied") : r("edge.tool", "tool")
        });
        i.push({
          ...o ? L7(d) : d,
          type: "builder",
          sourceHandle: "uses",
          data: { variant: o ? "denied" : "default" }
        });
        break;
      }
      case "guards": {
        const o = Ta(a.id, a.source, a.target, {
          label: a.placement === "input" ? r("edge.input", "input") : r("edge.output", "output")
        }), d = Ge.guardsHandle(a.placement);
        i.push({ ...o, type: "builder", sourceHandle: d, data: { variant: "guards" } });
        break;
      }
      case "scores": {
        const o = Ta(a.id, a.source, a.target, { label: r("edge.scores", "scores") });
        i.push({
          ...F7(o),
          type: "builder",
          sourceHandle: "scores",
          data: { variant: "scores" }
        });
        break;
      }
    }
  return i.map((a) => ({ ...a, selected: a.id === n }));
}
function m0(e, t) {
  return e.source === e.target ? null : JO(e, t);
}
function JO(e, t) {
  if (!e.source || !e.target) return null;
  const n = e.sourceHandle;
  if (!Ge.isBuilderSourceHandle(n)) return null;
  const r = t.get(e.source), i = t.get(e.target);
  if (!r || !i || !(r.kind === "agent" && r.source === "inline")) return null;
  const a = Ge.resolveEdgeType(n, i.kind);
  return a ? { source: e.source, target: e.target, sourceHandle: n, type: a } : null;
}
function U7(e) {
  if (e.isValid !== !1 || !e.fromNode || !e.toNode) return null;
  const t = e.fromHandle?.type === "target";
  return {
    source: t ? e.toNode.id : e.fromNode.id,
    target: t ? e.fromNode.id : e.toNode.id,
    sourceHandle: (t ? e.toHandle?.id : e.fromHandle?.id) ?? null
  };
}
function B7(e, t, n, r, i) {
  const a = JO(e, t), o = a ? Ge.loopClosedBy(n, a.type, a.source, a.target) : void 0;
  if (!o) return;
  const d = (u) => {
    const l = t.get(u);
    return l ? r(l) : u;
  };
  return i(
    "canvas.loopRefused",
    "Not connected: this would let an agent invoke itself ({{loop}}).",
    {
      loop: Ge.describeLoop(o, d)
    }
  );
}
const V7 = [
  { id: "agents", type: "agent" },
  { id: "tools", type: "tool" },
  { id: "widgets", type: "widget" },
  { id: "connectors", type: "connector" },
  { id: "guardrails", type: "guardrail" },
  { id: "scorers", type: "scorer" }
];
function br(e, t) {
  return e.size === 0 || e.has(t);
}
function Lr(e, ...t) {
  return e ? t.some((n) => n?.toLowerCase().includes(e)) : !0;
}
function q7(e) {
  const { active: t, labels: n } = e, r = e.query.trim().toLowerCase(), i = br(t, "agents") && Lr(r, "agent", n?.agent), a = br(t, "guardrails") && Lr(r, "guardrail", n?.guardrail), o = br(t, "scorers") && Lr(r, "scorer", n?.scorer), d = br(t, "tools") && Lr(r, "web search", "web-search", n?.webSearch), u = e.isWidget ?? (() => !1), l = br(t, "widgets") && !r, c = e.tools.filter(
    (h) => br(t, u(h) ? "widgets" : "tools") && Lr(r, h.name, h.id)
  ), f = br(t, "agents") ? e.agents.filter((h) => Lr(r, h.name, h.id)) : [], s = br(t, "connectors") ? e.connectors.filter((h) => Lr(r, h.label, h.id, h.description)) : [];
  return XO({
    showAgentCreate: i,
    showGuardrailCreate: a,
    showScorerCreate: o,
    showWidgetCreate: l,
    showWebSearch: d,
    tools: c,
    agents: f,
    connectors: s
  });
}
function XO(e) {
  const t = !e.showAgentCreate && !e.showGuardrailCreate && !e.showScorerCreate && !e.showWidgetCreate && !e.showWebSearch && e.tools.length === 0 && e.agents.length === 0 && e.connectors.length === 0;
  return { ...e, empty: t };
}
function H7(e, t) {
  return XO({
    showAgentCreate: e.showAgentCreate && t.agent,
    showGuardrailCreate: e.showGuardrailCreate && t.guardrail,
    showScorerCreate: e.showScorerCreate && t.scorer,
    showWidgetCreate: e.showWidgetCreate && t.newWidget,
    showWebSearch: e.showWebSearch && t.webSearch,
    tools: e.tools.filter(t.tool),
    agents: t.agent ? e.agents : [],
    connectors: t.connectors ? e.connectors : []
  });
}
const YO = "application/x-agentic-node";
function W7(e, t) {
  switch (e) {
    case "agents":
      return t("palette.category.agents", "Agents");
    case "tools":
      return t("palette.category.tools", "Tools");
    case "widgets":
      return t("palette.category.widgets", "Widgets");
    case "connectors":
      return t("palette.category.connectors", "Connectors");
    case "guardrails":
      return t("palette.category.guardrails", "Guardrails");
    case "scorers":
      return t("palette.category.scorers", "Scorers");
  }
}
const G7 = /* @__PURE__ */ new Set();
function K7(e) {
  return (t) => {
    t.dataTransfer.setData(YO, JSON.stringify(e)), t.dataTransfer.effectAllowed = "move";
    const n = t.currentTarget, r = n.getBoundingClientRect(), i = n.cloneNode(!0);
    Object.assign(i.style, {
      position: "fixed",
      top: "-9999px",
      left: "-9999px",
      width: `${r.width}px`,
      height: `${r.height}px`,
      margin: "0",
      overflow: "hidden",
      pointerEvents: "none"
    }), document.body.appendChild(i), t.dataTransfer.setDragImage(i, t.nativeEvent.offsetX, t.nativeEvent.offsetY), setTimeout(() => i.remove(), 0);
  };
}
const g0 = (e) => e === "generative-widget" ? "widget" : e;
function Fr({
  type: e,
  title: t,
  subtitle: n,
  payload: r,
  create: i = !1,
  icon: a,
  action: o
}) {
  return /* @__PURE__ */ x(
    _I,
    {
      draggable: !0,
      onDragStart: K7(r),
      className: "cursor-grab active:cursor-grabbing",
      type: e,
      title: t,
      ...n ? { subtitle: n } : {},
      ...a ? { icon: a } : {},
      ...o ? { action: o } : {},
      create: i
    }
  );
}
function J7({
  category: e,
  label: t,
  active: n,
  onToggle: r
}) {
  const { Icon: i, color: a } = Po[e.type];
  return /* @__PURE__ */ te(
    "button",
    {
      type: "button",
      "aria-pressed": n,
      onClick: r,
      className: Be(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-label-sm transition-colors",
        n ? "border-transparent bg-muted font-medium text-foreground" : "border-border-light text-muted-foreground hover:bg-muted/50"
      ),
      children: [
        /* @__PURE__ */ x(i, { className: "size-4", style: { color: a } }),
        t
      ]
    }
  );
}
function X7({ onMinimize: e } = {}) {
  const { capabilities: t, text: n, data: r, branding: i } = dt(), a = (P) => t.nodeKinds.includes(P), o = dr().data ?? [], d = we(
    Gz(
      (P) => (P.doc?.nodes ?? []).flatMap((E) => E.kind === "tool" ? [E.toolId] : [])
    )
  ), u = Le(() => new Set(d), [d]), l = wl().data ?? [], c = kl().data ?? [], [f, s] = Ae(""), [h, p] = Ae(G7), m = (P) => p((E) => {
    const T = new Set(E);
    return T.has(P) ? T.delete(P) : T.add(P), T;
  }), y = Le(
    () => ({
      agent: n("palette.agent", "Agent"),
      guardrail: n("palette.guardrail", "Guardrail"),
      scorer: n("palette.scorer", "Scorer"),
      webSearch: n("palette.webSearch", "Web Search")
    }),
    [n]
  ), w = Le(
    () => q7({
      query: f,
      active: h,
      tools: o,
      agents: l,
      connectors: c,
      labels: y,
      isWidget: (P) => g0(sr(P)) === "widget"
    }),
    [f, h, o, l, c, y]
  ), b = H7(w, {
    agent: a("agent"),
    guardrail: a("guardrail"),
    scorer: a("scorer"),
    newWidget: a("tool") && !!t.newWidget,
    webSearch: a("web-search"),
    connectors: a("mcp-connection"),
    // A knowledge base or guidelines node is only worth dropping where the host can list what it
    // may read; elsewhere the inspector would have nothing to offer.
    tool: (P) => {
      if (!a("tool")) return !1;
      const E = sr(P);
      return E === "knowledge-base" ? !!r.knowledgeBases : E === "brand-guidelines" ? !!r.guidelineFolders : !0;
    }
  }), _ = {
    agents: "agent",
    tools: "tool",
    widgets: "tool",
    connectors: "mcp-connection",
    guardrails: "guardrail",
    scorers: "scorer"
  }, g = !!t.newWidget || o.some((P) => P.widget), O = V7.filter(
    (P) => a(_[P.id]) && (P.id !== "widgets" || g)
  );
  return /* @__PURE__ */ te("div", { className: "flex min-h-0 flex-1 flex-col", children: [
    /* @__PURE__ */ te("div", { className: "flex shrink-0 items-center justify-between px-3 pt-3 pb-2.5", children: [
      /* @__PURE__ */ x(un, { children: n("palette.title", "Palette") }),
      e && /* @__PURE__ */ x(im, { label: n("palette.minimize", "Minimize palette"), onClick: e })
    ] }),
    /* @__PURE__ */ te("div", { className: "flex min-h-0 flex-1 flex-col gap-2.5 overflow-y-auto px-3 pb-3", children: [
      (b.showAgentCreate || b.showGuardrailCreate || b.showScorerCreate) && /* @__PURE__ */ te("div", { className: "flex flex-wrap gap-2", children: [
        b.showAgentCreate && /* @__PURE__ */ x("div", { className: "min-w-0 flex-1 basis-[45%]", children: /* @__PURE__ */ x(Fr, { create: !0, type: "agent", title: y.agent, payload: { kind: "agent" } }) }),
        b.showGuardrailCreate && /* @__PURE__ */ x("div", { className: "min-w-0 flex-1 basis-[45%]", children: /* @__PURE__ */ x(
          Fr,
          {
            create: !0,
            type: "guardrail",
            title: y.guardrail,
            payload: { kind: "guardrail" }
          }
        ) }),
        b.showScorerCreate && /* @__PURE__ */ x("div", { className: "min-w-0 flex-1 basis-[45%]", children: /* @__PURE__ */ x(
          Fr,
          {
            create: !0,
            type: "scorer",
            title: y.scorer,
            payload: { kind: "scorer" }
          }
        ) })
      ] }),
      /* @__PURE__ */ te("div", { className: "relative", children: [
        /* @__PURE__ */ x(gN, { className: "pointer-events-none absolute left-2 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground" }),
        /* @__PURE__ */ x(
          Qt,
          {
            size: "sm",
            className: "pl-7",
            "aria-label": n("palette.searchLabel", "Search palette"),
            placeholder: n("palette.searchPlaceholder", "Search tools, agents, connectors"),
            value: f,
            onChange: (P) => s(P.target.value)
          }
        )
      ] }),
      /* @__PURE__ */ x("div", { className: "flex flex-wrap gap-1.5", children: O.map((P) => /* @__PURE__ */ x(
        J7,
        {
          category: P,
          label: W7(P.id, n),
          active: h.has(P.id),
          onToggle: () => m(P.id)
        },
        P.id
      )) }),
      [
        ["tool", n("palette.tools", "Tools")],
        ["knowledge-base", n("palette.knowledge", "Knowledge")],
        ["brand-guidelines", n("palette.brand", "Brand")],
        ["widget", n("palette.widgets", "Widgets")]
      ].map(([P, E]) => {
        const T = b.tools.filter((M) => g0(sr(M)) === P).sort(
          (M, R) => +(sr(R) === "generative-widget") - +(sr(M) === "generative-widget")
        ), D = P === "tool" && b.showWebSearch, N = P === "widget" && b.showWidgetCreate ? t.newWidget : void 0;
        return T.length > 0 || D || N ? /* @__PURE__ */ te("div", { className: "contents", children: [
          /* @__PURE__ */ x(un, { children: E }),
          N && /* @__PURE__ */ te(
            "button",
            {
              type: "button",
              onClick: N,
              className: "flex items-center gap-2.5 rounded-lg border border-dashed border-border bg-card px-2.5 py-2 text-left transition-colors hover:bg-muted/50",
              children: [
                /* @__PURE__ */ x(Wo, { type: "widget", size: "md" }),
                /* @__PURE__ */ x("span", { className: "text-body-md font-medium text-foreground", children: n("palette.newWidget", "New widget") })
              ]
            }
          ),
          D && /* @__PURE__ */ x(
            Fr,
            {
              type: "tool",
              title: y.webSearch,
              subtitle: n(
                "palette.webSearchDescription",
                "Searches the web for current information, through the agent's model provider."
              ),
              payload: { kind: "web-search" }
            }
          ),
          T.map((M) => {
            const R = Ge.widgetIdOfTool(M.id), V = R && i.widgetThumbnail ? i.widgetThumbnail({ widgetId: R, size: "md" }) : void 0, C = R && t.deleteWidget && M.widget?.inUse === !1 && !u.has(M.id), B = t.deleteWidget, G = R ? i.widgetInfo : void 0, Q = /* @__PURE__ */ te(Ue, { children: [
              R && G && /* @__PURE__ */ te(R0, { children: [
                /* @__PURE__ */ x(Z0, { asChild: !0, children: /* @__PURE__ */ x(
                  "button",
                  {
                    type: "button",
                    "aria-label": n("palette.widgetInfo", "About {{name}}", {
                      name: M.name
                    }),
                    className: "flex size-6 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground",
                    children: /* @__PURE__ */ x(BT, { className: "size-4" })
                  }
                ) }),
                /* @__PURE__ */ x(L0, { side: "right", align: "start", className: "w-80", children: G({ widgetId: R }) })
              ] }),
              C && B && /* @__PURE__ */ x(
                "button",
                {
                  type: "button",
                  "aria-label": n("palette.deleteWidget", "Delete {{name}}", {
                    name: M.name
                  }),
                  onClick: () => B(R, M.name),
                  className: "flex size-6 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-destructive",
                  children: /* @__PURE__ */ x(EN, { className: "size-4" })
                }
              )
            ] });
            return /* @__PURE__ */ x(
              Fr,
              {
                type: sr(M),
                title: M.name,
                subtitle: M.widget ? Dm(M.widget, n) : sr(M) === "generative-widget" ? n(
                  "palette.generativeWidgets",
                  "Designed by the agent, answer by answer"
                ) : M.description,
                payload: { kind: "tool", id: M.id },
                ...V ? { icon: V } : {},
                ...R && G || C && B ? { action: Q } : {}
              },
              M.id
            );
          })
        ] }, P) : null;
      }),
      a("mcp-connection") && (b.connectors.length > 0 || !f && (h.size === 0 || h.has("connectors"))) && /* @__PURE__ */ te("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ x(un, { children: n("palette.connectors", "Connectors") }),
        t.manageConnections && /* @__PURE__ */ x(
          "button",
          {
            type: "button",
            "aria-label": n("palette.manageConnections", "Manage connections"),
            title: n("palette.manageConnections", "Manage connections"),
            onClick: t.manageConnections,
            className: "flex size-5 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground",
            children: /* @__PURE__ */ x(vN, { className: "size-3.5" })
          }
        )
      ] }),
      b.connectors.map((P) => /* @__PURE__ */ x(
        Fr,
        {
          type: "connector",
          title: P.label,
          subtitle: P.description,
          payload: { kind: "mcp-connection", id: P.id, name: P.label }
        },
        P.id
      )),
      b.agents.length > 0 && /* @__PURE__ */ te(Ue, { children: [
        /* @__PURE__ */ x(un, { children: n("palette.existingAgents", "Existing agents") }),
        b.agents.map((P) => /* @__PURE__ */ x(
          Fr,
          {
            type: "ref-agent",
            icon: /* @__PURE__ */ x($m, { agent: P, size: "md" }),
            title: P.name,
            subtitle: P.description,
            payload: { kind: "ref", id: P.id, name: P.name }
          },
          P.id
        ))
      ] }),
      b.empty && /* @__PURE__ */ x("p", { className: "px-0.5 text-[11px] text-muted-foreground", children: n("palette.noMatches", "No matches.") })
    ] })
  ] });
}
function Y7(e, t) {
  const { getNodes: n, getNodesBounds: r, getViewport: i, fitView: a } = Jo();
  Ze(() => {
    const o = e.current;
    if (!o || typeof ResizeObserver > "u") return;
    let d = null;
    const u = new ResizeObserver(([l]) => {
      const { width: c, height: f } = l.contentRect;
      if (c === 0 || f === 0) return;
      const s = d !== null && c !== d;
      d = c;
      const h = n();
      if (!s || h.length === 0) return;
      const p = r(h), { x: m, y, zoom: w } = i(), b = -m / w, _ = -y / w;
      p.x >= b && p.y >= _ && p.x + p.width <= b + c / w && p.y + p.height <= _ + f / w || a(t);
    });
    return u.observe(o), () => u.disconnect();
  }, [e, t, n, r, i, a]);
}
const QO = { builder: Q9 }, ez = { builder: tq }, y0 = {
  maxZoom: 1,
  padding: { top: "48px", right: "48px", bottom: "160px", left: "340px" }
}, Q7 = [], eG = [], tG = /* @__PURE__ */ new Set(), tz = /* @__PURE__ */ new Set();
function nG(e, t, n, r, i, a = () => tG, o = () => {
}) {
  const d = Tc(e, n, i);
  if (e.kind === "tool") {
    const u = o(e.toolId), l = sr(u), c = Ge.widgetIdOfTool(e.toolId);
    if (l === "widget" && u?.widget && c)
      return {
        kind: "tool",
        label: d,
        sublabel: Dm(u.widget, i),
        entityType: l,
        widgetId: c,
        policy: e.policy
      };
    const f = aO(e, i);
    return {
      kind: "tool",
      label: f ?? d,
      ...f ? { sublabel: d } : {},
      ...l !== "tool" ? { entityType: l } : {},
      policy: e.policy
    };
  }
  if (e.kind === "web-search")
    return {
      kind: "tool",
      label: d,
      sublabel: i("canvas.webSearchProvider", "the model's provider"),
      policy: "allow"
    };
  if (e.kind === "agent") {
    const u = e.source === "ref";
    return {
      kind: "agent",
      isRef: u,
      ...u && e.agentId ? { agentId: e.agentId } : {},
      label: d,
      sublabel: !u && e.llm?.model ? r(e.llm.model) : void 0,
      isEntry: e.id === t
    };
  }
  if (e.kind === "guardrail")
    return {
      kind: "guardrail",
      label: d,
      sublabel: e.criterion || i("canvas.noCriterion", "No criterion yet")
    };
  if (e.kind === "scorer")
    return {
      kind: "scorer",
      label: d,
      sublabel: e.scorerId || i("canvas.noScorer", "No scorer picked")
    };
  if (e.kind === "mcp-connection") {
    if (e.tools === "all")
      return {
        kind: "mcp-connection",
        label: d,
        sublabel: i("canvas.allTools", "Every tool it offers")
      };
    const u = e.tools.filter((p) => p.policy !== "disallow"), l = a(e.connectionId), c = u.filter(
      (p) => p.policy === "needs_approval" || l.has(p.name) && p.policy !== "always_allow"
    ).length, f = u.filter((p) => p.policy === "always_allow").length;
    if (u.length === 0)
      return {
        kind: "mcp-connection",
        label: d,
        sublabel: i("canvas.noToolsEnabled", "No tools enabled")
      };
    const s = { count: u.length }, h = [
      {
        kind: "tools",
        count: u.length,
        label: u.length === 1 ? i("canvas.toolCountOne", "{{count}} tool", s) : i("canvas.toolCount", "{{count}} tools", s)
      },
      ...c ? [
        {
          kind: "approval",
          count: c,
          label: i("canvas.approvalCount", "{{count}} need approval", { count: c })
        }
      ] : [],
      ...f ? [
        {
          kind: "always-allowed",
          count: f,
          label: i("canvas.alwaysAllowedCount", "{{count}} always allowed", {
            count: f
          })
        }
      ] : []
    ];
    return { kind: "mcp-connection", label: d, stats: h };
  }
  return e;
}
function nz(e, t, n, r, i, a, o, d, u, l = tz) {
  return e.map((c) => {
    const f = [
      ...a[c.id]?.issues ?? [],
      ...cO(a[c.id], l.has(c.id), o)
    ];
    return {
      id: c.id,
      type: "builder",
      position: c.ui,
      selected: c.id === t,
      data: {
        ...nG(c, n, r, i, o, d, u),
        incompleteReason: f.length > 0 ? f.join(" · ") : void 0
      }
    };
  });
}
function rG({
  fromX: e,
  fromY: t,
  fromPosition: n,
  toX: r,
  toY: i,
  toPosition: a,
  connectionStatus: o
}) {
  const d = o === "invalid" ? "var(--destructive)" : "var(--positive-foreground)", [u] = _c({
    sourceX: e,
    sourceY: t,
    sourcePosition: n,
    targetX: r,
    targetY: i,
    targetPosition: a
  });
  return /* @__PURE__ */ x("path", { fill: "none", stroke: d, strokeWidth: 2, d: u });
}
const iG = 6e3;
function oG() {
  const e = we((se) => se.doc), t = we((se) => se.selectedNodeId), n = we((se) => se.selectedEdgeId), r = we((se) => se.addAgentNode), i = we((se) => se.addToolNode), a = we((se) => se.addRefAgentNode), o = we((se) => se.addGuardrailNode), d = we((se) => se.addWebSearchNode), u = we((se) => se.addScorerNode), l = we((se) => se.addMcpConnectionNode), c = we((se) => se.moveNode), f = we((se) => se.selectNode), s = we((se) => se.selectEdge), h = we((se) => se.deleteNode), p = we((se) => se.addEdge), m = we((se) => se.deleteEdge), y = dr().data ?? Q7, w = _l().data, b = w?.models ?? eG, _ = w?.defaultModelId, g = Re(), O = Qz(), [P, E, T] = ML([]), [D, N, M] = $L([]), { screenToFlowPosition: R } = Jo(), V = Ce(null);
  Y7(V, y0);
  const C = Le(() => new Map((e?.nodes ?? []).map((se) => [se.id, se])), [e?.nodes]), B = Nc(), G = Ye((se) => hO(b, se), [b]), Q = (e?.nodes ?? []).flatMap((se) => se.kind === "mcp-connection" && se.tools !== "all" ? [se.connectionId] : []).sort().join(","), k = Le(
    () => Q ? [...new Set(Q.split(","))] : [],
    [Q]
  ), I = Am(k), S = Le(() => new Set(y.map((se) => se.id)), [y]), A = Ye((se) => y.find((pe) => pe.id === se), [y]), j = Le(
    () => lO(e?.nodes ?? [], S, g, A),
    [e?.nodes, S, g, A]
  ), z = e?.nodes, L = e?.edges, F = e?.entryNodeId, K = Le(
    () => z && L && F !== void 0 ? uO({ nodes: z, edges: L, entryNodeId: F }) : tz,
    [z, L, F]
  ), ee = Le(
    () => (e?.nodes ?? []).filter((se) => se.kind === "tool" && se.policy === "disallow").map((se) => se.id).sort().join(","),
    [e?.nodes]
  );
  Ze(() => {
    E(
      nz(
        e?.nodes ?? [],
        t,
        e?.entryNodeId ?? "",
        B,
        G,
        j,
        g,
        I,
        A,
        K
      )
    );
  }, [
    e?.nodes,
    e?.entryNodeId,
    t,
    B,
    G,
    j,
    g,
    I,
    A,
    K,
    E
  ]), Ze(() => {
    const se = new Set(ee ? ee.split(",") : []);
    N(KO(e?.edges ?? [], se, n, g));
  }, [e?.edges, ee, n, g, N]);
  const [U, q] = Ae(null);
  Ze(() => {
    if (!U) return;
    const se = setTimeout(() => q(null), iG);
    return () => clearTimeout(se);
  }, [U]);
  const ne = Ye(
    (se) => Ge.loopClosedBy(e?.edges ?? [], se.type, se.source, se.target),
    [e?.edges]
  ), oe = Ye(
    (se) => {
      const pe = m0(se, C);
      pe && p(pe.source, pe.target, pe.sourceHandle), q(null);
    },
    [p, C]
  ), Y = Ye(
    (se) => {
      const pe = m0(se, C);
      return !pe || Ge.edgeExists(e?.edges ?? [], pe.type, pe.source, pe.target, Ge.guardsPlacement(pe.sourceHandle)) ? !1 : !ne(pe);
    },
    [C, e?.edges, ne]
  ), re = Ye(
    (se, pe) => {
      const ke = U7(pe), Ne = ke ? B7(
        ke,
        C,
        e?.edges ?? [],
        (Ke) => Tc(Ke, B, g),
        g
      ) : void 0;
      q(Ne ? { reason: Ne } : null);
    },
    [C, e?.edges, B, g]
  ), de = Ye(
    (se) => {
      se.preventDefault();
      const pe = se.dataTransfer.getData(YO);
      if (!pe) return;
      let ke;
      try {
        ke = JSON.parse(pe);
      } catch {
        return;
      }
      const Ne = Z7.safeParse(ke);
      if (!Ne.success) return;
      const Ke = R({ x: se.clientX, y: se.clientY }), X = Ne.data;
      X.kind === "agent" ? r(Ke, _) : X.kind === "tool" && X.id ? i(Ke, X.id) : X.kind === "ref" && X.id ? a(Ke, X.id, X.name ?? X.id) : X.kind === "web-search" ? d(Ke) : X.kind === "guardrail" ? o(Ke) : X.kind === "scorer" ? u(Ke) : X.kind === "mcp-connection" && X.id && l(Ke, X.id);
    },
    [
      R,
      r,
      _,
      i,
      a,
      o,
      d,
      u,
      l
    ]
  ), ve = Ye((se) => {
    se.preventDefault(), se.dataTransfer.dropEffect = "move";
  }, []);
  return /* @__PURE__ */ te("div", { ref: V, className: "relative h-full w-full", onDrop: de, onDragOver: ve, children: [
    /* @__PURE__ */ x(
      oI,
      {
        nodes: P,
        edges: D,
        nodeTypes: QO,
        edgeTypes: ez,
        onNodesChange: T,
        onEdgesChange: M,
        onNodeDragStop: (se, pe) => c(pe.id, pe.position),
        onNodeClick: (se, pe) => f(pe.id),
        onEdgeClick: (se, pe) => s(pe.id),
        onNodesDelete: (se) => se.forEach((pe) => h(pe.id)),
        onEdgesDelete: (se) => se.forEach((pe) => m(pe.id)),
        onConnect: oe,
        onConnectEnd: re,
        isValidConnection: Y,
        onPaneClick: () => f(null),
        connectionLineComponent: rG,
        deleteKeyCode: ["Backspace", "Delete"],
        fitView: !0,
        fitViewOptions: y0,
        minZoom: 0.2,
        maxZoom: 2,
        nodesConnectable: !0,
        proOptions: { hideAttribution: !0 },
        children: /* @__PURE__ */ x(sI, { variant: Un.Dots, gap: 18, size: 1, color: "var(--border)" })
      }
    ),
    U && /* @__PURE__ */ x(
      "p",
      {
        role: "alert",
        className: "pointer-events-none absolute left-1/2 top-3 max-w-[90%] -translate-x-1/2 rounded-md bg-destructive/10 px-2 py-1 text-[11px] text-destructive shadow-sm",
        children: U.reason
      }
    ),
    P.length === 0 && /* @__PURE__ */ x("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ x(
      hk,
      {
        cue: "create",
        hint: O.copilot ? g(
          "canvas.emptyHintCopilot",
          "Drag one in from the palette, or ask Flow.Assist to draw the whole flow for you."
        ) : g("canvas.emptyHint", "Drag one in from the palette."),
        children: g("canvas.emptyTitle", "Start with an agent")
      }
    ) })
  ] });
}
function aG() {
  return /* @__PURE__ */ x(rm, { children: /* @__PURE__ */ x(oG, {}) });
}
function sG({ top: e = 16 } = {}) {
  const t = Re(), n = Ot((u) => u.paletteWidth), r = Ot((u) => u.setPaletteWidth), i = Ot((u) => u.paletteHeight), a = Ot((u) => u.setPaletteHeight), o = Ot((u) => u.paletteMinimized), d = Ot((u) => u.setPaletteMinimized);
  return o ? /* @__PURE__ */ x("div", { className: "absolute left-4 z-10 transition-[top] duration-slow ease-out", style: { top: e }, children: /* @__PURE__ */ x(
    hI,
    {
      icon: /* @__PURE__ */ x(KT, { className: "size-4", "aria-hidden": !0 }),
      label: t("builder.palette", "Palette"),
      title: t("palette.restore", "Show the palette"),
      onRestore: () => d(!1)
    }
  ) }) : /* @__PURE__ */ x(
    bp,
    {
      side: "left",
      ariaLabel: t("builder.palette", "Palette"),
      top: e,
      className: "transition-[top] duration-slow ease-out",
      resize: {
        width: n,
        minWidth: 200,
        onResize: r,
        height: i,
        minHeight: 200,
        onResizeHeight: a
      },
      children: /* @__PURE__ */ x(X7, { onMinimize: () => d(!0) })
    }
  );
}
const lG = [], uG = [], cG = /* @__PURE__ */ new Set(), rz = 0.2, rp = { padding: 0.2, maxZoom: 1, minZoom: rz };
function dG() {
  const { fitView: e } = Jo(), t = at(), n = ZL();
  return Ze(() => {
    n && e(rp);
  }, [n, e]), Ze(() => {
    const r = t.getState().domNode;
    if (!r || typeof ResizeObserver > "u") return;
    const i = new ResizeObserver(() => {
      e(rp);
    });
    return i.observe(r), () => {
      i.disconnect();
    };
  }, [e, t]), null;
}
function eJ({
  doc: e,
  className: t,
  showRun: n = !1
}) {
  const r = dr().data ?? lG, i = Nc(), a = _l().data?.models ?? uG, o = Re(), d = Le(
    () => [
      ...new Set(
        e.nodes.flatMap(
          (f) => f.kind === "mcp-connection" && f.tools !== "all" ? [f.connectionId] : []
        )
      )
    ],
    [e.nodes]
  ), u = Am(d), l = Le(
    () => nz(
      e.nodes,
      null,
      e.entryNodeId,
      i,
      (f) => hO(a, f),
      {},
      o,
      u,
      (f) => r.find((s) => s.id === f)
    ).map((f) => ({ ...f, data: { ...f.data, readOnly: !0, showRun: n } })),
    [e, r, i, a, o, u, n]
  ), c = Le(() => KO(e.edges, cG, null, o), [e.edges, o]);
  return /* @__PURE__ */ x("div", { className: t ?? "relative h-full w-full", children: /* @__PURE__ */ x(rm, { children: /* @__PURE__ */ te(
    oI,
    {
      nodes: l,
      edges: c,
      nodeTypes: QO,
      edgeTypes: ez,
      nodesDraggable: !1,
      nodesConnectable: !1,
      elementsSelectable: !1,
      deleteKeyCode: null,
      fitView: !0,
      fitViewOptions: rp,
      minZoom: rz,
      proOptions: { hideAttribution: !0 },
      children: [
        /* @__PURE__ */ x(sI, { variant: Un.Dots, gap: 16, size: 1 }),
        /* @__PURE__ */ x(JL, { showInteractive: !1 }),
        /* @__PURE__ */ x(dG, {})
      ]
    }
  ) }) });
}
function fG() {
  const e = we((n) => n.undo), t = we((n) => n.redo);
  Ze(() => {
    const n = (r) => {
      if (!(r.metaKey || r.ctrlKey) || r.key.toLowerCase() !== "z") return;
      const i = r.target;
      i && (i.isContentEditable || i.tagName === "INPUT" || i.tagName === "TEXTAREA") || (r.preventDefault(), r.shiftKey ? t() : e());
    };
    return window.addEventListener("keydown", n), () => window.removeEventListener("keydown", n);
  }, [e, t]);
}
zr((e) => ({
  selectedAgentId: null,
  selectedSessionId: null,
  newSessionCounter: 0,
  selectAgent: (t) => e({ selectedAgentId: t, selectedSessionId: null }),
  selectSession: (t) => e({ selectedSessionId: t }),
  startNewSession: () => e((t) => ({ selectedSessionId: null, newSessionCounter: t.newSessionCounter + 1 }))
}));
nt({
  deleted: On(),
  agentIds: Ct(xe())
});
function iz(e) {
  return e.tools === "all" ? [] : e.tools;
}
function Wf(e, t) {
  return iz(e).find((n) => n.name === t)?.policy ?? "disallow";
}
function Ql(e, t) {
  return t && e === "allow" ? "needs_approval" : !t && e === "always_allow" ? "allow" : e;
}
function v0(e) {
  return e.filter((t) => t.policy !== "disallow").map((t) => ({ name: t.name, policy: t.policy }));
}
function hG({ node: e }) {
  const t = we((b) => b.updateMcpConnectionNode), { text: n, capabilities: r } = dt(), i = Ph(n), a = l9(e.connectionId), o = a.data ?? [], d = Le(() => [e.connectionId], [e.connectionId]), u = Am(d)(e.connectionId), l = a.error instanceof Kz && a.error.code === "mcp_server_not_connected", [c, f] = Ae(null), s = (b, _) => {
    const g = Ql(_, u.has(b)), O = iz(e).filter((P) => P.name !== b);
    t(e.id, v0([...O, { name: b, policy: g }]));
  }, h = (b, _) => {
    _ === "always_allow" && u.has(b) ? f({ tool: b }) : s(b, _);
  }, p = [
    { value: "always_allow", label: n("connector.alwaysAllow", "Always allow") },
    ...i.filter((b) => b.value !== "allow")
  ], m = (b, _) => {
    const g = v0(
      b.map((P) => {
        const E = u.has(P.name);
        return {
          name: P.name,
          policy: _ === "allow" && E ? "always_allow" : Ql(_, E)
        };
      })
    ), O = g.filter(
      (P) => P.policy === "always_allow" && Wf(e, P.name) !== "always_allow"
    ).length;
    _ === "allow" && O > 0 ? f({ rows: g, locked: O }) : t(e.id, g);
  }, y = (() => {
    const b = new Set(
      o.map((_) => {
        const g = Ql(Wf(e, _.name), u.has(_.name));
        return g === "always_allow" ? "allow" : g;
      })
    );
    return b.size === 1 ? [...b][0] : void 0;
  })(), w = e.tools === "all";
  return /* @__PURE__ */ x(Yu, { children: /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
    /* @__PURE__ */ te("div", { className: "flex items-start justify-between gap-3", children: [
      /* @__PURE__ */ te("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ x(zz, { htmlFor: `all-tools-${e.id}`, children: n("connector.allTools", "Every tool") }),
        /* @__PURE__ */ x("span", { className: "text-[11px] text-muted-foreground", children: n(
          "connector.allToolsHint",
          "Offer whatever the server has when the agent runs. Tools it doesn't mark read-only ask before running."
        ) })
      ] }),
      /* @__PURE__ */ x(
        $0,
        {
          id: `all-tools-${e.id}`,
          checked: w,
          onCheckedChange: (b) => {
            t(e.id, b ? "all" : []);
          }
        }
      )
    ] }),
    !w && a.isPending && /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: n("connector.discovering", "Discovering tools…") }),
    !w && l && /* @__PURE__ */ te("div", { className: "flex flex-col items-start gap-2", children: [
      /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: n(
        "connector.notConnected",
        "Connect this server with your own account to choose its tools."
      ) }),
      r.connectConnection && /* @__PURE__ */ x(
        Tt,
        {
          size: "sm",
          variant: "outline",
          onClick: () => r.connectConnection?.(e.connectionId),
          children: n("connector.connect", "Connect")
        }
      )
    ] }),
    !w && a.isError && !l && /* @__PURE__ */ te("div", { className: "flex flex-col items-start gap-2", children: [
      /* @__PURE__ */ x("p", { className: "text-[11px] text-destructive", children: n("connector.unreachable", "Couldn't reach the MCP server.") }),
      /* @__PURE__ */ x(Tt, { size: "sm", variant: "outline", onClick: () => {
        a.refetch();
      }, children: n("connector.retry", "Retry") })
    ] }),
    !w && a.isSuccess && (o.length === 0 ? /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: n("connector.noTools", "This connection exposes no tools.") }) : /* @__PURE__ */ te(Ue, { children: [
      /* @__PURE__ */ x(Xe, { label: n("connector.setAll", "Set all tools"), as: "div", children: /* @__PURE__ */ x(
        Fo,
        {
          options: i,
          value: y,
          onChange: (b) => m(o, b)
        }
      ) }),
      /* @__PURE__ */ x(un, { children: n("connector.tools", "Tools") }),
      o.map((b) => {
        const _ = u.has(b.name), g = Ql(Wf(e, b.name), _), O = g === "always_allow", P = O ? n(
          "connector.alwaysAllowedTool",
          "The server doesn't mark this tool read-only, but it runs without asking"
        ) : n(
          "connector.writeTool",
          "The server doesn't mark this tool read-only, so it asks before running"
        );
        return /* @__PURE__ */ te("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ te("span", { className: "flex items-center gap-1 text-sm text-foreground", children: [
            b.name,
            _ && /* @__PURE__ */ te(Qu, { children: [
              /* @__PURE__ */ x(ec, { asChild: !0, children: /* @__PURE__ */ x("span", { role: "img", "aria-label": P, tabIndex: 0, className: "flex", children: /* @__PURE__ */ x(dk, { "aria-hidden": !0, className: "size-3 text-muted-foreground" }) }) }),
              /* @__PURE__ */ x(tc, { children: P })
            ] }),
            O && /* @__PURE__ */ x(
              _r,
              {
                variant: "outline",
                roundness: "full",
                className: "text-warning-foreground",
                children: n("connector.alwaysAllowed", "Always allowed")
              }
            )
          ] }),
          b.description && /* @__PURE__ */ x("span", { className: "text-[11px] text-muted-foreground", children: b.description }),
          /* @__PURE__ */ x(
            Fo,
            {
              options: _ ? p : i,
              value: g,
              onChange: (E) => h(b.name, E)
            }
          )
        ] }, b.name);
      })
    ] })),
    /* @__PURE__ */ x(
      Ez,
      {
        open: c !== null,
        onOpenChange: (b) => {
          b || f(null);
        },
        children: /* @__PURE__ */ te(Tz, { children: [
          /* @__PURE__ */ te(Nz, { children: [
            /* @__PURE__ */ x(Cz, { children: c && "rows" in c ? n("connector.alwaysAllowAllTitle", "Allow every tool?") : n("connector.alwaysAllowTitle", "Always allow {{tool}}?", {
              tool: c?.tool ?? ""
            }) }),
            /* @__PURE__ */ x(Dz, { children: c && "rows" in c ? c.locked === 1 ? n(
              "connector.alwaysAllowAllWarningOne",
              "{{count}} of these tools may change things outside the agent. It will run without asking anyone who uses this agent.",
              { count: c.locked }
            ) : n(
              "connector.alwaysAllowAllWarning",
              "{{count}} of these tools may change things outside the agent. They will run without asking anyone who uses this agent.",
              { count: c.locked }
            ) : n(
              "connector.alwaysAllowWarning",
              "This tool may change things outside the agent. It will run without asking anyone who uses this agent."
            ) })
          ] }),
          /* @__PURE__ */ te(Az, { children: [
            /* @__PURE__ */ x(jz, { children: n("connector.alwaysAllowCancel", "Cancel") }),
            /* @__PURE__ */ x(
              Mz,
              {
                onClick: () => {
                  c && "rows" in c ? t(e.id, c.rows) : c && s(c.tool, "always_allow"), f(null);
                },
                children: n("connector.alwaysAllowConfirm", "Always allow")
              }
            )
          ] })
        ] })
      }
    )
  ] }) });
}
const oz = "agent-files", pG = (e, t) => {
  switch (e) {
    case "TextCorrectness":
      return t("guidelineCategory.textCorrectness", "Text correctness");
    case "TextFormatting":
      return t("guidelineCategory.textFormatting", "Text formatting");
    case "ContentStyle":
      return t("guidelineCategory.contentStyle", "Content style");
    case "BrandAssets":
      return t("guidelineCategory.brandAssets", "Brand assets");
    case "TechnicalRequirements":
      return t("guidelineCategory.technicalRequirements", "Technical requirements");
  }
}, az = "inline-flex shrink-0 items-center gap-1 text-xs text-primary hover:underline", Ju = (e) => typeof e == "string" && e.length > 0 ? e : void 0;
function mG({
  node: e,
  fields: t
}) {
  const n = we((a) => a.updateToolNode), r = e.config ?? {}, i = (a) => n(e.id, { config: a });
  return /* @__PURE__ */ x(Ue, { children: t.map(
    (a) => a.kind === "placements" ? /* @__PURE__ */ x(
      bG,
      {
        value: Array.isArray(r[a.key]) ? r[a.key] : [],
        onChange: (o) => {
          const { [a.key]: d, ...u } = r;
          i(o.length === 1 ? { ...u, [a.key]: o } : u);
        }
      },
      a.key
    ) : a.kind === "guideline-categories" ? /* @__PURE__ */ x(
      vG,
      {
        value: Array.isArray(r[a.key]) ? r[a.key] : [],
        onChange: (o) => {
          const { [a.key]: d, ...u } = r;
          i(o.length > 0 ? { ...u, [a.key]: o } : u);
        }
      },
      a.key
    ) : a.kind === "knowledge-base" ? /* @__PURE__ */ x(
      gG,
      {
        config: r,
        onPick: (o) => i({ [a.key]: o.id, name: o.name }),
        onUseAgentFiles: () => i({ source: oz }),
        onUsePicked: () => i({})
      },
      a.key
    ) : /* @__PURE__ */ x(
      sz,
      {
        kind: a.kind,
        pickedId: Ju(r[a.key]),
        pickedName: Ju(r.name),
        onPick: (o) => i({ ...r, [a.key]: o.id, name: o.name })
      },
      a.key
    )
  ) });
}
function gG({
  config: e,
  onPick: t,
  onUseAgentFiles: n,
  onUsePicked: r
}) {
  const i = Re(), { inspector: a } = dt(), o = e.source === oz, [d, u] = Ae(o ? "upload" : "pick"), l = /* @__PURE__ */ x(
    sz,
    {
      kind: "knowledge-base",
      pickedId: Ju(e.knowledgeBaseId),
      pickedName: Ju(e.name),
      onPick: t
    }
  );
  return a.agentFiles ? /* @__PURE__ */ te("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ x(
      Fo,
      {
        options: [
          { value: "pick", label: i("inspector.toolConfig.pickKnowledgeBase", "Knowledge base") },
          { value: "upload", label: i("inspector.toolConfig.uploadFiles", "Upload files") }
        ],
        value: d,
        onChange: (c) => {
          u(c), c === "upload" && !o && n(), c === "pick" && o && r();
        }
      }
    ),
    d === "upload" ? /* @__PURE__ */ x(
      Xe,
      {
        label: i("inspector.toolConfig.agentFiles", "This agent's files"),
        hint: i(
          "inspector.toolConfig.agentFilesHint",
          "Only this agent searches them. They apply to every version straight away."
        ),
        as: "div",
        children: a.agentFiles()
      }
    ) : l
  ] }) : l;
}
function sz({
  kind: e,
  pickedId: t,
  pickedName: n,
  onPick: r
}) {
  const i = Re(), a = c9(), o = d9(), d = e === "knowledge-base" ? a : o, [u, l] = Ae(!1), c = e === "knowledge-base", f = c ? i("inspector.toolConfig.knowledgeBase", "Knowledge base") : i("inspector.toolConfig.guidelinesFolder", "Guidelines folder"), s = c ? i("inspector.toolConfig.knowledgeBaseHint", "Anyone who uses this agent can search it.") : i(
    "inspector.toolConfig.guidelinesHint",
    "Read with the access of whoever uses the agent. A folder belongs to one workspace."
  ), h = d.data?.items ?? [], p = t ? h.find((m) => m.id === t) : void 0;
  return /* @__PURE__ */ x(Xe, { label: f, hint: s, as: "div", children: t && !u ? /* @__PURE__ */ te(
    "div",
    {
      "data-testid": "tool-config-picked",
      className: "flex items-center gap-2 rounded-md border border-border p-2",
      children: [
        /* @__PURE__ */ x(Wo, { type: c ? "knowledge-base" : "brand-guidelines", size: "md" }),
        /* @__PURE__ */ te("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ x("div", { className: "truncate text-sm font-medium", children: p?.name ?? n ?? t }),
          p ? p.detail && /* @__PURE__ */ x("div", { className: "truncate text-xs text-muted-foreground", children: p.detail }) : d.isSuccess && /* @__PURE__ */ te("div", { className: "flex items-center gap-1 text-xs text-badge-yellow-foreground", children: [
            /* @__PURE__ */ x(sc, { className: "size-3" }),
            i("inspector.toolConfig.gone", "No longer available. Pick another.")
          ] })
        ] }),
        p?.href && /* @__PURE__ */ te("a", { className: az, href: p.href, target: "_blank", rel: "noreferrer", children: [
          /* @__PURE__ */ x(uk, { className: "size-3" }),
          i("inspector.toolConfig.open", "Open")
        ] }),
        /* @__PURE__ */ x(Tt, { variant: "outline", size: "mini", onClick: () => l(!0), children: i("inspector.toolConfig.change", "Change") })
      ]
    }
  ) : /* @__PURE__ */ x(
    yG,
    {
      kind: e,
      items: h,
      loading: d.isPending,
      createHref: d.data?.createHref,
      emptyReason: d.data?.emptyReason,
      onPick: (m) => {
        r(m), l(!1);
      }
    }
  ) });
}
function yG({
  kind: e,
  items: t,
  loading: n,
  createHref: r,
  emptyReason: i,
  onPick: a
}) {
  const o = Re(), [d, u] = Ae(""), l = d.trim().toLowerCase(), c = l ? t.filter((f) => f.name.toLowerCase().includes(l)) : t;
  return n ? null : t.length === 0 ? /* @__PURE__ */ te("div", { className: "flex flex-col gap-1 text-xs text-muted-foreground", children: [
    i ?? (e === "knowledge-base" ? o("inspector.toolConfig.noKnowledgeBases", "No knowledge bases yet.") : o("inspector.toolConfig.noFolders", "No guidelines folders in this workspace yet.")),
    !i && r && /* @__PURE__ */ te("a", { className: az, href: r, target: "_blank", rel: "noreferrer", children: [
      /* @__PURE__ */ x(uk, { className: "size-3" }),
      o("inspector.toolConfig.createInKnowledgeHub", "Create one in the Knowledge Hub")
    ] })
  ] }) : /* @__PURE__ */ te("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ x(
      Qt,
      {
        value: d,
        onChange: (f) => u(f.target.value),
        placeholder: o("inspector.toolConfig.search", "Search"),
        "aria-label": o("inspector.toolConfig.search", "Search")
      }
    ),
    /* @__PURE__ */ x("div", { className: "flex max-h-56 flex-col overflow-y-auto", children: c.length === 0 ? /* @__PURE__ */ x("span", { className: "px-2 py-1 text-xs text-muted-foreground", children: o("inspector.toolConfig.noMatch", "Nothing matches.") }) : c.map((f) => /* @__PURE__ */ te(
      "button",
      {
        type: "button",
        onClick: () => a(f),
        className: "flex flex-col items-start rounded-md px-2 py-1.5 text-left hover:bg-accent",
        children: [
          /* @__PURE__ */ x("span", { className: "text-sm", children: f.name }),
          f.detail && /* @__PURE__ */ x("span", { className: "text-xs text-muted-foreground", children: f.detail })
        ]
      },
      f.id
    )) })
  ] });
}
function vG({
  value: e,
  onChange: t
}) {
  const n = Re();
  return /* @__PURE__ */ x(
    Xe,
    {
      label: n("inspector.toolConfig.categories", "Categories"),
      hint: n("inspector.toolConfig.categoriesHint", "Leave all unticked to read every category."),
      as: "div",
      children: /* @__PURE__ */ x("div", { className: "flex flex-col gap-1.5", children: Ge.GUIDELINE_CATEGORIES.map((r) => {
        const i = pG(r, n);
        return /* @__PURE__ */ te("label", { className: "flex items-center gap-2 text-sm", children: [
          /* @__PURE__ */ x(
            F0,
            {
              "aria-label": i,
              checked: e.includes(r),
              onCheckedChange: (a) => t(
                a === !0 ? Ge.GUIDELINE_CATEGORIES.filter((o) => o === r || e.includes(o)) : e.filter((o) => o !== r)
              )
            }
          ),
          i
        ] }, r);
      }) })
    }
  );
}
const Gf = ["inline", "panel"];
function bG({
  value: e,
  onChange: t
}) {
  const n = Re(), r = Gf.filter((a) => e.length === 0 || e.includes(a)), i = (a) => a === "inline" ? n("inspector.toolConfig.placementInline", "Inline, in the reply") : n("inspector.toolConfig.placementPanel", "Side panel");
  return /* @__PURE__ */ x(
    Xe,
    {
      label: n("inspector.toolConfig.placements", "Where widgets show"),
      hint: n(
        "inspector.toolConfig.placementsHint",
        "Inline for short summaries, the side panel for dashboards."
      ),
      as: "div",
      children: /* @__PURE__ */ x("div", { className: "flex flex-col gap-1.5", children: Gf.map((a) => {
        const o = r.includes(a);
        return /* @__PURE__ */ te("label", { className: "flex items-center gap-2 text-sm", children: [
          /* @__PURE__ */ x(
            F0,
            {
              "aria-label": i(a),
              checked: o,
              disabled: o && r.length === 1,
              onCheckedChange: (d) => t(
                Gf.filter(
                  (u) => u === a ? d === !0 : r.includes(u)
                )
              )
            }
          ),
          i(a)
        ] }, a);
      }) })
    }
  );
}
function Wr(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e) ? e : {};
}
function eu(e) {
  return Array.isArray(e) ? e.filter((t) => typeof t == "string") : [];
}
function _G(e) {
  return typeof e == "string" && e.trim() !== "" ? e : void 0;
}
function b0(e) {
  return typeof e == "string" && /^\d{4}-\d{2}-\d{2}/.test(e) ? e.slice(0, 10) : void 0;
}
function _0(e) {
  const t = Wr(e), n = {};
  for (const r of ["country", "region", "city", "timezone"]) {
    const i = _G(t[r]);
    i && (n[r] = i);
  }
  return n;
}
function wG(e) {
  const t = Wr(e), n = Wr(t.openai), r = Wr(t.anthropic), i = Wr(t.google), a = Wr(n.filters), o = eu(a.allowedDomains), d = eu(a.blockedDomains), u = _0(n.userLocation), l = Wr(i.timeRangeFilter), c = b0(l.startTime), f = b0(l.endTime), s = n.searchContextSize;
  return {
    allowedDomains: o.length > 0 ? o : eu(r.allowedDomains),
    blockedDomains: d.length > 0 ? d : eu(r.blockedDomains),
    location: Object.keys(u).length > 0 ? u : _0(r.userLocation),
    ...s === "low" || s === "medium" || s === "high" ? { contextSize: s } : {},
    ...n.externalWebAccess === !1 ? { liveResults: !1 } : {},
    ...typeof r.maxUses == "number" ? { maxUses: r.maxUses } : {},
    ...c && f ? { timeRange: { start: c, end: f } } : {}
  };
}
function kG(e) {
  const { allowedDomains: t, blockedDomains: n, contextSize: r, liveResults: i, maxUses: a, timeRange: o } = e, u = Object.keys(e.location).length > 0 ? { type: "approximate", ...e.location } : void 0, l = {
    ...t.length > 0 ? { allowedDomains: t } : {},
    ...n.length > 0 ? { blockedDomains: n } : {}
  }, c = {
    ...Object.keys(l).length > 0 ? { filters: l } : {},
    ...u ? { userLocation: u } : {},
    ...r ? { searchContextSize: r } : {},
    ...i === !1 ? { externalWebAccess: !1 } : {}
  }, f = {
    ...t.length > 0 ? { allowedDomains: t } : n.length > 0 ? { blockedDomains: n } : {},
    ...u ? { userLocation: u } : {},
    ...a !== void 0 ? { maxUses: a } : {}
  }, s = o ? {
    timeRangeFilter: {
      startTime: `${o.start}T00:00:00Z`,
      endTime: `${o.end}T23:59:59Z`
    }
  } : {};
  return {
    ...Object.keys(c).length > 0 ? { openai: c } : {},
    ...Object.keys(f).length > 0 ? { anthropic: f } : {},
    ...Object.keys(s).length > 0 ? { google: s } : {}
  };
}
function w0(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e.split(/[\s,]+/)) {
    const r = n.trim().toLowerCase().replace(/^[a-z][a-z0-9+.-]*:\/\//, "").replace(/[/?#].*$/, "");
    r && t.add(r);
  }
  return [...t];
}
function ip(e, t) {
  switch (t) {
    case "openai":
      return e("inspector.webSearch.provider.openai", "OpenAI");
    case "anthropic":
      return e("inspector.webSearch.provider.anthropic", "Anthropic");
    case "google":
      return e("inspector.webSearch.provider.google", "Gemini");
  }
}
function SG(e) {
  return e === "openai" || e === "anthropic" || e === "google";
}
function xG(e) {
  const t = we((i) => i.doc), n = _l().data, r = /* @__PURE__ */ new Set();
  for (const i of t?.edges ?? []) {
    if (i.type !== "uses-tool" || i.target !== e) continue;
    const a = t?.nodes.find((u) => u.id === i.source);
    if (a?.kind !== "agent" || a.source !== "inline") continue;
    const o = a.llm?.model ?? n?.defaultModelId, d = o ? Mm(n?.models ?? [], o) : void 0;
    SG(d) && r.add(d);
  }
  return r;
}
function Ur({
  value: e,
  onCommit: t,
  ...n
}) {
  const [r, i] = Ae(e), [a, o] = Ae(e);
  return e !== a && (o(e), i(e)), /* @__PURE__ */ x(
    Qt,
    {
      ...n,
      value: r,
      onChange: (d) => i(d.target.value),
      onBlur: () => {
        r !== e && t(r);
      }
    }
  );
}
function Br({ providers: e }) {
  const t = Re(), n = (r) => t("inspector.webSearch.appliesTo", "Applies on {{providers}}", { providers: r });
  return /* @__PURE__ */ te("span", { className: "flex shrink-0 items-center gap-1", children: [
    /* @__PURE__ */ x("span", { className: "sr-only", children: n(e.map((r) => ip(t, r)).join(", ")) }),
    e.map((r) => /* @__PURE__ */ te(Qu, { children: [
      /* @__PURE__ */ x(ec, { asChild: !0, children: /* @__PURE__ */ x("span", { "aria-hidden": !0, className: "flex", children: /* @__PURE__ */ x(pO, { provider: r, className: "size-3.5" }) }) }),
      /* @__PURE__ */ x(tc, { children: n(ip(t, r)) })
    ] }, r))
  ] });
}
function IG({ node: e }) {
  const t = Re(), n = we((g) => g.updateWebSearchNode), r = xG(e.id), i = wG(e.config), a = (g) => n(e.id, kG({ ...i, ...g })), o = (g) => g.map((O) => ip(t, O)).join(", "), d = (g, O) => {
    const P = r.size > 0 && !g.some((E) => r.has(E));
    if (!(!O && !P))
      return /* @__PURE__ */ te(Ue, { children: [
        O,
        P && /* @__PURE__ */ te(Ue, { children: [
          O && " ",
          t(
            "inspector.webSearch.ignored",
            "Ignored while the connected agents run on {{providers}}.",
            {
              providers: o([...r])
            }
          )
        ] })
      ] });
  }, u = [
    { value: "default", label: t("inspector.webSearch.default", "Default") },
    { value: "low", label: t("inspector.webSearch.contextLow", "Low") },
    { value: "medium", label: t("inspector.webSearch.contextMedium", "Medium") },
    { value: "high", label: t("inspector.webSearch.contextHigh", "High") }
  ], l = (g) => g === "" || /^[A-Za-z]{2}$/.test(g.trim()), [c, f] = Ae(!1), s = (g, O) => {
    const P = g === "country" ? O.trim().toUpperCase() : O.trim(), { [g]: E, ...T } = i.location;
    a({ location: P ? { ...T, [g]: P } : T });
  }, h = { start: i.timeRange?.start ?? "", end: i.timeRange?.end ?? "" }, [p, m] = Ae(h), y = `${h.start}|${h.end}`, [w, b] = Ae(y);
  y !== w && (b(y), m(h));
  const _ = (g, O) => {
    const P = { ...p, [g]: O }, E = P.start !== "" && P.end !== "" && P.start <= P.end;
    m(P);
    const T = E ? `${P.start}|${P.end}` : "|";
    b(T), T !== y && a({ timeRange: E ? P : void 0 });
  };
  return /* @__PURE__ */ x(Yu, { children: /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
    /* @__PURE__ */ x(Xu, { children: t(
      "palette.webSearchDescription",
      "Searches the web for current information, through the agent's model provider."
    ) }),
    /* @__PURE__ */ te("p", { className: "text-[11px] text-muted-foreground", children: [
      t(
        "inspector.webSearch.disclaimer",
        "The search is run by the provider of the connected agent's model, so each setting applies only on the providers it names, and the others ignore it."
      ),
      " ",
      r.size > 0 ? t("inspector.webSearch.connected", "The connected agents run on {{providers}}.", {
        providers: o([...r])
      }) : t(
        "inspector.webSearch.notConnected",
        "Connect it to an agent to see which provider runs it."
      )
    ] }),
    /* @__PURE__ */ x(
      Xe,
      {
        label: t("inspector.webSearch.allowedDomains", "Only search these sites"),
        aside: /* @__PURE__ */ x(Br, { providers: ["openai", "anthropic"] }),
        hint: d(
          ["openai", "anthropic"],
          t(
            "inspector.webSearch.domainsHint",
            "Separate sites with commas. Subdomains are included."
          )
        ),
        children: /* @__PURE__ */ x(
          Ur,
          {
            value: i.allowedDomains.join(", "),
            placeholder: t("inspector.webSearch.domainsPlaceholder", "apple.com, reuters.com"),
            onCommit: (g) => a({ allowedDomains: w0(g) })
          }
        )
      }
    ),
    /* @__PURE__ */ x(
      Xe,
      {
        label: t("inspector.webSearch.blockedDomains", "Never search these sites"),
        aside: /* @__PURE__ */ x(Br, { providers: ["openai", "anthropic"] }),
        hint: d(
          ["openai", "anthropic"],
          i.allowedDomains.length > 0 ? t(
            "inspector.webSearch.blockedWithAllowed",
            "Anthropic takes one list only, so it uses the sites to search."
          ) : void 0
        ),
        children: /* @__PURE__ */ x(
          Ur,
          {
            value: i.blockedDomains.join(", "),
            placeholder: t("inspector.webSearch.blockedPlaceholder", "reddit.com"),
            onCommit: (g) => a({ blockedDomains: w0(g) })
          }
        )
      }
    ),
    /* @__PURE__ */ te(
      Xe,
      {
        label: t("inspector.webSearch.location", "Search from a location"),
        aside: /* @__PURE__ */ x(Br, { providers: ["openai", "anthropic"] }),
        hint: d(
          ["openai", "anthropic"],
          t(
            "inspector.webSearch.locationHint",
            "Ranks results for that place. All fields are optional."
          )
        ),
        as: "div",
        children: [
          /* @__PURE__ */ te("div", { className: "grid grid-cols-2 gap-2", children: [
            /* @__PURE__ */ x(
              Ur,
              {
                "aria-label": t("inspector.webSearch.country", "Country"),
                "aria-invalid": c || void 0,
                value: i.location.country ?? "",
                placeholder: t("inspector.webSearch.countryPlaceholder", "Country (GB)"),
                maxLength: 2,
                onCommit: (g) => {
                  const O = l(g);
                  f(!O), O && s("country", g);
                }
              }
            ),
            /* @__PURE__ */ x(
              Ur,
              {
                "aria-label": t("inspector.webSearch.region", "Region"),
                value: i.location.region ?? "",
                placeholder: t("inspector.webSearch.region", "Region"),
                onCommit: (g) => s("region", g)
              }
            ),
            /* @__PURE__ */ x(
              Ur,
              {
                "aria-label": t("inspector.webSearch.city", "City"),
                value: i.location.city ?? "",
                placeholder: t("inspector.webSearch.city", "City"),
                onCommit: (g) => s("city", g)
              }
            ),
            /* @__PURE__ */ x(
              Ur,
              {
                "aria-label": t("inspector.webSearch.timezone", "Time zone"),
                value: i.location.timezone ?? "",
                placeholder: t("inspector.webSearch.timezonePlaceholder", "Europe/London"),
                onCommit: (g) => s("timezone", g)
              }
            )
          ] }),
          c && /* @__PURE__ */ x("p", { className: "text-[11px] text-destructive", children: t(
            "inspector.webSearch.countryInvalid",
            "Use a two-letter country code, such as GB."
          ) })
        ]
      }
    ),
    /* @__PURE__ */ x(
      Xe,
      {
        label: t("inspector.webSearch.contextSize", "How much of each page to read"),
        aside: /* @__PURE__ */ x(Br, { providers: ["openai"] }),
        hint: d(
          ["openai"],
          t(
            "inspector.webSearch.contextSizeHint",
            "More context answers better, and costs more and takes longer."
          )
        ),
        as: "div",
        children: /* @__PURE__ */ x(
          Fo,
          {
            options: u,
            value: i.contextSize ?? "default",
            onChange: (g) => a({ contextSize: g === "default" ? void 0 : g })
          }
        )
      }
    ),
    /* @__PURE__ */ x(
      dI,
      {
        label: t("inspector.webSearch.liveResults", "Fetch live pages"),
        aside: /* @__PURE__ */ x(Br, { providers: ["openai"] }),
        hint: d(
          ["openai"],
          t(
            "inspector.webSearch.liveResultsHint",
            "Off uses cached results, which is faster but can be out of date."
          )
        ),
        checked: i.liveResults !== !1,
        onCheckedChange: (g) => a({ liveResults: g ? void 0 : !1 })
      }
    ),
    /* @__PURE__ */ x(
      Xe,
      {
        label: t("inspector.webSearch.maxUses", "Most searches per answer"),
        aside: /* @__PURE__ */ x(Br, { providers: ["anthropic"] }),
        hint: d(
          ["anthropic"],
          t("inspector.webSearch.maxUsesHint", "Leave empty for no limit.")
        ),
        children: /* @__PURE__ */ x(
          Ur,
          {
            type: "number",
            min: 1,
            step: 1,
            value: i.maxUses === void 0 ? "" : String(i.maxUses),
            onCommit: (g) => {
              const O = Number.parseInt(g, 10);
              a({ maxUses: Number.isFinite(O) && O > 0 ? O : void 0 });
            }
          }
        )
      }
    ),
    /* @__PURE__ */ x(
      Xe,
      {
        label: t("inspector.webSearch.timeRange", "Only results published between"),
        aside: /* @__PURE__ */ x(Br, { providers: ["google"] }),
        hint: d(
          ["google"],
          t("inspector.webSearch.timeRangeHint", "Set both dates, or neither.")
        ),
        as: "div",
        children: /* @__PURE__ */ te("div", { className: "grid grid-cols-2 gap-2", children: [
          /* @__PURE__ */ x(
            Qt,
            {
              type: "date",
              "aria-label": t("inspector.webSearch.timeRangeStart", "From"),
              value: p.start,
              onChange: (g) => _("start", g.target.value)
            }
          ),
          /* @__PURE__ */ x(
            Qt,
            {
              type: "date",
              "aria-label": t("inspector.webSearch.timeRangeEnd", "To"),
              value: p.end,
              onChange: (g) => _("end", g.target.value)
            }
          )
        ] })
      }
    )
  ] }) });
}
const PG = nt({
  key: xe().min(1),
  kind: Lt(["knowledge-base", "guidelines-folder", "guideline-categories", "placements"]),
  optional: On().optional()
});
nt({
  id: xe().min(1),
  name: xe().min(1),
  description: xe().optional(),
  /** The palette section it goes under; `knowledge` and `brand` get their own. */
  category: xe().optional(),
  configFields: Ct(PG).optional(),
  /** Set for a published widget, which the host lists among the tools as `widget:<id>`. */
  widget: nt({
    placement: Lt(["inline", "panel"]),
    status: Lt(["draft", "published", "archived"]),
    publishedVersion: tn().nullable(),
    hasUnpublishedChanges: On(),
    /** Whether any agent shows it; one no agent shows can be deleted. */
    inUse: On().optional()
  }).optional()
});
nt({
  scorerId: xe().min(1),
  label: xe().min(1),
  description: xe(),
  /** Reference-based: needs a dataset `expected`, so it is offline-only. */
  needsExpected: On(),
  usesModel: On(),
  usesCriterion: On(),
  /** True when `options.tools` applies. */
  usesTools: On(),
  replayKind: Lt(["deterministic", "external"])
});
function OG(e, t) {
  return e.usesCriterion && !t.criterion?.trim() ? "criterion" : e.usesTools && (t.tools ?? []).length === 0 ? "tools" : null;
}
nt({
  name: xe(),
  description: xe().optional(),
  /** `false` marks a write tool, which may never run without approval. */
  readOnly: On().optional()
});
nt({
  id: xe().min(1),
  label: xe().min(1),
  description: xe().optional(),
  endpointUrl: xe(),
  transport: Lt(["http", "sse"]),
  writeTools: Ct(xe()).default([]),
  authKind: Lt(["manual", "oauth"])
});
const zG = nt({
  id: xe().min(1),
  label: xe().min(1),
  description: xe().optional(),
  endpointUrl: xe().optional(),
  transport: Lt(["http", "sse"]).default("http"),
  authHint: Lt(["oauth", "manual", "unknown"]).default("unknown"),
  writeTools: Ct(xe()).default([]),
  // Superset of the libs/mcp loader's direct/klavis/demo/custom — 'registry' is
  // set later by the registry route mapper.
  provider: Lt(["direct", "klavis", "demo", "registry", "custom"]).default("custom")
}), EG = Ct(zG);
nt({
  items: EG,
  unavailable: On()
});
const lz = g7("kind", [
  nt({ kind: Yl("bearer"), token: xe().min(1) }),
  nt({ kind: Yl("apiKey"), header: xe().min(1), value: xe().min(1) }),
  nt({ kind: Yl("none") }),
  nt({ kind: Yl("raw"), headers: HO(xe(), xe()) })
]);
nt({
  id: xe().min(1).optional(),
  // server derives from label when absent
  label: xe().min(1),
  description: xe().optional(),
  endpointUrl: xe().min(1),
  transport: Lt(["http", "sse"]).default("http"),
  writeTools: Ct(xe()).default([]),
  auth: lz
});
nt({
  label: xe().min(1).optional(),
  description: xe().optional(),
  endpointUrl: xe().min(1).optional(),
  transport: Lt(["http", "sse"]).optional(),
  writeTools: Ct(xe()).optional(),
  auth: lz.optional()
});
nt({
  label: xe().min(1),
  description: xe().optional(),
  endpointUrl: xe().min(1),
  transport: Lt(["http", "sse"]).default("http"),
  writeTools: Ct(xe()).default([])
});
nt({
  authorizationUrl: xe(),
  connectionId: xe()
});
const TG = nt({
  id: xe().min(1),
  label: xe().min(1),
  provider: xe().min(1),
  providerLabel: xe().min(1),
  tier: xe().min(1).optional(),
  features: Ct(xe().min(1)).optional(),
  contextWindow: tn().int().positive().optional(),
  pricing: nt({
    input: tn().nonnegative(),
    output: tn().nonnegative(),
    cachedInput: tn().nonnegative().optional(),
    cacheWrite: tn().nonnegative().optional(),
    currency: xe().optional()
  }).optional(),
  samplingSupport: Lt(["both", "temperature-or-topP", "none"]).optional(),
  reasoningEffort: nt({ levels: Ct(xe().min(1)).min(1), recommended: xe().min(1) }).optional(),
  userSelectable: On(),
  tags: Ct(xe().min(1)).optional()
}), NG = nt({
  id: xe().min(1),
  label: xe().min(1)
});
nt({
  models: Ct(TG),
  providers: Ct(NG),
  /** What an agent with no model picked runs on. */
  defaultModelId: xe().min(1).optional()
});
nt({
  maxBytesPerFile: tn().positive().optional(),
  maxTotalBytes: tn().positive().optional(),
  maxFiles: tn().int().positive().optional(),
  allowedMediaTypes: Ct(xe().min(1)).optional()
});
const CG = nt({
  traceId: xe(),
  spanId: xe(),
  parentSpanId: xe().optional(),
  name: xe(),
  /** Epoch milliseconds (fractional), converted from OTel HrTime. */
  startMs: tn(),
  endMs: tn(),
  durationMs: tn(),
  /** OTel status code: 0 UNSET, 1 OK, 2 ERROR. */
  statusCode: tn(),
  statusMessage: xe().optional(),
  scope: xe().optional(),
  attributes: HO(xe(), tp())
});
nt({ spans: Ct(CG) });
const DG = _z(
  () => import("./MetadataForm-1Q52SLvT.mjs").then((e) => ({ default: e.MetadataForm }))
);
function AG(e) {
  return [
    { value: "input", label: e("inspector.guards.input", "Input") },
    { value: "output", label: e("inspector.guards.output", "Output") }
  ];
}
function Kf(e) {
  if (e.trim() === "") return;
  const t = Number(e);
  return Number.isNaN(t) ? void 0 : t;
}
function jG(e) {
  const { openai: t, anthropic: n, google: r, ...i } = e, { reasoningEffort: a, ...o } = t ?? {}, { thinking: d, ...u } = n ?? {}, { thinkingConfig: l, ...c } = r ?? {}, f = {
    ...i,
    ...Object.keys(o).length > 0 ? { openai: o } : {},
    ...Object.keys(u).length > 0 ? { anthropic: u } : {},
    ...Object.keys(c).length > 0 ? { google: c } : {}
  };
  return Object.keys(f).length > 0 ? f : void 0;
}
const MG = (e, t) => {
  switch (e) {
    case "minimal":
      return t("inspector.reasoning.minimal", "Minimal");
    case "low":
      return t("inspector.reasoning.low", "Low");
    case "medium":
      return t("inspector.reasoning.medium", "Medium");
    case "high":
      return t("inspector.reasoning.high", "High");
    case "xhigh":
      return t("inspector.reasoning.xhigh", "Extra high");
    case "max":
      return t("inspector.reasoning.max", "Max");
    default:
      return e;
  }
};
function $G({
  support: e,
  value: t,
  onChange: n
}) {
  const r = Re(), i = e.levels.filter((o) => o !== "none"), a = t === void 0 ? -1 : i.indexOf(t);
  return /* @__PURE__ */ x(
    Ih,
    {
      label: r("inspector.reasoning.label", "Reasoning"),
      value: a >= 0 ? a : void 0,
      min: 0,
      max: i.length - 1,
      step: 1,
      restAt: Math.max(0, i.indexOf(e.recommended)),
      format: (o) => MG(i[o] ?? e.recommended, r),
      onChange: (o) => n(o === void 0 ? void 0 : i[o])
    }
  );
}
function RG({
  tools: e,
  onCommit: t
}) {
  const n = Re(), r = O_(e), [i, a] = Ae(r), [o, d] = Ae(r);
  return r !== o && (d(r), a(r)), /* @__PURE__ */ x(
    Xe,
    {
      label: n("inspector.scorer.expectedTools", "Expected tools"),
      hint: n(
        "inspector.scorer.expectedToolsHint",
        "Comma-separated. Scores the fraction of these the agent actually called."
      ),
      children: /* @__PURE__ */ x(
        Qt,
        {
          value: i,
          placeholder: n("inspector.scorer.expectedToolsPlaceholder", "web_search, calculate"),
          onChange: (u) => a(u.target.value),
          onBlur: () => {
            const u = rU(i);
            O_(u) !== r && t(u);
          }
        }
      )
    }
  );
}
function ZG() {
  const e = we((E) => E.doc), t = we((E) => E.selectedNodeId), n = we((E) => E.selectedEdgeId), r = we((E) => E.updateAgentNode), i = we((E) => E.updateRefAgentInput), a = we((E) => E.updateToolNode), o = we((E) => E.updateGuardrailNode), d = we((E) => E.updateScorerNode), { data: u } = a9(), l = we((E) => E.updateGuardsPlacement), c = we((E) => E.updateHandoffDescription), f = we((E) => E.updateAgentAsToolEdge), s = we((E) => E.setEntryNode), h = _l().data, p = h?.models ?? [], m = dr().data, y = wl().data, w = Nc(), { inspector: b } = dt(), _ = Re();
  if (!e)
    return /* @__PURE__ */ x(hk, { cue: "create", size: "md", children: _("inspector.empty", "Create or open a flow to begin") });
  const g = e.nodes.find((E) => E.id === t), O = e.edges.find((E) => E.id === n), P = g?.kind === "tool" ? Ge.widgetIdOfTool(g.toolId) : void 0;
  if (g && g.kind === "tool" && P && b.widget)
    return /* @__PURE__ */ x("div", { className: "flex flex-col gap-3 p-3", children: b.widget({ node: g, widgetId: P }) });
  if (g && g.kind === "tool") {
    const E = m?.find((N) => N.id === g.toolId), T = E?.configFields, D = P || E?.category === "widget" ? Ph(_).filter((N) => N.value !== "needs_approval") : Ph(_);
    return /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
      E?.description && /* @__PURE__ */ x(Xu, { children: E.description }),
      T && T.length > 0 && // Keyed by node: what a picker is showing belongs to the node it was opened on.
      /* @__PURE__ */ x(mG, { node: g, fields: T }, g.id),
      b.toolSections?.({
        node: g,
        onConfigChange: (N) => a(g.id, { config: N })
      }),
      /* @__PURE__ */ x(
        Xe,
        {
          label: _("inspector.tool.policy", "Policy"),
          hint: _(
            "inspector.tool.policyHint",
            "Deny keeps the connection but removes the tool from the agent (shown as a severed edge)."
          ),
          as: "div",
          children: /* @__PURE__ */ x(
            Fo,
            {
              options: D,
              value: g.policy,
              onChange: (N) => a(g.id, { policy: N })
            }
          )
        }
      )
    ] });
  }
  if (g && g.kind === "web-search")
    return /* @__PURE__ */ x(IG, { node: g }, g.id);
  if (g && g.kind === "agent" && g.source === "ref") {
    const E = y?.find((T) => T.id === g.agentId)?.description;
    return /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
      E && /* @__PURE__ */ x("p", { className: "text-xs text-foreground", children: E }),
      e.entryNodeId === g.id ? /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: _("inspector.agent.isEntry", "This agent is the flow entry point.") }) : /* @__PURE__ */ x(Tt, { size: "sm", variant: "outline", onClick: () => s(g.id), children: _("inspector.agent.setEntry", "Set as entry") }),
      /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: _(
        "inspector.agent.refReadOnly",
        "Referenced agents are read-only; edit them where they are defined."
      ) }),
      b.refAgentSections?.({
        node: { ...g, source: "ref" },
        onInputChange: (T) => i(g.id, T)
      })
    ] });
  }
  if (g && g.kind === "agent" && g.source === "inline") {
    const E = g.llm?.model ?? h?.defaultModelId, T = E ? Mm(p, E) : void 0, D = g.llm?.providerOptions ?? {}, N = T === "anthropic" ? 1 : 2, M = g.memoryConfig?.useMemory === !0, R = /* @__PURE__ */ te("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ x(
        dI,
        {
          label: _("inspector.agent.useMemory", "Use memory"),
          hint: _(
            "inspector.agent.useMemoryHint",
            "Keeps the latest turns of the conversation in front of the agent."
          ),
          checked: M,
          onCheckedChange: (k) => r(g.id, {
            memoryConfig: k ? { useMemory: !0, maxTurns: g.memoryConfig?.maxTurns ?? 10 } : void 0
          })
        }
      ),
      M && /* @__PURE__ */ x(Xe, { label: _("inspector.agent.maxTurns", "Max turns"), children: /* @__PURE__ */ x(
        Qt,
        {
          type: "number",
          value: g.memoryConfig?.maxTurns ?? 10,
          onChange: (k) => {
            const I = Kf(k.target.value);
            r(g.id, {
              memoryConfig: {
                useMemory: !0,
                maxTurns: I ?? g.memoryConfig?.maxTurns ?? 10
              }
            });
          }
        }
      ) })
    ] }), V = E ? jm(p, E) : void 0, C = V?.samplingSupport, B = V?.reasoningEffort, G = C === "temperature-or-topP", Q = /* @__PURE__ */ x(
      gu,
      {
        value: E,
        ...E === void 0 ? { placeholder: _("inspector.agent.defaultModel", "Default model") } : {},
        onChange: (k) => r(g.id, { model: k })
      }
    );
    return /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
      e.entryNodeId === g.id ? /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: _("inspector.agent.isEntry", "This agent is the flow entry point.") }) : /* @__PURE__ */ x(Tt, { size: "sm", variant: "outline", onClick: () => s(g.id), children: _("inspector.agent.setEntry", "Set as entry") }),
      /* @__PURE__ */ x(Xe, { label: _("inspector.agent.instructions", "Instructions"), children: /* @__PURE__ */ x(
        mo,
        {
          rows: 8,
          value: g.instructions ?? "",
          onChange: (k) => r(g.id, { instructions: k.target.value })
        }
      ) }),
      /* @__PURE__ */ x(un, { children: _("inspector.agent.modelSection", "Model & sampling") }),
      b.modelField ? b.modelField({
        node: g,
        select: Q,
        onChange: (k) => r(g.id, k)
      }) : /* @__PURE__ */ x(Xe, { label: _("inspector.agent.model", "Model"), children: Q }),
      C !== "none" && /* @__PURE__ */ te(Ue, { children: [
        G && /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: _(
          "inspector.agent.samplingOneOf",
          "This model takes one of temperature and top P, so setting one clears the other."
        ) }),
        /* @__PURE__ */ x(
          Ih,
          {
            label: _("inspector.agent.temperature", "Temperature"),
            value: g.llm?.sampling?.temperature,
            min: 0,
            max: N,
            step: 0.05,
            restAt: Math.min(1, N),
            onChange: (k) => r(
              g.id,
              G && k !== void 0 ? { temperature: k, topP: void 0 } : { temperature: k }
            )
          }
        ),
        /* @__PURE__ */ x(
          Ih,
          {
            label: _("inspector.agent.topP", "Top P"),
            value: g.llm?.sampling?.topP,
            min: 0,
            max: 1,
            step: 0.05,
            restAt: 1,
            onChange: (k) => r(
              g.id,
              G && k !== void 0 ? { topP: k, temperature: void 0 } : { topP: k }
            )
          }
        )
      ] }),
      B && /* @__PURE__ */ x(
        $G,
        {
          support: B,
          value: g.llm?.reasoningEffort,
          onChange: (k) => r(g.id, {
            reasoningEffort: k,
            providerOptions: jG(D)
          })
        }
      ),
      /* @__PURE__ */ x(
        jN,
        {
          title: _("inspector.agent.advanced", "Advanced"),
          defaultOpen: g.llm?.maxOutputTokens !== void 0 || g.maxToolSteps !== void 0,
          children: /* @__PURE__ */ te("div", { className: "flex flex-col gap-3", children: [
            /* @__PURE__ */ x(Xe, { label: _("inspector.agent.maxOutputTokens", "Max output tokens"), children: /* @__PURE__ */ x(
              Qt,
              {
                type: "number",
                value: g.llm?.maxOutputTokens ?? "",
                onChange: (k) => r(g.id, { maxOutputTokens: Kf(k.target.value) })
              }
            ) }),
            /* @__PURE__ */ x(
              Xe,
              {
                label: _("inspector.agent.maxToolSteps", "Max tool steps"),
                hint: _(
                  "inspector.agent.maxToolStepsHint",
                  "Rounds of tool calls before the agent has to answer."
                ),
                children: /* @__PURE__ */ x(
                  Qt,
                  {
                    type: "number",
                    min: 1,
                    max: qu.FLOW_MAX_TOOL_STEPS,
                    placeholder: _("inspector.agent.maxToolStepsDefault", "{{steps}} (default)", {
                      steps: qu.DEFAULT_MAX_TOOL_STEPS
                    }),
                    value: g.maxToolSteps ?? "",
                    onChange: (k) => r(g.id, { maxToolSteps: Kf(k.target.value) })
                  }
                )
              }
            )
          ] })
        },
        g.id
      ),
      /* @__PURE__ */ x(un, { children: _("inspector.description", "Description") }),
      /* @__PURE__ */ x(Xe, { label: _("inspector.agent.userFacing", "User-facing"), children: /* @__PURE__ */ x(
        mo,
        {
          rows: 2,
          value: g.description?.user ?? "",
          onChange: (k) => r(g.id, {
            description: { user: k.target.value, llm: g.description?.llm ?? "" }
          })
        }
      ) }),
      /* @__PURE__ */ x(Xe, { label: _("inspector.agent.llmFacing", "LLM-facing"), children: /* @__PURE__ */ x(
        mo,
        {
          rows: 2,
          value: g.description?.llm ?? "",
          onChange: (k) => r(g.id, {
            description: { user: g.description?.user ?? "", llm: k.target.value }
          })
        }
      ) }),
      b.agentSections ? b.agentSections({
        node: g,
        isEntry: e.entryNodeId === g.id,
        onMetadataChange: (k) => r(g.id, { metadata: k }),
        memory: R
      }) : /* @__PURE__ */ te(Ue, { children: [
        /* @__PURE__ */ x(un, { children: _("inspector.agent.memory", "Memory") }),
        R,
        /* @__PURE__ */ x(un, { children: _("inspector.agent.metadata", "Metadata") }),
        /* @__PURE__ */ x(wz, { fallback: null, children: /* @__PURE__ */ x(
          DG,
          {
            value: g.metadata,
            onChange: (k) => r(g.id, { metadata: k })
          }
        ) })
      ] })
    ] });
  }
  if (g && g.kind === "guardrail")
    return /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
      /* @__PURE__ */ te(Xe, { label: _("inspector.criterion", "Criterion"), children: [
        /* @__PURE__ */ x(
          mo,
          {
            rows: 5,
            value: g.criterion,
            onChange: (E) => o(g.id, { criterion: E.target.value })
          }
        ),
        g.criterion.trim() === "" && /* @__PURE__ */ x("span", { className: "text-[11px] text-warning-foreground", children: _("inspector.guardrail.criterionRequired", "A criterion is required to run.") })
      ] }),
      /* @__PURE__ */ x(Xe, { label: _("inspector.judgeModel", "Judge model"), children: /* @__PURE__ */ x(
        gu,
        {
          value: g.model,
          placeholder: _("inspector.guardrail.flowDefault", "Flow default"),
          onChange: (E) => o(g.id, { model: E })
        }
      ) })
    ] });
  if (g && g.kind === "scorer") {
    const E = u ?? [], T = E.find((R) => R.scorerId === g.scorerId), D = Array.isArray(g.options?.tools) ? g.options.tools.filter((R) => typeof R == "string") : [], N = T ? OG(T, { criterion: g.criterion, tools: D }) : null, M = N === "criterion" ? _(
      "inspector.scorer.needsCriterion",
      "{{scorer}} needs a criterion; without one it has nothing to grade the output against.",
      { scorer: T?.label ?? g.scorerId }
    ) : N === "tools" ? _(
      "inspector.scorer.needsTools",
      "{{scorer}} needs at least one expected tool; with nothing to look for it cannot measure anything, and reports no score at all.",
      { scorer: T?.label ?? g.scorerId }
    ) : null;
    return /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
      /* @__PURE__ */ te(Xe, { label: _("inspector.scorer.scorer", "Scorer"), children: [
        /* @__PURE__ */ te(
          "select",
          {
            className: hF,
            value: g.scorerId,
            onChange: (R) => d(g.id, { scorerId: R.target.value }),
            children: [
              /* @__PURE__ */ x("option", { value: "", children: _("inspector.scorer.pick", "Pick a scorer…") }),
              E.map((R) => /* @__PURE__ */ x("option", { value: R.scorerId, children: R.label }, R.scorerId))
            ]
          }
        ),
        g.scorerId.trim() === "" && /* @__PURE__ */ x("span", { className: "text-[11px] text-warning-foreground", children: _("inspector.scorer.required", "A scorer is required to run.") }),
        T && /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: T.description }),
        T?.needsExpected && /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: Jm(
          (R) => _(
            "inspector.scorer.referenceBased",
            "Reference-based: needs an {{field}} value in the dataset, so it only runs in offline evaluation.",
            R
          ),
          { field: /* @__PURE__ */ x("code", { children: "expected" }) }
        ) })
      ] }),
      /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: _(
        "inspector.scorer.resultsKey",
        "Results are reported under the name above, or under the scorer id if you leave it blank."
      ) }),
      T?.usesCriterion && /* @__PURE__ */ x(Xe, { label: _("inspector.criterion", "Criterion"), children: /* @__PURE__ */ x(
        mo,
        {
          rows: 4,
          value: g.criterion ?? "",
          onChange: (R) => d(g.id, { criterion: R.target.value })
        }
      ) }),
      T?.usesModel && /* @__PURE__ */ x(
        Xe,
        {
          label: _("inspector.judgeModel", "Judge model"),
          hint: _(
            "inspector.scorer.judgeModelHint",
            "Scorer models resolve through the scoring library's own client, not the engine model catalog, so eval spend does not appear in the cost panel."
          ),
          children: /* @__PURE__ */ x(
            gu,
            {
              value: g.model,
              placeholder: _("inspector.scorer.default", "Scorer default"),
              onChange: (R) => d(g.id, { model: R })
            }
          )
        }
      ),
      T?.usesTools && /* @__PURE__ */ x(
        RG,
        {
          tools: D,
          onCommit: (R) => d(g.id, { options: { tools: R } })
        }
      ),
      M && /* @__PURE__ */ x("span", { className: "text-[11px] text-warning-foreground", children: M })
    ] });
  }
  if (g && g.kind === "mcp-connection")
    return /* @__PURE__ */ x(hG, { node: g });
  if (!g && O) {
    if (O.type === "guards")
      return /* @__PURE__ */ x("div", { className: "flex flex-col gap-3 p-3", children: /* @__PURE__ */ x(
        Xe,
        {
          label: _("inspector.guards.placement", "Placement"),
          hint: _(
            "inspector.guards.placementHint",
            "Input evaluates the incoming message before the agent runs; output evaluates the agent's response."
          ),
          as: "div",
          children: /* @__PURE__ */ x(
            Fo,
            {
              options: AG(_),
              value: O.placement,
              onChange: (E) => l(O.id, E)
            }
          )
        }
      ) });
    if (O.type === "scores") {
      const E = e.nodes.find((D) => D.id === O.target), T = E && E.kind === "scorer" && (O.key?.trim() || E.name?.trim() || E.scorerId.trim()) || O.target;
      return /* @__PURE__ */ x("div", { className: "flex flex-col gap-3 p-3", children: /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: Jm(
        (D) => _(
          "inspector.scores.body",
          "Results are reported under {{key}}. Scoring is post-hoc: unlike a guardrail, it never blocks the run. Configure the scorer on its own node.",
          D
        ),
        { key: /* @__PURE__ */ x("code", { children: T }) }
      ) }) });
    }
    if (O.type === "handoff") {
      const E = e.nodes.find((D) => D.id === O.target), T = E ? Tc(E, w, _) : O.target;
      return /* @__PURE__ */ x("div", { className: "flex flex-col gap-3 p-3", children: /* @__PURE__ */ x(Xe, { label: _("inspector.description", "Description"), children: /* @__PURE__ */ x(
        Qt,
        {
          value: O.description ?? "",
          placeholder: _("inspector.handoff.placeholder", "Hand off to {{name}}", {
            name: T
          }),
          onChange: (D) => c(O.id, D.target.value)
        }
      ) }) });
    }
    return O.type === "uses-agent-as-tool" ? /* @__PURE__ */ te("div", { className: "flex flex-col gap-3 p-3", children: [
      /* @__PURE__ */ x(Xe, { label: _("inspector.agentTool.toolName", "Tool name"), children: /* @__PURE__ */ x(
        Qt,
        {
          value: O.toolName ?? "",
          onChange: (E) => f(O.id, { toolName: E.target.value })
        }
      ) }),
      /* @__PURE__ */ x(Xe, { label: _("inspector.description", "Description"), children: /* @__PURE__ */ x(
        Qt,
        {
          value: O.description ?? "",
          onChange: (E) => f(O.id, { description: E.target.value })
        }
      ) })
    ] }) : /* @__PURE__ */ x("div", { className: "flex flex-col gap-3 p-3", children: /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: _(
      "inspector.toolLink.body",
      "Tool identity and policy are configured on the tool node."
    ) }) });
  }
  return null;
}
const LG = [];
function FG({ node: e }) {
  const t = Re(), n = dr().data, r = To((l) => l.issuesByNode[e.id] ?? LG), i = we((l) => l.doc?.nodes), a = we((l) => l.doc?.edges), o = we((l) => l.doc?.entryNodeId), d = Le(
    () => i && a && o !== void 0 ? uO({ nodes: i, edges: a, entryNodeId: o }).has(e.id) : !1,
    [i, a, o, e.id]
  ), u = Le(() => {
    const l = n ? lO(
      [e],
      new Set(n.map((c) => c.id)),
      t,
      (c) => n.find((f) => f.id === c)
    )[e.id] : sO(e, t);
    return Array.from(
      /* @__PURE__ */ new Set([...l?.issues ?? [], ...r, ...cO(l, d, t)])
    );
  }, [e, n, r, d, t]);
  return u.length === 0 ? null : (
    // Tessra's Alert has no warning variant, so the warning tokens are composed here, as the canvas
    // card's own warning glyph is.
    /* @__PURE__ */ te(
      $z,
      {
        "data-testid": "node-problems",
        iconPosition: "left",
        icon: /* @__PURE__ */ x(sc, { "aria-hidden": !0 }),
        className: "mx-3 mt-3 w-auto border-warning bg-warning text-warning-foreground",
        children: [
          /* @__PURE__ */ x(Rz, { children: t("inspector.problems.title", "Needs attention") }),
          /* @__PURE__ */ x(Zz, { className: "text-warning-foreground", children: /* @__PURE__ */ x("ul", { className: "m-0 list-disc pl-md", children: u.map((l) => /* @__PURE__ */ x("li", { children: l }, l)) }) })
        ]
      }
    )
  );
}
function UG(e) {
  return e.kind === "agent" && e.source === "inline" || e.kind === "guardrail" || e.kind === "scorer";
}
function BG(e, t) {
  return e.kind === "scorer" ? e.scorerId || t("inspector.scorerPlaceholder", "scorer") : t("inspector.name", "Name");
}
function VG(e, t) {
  switch (e) {
    case "handoff":
      return t("inspector.handoff.title", "Handoff");
    case "uses-agent-as-tool":
      return t("inspector.agentTool.title", "Agent as tool");
    case "uses-tool":
      return t("inspector.toolLink.title", "Tool link");
    case "guards":
      return t("inspector.guards.title", "Guardrail link");
    case "scores":
      return t("inspector.scores.title", "Scorer link");
  }
}
function qG({ edge: e, targetType: t }) {
  const n = e.type === "handoff", r = n ? LT : QT;
  return /* @__PURE__ */ x(
    "span",
    {
      className: Be(
        "flex size-7 shrink-0 items-center justify-center rounded-md",
        n ? "bg-badge-orange text-badge-orange-foreground" : Po[t].tile
      ),
      children: /* @__PURE__ */ x(r, { className: "size-4", "aria-hidden": !0 })
    }
  );
}
function Vm() {
  const e = we((a) => a.doc), t = we((a) => a.selectedNodeId), n = we((a) => a.selectedEdgeId), r = e?.nodes.find((a) => a.id === t), i = !!(e && n && e.edges.some((a) => a.id === n));
  return !!(r || i);
}
function HG() {
  const e = we((r) => r.selectedNodeId ?? r.selectedEdgeId), t = Ot((r) => r.setInspectorMinimized), n = Ce(e);
  Ze(() => {
    e && e !== n.current && t(!1), n.current = e;
  }, [e, t]);
}
function WG({ onMinimize: e } = {}) {
  const t = we((g) => g.doc), n = we((g) => g.selectedNodeId), r = we((g) => g.selectedEdgeId), i = we((g) => g.selectNode), a = we((g) => g.updateAgentNode), o = we((g) => g.updateGuardrailNode), d = we((g) => g.updateScorerNode), u = dr().data ?? [], l = Nc(), c = Re(), f = t?.nodes.find((g) => g.id === n), s = f ? void 0 : t?.edges.find((g) => g.id === r);
  if (!f && !s) return null;
  const h = (g) => g.kind === "tool" ? sr(u.find((O) => O.id === g.toolId)) : i9(g), p = (g) => aO(g, c) ?? Tc(g, l, c), m = (g) => {
    const O = g.kind === "tool" ? u.find((P) => P.id === g.toolId)?.widget : void 0;
    return O ? O.placement === "inline" ? c("entity.widgetInline", "Inline widget") : c("entity.widgetPanel", "Side panel widget") : ZN(h(g), c);
  }, y = (g) => t?.nodes.find((O) => O.id === g), w = s ? y(s.source) : void 0, b = s ? y(s.target) : void 0, _ = (g) => {
    f && (f.kind === "guardrail" ? o(f.id, { name: g }) : f.kind === "agent" ? a(f.id, { name: g }) : f.kind === "scorer" && d(f.id, { name: g || void 0 }));
  };
  return /* @__PURE__ */ te(Ue, { children: [
    /* @__PURE__ */ te(
      "div",
      {
        "data-testid": "inspector-header",
        className: "flex shrink-0 items-center gap-2.5 border-b border-border-light p-3",
        children: [
          f ? /* @__PURE__ */ te(Ue, { children: [
            f.kind === "agent" && f.source === "ref" ? /* @__PURE__ */ x($m, { agentId: f.agentId, size: "md" }) : /* @__PURE__ */ x(Wo, { type: h(f), size: "md" }),
            /* @__PURE__ */ te("div", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ x(un, { children: m(f) }),
              UG(f) ? /* @__PURE__ */ x(
                "input",
                {
                  value: f.name ?? "",
                  onChange: (g) => _(g.target.value),
                  placeholder: BG(f, c),
                  "aria-label": c("inspector.name", "Name"),
                  className: "-mx-1 w-full rounded border border-transparent bg-transparent px-1 text-sm font-semibold text-foreground outline-none hover:border-border-light focus:border-primary"
                }
              ) : /* @__PURE__ */ x("span", { className: "truncate text-sm font-semibold text-foreground", children: p(f) })
            ] })
          ] }) : s ? /* @__PURE__ */ te(Ue, { children: [
            /* @__PURE__ */ x(qG, { edge: s, targetType: b ? h(b) : "tool" }),
            /* @__PURE__ */ te("div", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ x(un, { children: VG(s.type, c) }),
              /* @__PURE__ */ x("span", { className: "truncate text-sm font-semibold text-foreground", children: c("inspector.edge.route", "{{source}} → {{target}}", {
                source: w ? p(w) : s.source,
                target: b ? p(b) : s.target
              }) })
            ] })
          ] }) : null,
          /* @__PURE__ */ te("div", { className: "ml-auto flex shrink-0 items-center", children: [
            e && /* @__PURE__ */ x(
              im,
              {
                label: c("inspector.minimize", "Minimize inspector"),
                onClick: e
              }
            ),
            /* @__PURE__ */ x(
              "button",
              {
                type: "button",
                "aria-label": c("inspector.close", "Close inspector"),
                onClick: () => i(null),
                className: "flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-muted",
                children: /* @__PURE__ */ x(vp, { className: "size-4" })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ te("div", { className: "min-h-0 flex-1 overflow-y-auto", children: [
      f && /* @__PURE__ */ x(FG, { node: f }),
      /* @__PURE__ */ x(ZG, {})
    ] })
  ] });
}
function GG() {
  const e = Ot((o) => o.inspectorWidth), t = Ot((o) => o.setInspectorWidth), n = Ot((o) => o.inspectorMinimized), r = Ot((o) => o.setInspectorMinimized), i = Vm(), a = Re();
  return !i || n ? null : /* @__PURE__ */ x(
    bp,
    {
      side: "right",
      role: "dialog",
      ariaLabel: a("inspector.title", "Inspector"),
      resize: { width: e, minWidth: 240, onResize: t },
      children: /* @__PURE__ */ x(WG, { onMinimize: () => r(!0) })
    }
  );
}
function KG() {
  const e = Vm(), t = Ot((i) => i.inspectorMinimized), n = Ot((i) => i.setInspectorMinimized), r = Re();
  return !e || !t ? null : /* @__PURE__ */ x(
    hI,
    {
      icon: /* @__PURE__ */ x(kN, { className: "size-4", "aria-hidden": !0 }),
      label: r("inspector.title", "Inspector"),
      title: r("inspector.restore", "Show the inspector"),
      onRestore: () => n(!1)
    }
  );
}
function JG() {
  const e = Re(), { copilot: t } = dt(), n = Ir((i) => i.open), r = Ir((i) => i.setOpen);
  return !t || n ? null : /* @__PURE__ */ te(
    Tt,
    {
      size: "sm",
      variant: "outline",
      className: "shrink-0 gap-xs bg-background",
      "aria-label": e("copilot.open", "Ask Flow.Assist to build or change this agent"),
      title: e("copilot.open", "Ask Flow.Assist to build or change this agent"),
      onClick: () => {
        r(!0), requestAnimationFrame(
          () => document.querySelector("[data-flow-assist-dock] textarea")?.focus()
        );
      },
      children: [
        /* @__PURE__ */ x(fk, { className: "size-4 text-primary", "aria-hidden": !0 }),
        e("copilot.title", "Flow.Assist")
      ]
    }
  );
}
const XG = { type: "spring", stiffness: 280, damping: 32, mass: 0.8 }, k0 = "var(--space-app-inset, var(--space-sm))", YG = 56;
function tJ({ sidePanel: e, cover: t }) {
  const n = Re(), r = Ot((b) => b.inspectorWidth), i = Ot((b) => b.setInspectorWidth), a = Ot((b) => b.copilotWidth), o = Ot((b) => b.setCopilotWidth), d = Ot((b) => b.inspectorMinimized), u = Vm();
  HG();
  const l = u && !d, { copilot: c } = dt(), f = Ir((b) => b.open) && !!c, s = iU(f), h = e9(), p = f ? 1 : 0, m = {
    width: `calc(var(--assist-reveal) * (${String(a)}px + ${k0}))`,
    paddingRight: `calc(var(--assist-reveal) * ${k0})`
  }, y = {
    "data-flow-assist-dock": "",
    className: "flex h-full shrink-0 overflow-hidden",
    // Closing only slides it away, so the conversation is still there when it opens again.
    inert: !f,
    ...f ? {} : { "aria-hidden": !0 }
  }, w = c && /* @__PURE__ */ x(
    VN,
    {
      width: a,
      minWidth: 300,
      maxWidth: 640,
      defaultWidth: fI,
      onResize: o,
      children: /* @__PURE__ */ x(
        F9,
        {
          ...c.transport ? { transport: c.transport } : {},
          ...c.chat ? { chat: c.chat } : {}
        }
      )
    }
  );
  return fG(), /* @__PURE__ */ te("div", { className: "flex h-full w-full", children: [
    c && s && (h ? /* @__PURE__ */ x("div", { ...y, style: { ...m, "--assist-reveal": p }, children: w }) : /* @__PURE__ */ x(
      t9.div,
      {
        ...y,
        style: m,
        initial: { "--assist-reveal": 0, opacity: 0 },
        animate: { "--assist-reveal": p, opacity: p },
        transition: XG,
        children: w
      }
    )),
    /* @__PURE__ */ te(
      "div",
      {
        className: `relative h-full min-w-0 flex-1 overflow-hidden ${t ? "" : "agentic-dock"}`,
        children: [
          /* @__PURE__ */ x("div", { className: t ? "invisible h-full" : "contents", children: /* @__PURE__ */ x(aG, {}) }),
          t ? /* @__PURE__ */ x("div", { className: "absolute inset-0 z-10 flex min-h-0 flex-col", children: t }) : /* @__PURE__ */ te(Ue, { children: [
            /* @__PURE__ */ x(sG, { top: c && !f ? YG : 16 }),
            l ? /* @__PURE__ */ x(GG, {}) : e && /* @__PURE__ */ x(
              bp,
              {
                side: "right",
                fill: !0,
                role: "complementary",
                ariaLabel: n("builder.sidePanel", "Run details"),
                resize: { width: r, minWidth: 280, onResize: i },
                children: e
              }
            ),
            u && d && /* @__PURE__ */ x(
              "div",
              {
                className: "absolute top-4 z-10 flex items-center gap-xs",
                style: { right: e ? r + FN : 16 },
                children: /* @__PURE__ */ x(KG, {})
              }
            )
          ] }),
          !t && c && !f && /* @__PURE__ */ x("div", { className: "absolute left-4 top-4 z-20", children: /* @__PURE__ */ x(JG, {}) })
        ]
      }
    )
  ] });
}
nt({ compaction: Uz.nullable() });
const QG = { runs: {}, runOrder: [], nodes: {}, suspensionTokens: {} }, eK = /* @__PURE__ */ new Set([
  "completed",
  "error",
  "aborted"
]);
function Jf(e, t) {
  return e[t] ?? QG;
}
zr((e) => ({
  sessions: {},
  upsertRun: (t, n) => e((r) => {
    const i = Jf(r.sessions, t), a = !(n.runId in i.runs);
    let o = i.suspensionTokens;
    if (eK.has(n.status) && n.runId in o) {
      const { [n.runId]: d, ...u } = o;
      o = u;
    }
    return {
      sessions: {
        ...r.sessions,
        [t]: {
          ...i,
          runs: { ...i.runs, [n.runId]: n },
          runOrder: a ? [...i.runOrder, n.runId] : i.runOrder,
          suspensionTokens: o
        }
      }
    };
  }),
  upsertNode: (t, n) => e((r) => {
    const i = Jf(r.sessions, t);
    return {
      sessions: {
        ...r.sessions,
        [t]: {
          ...i,
          nodes: { ...i.nodes, [n.nodeId]: n }
        }
      }
    };
  }),
  setSuspensionToken: (t, n, r) => e((i) => {
    const a = Jf(i.sessions, t);
    return {
      sessions: {
        ...i.sessions,
        [t]: {
          ...a,
          suspensionTokens: { ...a.suspensionTokens, [n]: r }
        }
      }
    };
  }),
  dropSuspensionTokens: (t) => e((n) => {
    const r = n.sessions[t];
    return r ? { sessions: { ...n.sessions, [t]: { ...r, suspensionTokens: {} } } } : n;
  }),
  clearSession: (t) => e((n) => {
    const { [t]: r, ...i } = n.sessions;
    return { sessions: i };
  })
}));
const rl = { inputTokens: 0, outputTokens: 0, cachedInputTokens: 0 };
function tK(e) {
  const t = e.filter((i) => i.type === "agent:end" && i.usage), n = Object.fromEntries(
    t.map((i, a) => {
      const o = i.nodeId ?? `#${a}`;
      return [o, { nodeId: o, parentNodeId: i.parentNodeId ?? null, usage: i.usage }];
    })
  ), r = { ...rl };
  for (const i of U0(n).values())
    r.inputTokens += i.inputTokens, r.outputTokens += i.outputTokens, r.cachedInputTokens += i.cachedInputTokens;
  return r;
}
function Xf(e, t) {
  return t ? e[t] ?? { events: [], usage: { ...rl } } : { events: [], usage: { ...rl } };
}
zr((e, t) => ({
  isRunning: !1,
  activeSessionId: null,
  sessions: {},
  traceEvents: [],
  totalUsage: { ...rl },
  setRunning: (n) => e({ isRunning: n }),
  setActiveSession: (n) => {
    const r = Xf(t().sessions, n);
    e({
      activeSessionId: n,
      traceEvents: r.events,
      totalUsage: r.usage
    });
  },
  addTraceEvent: (n, r) => e((i) => {
    const a = Xf(i.sessions, n), o = [...a.events, r], d = r.type === "agent:end" && r.usage ? tK(o) : a.usage, u = i.activeSessionId === n ? { traceEvents: o, totalUsage: d } : {};
    return {
      sessions: { ...i.sessions, [n]: { events: o, usage: d } },
      ...u
    };
  }),
  addRunSeparator: (n) => e((r) => {
    const i = Xf(r.sessions, n), a = {
      type: "run:separator",
      agentId: "",
      timestamp: Date.now(),
      isSeparator: !0
    }, o = [...i.events, a];
    return {
      sessions: { ...r.sessions, [n]: { ...i, events: o } },
      ...r.activeSessionId === n ? { traceEvents: o } : {}
    };
  }),
  reset: () => e({
    isRunning: !1,
    activeSessionId: null,
    traceEvents: [],
    totalUsage: { ...rl }
  })
}));
function nK(e, t, n) {
  const r = [], i = [], a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), u = [];
  let l = 0;
  const c = () => `r${t}-s${l++}`, f = (g, O, P) => {
    for (let E = i.length - 1; E >= 0; E--) {
      const T = i[E];
      if (g(T))
        return i.splice(E, 1), T.running = !1, T.endTs = O, T.duration = P ?? O - T.startTs, T;
    }
  }, s = (g) => (O) => g.nodeId && O.nodeId ? O.nodeId === g.nodeId : O.agentId === g.agentId, h = (g) => [...i].reverse().find((O) => g.nodeId ? O.nodeId === g.nodeId : O.agentId === g.agentId), p = (g) => {
    const O = h(g);
    return O ? O.depth + 1 : i.length;
  }, m = (g) => {
    const O = g.parentNodeId ? i.find((E) => E.nodeId === g.parentNodeId) : void 0;
    if (!O) return i.length;
    const P = [...a.values()].reverse().find((E) => E.agentId === O.agentId);
    return P ? P.depth + 1 : O.depth + 1;
  }, y = (g, O, P) => `${g}::${O ?? ""}::${P ?? ""}`;
  for (const g of e)
    switch (g.runId !== void 0 && !u.includes(g.runId) && u.push(g.runId), g.type) {
      case "agent:start": {
        f(
          g.parentNodeId ? (P) => g.nodeId !== void 0 && P.nodeId === g.nodeId : s(g),
          g.timestamp
        );
        const O = {
          id: c(),
          kind: "agent",
          label: g.agentId,
          agentId: g.agentId,
          ...g.nodeId ? { nodeId: g.nodeId } : {},
          depth: m(g),
          startTs: g.timestamp,
          endTs: g.timestamp,
          duration: 0,
          running: !0,
          point: !1,
          input: g.input,
          ...g.opaque ? { opaque: !0 } : {}
        };
        r.push(O), i.push(O);
        break;
      }
      case "agent:end":
      case "agent:error": {
        const O = f(s(g), g.timestamp, g.duration);
        O && (g.type === "agent:error" ? (O.failed = !0, g.error && (O.error = g.error)) : (O.output = g.output, O.usage = g.usage));
        break;
      }
      case "tool:start": {
        const O = {
          id: c(),
          kind: "tool",
          label: g.toolName ?? "tool",
          agentId: g.agentId,
          depth: p(g),
          startTs: g.timestamp,
          endTs: g.timestamp,
          duration: 0,
          running: !0,
          point: !1,
          input: g.input,
          ...g.toolName ? { toolName: g.toolName } : {}
        };
        r.push(O), g.callId && (a.set(g.callId, O), o.set(g.callId, O));
        break;
      }
      case "tool:kept": {
        const O = g.callId ? o.get(g.callId) : void 0;
        O && g.handle && (O.kept = g.handle);
        break;
      }
      // The three ways a started tool call stops. A pause is not a failure and carries no result,
      // so it closes the span without an error and without an output.
      case "tool:end":
      case "tool:error":
      case "tool:awaiting": {
        const O = g.callId ? a.get(g.callId) : void 0;
        O && (O.running = !1, O.endTs = g.timestamp, O.duration = g.duration ?? g.timestamp - O.startTs, g.type === "tool:error" ? (O.failed = !0, g.error && (O.error = g.error)) : g.type === "tool:awaiting" ? O.awaiting = !0 : (O.output = g.output, g.timings && (O.timings = g.timings)), g.callId && a.delete(g.callId));
        break;
      }
      case "guardrail:start": {
        const O = {
          id: c(),
          kind: "guardrail",
          label: g.guardrailName ?? "guardrail",
          agentId: g.agentId,
          depth: p(g),
          startTs: g.timestamp,
          endTs: g.timestamp,
          duration: 0,
          running: !0,
          point: !1,
          ...g.guardrailType ? { guardrailType: g.guardrailType } : {}
        };
        r.push(O), d.set(y(g.agentId, g.guardrailType, g.guardrailName), O);
        break;
      }
      case "guardrail:end": {
        const O = y(g.agentId, g.guardrailType, g.guardrailName), P = d.get(O);
        P && (P.running = !1, P.endTs = g.timestamp, P.duration = g.duration ?? g.timestamp - P.startTs, P.guardrailTriggered = g.triggered, d.delete(O));
        break;
      }
      case "agent:prompt": {
        const O = h(g);
        O && g.prompt && (O.prompt = g.prompt);
        break;
      }
      case "artifact": {
        if (!g.artifact) break;
        r.push({
          id: c(),
          kind: "artifact",
          label: g.artifact.name,
          agentId: g.agentId,
          depth: p(g),
          startTs: g.timestamp,
          endTs: g.timestamp,
          duration: 0,
          running: !1,
          point: !0,
          artifact: g.artifact
        });
        break;
      }
      case "step:finish": {
        r.push({
          id: c(),
          kind: "step",
          label: `step ${g.stepNumber ?? ""}`.trim(),
          agentId: g.agentId,
          depth: p(g),
          startTs: g.timestamp,
          endTs: g.timestamp,
          duration: 0,
          running: !1,
          point: !0,
          ...g.usage ? { usage: g.usage } : {},
          ...g.stepNumber != null ? { stepNumber: g.stepNumber } : {}
        });
        break;
      }
      case "handoff": {
        g.from && f((O) => O.agentId === g.from, g.timestamp), r.push({
          id: c(),
          kind: "handoff",
          label: `${g.from ?? "?"} → ${g.to ?? "?"}`,
          agentId: g.agentId,
          depth: p(g),
          startTs: g.timestamp,
          endTs: g.timestamp,
          duration: 0,
          running: !1,
          point: !0,
          ...g.from ? { from: g.from } : {},
          ...g.to ? { to: g.to } : {},
          ...g.reason ? { reason: g.reason } : {}
        });
        break;
      }
    }
  const w = r.length ? Math.min(...r.map((g) => g.startTs)) : n, b = r.length ? Math.max(...r.map((g) => g.running ? n : g.endTs)) : n, _ = r.filter((g) => g.kind === "agent" && g.usage).reduce(
    (g, O) => ({
      inputTokens: g.inputTokens + (O.usage?.inputTokens ?? 0),
      outputTokens: g.outputTokens + (O.usage?.outputTokens ?? 0),
      cachedInputTokens: g.cachedInputTokens + (O.usage?.cachedInputTokens ?? 0)
    }),
    { inputTokens: 0, outputTokens: 0, cachedInputTokens: 0 }
  );
  return { index: t, spans: r, start: w, end: b, duration: b - w, usage: _, runIds: u };
}
function qm(e) {
  return e < 1e3 ? `${Math.round(e)}ms` : `${(e / 1e3).toFixed(2)}s`;
}
const uz = "grid grid-cols-[minmax(0,7fr)_minmax(0,9fr)_auto] items-center gap-2", cz = {
  agent: Po.agent,
  tool: Po.tool,
  guardrail: Po.guardrail,
  step: { color: "var(--badge-orange-foreground)", Icon: qT },
  handoff: { color: "var(--badge-orange-foreground)", Icon: vT },
  artifact: { color: "var(--badge-blue-foreground)", Icon: XT }
};
function rK(e, t) {
  switch (t) {
    case "agent":
      return e("trace.kind.agent", "agent");
    case "tool":
      return e("trace.kind.tool", "tool");
    case "guardrail":
      return e("trace.kind.guardrail", "guardrail");
    case "step":
      return e("trace.kind.step", "step");
    case "handoff":
      return e("trace.kind.handoff", "handoff");
    case "artifact":
      return e("trace.kind.artifact", "widget");
  }
}
function iK({
  span: e,
  runStart: t,
  runDuration: n,
  selected: r,
  onSelect: i,
  approval: a
}) {
  const o = Re(), { color: d, Icon: u } = cz[e.kind], l = n > 0 ? (e.startTs - t) / n * 100 : 0, c = e.running ? t + n : e.endTs, f = n > 0 ? (c - e.startTs) / n * 100 : 0, s = Math.min(100 - l, Math.max(f, e.point ? 0 : 1.5));
  return /* @__PURE__ */ te(
    "button",
    {
      type: "button",
      onClick: i,
      "aria-expanded": r,
      className: Be(
        uz,
        "w-full rounded-md py-1 pr-2 text-left transition-colors",
        r ? "bg-accent" : "hover:bg-muted/60"
      ),
      children: [
        /* @__PURE__ */ te(
          "span",
          {
            className: "flex min-w-0 items-center gap-1.5",
            style: { paddingLeft: e.depth * 14 + 6 },
            children: [
              /* @__PURE__ */ x(
                "span",
                {
                  className: "flex size-4 shrink-0 items-center justify-center rounded",
                  style: { background: `color-mix(in oklab, ${d} 15%, transparent)`, color: d },
                  children: /* @__PURE__ */ x(u, { className: "size-2.5" })
                }
              ),
              /* @__PURE__ */ x("span", { className: "truncate text-xs text-foreground", children: e.label }),
              a && /* @__PURE__ */ x(mp, { className: "size-3 shrink-0 text-warning-foreground" }),
              e.kept && /* @__PURE__ */ x("span", { className: "shrink-0 rounded bg-muted px-1 font-mono text-[9px] text-muted-foreground", children: o("trace.kept", "kept as {{handle}}", { handle: e.kept }) }),
              e.guardrailTriggered && /* @__PURE__ */ x("span", { className: "shrink-0 rounded bg-destructive/10 px-1 text-[9px] font-medium uppercase text-destructive", children: o("trace.tripped", "tripped") }),
              e.failed && /* @__PURE__ */ x("span", { className: "shrink-0 rounded bg-destructive/10 px-1 text-[9px] font-medium uppercase text-destructive", children: o("trace.error", "error") }),
              e.awaiting && /* @__PURE__ */ x("span", { className: "shrink-0 rounded bg-warning px-1 text-[9px] font-medium uppercase text-warning-foreground", children: o("trace.waiting", "waiting") })
            ]
          }
        ),
        /* @__PURE__ */ x("span", { className: "relative h-2 min-w-0 overflow-hidden rounded-full bg-muted/70", children: e.point ? /* @__PURE__ */ x(
          "span",
          {
            className: "absolute top-1/2 size-2 -translate-y-1/2 rounded-full",
            style: { left: `calc(${l}% - 4px)`, background: d }
          }
        ) : /* @__PURE__ */ x(
          "span",
          {
            className: Be("absolute inset-y-0 rounded-full", e.running && "animate-pulse"),
            style: { left: `${l}%`, width: `${s}%`, background: d, minWidth: 3 }
          }
        ) }),
        /* @__PURE__ */ x("span", { className: "w-12 shrink-0 text-right font-mono text-[10px] tabular-nums text-muted-foreground", children: e.point ? "" : e.running ? "…" : qm(e.duration) })
      ]
    }
  );
}
const oK = [0, 0.25, 0.5, 0.75, 1];
function aK({ duration: e }) {
  return /* @__PURE__ */ te("div", { className: Be(uz, "w-full select-none pb-1 pr-2"), children: [
    /* @__PURE__ */ x("span", {}),
    /* @__PURE__ */ x("div", { className: "relative h-4", children: oK.map((t) => /* @__PURE__ */ te(
      "div",
      {
        className: "absolute top-0 flex flex-col items-start",
        style: {
          left: `${t * 100}%`,
          transform: t === 0 ? "none" : t === 1 ? "translateX(-100%)" : "translateX(-50%)"
        },
        children: [
          /* @__PURE__ */ x("span", { className: "h-1.5 w-px bg-border" }),
          /* @__PURE__ */ x("span", { className: "mt-0.5 whitespace-nowrap text-[8px] leading-none text-muted-foreground", children: qm(t * e) })
        ]
      },
      t
    )) }),
    /* @__PURE__ */ x("span", { className: "w-12" })
  ] });
}
function sK(e, t) {
  switch (e) {
    case "design":
      return t("trace.phase.design", "writing");
    case "render":
      return t("trace.phase.render", "render check");
    case "fix":
      return t("trace.phase.fix", "fixing");
    default:
      return e;
  }
}
function ir({ label: e, value: t }) {
  return /* @__PURE__ */ te("div", { className: "flex gap-2 text-[11px]", children: [
    /* @__PURE__ */ x("span", { className: "min-w-[68px] shrink-0 text-muted-foreground", children: e }),
    /* @__PURE__ */ x("span", { className: "break-all text-foreground/80", children: t })
  ] });
}
function tu({ children: e }) {
  return /* @__PURE__ */ x("div", { className: "mt-1 text-[10px] font-medium uppercase tracking-wide text-muted-foreground", children: e });
}
function lK({
  span: e,
  approval: t,
  cost: n
}) {
  const r = Re(), { color: i, Icon: a } = cz[e.kind];
  return /* @__PURE__ */ te("div", { className: "flex flex-col gap-2 p-3", children: [
    /* @__PURE__ */ te("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ x(
        "span",
        {
          className: "flex size-6 shrink-0 items-center justify-center rounded-md",
          style: { background: `color-mix(in oklab, ${i} 15%, transparent)`, color: i },
          children: /* @__PURE__ */ x(a, { className: "size-3.5" })
        }
      ),
      /* @__PURE__ */ x("span", { className: "truncate text-[13px] font-medium text-foreground", children: e.label }),
      /* @__PURE__ */ x("span", { className: "text-[10px] uppercase tracking-wide text-muted-foreground", children: rK(r, e.kind) }),
      t && /* @__PURE__ */ te("span", { className: "flex items-center gap-1 rounded bg-warning px-1.5 py-0.5 text-[10px] font-medium text-warning-foreground", children: [
        /* @__PURE__ */ x(mp, { className: "size-3" }),
        t === "conditional" ? r("trace.conditionalApproval", "conditional approval") : r("trace.requiresApproval", "requires approval")
      ] })
    ] }),
    /* @__PURE__ */ te("div", { className: "flex flex-col gap-1", children: [
      !e.point && /* @__PURE__ */ x(
        ir,
        {
          label: r("trace.duration", "Duration"),
          value: e.running ? r("trace.running", "running…") : qm(e.duration)
        }
      ),
      e.usage && /* @__PURE__ */ x(
        ir,
        {
          label: r("trace.tokens", "Tokens"),
          value: e.usage.cachedInputTokens ? r("trace.tokensCached", "{{input}} in / {{output}} out · {{cached}} cached", {
            input: e.usage.inputTokens.toLocaleString(),
            output: e.usage.outputTokens.toLocaleString(),
            cached: e.usage.cachedInputTokens.toLocaleString()
          }) : r("trace.tokensValue", "{{input}} in / {{output}} out", {
            input: e.usage.inputTokens.toLocaleString(),
            output: e.usage.outputTokens.toLocaleString()
          })
        }
      ),
      n && /* @__PURE__ */ x(ir, { label: r("trace.cost", "Cost"), value: n }),
      e.guardrailType && /* @__PURE__ */ x(ir, { label: r("trace.guardrailType", "Type"), value: e.guardrailType }),
      e.guardrailTriggered != null && /* @__PURE__ */ x(
        ir,
        {
          label: r("trace.triggered", "Triggered"),
          value: e.guardrailTriggered ? r("trace.yes", "Yes") : r("trace.no", "No")
        }
      ),
      e.reason && /* @__PURE__ */ x(ir, { label: r("trace.reason", "Reason"), value: e.reason }),
      e.timings && /* @__PURE__ */ x(
        ir,
        {
          label: r("trace.timeSpent", "Time spent"),
          value: e.timings.map(
            ({ phase: o, ms: d }) => r("trace.phaseTime", "{{phase}} {{seconds}}s", {
              phase: sK(o, r),
              seconds: (d / 1e3).toFixed(1)
            })
          ).join(" · ")
        }
      ),
      e.artifact && /* @__PURE__ */ x(ir, { label: r("trace.artifactKind", "Shown as"), value: e.artifact.kind })
    ] }),
    e.opaque && /* @__PURE__ */ x("p", { className: "text-[11px] text-muted-foreground", children: r(
      "trace.opaque",
      "A system agent: only that it ran is shown. Its tools, steps and prompts stay private, and what it put on screen appears as its own step."
    ) }),
    e.error && /* @__PURE__ */ x("div", { className: "rounded-md border border-destructive/30 bg-destructive/5 p-2 text-[11px] text-destructive", children: e.error }),
    e.prompt && /* @__PURE__ */ te(Ue, { children: [
      /* @__PURE__ */ x(tu, { children: r("trace.systemPrompt", "System prompt") }),
      /* @__PURE__ */ x("pre", { className: "max-h-64 overflow-auto whitespace-pre-wrap rounded-md bg-muted/60 p-2 text-[11px] text-foreground/90", children: e.prompt.system }),
      e.prompt.tools.length > 0 && /* @__PURE__ */ x(ir, { label: r("trace.tools", "Tools"), value: e.prompt.tools.join(", ") }),
      e.prompt.messages.length > 0 && /* @__PURE__ */ te(Ue, { children: [
        /* @__PURE__ */ x(tu, { children: r("trace.messages", "Messages") }),
        /* @__PURE__ */ x(ad, { data: e.prompt.messages })
      ] })
    ] }),
    e.input != null && /* @__PURE__ */ te(Ue, { children: [
      /* @__PURE__ */ x(tu, { children: r("trace.input", "Input") }),
      /* @__PURE__ */ x(ad, { data: e.input })
    ] }),
    e.output != null && /* @__PURE__ */ te(Ue, { children: [
      /* @__PURE__ */ x(tu, { children: e.kind === "agent" ? r("trace.response", "Response") : r("trace.output", "Output") }),
      /* @__PURE__ */ x(ad, { data: typeof e.output == "object" ? e.output : String(e.output) })
    ] })
  ] });
}
function uK({
  trace: e,
  approvalOf: t,
  costOf: n
}) {
  const [r, i] = Ae(null);
  return /* @__PURE__ */ te("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ x(aK, { duration: e.duration }),
    e.spans.map((a) => {
      const o = t?.(a), d = n?.(a), u = a.id === r;
      return /* @__PURE__ */ te("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ x(
          iK,
          {
            span: a,
            runStart: e.start,
            runDuration: e.duration,
            selected: u,
            onSelect: () => i(u ? null : a.id),
            ...o ? { approval: o } : {}
          }
        ),
        u && /* @__PURE__ */ x("div", { className: "mb-1 ml-3 rounded-md border border-border-light bg-card", children: /* @__PURE__ */ x(
          lK,
          {
            span: a,
            ...o ? { approval: o } : {},
            ...d ? { cost: d } : {}
          }
        ) })
      ] }, a.id);
    })
  ] });
}
var Vr = {}, Yf = {}, S0;
function dz() {
  return S0 || (S0 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.askUserAnswersSchema = e.askUserAnswerSchema = e.askUserInputSchema = e.askUserQuestionSchema = e.NOT_ANSWERED_REASON = e.ASK_USER_TOOL_NAME = void 0, e.isAnswerFor = a;
    const t = /* @__PURE__ */ pp();
    e.ASK_USER_TOOL_NAME = "ask_user", e.NOT_ANSWERED_REASON = "The person did not answer and sent a new message instead. Go on without these answers, or ask again if you still need them.";
    const n = /* @__PURE__ */ new Set(["other", "otra", "outra"]), r = (o) => new Set(o.map((d) => d.trim().toLowerCase())).size === o.length, i = t.z.object({
      label: t.z.string().trim().min(1).max(80).refine((o) => !n.has(o.toLowerCase()), {
        message: 'Leave "Other" out: the person can always type their own answer'
      }),
      description: t.z.string().trim().max(200).optional()
    });
    e.askUserQuestionSchema = t.z.object({
      /** A chip naming the question, short enough to sit beside it. */
      header: t.z.string().trim().min(1).max(12),
      question: t.z.string().trim().min(1).max(500),
      multiSelect: t.z.boolean(),
      // Told apart by label in the answers and on screen.
      options: t.z.array(i).min(2).max(4).refine((o) => r(o.map((d) => d.label)), {
        message: "Give each option a different label"
      })
    }), e.askUserInputSchema = t.z.object({
      questions: t.z.array(e.askUserQuestionSchema).min(1).max(4).refine((o) => r(o.map((d) => d.question)), {
        message: "Ask each question once"
      })
    }), e.askUserAnswerSchema = t.z.object({
      question: t.z.string(),
      selected: t.z.array(t.z.string()),
      /** What the person typed instead of, or beside, a choice. */
      other: t.z.string().trim().min(1).max(1e3).optional()
    }), e.askUserAnswersSchema = t.z.object({
      answers: t.z.array(e.askUserAnswerSchema).min(1).max(4)
    });
    function a(o, d) {
      return d.answers.length !== o.length ? !1 : o.every((u) => {
        const l = d.answers.find((f) => f.question === u.question);
        if (!l)
          return !1;
        const c = new Set(u.options.map((f) => f.label));
        return !l.selected.every((f) => c.has(f)) || new Set(l.selected).size !== l.selected.length || !u.multiSelect && l.selected.length > 1 ? !1 : l.selected.length > 0 || l.other !== void 0;
      });
    }
  })(Yf)), Yf;
}
var Qf = {}, x0;
function cK() {
  return x0 || (x0 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isAnswered = e.withOtherText = e.EMPTY_DRAFT = void 0, e.pickOption = t, e.toggleOther = n, e.answersFrom = o, e.nextUnanswered = d, e.EMPTY_DRAFT = { selected: [], other: "", otherOn: !1 };
    function t(u, l, c) {
      if (!u.multiSelect)
        return { ...l, selected: [c], otherOn: !1 };
      const f = l.selected.includes(c) ? l.selected.filter((s) => s !== c) : [...l.selected, c];
      return { ...l, selected: f };
    }
    function n(u, l) {
      return u.multiSelect ? { ...l, otherOn: !l.otherOn } : { ...l, selected: [], otherOn: !0 };
    }
    const r = (u, l) => ({
      ...u,
      other: l
    });
    e.withOtherText = r;
    const i = (u) => {
      const l = u.other.trim();
      return u.otherOn && l ? l : void 0;
    }, a = (u) => !!(u && (u.selected.length > 0 || i(u)));
    e.isAnswered = a;
    function o(u, l) {
      return {
        answers: u.map((c, f) => {
          const s = l[f] ?? e.EMPTY_DRAFT, h = i(s);
          return {
            question: c.question,
            selected: [...s.selected],
            ...h ? { other: h } : {}
          };
        })
      };
    }
    function d(u, l, c) {
      for (let f = 1; f <= u.length; f++) {
        const s = (c + f) % u.length;
        if (!(0, e.isAnswered)(l[s]))
          return s;
      }
    }
  })(Qf)), Qf;
}
var eh = {}, I0;
function dK() {
  return I0 || (I0 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.askedQuestionSchema = void 0, e.askedQuestionsOfOutput = i, e.answerText = a, e.isAskUser = o, e.questionsOfCall = d, e.askedQuestionsIn = u, e.answeredQuestions = l, e.questionsAskedBy = c, e.askedAt = s, e.interleaveAsked = h, e.closeOpenQuestions = p;
    const t = /* @__PURE__ */ pp(), n = dz();
    e.askedQuestionSchema = t.z.object({
      question: t.z.string(),
      answer: t.z.string().optional(),
      /**
       * How far into the reply's text it was asked, in characters. Absent on replies stored before
       * this was recorded, which read as asked before the text.
       */
      at: t.z.number().int().nonnegative().optional(),
      /**
       * The call that asked it: an ask_user call, or a tool that asked about its own call. What one
       * call asked is answered, and shown, together.
       */
      callId: t.z.string().optional()
    });
    const r = t.z.array(e.askedQuestionSchema.pick({ question: !0, answer: !0 }));
    function i(m) {
      const y = m?.askedQuestions;
      if (!Array.isArray(y) || y.length === 0)
        return;
      const w = r.safeParse(y);
      return w.success ? w.data : void 0;
    }
    function a(m) {
      return [...m.selected, ...m.other ? [m.other] : []].join(", ");
    }
    function o(m) {
      const y = m;
      return y.type === `tool-${n.ASK_USER_TOOL_NAME}` || y.type === "dynamic-tool" && y.toolName === n.ASK_USER_TOOL_NAME;
    }
    function d(m, y) {
      if (m !== n.ASK_USER_TOOL_NAME)
        return;
      const w = n.askUserInputSchema.safeParse(y);
      return w.success ? w.data.questions : void 0;
    }
    function u(m) {
      const y = m, w = typeof y.toolCallId == "string" ? y.toolCallId : void 0;
      if (!o(y)) {
        if (y.state !== "output-available")
          return;
        const b = i(y.output);
        return b && f(b, w);
      }
      if (y.state === "output-available")
        return l(y.output, w);
      if (!(y.state !== "output-error" && y.state !== "output-denied"))
        return c(y.input, w);
    }
    function l(m, y) {
      const w = n.askUserAnswersSchema.safeParse(m);
      if (!w.success)
        return;
      const b = w.data.answers.map((_) => ({
        question: _.question,
        answer: a(_)
      }));
      return f(b, y);
    }
    function c(m, y) {
      const w = n.askUserInputSchema.safeParse(m);
      if (!w.success)
        return;
      const b = w.data.questions.map(({ question: _ }) => ({ question: _ }));
      return f(b, y);
    }
    const f = (m, y) => y ? m.map((w) => ({ ...w, callId: y })) : m;
    function s(m, y) {
      return m.map((w) => ({ ...w, at: y }));
    }
    function h(m, y) {
      const w = [];
      let b = 0;
      for (const g of y) {
        const O = Math.min(Math.max(g.at ?? 0, b), m.length);
        if (O > b) {
          const E = m.slice(b, O);
          E.trim() !== "" && w.push({ text: E }), b = O;
        }
        const P = w.at(-1);
        P && "asked" in P && P.asked[0]?.callId === g.callId ? P.asked.push(g) : w.push({ asked: [g] });
      }
      const _ = m.slice(b);
      return _.trim() !== "" && w.push({ text: _ }), w;
    }
    function p(m, y = o) {
      const w = (b) => y(b) && b.state === "approval-requested";
      return m.map((b) => b.parts.some(w) ? {
        ...b,
        parts: b.parts.map((_) => {
          if (!w(_))
            return _;
          const g = {
            ..._,
            state: "output-error",
            errorText: n.NOT_ANSWERED_REASON
          };
          return delete g.approval, g;
        })
      } : b);
    }
  })(eh)), eh;
}
var P0;
function fK() {
  return P0 || (P0 = 1, (function(e) {
    var t = Vr && Vr.__createBinding || (Object.create ? (function(r, i, a, o) {
      o === void 0 && (o = a);
      var d = Object.getOwnPropertyDescriptor(i, a);
      (!d || ("get" in d ? !i.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return i[a];
      } }), Object.defineProperty(r, o, d);
    }) : (function(r, i, a, o) {
      o === void 0 && (o = a), r[o] = i[a];
    })), n = Vr && Vr.__exportStar || function(r, i) {
      for (var a in r) a !== "default" && !Object.prototype.hasOwnProperty.call(i, a) && t(i, r, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), n(dz(), e), n(cK(), e), n(dK(), e);
  })(Vr)), Vr;
}
var wn = fK();
function nJ({ items: e }) {
  const t = Re(), n = e.filter((i) => i.answer !== void 0), r = e.filter((i) => i.answer === void 0);
  return /* @__PURE__ */ te(Ue, { children: [
    n.length > 0 && /* @__PURE__ */ x(O0, { heading: t("chat.answeredQuestions", "You answered"), children: /* @__PURE__ */ x("dl", { className: "m-0 flex flex-col gap-2", children: n.map((i, a) => /* @__PURE__ */ te("div", { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ x("dt", { className: "text-muted-foreground", children: i.question }),
      /* @__PURE__ */ x("dd", { className: "m-0 font-medium text-foreground", children: i.answer })
    ] }, a)) }) }),
    r.length > 0 && /* @__PURE__ */ x(O0, { heading: t("chat.unansweredQuestions", "Not answered"), children: /* @__PURE__ */ x("ul", { className: "m-0 flex list-none flex-col gap-1 p-0 text-muted-foreground", children: r.map((i, a) => /* @__PURE__ */ x("li", { children: i.question }, a)) }) })
  ] });
}
function O0({ heading: e, children: t }) {
  const n = Ho();
  return /* @__PURE__ */ te(
    "section",
    {
      "aria-labelledby": n,
      className: "flex flex-col gap-1.5 rounded-lg border border-border-lighter px-3 py-2 text-sm",
      children: [
        /* @__PURE__ */ te("span", { id: n, className: "flex items-center gap-1.5 text-xs text-muted-foreground", children: [
          /* @__PURE__ */ x(iN, { className: "size-3.5", "aria-hidden": !0 }),
          e
        ] }),
        t
      ]
    }
  );
}
const hK = wn.askUserAnswersSchema.shape.answers.element.shape.other.unwrap().maxLength ?? void 0, z0 = "flex w-full items-center gap-3 rounded-lg border px-3 py-2 text-left transition-colors disabled:cursor-not-allowed", E0 = "border-border bg-muted/40 hover:bg-muted", T0 = "border-primary bg-muted", pK = /* @__PURE__ */ new Set(["ArrowUp", "ArrowLeft"]), mK = /* @__PURE__ */ new Set(["ArrowDown", "ArrowRight"]);
function rJ({ waiting: e }) {
  const t = Re();
  return /* @__PURE__ */ x("p", { role: "status", className: "sr-only", children: e ? t(
    "chat.askingAnnouncement",
    "The agent is asking you something. Answer above the message box."
  ) : "" });
}
function iJ({
  questions: e,
  onSubmit: t,
  onSkip: n,
  drafts: r,
  onDraftChange: i,
  disabled: a = !1,
  note: o,
  label: d
}) {
  const u = Re(), [l, c] = Ae(0), [f, s] = Ae(!1), [h, p] = Ae([]), m = r ?? h, [y, w] = Ae(!1), b = Ho(), _ = Ce([]), g = Ce(null), O = Math.min(l, e.length - 1), P = e[O];
  if (!P) return null;
  const E = m[O] ?? wn.EMPTY_DRAFT, T = O === e.length - 1, D = e.every((F, K) => wn.isAnswered(m[K])), N = y || a, M = (F) => {
    if (i) {
      i(O, F);
      return;
    }
    p((K) => {
      const ee = [...K];
      return ee[O] = F, ee;
    });
  }, R = (F) => () => {
    N || (w(!0), F());
  }, V = R(() => t(wn.answersFrom(e, m))), C = R(n), B = () => {
    E.otherOn || g.current?.focus(), M(wn.toggleOther(P, E));
  }, G = P.options.map((F) => F.label), Q = E.otherOn ? G.length : G.indexOf(E.selected[0] ?? ""), k = P.multiSelect ? void 0 : Math.max(0, Q), I = (F) => {
    const K = G[F];
    K === void 0 ? B() : M(wn.pickOption(P, E, K));
  }, S = (F) => (K) => {
    if (P.multiSelect || N) return;
    const ee = mK.has(K.key) ? 1 : pK.has(K.key) ? -1 : 0;
    if (ee === 0) return;
    K.preventDefault();
    const U = (F + ee + G.length + 1) % (G.length + 1);
    I(U), _.current[U]?.focus();
  }, A = (F) => {
    if (N || F.target instanceof HTMLInputElement) return;
    const K = Number(F.key) - 1;
    !Number.isInteger(K) || K < 0 || K > G.length || (F.preventDefault(), I(K));
  }, j = (F) => ({
    ref: (K) => {
      _.current[F] = K;
    },
    ...k === void 0 ? {} : { tabIndex: F === k ? 0 : -1 },
    onKeyDown: S(F)
  }), z = (F) => {
    if (F.key !== "Enter" || F.nativeEvent.isComposing || N) return;
    F.preventDefault();
    const K = wn.nextUnanswered(e, m, O);
    K !== void 0 ? c(K) : D && V();
  }, L = P.multiSelect ? "checkbox" : "radio";
  return /* @__PURE__ */ te(
    "section",
    {
      "aria-label": d ?? u("chat.questions", "Questions from the agent"),
      className: "flex flex-col gap-2 border-b border-border-lighter p-2",
      children: [
        /* @__PURE__ */ te("div", { className: "flex flex-col gap-1.5 px-1", children: [
          /* @__PURE__ */ te("div", { className: "flex items-center justify-between gap-2", children: [
            /* @__PURE__ */ x(_r, { variant: "secondary", className: "shrink-0 tabular-nums", children: e.length > 1 ? u("chat.questionProgress", "{{current}}/{{total}}", {
              current: O + 1,
              total: e.length
            }) : P.header }),
            /* @__PURE__ */ x(
              Tt,
              {
                variant: "ghost",
                size: "mini",
                className: "size-6 shrink-0 p-0",
                "aria-label": f ? u("chat.showQuestions", "Show questions") : u("chat.minimizeQuestions", "Minimize questions"),
                "aria-expanded": !f,
                onClick: () => s(!f),
                children: f ? /* @__PURE__ */ x(DT, { className: "size-3.5" }) : /* @__PURE__ */ x(TT, { className: "size-3.5" })
              }
            )
          ] }),
          /* @__PURE__ */ x("p", { id: b, className: "m-0 text-sm font-medium text-foreground", children: P.question })
        ] }),
        !f && /* @__PURE__ */ te(Ue, { children: [
          /* @__PURE__ */ te(
            "div",
            {
              role: P.multiSelect ? "group" : "radiogroup",
              "aria-labelledby": b,
              onKeyDown: A,
              className: "flex max-h-96 flex-col gap-1.5 overflow-y-auto",
              children: [
                P.options.map((F, K) => {
                  const ee = E.selected.includes(F.label);
                  return /* @__PURE__ */ te(
                    "button",
                    {
                      type: "button",
                      role: L,
                      "aria-checked": ee,
                      disabled: N,
                      onClick: () => M(wn.pickOption(P, E, F.label)),
                      className: Be(z0, ee ? T0 : E0),
                      ...j(K),
                      children: [
                        /* @__PURE__ */ te("span", { className: "flex min-w-0 flex-1 flex-col", children: [
                          /* @__PURE__ */ x("span", { className: "text-sm text-foreground", children: F.label }),
                          F.description && /* @__PURE__ */ x("span", { className: "text-xs text-muted-foreground", children: F.description })
                        ] }),
                        /* @__PURE__ */ x(Gm, { "aria-hidden": !0, children: K + 1 })
                      ]
                    },
                    F.label
                  );
                }),
                /* @__PURE__ */ te(
                  "div",
                  {
                    className: Be(
                      "flex flex-col gap-1.5 rounded-lg border",
                      E.otherOn ? T0 : E0
                    ),
                    children: [
                      /* @__PURE__ */ te(
                        "button",
                        {
                          type: "button",
                          role: L,
                          "aria-checked": E.otherOn,
                          disabled: N,
                          onClick: B,
                          className: Be(z0, "border-transparent pb-0"),
                          ...j(G.length),
                          children: [
                            /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 text-sm text-foreground", children: u("chat.otherAnswer", "Other") }),
                            /* @__PURE__ */ x(Gm, { "aria-hidden": !0, children: G.length + 1 })
                          ]
                        }
                      ),
                      /* @__PURE__ */ x(
                        Qt,
                        {
                          ref: g,
                          size: "sm",
                          className: "mx-3 mb-2 w-auto",
                          "aria-label": u("chat.yourAnswer", "Your answer"),
                          placeholder: u("chat.otherAnswerHint", "Type your own answer"),
                          value: E.other,
                          maxLength: hK,
                          disabled: N,
                          onChange: (F) => M(
                            wn.withOtherText(
                              E.otherOn ? E : wn.toggleOther(P, E),
                              F.target.value
                            )
                          ),
                          onKeyDown: z
                        }
                      )
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ te("div", { className: "flex items-center gap-1.5 px-1", children: [
            /* @__PURE__ */ x("span", { className: "min-w-0 flex-1 text-xs text-muted-foreground", children: o }),
            O > 0 && /* @__PURE__ */ x(Tt, { size: "sm", variant: "ghost", disabled: N, onClick: () => c(O - 1), children: u("chat.previousQuestion", "Back") }),
            /* @__PURE__ */ x(Tt, { size: "sm", variant: "secondary", disabled: N, onClick: C, children: u("chat.skipQuestions", "Skip") }),
            T ? /* @__PURE__ */ x(Tt, { size: "sm", disabled: !D || N, onClick: V, children: u("chat.sendAnswers", "Send answers") }) : /* @__PURE__ */ x(
              Tt,
              {
                size: "sm",
                disabled: !wn.isAnswered(E) || N,
                onClick: () => c(O + 1),
                children: u("chat.nextQuestion", "Next")
              }
            )
          ] })
        ] })
      ]
    }
  );
}
const gK = 0.7, yK = 0.9, Hm = (e) => e.window ? e.tokens / e.window : void 0;
function fz(e, t) {
  const n = Hm(t);
  return n === void 0 ? e("debug.context", "Context {{tokens}}", { tokens: En(e, t.tokens) }) : e("debug.contextOfWindow", "Context {{tokens}} / {{window}} ({{percent}}%)", {
    tokens: En(e, t.tokens),
    window: En(e, t.window ?? 0),
    // A real but tiny share reads as "<1", not as an empty context.
    percent: n > 0 && n < 0.01 ? "<1" : Math.round(n * 100)
  });
}
function hz(e) {
  const t = Hm(e);
  if (!(t === void 0 || t < gK))
    return t >= yK ? "text-destructive" : "text-warning-foreground";
}
function vK(e, t) {
  let n = 0, r = e.parentNodeId;
  for (; r && n < 50; )
    n += 1, r = t[r]?.parentNodeId ?? null;
  return n;
}
function bK(e, t) {
  return e.nodeId ? t.find((r) => r.nodeId === e.nodeId) : t.filter((r) => r.agentId === e.agentId && r.startedAt <= e.timestamp).sort((r, i) => i.startedAt - r.startedAt)[0];
}
function _K(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const r of e) {
    if (!r.type.startsWith("tool:") || !r.callId) continue;
    if (r.type === "tool:start") {
      n.set(r.callId, {
        callId: r.callId,
        toolName: r.toolName ?? "",
        status: "running",
        startedAt: r.timestamp,
        durationMs: null
      });
      continue;
    }
    const i = n.get(r.callId);
    i && (i.durationMs = r.duration ?? r.timestamp - i.startedAt, r.type === "tool:error" ? (i.status = "error", r.error && (i.error = r.error)) : r.type === "tool:awaiting" ? i.status = "awaiting" : i.status = "done");
  }
  return [...n.values()].map(
    (r) => r.status === "running" ? { ...r, durationMs: t - r.startedAt } : r
  );
}
function wK(e, t, n) {
  const r = Math.max(
    0,
    ...t.filter((a) => a.type === "step:finish").map((a) => a.usage?.inputTokens ?? 0)
  );
  if (r === 0) return;
  const i = e.model ? n?.(e.model) : void 0;
  return { agentName: e.name, tokens: r, ...i ? { window: i } : {} };
}
const kK = (e, t) => {
  const n = (r) => r.window ? r.tokens / r.window : 0;
  return n(e) !== n(t) ? n(e) > n(t) ? e : t : e.tokens >= t.tokens ? e : t;
};
function pz(e, t, { pricingFor: n, contextWindowFor: r } = {}, i = Date.now()) {
  const a = Bz(e, t, n), o = e.runs[t];
  if (!a || !o) return;
  const d = Object.values(e.nodes).filter((h) => h.runId === t), u = U0(Object.fromEntries(d.map((h) => [h.nodeId, h]))), l = /* @__PURE__ */ new Map();
  for (const h of e.trace) {
    if (h.runId && h.runId !== t || h.timestamp < o.startedAt || o.endedAt !== null && h.timestamp > o.endedAt)
      continue;
    const p = bK(h, d);
    p && l.set(p.nodeId, [...l.get(p.nodeId) ?? [], h]);
  }
  const c = d.sort((h, p) => h.startedAt - p.startedAt).map((h) => {
    const p = u.get(h.nodeId);
    return {
      nodeId: h.nodeId,
      agentId: h.agentId,
      name: h.name,
      kind: h.kind,
      depth: vK(h, e.nodes),
      status: h.status,
      offsetMs: h.startedAt - o.startedAt,
      durationMs: h.endedAt === null ? i - h.startedAt : h.endedAt - h.startedAt,
      ...h.model ? { model: h.model } : {},
      inputTokens: p?.inputTokens ?? 0,
      outputTokens: p?.outputTokens ?? 0,
      costUsd: h.model ? Vz(p, n?.(h.model)) : void 0,
      ...h.error ? { error: h.error.message } : {},
      tools: _K(l.get(h.nodeId) ?? [], i),
      guardrails: Object.values(e.guardrails).filter((m) => m.nodeId === h.nodeId).map((m) => ({
        id: m.guardrailRunId,
        name: m.guardrailName,
        stage: m.stage,
        status: m.status
      }))
    };
  }), f = d.map((h) => wK(h, l.get(h.nodeId) ?? [], r)).filter((h) => h !== void 0).reduce((h, p) => h ? kK(h, p) : p, void 0), s = Math.max(1, (o.endedAt ?? i) - o.startedAt);
  return { summary: a, spanMs: s, rows: c, ...f ? { context: f } : {} };
}
function oJ(e, t = {}) {
  const n = e.runOrder.at(-1);
  return n ? pz(e, n, t)?.context : void 0;
}
const mz = {
  running: "default",
  awaiting_input: "warning",
  completed: "positive",
  error: "destructive",
  aborted: "secondary"
};
function gz(e, t) {
  switch (t) {
    case "running":
      return e("debug.status.running", "Running");
    case "awaiting_input":
      return e("debug.status.awaiting", "Waiting for you");
    case "completed":
      return e("debug.status.completed", "Completed");
    case "error":
      return e("debug.status.error", "Failed");
    case "aborted":
      return e("debug.status.aborted", "Stopped");
    default:
      return t;
  }
}
const op = (e, t) => t === null ? "…" : e("debug.seconds", "{{value}}s", { value: (t / 1e3).toFixed(1) });
function SK(e) {
  const [t, n] = Ae(() => Date.now());
  return Ze(() => {
    if (!e) return;
    const r = setInterval(() => {
      n(Date.now());
    }, 500);
    return () => {
      clearInterval(r);
    };
  }, [e]), t;
}
function xK({ context: e, t }) {
  const n = hz(e);
  return /* @__PURE__ */ x(
    "span",
    {
      "data-testid": "run-context",
      title: t("debug.contextTitle", "The largest prompt {{agent}} sent its model this turn", {
        agent: e.agentName
      }),
      className: Be(n && `font-medium ${n}`),
      children: fz(t, e)
    }
  );
}
function IK({
  summary: e,
  context: t,
  t: n
}) {
  return /* @__PURE__ */ te("div", { className: "flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] tabular-nums text-muted-foreground", children: [
    /* @__PURE__ */ te("span", { children: [
      n("debug.agents", "{{count}} agents", { count: e.agentCount }),
      " · ",
      n("debug.handoffs", "{{count}} handoffs", { count: e.handoffCount })
    ] }),
    /* @__PURE__ */ x("span", { children: op(n, e.durationMs) }),
    /* @__PURE__ */ te("span", { children: [
      n("debug.tokensInOut", "{{input}} in · {{output}} out", {
        input: En(n, e.usage.inputTokens),
        output: En(n, e.usage.outputTokens)
      }),
      e.usage.cachedInputTokens > 0 && ` · ${n("debug.tokensCached", "{{cached}} cached", {
        cached: En(n, e.usage.cachedInputTokens)
      })}`
    ] }),
    e.costUsd !== void 0 && /* @__PURE__ */ x("span", { className: "font-medium text-foreground", children: lp(e.costUsd) }),
    t && /* @__PURE__ */ x(xK, { context: t, t: n })
  ] });
}
function PK({
  row: e,
  spanMs: t,
  selected: n,
  onSelect: r,
  t: i
}) {
  const a = e.offsetMs / t * 100, o = Math.max(1.5, (e.durationMs ?? 0) / t * 100), d = e.status === "running";
  return /* @__PURE__ */ te("li", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ te(
      "button",
      {
        type: "button",
        onClick: r,
        "aria-expanded": n,
        className: Be(
          "flex w-full flex-col gap-1 rounded-md px-2 py-1.5 text-left transition-colors hover:bg-muted",
          n && "bg-muted"
        ),
        style: { paddingLeft: `${0.5 + e.depth * 0.75}rem` },
        children: [
          /* @__PURE__ */ te("span", { className: "flex items-center gap-1.5 text-xs", children: [
            /* @__PURE__ */ x(
              lk,
              {
                className: Be("size-3 shrink-0 text-muted-foreground", n && "rotate-90")
              }
            ),
            /* @__PURE__ */ x("span", { className: "truncate font-medium text-foreground", children: e.name }),
            e.kind === "handoff" && /* @__PURE__ */ x(_r, { variant: "outline", children: i("debug.kind.handoff", "handoff") }),
            e.kind === "subagent" && /* @__PURE__ */ x(_r, { variant: "outline", children: i("debug.kind.tool", "as tool") }),
            e.status !== "completed" && /* @__PURE__ */ x(_r, { variant: mz[e.status] ?? "secondary", children: gz(i, e.status) }),
            /* @__PURE__ */ x("span", { className: "ml-auto shrink-0 tabular-nums text-[11px] text-muted-foreground", children: op(i, e.durationMs) })
          ] }),
          /* @__PURE__ */ x("span", { className: "relative block h-1.5 w-full rounded-full bg-muted", children: /* @__PURE__ */ x(
            "span",
            {
              className: Be(
                "absolute inset-y-0 rounded-full",
                e.status === "error" ? "bg-destructive" : "bg-primary",
                d && "agentic-bar-running"
              ),
              style: { left: `${a}%`, width: `${Math.min(o, 100 - a)}%` }
            }
          ) })
        ]
      }
    ),
    n && /* @__PURE__ */ te(
      "div",
      {
        className: "flex flex-col gap-1.5 rounded-md border border-border-light bg-card px-2.5 py-2 text-[11px]",
        style: { marginLeft: `${0.5 + e.depth * 0.75}rem` },
        children: [
          /* @__PURE__ */ te("dl", { className: "grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5", children: [
            e.model && /* @__PURE__ */ te(Ue, { children: [
              /* @__PURE__ */ x("dt", { className: "text-muted-foreground", children: i("debug.detail.model", "Model") }),
              /* @__PURE__ */ x("dd", { className: "truncate text-foreground", children: e.model })
            ] }),
            /* @__PURE__ */ x("dt", { className: "text-muted-foreground", children: i("debug.detail.tokens", "Tokens") }),
            /* @__PURE__ */ x("dd", { className: "tabular-nums text-foreground", children: i("debug.tokensInOut", "{{input}} in · {{output}} out", {
              input: En(i, e.inputTokens),
              output: En(i, e.outputTokens)
            }) }),
            e.costUsd !== void 0 && /* @__PURE__ */ te(Ue, { children: [
              /* @__PURE__ */ x("dt", { className: "text-muted-foreground", children: i("debug.detail.cost", "Cost") }),
              /* @__PURE__ */ x("dd", { className: "tabular-nums text-foreground", children: lp(e.costUsd) })
            ] })
          ] }),
          e.error && /* @__PURE__ */ x("p", { className: "m-0 text-destructive", children: e.error }),
          e.tools.length > 0 && /* @__PURE__ */ x("ul", { className: "m-0 flex list-none flex-col gap-1 p-0", children: e.tools.map((u) => /* @__PURE__ */ te("li", { className: "flex items-center gap-1.5", children: [
            /* @__PURE__ */ x(yp, { className: "size-3 shrink-0 text-muted-foreground" }),
            /* @__PURE__ */ x("span", { className: "truncate text-foreground", children: u.toolName || i("debug.unnamedTool", "tool") }),
            u.status !== "done" && /* @__PURE__ */ x(_r, { variant: u.status === "error" ? "destructive" : "warning", children: u.status === "error" ? i("debug.status.error", "Failed") : u.status === "awaiting" ? i("debug.status.awaiting", "Waiting for you") : i("debug.status.running", "Running") }),
            /* @__PURE__ */ x("span", { className: "ml-auto shrink-0 tabular-nums text-muted-foreground", children: op(i, u.durationMs) })
          ] }, u.callId)) }),
          e.guardrails.length > 0 && /* @__PURE__ */ x("ul", { className: "m-0 flex list-none flex-col gap-1 p-0", children: e.guardrails.map((u) => /* @__PURE__ */ te("li", { className: "flex items-center gap-1.5", children: [
            /* @__PURE__ */ x(gp, { className: "size-3 shrink-0 text-muted-foreground" }),
            /* @__PURE__ */ x("span", { className: "truncate text-foreground", children: u.name }),
            /* @__PURE__ */ x(
              _r,
              {
                variant: u.status === "failed" ? "destructive" : u.status === "passed" ? "positive" : "default",
                children: u.status === "failed" ? i("debug.guardrail.failed", "Blocked") : u.status === "passed" ? i("debug.guardrail.passed", "Passed") : i("debug.status.running", "Running")
              }
            )
          ] }, u.id)) })
        ]
      }
    )
  ] });
}
const OK = [];
function zK(e, t) {
  const n = new Map(t.rows.map((r) => [r.nodeId, r.name]));
  return {
    ...e,
    spans: e.spans.map((r) => {
      const i = r.kind === "agent" && r.nodeId ? n.get(r.nodeId) : void 0;
      return i ? { ...r, label: i } : r;
    })
  };
}
function EK({
  timeline: e,
  expanded: t,
  onToggle: n,
  onSelectAgent: r,
  t: i,
  events: a,
  now: o
}) {
  const [d, u] = Ae(null), { summary: l } = e, c = a.some((h) => h.type === "agent:start"), f = Le(
    () => t && c ? (
      // A fixed run index: each section draws one run, and an index that moved as turns
      // arrive would rename its spans and close the step that was open.
      zK(nK([...a], 0, o), e)
    ) : void 0,
    [t, c, a, o, e]
  ), s = Le(
    () => new Map(e.rows.map((h) => [h.nodeId, h.costUsd])),
    [e]
  );
  return /* @__PURE__ */ te("section", { className: "flex flex-col gap-2 border-b border-border-light pb-3 last:border-b-0", children: [
    /* @__PURE__ */ te(
      "button",
      {
        type: "button",
        onClick: n,
        "aria-expanded": t,
        className: "flex w-full flex-col gap-1 text-left",
        children: [
          /* @__PURE__ */ te("span", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ x(_r, { variant: mz[l.status] ?? "secondary", children: gz(i, l.status) }),
            /* @__PURE__ */ x("span", { className: "truncate text-sm font-medium text-foreground", children: l.rootName ?? l.rootAgentId })
          ] }),
          /* @__PURE__ */ x(
            IK,
            {
              summary: l,
              ...e.context ? { context: e.context } : {},
              t: i
            }
          )
        ]
      }
    ),
    l.error && t && /* @__PURE__ */ x("p", { className: "m-0 rounded-md bg-destructive-soft px-2 py-1.5 text-[11px] text-destructive-soft-foreground", children: l.error.message }),
    t && f && /* @__PURE__ */ x(
      uK,
      {
        trace: f,
        costOf: (h) => {
          const p = h.nodeId ? s.get(h.nodeId) : void 0;
          return p === void 0 ? void 0 : lp(p);
        }
      }
    ),
    t && !c && /* @__PURE__ */ x("ol", { className: "m-0 flex list-none flex-col gap-0.5 p-0", children: e.rows.map((h) => /* @__PURE__ */ x(
      PK,
      {
        row: h,
        spanMs: e.spanMs,
        selected: d === h.nodeId,
        onSelect: () => {
          u((p) => p === h.nodeId ? null : h.nodeId), r?.(h.agentId);
        },
        t: i
      },
      h.nodeId
    )) })
  ] });
}
function aJ({
  pricingFor: e,
  contextWindowFor: t,
  header: n,
  onSelectAgent: r,
  hideTitle: i = !1
}) {
  const { text: a } = dt(), o = gi((b) => b.runs), d = gi((b) => b.runOrder), u = gi((b) => b.nodes), l = gi((b) => b.handoffs), c = gi((b) => b.guardrails), f = gi((b) => b.trace), s = d.some((b) => o[b]?.status === "running"), h = SK(s), [p, m] = Ae({}), y = Le(() => {
    const b = /* @__PURE__ */ new Map();
    for (const _ of f) {
      if (!_.runId) continue;
      const g = b.get(_.runId);
      g ? g.push(_) : b.set(_.runId, [_]);
    }
    return b;
  }, [f]), w = Le(
    () => [...d].reverse().map(
      (b) => pz(
        { runs: o, nodes: u, handoffs: l, guardrails: c, trace: f },
        b,
        { pricingFor: e, contextWindowFor: t },
        h
      )
    ).filter((b) => b !== void 0),
    [d, o, u, l, c, f, e, t, h]
  );
  return /* @__PURE__ */ te("div", { className: "flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-3", children: [
    !i && /* @__PURE__ */ x("h2", { className: "m-0 text-sm font-semibold text-foreground", children: a("debug.title", "Run details") }),
    n,
    w.length === 0 ? /* @__PURE__ */ x("p", { className: "m-0 text-xs text-muted-foreground", children: a("debug.empty", "Send a test message to see which part of the agent runs.") }) : w.map((b, _) => {
      const g = b.summary.runId, O = p[g] ?? _ === 0;
      return /* @__PURE__ */ x(
        EK,
        {
          timeline: b,
          events: y.get(g) ?? OK,
          now: h,
          expanded: O,
          onToggle: () => {
            m((P) => ({ ...P, [g]: !O }));
          },
          ...r ? { onSelectAgent: r } : {},
          t: a
        },
        g
      );
    })
  ] });
}
const ar = 16, ap = 2, sp = (ar - ap) / 2, N0 = 2 * Math.PI * sp;
function sJ({
  context: e,
  className: t,
  onCompact: n,
  compactDisabled: r,
  compacting: i
}) {
  const a = Re(), o = fz(a, e);
  return n ? /* @__PURE__ */ te(R0, { children: [
    /* @__PURE__ */ x(Z0, { asChild: !0, children: /* @__PURE__ */ x(
      "button",
      {
        type: "button",
        "aria-label": o,
        className: "inline-flex items-center justify-center rounded-md p-1 hover:bg-muted",
        children: /* @__PURE__ */ x(C0, { context: e, className: t })
      }
    ) }),
    /* @__PURE__ */ te(
      L0,
      {
        side: "top",
        align: "end",
        className: "flex w-auto flex-col items-start gap-1 px-3 pb-1.5 pt-2.5 text-xs",
        onOpenAutoFocus: (d) => d.preventDefault(),
        children: [
          /* @__PURE__ */ x("span", { children: o }),
          /* @__PURE__ */ x(
            Tt,
            {
              size: "mini",
              variant: "ghost",
              className: "-ml-2 font-medium underline underline-offset-2",
              disabled: r === !0 || i === !0,
              onClick: n,
              children: i ? a("debug.compacting", "Compacting...") : a("debug.compactNow", "Compact now")
            }
          )
        ]
      }
    )
  ] }) : /* @__PURE__ */ x(Yu, { delayDuration: 200, children: /* @__PURE__ */ te(Qu, { children: [
    /* @__PURE__ */ x(ec, { asChild: !0, children: /* @__PURE__ */ x(C0, { context: e, label: o, className: t }) }),
    /* @__PURE__ */ x(tc, { children: o })
  ] }) });
}
function C0({
  context: e,
  label: t,
  className: n,
  ...r
}) {
  const i = Hm(e);
  return /* @__PURE__ */ te(
    "svg",
    {
      ...r,
      ...t ? { role: "img", "aria-label": t } : { "aria-hidden": !0 },
      width: ar,
      height: ar,
      viewBox: `0 0 ${String(ar)} ${String(ar)}`,
      className: Be("shrink-0 -rotate-90", hz(e) ?? "text-primary", n),
      children: [
        /* @__PURE__ */ x(
          "circle",
          {
            "data-testid": "context-ring-track",
            cx: ar / 2,
            cy: ar / 2,
            r: sp,
            fill: "none",
            strokeWidth: ap,
            ...i === void 0 ? { strokeDasharray: "2 2" } : {},
            className: i === void 0 ? "stroke-muted-foreground" : "stroke-border"
          }
        ),
        i !== void 0 && /* @__PURE__ */ x(
          "circle",
          {
            "data-testid": "context-ring-fill",
            cx: ar / 2,
            cy: ar / 2,
            r: sp,
            fill: "none",
            stroke: "currentColor",
            strokeWidth: ap,
            strokeLinecap: "round",
            strokeDasharray: N0,
            strokeDashoffset: N0 * (1 - Math.max(0.03, Math.min(1, i)))
          }
        )
      ]
    }
  );
}
export {
  tJ as A,
  YK as C,
  eJ as F,
  JG as O,
  rJ as Q,
  aJ as R,
  un as S,
  qK as U,
  XK as W,
  BK as a,
  nJ as b,
  sJ as c,
  Xe as d,
  dI as e,
  Ge as f,
  up as g,
  iJ as h,
  VK as i,
  QK as j,
  GK as k,
  HK as l,
  oJ as m,
  KK as n,
  JK as u
};
//# sourceMappingURL=components-C23RGENr.mjs.map
